(function () {
/* of219-hide-empty-metafield-notice */
/* of218-approve-pass-label */
/* of216-picker-hit-target */
/* of215-private-qc-calendar-color */
/* of214-durable-ad-cdn */
/* of210-remember-ticket-qty */
/* of210-wall-tagline */
/* of209-preview-match-storefront */
/* of208-preview-close-span */
/* of207-phone-preview-card */
/* of206-popup-preview-flush */
/* of205-crop-ratio-fraction */
/* of204-crop-revert-percent */
/* of203-crop-no-squeeze */
/* of202-crop-fill-important */
/* of201-popup-keep-device */
/* of200-popup-preview-sync */
/* of199-popup-crop-54 */
/* of198-listing-save-cdn-only */
/* of157-grant-history-refund-link */
/* of156-grant-history-status-labels */
/* of155-subnav-segmented-strong */
/* of51-full-pii-no-mask */
/* lb-kpi-help-tips-of18 */
/* kpi-tip-overlay-of72 */
/* checkout-date-dyn-of73 */
/* checkout-studio-of74 */
/* purchase-modal-of75 */
/* addon-gate-reason-of76 */
/* purchase-type-of77 */
/* attach-parent-of79 */
/* detach-parent-of88 */
/* ads-board-layout-of89 */
/* ads-board-brand-of90 */
/* ads-board-layout-of92 */
/* ads-board-title-chip-of93 */
/* ads-board-title-th-of94 */
/* listings-board-style-of95 */
/* listing-chrome-of96 */
/* mobile-board-cards-of97 */
/* mobile-datepicker-of98 */
/* datepicker-showpicker-of99 */
/* ads-create-nav-of100 */
/* capacity-alert-refresh-of101 */
/* ads-pick-checkboxes-of102 */
/* ads-pick-compact-of103 */
/* listing-form-sheet-of104 */
/* notes-preview-grid-of105 */
/* listing-form-trim-of106 */
/* listing-mobile-buybtn-of107 */
/* private-host-hide-of108 */
/* pending-locked-pick-of109 */
/* plan-gate-of110 */
/* list-date-wrap-of111 */
/* base-claim-to-course-new-of112 */
/* edit-plan-keep-of113 */
/* ads-create-compose-of81 */
/* purchase-footer-cta-of82 */
/* settlement-view-gate-of83 */
/* private-settle-approved-of84 */
/* ops-subnav-settle-hide-of85 */
/* subnav-hidden-fix-of86 */
/* lb-kpi-help-tips-of17 */
/* lb-return-retained-of16 */
/* lb-kpi-clarity-of15-cancel-discount */
/* of15-share-base-card */
/* lb-kpi-clarity-of14-20260801t2315 */
  var APP_PROXY_BASE = '/apps/ladybae-vendor-test';
  var LISTING_IMAGE_UPLOAD_DIRECT_DEFAULT =
    'https://api.ladybaeshop.com/v1/vendor-portal/listing/image-upload-direct';
  var PATHS = {
    authorized: APP_PROXY_BASE + '/authorized-vendors-dry-run',
    list: APP_PROXY_BASE + '/list-dry-run',
    summary: APP_PROXY_BASE + '/summary-dry-run',
    events: APP_PROXY_BASE + '/events-dry-run',
    export: APP_PROXY_BASE + '/export-csv-dry-run',
    exportFullPii: APP_PROXY_BASE + '/export-csv-full-pii',
    exportAttendance: APP_PROXY_BASE + '/export-attendance',
    listingSave: APP_PROXY_BASE + '/listing/save',
    listingImageUploadSession: APP_PROXY_BASE + '/listing/image-upload-session',
    listingSubmit: APP_PROXY_BASE + '/listing/submit',
    listingPurchaseHold: APP_PROXY_BASE + '/listing/purchase-hold',
    listingClaimWindow: APP_PROXY_BASE + '/listing/claim-window',
    listingAttachParent: APP_PROXY_BASE + '/listing/attach-parent',
    listingDetachParent: APP_PROXY_BASE + '/listing/detach-parent',
    listingDelete: APP_PROXY_BASE + '/listing/delete',
    listingRevertDraft: APP_PROXY_BASE + '/listing/revert-draft',
    listingUnpublish: APP_PROXY_BASE + '/listing/unpublish',
    listingUnpublishRequest: APP_PROXY_BASE + '/listing/unpublish-request',
    listingUnpublishRequestCancel: APP_PROXY_BASE + '/listing/unpublish-request/cancel',
    listingContentEdit: APP_PROXY_BASE + '/listing/content-edit',
    listingList: APP_PROXY_BASE + '/listing/list',
    listingDetail: APP_PROXY_BASE + '/listing/detail',
    listingTaxonomy: APP_PROXY_BASE + '/listing/taxonomy',
    listingCityTaxonomy: APP_PROXY_BASE + '/listing/city-taxonomy',
    reportsBundle: APP_PROXY_BASE + '/reports-bundle-dry-run',
    feePlans: APP_PROXY_BASE + '/fee-plans',
    feeGrantRefundRequest: APP_PROXY_BASE + '/fee-grants/refund-request',
    feeGrantRefundRequestCancel: APP_PROXY_BASE + '/fee-grants/refund-request/cancel',
    feeEntitlement: APP_PROXY_BASE + '/fee-entitlement',
    feeEntitlementBatch: APP_PROXY_BASE + '/fee-entitlement-batch',
    slotAvailability: APP_PROXY_BASE + '/slot-availability',
    ticketsPendingPayment: APP_PROXY_BASE + '/tickets/pending-payment',
    ticketsConfirmPayment: APP_PROXY_BASE + '/tickets/confirm-payment',
    ticketsExposureConfirmed: APP_PROXY_BASE + '/tickets/exposure-confirmed',
    ticketsVoidExposure: APP_PROXY_BASE + '/tickets/void-exposure',
    courseDecisionList: APP_PROXY_BASE + '/course-decision/list',
    courseDecisionSubmit: APP_PROXY_BASE + '/course-decision/submit',
    settlements: APP_PROXY_BASE + '/settlements',
    privateEligibilityList: APP_PROXY_BASE + '/listing/private/eligibility',
    privateEligibilityCustomerSearch: APP_PROXY_BASE + '/listing/private/eligibility/customers/search',
    privateEligibilityUpsert: APP_PROXY_BASE + '/listing/private/eligibility/upsert',
    privateEligibilityCancel: APP_PROXY_BASE + '/listing/private/eligibility/cancel',
    privateEligibilityRequestList: APP_PROXY_BASE + '/listing/private/eligibility-request/list',
    privateEligibilityRequestApprove: APP_PROXY_BASE + '/listing/private/eligibility-request/approve',
    privateEligibilityRequestReject: APP_PROXY_BASE + '/listing/private/eligibility-request/reject',
    privateApplications: APP_PROXY_BASE + '/listing/private/applications',
    privateApplicationStartFree: APP_PROXY_BASE + '/listing/private/applications/start-free',
    privateApplicationSubmit: APP_PROXY_BASE + '/listing/private/applications/submit',
    privateImportTemplate: APP_PROXY_BASE + '/listing/private/import/template',
    privateImportUpload: APP_PROXY_BASE + '/listing/private/import/upload',
    privateImportBatches: APP_PROXY_BASE + '/listing/private/import/batches',
    privateImportPending: APP_PROXY_BASE + '/listing/private/import/pending',
    privateImportErrors: APP_PROXY_BASE + '/listing/private/import/errors',
    privateImportConfirm: APP_PROXY_BASE + '/listing/private/import/confirm',
    privateImportDeleteDrafts: APP_PROXY_BASE + '/listing/private/import/delete-drafts',
    privateCalendarExport: APP_PROXY_BASE + '/listing/private/import/calendar-export',
    privateCalendarShare: APP_PROXY_BASE + '/listing/private/calendar-share',
    privateCalendarShareCreate: APP_PROXY_BASE + '/listing/private/calendar-share/create',
    privateCalendarShareRevoke: APP_PROXY_BASE + '/listing/private/calendar-share/revoke',
    privateCalendarNotices: APP_PROXY_BASE + '/listing/private/calendar-notices',
    privateCalendarNoticeUpsert: APP_PROXY_BASE + '/listing/private/calendar-notices/upsert',
    privateCalendarNoticeDelete: APP_PROXY_BASE + '/listing/private/calendar-notices/delete',
    privatePagePlacements: APP_PROXY_BASE + '/listing/private/page-placements',
    privatePagePlacementsPreview: APP_PROXY_BASE + '/listing/private/page-placements/preview',
    privateLearnerSurfaceUpsert: APP_PROXY_BASE + '/listing/private/page-placements/learner-surface',
    privatePagePlacementUpsert: APP_PROXY_BASE + '/listing/private/page-placements/upsert',
  };

  var CAL_SOFT_PALETTE = [
    '#F8D7DA', '#D1ECF1', '#D4EDDA', '#FFF3CD', '#E2D5F1', '#FDE2D2',
    '#D6EAF8', '#E8F5E9', '#FCE4EC', '#E0F2F1', '#FFF0DB', '#E8DAEF'
  ];

  function hashCalPalette(seed) {
    var s = String(seed || '');
    var h = 0;
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return CAL_SOFT_PALETTE[h % CAL_SOFT_PALETTE.length];
  }

  function normalizeCalHex(raw) {
    var s = String(raw || '').trim().replace(/^#/, '');
    if (/^[0-9A-Fa-f]{6}$/.test(s)) return '#' + s.toUpperCase();
    if (/^[0-9A-Fa-f]{3}$/.test(s)) {
      return ('#' + s[0] + s[0] + s[1] + s[1] + s[2] + s[2]).toUpperCase();
    }
    return '';
  }

  function resolveCalChipColor(stored, seed) {
    var n = normalizeCalHex(stored);
    return n || hashCalPalette(seed);
  }

  function defaultCalSwatchColor() {
    return CAL_SOFT_PALETTE[0];
  }

  function calendarSwatchesHtml(selected) {
    var cur = normalizeCalHex(selected) || defaultCalSwatchColor();
    var html = '<div class="lb-v2-cal-swatches" role="radiogroup" aria-label="月曆顏色">';
    CAL_SOFT_PALETTE.forEach(function (hex) {
      var on = hex === cur;
      html += '<button type="button" class="lb-v2-cal-swatch' + (on ? ' is-selected' : '') +
        '" data-cal-color="' + hex + '" style="background:' + hex + '" ' +
        'aria-pressed="' + (on ? 'true' : 'false') + '" title="' + hex + '"></button>';
    });
    html += '</div>';
    return html;
  }

  function mountCalSwatches(hostId, hiddenId, selected) {
    var host = $(hostId);
    if (!host) return;
    var cur = normalizeCalHex(selected) || defaultCalSwatchColor();
    var hidden = $(hiddenId);
    if (hidden) hidden.value = cur;
    host.innerHTML = calendarSwatchesHtml(cur);
    if (host.getAttribute('data-cal-swatch-bound') === '1') return;
    host.setAttribute('data-cal-swatch-bound', '1');
    host.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('[data-cal-color]');
      if (!btn || !host.contains(btn)) return;
      ev.preventDefault();
      var hex = normalizeCalHex(btn.getAttribute('data-cal-color'));
      if (!hex) return;
      var hid = $(hiddenId);
      if (hid) hid.value = hex;
      Array.prototype.forEach.call(host.querySelectorAll('[data-cal-color]'), function (el) {
        var on = el.getAttribute('data-cal-color') === hex;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
  }

  function readCalSwatchValue(hiddenId) {
    var el = $(hiddenId);
    return normalizeCalHex(el && el.value) || defaultCalSwatchColor();
  }

  var CAL_FIELD_DEFAULTS = ['time', 'title', 'instructor', 'organizer', 'co_organizer'];
  var CAL_FIELD_STORAGE_KEY = 'lb-v2-private-cal-fields';

  function ticketSummaryFromVariants(variants) {
    if (!Array.isArray(variants) || !variants.length) return '';
    var parts = [];
    variants.forEach(function (v) {
      if (!v) return;
      var name = String(v.name || '').trim() || '票種';
      var price = Number(v.price);
      if (!isFinite(price)) parts.push(name);
      else parts.push(price === 0 ? name + ' $0' : name + ' $' + Math.round(price));
    });
    return parts.join(' · ');
  }

  function readCalDisplayFields() {
    var root = $('lb-v2-private-cal-fields');
    if (!root) return CAL_FIELD_DEFAULTS.slice();
    var checked = [];
    Array.prototype.forEach.call(root.querySelectorAll('input[data-cal-field]'), function (el) {
      if (el.checked) checked.push(String(el.getAttribute('data-cal-field') || ''));
    });
    return checked.length ? checked : CAL_FIELD_DEFAULTS.slice();
  }

  function persistCalDisplayFields() {
    try {
      localStorage.setItem(CAL_FIELD_STORAGE_KEY, readCalDisplayFields().join(','));
    } catch (e) { /* ignore */ }
  }

  function restoreCalDisplayFields() {
    var root = $('lb-v2-private-cal-fields');
    if (!root) return;
    var saved = '';
    try { saved = String(localStorage.getItem(CAL_FIELD_STORAGE_KEY) || ''); } catch (e) { saved = ''; }
    var set = {};
    (saved ? saved.split(',') : CAL_FIELD_DEFAULTS).forEach(function (k) {
      if (k) set[k] = true;
    });
    Array.prototype.forEach.call(root.querySelectorAll('input[data-cal-field]'), function (el) {
      var key = String(el.getAttribute('data-cal-field') || '');
      el.checked = !!set[key];
    });
  }

  function formatCalEventLabel(ev, fields) {
    var parts = [];
    var startHm = '';
    var endHm = '';
    try {
      if (ev.start_at) {
        startHm = new Date(ev.start_at).toLocaleTimeString('zh-TW', { hour: '2-digit', minute: '2-digit' });
      }
      if (ev.end_at) {
        endHm = new Date(ev.end_at).toLocaleTimeString('zh-TW', { hour: '2-digit', minute: '2-digit' });
      }
    } catch (e) { /* keep */ }
    var has = {};
    (fields || []).forEach(function (f) { has[f] = true; });
    (fields || []).forEach(function (f) {
      if (f === 'time' && startHm) {
        if (has.end_time && endHm && endHm !== startHm) parts.push(startHm + '–' + endHm);
        else parts.push(startHm);
      } else if (f === 'end_time') {
        if (!has.time && endHm) parts.push('至 ' + endHm);
      } else if (f === 'title' && String(ev.title || '').trim()) {
        parts.push(String(ev.title).trim());
      } else if (f === 'instructor' && String(ev.instructor || '').trim()) {
        parts.push(String(ev.instructor).trim());
      } else if (f === 'organizer' && String(ev.organizer || '').trim()) {
        parts.push('主辦:' + String(ev.organizer).trim());
      } else if (f === 'co_organizer' && String(ev.co_organizer || '').trim()) {
        parts.push('協辦:' + String(ev.co_organizer).trim());
      } else if (f === 'venue' && String(ev.venue_name || '').trim()) {
        parts.push(String(ev.venue_name).trim());
      } else if (f === 'category' && String(ev.category || '').trim()) {
        parts.push(String(ev.category).trim());
      } else if (f === 'ticket') {
        var t = String(ev.ticket_summary || ticketSummaryFromVariants(ev.variants_json) || '').trim();
        if (t && t !== '—') parts.push(t);
      }
    });
    return parts.join(' · ') || String(ev.title || '').trim() || '（無標題）';
  }

  var ALL_MODE = '__ALL__';
  /** Fixed 22 Taiwan city codes (must match backend city-taxonomy). */
  /** Fallback; overwritten by /listing/city-taxonomy when available. */
  var CITY_OPTIONS = [
    { code: 'city-taipei', label: '臺北市' },
    { code: 'city-new-taipei', label: '新北市' },
    { code: 'city-taoyuan', label: '桃園市' },
    { code: 'city-taichung', label: '臺中市' },
    { code: 'city-tainan', label: '臺南市' },
    { code: 'city-kaohsiung', label: '高雄市' },
    { code: 'city-keelung', label: '基隆市' },
    { code: 'city-hsinchu-city', label: '新竹市' },
    { code: 'city-hsinchu-county', label: '新竹縣' },
    { code: 'city-miaoli', label: '苗栗縣' },
    { code: 'city-changhua', label: '彰化縣' },
    { code: 'city-nantou', label: '南投縣' },
    { code: 'city-yunlin', label: '雲林縣' },
    { code: 'city-chiayi-city', label: '嘉義市' },
    { code: 'city-chiayi-county', label: '嘉義縣' },
    { code: 'city-pingtung', label: '屏東縣' },
    { code: 'city-yilan', label: '宜蘭縣' },
    { code: 'city-hualien', label: '花蓮縣' },
    { code: 'city-taitung', label: '臺東縣' },
    { code: 'city-penghu', label: '澎湖縣' },
    { code: 'city-kinmen', label: '金門縣' },
    { code: 'city-lienchiang', label: '連江縣' },
  ];
  /** Check order = address row order (first checked first). */
  var cityCheckOrder = [];
  /** Per-city address rest (區／路／號), keyed by city code. */
  var addressRestByCity = {};
  /** Internal bootstrap slugs — keep for scan/admin pages, hide from portal vendor picker. */
  var PORTAL_VENDOR_EXCLUDE = {
    LadyBaeStaff: true,
    Admin0920: true,
    __admin__: true,
    LadyBaeOps: true,
  };
  var config = { loggedIn: false, loginUrl: '/account/login', scanUrl: '/pages/vendor-scan-v2', vendors: [] };
  var metafieldVendors = [];
  var activeVendors = [];
  var vendorRoleBySlug = {};
  var vendorNameBySlug = {};
  var accountIsScanOnlyOnly = false;
  /** When true, list requests reveal=1 for full PII (default on — no masking). */
  var revealFullPii = true;

  try {
    var configEl = document.getElementById('lb-v2-config');
    if (configEl) config = JSON.parse(configEl.textContent || '{}');
  } catch (e) {
    config = { loggedIn: false, loginUrl: '/account/login', scanUrl: '/pages/vendor-scan-v2', vendors: [] };
  }

  metafieldVendors = (config.vendors || [])
    .map(function (v) { return String(v || '').trim(); })
    .filter(function (v, i, arr) { return v && arr.indexOf(v) === i; });

  var activeTab = 'events';
  var vendorMode = ALL_MODE;
  var selectedEventId = null;
  var cachedEventsItems = [];
  var eventSearchQuery = '';
  var overviewRankSort = 'sales';
  var eventsPage = { currentPage: 1, listLimit: 50, filterQ: '', filterRedeemed: '', filterTicketStatus: '' };
  var overviewPage = { currentPage: 1, listLimit: 50, filterQ: '', filterRedeemed: '', filterTicketStatus: '' };
  /** Soft cache: same vendor + tab revisit skips network/DOM rebuild (reload button bypasses). */
  var tabDataCache = {
    events: { vendorKey: '', loaded: false },
    overview: { vendorKey: '', loaded: false },
    listing: { vendorKey: '', loaded: false },
    private: { vendorKey: '', loaded: false },
    'private-eligibility': { vendorKey: '', loaded: false },
    'private-schedule': { vendorKey: '', loaded: false },
    'private-page': { vendorKey: '', loaded: false },
    'settlement-private': { vendorKey: '', loaded: false },
  };

  function currentVendorCacheKey() {
    return String(vendorMode || '');
  }

  function invalidateTabCaches() {
    Object.keys(tabDataCache).forEach(function (k) {
      tabDataCache[k].loaded = false;
      tabDataCache[k].vendorKey = '';
    });
    clearFeeEntitlementTtlCache();
  }

  function beginTabLoad(tab, forceReload) {
    if (forceReload === false && tabCacheHit(tab)) return false;
    if (forceReload !== false && tabDataCache[tab]) {
      tabDataCache[tab].loaded = false;
    }
    return true;
  }

  function tabCacheHit(tab) {
    var c = tabDataCache[tab];
    return !!(c && c.loaded && c.vendorKey === currentVendorCacheKey());
  }

  function markTabCache(tab) {
    var c = tabDataCache[tab];
    if (!c) return;
    c.loaded = true;
    c.vendorKey = currentVendorCacheKey();
  }

  var root = document.getElementById('lb-v2-root');
  if (!root) return;

  var LbV2 = window.LbVendorPortalV2 || (window.LbVendorPortalV2 = {});
  LbV2.chunks = LbV2.chunks || {};
  LbV2.chunkPromises = LbV2.chunkPromises || {};
  LbV2.registerListing = function (api) {
    LbV2.chunks.listing = api || { ready: true };
    return LbV2.chunks.listing;
  };
  LbV2.registerPrivate = function (api) {
    LbV2.chunks.private = api || { ready: true };
    return LbV2.chunks.private;
  };
  LbV2.ensureChunk = function (name) {
    if (LbV2.chunks[name]) return Promise.resolve(LbV2.chunks[name]);
    if (LbV2.chunkPromises[name]) return LbV2.chunkPromises[name];
    var srcAttr = name === 'listing' ? 'listingSrc' : name === 'private' ? 'privateSrc' : '';
    var src = srcAttr && root.dataset ? root.dataset[srcAttr] : '';
    if (!src) {
      // Offline / missing asset: mark ready so tabs still work (logic stays in core).
      LbV2.chunks[name] = { ready: true, inline: true };
      return Promise.resolve(LbV2.chunks[name]);
    }
    LbV2.chunkPromises[name] = new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () {
        if (!LbV2.chunks[name]) LbV2.chunks[name] = { ready: true };
        resolve(LbV2.chunks[name]);
      };
      s.onerror = function () {
        LbV2.chunks[name] = { ready: true, loadError: true };
        resolve(LbV2.chunks[name]);
      };
      document.head.appendChild(s);
    });
    return LbV2.chunkPromises[name];
  };

  function $(id) { return document.getElementById(id); }

  function escapeHtml(value) {
    // Never coerce empty → "—" (that leaks into input value="" as a literal symbol)
    if (value == null || value === '') return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /** Shopify product id as digits only (GID or numeric). */
  function numericShopifyProductId(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/\/(?:Product|ProductVariant)\/(\d+)/i);
    if (m) return m[1];
    if (/^\d+$/.test(s)) return s;
    return '';
  }

  /**
   * Dual tracking labels: 課程 #listingId always; 商品 {shopify} after product exists.
   * Keep listing # as primary — drafts/addons never rely on Shopify id alone.
   */
  function listingTrackIdsHtml(item) {
    if (!item || item.id == null || item.id === '') return '—';
    var lid = String(item.id);
    var pid = numericShopifyProductId(item.shopify_product_id);
    var html = '<div class="lb-v2-track-ids">' +
      '<span class="lb-v2-track-id">課程 #' + escapeHtml(lid) + '</span>';
    if (pid) {
      html += '<span class="lb-v2-track-id lb-v2-track-id--product">商品 ' + escapeHtml(pid) + '</span>';
    }
    html += '</div>';
    return html;
  }

  function listingTrackIdsPlain(item) {
    if (!item || item.id == null || item.id === '') return '';
    var bits = ['課程 #' + String(item.id)];
    var pid = numericShopifyProductId(item.shopify_product_id);
    if (pid) bits.push('商品 ' + pid);
    return bits.join(' · ');
  }

  function setListingFormTrackIds(item) {
    var el = $('lb-v2-listing-track-ids');
    if (!el) return;
    if (!item || item.id == null || item.id === '') {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    el.hidden = false;
    el.innerHTML = listingTrackIdsHtml(item);
  }

  /** Display helper: empty values show an em dash in read-only UI only */
  function cellText(value) {
    if (value == null || value === '') return '—';
    return escapeHtml(value);
  }

  function moneyCents(n) {
    return Math.round(Number(n) || 0);
  }

  function formatMoney(amount, currency) {
    if (amount == null || amount === '') return '—';
    var num = moneyCents(amount);
    if (Number.isNaN(num)) return escapeHtml(amount);
    var cur = (currency || 'TWD').toUpperCase();
    try {
      return escapeHtml(new Intl.NumberFormat('zh-TW', {
        style: 'currency', currency: cur, maximumFractionDigits: 0,
      }).format(num));
    } catch (e) {
      return escapeHtml(String(num) + ' ' + cur);
    }
  }

  function formatPercent(rate) {
    if (rate == null || rate === '') return '—';
    var num = Number(rate);
    if (Number.isNaN(num)) return escapeHtml(rate);
    var pct = num <= 1 ? num * 100 : num;
    return escapeHtml(pct.toFixed(1) + '%');
  }

  function formatCount(value) {
    if (value == null || value === '') return '—';
    var num = Number(value);
    if (Number.isNaN(num)) return escapeHtml(value);
    return escapeHtml(String(num));
  }

  function formatDateRange(startAt, endAt) {
    function fmt(value) {
      if (!value) return '';
      var d = new Date(String(value));
      if (Number.isNaN(d.getTime())) return String(value);
      return d.toLocaleString('zh-TW', {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
      });
    }
    var start = fmt(startAt);
    var end = fmt(endAt);
    if (start && end) return start + ' – ' + end;
    return start || end || '—';
  }

  function maskUid(uid) {
    uid = String(uid || '').trim();
    return uid || '—';
  }

  function isVoidItem(item) {
    var fs = String(item.financial_status || '').toLowerCase();
    var ts = String(item.ticket_status || '').toUpperCase();
    if (item.voided_at) return true;
    return fs.indexOf('void') >= 0 ||
      ts === 'VOID' || ts === 'VOIDED' || ts === 'CANCELLED' || ts === 'CANCELED';
  }

  function isRefundedItem(item) {
    var fs = String(item.financial_status || '').toLowerCase();
    var ts = String(item.ticket_status || '').toUpperCase();
    if (ts === 'REFUNDED') return true;
    if (item.refunded_at) return true;
    if (fs.indexOf('refund') >= 0) return true;
    if (item.refunded_amount != null && Number(item.refunded_amount) > 0) return true;
    return false;
  }

  /** Ticket / financial status → Traditional Chinese for portal tables. */
  function ticketStatusLabelZh(item) {
    var ts = String(item.ticket_status || '').trim().toUpperCase();
    var fs = String(item.financial_status || '').trim().toUpperCase();
    var tsKnown = {
      REFUNDED: '已退款',
      VOID: '已作廢',
      VOIDED: '已作廢',
      CANCELLED: '已作廢',
      CANCELED: '已作廢',
      PENDING_VENDOR_CONFIRM: '待確認收款',
      ACTIVE: '有效',
      VALID: '有效',
      OK: '有效',
      PENDING: '待處理',
      INACTIVE: '已停用',
      INVALID: '無效',
      EXPIRED: '已過期',
      REDEEMED: '已核銷',
      USED: '已核銷'
    };
    var fsKnown = {
      PAID: '已付款',
      PENDING: '待付款',
      AUTHORIZED: '已授權',
      PARTIALLY_PAID: '部分付款',
      PARTIALLY_REFUNDED: '部分退款',
      REFUNDED: '已退款',
      VOIDED: '已作廢'
    };
    if (ts === 'REFUNDED' || fs.indexOf('REFUND') >= 0) return '已退款';
    if (item.voided_at || tsKnown[ts] === '已作廢') return '已作廢';
    if (tsKnown[ts]) return tsKnown[ts];
    if (!ts && fsKnown[fs]) return fsKnown[fs];
    if (fsKnown[fs]) return fsKnown[fs];
    // Never surface raw English codes in the portal UI.
    return '—';
  }

  var ROLE_LABELS = { owner: '擁有者', admin: '管理員', staff: '工作人員', scan_only: '僅掃碼' };

  function renderRedeemBadge(item) {
    // Terminal money states first — $0 REFUNDED must not look like「未核銷」.
    if (isRefundedItem(item)) return '<span class="lb-v2-badge lb-v2-badge--refund">已退款</span>';
    if (isVoidItem(item)) return '<span class="lb-v2-badge lb-v2-badge--void">已作廢</span>';
    if (item.redeemed === true) return '<span class="lb-v2-badge lb-v2-badge--ok">已核銷</span>';
    var st = (item.ticket_status || '').toUpperCase();
    if (st === 'PENDING_VENDOR_CONFIRM') return '<span class="lb-v2-badge lb-v2-badge--warn">待確認收款</span>';
    return '<span class="lb-v2-badge lb-v2-badge--pending">未核銷</span>';
  }

  function friendlyError(code, message) {
    switch (code) {
      case 'CUSTOMER_NOT_LOGGED_IN': return '請先登入 LadyBae 會員帳號。';
      case 'VENDOR_NOT_ALLOWED':
      case 'VENDOR_USER_INACTIVE': return '此廠商尚未完成系統授權。';
      case 'EXPORT_NOT_ALLOWED':
      case 'REPORT_NOT_ALLOWED': return '此角色不可使用此功能。';
      case 'SIGNATURE_MISSING':
      case 'SIGNATURE_INVALID':
      case 'TIMESTAMP_EXPIRED': return '系統代理驗證失敗（請確認已登入前台）。';
      default: return (message || '載入失敗') + (code ? ' (' + code + ')' : '');
    }
  }

  function showNotice(el, message) {
    if (!el) return;
    if (!message) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = message;
  }

  function hideNotice(el) { if (el) { el.hidden = true; el.textContent = ''; } }

  var modalKeyHandler = null;
  var listingFormReadOnly = false;

  function bindModalChrome() {
    var modal = $('lb-v2-modal');
    if (!modal || modal.dataset.lbModalChromeBound === '1') return;
    modal.dataset.lbModalChromeBound = '1';
    modal.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-lb-v2-modal-close]') : null;
      if (!t || !modal.contains(t)) return;
      if (t.disabled || t.getAttribute('aria-disabled') === 'true' || t.classList.contains('is-disabled')) return;
      e.preventDefault();
      closeModal();
    });
  }

  function closeModal() {
    var modal = $('lb-v2-modal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.classList.remove('lb-v2-modal-open');
    var panelClose = modal.querySelector('.lb-v2-modal__panel');
    if (panelClose) {
      panelClose.classList.remove(
        'lb-v2-modal__panel--purchase',
        'lb-v2-modal__panel--wide',
        'lb-v2-modal__panel--compose'
      );
    }
    var closeBtn = modal.querySelector('.lb-v2-modal__close');
    if (closeBtn) {
      closeBtn.disabled = false;
      closeBtn.removeAttribute('aria-disabled');
      closeBtn.classList.remove('is-disabled');
      closeBtn.tabIndex = 0;
    }
    if (modalKeyHandler) {
      document.removeEventListener('keydown', modalKeyHandler);
      modalKeyHandler = null;
    }
  }

  function openModal(opts) {
    var modal = $('lb-v2-modal');
    var titleEl = $('lb-v2-modal-title');
    var bodyEl = $('lb-v2-modal-body');
    var actionsEl = $('lb-v2-modal-actions');
    var panel = modal ? modal.querySelector('.lb-v2-modal__panel') : null;
    if (!modal || !titleEl || !bodyEl || !actionsEl) return;

    // Escape theme stacking contexts (footer often sits above in-page z-index)
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    bindModalChrome();

    titleEl.textContent = (opts && opts.title) || '提示';
    bodyEl.innerHTML = (opts && opts.bodyHtml) || '';
    if (panel) {
      panel.classList.toggle('lb-v2-modal__panel--wide', !!(opts && opts.wide));
      panel.classList.toggle('lb-v2-modal__panel--compose', !!(opts && opts.compose));
    }
    var closeBtn = modal.querySelector('.lb-v2-modal__close');
    if (closeBtn) {
      if (opts && opts.disableCloseX) {
        closeBtn.disabled = true;
        closeBtn.setAttribute('aria-disabled', 'true');
        closeBtn.classList.add('is-disabled');
        closeBtn.tabIndex = -1;
      } else {
        closeBtn.disabled = false;
        closeBtn.removeAttribute('aria-disabled');
        closeBtn.classList.remove('is-disabled');
        closeBtn.tabIndex = 0;
      }
    }
    actionsEl.innerHTML = '';

    var actions = (opts && opts.actions) || [{ label: '知道了', accent: true, close: true }];
    actions.forEach(function (act) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lb-v2-btn' + (act.accent ? ' lb-v2-btn--accent' : (act.ghost ? ' lb-v2-btn--ghost' : ''));
      btn.textContent = act.label || '確定';
      if (act.disabled) btn.disabled = true;
      btn.addEventListener('click', function () {
        var keepOpen = false;
        if (typeof act.onClick === 'function') {
          keepOpen = act.onClick() === false;
        }
        if (act.close !== false && !keepOpen) closeModal();
      });
      actionsEl.appendChild(btn);
    });

    bindSlotPreviewToggle(bodyEl);
    modal.hidden = false;
    document.documentElement.classList.add('lb-v2-modal-open');
    if (modalKeyHandler) document.removeEventListener('keydown', modalKeyHandler);
    modalKeyHandler = function (e) {
      if (e.key === 'Escape') closeModal();
    };
    document.addEventListener('keydown', modalKeyHandler);
  }

  function setListingFormReadOnly(readonly, status) {
    listingFormReadOnly = !!readonly;
    var form = $('lb-v2-listing-form');
    var banner = $('lb-v2-listing-readonly-banner');
    var headTitle = document.querySelector('#lb-v2-listing-form-section .lb-v2-section-subtitle');
    if (form) form.classList.toggle('is-readonly', listingFormReadOnly);

    if (banner) {
      if (listingFormReadOnly) {
        var label = STATUS_LABELS[status] || status || '不可編輯';
        banner.hidden = false;
        banner.innerHTML =
          '<div class="lb-v2-listing-readonly-banner__content">' +
            '<span>目前為<strong>唯讀檢視</strong>（狀態：' + escapeHtml(label) + '）。送審後無法修改，請等候審核結果。</span>' +
          '</div>';
      } else {
        banner.hidden = true;
        banner.textContent = '';
      }
    }
    if (headTitle) {
      headTitle.textContent = listingFormReadOnly ? '檢視申請（唯讀）' : '新增 / 編輯草稿';
    }

    if (!form) return;
    var nodes = form.querySelectorAll('input, textarea, select, button');
    nodes.forEach(function (el) {
      if (el.id === 'lb-v2-listing-id' || el.id === 'lb-v2-listing-fee-plan' || el.id === 'lb-v2-listing-slot' || el.id === 'lb-v2-listing-cutoff-mode') {
        return;
      }
      if (listingFormReadOnly) {
        if (!el.hasAttribute('data-lb-ro-prev')) {
          el.setAttribute('data-lb-ro-prev', el.disabled ? '1' : '0');
        }
        el.disabled = true;
      } else if (el.hasAttribute('data-lb-ro-prev')) {
        el.disabled = el.getAttribute('data-lb-ro-prev') === '1';
        el.removeAttribute('data-lb-ro-prev');
      }
    });
  }

  function isListingEditableStatus(status, listingMode) {
    var st = String(status || '').toUpperCase();
    // UNPUBLISHED is editable for every mode: unpublish → edit → re-submit is the
    // only way to change price／dates／tickets after going live.
    if (st === 'DRAFT' || st === 'REJECTED' || st === 'UNPUBLISHED') return true;
    var mode = String(listingMode || '').toUpperCase();
    return mode === 'PRIVATE' && st === 'PUBLISHED';
  }

  function isPrivateLiveMutable(item) {
    if (!item) return false;
    var mode = String(item.listing_mode || '').toUpperCase();
    var st = String(item.status || '').toUpperCase();
    return mode === 'PRIVATE' && (st === 'PUBLISHED' || st === 'UNPUBLISHED');
  }

  /** Light content edit (no re-review) is only offered on live non-PROMO listings. */
  function canContentEditListing(item) {
    if (!item) return false;
    var st = String(item.status || '').toUpperCase();
    var mode = String(item.listing_mode || '').toUpperCase();
    return st === 'PUBLISHED' && mode !== 'PROMO';
  }

  function hasOpenUnpublishRequest(item) {
    if (!item) return false;
    return !!item.unpublish_request_at && !item.unpublish_request_resolved_at;
  }

  function unpublishRequestRejected(item) {
    if (!item || !item.unpublish_request_resolved_at) return false;
    return String(item.unpublish_request_resolution || '').toUpperCase() === 'REJECTED';
  }

  function listingSeatHoldActive(item) {
    if (!item || !item.seat_hold_until || !item.seat_hold_start || !item.seat_hold_end) {
      return false;
    }
    var until = new Date(item.seat_hold_until);
    if (isNaN(until.getTime())) return false;
    return until.getTime() > Date.now();
  }

  function showListingAlert(message, title) {
    if (!message) return;
    openModal({
      title: title || '請檢查表單',
      bodyHtml: '<p class="lb-v2-modal__msg">' + escapeHtml(message) + '</p>',
      actions: [{ label: '知道了', accent: true, close: true }],
    });
  }

  /**
   * 疊在既有 modal 上的警示（不關掉底下的選檔期視窗）。
   * 容量已滿等錯誤用這個，不要把長文寫在月曆下方。
   */
  function showPortalAlert(message, title) {
    if (!message) return;
    var existing = document.getElementById('lb-v2-portal-alert');
    if (existing) existing.remove();
    var wrap = document.createElement('div');
    wrap.id = 'lb-v2-portal-alert';
    wrap.className = 'lb-v2-portal-alert';
    wrap.setAttribute('role', 'alertdialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.innerHTML =
      '<div class="lb-v2-portal-alert__backdrop" data-portal-alert-close></div>' +
      '<div class="lb-v2-portal-alert__panel">' +
        '<h3 class="lb-v2-portal-alert__title">' + escapeHtml(title || '請注意') + '</h3>' +
        '<p class="lb-v2-portal-alert__msg">' + escapeHtml(message) + '</p>' +
        '<div class="lb-v2-portal-alert__actions">' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--accent" data-portal-alert-close>知道了</button>' +
        '</div>' +
      '</div>';
    function dismiss() {
      wrap.remove();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') dismiss();
    }
    wrap.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t && t.closest && t.closest('[data-portal-alert-close]')) dismiss();
    });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(wrap);
  }

  function formatPortalError(code, message) {
    var msg = String(message || '').trim();
    if (!msg && code) msg = String(code);
    if (!msg) return '操作失敗，請稍後再試';
    // 不要把 [SLOT_CAPACITY_FULL] 這種 raw code 塞進提示文。
    if (code === 'SLOT_CAPACITY_FULL' || /SLOT_CAPACITY_FULL/i.test(msg)) {
      return msg.replace(/^\s*\[?SLOT_CAPACITY_FULL\]?\s*/i, '') ||
        '此檔期有日期已滿，請改選其他日期';
    }
    return msg.replace(/^\s*\[[A-Z0-9_]+\]\s*/, '');
  }

  function showListingSuccess(message, title, opts) {
    opts = opts || {};
    openModal({
      title: title || '完成',
      bodyHtml: '<p class="lb-v2-modal__msg">' + escapeHtml(message) + '</p>',
      actions: [{
        label: '好的',
        accent: true,
        close: true,
        onClick: function () {
          if (opts.navigate === 'course-new') {
            if (typeof switchTab === 'function') switchTab('course-new');
            if (opts.listingId) {
              try { loadListingIntoForm(opts.listingId); } catch (eNav) { /* ignore */ }
            } else {
              try { refreshListingEntitlementUI(); } catch (eGate) { /* ignore */ }
            }
          } else if (opts.navigate === 'course-ads') {
            if (typeof switchTab === 'function') switchTab('course-ads');
            if (opts.adsCreate && typeof setCourseAdsView === 'function') {
              setCourseAdsView('create');
            }
          }
        },
      }],
    });
  }

  function reviewRow(label, value) {
    var v = String(value == null || value === '' ? '—' : value);
    return '<div class="lb-v2-review-row"><dt>' + escapeHtml(label) + '</dt><dd>' + escapeHtml(v) + '</dd></div>';
  }

  function getListingPreviewSlotMeta() {
    var planEl = $('lb-v2-listing-fee-plan');
    var slotName = planEl ? (planEl.getAttribute('data-slot-name') || '') : '';
    var planName = planEl ? (planEl.getAttribute('data-plan-name') || '') : '';
    var slotId = planEl ? (planEl.getAttribute('data-slot-id') || '') : '';
    var selected = document.querySelector(
      '#lb-v2-listing-fee-plan-list .lb-v2-fee-plan-pick__item.is-selected'
    );
    if (selected) {
      slotName = selected.getAttribute('data-slot-name') || slotName;
      planName = selected.getAttribute('data-plan-name') || planName;
      slotId = selected.getAttribute('data-slot-id') || slotId;
      if (!planName) {
        var nameEl = selected.querySelector('.lb-v2-fee-plan-pick__name');
        planName = nameEl ? (nameEl.textContent || '').trim() : planName;
      }
    }
    return { slotName: slotName, planName: planName, slotId: slotId };
  }

  function resolveWallPreviewKind(slotName, planName, mode) {
    var key = String(slotName || '') + ' ' + String(planName || '');
    // Admin／Portal 產品名可能是「首頁輪播廣告」，規格名也可能是「首頁大輪播」
    if (/首頁大輪播|首頁輪播|輪播廣告|home[-_\s]?ad[-_\s]?carousel/i.test(key)) return 'home_carousel';
    if (/首頁彈窗|homepage[-_\s]?popup/i.test(key)) return 'home_popup';
    if (/熱門課程|popular[-_\s]?courses/i.test(key)) return 'popular_courses';
    if (/活動焦點|event[-_\s]?spotlight/i.test(key)) return 'event_spotlight';
    var m = String(mode || '').toUpperCase();
    if (m === 'PROMO') return 'promo_card';
    // 基礎上架：商品頁／課程卡封面為 1:1，不用通用橫幅
    if (m === 'FULL' || m === 'EXPOSURE') return 'course_card';
    return 'generic_banner';
  }

  function isEventSpotlightSlot(slotName, planName) {
    return /活動焦點|event-spotlight/i.test(
      String(slotName || '') + ' ' + String(planName || '')
    );
  }

  function listingDescriptionPreviewText(maxLen) {
    var raw = (($('lb-v2-listing-desc') || {}).value || '').trim();
    if (!raw) return '';
    var text = raw
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    var limit = maxLen || 80;
    if (text.length <= limit) return text;
    return text.slice(0, limit) + '…';
  }

  function previewImageOrPlaceholder(src, className, placeholderText) {
    if (src) {
      return '<img class="' + className + '" src="' + escapeHtml(src) + '" alt="">';
    }
    return '<div class="' + className + '" style="min-height:180px;display:flex;align-items:center;justify-content:center;background:#efe6e9;color:#776b70;font-size:var(--lbt-caption, 13px);font-weight:600;">' +
      escapeHtml(placeholderText || '尚未有圖') + '</div>';
  }

  function listingPreviewPriceText(parent) {
    var vars = parent && parent.variants_json;
    if (Array.isArray(vars) && vars.length) {
      var p = vars[0] && vars[0].price;
      if (p === 0 || p === '0') return '免費';
      if (p != null && String(p).trim() !== '') {
        var n = Number(p);
        if (Number.isFinite(n)) return 'NT$' + (n % 1 === 0 ? String(n) : n.toFixed(0));
        return 'NT$' + String(p);
      }
    }
    return '';
  }

  function listingPreviewVendorName(parent) {
    if (!parent) return '';
    return String(parent.organizer || parent.instructor || parent.vendor_name || '').trim();
  }

  function listingPreviewDesc(parent, maxLen) {
    var raw = parent && parent.description ? String(parent.description) : '';
    if (!raw && typeof listingDescriptionPreviewText === 'function') {
      try { return listingDescriptionPreviewText(maxLen || 90); } catch (e) { /* ignore */ }
    }
    var text = raw.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    var limit = maxLen || 90;
    if (text.length <= limit) return text;
    return text.slice(0, limit) + '…';
  }

  /** Storefront-identical wall previews (same class names as section liquid). */
  function buildStorefrontSlotWallHtml(kind, opts) {
    opts = opts || {};
    var title = opts.title || '（課程標題）';
    var desk = opts.desk || '';
    var mob = opts.mob || desk;
    var imgs = opts.imgs || (desk ? [desk] : []);
    var desc = opts.desc || '';
    var vendor = opts.vendor || '';
    var priceText = opts.priceText || '';
    var device = opts.device === 'mobile' ? 'mobile' : 'desktop';
    var skipHint = !!opts.skipHint;
    var html = '';

    if (kind === 'home_carousel') {
      // 桌機／手機用不同圖；不可只靠 <picture media>——Portal modal 視窗永遠 ≥750，媒體查詢不會切換
      var carouselSrc = device === 'mobile' ? (mob || desk) : (desk || mob);
      html += '<section class="lb-ad-carousel" aria-label="首頁大輪播' +
        (device === 'mobile' ? '（手機）' : '（桌機）') + '預覽">';
      html += '<div class="lb-ad-carousel__viewport">';
      html += '<div class="lb-ad-carousel__track">';
      html += '<div class="lb-ad-carousel__slide is-active">';
      html += '<div class="lb-ad-carousel__link">';
      if (carouselSrc) {
        html += '<img class="lb-ad-carousel__img" src="' + escapeHtml(carouselSrc) + '" alt="">';
      } else {
        html += '<div class="lb-ad-carousel__placeholder">請上傳第 1 張（電腦）／第 2 張（手機）</div>';
      }
      html += '</div></div></div>';
      html += '<div class="lb-ad-carousel__chrome">';
      html += '<div class="lb-ad-carousel__dots" role="tablist" aria-label="輪播頁次">';
      html += '<button type="button" class="lb-ad-carousel__dot is-active" tabindex="-1" aria-label="第 1 張"></button>';
      html += '<button type="button" class="lb-ad-carousel__dot" tabindex="-1" aria-label="第 2 張"></button>';
      html += '</div>';
      html += '<div class="lb-ad-carousel__index" aria-hidden="true"><span>01</span><span class="lb-ad-carousel__index-sep">/</span><span>02</span></div>';
      html += '</div></div></section>';
      if (!skipHint) {
        html += '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">與官網相同：桌機用第 1 張、手機用第 2 張（缺則互用）。同池輪播，不保證順序。</p>';
      }
      return html;
    }

    if (kind === 'popular_courses') {
      html += '<section class="lb-popular lb-popular--premium" style="--lb-popular-cols:3" aria-label="熱門課程預覽">';
      html += '<div class="lb-popular__panel"><div class="lb-popular__inner">';
      html += '<header class="lb-popular__head"><div class="lb-popular__titles">';
      html += '<p class="lb-popular__kicker">精選推薦</p>';
      html += '<p class="lb-popular__eyebrow">LadyBae</p>';
      html += '<h2 class="lb-popular__title">熱門課程</h2>';
      html += '<p class="lb-popular__sub">大家都在學！把握優惠讓自己跟上趨勢</p>';
      html += '</div></header>';
      html += '<div class="lb-popular__viewport"><div class="lb-popular__track">';
      for (var pi = 0; pi < 3; pi++) {
        var isYou = pi === 0;
        html += '<div class="lb-popular__slide"' + (isYou ? '' : ' style="opacity:0.55"') + '>';
        html += '<article class="lb-card' + (isYou ? ' lb-card--has-badge' : '') + '">';
        html += '<a class="lb-card__media" href="#" tabindex="-1" onclick="return false;">';
        if (isYou && desk) {
          html += '<img src="' + escapeHtml(desk) + '" alt="" width="800" height="640" loading="lazy">';
        } else if (isYou) {
          html += '<div style="aspect-ratio:5/4;background:rgba(0,0,0,.04);display:flex;align-items:center;justify-content:center;color:#776b70;font-size:var(--lbt-caption, 13px);font-weight:600;">你的封面</div>';
        } else {
          html += '<div style="aspect-ratio:5/4;background:rgba(0,0,0,.04);display:flex;align-items:center;justify-content:center;color:#776b70;font-size:var(--lbt-caption, 13px);font-weight:600;">同池其他課</div>';
        }
        if (isYou) html += '<span class="lb-card__badge">熱門課程</span>';
        html += '</a><div class="lb-card__body">';
        html += '<a class="lb-card__name" href="#" tabindex="-1" onclick="return false;">' +
          escapeHtml(isYou ? title : '…') + '</a>';
        if (isYou && vendor) {
          html += '<div class="lb-card__meta"><span class="lb-card__vendor">by ' + escapeHtml(vendor) + '</span></div>';
        }
        if (isYou && priceText) {
          html += '<div class="lb-card__price">' + escapeHtml(priceText) + '</div>';
        }
        if (isYou) {
          html += '<a class="lb-card__cta" href="#" tabindex="-1" onclick="return false;">立即報名</a>';
        }
        html += '</div></article></div>';
      }
      html += '</div></div></div></div></section>';
      if (!skipHint) {
        html += '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">與官網相同：左對齊編輯牆、封面滿版、CTA 全寬；桌機 3 格／手機橫滑。同池不順位。</p>';
      }
      return html;
    }

    if (kind === 'home_popup') {
      html += '<div class="lb-home-popup is-open lb-v2-popup-preview" aria-label="首頁彈窗預覽">';
      html += '<div class="lb-home-popup__dialog" role="dialog" aria-modal="false">';
      html += '<span class="lb-home-popup__close" aria-hidden="true"><span></span></span>';
      html += '<div class="lb-home-popup__cards"><article class="lb-home-popup__card">';
      html += '<a class="lb-home-popup__media" href="#" tabindex="-1" onclick="return false;">';
      if (desk) html += '<img src="' + escapeHtml(desk) + '" alt="">';
      else html += '<div class="lb-home-popup__placeholder">尚未有彈窗主圖</div>';
      html += '</a><div class="lb-home-popup__content">';
      html += '<p class="lb-home-popup__eyebrow">LADYBAE FEATURED</p>';
      html += '<h2 class="lb-home-popup__title">' + escapeHtml(title) + '</h2>';
      if (desc) html += '<p class="lb-home-popup__description">' + escapeHtml(desc) + '</p>';
      if (priceText) html += '<div class="lb-home-popup__price"><strong>' + escapeHtml(priceText) + '</strong></div>';
      html += '<a class="lb-home-popup__cta" href="#" tabindex="-1" onclick="return false;"><span>查看詳情</span><span aria-hidden="true"> →</span></a>';
      html += '<label class="lb-home-popup__today"><input type="checkbox" tabindex="-1" disabled>';
      html += '<span class="lb-home-popup__check" aria-hidden="true"></span>今日不再顯示</label>';
      html += '</div></article></div></div></div>';
      if (!skipHint) {
        html += '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">與官網相同：桌機左右分欄、手機改上下堆疊。同池可能輪替。</p>';
      }
      return html;
    }

    if (kind === 'event_spotlight') {
      html += '<section class="lb-spotlight" aria-label="活動焦點預覽">';
      html += '<div class="lb-spotlight__panel"><div class="lb-spotlight__inner">';
      html += '<header class="lb-spotlight__head">';
      html += '<p class="lb-spotlight__eyebrow">LadyBae</p>';
      html += '<h2 class="lb-spotlight__section-title">活動焦點</h2>';
      html += '</header>';
      html += '<article class="lb-spotlight__card">';
      html += '<div class="lb-spotlight__stage">';
      html += '<a class="lb-spotlight__hero" href="#" tabindex="-1" onclick="return false;">';
      if (desk) html += '<img class="lb-spotlight__hero-img" src="' + escapeHtml(desk) + '" alt="">';
      else html += '<div class="lb-spotlight__hero-img" style="display:flex;align-items:center;justify-content:center;background:#efe6e9;color:#776b70;">第 1 張大圖</div>';
      html += '</a>';
      html += '<div class="lb-spotlight__side is-thumbs-3" role="list">';
      for (var tj = 1; tj <= 3; tj++) {
        var tSrc = imgs[tj] || '';
        html += '<a class="lb-spotlight__thumb" href="#" tabindex="-1" onclick="return false;" role="listitem">';
        if (tSrc) html += '<img class="lb-spotlight__thumb-img" src="' + escapeHtml(tSrc) + '" alt="">';
        else html += '<div class="lb-spotlight__thumb-img" style="display:flex;align-items:center;justify-content:center;background:#efe6e9;color:#776b70;font-size:var(--lbt-min, 12px);">小圖 ' + tj + '</div>';
        html += '</a>';
      }
      html += '</div></div>';
      html += '<div class="lb-spotlight__copy">';
      html += '<h3 class="lb-spotlight__title"><a href="#" tabindex="-1" onclick="return false;">' + escapeHtml(title) + '</a></h3>';
      if (desc) html += '<p class="lb-spotlight__sub">' + escapeHtml(desc) + '</p>';
      html += '<a class="lb-spotlight__cta" href="#" tabindex="-1" onclick="return false;">查看活動</a>';
      html += '</div></article></div></div></section>';
      if (!skipHint) {
        html += '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">與官網相同：1 大圖＋最多 3 小圖＋CTA。建議同時間只一檔上牆。</p>';
      }
      return html;
    }

    if (kind === 'promo_card' || kind === 'course_card') {
      var isCourseCard = kind === 'course_card';
      var cardBadge = isCourseCard
        ? (String((opts && opts.mode) || '').toUpperCase() === 'EXPOSURE' ? '純上架' : '含金流')
        : '宣傳刊登';
      var emptyText = isCourseCard ? '尚未上傳封面圖' : '尚未上傳宣傳圖';
      var ariaLabel = isCourseCard ? '課程卡預覽（1:1）' : '宣傳牆卡片預覽';
      html += '<article class="lb-promo-card lb-v2-promo-preview-card" aria-label="' + ariaLabel + '">';
      html += '<a class="lb-promo-card__link" href="#" tabindex="-1" onclick="return false;">';
      html += '<div class="lb-promo-card__media">';
      if (desk) {
        html += '<img class="lb-promo-card__img" data-promo-preview-img="0" src="' + escapeHtml(desk) + '" alt="">';
      } else {
        html += '<div class="lb-promo-card__img lb-promo-card__img--empty" style="display:flex;align-items:center;justify-content:center;color:#776b70;font-size:var(--lbt-caption, 13px);font-weight:600;">' +
          escapeHtml(emptyText) + '</div>';
      }
      html += '<span class="lb-promo-card__badge">' + escapeHtml(cardBadge) + '</span>';
      html += '</div>';
      html += '<div class="lb-promo-card__body">';
      html += '<h3 class="lb-promo-card__title">' + escapeHtml(title) + '</h3>';
      if (vendor) html += '<p class="lb-promo-card__vendor">' + escapeHtml(vendor) + '</p>';
      html += '<span class="lb-promo-card__cta">' + (isCourseCard ? '立即報名' : '查看詳情') + '</span>';
      html += '</div></a></article>';
      if (!skipHint) {
        html += '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">封面固定 <strong>1:1</strong> 正方形、object-fit:cover。比例不同請用下方構圖調整。</p>';
      }
      return html;
    }

    html += '<div class="lb-v2-place-preview__banner">';
    html += desk
      ? '<img src="' + escapeHtml(desk) + '" alt="">'
      : '<div class="lb-v2-place-preview__empty">尚未上傳封面圖</div>';
    html += '<div class="lb-v2-place-preview__banner-cap">' + escapeHtml(title) + '</div></div>';
    if (!skipHint) {
      html += '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">此版位尚無專用前台 section 預覽，僅顯示通用橫幅。</p>';
    }
    return html;
  }

  /** 桌機＋手機並排；手機欄用 --phone 強制套用前台 ≤749 規則（modal 視窗寬度不會觸發 media）。 */
  function buildStorefrontSlotWallToggleHtml(kind, opts) {
    opts = opts || {};
    var openDevice = opts.openDevice === 'mobile' ? 'mobile' : (opts.openDevice === 'desktop' ? 'desktop' : '');
    var hint = '';
    if (kind === 'home_carousel') {
      hint = '與官網相同：桌機＝第 1 張、手機＝第 2 張（缺則互用）。同池輪播，不保證順序。';
    } else if (kind === 'popular_courses') {
      hint = '與官網相同：桌機 3 格、手機橫滑單卡；封面 5:4。同池不順位。';
    } else if (kind === 'home_popup') {
      hint = '與官網相同：桌機左右分欄、手機上下堆疊。調構圖會留在目前的桌機／手機預覽。';
    } else if (kind === 'event_spotlight') {
      hint = '與官網相同：1 大圖＋最多 3 小圖＋CTA。建議同時間只一檔上牆。';
    } else if (kind === 'promo_card' || kind === 'course_card') {
      hint = openDevice
        ? '封面固定 1:1。右側（手機則下方）調構圖時，左側牆面會即時更新，可一眼對照整體效果。'
        : '封面固定 1:1 正方形。比例不同時請在下方構圖區縮放／移動後再送審。';
    }
    var html = '<div class="lb-v2-slot-preview-toggle' + (openDevice ? ' is-open' : '') + '"' +
      (openDevice ? ' data-open-device="' + openDevice + '"' : '') + '>';
    html += '<div class="lb-v2-slot-preview-toggle__bar" role="group" aria-label="官網版位預覽">';
    html += '<button type="button" class="lb-v2-slot-preview-toggle__btn' +
      (openDevice === 'desktop' ? ' is-active' : '') + '" data-preview-device="desktop">桌機預覽</button>';
    html += '<button type="button" class="lb-v2-slot-preview-toggle__btn' +
      (openDevice === 'mobile' ? ' is-active' : '') + '" data-preview-device="mobile">手機預覽</button>';
    html += '<button type="button" class="lb-v2-slot-preview-toggle__btn lb-v2-slot-preview-toggle__btn--ghost" data-preview-device="close"' +
      (openDevice ? '' : ' hidden') + '>收合預覽</button>';
    html += '</div>';
    if (hint) html += '<p class="lb-v2-hint lb-v2-slot-preview-toggle__hint">' + hint + '</p>';
    html += '<div class="lb-v2-slot-preview-toggle__stage"' + (openDevice ? '' : ' hidden') + '>';
    html += '<div class="lb-v2-slot-preview-toggle__pane" data-pane="desktop"' +
      (openDevice === 'desktop' ? '' : ' hidden') + '>';
    html += '<div class="lb-v2-slot-preview-fit"><div class="lb-v2-slot-preview">';
    html += buildStorefrontSlotWallHtml(kind, Object.assign({}, opts, { device: 'desktop', skipHint: true }));
    html += '</div></div></div>';
    html += '<div class="lb-v2-slot-preview-toggle__pane lb-v2-slot-preview-toggle__pane--phone" data-pane="mobile"' +
      (openDevice === 'mobile' ? '' : ' hidden') + '>';
    html += '<div class="lb-v2-slot-preview-fit lb-v2-slot-preview-fit--phone">';
    html += '<div class="lb-v2-slot-preview lb-v2-slot-preview--phone">';
    html += buildStorefrontSlotWallHtml(kind, Object.assign({}, opts, { device: 'mobile', skipHint: true }));
    html += '</div></div></div>';
    html += '</div></div>';
    return html;
  }

  function bindSlotPreviewToggle(root) {
    if (!root || !root.querySelectorAll) return;
    var wraps = root.querySelectorAll('.lb-v2-slot-preview-toggle');
    for (var i = 0; i < wraps.length; i++) {
      (function (wrap) {
        if (wrap._lbPreviewBound) return;
        wrap._lbPreviewBound = true;
        wrap.addEventListener('click', function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          var btn = t.closest('[data-preview-device]');
          if (!btn || !wrap.contains(btn)) return;
          e.preventDefault();
          var device = btn.getAttribute('data-preview-device') || '';
          var stage = wrap.querySelector('.lb-v2-slot-preview-toggle__stage');
          var closeBtn = wrap.querySelector('[data-preview-device="close"]');
          var deskPane = wrap.querySelector('[data-pane="desktop"]');
          var mobPane = wrap.querySelector('[data-pane="mobile"]');
          var deskBtn = wrap.querySelector('[data-preview-device="desktop"]');
          var mobBtn = wrap.querySelector('[data-preview-device="mobile"]');
          function setActive(which) {
            if (deskBtn) deskBtn.classList.toggle('is-active', which === 'desktop');
            if (mobBtn) mobBtn.classList.toggle('is-active', which === 'mobile');
            if (deskPane) deskPane.hidden = which !== 'desktop';
            if (mobPane) mobPane.hidden = which !== 'mobile';
            if (stage) stage.hidden = !which;
            if (closeBtn) closeBtn.hidden = !which;
            wrap.classList.toggle('is-open', !!which);
            wrap.setAttribute('data-open-device', which || '');
          }
          if (device === 'close') {
            setActive('');
            return;
          }
          if (device === 'desktop' || device === 'mobile') {
            // 再按一次同一顆 → 收合
            if (btn.classList.contains('is-active')) setActive('');
            else setActive(device);
          }
        });
      })(wraps[i]);
    }
  }

  function readSlotPreviewDevice(root) {
    if (!root || !root.querySelector) return 'desktop';
    var wrap = root.querySelector('.lb-v2-slot-preview-toggle');
    if (!wrap) return 'desktop';
    var saved = wrap.getAttribute('data-open-device') || '';
    if (saved === 'mobile' || saved === 'desktop') return saved;
    var mob = wrap.querySelector('[data-preview-device="mobile"]');
    if (mob && mob.classList.contains('is-active')) return 'mobile';
    return 'desktop';
  }

  /** Wall + product-page mock for public slots (docs §7). PRIVATE skips. */
  function buildListingPlacementPreviewHtml(mode) {
    if (String(mode || '').toUpperCase() === 'PRIVATE') return '';
    var meta = getListingPreviewSlotMeta();
    var imgs = collectListingImageSources();
    var title = (($('lb-v2-listing-title') || {}).value || '').trim() || '（未填標題）';
    var desk = imgs[0] || '';
    var mob = imgs[1] || desk;
    if (!desk && mob) desk = mob;
    var kind = resolveWallPreviewKind(meta.slotName, meta.planName, mode);
    var slotLabel = meta.slotName || meta.planName || '公開版位';
    var needsCrop = listingModeNeedsSquareReviewCrop(mode);
    var previewHead = (kind === 'course_card' || kind === 'promo_card')
      ? ('課程卡／封面預覽（1:1）· ' + slotLabel)
      : ('牆面／版位預覽 · ' + slotLabel);
    var html = '<div class="lb-v2-place-preview' + (needsCrop ? ' lb-v2-place-preview--compose' : '') + '">';
    html += '<p class="lb-v2-review-note">以下預覽使用<strong>與官網相同</strong>的封面比例。同池<strong>不保證</strong>順位或第幾格。' +
      (needsCrop ? '調構圖時請看左側（手機為上方）牆面，無需來回捲動。' : '') +
      '</p>';
    if (needsCrop) {
      var cropMode = String(mode || '').toUpperCase();
      var cropTitle = cropMode === 'PROMO' ? '宣傳圖構圖（1:1）' : '商品圖構圖（1:1）';
      var cropHint = cropMode === 'PROMO'
        ? '與官網宣傳牆相同為正方形。縮放／左右／上下時，左側牆面即時更新；確認送審時會套用裁切。'
        : '商品頁封面與課程卡縮圖以 1:1 正方形顯示。縮放／左右／上下時，左側牆面即時更新；確認送審時會套用裁切。';
      html += '<div class="lb-v2-place-preview__block lb-v2-place-preview__compose">';
      html += '<div class="lb-v2-place-preview__compose-wall">';
      html += '<h4 class="lb-v2-place-preview__h">' + escapeHtml(previewHead) + '</h4>';
      html += buildStorefrontSlotWallToggleHtml(kind, {
        title: title,
        desk: desk,
        mob: mob,
        imgs: imgs,
        desc: listingDescriptionPreviewText(90),
        vendor: '',
        priceText: '',
        mode: mode,
        openDevice: 'desktop',
      });
      html += '</div>';
      html += '<div class="lb-v2-place-preview__compose-crop">';
      html += '<h4 class="lb-v2-place-preview__h">' + cropTitle + '</h4>';
      html += '<p class="lb-v2-hint" style="margin:0 0 0.55rem;">' + cropHint + '</p>';
      html += '<div id="lb-v2-promo-review-crop-root" class="lb-v2-addon-crop-root"></div>';
      html += '</div></div>';
    } else {
      html += '<div class="lb-v2-place-preview__block">';
      html += '<h4 class="lb-v2-place-preview__h">' + escapeHtml(previewHead) + '</h4>';
      html += buildStorefrontSlotWallToggleHtml(kind, {
        title: title,
        desk: desk,
        mob: mob,
        imgs: imgs,
        desc: listingDescriptionPreviewText(90),
        vendor: '',
        priceText: '',
        mode: mode,
      });
      html += '</div>';
    }

    html += '<div class="lb-v2-place-preview__block">';
    html += '<h4 class="lb-v2-place-preview__h">商品頁預覽</h4>';
    html += '<div class="lb-v2-place-preview__pdp">';
    html += '<div class="lb-v2-place-preview__pdp-cover">';
    html += desk
      ? '<img src="' + escapeHtml(desk) + '" alt="">'
      : '<div class="lb-v2-place-preview__empty">無封面</div>';
    html += '</div>';
    html += '<div class="lb-v2-place-preview__pdp-body">';
    html += '<strong class="lb-v2-place-preview__pdp-title">' + escapeHtml(title) + '</strong>';
    html += '<p class="lb-v2-hint">' + escapeHtml(modeLabel(mode)) + '</p>';
    if (imgs.length) {
      html += '<div class="lb-v2-place-preview__thumbs">';
      imgs.forEach(function (src, i) {
        html +=
          '<figure><img src="' +
          escapeHtml(src) +
          '" alt=""><figcaption>' +
          (i + 1) +
          (i === 0 ? ' 封面' : i === 1 && kind === 'home_carousel' ? ' 手機' : '') +
          '</figcaption></figure>';
      });
      html += '</div>';
    } else {
      html += '<p class="lb-v2-hint">尚未上傳商品圖片</p>';
    }
    html += '</div></div></div>';

    html += '</div>';
    return html;
  }

  function buildListingReviewHtml() {
    var modeEl = $('lb-v2-listing-mode');
    var mode = modeEl ? modeEl.value : 'FULL';
    var variants = collectVariants();
    var variantText = variants.length
      ? variants.map(function (v) {
          return v.name + '／NT$' + v.price + '／' + v.quantity + ' 張';
        }).join('；')
      : '—';
    var startAt = readDateTimePair('lb-v2-listing-start-date', 'lb-v2-listing-start-time');
    var endAt = readDateTimePair('lb-v2-listing-end-date', 'lb-v2-listing-end-time');
    var planEl = $('lb-v2-listing-fee-plan');
    var planLabel = '—';
    if (planEl && planEl.value) {
      var selectedPlan = document.querySelector(
        '#lb-v2-listing-fee-plan-list .lb-v2-fee-plan-pick__item.is-selected'
      );
      planLabel =
        (selectedPlan && (selectedPlan.getAttribute('data-plan-name') || '').trim()) ||
        ('方案 #' + planEl.value);
    } else if (planEl && planEl.getAttribute('data-official-direct-slot') === '1') {
      planLabel = planEl.getAttribute('data-plan-name') || planEl.getAttribute('data-slot-name') || '直接選版位';
    }
    var html = buildListingPlacementPreviewHtml(mode);
    html += '<p class="lb-v2-review-note">請確認以下欄位無誤。送出後無法編輯，直到審核結果回傳。</p>';
    html += '<dl class="lb-v2-review-dl">';
    html += reviewRow('上架模式', modeLabel(mode));
    html += reviewRow(mode === 'PROMO' ? '宣傳主題' : '標題', (($('lb-v2-listing-title') || {}).value || '').trim());
    if (mode === 'PROMO') {
      html += reviewRow('活動介紹', (($('lb-v2-listing-desc') || {}).value || '').trim() || '—');
      html += reviewRow('主題系列', getSelectedSubcategories().join('、') || '—');
      html += reviewRow('露出縣市', collectCityCodes().map(cityLabelForCode).join('、') || '—');
      html += reviewRow('預設前往連結', (($('lb-v2-listing-external-url') || {}).value || '').trim());
      var ctaMap = readCityCtaUrls();
      var ctaText = Object.keys(ctaMap).map(function (k) {
        return cityLabelForCode(k) + ' → ' + ctaMap[k];
      }).join('；');
      html += reviewRow('縣市專用連結', ctaText || '（皆用預設）');
      html += reviewRow('曝光起日', (($('lb-v2-listing-exposure-start') || {}).value || '').trim());
      html += reviewRow('曝光迄日', (($('lb-v2-listing-exposure-end') || {}).value || '').trim());
      html += reviewRow('使用方案', planLabel);
      var promoDescImgs = collectDescImageSources();
      if (promoDescImgs.length) {
        html += '<div class="lb-v2-review-row"><dt>說明圖片</dt><dd class="lb-v2-review-images">';
        promoDescImgs.forEach(function (src) {
          html += '<img src="' + escapeHtml(src) + '" alt="">';
        });
        html += '</dd></div>';
      } else {
        html += reviewRow('說明圖片', '未上傳');
      }
      var promoImgs = collectListingImageSources();
      if (promoImgs.length) {
        html += reviewRow('宣傳圖片', '共 ' + promoImgs.length + ' 張（構圖見上方 1:1 預覽；送審時套用裁切）');
      } else {
        html += reviewRow('宣傳圖片', '尚未上傳');
      }
    } else {
      html += reviewRow('商品類型', getSelectedCategory());
      html += reviewRow('商品系列', getSelectedSubcategories().join('、') || '—');
      html += reviewRow('開課開始', startAt || '—');
      html += reviewRow('開課結束', endAt || '—');
      html += reviewRow('場地', (($('lb-v2-listing-venue') || {}).value || '').trim());
      if (mode === 'PRIVATE') {
        html += reviewRow('講師', (($('lb-v2-listing-instructor') || {}).value || '').trim());
        html += reviewRow('主辦單位', (($('lb-v2-listing-organizer') || {}).value || '').trim());
        html += reviewRow('協辦單位', (($('lb-v2-listing-co-organizer') || {}).value || '').trim());
        html += reviewRow('月曆顏色', readCalSwatchValue('lb-v2-listing-calendar-color'));
      }
      html += reviewRow('開課縣市', collectCityCodes().map(cityLabelForCode).join('、') || '—');
      html += reviewRow('地址', composeListingAddress() || '—');
      html += reviewRow('票種', variantText);
      var descImgSources = collectDescImageSources();
      if (descImgSources.length) {
        html += '<div class="lb-v2-review-row"><dt>說明圖片</dt><dd class="lb-v2-review-images">';
        descImgSources.forEach(function (src) {
          html += '<img src="' + escapeHtml(src) + '" alt="">';
        });
        html += '</dd></div>';
      } else {
        html += reviewRow('說明圖片', '未上傳');
      }
      var imgSources = collectListingImageSources();
      if (imgSources.length) {
        if (listingModeNeedsSquareReviewCrop(mode)) {
          html += reviewRow('商品圖片', '共 ' + imgSources.length + ' 張（構圖見上方 1:1 預覽；送審時套用裁切）');
        } else {
          html += '<div class="lb-v2-review-row"><dt>商品圖片</dt><dd class="lb-v2-review-images">';
          imgSources.forEach(function (src) {
            html += '<img src="' + escapeHtml(src) + '" alt="">';
          });
          html += '</dd></div>';
        }
      } else {
        html += reviewRow('商品圖片', '尚未上傳');
      }
      html += reviewRow('最低開課人數', (($('lb-v2-listing-min-attendees') || {}).value || '').trim() || '不設限');
      var highlightNotesRaw = (($('lb-v2-listing-highlight-notes') || {}).value || '').trim();
      html += reviewRow(
        '重點備註',
        highlightNotesRaw
          ? highlightNotesRaw.split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean).join('；')
          : '（無，僅系統自動）'
      );
      html += reviewRow(
        '開課判斷時程',
        '固定：活動前第 3 天 00:00 評估／第 2 天 00:00 截止（台北）'
      );
      if (mode === 'EXPOSURE') {
        html += reviewRow('外部購票連結', (($('lb-v2-listing-external-url') || {}).value || '').trim());
        html += reviewRow('曝光起日', (($('lb-v2-listing-exposure-start') || {}).value || '').trim());
        html += reviewRow('曝光迄日', (($('lb-v2-listing-exposure-end') || {}).value || '').trim());
        html += reviewRow('使用方案', planLabel);
      } else if (mode === 'PRIVATE') {
        html += reviewRow('曝光起日', (($('lb-v2-listing-exposure-start') || {}).value || '').trim());
        html += reviewRow('曝光迄日', (($('lb-v2-listing-exposure-end') || {}).value || '').trim());
        html += reviewRow('使用方案', planLabel || '年約（自動）');
        html += reviewRow('取消政策', '開課前 3 天退 90%；3 天內不退；截止 23:59');
      } else if (mode === 'FULL') {
        html += reviewRow('取消政策', '開課前 3 天退 90%；3 天內不退；截止 23:59');
      }
    }
    html += '</dl>';
    return html;
  }

  function isPrivateListingMode() {
    var modeEl = $('lb-v2-listing-mode');
    return resolveListingMode((modeEl && modeEl.value) || '') === 'PRIVATE';
  }

  var promoReviewCrops = [];
  var promoReviewPreviews = [];
  var promoReviewTimers = {};
  var PROMO_WALL_CROP_SPEC = {
    label: '宣傳牆封面',
    ratio: 1,
    ratioLabel: '1:1',
    wall: true,
  };
  var FULL_PRODUCT_CROP_SPEC = {
    label: '商品封面',
    ratio: 1,
    ratioLabel: '1:1',
    wall: true,
  };

  function listingModeNeedsSquareReviewCrop(mode) {
    var m = String(mode || '').toUpperCase();
    return m === 'PROMO' || m === 'FULL';
  }

  function currentListingReviewMode() {
    var modeEl = $('lb-v2-listing-mode');
    return resolveListingMode((modeEl && modeEl.value) || '') || 'FULL';
  }

  function clearPromoReviewCropState() {
    Object.keys(promoReviewTimers).forEach(function (k) {
      clearTimeout(promoReviewTimers[k]);
    });
    promoReviewTimers = {};
    (promoReviewPreviews || []).forEach(function (u) { revokeIfBlobUrl(u); });
    promoReviewCrops = [];
    promoReviewPreviews = [];
  }

  function getPromoReviewSpec() {
    return currentListingReviewMode() === 'PROMO'
      ? PROMO_WALL_CROP_SPEC
      : FULL_PRODUCT_CROP_SPEC;
  }

  function ensurePromoReviewCropState(idx, natW, natH) {
    if (!promoReviewCrops[idx]) {
      promoReviewCrops[idx] = defaultAddonCrop(natW, natH);
    } else {
      if (natW) promoReviewCrops[idx].natW = natW;
      if (natH) promoReviewCrops[idx].natH = natH;
    }
    return promoReviewCrops[idx];
  }

  async function bakePromoReviewCropToBlob(idx) {
    var sources = collectListingImageSources();
    var src = sources[idx];
    var spec = getPromoReviewSpec();
    if (!src || !spec) return null;
    var crop = promoReviewCrops[idx] || defaultAddonCrop(0, 0);
    var img = await loadImageElement(src);
    var natW = img.naturalWidth || img.width;
    var natH = img.naturalHeight || img.height;
    if (!(natW > 0 && natH > 0)) return null;
    crop.natW = natW;
    crop.natH = natH;
    promoReviewCrops[idx] = crop;
    var rect = computeCoverCropRect(natW, natH, spec.ratio, crop.zoom, crop.fx, crop.fy);
    var outW = Math.round(rect.w);
    var outH = Math.round(rect.h);
    var longEdge = Math.max(outW, outH);
    var maxLong = 2200;
    if (longEdge > maxLong) {
      var s = maxLong / longEdge;
      outW = Math.max(1, Math.round(outW * s));
      outH = Math.max(1, Math.round(outH * s));
    }
    var canvas = document.createElement('canvas');
    canvas.width = outW;
    canvas.height = outH;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, rect.x, rect.y, rect.w, rect.h, 0, 0, outW, outH);
    return canvasToJpegBlob(canvas, 0.92);
  }

  function schedulePromoReviewCropPreview(idx) {
    if (promoReviewTimers[idx]) clearTimeout(promoReviewTimers[idx]);
    promoReviewTimers[idx] = setTimeout(function () {
      refreshPromoReviewCropPreview(idx);
    }, 120);
  }

  async function refreshPromoReviewCropPreview(idx) {
    var sources = collectListingImageSources();
    if (!sources[idx]) return;
    try {
      var blob = await bakePromoReviewCropToBlob(idx);
      if (!blob) return;
      revokeIfBlobUrl(promoReviewPreviews[idx]);
      promoReviewPreviews[idx] = URL.createObjectURL(blob);
      var modal = $('lb-v2-modal-body') || document;
      var frameImg = modal.querySelector(
        '.lb-v2-addon-crop[data-promo-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
      );
      if (frameImg) {
        if (sources[idx] && frameImg.getAttribute('src') !== sources[idx]) {
          frameImg.src = sources[idx];
        }
        applyLiveCropFrameStyle(
          frameImg,
          promoReviewCrops[idx] || defaultAddonCrop(0, 0),
          getPromoReviewSpec()
        );
      }
      var wallImgs = modal.querySelectorAll('[data-promo-preview-img="' + idx + '"]');
      for (var wi = 0; wi < wallImgs.length; wi++) {
        wallImgs[wi].src = promoReviewPreviews[idx];
      }
      if (idx === 0) {
        var pdp = modal.querySelector('.lb-v2-place-preview__pdp-cover img');
        if (pdp) pdp.src = promoReviewPreviews[idx];
        var bannerImgs = modal.querySelectorAll('.lb-v2-place-preview__banner img');
        for (var bi = 0; bi < bannerImgs.length; bi++) {
          bannerImgs[bi].src = promoReviewPreviews[idx];
        }
      }
      var thumbFigs = modal.querySelectorAll('.lb-v2-place-preview__thumbs figure img');
      if (thumbFigs[idx]) thumbFigs[idx].src = promoReviewPreviews[idx];
      var warnEl = modal.querySelector(
        '.lb-v2-addon-crop[data-promo-crop-idx="' + idx + '"] .lb-v2-addon-crop__warn'
      );
      var crop = promoReviewCrops[idx] || defaultAddonCrop(0, 0);
      var spec = getPromoReviewSpec();
      if (warnEl && spec) warnEl.textContent = cropFramePanHint(crop, spec);
    } catch (e) {
      /* CORS／讀圖失敗時仍用原圖 */
    }
  }

  function renderPromoReviewCropEditors() {
    var root = $('lb-v2-promo-review-crop-root');
    if (!root) return;
    var sources = collectListingImageSources();
    var spec = getPromoReviewSpec();
    var emptyHint = currentListingReviewMode() === 'PROMO'
      ? '尚未上傳宣傳圖。'
      : '尚未上傳商品圖片。';
    var html = '';
    var any = false;
    for (var idx = 0; idx < sources.length; idx++) {
      if (!sources[idx]) continue;
      any = true;
      var crop = promoReviewCrops[idx] || defaultAddonCrop(0, 0);
      var previewSrc = sources[idx];
      var warn = cropFramePanHint(crop, spec);
      html += '<div class="lb-v2-addon-crop" data-promo-crop-idx="' + idx + '">';
      html += '<div class="lb-v2-addon-crop__head">';
      html += '<div class="lb-v2-addon-crop__title">';
      html += '<span class="lb-v2-addon-crop__kicker">構圖</span>';
      html += '<strong>第 ' + (idx + 1) + ' 張 · ' + escapeHtml(spec.label) +
        (idx === 0 ? '（封面）' : '') + '</strong>';
      html += '</div>';
      html += '<div class="lb-v2-addon-crop__head-actions">';
      html += '<span class="lb-v2-addon-crop__ratio">' + escapeHtml(spec.ratioLabel) + '</span>';
      html += '</div></div>';
      html += '<div class="lb-v2-addon-crop__stage">';
      html += '<div class="lb-v2-addon-crop__viewport">';
      html += cropFrameBoxOpenTag(spec);
      html += '<img src="' + escapeHtml(previewSrc) + '" alt="裁切預覽">';
      html += '<span class="lb-v2-addon-crop__guide" aria-hidden="true"></span>';
      html += '</div></div>';
      html += '<div class="lb-v2-addon-crop__controls" role="group" aria-label="構圖微調">';
      html += '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">縮放</span>';
      html += '<input class="lb-v2-addon-crop__range" type="range" min="100" max="300" step="1" value="' +
        Math.round((crop.zoom || 1) * 100) + '" data-promo-crop-zoom="' + idx + '" aria-label="縮放"></div>';
      html += '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">左右</span>';
      html += '<input class="lb-v2-addon-crop__range" type="range" min="0" max="100" step="1" value="' +
        Math.round(crop.fx == null ? 50 : crop.fx) + '" data-promo-crop-fx="' + idx + '" aria-label="左右"></div>';
      html += '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">上下</span>';
      html += '<input class="lb-v2-addon-crop__range" type="range" min="0" max="100" step="1" value="' +
        Math.round(crop.fy == null ? 50 : crop.fy) + '" data-promo-crop-fy="' + idx + '" aria-label="上下"></div>';
      html += '</div></div>';
      html += '<p class="lb-v2-addon-crop__warn">' + escapeHtml(warn) + '</p>';
      html += '</div>';
    }
    if (!any) {
      root.innerHTML = '<p class="lb-v2-hint">' + emptyHint + '</p>';
      return;
    }
    root.innerHTML = html;
    for (var pj = 0; pj < sources.length; pj++) {
      if (!sources[pj]) continue;
      applyLiveCropFrameStyle(
        root.querySelector('.lb-v2-addon-crop[data-promo-crop-idx="' + pj + '"] .lb-v2-addon-crop__frame img'),
        promoReviewCrops[pj] || defaultAddonCrop(0, 0),
        spec
      );
    }
    if (!root._lbPromoCropBound) {
      root._lbPromoCropBound = true;
      root.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || !t.getAttribute) return;
        var idxZ = t.getAttribute('data-promo-crop-zoom');
        var idxX = t.getAttribute('data-promo-crop-fx');
        var idxY = t.getAttribute('data-promo-crop-fy');
        var idx = idxZ != null ? parseInt(idxZ, 10)
          : (idxX != null ? parseInt(idxX, 10)
            : (idxY != null ? parseInt(idxY, 10) : -1));
        if (!(idx >= 0)) return;
        var crop = ensurePromoReviewCropState(idx, 0, 0);
        if (idxZ != null) crop.zoom = Math.max(1, (parseInt(t.value, 10) || 100) / 100);
        if (idxX != null) crop.fx = parseInt(t.value, 10) || 0;
        if (idxY != null) crop.fy = parseInt(t.value, 10) || 0;
        promoReviewCrops[idx] = crop;
        var live = root.querySelector(
          '.lb-v2-addon-crop[data-promo-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
        );
        applyLiveCropFrameStyle(live, crop, getPromoReviewSpec());
        schedulePromoReviewCropPreview(idx);
      });
    }
    sources.forEach(function (src, idx) {
      if (!src) return;
      loadImageElement(src).then(function (img) {
        ensurePromoReviewCropState(
          idx,
          img.naturalWidth || img.width,
          img.naturalHeight || img.height
        );
        schedulePromoReviewCropPreview(idx);
      }).catch(function () { /* ignore */ });
    });
  }

  async function applyPromoReviewCropsToListingImages() {
    var sources = collectListingImageSources();
    if (!sources.length) return true;
    var prefix = currentListingReviewMode() === 'PROMO' ? 'promo-crop-' : 'full-crop-';
    var nextSources = sources.slice();
    var nextFiles = (listingImageFiles || []).slice();
    while (nextFiles.length < nextSources.length) nextFiles.push(null);
    for (var i = 0; i < sources.length; i++) {
      if (!sources[i]) continue;
      var blob = await bakePromoReviewCropToBlob(i);
      if (!blob) continue;
      var file = new File([blob], prefix + (i + 1) + '.jpg', { type: 'image/jpeg' });
      revokeIfBlobUrl(nextSources[i]);
      nextSources[i] = URL.createObjectURL(blob);
      nextFiles[i] = file;
    }
    setListingImageSources(nextSources);
    listingImageFiles = nextFiles;
    return true;
  }

  function openListingReviewModal() {
    var isPrivate = isPrivateListingMode();
    var modeEl = $('lb-v2-listing-mode');
    var reviewMode = modeEl ? resolveListingMode(modeEl.value) : 'FULL';
    var needsSquareCrop = listingModeNeedsSquareReviewCrop(reviewMode);
    clearPromoReviewCropState();
    openModal({
      title: isPrivate ? '確認上架內容' : '預覽並確認送審',
      wide: true,
      compose: needsSquareCrop,
      bodyHtml: buildListingReviewHtml(),
      actions: [
        { label: '返回修改', ghost: true, close: true },
        {
          label: isPrivate ? '確認上架' : '確認送審',
          accent: true,
          close: false,
          onClick: function () {
            if (needsSquareCrop) {
              (async function () {
                setDataLoading(
                  true,
                  reviewMode === 'PROMO' ? '套用宣傳圖構圖…' : '套用商品圖構圖…'
                );
                try {
                  await applyPromoReviewCropsToListingImages();
                  closeModal();
                  clearPromoReviewCropState();
                  var ok = await saveListingDraft({ skipReview: true });
                  if (ok) await submitListingForReview();
                } catch (err) {
                  showListingAlert(err.message || '套用構圖失敗');
                } finally {
                  setDataLoading(false);
                }
              })();
              return false;
            }
            closeModal();
            submitListingForReview();
            return false;
          },
        },
      ],
    });
    if (needsSquareCrop) {
      try { renderPromoReviewCropEditors(); } catch (e) {
        console.warn('[lb-v2] listing review crop', e);
      }
    }
  }

  function formatCurrency(val) {
    var n = moneyCents(val);
    return 'NT$ ' + n.toLocaleString('zh-TW', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function setDataLoading(show, text) {
    var el = $('lb-v2-data-status');
    if (!el) return;
    el.classList.toggle('lb-v2-status--hidden', !show);
    el.setAttribute('aria-busy', show ? 'true' : 'false');
    var root = $('lb-v2-root');
    if (root) root.classList.toggle('is-data-loading', !!show);
    var textEl = $('lb-v2-data-status-text');
    if (textEl) textEl.textContent = text || '載入中…';
    // 鎖捲動，避免遮罩下頁面跳動感
    try {
      if (show) {
        if (document.documentElement.dataset.lbV2ScrollLock !== '1') {
          document.documentElement.dataset.lbV2ScrollLock = '1';
          document.documentElement.style.overflow = 'hidden';
        }
      } else if (document.documentElement.dataset.lbV2ScrollLock === '1') {
        delete document.documentElement.dataset.lbV2ScrollLock;
        document.documentElement.style.overflow = '';
      }
    } catch (e) {}
  }

  function setBootstrapText(text) {
    var el = $('lb-v2-bootstrap-text');
    if (el) el.textContent = text || '授權確認中…';
  }

  /** Cancel token for ALL-mode progressive fan-out. */
  var dataLoadGeneration = 0;

  function bumpDataLoadGeneration() {
    dataLoadGeneration += 1;
    return dataLoadGeneration;
  }

  async function mapPool(items, concurrency, workerFn) {
    var list = Array.isArray(items) ? items : [];
    var results = new Array(list.length);
    var cursor = 0;
    async function runWorker() {
      while (cursor < list.length) {
        var i = cursor;
        cursor += 1;
        results[i] = await workerFn(list[i], i);
      }
    }
    var n = Math.max(1, Math.min(concurrency || 3, list.length || 1));
    var workers = [];
    for (var w = 0; w < n; w++) workers.push(runWorker());
    await Promise.all(workers);
    return results;
  }

  function preferMobileTicketList() {
    try {
      return window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
    } catch (e) {
      return false;
    }
  }

  function setUpdatedAt() {
    $('lb-v2-updated-at').textContent = new Date().toLocaleString('zh-TW');
  }

  function syncScanLink() {
    var link = $('lb-v2-scan-link');
    if (!link) return;
    var base = config.scanUrl || '/pages/vendor-scan-v2';
    if (!isAllMode() && vendorMode && vendorMode !== ALL_MODE) {
      link.href = base + '?vendor=' + encodeURIComponent(vendorMode);
    } else {
      link.href = base;
    }
  }

  function normalizeRole(role) {
    var value = String(role || '').trim().toLowerCase();
    if (value === 'admin' || value === 'owner' || value === 'staff' || value === 'scan_only') return value;
    return '';
  }

  function canExportRole(role) { return role === 'owner' || role === 'admin'; }
  function canRevealFullPiiRole(role) { return role === 'owner' || role === 'admin'; }
  function canAccessAttendanceRole(role) {
    return role === 'owner' || role === 'admin' || role === 'staff';
  }
  /** Owner/admin: private apply / brand page / private settlement. */
  function canManagePrivateVendorAdminRole(role) {
    return role === 'owner' || role === 'admin';
  }
  /** Staff whitelist tabs when PRIVATE module is open. */
  function isStaffPrivateOpsTab(tab) {
    return tab === 'private-eligibility' || tab === 'private-schedule';
  }
  function isStaffPrivateAdminTab(tab) {
    return tab === 'private' || tab === 'private-page' || tab === 'settlement-private';
  }

  function getRoleForSlug(slug) { return normalizeRole(vendorRoleBySlug[slug]); }

  function getSelectedVendorRole() {
    if (isAllMode()) return '';
    if (!vendorMode) return '';
    return getRoleForSlug(vendorMode);
  }

  function getFullPiiGate() {
    var vendors = getActiveVendors();
    if (!vendors.length) return { allowed: false, reason: '尚無授權廠商' };
    if (isAllMode() && vendors.length > 1) {
      return { allowed: false, reason: '全部模式請先選擇單一擁有者／管理員廠商再顯示或匯出完整個資' };
    }
    var role = getRoleForSlug(vendors[0]);
    if (!canRevealFullPiiRole(role)) {
      return { allowed: false, reason: '此角色不可檢視完整個資' + (role ? '（' + (ROLE_LABELS[role] || role) + '）' : '') };
    }
    return { allowed: true, reason: '' };
  }

  function getAttendanceGate() {
    var vendors = getActiveVendors();
    if (!vendors.length) return { allowed: false, reason: '尚無授權廠商' };
    if (isAllMode() && vendors.length > 1) {
      return { allowed: false, reason: '全部模式請先選擇單一廠商再匯出簽到表' };
    }
    var role = getRoleForSlug(vendors[0]);
    if (!canAccessAttendanceRole(role)) {
      return {
        allowed: false,
        reason: '此角色不可匯出簽到表' + (role ? '（' + (ROLE_LABELS[role] || role) + '）' : ''),
      };
    }
    return { allowed: true, reason: '' };
  }

  function isScanOnlyOnlyAccount() {
    if (!activeVendors.length) return false;
    return activeVendors.every(function (slug) { return getRoleForSlug(slug) === 'scan_only'; });
  }

  function getActiveVendors() {
    if (vendorMode === ALL_MODE) return activeVendors.slice();
    if (activeVendors.indexOf(vendorMode) >= 0) return [vendorMode];
    return [];
  }

  function isAllMode() { return vendorMode === ALL_MODE; }

  function getPageState(tab) { return tab === 'overview' ? overviewPage : eventsPage; }

  function getExportGate() {
    var vendors = getActiveVendors();
    if (!vendors.length) return { allowed: false, reason: '尚無授權廠商' };

    if (isAllMode() && vendors.length > 1) {
      var mixedBlocked = vendors.filter(function (slug) { return !canExportRole(getRoleForSlug(slug)); });
      if (mixedBlocked.length) {
        return { allowed: false, reason: '全部模式含工作人員／僅掃碼角色，不可匯出' };
      }
      return { allowed: false, reason: '全部模式請先選擇單一擁有者／管理員廠商再匯出' };
    }

    var role = getRoleForSlug(vendors[0]);
    if (!canExportRole(role)) {
      return { allowed: false, reason: '此角色不可匯出' + (role ? '（' + (ROLE_LABELS[role] || role) + '）' : '') };
    }
    return { allowed: true, reason: '' };
  }

  function updateExportControls() {
    var exportStudentsBtn = $('lb-v2-export-students');
    var exportAttendanceBtn = $('lb-v2-export-attendance');
    var roleNotice = $('lb-v2-role-notice');
    var fullGate = getFullPiiGate();
    var attendanceGate = getAttendanceGate();

    // 列表已預設完整個資，不再提供遮蔽切換。
    revealFullPii = fullGate.allowed ? true : revealFullPii;

    if (exportStudentsBtn) {
      exportStudentsBtn.disabled = !fullGate.allowed;
      exportStudentsBtn.title = fullGate.reason || '匯出學員名單（含完整個資，會寫入稽核）';
    }
    if (exportAttendanceBtn) {
      exportAttendanceBtn.disabled = !attendanceGate.allowed;
      exportAttendanceBtn.title =
        attendanceGate.reason || '匯出簽到表（可選欄位）';
    }
    if (roleNotice) {
      roleNotice.hidden = true;
      roleNotice.innerHTML = '';
    }
  }

  function renderMetafieldWarning() {
    // Do not surface unauthorized / other-vendor slugs to vendors.
    var el = $('lb-v2-auth-warning');
    if (el) {
      el.hidden = true;
      el.innerHTML = '';
    }
  }

  var vendorPickerBound = false;
  var vendorPickerOpen = false;

  function vendorDisplayName(slug) {
    var name = vendorNameBySlug[slug] || '';
    if (name && name !== slug) return name + '（' + slug + '）';
    return slug;
  }

  function vendorOptionLabel(slug) {
    var role = getRoleForSlug(slug);
    var roleLabel = ROLE_LABELS[role] || role;
    var base = vendorDisplayName(slug);
    return roleLabel ? (base + ' · ' + roleLabel) : base;
  }

  function vendorPickerCurrentLabel() {
    // Closed button: short brand-first label (slug stays in title / menu).
    if (vendorMode === ALL_MODE) return 'ALL（全部授權廠商）';
    var name = vendorNameBySlug[vendorMode] || vendorMode;
    var role = ROLE_LABELS[getRoleForSlug(vendorMode)] || '';
    return role ? (name + ' · ' + role) : name;
  }

  function vendorPickerCurrentTitle() {
    if (vendorMode === ALL_MODE) return 'ALL（全部授權廠商）';
    return vendorOptionLabel(vendorMode);
  }

  function setVendorPickerBodyScrollLock(locked) {
    // 不用 overflow:hidden 鎖 body：iOS 會連 fixed 選單內部的 overflow 滾動一併關掉
    try {
      if (locked) {
        if (document.body.dataset.lbV2PickerScrollLock === '1') return;
        var y = window.scrollY || window.pageYOffset || 0;
        document.body.dataset.lbV2PickerScrollLock = '1';
        document.body.dataset.lbV2PickerScrollY = String(y);
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + y + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      } else if (document.body.dataset.lbV2PickerScrollLock === '1') {
        var y2 = parseInt(document.body.dataset.lbV2PickerScrollY || '0', 10) || 0;
        delete document.body.dataset.lbV2PickerScrollLock;
        delete document.body.dataset.lbV2PickerScrollY;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, y2);
      }
    } catch (e) { /* ignore */ }
  }

  function ensureVendorPickerMenuOnBody() {
    var menu = $('lb-v2-vendor-picker-menu');
    if (menu && menu.parentNode !== document.body) document.body.appendChild(menu);
    return menu;
  }

  function closeVendorPicker() {
    var btn = $('lb-v2-vendor-picker-btn');
    var menu = ensureVendorPickerMenuOnBody();
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (menu) {
      menu.hidden = true;
      menu.classList.remove('is-open');
      menu.removeAttribute('style');
    }
    vendorPickerOpen = false;
    setVendorPickerBodyScrollLock(false);
  }

  function positionVendorPickerMenu() {
    var btn = $('lb-v2-vendor-picker-btn');
    var menu = ensureVendorPickerMenuOnBody();
    if (!btn || !menu || menu.hidden) return;
    var rect = btn.getBoundingClientRect();
    var width = Math.max(rect.width, Math.min(520, window.innerWidth - 24));
    var left = Math.min(rect.left, window.innerWidth - width - 12);
    left = Math.max(12, left);
    var top = rect.bottom + 6;
    var maxH = Math.min(420, window.innerHeight * 0.6);
    if (top + Math.min(maxH, 240) > window.innerHeight - 12) {
      top = Math.max(12, rect.top - 6 - Math.min(maxH, rect.top - 12));
    }
    menu.style.position = 'fixed';
    menu.style.top = Math.round(top) + 'px';
    menu.style.left = Math.round(left) + 'px';
    menu.style.width = Math.round(width) + 'px';
    menu.style.maxHeight = Math.round(maxH) + 'px';
    menu.style.zIndex = '2147483000';
  }

  function openVendorPicker() {
    var btn = $('lb-v2-vendor-picker-btn');
    var menu = ensureVendorPickerMenuOnBody();
    if (!btn || !menu) return;
    menu.hidden = false;
    menu.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    vendorPickerOpen = true;
    setVendorPickerBodyScrollLock(true);
    positionVendorPickerMenu();
  }

  function setVendorMode(next, opts) {
    var options = opts || {};
    if (activeVendors.indexOf(next) < 0 && next !== ALL_MODE) return;
    if (vendorMode === next && !options.force) {
      closeVendorPicker();
      return;
    }
    bumpDataLoadGeneration();
    vendorMode = next;
    var valueEl = $('lb-v2-vendor-picker-value');
    var pickerBtn = $('lb-v2-vendor-picker-btn');
    if (valueEl) valueEl.textContent = vendorPickerCurrentLabel();
    if (pickerBtn) pickerBtn.title = vendorPickerCurrentTitle();
    closeVendorPicker();
    if (options.skipLoad) {
      syncScanLink();
      updateExportControls();
      return;
    }
    selectedEventId = null;
    cachedEventsItems = [];
    eventsPage.currentPage = 1;
    overviewPage.currentPage = 1;
    invalidateTabCaches();
    refreshCourseDecisionBadge();
    refreshTabNavCapability();
    loadActiveTab(true);
  }

  function bindVendorPicker() {
    if (vendorPickerBound) return;
    var btn = $('lb-v2-vendor-picker-btn');
    var menu = $('lb-v2-vendor-picker-menu');
    if (!btn || !menu) return;
    vendorPickerBound = true;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (vendorPickerOpen) closeVendorPicker();
      else openVendorPicker();
    });

    menu.addEventListener('click', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('[data-vendor-value]') : null;
      if (!item) return;
      e.preventDefault();
      setVendorMode(item.getAttribute('data-vendor-value') || '');
    });

    document.addEventListener('click', function (e) {
      if (!vendorPickerOpen) return;
      var picker = $('lb-v2-vendor-picker');
      var menuEl = $('lb-v2-vendor-picker-menu');
      // menu 會掛到 body，不能只判斷 picker.contains
      if (picker && e.target && picker.contains(e.target)) return;
      if (menuEl && e.target && menuEl.contains(e.target)) return;
      closeVendorPicker();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && vendorPickerOpen) closeVendorPicker();
    });

    window.addEventListener('resize', function () {
      if (vendorPickerOpen) positionVendorPickerMenu();
    });
    // 選單本身的 overflow 滾動不要重算定位，否則手機滑動會被打斷／重置
    window.addEventListener('scroll', function (e) {
      if (!vendorPickerOpen) return;
      var menuEl = $('lb-v2-vendor-picker-menu');
      var t = e && e.target;
      if (menuEl && (t === menuEl || (t && menuEl.contains && menuEl.contains(t)))) return;
      positionVendorPickerMenu();
    }, true);
  }

  function renderVendorSelector() {
    bindVendorPicker();
    var menu = ensureVendorPickerMenuOnBody();
    var valueEl = $('lb-v2-vendor-picker-value');
    var menuHtml = '';

    function pushOption(value, label, roleLine) {
      var selected = vendorMode === value;
      // 用 div 而非 button：iOS 在 overflow 容器內對 button 觸控滾動常失效
      menuHtml +=
        '<li role="presentation">' +
          '<div role="option" class="lb-v2-vendor-picker__option' +
          (selected ? ' is-active' : '') +
          '" data-vendor-value="' + escapeHtml(value) + '"' +
          ' aria-selected="' + (selected ? 'true' : 'false') + '"' +
          ' tabindex="-1">' +
            '<span>' + escapeHtml(label) + '</span>' +
            (roleLine ? '<span class="lb-v2-vendor-picker__option-role">' + escapeHtml(roleLine) + '</span>' : '') +
          '</div>' +
        '</li>';
    }

    if (activeVendors.length > 1) {
      pushOption(ALL_MODE, 'ALL（全部授權廠商）', '');
    }
    activeVendors.forEach(function (slug) {
      var role = getRoleForSlug(slug);
      var roleLabel = ROLE_LABELS[role] || role;
      pushOption(slug, vendorDisplayName(slug), roleLabel ? ('角色：' + roleLabel) : '');
    });

    if (menu) menu.innerHTML = menuHtml;
    if (valueEl) valueEl.textContent = vendorPickerCurrentLabel();
    var pickerBtn = $('lb-v2-vendor-picker-btn');
    if (pickerBtn) pickerBtn.title = vendorPickerCurrentTitle();
    closeVendorPicker();
    syncScanLink();
    updateExportControls();
  }

  function buildFilterParams(pageState, includeEvent) {
    var params = {};
    if (includeEvent && selectedEventId) params.event_id = selectedEventId;
    if (pageState.filterRedeemed) params.redeemed = pageState.filterRedeemed;
    if (pageState.filterTicketStatus) params.ticket_status = pageState.filterTicketStatus;
    if (pageState.filterQ) params.q = pageState.filterQ;
    return params;
  }

  function buildListParams(pageState, includeEvent) {
    var params = buildFilterParams(pageState, includeEvent);
    params.page = pageState.currentPage;
    params.limit = pageState.listLimit;
    if (revealFullPii && getFullPiiGate().allowed) {
      params.reveal = '1';
    }
    return params;
  }

  function buildExportUrl(vendorSlug, pageState, includeEvent, fullPii) {
    var params = new URLSearchParams();
    params.set('vendor_slug', vendorSlug);
    var extra = buildFilterParams(pageState, includeEvent);
    Object.keys(extra).forEach(function (key) { params.set(key, extra[key]); });
    var path = fullPii ? PATHS.exportFullPii : PATHS.export;
    return path + '?' + params.toString();
  }

  function buildAttendanceExportUrl(vendorSlug, pageState, includeEvent, format, cols) {
    var params = new URLSearchParams();
    params.set('vendor_slug', vendorSlug);
    params.set('format', format === 'pdf' ? 'pdf' : 'docx');
    params.set('cols', cols || attendanceColsQueryValue(DEFAULT_ATTENDANCE_COLS));
    var extra = buildFilterParams(pageState, includeEvent);
    Object.keys(extra).forEach(function (key) { params.set(key, extra[key]); });
    return PATHS.exportAttendance + '?' + params.toString();
  }

  /** Optional cols default off (figure-2 red-X). Fixed: seq/student/signature/note. */
  var DEFAULT_ATTENDANCE_COLS = {
    elig: false,
    buyer: false,
    phone: false,
    birth: false,
    venue: false,
    portrait: false
  };

  function attendanceColsStorageKey(slug) {
    return 'lb-v2-attendance-cols:' + String(slug || '');
  }

  function readAttendanceColsPref(slug) {
    var out = {
      elig: DEFAULT_ATTENDANCE_COLS.elig,
      buyer: DEFAULT_ATTENDANCE_COLS.buyer,
      phone: DEFAULT_ATTENDANCE_COLS.phone,
      birth: DEFAULT_ATTENDANCE_COLS.birth,
      venue: DEFAULT_ATTENDANCE_COLS.venue,
      portrait: DEFAULT_ATTENDANCE_COLS.portrait
    };
    try {
      var raw = localStorage.getItem(attendanceColsStorageKey(slug));
      if (!raw) return out;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj !== 'object') return out;
      ['elig', 'buyer', 'phone', 'birth', 'venue', 'portrait'].forEach(function (k) {
        if (typeof obj[k] === 'boolean') out[k] = obj[k];
      });
    } catch (e) { /* keep defaults */ }
    return out;
  }

  function writeAttendanceColsPref(slug, opts) {
    try {
      localStorage.setItem(attendanceColsStorageKey(slug), JSON.stringify({
        elig: !!opts.elig,
        buyer: !!opts.buyer,
        phone: !!opts.phone,
        birth: !!opts.birth,
        venue: !!opts.venue,
        portrait: !!opts.portrait
      }));
    } catch (e) { /* ignore */ }
  }

  function attendanceColsQueryValue(opts) {
    var parts = ['seq', 'student', 'signature', 'note'];
    if (opts.elig) parts.push('elig');
    if (opts.buyer) parts.push('buyer');
    if (opts.phone) parts.push('phone');
    if (opts.birth) parts.push('birth');
    if (opts.venue) parts.push('venue');
    if (opts.portrait) parts.push('portrait');
    return parts.join(',');
  }

  function readAttendanceColsFromModal() {
    function checked(id) {
      var el = $(id);
      return !!(el && el.checked);
    }
    return {
      elig: checked('lb-v2-att-col-elig'),
      buyer: checked('lb-v2-att-col-buyer'),
      phone: checked('lb-v2-att-col-phone'),
      birth: checked('lb-v2-att-col-birth'),
      venue: checked('lb-v2-att-col-venue'),
      portrait: checked('lb-v2-att-col-portrait')
    };
  }

  function attendanceColsCheckHtml(opts) {
    function box(id, label, on) {
      return (
        '<label class="lb-v2-att-col">' +
          '<input type="checkbox" id="' + id + '"' + (on ? ' checked' : '') + '>' +
          '<span>' + label + '</span>' +
        '</label>'
      );
    }
    return (
      '<div class="lb-v2-att-cols">' +
        '<div class="lb-v2-att-cols__title">選擇輸出欄位</div>' +
        '<p class="lb-v2-muted lb-v2-att-cols__hint">固定：編號、學員、簽名、備註。其餘勾選後會記住此廠商偏好。</p>' +
        '<div class="lb-v2-att-cols__grid">' +
          box('lb-v2-att-col-elig', '標籤', opts.elig) +
          box('lb-v2-att-col-buyer', '購買者姓名', opts.buyer) +
          box('lb-v2-att-col-phone', '電話', opts.phone) +
          box('lb-v2-att-col-birth', '生日(年月)', opts.birth) +
          box('lb-v2-att-col-venue', '地點', opts.venue) +
          box('lb-v2-att-col-portrait', '肖像權聲明', opts.portrait) +
        '</div>' +
      '</div>'
    );
  }

  // Mirror admin extractApiError: accept a fetch-wrapper result ({ payload })
  // OR a raw payload; surface { code, message } whether shaped as
  // { error:{code,message} }, flat { code, message }, or { message }.
  function extractApiError(res) {
    var payload = res && Object.prototype.hasOwnProperty.call(res, 'payload') ? res.payload : res;
    if (payload) {
      if (payload.error) {
        return {
          code: payload.error.code || '',
          message: payload.error.message || '',
        };
      }
      if (payload.code && payload.message) {
        return { code: String(payload.code), message: String(payload.message) };
      }
      if (payload.message) {
        return { code: '', message: String(payload.message) };
      }
    }
    return { code: '', message: '' };
  }

  async function fetchAuthorizedVendors() {
    var payload = null;
    var status = 0;
    var cache = window.LbVendorAuthCache;
    if (cache && typeof cache.fetchAuthorized === 'function') {
      var cached = await cache.fetchAuthorized(PATHS.authorized);
      status = cached.status || 0;
      payload = cached.payload;
      if (!cached.ok || !payload || payload.ok !== true) {
        var codeC = payload && payload.error && payload.error.code ? payload.error.code : 'HTTP_' + status;
        var messageC = payload && payload.error && payload.error.message ? payload.error.message : '';
        return { ok: false, code: codeC, message: messageC, slugs: [], items: [] };
      }
    } else {
      var response = await fetch(PATHS.authorized, {
        method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin',
      });
      status = response.status;
      try { payload = await response.json(); } catch (e) { payload = null; }
      if (!response.ok || !payload || payload.ok !== true) {
        var code = payload && payload.error && payload.error.code ? payload.error.code : 'HTTP_' + status;
        var message = payload && payload.error && payload.error.message ? payload.error.message : '';
        return { ok: false, code: code, message: message, slugs: [], items: [] };
      }
    }
    var items = Array.isArray(payload.items) ? payload.items : [];
    var slugs = [];
    var roles = {};
    var names = {};
    items.forEach(function (item) {
      var slug = String(item && item.slug_handle || '').trim();
      if (!slug) return;
      if (PORTAL_VENDOR_EXCLUDE[slug]) return;
      if (slugs.indexOf(slug) < 0) slugs.push(slug);
      roles[slug] = normalizeRole(item && item.role);
      var name = String(item && item.name || '').trim();
      if (name) names[slug] = name;
    });
    slugs.sort(function (a, b) {
      var an = names[a] || a;
      var bn = names[b] || b;
      var byName = an.localeCompare(bn, 'zh-Hant', { sensitivity: 'base' });
      if (byName !== 0) return byName;
      return a.localeCompare(b, 'en', { sensitivity: 'base' });
    });
    return { ok: true, slugs: slugs, roles: roles, names: names, items: items };
  }

  async function fetchAppProxy(path, vendorSlug, extraParams) {
    var params = new URLSearchParams();
    if (vendorSlug != null && vendorSlug !== '') params.set('vendor_slug', vendorSlug);
    if (extraParams) {
      Object.keys(extraParams).forEach(function (key) {
        var value = extraParams[key];
        if (value != null && value !== '') params.set(key, String(value));
      });
    }
    var response = await fetch(path + '?' + params.toString(), {
      method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin',
    });
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    if (!response.ok || !payload || payload.ok !== true) {
      var code = payload && payload.error && payload.error.code ? payload.error.code : 'HTTP_' + response.status;
      var message = payload && payload.error && payload.error.message ? payload.error.message : '';
      return { ok: false, code: code, message: message, payload: payload };
    }
    return { ok: true, payload: payload };
  }

  async function fetchReportsBundle(pageState, includeEvent) {
    return fetchAppProxy(PATHS.reportsBundle, '', buildListParams(pageState, includeEvent));
  }

  async function applyReportsBundlePayload(payload, pageState, opts) {
    opts = opts || {};
    var events = (payload && payload.events) || {};
    var list = (payload && payload.list) || {};
    cachedEventsItems = events.items || [];
    if (events.errors && events.errors.length && !cachedEventsItems.length) {
      showNotice($('lb-v2-events-notice'), '部分廠商無法載入活動：' +
        friendlyError(events.errors[0].code, events.errors[0].message));
    } else if (events.errors && events.errors.length) {
      showNotice($('lb-v2-events-notice'), '部分廠商無法載入，其餘活動仍顯示。');
    } else {
      showNotice($('lb-v2-events-notice'), '');
    }
    renderEventsList();
    updateEventTitleBar();

    if (payload && payload.summary) {
      renderKpi(opts.kpiId || 'lb-v2-kpi', payload.summary, { scope: (opts.kpiId || 'lb-v2-kpi') === 'lb-v2-kpi' ? 'course' : 'ops' });
      showNotice($(opts.summaryNoticeId || 'lb-v2-summary-notice'), '');
    } else if (payload && payload.summary_errors && payload.summary_errors.length) {
      var kpiEl = $(opts.kpiId || 'lb-v2-kpi');
      if (kpiEl) kpiEl.hidden = true;
      showNotice($(opts.summaryNoticeId || 'lb-v2-summary-notice'), friendlyError(
        payload.summary_errors[0].code,
        payload.summary_errors[0].message
      ));
    }

    var listItems = list.items || [];
    var listErrors = list.errors || [];
    if (!listItems.length && listErrors.length) {
      showNotice($(opts.listNoticeId || 'lb-v2-list-notice'), friendlyError(
        listErrors[0].code,
        listErrors[0].message
      ));
    } else if (listErrors.length && listItems.length) {
      showNotice($(opts.listNoticeId || 'lb-v2-list-notice'), '部分廠商票券無法載入，其餘仍顯示。');
    } else {
      showNotice($(opts.listNoticeId || 'lb-v2-list-notice'), '');
    }
    renderItems(opts.listId || 'lb-v2-list', listItems, !!list.showVendor);
    renderPagination(opts.paginationId || 'lb-v2-pagination', list.pagination || {
      page: pageState.currentPage,
      limit: pageState.listLimit,
      total: listItems.length,
      total_pages: 1,
      has_prev: false,
      has_next: false,
    }, function (delta) {
      pageState.currentPage = Math.max(1, pageState.currentPage + delta);
      if (typeof opts.onPage === 'function') opts.onPage();
    });
  }

  function emptySummary() {
    return {
      sold_count: 0, sales_amount: 0, redeemed_count: 0, redeemed_amount: 0,
      unredeemed_count: 0, unredeemed_amount: 0, redeem_rate: 0,
      refund_amount: 0, net_amount: 0, average_order_value: 0, discount_total: 0,
      settlement_count: 0, active_count: 0, void_count: 0, refunded_count: 0,
      cancel_basic_count: 0, cancel_recent_count: 0,
      cancel_basic_amount: 0, cancel_recent_amount: 0,
      platform_fee_total: 0, vendor_share_total: 0,
      order_count: 0, currency: 'TWD',
    };
  }

  function aggregateSummaries(summaries) {
    var base = emptySummary();
    var orderCountSum = 0;
    summaries.forEach(function (s) {
      if (!s) return;
      base.sold_count += Number(s.sold_count || 0);
      base.sales_amount += Number(s.sales_amount || 0);
      base.redeemed_count += Number(s.redeemed_count || 0);
      base.redeemed_amount += Number(s.redeemed_amount || 0);
      base.unredeemed_count += Number(s.unredeemed_count || 0);
      base.unredeemed_amount += Number(s.unredeemed_amount || 0);
      base.refund_amount += Number(s.refund_amount || 0);
      base.discount_total += Number(s.discount_total || 0);
      base.settlement_count += Number(s.settlement_count || 0);
      base.active_count += Number(s.active_count || s.settlement_count || 0);
      base.void_count += Number(s.void_count || 0);
      base.refunded_count += Number(s.refunded_count || 0);
      base.cancel_basic_count += Number(s.cancel_basic_count || 0);
      base.cancel_recent_count += Number(s.cancel_recent_count || 0);
      base.cancel_basic_amount += Number(s.cancel_basic_amount || 0);
      base.cancel_recent_amount += Number(s.cancel_recent_amount || 0);
      base.platform_fee_total += Number(s.platform_fee_total || 0);
      base.vendor_share_total += Number(s.vendor_share_total || 0);
      orderCountSum += Number(s.order_count || 0);
      if (!base.currency && s.currency) base.currency = s.currency;
    });
    var activeForRate = base.active_count || base.settlement_count;
    var activeRedeemed = Math.max(0, activeForRate - base.unredeemed_count);
    base.redeem_rate = activeForRate ? activeRedeemed / activeForRate : 0;
    base.order_count = orderCountSum;
    base.sales_amount = moneyCents(base.sales_amount);
    base.refund_amount = moneyCents(base.refund_amount);
    base.cancel_basic_amount = moneyCents(base.cancel_basic_amount);
    base.cancel_recent_amount = moneyCents(base.cancel_recent_amount);
    base.net_amount = moneyCents(base.sales_amount - base.refund_amount);
    base.average_order_value = orderCountSum ? moneyCents(base.net_amount / orderCountSum) : 0;
    return base;
  }

  /**
   * scope='course'（課程數據）只出票券張數／核銷率，不含任何金額。
   * 票面額、退款現金、營運淨額、分潤等完整口徑一律在營運數據。
   */
  function renderKpi(targetId, summary, opts) {
    var el = $(targetId);
    if (!summary) { el.hidden = true; return; }
    var courseScope = !!(opts && opts.scope === 'course');
    var currency = summary.currency || 'TWD';
    var activeCount = Number(summary.active_count != null ? summary.active_count : summary.settlement_count || 0);
    var unredeemedCount = Number(summary.unredeemed_count || 0);
    var activeRedeemed = Math.max(0, activeCount - unredeemedCount);
    var cancelBasicCount = Number(summary.cancel_basic_count != null ? summary.cancel_basic_count : summary.refunded_count || 0);
    var cancelRecentCount = Number(summary.cancel_recent_count != null ? summary.cancel_recent_count : summary.void_count || 0);
    var cancelBasicAmount = moneyCents(summary.cancel_basic_amount);
    var cancelRecentAmount = moneyCents(summary.cancel_recent_amount);
    var salesAmount = moneyCents(summary.sales_amount);
    var refundAmount = moneyCents(summary.refund_amount);
    var discountTotal = moneyCents(summary.discount_total);
    var platformFee = moneyCents(summary.platform_fee_total);
    var vendorShare = moneyCents(summary.vendor_share_total);
    // 實際入帳 − 實際退款（整數元，對 Shopify 實收／實退）
    var retainedFromCancels = Math.max(0, cancelBasicAmount + cancelRecentAmount - refundAmount);
    var netAmount = salesAmount - refundAmount;
    var orderCount = Number(summary.order_count || 0);
    var averageOrderValue = orderCount ? moneyCents(netAmount / orderCount) : 0;

    // 用 span，避免主題全域 button 把問號拉成高瘦膠囊
    function tipBtn(text, label) {
      if (!text) return '';
      return '<span class="lb-v2-kpi-tip" role="button" tabindex="0" aria-expanded="false" aria-label="' +
        escapeHtml(label || '說明') + '" data-kpi-tip="' + escapeHtml(text) + '">?</span>';
    }

    function cardHtml(card) {
      return '<div class="lb-v2-kpi-card' + (card.tone ? ' lb-v2-kpi-card--' + card.tone : '') + '">' +
        '<div class="lb-v2-kpi-label-row">' +
          '<span class="lb-v2-kpi-label">' + escapeHtml(card.label) + '</span>' +
          tipBtn(card.hint, card.label + '說明') +
        '</div>' +
        '<div class="lb-v2-kpi-value">' + card.value + '</div>' +
      '</div>';
    }

    function groupHtml(num, title, blurb, cards) {
      return '<section class="lb-v2-kpi-group">' +
        '<div class="lb-v2-kpi-group__head">' +
          '<span class="lb-v2-kpi-group__num" aria-hidden="true">' + escapeHtml(String(num)) + '</span>' +
          '<h3 class="lb-v2-kpi-group__title">' + escapeHtml(title) + '</h3>' +
          tipBtn(blurb, title + '說明') +
        '</div>' +
        '<div class="lb-v2-kpi-group__grid">' + cards.map(cardHtml).join('') + '</div>' +
      '</section>';
    }

    el.hidden = false;
    el.classList.toggle('lb-v2-kpi--grouped', !courseScope);
    el.classList.toggle('lb-v2-kpi--strip', !!courseScope);
    el.classList.remove('lb-v2-kpi--compact');

    // 課程數據：單排指標列（銷售｜核銷｜退票），不再三欄卡片堆疊
    var capacityCards = [];
    if (
      summary.available_count != null &&
      summary.capacity_total != null &&
      summary.capacity_total > 0
    ) {
      capacityCards.push({
        label: '可售票數',
        value: formatCount(summary.available_count) + '／' + formatCount(summary.capacity_total),
        hint: '名額 − 有效票 − 作廢；基本退票會釋出名額，作廢不補',
        cluster: 'end',
      });
    }
    var courseKpiCards = [
          { label: '售出', value: formatCount(summary.sold_count), hint: '售出張數・含退款／作廢', cluster: 'start' },
          { label: '訂單', value: formatCount(summary.order_count), hint: '不重複訂單' },
          { label: '有效票', value: formatCount(activeCount), hint: '未作廢且無退款紀錄', cluster: 'end' },
          { label: '已核銷', value: formatCount(activeRedeemed), tone: 'ok', hint: '僅有效票', cluster: 'start' },
          { label: '未核銷', value: formatCount(unredeemedCount), hint: '僅有效票' },
          { label: '核銷率', value: formatPercent(summary.redeem_rate), tone: 'accent', hint: '已核銷 ÷ 有效票', cluster: 'end' },
          { label: '基本退票', value: formatCount(cancelBasicCount), tone: 'warn', hint: '有退款紀錄的票', cluster: 'start' },
          { label: '近期作廢', value: formatCount(cancelRecentCount), hint: '作廢且無退款', cluster: 'end' },
        ];
    if (capacityCards.length) {
      courseKpiCards.splice(1, 0, capacityCards[0]);
    }
    var courseKpiHtml =
      '<div class="lb-v2-kpi-strip" role="group" aria-label="課程票券指標">' +
        courseKpiCards.map(function (card) {
          var cls = 'lb-v2-kpi-card';
          if (card.tone) cls += ' lb-v2-kpi-card--' + card.tone;
          if (card.cluster) cls += ' lb-v2-kpi-card--' + card.cluster;
          return '<div class="' + cls + '">' +
            '<div class="lb-v2-kpi-label-row">' +
              '<span class="lb-v2-kpi-label">' + escapeHtml(card.label) + '</span>' +
              tipBtn(card.hint, card.label + '說明') +
            '</div>' +
            '<div class="lb-v2-kpi-value">' + card.value + '</div>' +
          '</div>';
        }).join('') +
      '</div>';

    var opsKpiHtml =
      groupHtml(
        '1',
        '銷售（票面）',
        '含退款／作廢票。此區是「當初賣出」的票面，尚未扣除退款。',
        [
          { label: '售出張數', value: formatCount(summary.sold_count), hint: '全部票（含退款／作廢）' },
          { label: '票面銷售額', value: formatMoney(salesAmount, currency), tone: 'accent', hint: 'line_total 合計・未扣退款' },
          { label: '訂單數', value: formatCount(summary.order_count), hint: '不重複訂單' },
          { label: '有效票張數', value: formatCount(activeCount), hint: '未作廢且無退款紀錄' },
        ]
      ) +
      groupHtml(
        '2',
        '核銷（僅有效票）',
        '有效票＝未作廢、且沒有退款紀錄（部分退款也不算有效）。已核銷＋未核銷＝有效票。',
        [
          { label: '已核銷', value: formatCount(activeRedeemed), tone: 'ok', hint: '僅有效票' },
          { label: '未核銷', value: formatCount(unredeemedCount), hint: '僅有效票' },
          { label: '核銷率', value: formatPercent(summary.redeem_rate), tone: 'accent', hint: '已核銷 ÷ 有效票' },
          { label: '已核銷金額', value: formatMoney(summary.redeemed_amount, currency), hint: '曾核銷票的票面合計' },
        ]
      ) +
      groupHtml(
        '3',
        '退票／作廢',
        '「基本退票」＝有退款（含部分退）；「近期作廢」＝作廢且無退款。票面額＝當初賣價，退款現金＝退給顧客的錢。' +
          '消費者退票時未退還的部分（基本退票的固定 10% 手續費、近期退票的全額）仍算你的收入，會進⑤分潤基數並照拆帳比例抽成。',
        [
          { label: '基本退票張數', value: formatCount(cancelBasicCount), tone: 'warn', hint: '有退款紀錄的票' },
          { label: '基本退票票面額', value: formatMoney(cancelBasicAmount, currency), tone: 'warn', hint: '這些票當初的銷售額' },
          { label: '近期作廢張數', value: formatCount(cancelRecentCount), hint: '作廢且無退款' },
          { label: '近期作廢票面額', value: formatMoney(cancelRecentAmount, currency), hint: '這些票當初的銷售額' },
          { label: '退款現金合計', value: formatMoney(refundAmount, currency), tone: 'warn', hint: '已退給顧客（≠ 基本退票票面）' },
          { label: '退票留存（你的收入）', value: formatMoney(retainedFromCancels, currency), tone: 'accent', hint: '退票／作廢票面 − 退款現金・計入分潤' },
        ]
      ) +
      groupHtml(
        '4',
        '營運淨額與官方折扣',
        '營運淨額＝票面銷售−退款現金，已含退票留存款。官方折扣由平台吸收，會加回「結算分潤基數」，但不在營運淨額裡。',
        [
          { label: '營運淨額', value: formatMoney(netAmount, currency), tone: 'accent', hint: '票面銷售 − 退款現金' },
          { label: '官方折扣', value: formatMoney(discountTotal, currency), hint: '平台吸收・加回分潤基數' },
          { label: '平均客單', value: formatMoney(averageOrderValue, currency), hint: '營運淨額 ÷ 訂單數' },
          { label: '有效票張數', value: formatCount(summary.settlement_count), hint: '未退款／未作廢' },
        ]
      ) +
      groupHtml(
        '5',
        '結算分潤（票上記錄）',
        '以下加總票券上已寫入的平台費／廠商分潤（通常綁定結算批次後才有；未綁批可能為 0）。含退票留存款，抽成比例與成功售票相同。完整批次請看「結算明細」。上架費／版位費不在此表。',
        [
          { label: '分潤基數', value: formatMoney(platformFee + vendorShare, currency), hint: '平台費 + 廠商分潤・含退票留存' },
          { label: '平台手續費', value: formatMoney(platformFee, currency), hint: '票上 platform_fee 合計' },
          { label: '廠商分潤（應匯）', value: formatMoney(vendorShare, currency), tone: 'accent', hint: '票上 vendor_share 合計' },
          { label: '官方折扣（平台成本）', value: formatMoney(discountTotal, currency), hint: '與④相同・結算不扣廠商' },
        ]
      );

    var footnote = courseScope
      ? '<div class="lb-v2-kpi-footnote">' +
          '<span class="lb-v2-kpi-footnote__label">口徑提醒</span>' +
          tipBtn(
            '本頁只看課程票券：售出／有效／核銷／退票作廢張數。票面額、退款現金、營運淨額、官方折扣、手續費、分潤與結算批次一律在「營運數據」。',
            '口徑提醒說明'
          ) +
        '</div>'
      : '<div class="lb-v2-kpi-footnote">' +
          '<span class="lb-v2-kpi-footnote__label">口徑提醒</span>' +
          tipBtn(
            '營運淨額 ≠ 結算分潤基數。結算依活動結束日雙週撥款；退票留存款（基本退票 10% 手續費、近期退票全額）計入並照拆帳比例抽成，官方取消開課的全額退款不計入。官方折扣加回基數後再抽平台費。上架費見「營運結帳／額度」。詳見本頁「結算明細」。',
            '口徑提醒說明'
          ) +
        '</div>';

    el.innerHTML = (courseScope ? courseKpiHtml : opsKpiHtml) + footnote;
    bindKpiTips(el);
  }

  function bindKpiTips(root) {
    if (!root || root.__lbKpiTipsBound) return;
    root.__lbKpiTipsBound = true;

    function closeAll(except) {
      root.querySelectorAll('.lb-v2-kpi-tip.is-open').forEach(function (btn) {
        if (except && btn === except) return;
        btn.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
      // Fixed tips may live on #lb-v2-root (outside this KPI root).
      document.querySelectorAll('.lb-v2-kpi-tip-pop, .lb-v2-kpi-tip-panel').forEach(function (el) {
        el.remove();
      });
    }

    function placeFixedPop(btn, pop) {
      var rect = btn.getBoundingClientRect();
      var pad = 12;
      var maxW = Math.min(300, window.innerWidth - pad * 2);
      pop.style.width = maxW + 'px';
      var left = Math.min(
        Math.max(pad, rect.left + rect.width / 2 - maxW / 2),
        window.innerWidth - maxW - pad
      );
      var top = rect.bottom + 8;
      // Prefer below; flip above if near bottom edge.
      var estH = 120;
      if (top + estH > window.innerHeight - pad && rect.top > estH + pad) {
        top = Math.max(pad, rect.top - 8);
        pop.style.transform = 'translateY(-100%)';
      } else {
        pop.style.transform = '';
      }
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    }

    function toggleTip(btn) {
      if (!btn || !root.contains(btn)) return;
      var open = btn.classList.contains('is-open');
      closeAll();
      if (open) return;
      var text = btn.getAttribute('data-kpi-tip') || '';
      if (!text) return;
      var pop = document.createElement('div');
      pop.setAttribute('role', 'tooltip');
      pop.textContent = text;
      // 一律 fixed：課程指標列 overflow:hidden 會裁掉 absolute 氣泡
      pop.className = 'lb-v2-kpi-tip-pop lb-v2-kpi-tip-pop--fixed';
      var mount = document.getElementById('lb-v2-root') || document.body;
      mount.appendChild(pop);
      placeFixedPop(btn, pop);
      btn.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }

    root.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('.lb-v2-kpi-tip') : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      ev.stopPropagation();
      toggleTip(btn);
    });
    root.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var btn = ev.target && ev.target.closest ? ev.target.closest('.lb-v2-kpi-tip') : null;
      if (!btn || !root.contains(btn)) return;
      ev.preventDefault();
      toggleTip(btn);
    });

    document.addEventListener('click', function (ev) {
      if (!root.isConnected) return;
      if (ev.target &&
          ev.target.closest('.lb-v2-kpi-tip, .lb-v2-kpi-tip-pop, .lb-v2-kpi-tip-panel')) return;
      closeAll();
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeAll();
    });
    window.addEventListener('resize', function () { closeAll(); }, { passive: true });
    window.addEventListener('scroll', function () { closeAll(); }, { passive: true, capture: true });
  }

  function eligTagHtml(label) {
    var t = String(label || '').trim();
    if (!t) return '';
    return '<span class="lb-v2-elig-tag" title="通行證標籤：' + escapeHtml(t) + '">' +
      '<span class="lb-v2-elig-tag__mark" aria-hidden="true">標</span>' +
      '<span class="lb-v2-elig-tag__text">' + escapeHtml(t) + '</span>' +
      '</span>';
  }

  function renderItems(targetId, items, showVendor) {
    var el = $(targetId);
    if (!items.length) {
      el.hidden = false;
      el.innerHTML = '<div class="lb-v2-empty">目前沒有票券資料</div>';
      return;
    }
    var showFull = revealFullPii;
    var mobile = preferMobileTicketList();
    // Viewport-only DOM: desktop table XOR mobile cards (same data; ~half nodes).
    if (mobile) {
      var cards = items.map(function (item) {
        var ticketLabel = item.variant_title || item.ticket_type || '—';
        var statusLabel = ticketStatusLabelZh(item);
        var contactBits = [
          item.buyer_name ? ('購買者 ' + item.buyer_name) : '',
          item.phone,
          item.email,
        ].filter(Boolean).join(' · ');
        var uidDisplay = showFull ? (item.ticket_uid || '—') : maskUid(item.ticket_uid);
        return '<article class="lb-v2-m-card">' +
          '<div class="lb-v2-m-card__head">' +
            '<div class="lb-v2-m-card__title">' + escapeHtml(item.event_title || '—') + '</div>' +
            '<div class="lb-v2-m-card__badges">' + renderRedeemBadge(item) + '</div>' +
          '</div>' +
          (showVendor ? '<div class="lb-v2-m-card__meta">' + escapeHtml(item._vendor_slug || item.slug_handle || '') + '</div>' : '') +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">票種</span><span>' + escapeHtml(ticketLabel) + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">訂單</span><span>' + escapeHtml(item.order_name || '—') +
            ' · ' + escapeHtml(statusLabel) + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">學員</span><span>' +
            escapeHtml(item.name || '—') + eligTagHtml(item.eligibility_label) + '</span></div>' +
          (contactBits ? '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">聯絡</span><span>' + escapeHtml(contactBits) + '</span></div>' : '') +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">生日(年月)</span><span>' + escapeHtml(item.birth_ym || '—') + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">需求備註</span><span>' + escapeHtml(item.note || '—') + '</span></div>' +
          '<div class="lb-v2-m-card__foot">' +
            '<strong>' + formatMoney(item.line_total, item.currency) + '</strong>' +
            '<span class="lb-v2-m-card__uid" title="' + escapeHtml(item.ticket_uid || '') + '">' + escapeHtml(uidDisplay) + '</span>' +
          '</div>' +
        '</article>';
      }).join('');
      el.hidden = false;
      el.innerHTML = '<div class="lb-v2-m-cards" aria-label="票券列表">' + cards + '</div>';
      return;
    }

    var rows = items.map(function (item) {
      var ticketLabel = item.variant_title || item.ticket_type || '—';
      var statusLabel = ticketStatusLabelZh(item);
      var uidDisplay = showFull ? (item.ticket_uid || '—') : maskUid(item.ticket_uid);
      return '<tr>' +
        (showVendor ? '<td>' + escapeHtml(item._vendor_slug || item.slug_handle) + '</td>' : '') +
        '<td>' + escapeHtml(item.event_title) + '</td>' +
        '<td>' + escapeHtml(ticketLabel) + '</td>' +
        '<td>' + escapeHtml(item.order_name) + '</td>' +
        '<td>' + renderRedeemBadge(item) + '</td>' +
        '<td>' + escapeHtml(statusLabel) + '</td>' +
        '<td class="lb-v2-col-student">' + escapeHtml(item.name || '—') + eligTagHtml(item.eligibility_label) + '</td>' +
        '<td>' + escapeHtml(item.buyer_name || '—') + '</td>' +
        '<td>' + escapeHtml(item.email || '—') + '</td>' +
        '<td>' + escapeHtml(item.phone || '—') + '</td>' +
        '<td>' + escapeHtml(item.birth_ym || '—') + '</td>' +
        '<td>' + escapeHtml(item.note || '—') + '</td>' +
        '<td>' + formatMoney(item.line_total, item.currency) + '</td>' +
        '<td title="' + escapeHtml(item.ticket_uid || '') + '">' + escapeHtml(uidDisplay) + '</td>' +
      '</tr>';
    }).join('');

    el.hidden = false;
    el.innerHTML =
      '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
      (showVendor ? '<th>廠商</th>' : '') +
      '<th>活動</th><th>票種</th><th>訂單</th><th>核銷</th><th>狀態</th>' +
      '<th>學員姓名</th><th>購買者姓名</th><th>電子信箱</th><th>電話</th><th>生日(年月)</th><th>需求備註</th><th>金額</th><th>票券碼</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>';
  }

  function renderPagination(targetId, pagination, onPageChange) {
    var el = $(targetId);
    if (!pagination || pagination.total == null) { el.hidden = true; return; }
    el.hidden = false;
    el.innerHTML = '<div>第 ' + escapeHtml(pagination.page) + ' / ' + escapeHtml(pagination.total_pages || 0) +
      ' 頁（共 ' + escapeHtml(pagination.total) + ' 筆）</div>' +
      '<div class="lb-v2-pagination-actions">' +
      '<button type="button" class="lb-v2-btn lb-v2-btn--sm" id="' + targetId + '-prev"' +
        (pagination.has_prev ? '' : ' disabled') + '>上一頁</button>' +
      '<button type="button" class="lb-v2-btn lb-v2-btn--sm" id="' + targetId + '-next"' +
        (pagination.has_next ? '' : ' disabled') + '>下一頁</button>' +
      '</div>';
    var prev = $(targetId + '-prev');
    var next = $(targetId + '-next');
    if (prev && pagination.has_prev) prev.onclick = function () { onPageChange(-1); };
    if (next && pagination.has_next) next.onclick = function () { onPageChange(1); };
  }

  function mountFilters(targetId, pageState, onApply) {
    var el = $(targetId);
    if (!el) return;

    function bindFilterActions() {
      var applyBtn = $(targetId + '-apply');
      var clearBtn = $(targetId + '-clear');
      if (applyBtn) {
        applyBtn.onclick = function () {
          var q = (($(targetId + '-q') && $(targetId + '-q').value) || '').trim();
          var status = (($(targetId + '-status') && $(targetId + '-status').value) || '').trim();
          if (q === '—' || q === '-') q = '';
          if (status === '—' || status === '-') status = '';
          pageState.filterQ = q;
          pageState.filterRedeemed = ($(targetId + '-redeemed') && $(targetId + '-redeemed').value) || '';
          pageState.filterTicketStatus = status;
          pageState.listLimit = Number(($(targetId + '-limit') && $(targetId + '-limit').value) || 50) || 50;
          pageState.currentPage = 1;
          onApply(false);
        };
      }
      if (clearBtn) {
        clearBtn.onclick = function () {
          pageState.filterQ = '';
          pageState.filterRedeemed = '';
          pageState.filterTicketStatus = '';
          pageState.currentPage = 1;
          var qEl = $(targetId + '-q');
          var redeemedEl = $(targetId + '-redeemed');
          var statusEl = $(targetId + '-status');
          if (qEl) qEl.value = '';
          if (redeemedEl) redeemedEl.value = '';
          if (statusEl) statusEl.value = '';
          onApply(false);
        };
      }
    }

    if (el.dataset.lbFiltersMounted === '1') {
      var qEl = $(targetId + '-q');
      var redeemedEl = $(targetId + '-redeemed');
      var statusEl = $(targetId + '-status');
      var limitEl = $(targetId + '-limit');
      if (qEl) qEl.value = pageState.filterQ || '';
      if (redeemedEl) redeemedEl.value = pageState.filterRedeemed || '';
      if (statusEl) statusEl.value = pageState.filterTicketStatus || '';
      if (limitEl) limitEl.value = String(pageState.listLimit || 50);
      stripThemeSelectWrappers(el);
      bindFilterActions();
      return;
    }

    el.dataset.lbFiltersMounted = '1';
    // lb-v2-dyn：強迫原生 menulist，避免主題把 select 藏成「只有標籤」
    el.innerHTML = '<h2 class="lb-v2-filters-title">篩選與分頁</h2>' +
      '<div class="lb-v2-filters-grid">' +
      '<div class="lb-v2-field"><label for="' + targetId + '-q">搜尋</label><input id="' + targetId + '-q" class="lb-v2-input" type="search" value="' +
        escapeHtml(pageState.filterQ || '') + '" placeholder="訂單 / 姓名 / 電子信箱"></div>' +
      '<div class="lb-v2-field"><label for="' + targetId + '-redeemed">核銷狀態</label><select id="' + targetId + '-redeemed" class="lb-v2-select lb-v2-select--sm lb-v2-dyn">' +
        '<option value="">全部</option>' +
        '<option value="pending"' + (pageState.filterRedeemed === 'pending' ? ' selected' : '') + '>未核銷</option>' +
        '<option value="true"' + (pageState.filterRedeemed === 'true' ? ' selected' : '') + '>已核銷</option>' +
      '</select></div>' +
      '<div class="lb-v2-field"><label for="' + targetId + '-status">票券狀態</label><select id="' + targetId + '-status" class="lb-v2-select lb-v2-select--sm lb-v2-dyn">' +
        '<option value="">全部</option>' +
        '<option value="ACTIVE"' + (pageState.filterTicketStatus === 'ACTIVE' ? ' selected' : '') + '>有效</option>' +
        '<option value="PENDING_VENDOR_CONFIRM"' + (pageState.filterTicketStatus === 'PENDING_VENDOR_CONFIRM' ? ' selected' : '') + '>待確認收款</option>' +
        '<option value="REFUNDED"' + (pageState.filterTicketStatus === 'REFUNDED' ? ' selected' : '') + '>已退款</option>' +
        '<option value="VOIDED"' + (pageState.filterTicketStatus === 'VOIDED' ? ' selected' : '') + '>已作廢</option>' +
        '<option value="EXPIRED"' + (pageState.filterTicketStatus === 'EXPIRED' ? ' selected' : '') + '>已過期</option>' +
      '</select></div>' +
      '<div class="lb-v2-field"><label for="' + targetId + '-limit">每頁筆數</label><select id="' + targetId + '-limit" class="lb-v2-select lb-v2-select--sm lb-v2-dyn">' +
        [25, 50, 100, 200].map(function (n) {
          return '<option value="' + n + '"' + (pageState.listLimit === n ? ' selected' : '') + '>' + n + '</option>';
        }).join('') +
      '</select></div>' +
      '<div class="lb-v2-filters-actions">' +
      '<button type="button" class="lb-v2-btn lb-v2-btn--accent" id="' + targetId + '-apply">套用篩選</button>' +
      '<button type="button" class="lb-v2-btn" id="' + targetId + '-clear">清除篩選</button>' +
      '</div></div>';

    stripThemeSelectWrappers(el);
    [0, 120, 400].forEach(function (ms) {
      setTimeout(function () { stripThemeSelectWrappers(el); }, ms);
    });
    bindFilterActions();
  }

  function updateEventTitleBar() {
    var bar = $('lb-v2-event-title-bar');
    if (!bar) return;
    if (!selectedEventId) {
      if (isAllMode()) {
        bar.innerHTML = '<strong>全部活動彙總</strong><span class="lb-v2-muted"> · 全部廠商</span>';
      } else {
        var vendorLabel = vendorDisplayName(vendorMode) || vendorMode || '目前廠商';
        bar.innerHTML = '<strong>全部活動彙總</strong><span class="lb-v2-muted"> · ' +
          escapeHtml(vendorLabel) + '</span>';
      }
      return;
    }
    var found = cachedEventsItems.find(function (e) {
      return String(e.event_id) === String(selectedEventId);
    });
    if (found) {
      var vendorBit = found._vendor_slug
        ? escapeHtml(vendorDisplayName(found._vendor_slug) || found._vendor_slug)
        : (!isAllMode() ? escapeHtml(vendorDisplayName(vendorMode) || vendorMode || '') : '');
      bar.innerHTML = '<strong>' + escapeHtml(found.event_title || found.event_id) + '</strong>' +
        (vendorBit ? '<span class="lb-v2-muted"> · ' + vendorBit + '</span>' : '') +
        '<span class="lb-v2-muted"> · ' + escapeHtml(formatDateRange(found.event_start_at, found.event_end_at)) + '</span>';
    } else {
      bar.textContent = '活動編號：' + selectedEventId;
    }
  }

  function renderEventsList() {
    var el = $('lb-v2-events');
    var q = (eventSearchQuery || '').trim().toLowerCase();
    var items = cachedEventsItems.filter(function (item) {
      if (!q) return true;
      var title = String(item.event_title || '').toLowerCase();
      var id = String(item.event_id || '').toLowerCase();
      var vendor = String(item._vendor_slug || '').toLowerCase();
      return title.indexOf(q) >= 0 || id.indexOf(q) >= 0 || vendor.indexOf(q) >= 0;
    });

    var allBtn = '<button type="button" class="lb-v2-btn lb-v2-btn--sm' +
      (!selectedEventId ? ' lb-v2-btn--accent' : '') + '" id="lb-v2-clear-event">全部活動</button>';

    if (!items.length) {
      el.innerHTML = allBtn + '<div class="lb-v2-empty">目前沒有活動資料</div>';
    } else {
      el.innerHTML = allBtn + items.map(function (item) {
        var selected = selectedEventId && String(item.event_id) === String(selectedEventId);
        var rate = formatPercent(item.redeem_rate);
        return '<button type="button" class="lb-v2-event-card' + (selected ? ' lb-v2-event-card--selected' : '') +
          '" data-event-id="' + escapeHtml(item.event_id) + '">' +
          '<div class="lb-v2-event-title">' + escapeHtml(item.event_title || item.event_id) + '</div>' +
          (item._vendor_slug ? '<div class="lb-v2-event-vendor">' + escapeHtml(item._vendor_slug) + '</div>' : '') +
          '<div class="lb-v2-event-meta">' + escapeHtml(formatDateRange(item.event_start_at, item.event_end_at)) + '</div>' +
          '<div class="lb-v2-event-stats">' +
          '<span>售出 <b>' + formatCount(item.sold_count) + '</b></span>' +
          '<span>銷售 <b>' + formatMoney(item.sales_amount, item.currency) + '</b></span>' +
          '<span>核銷率 <b>' + rate + '</b></span>' +
          '</div></button>';
      }).join('');

      el.querySelectorAll('[data-event-id]').forEach(function (btn) {
        btn.onclick = function () {
          selectedEventId = btn.getAttribute('data-event-id');
          eventsPage.currentPage = 1;
          updateEventTitleBar();
          renderEventsList();
          loadEventsData(false);
        };
      });
    }

    var clearBtn = $('lb-v2-clear-event');
    if (clearBtn) clearBtn.onclick = function () {
      selectedEventId = null;
      eventsPage.currentPage = 1;
      updateEventTitleBar();
      renderEventsList();
      loadEventsData(false);
    };
  }

  async function fetchEventsForVendors(vendors) {
    var results = await Promise.all(vendors.map(function (slug) {
      return fetchAppProxy(PATHS.events, slug).then(function (r) {
        if (!r.ok) return { ok: false, slug: slug, code: r.code, message: r.message };
        var items = (r.payload.items || []).map(function (item) {
          item._vendor_slug = slug;
          return item;
        });
        return { ok: true, slug: slug, items: items };
      });
    }));
    var errors = results.filter(function (r) { return !r.ok; });
    var items = [];
    results.forEach(function (r) { if (r.ok) items = items.concat(r.items); });
    items.sort(function (a, b) {
      var da = new Date(a.event_start_at || 0).getTime();
      var db = new Date(b.event_start_at || 0).getTime();
      return db - da;
    });
    return { items: items, errors: errors };
  }

  async function fetchSummaryForVendors(vendors, pageState, includeEvent) {
    var results = await Promise.all(vendors.map(function (slug) {
      return fetchAppProxy(PATHS.summary, slug, buildFilterParams(pageState, includeEvent));
    }));
    var errors = results.filter(function (r) { return !r.ok; });
    var summaries = results.filter(function (r) { return r.ok; }).map(function (r) { return r.payload.summary; });
    var authorizedCount = results.filter(function (r) { return r.ok; }).length;
    return {
      summary: isAllMode()
        ? (authorizedCount ? aggregateSummaries(summaries) : null)
        : (summaries[0] || null),
      errors: errors,
    };
  }

  async function fetchListForVendors(vendors, pageState, includeEvent) {
    if (!isAllMode()) {
      var one = await fetchAppProxy(PATHS.list, vendors[0], buildListParams(pageState, includeEvent));
      if (!one.ok) return { ok: false, error: one, items: [], pagination: null, errors: [{ slug: vendors[0], code: one.code }] };
      return {
        ok: true,
        items: one.payload.items || [],
        pagination: one.payload.pagination || null,
        showVendor: false,
        errors: [],
      };
    }

    var results = await Promise.all(vendors.map(function (slug) {
      return fetchAppProxy(PATHS.list, slug, buildListParams(pageState, includeEvent)).then(function (r) {
        return Object.assign({ slug: slug }, r);
      });
    }));
    var errors = results.filter(function (r) { return !r.ok; });
    var items = [];
    var total = 0;
    results.forEach(function (r) {
      if (!r.ok) return;
      (r.payload.items || []).forEach(function (item) {
        item._vendor_slug = r.slug;
        items.push(item);
      });
      total += Number((r.payload.pagination && r.payload.pagination.total) || 0);
    });
    return {
      ok: errors.length < vendors.length,
      items: items,
      errors: errors,
      showVendor: true,
      pagination: {
        page: pageState.currentPage,
        limit: pageState.listLimit,
        total: total,
        total_pages: Math.max(1, Math.ceil(total / pageState.listLimit)),
        has_prev: pageState.currentPage > 1,
        has_next: pageState.currentPage * pageState.listLimit < total,
      },
    };
  }

  function renderOverviewRanking(items) {
    var el = $('lb-v2-overview-ranking');
    if (!items.length) {
      el.innerHTML = '<div class="lb-v2-empty">目前沒有活動資料</div>';
      return;
    }
    var sorted = items.slice().sort(function (a, b) {
      if (overviewRankSort === 'sold') return Number(b.sold_count || 0) - Number(a.sold_count || 0);
      if (overviewRankSort === 'rate') return Number(b.redeem_rate || 0) - Number(a.redeem_rate || 0);
      return Number(b.sales_amount || 0) - Number(a.sales_amount || 0);
    }).slice(0, 10);

    var rows = sorted.map(function (item, idx) {
      return '<tr>' +
        '<td><strong>' + escapeHtml(item.event_title || item.event_id) + '</strong>' +
          (item._vendor_slug ? '<div class="lb-v2-muted">' + escapeHtml(item._vendor_slug) + '</div>' : '') +
        '</td>' +
        '<td>' + formatCount(item.sold_count) + '</td>' +
        '<td>' + formatCount(item.redeemed_count) + '</td>' +
        '<td>' + formatPercent(item.redeem_rate) + '</td>' +
        '<td>' + formatMoney(item.sales_amount, item.currency) + '</td>' +
        '<td>' + formatMoney(item.refund_amount, item.currency) + '</td>' +
      '</tr>';
    }).join('');

    var cards = sorted.map(function (item, idx) {
      return '<article class="lb-v2-rank-card">' +
        '<div class="lb-v2-rank-card__rank">' + (idx + 1) + '</div>' +
        '<div class="lb-v2-rank-card__body">' +
          '<div class="lb-v2-rank-card__title">' + escapeHtml(item.event_title || item.event_id) + '</div>' +
          (item._vendor_slug ? '<div class="lb-v2-rank-card__vendor">' + escapeHtml(item._vendor_slug) + '</div>' : '') +
          '<div class="lb-v2-rank-card__metrics">' +
            '<div><span>售出</span><strong>' + formatCount(item.sold_count) + '</strong></div>' +
            '<div><span>已核</span><strong>' + formatCount(item.redeemed_count) + '</strong></div>' +
            '<div><span>核銷率</span><strong>' + formatPercent(item.redeem_rate) + '</strong></div>' +
            '<div><span>銷售額</span><strong>' + formatMoney(item.sales_amount, item.currency) + '</strong></div>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    el.innerHTML =
      '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
      '<th>活動</th><th>售出</th><th>已核銷</th><th>核銷率</th><th>銷售額</th><th>退款</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      '<div class="lb-v2-m-cards lb-v2-rank-cards" aria-label="活動排行">' + cards + '</div>';
  }

  async function fetchVendorEventsSummaryList(slug, pageState) {
    var bundle = await Promise.all([
      fetchAppProxy(PATHS.events, slug),
      fetchAppProxy(PATHS.summary, slug, buildFilterParams(pageState, true)),
      fetchAppProxy(PATHS.list, slug, buildListParams(pageState, true)),
    ]);
    return { slug: slug, events: bundle[0], summary: bundle[1], list: bundle[2] };
  }

  function mergeVendorBundleIntoAcc(acc, bundle) {
    if (!bundle) return;
    var slug = bundle.slug;
    if (bundle.events && bundle.events.ok) {
      (bundle.events.payload.items || []).forEach(function (item) {
        item._vendor_slug = slug;
        acc.eventItems.push(item);
      });
    } else if (bundle.events) {
      acc.eventErrors.push({
        slug: slug,
        code: bundle.events.code,
        message: bundle.events.message,
      });
    }
    if (bundle.summary && bundle.summary.ok && bundle.summary.payload.summary) {
      acc.summaries.push(bundle.summary.payload.summary);
    } else if (bundle.summary && !bundle.summary.ok) {
      acc.summaryErrors.push({
        slug: slug,
        code: bundle.summary.code,
        message: bundle.summary.message,
      });
    }
    if (bundle.list && bundle.list.ok) {
      (bundle.list.payload.items || []).forEach(function (item) {
        item._vendor_slug = slug;
        acc.listItems.push(item);
      });
      acc.listTotal += Number(
        (bundle.list.payload.pagination && bundle.list.payload.pagination.total) || 0
      );
    } else if (bundle.list && !bundle.list.ok) {
      acc.listErrors.push({
        slug: slug,
        code: bundle.list.code,
        message: bundle.list.message,
      });
    }
  }

  function paintEventsAcc(acc, pageState, showVendor) {
    acc.eventItems.sort(function (a, b) {
      var da = new Date(a.event_start_at || 0).getTime();
      var db = new Date(b.event_start_at || 0).getTime();
      return db - da;
    });
    cachedEventsItems = acc.eventItems.slice();
    if (acc.eventErrors.length && !acc.eventItems.length) {
      showNotice($('lb-v2-events-notice'), '部分廠商無法載入活動：' +
        friendlyError(acc.eventErrors[0].code, acc.eventErrors[0].message));
    } else if (acc.eventErrors.length) {
      showNotice($('lb-v2-events-notice'), '部分廠商無法載入，其餘活動仍顯示。');
    } else {
      showNotice($('lb-v2-events-notice'), '');
    }
    renderEventsList();
    updateEventTitleBar();

    if (acc.summaries.length) {
      renderKpi('lb-v2-kpi', isAllMode() ? aggregateSummaries(acc.summaries) : acc.summaries[0], { scope: 'course' });
      showNotice($('lb-v2-summary-notice'), '');
    } else if (acc.summaryErrors.length) {
      $('lb-v2-kpi').hidden = true;
      showNotice($('lb-v2-summary-notice'), friendlyError(
        acc.summaryErrors[0].code,
        acc.summaryErrors[0].message
      ));
    }

    if (!acc.listItems.length && acc.listErrors.length && !isAllMode()) {
      $('lb-v2-list').hidden = true;
      $('lb-v2-pagination').hidden = true;
      showNotice($('lb-v2-list-notice'), friendlyError(
        acc.listErrors[0].code,
        acc.listErrors[0].message
      ));
    } else {
      if (acc.listErrors.length && acc.listItems.length) {
        showNotice($('lb-v2-list-notice'), '部分廠商票券無法載入，其餘仍顯示。');
      } else {
        showNotice($('lb-v2-list-notice'), '');
      }
      renderItems('lb-v2-list', acc.listItems, !!showVendor);
      renderPagination('lb-v2-pagination', {
        page: pageState.currentPage,
        limit: pageState.listLimit,
        total: acc.listTotal,
        total_pages: Math.max(1, Math.ceil(acc.listTotal / pageState.listLimit)),
        has_prev: pageState.currentPage > 1,
        has_next: pageState.currentPage * pageState.listLimit < acc.listTotal,
      }, function (delta) {
        eventsPage.currentPage = Math.max(1, eventsPage.currentPage + delta);
        loadEventsData(false);
      });
    }
    renderMetafieldWarning();
    renderVendorSelector();
    setUpdatedAt();
  }

  async function loadEventsProgressive(vendors, gen) {
    var total = vendors.length;
    var acc = {
      eventItems: [],
      eventErrors: [],
      summaries: [],
      summaryErrors: [],
      listItems: [],
      listErrors: [],
      listTotal: 0,
    };
    setDataLoading(true, '載入中…（1/' + total + '）');
    var first = await fetchVendorEventsSummaryList(vendors[0], eventsPage);
    if (gen !== dataLoadGeneration) return;
    mergeVendorBundleIntoAcc(acc, first);
    paintEventsAcc(acc, eventsPage, true);

    var completed = 1;
    var rest = vendors.slice(1);
    if (!rest.length) {
      if (gen === dataLoadGeneration) markTabCache('events');
      return;
    }

    setDataLoading(true, '彙總中 ' + completed + '/' + total + '…');
    var restResults = await mapPool(rest, 3, async function (slug) {
      if (gen !== dataLoadGeneration) return null;
      var bundle = await fetchVendorEventsSummaryList(slug, eventsPage);
      completed += 1;
      if (gen === dataLoadGeneration) {
        setDataLoading(true, '彙總中 ' + Math.min(completed, total) + '/' + total + '…');
      }
      return bundle;
    });
    if (gen !== dataLoadGeneration) return;
    restResults.forEach(function (bundle) {
      if (bundle) mergeVendorBundleIntoAcc(acc, bundle);
    });
    paintEventsAcc(acc, eventsPage, true);
    if (gen === dataLoadGeneration) markTabCache('events');
  }

  async function loadEventsStructure() {
    var vendors = getActiveVendors();
    if (!vendors.length) return;
    var gen = bumpDataLoadGeneration();

    setDataLoading(true, isAllMode() && vendors.length > 1
      ? '載入活動列表…（1/' + vendors.length + '）'
      : '載入活動列表…');
    showNotice($('lb-v2-events-notice'), '');

    try {
      if (isAllMode() && vendors.length > 1) {
        setDataLoading(true, '載入全部廠商彙總…');
        var allBundle = await fetchReportsBundle(eventsPage, true);
        if (gen !== dataLoadGeneration) return;
        if (!allBundle.ok) {
          showNotice($('lb-v2-events-notice'), friendlyError(allBundle.code, allBundle.message));
          return;
        }
        await applyReportsBundlePayload(allBundle.payload, eventsPage, {
          onPage: function () { loadEventsData(false); },
        });
        renderMetafieldWarning();
        renderVendorSelector();
        setUpdatedAt();
        if (gen === dataLoadGeneration) markTabCache('events');
        return;
      }

      var eventsResult = await fetchEventsForVendors(vendors);
      if (gen !== dataLoadGeneration) return;
      if (eventsResult.errors.length && !eventsResult.items.length) {
        showNotice($('lb-v2-events-notice'), '部分廠商無法載入活動：' +
          friendlyError(eventsResult.errors[0].code, eventsResult.errors[0].message));
        cachedEventsItems = [];
      } else {
        cachedEventsItems = eventsResult.items;
        if (eventsResult.errors.length) {
          showNotice($('lb-v2-events-notice'), '部分廠商無法載入，其餘活動仍顯示。');
        }
      }
      renderEventsList();
      updateEventTitleBar();
      await loadEventsData(true, gen);
      if (gen === dataLoadGeneration) markTabCache('events');
    } finally {
      if (gen === dataLoadGeneration) setDataLoading(false);
    }
  }

  async function loadEventsData(skipLoading, genOpt) {
    var vendors = getActiveVendors();
    if (!vendors.length) return;
    var gen = genOpt != null ? genOpt : bumpDataLoadGeneration();

    if (!skipLoading) {
      setDataLoading(true, isAllMode() && vendors.length > 1
        ? '更新報表資料…（1/' + vendors.length + '）'
        : '更新報表資料…');
    }
    showNotice($('lb-v2-summary-notice'), '');
    showNotice($('lb-v2-list-notice'), '');

    mountFilters('lb-v2-filters', eventsPage, loadEventsData);

    try {
      if (isAllMode() && vendors.length > 1) {
        var refreshBundle = await fetchReportsBundle(eventsPage, true);
        if (gen !== dataLoadGeneration) return;
        if (!refreshBundle.ok) {
          showNotice($('lb-v2-list-notice'), friendlyError(refreshBundle.code, refreshBundle.message));
          return;
        }
        await applyReportsBundlePayload(refreshBundle.payload, eventsPage, {
          onPage: function () { loadEventsData(false); },
        });
        renderMetafieldWarning();
        renderVendorSelector();
        setUpdatedAt();
        if (gen === dataLoadGeneration) markTabCache('events');
        return;
      }

      var eventsBundle = await Promise.all([
        fetchSummaryForVendors(vendors, eventsPage, true),
        fetchListForVendors(vendors, eventsPage, true),
        cachedEventsItems.length ? Promise.resolve(null) : fetchEventsForVendors(vendors),
      ]);
      if (gen !== dataLoadGeneration) return;
      var summaryResult = eventsBundle[0];
      var listResult = eventsBundle[1];
      var eventsWarm = eventsBundle[2];
      if (eventsWarm) {
        cachedEventsItems = eventsWarm.items || [];
        if (eventsWarm.errors.length && !cachedEventsItems.length) {
          showNotice($('lb-v2-events-notice'), '部分廠商無法載入活動：' +
            friendlyError(eventsWarm.errors[0].code, eventsWarm.errors[0].message));
        } else if (eventsWarm.errors.length) {
          showNotice($('lb-v2-events-notice'), '部分廠商無法載入，其餘活動仍顯示。');
        }
        renderEventsList();
        updateEventTitleBar();
      }
      if (summaryResult.summary) {
        renderKpi('lb-v2-kpi', summaryResult.summary, { scope: 'course' });
      } else if (summaryResult.errors.length) {
        $('lb-v2-kpi').hidden = true;
        showNotice($('lb-v2-summary-notice'), friendlyError(
          summaryResult.errors[0].code,
          summaryResult.errors[0].message
        ));
      }

      if (!listResult.ok && listResult.error && !isAllMode()) {
        $('lb-v2-list').hidden = true;
        $('lb-v2-pagination').hidden = true;
        showNotice($('lb-v2-list-notice'), friendlyError(listResult.error.code, listResult.error.message));
      } else {
        if (listResult.errors.length && listResult.items.length) {
          showNotice($('lb-v2-list-notice'), '部分廠商票券無法載入，其餘仍顯示。');
        }
        renderItems('lb-v2-list', listResult.items || [], listResult.showVendor);
        renderPagination('lb-v2-pagination', listResult.pagination, function (delta) {
          eventsPage.currentPage = Math.max(1, eventsPage.currentPage + delta);
          loadEventsData(false);
        });
      }

      renderMetafieldWarning();
      renderVendorSelector();
      setUpdatedAt();
      if (gen === dataLoadGeneration) markTabCache('events');
    } catch (err) {
      showNotice($('lb-v2-list-notice'), err && err.message ? err.message : '載入失敗');
    } finally {
      if (!skipLoading && gen === dataLoadGeneration) setDataLoading(false);
    }
  }

  async function loadOverviewTab(fullReload) {
    var vendors = getActiveVendors();
    if (!vendors.length) return;

    setDataLoading(true, fullReload ? '載入總覽分析…' : '更新總覽資料…');
    showNotice($('lb-v2-overview-summary-notice'), '');
    showNotice($('lb-v2-overview-list-notice'), '');

    mountFilters('lb-v2-overview-filters', overviewPage, function () { loadOverviewTab(false); });

    try {
      if (isAllMode() && vendors.length > 1) {
        var ovBundle = await fetchReportsBundle(overviewPage, false);
        if (!ovBundle.ok) {
          showNotice($('lb-v2-overview-list-notice'), friendlyError(ovBundle.code, ovBundle.message));
          return;
        }
        await applyReportsBundlePayload(ovBundle.payload, overviewPage, {
          kpiId: 'lb-v2-overview-kpi',
          summaryNoticeId: 'lb-v2-overview-summary-notice',
          listNoticeId: 'lb-v2-overview-list-notice',
          listId: 'lb-v2-overview-list',
          paginationId: 'lb-v2-overview-pagination',
          onPage: function () { loadOverviewTab(false); },
        });
        renderOverviewRanking(cachedEventsItems);
        renderMetafieldWarning();
        renderVendorSelector();
        setUpdatedAt();
        markTabCache('overview');
        return;
      }

      if (fullReload || !cachedEventsItems.length) {
        var eventsResult = await fetchEventsForVendors(vendors);
        cachedEventsItems = eventsResult.items;
        if (eventsResult.errors.length && !eventsResult.items.length) {
          showNotice($('lb-v2-overview-summary-notice'), '部分廠商無法載入活動。');
        }
      }

      renderOverviewRanking(cachedEventsItems);

      var overviewBundle = await Promise.all([
        fetchSummaryForVendors(vendors, overviewPage, false),
        fetchListForVendors(vendors, overviewPage, false),
      ]);
      var summaryResult = overviewBundle[0];
      var listResult = overviewBundle[1];
      if (summaryResult.summary) {
        renderKpi('lb-v2-overview-kpi', summaryResult.summary);
      } else if (summaryResult.errors.length) {
        $('lb-v2-overview-kpi').hidden = true;
        showNotice($('lb-v2-overview-summary-notice'), friendlyError(
          summaryResult.errors[0].code, summaryResult.errors[0].message
        ));
      }

      if (!listResult.ok && listResult.error && !isAllMode()) {
        $('lb-v2-overview-list').hidden = true;
        $('lb-v2-overview-pagination').hidden = true;
        showNotice($('lb-v2-overview-list-notice'), friendlyError(listResult.error.code, listResult.error.message));
      } else {
        renderItems('lb-v2-overview-list', listResult.items || [], listResult.showVendor);
        renderPagination('lb-v2-overview-pagination', listResult.pagination, function (delta) {
          overviewPage.currentPage = Math.max(1, overviewPage.currentPage + delta);
          loadOverviewTab(false);
        });
      }

      renderMetafieldWarning();
      renderVendorSelector();
      setUpdatedAt();
      markTabCache('overview');
    } catch (err) {
      showNotice($('lb-v2-overview-list-notice'), err && err.message ? err.message : '載入失敗');
    } finally {
      setDataLoading(false);
    }
  }

  // ── 導覽層：左側 rail 用 nav key，內部流程沿用既有 tab key ──────────────
  // 兩者共存，舊有 switchTab('fee-purchase') 等呼叫不用改寫。
  var NAV_KEYS = {
    'course-new': 1,
    'course-manage': 1,
    'course-ads': 1,
    'course-data': 1,
    'ops-data': 1,
    checkout: 1,
    private: 1,
    'private-eligibility': 1,
    'private-schedule': 1,
    'private-page': 1,
  };

  var LEGACY_TAB_NAV = {
    events: 'course-data',
    overview: 'ops-data',
    settlement: 'ops-data',
    'settlement-private': 'ops-data',
    'fee-purchase': 'checkout',
    listing: 'course-new',
    'course-decision': 'course-manage',
    'pending-payment': 'course-manage',
    'exposure-confirmed': 'course-manage',
    'course-ads': 'course-ads',
    private: 'private',
    'private-eligibility': 'private-eligibility',
    'private-schedule': 'private-schedule',
    'private-page': 'private-page',
  };

  var activeNav = 'course-data';
  var manageSub = 'list'; // list | decision | payment
  var opsSub = 'overview'; // overview | settlement | settlement-private
  var adsSub = 'list'; // list | create

  function subNavTargetTab(group, sub) {
    if (group === 'manage') {
      return sub === 'decision' ? 'course-decision' : sub === 'payment' ? 'pending-payment' : 'listing';
    }
    if (group === 'ops') {
      return sub === 'settlement' || sub === 'settlement-private' ? sub : 'overview';
    }
    return '';
  }

  function navToTab(nav) {
    if (nav === 'course-data') return 'events';
    if (nav === 'ops-data') return subNavTargetTab('ops', opsSub);
    if (nav === 'checkout') return 'fee-purchase';
    if (nav === 'course-new') return 'listing';
    if (nav === 'course-manage') return subNavTargetTab('manage', manageSub);
    return nav;
  }

  function syncSubStateFromTab(tab) {
    if (tab === 'course-decision') manageSub = 'decision';
    else if (tab === 'pending-payment' || tab === 'exposure-confirmed') manageSub = 'payment';
    else if (tab === 'settlement') opsSub = 'settlement';
    else if (tab === 'settlement-private') opsSub = 'settlement-private';
    else if (tab === 'overview') opsSub = 'overview';
  }

  function renderSubNavState() {
    var manageBar = $('lb-v2-subnav-manage');
    if (manageBar) manageBar.hidden = activeNav !== 'course-manage';
    var opsBar = $('lb-v2-subnav-ops');
    if (opsBar) opsBar.hidden = activeNav !== 'ops-data';
    root.querySelectorAll('[data-subnav]').forEach(function (btn) {
      var group = btn.getAttribute('data-subnav');
      var sub = btn.getAttribute('data-sub');
      var current =
        group === 'manage' ? manageSub : group === 'ops' ? opsSub : group === 'ads' ? adsSub : '';
      btn.classList.toggle('is-active', sub === current);
    });
  }

  /** 上架新課程＝只有表單；課程管理＝只有列表（同一 panel 兩種檢視）。 */
  function applyListingPanelView() {
    var listView = $('lb-v2-listing-list-view');
    var formView = $('lb-v2-listing-form-section');
    var title = $('lb-v2-listing-panel-title');
    var desc = $('lb-v2-listing-panel-desc');
    var showForm = activeNav === 'course-new';
    if (listView) listView.hidden = showForm;
    if (formView) formView.hidden = !showForm;
    if (title) title.textContent = showForm ? '上架新課程' : '課程管理';
    if (desc) {
      desc.textContent = showForm
        ? '填寫課程內容後儲存草稿，預覽確認再送審。已購買鎖定的版位與檔期為唯讀。'
        : '所有上架申請與已上架課程；開課人數設定、收款確認與廣告加購都在這裡處理。';
    }
  }

  function switchTab(key) {
    var nav;
    var tab;
    if (NAV_KEYS[key]) {
      nav = key;
      tab = navToTab(key);
    } else {
      tab = key;
      nav = LEGACY_TAB_NAV[key] || 'course-data';
      syncSubStateFromTab(tab);
    }
    activeNav = nav;
    activeTab = tab;
    if (tab === 'listing' || tab === 'fee-purchase' || tab === 'course-ads') {
      LbV2.ensureChunk('listing');
    }
    if (
      tab === 'private' ||
      tab === 'private-eligibility' ||
      tab === 'private-schedule' ||
      tab === 'private-page'
    ) {
      LbV2.ensureChunk('private');
    }
    root.querySelectorAll('.lb-v2-tab').forEach(function (btn) {
      if (btn.hasAttribute('data-subnav')) return;
      btn.classList.toggle('lb-v2-tab--active', btn.getAttribute('data-tab') === nav);
    });
    renderSubNavState();
    applyListingPanelView();
    var adsPanel = $('lb-v2-panel-course-ads');
    if (adsPanel) adsPanel.hidden = tab !== 'course-ads';
    $('lb-v2-panel-events').hidden = tab !== 'events';
    $('lb-v2-panel-overview').hidden = tab !== 'overview';
    var pendingPanel = $('lb-v2-panel-pending-payment');
    if (pendingPanel) pendingPanel.hidden = tab !== 'pending-payment';
    var courseDecisionPanel = $('lb-v2-panel-course-decision');
    if (courseDecisionPanel) courseDecisionPanel.hidden = tab !== 'course-decision';
    var feePurchasePanel = $('lb-v2-panel-fee-purchase');
    if (feePurchasePanel) feePurchasePanel.hidden = tab !== 'fee-purchase';
    var listingPanel = $('lb-v2-panel-listing');
    var privatePanel = $('lb-v2-panel-private');
    var privateEligPanel = $('lb-v2-panel-private-eligibility');
    var privateSchedulePanel = $('lb-v2-panel-private-schedule');
    var privatePagePanel = $('lb-v2-panel-private-page');
    var settlementPanel = $('lb-v2-panel-settlement');
    if (listingPanel) listingPanel.hidden = tab !== 'listing';
    if (privatePanel) privatePanel.hidden = tab !== 'private';
    if (privateEligPanel) privateEligPanel.hidden = tab !== 'private-eligibility';
    if (privateSchedulePanel) privateSchedulePanel.hidden = tab !== 'private-schedule';
    if (privatePagePanel) privatePagePanel.hidden = tab !== 'private-page';
    if (settlementPanel) {
      settlementPanel.hidden = tab !== 'settlement' && tab !== 'settlement-private';
    }
    if (tab === 'overview') selectedEventId = null;
    if (tab === 'fee-purchase') {
      loadFeePurchaseTab();
      return;
    }
    if (tab === 'course-ads') {
      loadCourseAdsTab(false);
      return;
    }
    if (tab === 'pending-payment') {
      loadPendingPaymentTab();
      return;
    }
    if (tab === 'course-decision') {
      loadCourseDecisionTab();
      return;
    }
    if (tab === 'private') {
      loadPrivateTab(false);
      return;
    }
    if (tab === 'private-eligibility') {
      loadPrivateEligibilityTab(false);
      return;
    }
    if (tab === 'private-schedule') {
      loadPrivateScheduleTab(false);
      return;
    }
    if (tab === 'private-page') {
      loadPrivatePageTab(false);
      return;
    }
    if (tab === 'settlement' || tab === 'settlement-private') {
      loadSettlementTab(settlementModeFromTab(tab), false);
      return;
    }
    // Soft reload: reuse tab cache when vendor unchanged (toolbar 重新整理 uses true).
    loadActiveTab(false);
  }

  var pendingPaymentPage = 1;

  var COURSE_DECISION_LABELS = {
    EXPOSURE_PENDING: '未到判斷日',
    FULL_PENDING: '未到判斷日',
    VENDOR_REVIEW: '已達判斷日／待廠商決策',
    CONFIRMED: '已確認開課',
    CANCELLED: '已取消開課',
    DISABLED: '未啟用',
  };

  function courseDecisionLabel(item) {
    if (!item) return '—';
    var mode = String(item.listing_mode || '').toUpperCase();
    if (mode !== 'EXPOSURE' && mode !== 'FULL' && mode !== 'PRIVATE') return '—';
    var status = String(item.course_decision_status || '').toUpperCase();
    if (status) return COURSE_DECISION_LABELS[status] || status;
    // 已填最低人數但還沒建決策列（通常是還沒上架）＝「已設定待上架」，不是壞掉。
    return Number(item.course_min_attendees || 0) > 0 ? '已設定待上架' : '未啟用';
  }

  /** 未達開課人數決策欄：狀態 +（min>0 時）評估起／截止 */
  function courseDecisionCellLabel(item) {
    var base = courseDecisionLabel(item);
    var min = Number(item && item.course_min_attendees || 0);
    if (!(min > 0)) return base;
    var win = formatCourseDecideWindowFromStart(item && item.start_at);
    if (!win) return base + '｜最低 ' + min;
    return base + '｜最低 ' + min + '｜評估起 ' + win.evalLabel + '｜截止 ' + win.deadlineLabel;
  }

  /** Taipei calendar YYYY-MM-DD (never trust UTC date prefix of ISO). */
  function taipeiYmdToday() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Taipei',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      var now = new Date();
      return (
        now.getFullYear() +
        '-' +
        String(now.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(now.getDate()).padStart(2, '0')
      );
    }
  }

  function ymdFromListingStart(startAt) {
    if (!startAt) return '';
    var s = String(startAt).trim();
    // Date-only from QC pickers — already Taipei calendar day.
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    try {
      var d = new Date(s);
      if (isNaN(d.getTime())) return '';
      // ISO/timestamptz: use Taipei day (00:30 Taipei is previous UTC day).
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Taipei',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(d);
    } catch (e) {
      return '';
    }
  }

  function formatCourseDecideWindowFromStart(startAt) {
    var ymd = ymdFromListingStart(startAt);
    if (!ymd) return null;
    var evalYmd = shiftYmd(ymd, -3);
    var deadlineYmd = shiftYmd(ymd, -2);
    if (!evalYmd || !deadlineYmd) return null;
    return {
      evalYmd: evalYmd,
      deadlineYmd: deadlineYmd,
      evalLabel: evalYmd.replace(/-/g, '/') + ' 00:00',
      deadlineLabel: deadlineYmd.replace(/-/g, '/') + ' 00:00'
    };
  }

  function parseCourseMinAttendeesInput(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return { ok: true, value: 0 };
    if (!/^\d+$/.test(s)) {
      return { ok: false, message: '最低開課人數須為 0 或正整數（空白＝0／不啟用）' };
    }
    return { ok: true, value: parseInt(s, 10) };
  }

  function validateCourseMinForQuickCreate(min, ticketQty, startDateYmd) {
    if (!(min > 0)) return { ok: true };
    if (!Number.isInteger(ticketQty) || ticketQty < 1) {
      return { ok: false, message: '已設定最低開課人數時，請先填寫票券名額' };
    }
    if (min > ticketQty) {
      return { ok: false, message: '最低開課人數（' + min + '）不可大於票券名額（' + ticketQty + '）' };
    }
    var win = formatCourseDecideWindowFromStart(startDateYmd);
    if (!win) {
      return { ok: false, message: '無法由上課日計算未達開課人數決策時程' };
    }
    // Align with backend: block once Taipei calendar day reaches T-3 (00:00 that day).
    var nowYmd = taipeiYmdToday();
    if (nowYmd >= win.evalYmd) {
      return {
        ok: false,
        message:
          '已設定最低開課人數，但評估起（' +
          win.evalLabel +
          '）已過或當下已來不及開窗；請改上課日或改最低人數為 0。決策截止為 ' +
          win.deadlineLabel +
          '。'
      };
    }
    return { ok: true, window: win };
  }

  function listingNeedsCourseDecision(item) {
    if (!item) return false;
    var mode = String(item.listing_mode || '').toUpperCase();
    if (mode !== 'EXPOSURE' && mode !== 'FULL' && mode !== 'PRIVATE') return false;
    return String(item.course_decision_status || '').toUpperCase() === 'VENDOR_REVIEW';
  }

  function updateCourseDecisionBadge(count) {
    var n = Math.max(0, Number(count || 0));
    ['lb-v2-course-decision-badge', 'lb-v2-course-decision-badge-sub'].forEach(function (id) {
      var badge = $(id);
      if (!badge) return;
      badge.textContent = String(n);
      badge.hidden = n === 0;
    });
  }

  async function refreshCourseDecisionBadge() {
    var slug = vendorMode === ALL_MODE ? '' : vendorMode;
    if (!slug) {
      updateCourseDecisionBadge(0);
      return;
    }
    try {
      // count_only: one cheap COUNT on listings (not full list + N ticket counts)
      var res = await fetchAppProxy(PATHS.courseDecisionList, slug, {
        count_only: '1',
      });
      if (res && res.ok === true && res.payload) {
        var n =
          typeof res.payload.count === 'number'
            ? res.payload.count
            : Array.isArray(res.payload.data)
              ? res.payload.data.length
              : 0;
        updateCourseDecisionBadge(n);
      }
    } catch (err) {
      // Badge is supplemental; tab itself remains usable.
    }
  }

  async function loadCourseDecisionTab() {
    var slug = vendorMode === ALL_MODE ? (activeVendors[0] || '') : vendorMode;
    var notice = $('lb-v2-course-decision-notice');
    var listEl = $('lb-v2-course-decision-list');
    if (!listEl) return;
    if (!slug || vendorMode === ALL_MODE) {
      if (notice) {
        notice.hidden = false;
        notice.textContent = '請先在上方選擇單一廠商，再載入待決策活動。';
      }
      listEl.innerHTML = '';
      return;
    }
    if (notice) {
      notice.hidden = true;
      notice.textContent = '';
    }
    listEl.innerHTML = '<p class="lb-v2-muted">載入中…</p>';
    try {
      var res = await fetchAppProxy(PATHS.courseDecisionList, slug, {});
      if (!res || res.ok !== true || !res.payload) {
        listEl.innerHTML = '';
        showNotice(
          notice,
          (res && res.message) ||
            (res && res.payload && res.payload.error && res.payload.error.message) ||
            '載入失敗'
        );
        return;
      }
      var items = Array.isArray(res.payload.data) ? res.payload.data : [];
      updateCourseDecisionBadge(items.length);
      if (!items.length) {
        listEl.innerHTML = '<p class="lb-v2-muted">目前沒有待決策的活動。</p>';
        return;
      }
      var html = '';
      var canCancelCourse = (function () {
        var role = getRoleForSlug(slug);
        return role === 'owner' || role === 'admin';
      })();
      items.forEach(function (item) {
        var canDecide = item.can_decide !== false;
        var mode = String(item.listing_mode || 'EXPOSURE').toUpperCase();
        var modeLabel = mode === 'FULL' ? '宣傳刊登（含金流）'
          : mode === 'PRIVATE' ? '資格限定課'
          : mode === 'PROMO' ? '宣傳刊登（不含金流）'
          : '純上架';
        // PRIVATE is payment-like (platform-collected), so count as sold like FULL.
        var countLabel = (mode === 'FULL' || mode === 'PRIVATE') ? '已售出' : '已確認收款';
        var blockReason = item.block_reason
          ? (item.block_reason === 'event_already_started'
            ? '活動已開始，請聯繫 LadyBae 後台處理'
            : item.block_reason === 'missing_event_id'
              ? '缺少活動 ID，無法決策'
              : String(item.block_reason))
          : '';
        // of178: course-decide list shows Taipei wall clock, not UTC +00
        var decideWin = formatCourseDecideWindowFromStart(item.start_at);
        var startLabel = formatListingSubmittedAt(item.start_at);
        var evalLabel = (decideWin && decideWin.evalLabel) ||
          formatListingSubmittedAt(item.course_decision_due_at);
        var deadlineLabel = (decideWin && decideWin.deadlineLabel) ||
          formatListingSubmittedAt(item.course_public_notify_at);
        html +=
          '<div class="lb-v2-card lb-v2-card--nested lb-v2-decide-card" data-listing-id="' +
          escapeHtml(String(item.listing_id)) +
          '" data-listing-mode="' +
          escapeHtml(mode) +
          '">' +
          '<header class="lb-v2-decide-card__head">' +
          '<span class="lb-v2-decide-card__mode">' +
          escapeHtml(modeLabel) +
          '</span>' +
          '<h3 class="lb-v2-decide-card__title">' +
          escapeHtml(item.title || '—') +
          '</h3>' +
          '<p class="lb-v2-decide-card__meta">開課時間 ' +
          escapeHtml(startLabel) +
          '</p>' +
          '</header>' +
          '<div class="lb-v2-decide-card__body">' +
          '<div class="lb-v2-decide-card__stats">' +
          '<div class="lb-v2-decide-card__stat">' +
          '<span class="lb-v2-decide-card__stat-k">' +
          escapeHtml(countLabel) +
          '</span>' +
          '<span class="lb-v2-decide-card__stat-v">' +
          escapeHtml(String(item.confirmed_count)) +
          '</span>' +
          '</div>' +
          '<div class="lb-v2-decide-card__stat">' +
          '<span class="lb-v2-decide-card__stat-k">最低人數</span>' +
          '<span class="lb-v2-decide-card__stat-v">' +
          escapeHtml(String(item.course_min_attendees)) +
          '</span>' +
          '</div>' +
          (mode === 'EXPOSURE'
            ? '<div class="lb-v2-decide-card__stat">' +
              '<span class="lb-v2-decide-card__stat-k">待確認</span>' +
              '<span class="lb-v2-decide-card__stat-v">' +
              escapeHtml(String(item.pending_count)) +
              '</span>' +
              '</div>'
            : '') +
          '</div>' +
          '<section class="lb-v2-decide-window">' +
          '<p class="lb-v2-decide-window__kicker">判斷時程</p>' +
          '<div class="lb-v2-decide-window__grid">' +
          '<div class="lb-v2-decide-window__item">' +
          '<span class="lb-v2-decide-window__k">判斷日（開課日3天前）</span>' +
          '<span class="lb-v2-decide-window__v">' + escapeHtml(evalLabel) + '</span>' +
          '</div>' +
          '<div class="lb-v2-decide-window__item">' +
          '<span class="lb-v2-decide-window__k">判斷截止日（開課日2天前）</span>' +
          '<span class="lb-v2-decide-window__v">' + escapeHtml(deadlineLabel) + '</span>' +
          '</div>' +
          '</div>' +
          '<p class="lb-v2-decide-window__note">逾期未決策將自動取消開課。學員開課通知於截止日寄出。</p>' +
          '</section>' +
          (blockReason
            ? '<p class="lb-v2-inline-notice" style="margin-top:0.5rem">' + escapeHtml(blockReason) + '</p>'
            : '') +
          '<div class="lb-v2-decide-card__actions">' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--accent lb-v2-course-confirm" data-listing-id="' +
          escapeHtml(String(item.listing_id)) +
          '"' +
          (canDecide ? '' : ' disabled') +
          '>仍然開課</button>' +
          (canCancelCourse
            ? '<button type="button" class="lb-v2-btn lb-v2-btn--ghost lb-v2-course-cancel" data-listing-id="' +
              escapeHtml(String(item.listing_id)) +
              '" data-listing-mode="' +
              escapeHtml(mode) +
              '"' +
              (canDecide ? '' : ' disabled') +
              '>取消開課</button>'
            : '') +
          '</div>' +
          '</div>' +
          '</div>';
      });
      listEl.innerHTML = html;
      listEl.querySelectorAll('.lb-v2-course-confirm').forEach(function (btn) {
        btn.addEventListener('click', function () {
          submitCourseDecision(btn.getAttribute('data-listing-id'), 'CONFIRM', btn);
        });
      });
      listEl.querySelectorAll('.lb-v2-course-cancel').forEach(function (btn) {
        btn.addEventListener('click', function () {
          openCourseCancelConfirm(
            btn.getAttribute('data-listing-id'),
            btn,
            btn.getAttribute('data-listing-mode')
          );
        });
      });
    } catch (err) {
      listEl.innerHTML = '';
      showNotice(notice, err.message || '載入失敗');
    }
  }

  function openCourseCancelConfirm(listingId, btn, listingMode) {
    var mode = String(listingMode || 'EXPOSURE').toUpperCase();
    var isPaymentLike = mode === 'FULL' || mode === 'PRIVATE';
    var bodyExplain = isPaymentLike
      ? '<p>取消後平台將為已付款學員辦理<strong>全額退款</strong>，並停止販售。</p>' +
        '<p><strong>取消後平台將代退；請確認後再送出。</strong></p>'
      : '<p>取消後將作廢該活動所有純上架名額並通知消費者。</p>' +
        '<p><strong>報名費退款由貴司自行處理；LadyBae 不代收、不退款。</strong></p>';
    var ackLabel = isPaymentLike
      ? '我已知悉平台將為已付款學員辦理全額退款'
      : '我已知悉退款責任由廠商承擔';
    openModal({
      title: '確認取消開課',
      bodyHtml:
        bodyExplain +
        '<label class="lb-v2-check" style="display:flex;gap:0.5rem;align-items:flex-start;margin-top:0.75rem">' +
        '<input type="checkbox" id="lb-v2-course-cancel-ack">' +
        '<span>' +
        ackLabel +
        '</span></label>' +
        '<div class="lb-v2-field" style="margin-top:0.75rem">' +
        '<label for="lb-v2-course-cancel-note">備註（選填）</label>' +
        '<input type="text" id="lb-v2-course-cancel-note" class="lb-v2-input" maxlength="500" placeholder="例：取消開課">' +
        '</div>' +
        '<p id="lb-v2-course-cancel-error" class="lb-v2-inline-notice" hidden style="margin-top:0.75rem"></p>',
      actions: [
        { label: '返回', ghost: true, close: true },
        {
          label: '確認取消',
          accent: true,
          close: false,
          onClick: function () {
            var ack = $('lb-v2-course-cancel-ack');
            var errEl = $('lb-v2-course-cancel-error');
            if (!ack || !ack.checked) {
              if (errEl) {
                errEl.hidden = false;
                errEl.textContent = '請先勾選確認事項';
              }
              return false;
            }
            var note = (($('lb-v2-course-cancel-note') || {}).value || '').trim();
            closeModal();
            submitCourseDecision(listingId, 'CANCEL', btn, note, true);
          },
        },
      ],
    });
  }

  async function submitCourseDecision(listingId, action, btn, note, ack) {
    var slug = vendorMode === ALL_MODE ? (activeVendors[0] || '') : vendorMode;
    if (!slug || !listingId) return;
    if (btn) btn.disabled = true;
    try {
      var response = await fetch(PATHS.courseDecisionSubmit, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          vendor_slug: slug,
          listing_id: Number(listingId),
          action: action,
          note: note || undefined,
          ack_vendor_refund_responsibility: action === 'CANCEL' ? Boolean(ack) : undefined,
        }),
      });
      var payload = await response.json();
      if (payload && payload.ok) {
        var cancelMsg =
          typeof payload.voided_count === 'number'
            ? '已取消開課（已作廢 ' + payload.voided_count + ' 張票；純上架由廠商自行退費）'
            : '已取消開課（宣傳刊登（含金流）／資格限定將由平台辦理全額退款）';
        if (payload.seal_warning) {
          cancelMsg += '；注意：' + payload.seal_warning;
        } else if (payload.product_sealed === false) {
          cancelMsg += '；注意：商品停售可能未完成，請聯繫後台';
        }
        if (payload.sheets_mirror && payload.sheets_mirror.failed > 0) {
          cancelMsg +=
            '；Sheets 備份失敗 ' + payload.sheets_mirror.failed + ' 筆（DB 仍為權威）';
        }
        var decideMsg = payload.already_decided
          ? '此活動先前已決策過'
          : action === 'CANCEL'
            ? cancelMsg
            : '已確認仍然開課（學員開課通知將於決策截止日寄出）';
        showNotice($('lb-v2-course-decision-notice'), decideMsg);
        loadCourseDecisionTab();
        // 從課程管理的「開課人數設定」欄操作時，通知與列表都要就地更新。
        if (activeNav === 'course-manage') {
          showNotice($('lb-v2-listing-notice'), decideMsg);
          loadListingTab();
        }
      } else {
        var decideErr = extractApiError(payload);
        var decideErrMsg = decideErr.code
          ? '[' + decideErr.code + '] ' + decideErr.message
          : (decideErr.message || '決策失敗');
        showNotice($('lb-v2-course-decision-notice'), decideErrMsg);
        if (activeNav === 'course-manage') showNotice($('lb-v2-listing-notice'), decideErrMsg);
        if (btn) btn.disabled = false;
      }
    } catch (err) {
      showNotice($('lb-v2-course-decision-notice'), err.message || '決策失敗');
      if (btn) btn.disabled = false;
    }
  }

  async function loadPendingPaymentTab() {
    var slug = vendorMode === ALL_MODE ? (activeVendors[0] || '') : vendorMode;
    var notice = $('lb-v2-pending-payment-notice');
    var listEl = $('lb-v2-pending-payment-list');
    var pageEl = $('lb-v2-pending-payment-pagination');
    if (!listEl) return;
    if (!slug || vendorMode === ALL_MODE) {
      if (notice) {
        notice.hidden = false;
        notice.textContent = '請先在上方選擇單一廠商，再載入待確認收款票券。';
      }
      listEl.innerHTML = '';
      if (pageEl) pageEl.hidden = true;
      return;
    }
    if (notice) notice.hidden = true;
    listEl.innerHTML = '<p class="lb-v2-muted">載入中…</p>';
    try {
      var res = await fetchAppProxy(PATHS.ticketsPendingPayment, slug, {
        page: pendingPaymentPage,
        limit: 50,
      });
      if (!res || res.ok !== true || !res.payload) {
        var msg = (res && res.message) || (res && res.payload && res.payload.error && res.payload.error.message) || '載入失敗';
        if (notice) { notice.hidden = false; notice.textContent = msg; }
        listEl.innerHTML = '';
        return;
      }
      var items = Array.isArray(res.payload.data) ? res.payload.data : [];
      if (!items.length) {
        listEl.innerHTML = '<p class="lb-v2-muted">目前沒有待確認收款的純上架票券。</p>';
      } else {
        var rowsHtml = items.map(function (t) {
          return (
            '<tr data-uid="' + escapeHtml(t.ticket_uid) + '">' +
            '<td>' + escapeHtml(t.event_title) + '</td>' +
            '<td>' + escapeHtml(t.order_name) + '</td>' +
            '<td>' + escapeHtml(t.name_masked) + '</td>' +
            '<td>' + escapeHtml(t.phone_masked) + '</td>' +
            '<td>' + escapeHtml(t.ticket_type) + '</td>' +
            '<td><span class="lb-v2-badge">待確認收款</span></td>' +
            '<td><button type="button" class="lb-v2-btn lb-v2-btn--accent lb-v2-btn--sm" data-confirm-payment="1" data-uid="' +
            escapeHtml(t.ticket_uid) + '">確認已收款</button> ' +
            '<button type="button" class="lb-v2-btn lb-v2-btn--ghost lb-v2-btn--sm" data-void-unpaid="1" data-uid="' +
            escapeHtml(t.ticket_uid) + '">作廢（未付款）</button></td>' +
            '</tr>'
          );
        }).join('');
        var cardsHtml = items.map(function (t) {
          return '<article class="lb-v2-m-card">' +
            '<div class="lb-v2-m-card__head">' +
              '<div class="lb-v2-m-card__title">' + escapeHtml(t.event_title || '—') + '</div>' +
              '<span class="lb-v2-badge lb-v2-badge--pending">待確認</span>' +
            '</div>' +
            '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">訂單</span><span>' + escapeHtml(t.order_name || '—') + '</span></div>' +
            '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">聯絡</span><span>' + escapeHtml([t.name_masked, t.phone_masked].filter(Boolean).join(' · ') || '—') + '</span></div>' +
            '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">票種</span><span>' + escapeHtml(t.ticket_type || '—') + '</span></div>' +
            '<div class="lb-v2-m-card__actions">' +
              '<button type="button" class="lb-v2-btn lb-v2-btn--accent" data-confirm-payment="1" data-uid="' + escapeHtml(t.ticket_uid) + '">確認已收款</button>' +
              '<button type="button" class="lb-v2-btn" data-void-unpaid="1" data-uid="' + escapeHtml(t.ticket_uid) + '">作廢（未付款）</button>' +
            '</div>' +
          '</article>';
        }).join('');
        listEl.innerHTML =
          '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
          '<th>活動</th><th>訂單</th><th>姓名</th><th>電話</th><th>票種</th><th>狀態</th><th></th>' +
          '</tr></thead><tbody>' + rowsHtml + '</tbody></table></div>' +
          '<div class="lb-v2-m-cards">' + cardsHtml + '</div>';
        listEl.querySelectorAll('[data-confirm-payment]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            confirmPendingPayment(slug, btn.getAttribute('data-uid'), btn);
          });
        });
        listEl.querySelectorAll('[data-void-unpaid]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            voidExposureTicket(slug, btn.getAttribute('data-uid'), 'UNPAID', btn);
          });
        });
      }
      var pag = res.payload.pagination || {};
      if (pageEl) {
        if (pag.total_pages > 1) {
          pageEl.hidden = false;
          pageEl.innerHTML =
            '<button type="button" class="lb-v2-btn" id="lb-v2-pending-prev"' + (pag.has_prev ? '' : ' disabled') + '>上一頁</button>' +
            '<span class="lb-v2-muted">第 ' + (pag.page || 1) + ' / ' + pag.total_pages + ' 頁（共 ' + (pag.total || 0) + '）</span>' +
            '<button type="button" class="lb-v2-btn" id="lb-v2-pending-next"' + (pag.has_next ? '' : ' disabled') + '>下一頁</button>';
          var prev = $('lb-v2-pending-prev');
          var next = $('lb-v2-pending-next');
          if (prev) prev.addEventListener('click', function () {
            pendingPaymentPage = Math.max(1, pendingPaymentPage - 1);
            loadPendingPaymentTab();
          });
          if (next) next.addEventListener('click', function () {
            pendingPaymentPage += 1;
            loadPendingPaymentTab();
          });
        } else {
          pageEl.hidden = true;
        }
      }
      // Confirmed list is independent — do not block pending table on second round-trip.
      loadExposureConfirmedList(slug);
    } catch (err) {
      if (notice) {
        notice.hidden = false;
        notice.textContent = err.message || '載入失敗';
      }
      listEl.innerHTML = '';
    }
  }

  async function loadExposureConfirmedList(slug) {
    var listEl = $('lb-v2-exposure-confirmed-list');
    if (!listEl || !slug) return;
    listEl.innerHTML = '<p class="lb-v2-muted">載入中…</p>';
    try {
      var res = await fetchAppProxy(PATHS.ticketsExposureConfirmed, slug, { page: 1, limit: 50 });
      if (!res || res.ok !== true || !res.payload) {
        listEl.innerHTML = '<p class="lb-v2-muted">無法載入已確認列表。</p>';
        return;
      }
      var items = Array.isArray(res.payload.data) ? res.payload.data : [];
      if (!items.length) {
        listEl.innerHTML = '<p class="lb-v2-muted">目前沒有「已確認且可退票作廢」的純上架票。</p>';
        return;
      }
      listEl.innerHTML =
        '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
        '<th>活動</th><th>訂單</th><th>姓名</th><th>電話</th><th>票種</th><th></th>' +
        '</tr></thead><tbody>' +
        items.map(function (t) {
          return (
            '<tr>' +
            '<td>' + escapeHtml(t.event_title) + '</td>' +
            '<td>' + escapeHtml(t.order_name) + '</td>' +
            '<td>' + escapeHtml(t.name_masked) + '</td>' +
            '<td>' + escapeHtml(t.phone_masked) + '</td>' +
            '<td>' + escapeHtml(t.ticket_type) + '</td>' +
            '<td><button type="button" class="lb-v2-btn lb-v2-btn--ghost lb-v2-btn--sm" data-void-refund="1" data-uid="' +
            escapeHtml(t.ticket_uid) + '">確認退票作廢</button></td>' +
            '</tr>'
          );
        }).join('') +
        '</tbody></table></div>' +
        '<div class="lb-v2-m-cards">' +
        items.map(function (t) {
          return '<article class="lb-v2-m-card">' +
            '<div class="lb-v2-m-card__title">' + escapeHtml(t.event_title || '—') + '</div>' +
            '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">訂單</span><span>' + escapeHtml(t.order_name || '—') + '</span></div>' +
            '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">聯絡</span><span>' + escapeHtml([t.name_masked, t.phone_masked].filter(Boolean).join(' · ') || '—') + '</span></div>' +
            '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">票種</span><span>' + escapeHtml(t.ticket_type || '—') + '</span></div>' +
            '<div class="lb-v2-m-card__actions">' +
              '<button type="button" class="lb-v2-btn" data-void-refund="1" data-uid="' + escapeHtml(t.ticket_uid) + '">確認退票作廢</button>' +
            '</div>' +
          '</article>';
        }).join('') +
        '</div>';
      listEl.querySelectorAll('[data-void-refund]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          voidExposureTicket(slug, btn.getAttribute('data-uid'), 'VENDOR_REFUND', btn);
        });
      });
    } catch (err) {
      listEl.innerHTML = '<p class="lb-v2-muted">' + escapeHtml(err.message || '載入失敗') + '</p>';
    }
  }

  async function voidExposureTicket(slug, ticketUid, reasonCode, btn) {
    if (!slug || !ticketUid) return;
    var promptMsg =
      reasonCode === 'VENDOR_REFUND'
        ? '確認已在外部完成退費，並取消此消費者入場資格？不會自動補庫存。可填備註（可留空）。按取消則不送出。'
        : '確認作廢此「未付款」報名？不會自動補庫存。可填備註（可留空）。按取消則不送出。';
    var note = window.prompt(promptMsg, '');
    if (note === null) return;
    if (btn) btn.disabled = true;
    try {
      var response = await fetch(PATHS.ticketsVoidExposure, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          vendor_slug: slug,
          ticket_uid: ticketUid,
          reason_code: reasonCode,
          note: note || undefined,
        }),
      });
      var payload = await response.json();
      if (payload && payload.ok) {
        showNotice(
          $('lb-v2-pending-payment-notice'),
          payload.already_voided ? '此票先前已作廢' : '已作廢。請自行於 LadyBae 後台調整名額（若需要）。'
        );
        loadPendingPaymentTab();
      } else {
        var voidErr = extractApiError(payload);
        showNotice($('lb-v2-pending-payment-notice'), voidErr.code ? '[' + voidErr.code + '] ' + voidErr.message : (voidErr.message || '作廢失敗'));
        if (btn) btn.disabled = false;
      }
    } catch (err) {
      showNotice($('lb-v2-pending-payment-notice'), err.message || '作廢失敗');
      if (btn) btn.disabled = false;
    }
  }

  async function confirmPendingPayment(slug, ticketUid, btn) {
    if (!slug || !ticketUid) return;
    var note = window.prompt('確認已收到此消費者的外部款項？可填外部單號／備註（可留空）。按取消則不送出。', '');
    if (note === null) return;
    if (btn) btn.disabled = true;
    try {
      var response = await fetch(PATHS.ticketsConfirmPayment, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          vendor_slug: slug,
          ticket_uid: ticketUid,
          note: note || undefined,
        }),
      });
      var payload = await response.json();
      if (payload && payload.ok) {
        showNotice($('lb-v2-pending-payment-notice'), payload.already_confirmed ? '此票先前已確認過' : '已確認收款，消費者報名 QR 已啟用');
        loadPendingPaymentTab();
      } else {
        var confirmErr = extractApiError(payload);
        showNotice($('lb-v2-pending-payment-notice'), confirmErr.code ? '[' + confirmErr.code + '] ' + confirmErr.message : (confirmErr.message || '確認失敗'));
        if (btn) btn.disabled = false;
      }
    } catch (err) {
      showNotice($('lb-v2-pending-payment-notice'), err.message || '確認失敗');
      if (btn) btn.disabled = false;
    }
  }

  function loadActiveTab(fullReload) {
    if (accountIsScanOnlyOnly) return;
    updateExportControls();
    var force = !!fullReload;
    if (activeTab === 'overview') {
      if (!force && tabCacheHit('overview')) return;
      loadOverviewTab(force);
    } else if (activeTab === 'fee-purchase') loadFeePurchaseTab();
    else if (activeTab === 'listing') {
      if (!force && tabCacheHit('listing')) return;
      loadListingTab(force);
    } else if (activeTab === 'private') {
      if (!force && tabCacheHit('private')) return;
      loadPrivateTab(force);
    } else if (activeTab === 'private-eligibility') {
      if (!force && tabCacheHit('private-eligibility')) return;
      loadPrivateEligibilityTab(force);
    } else if (activeTab === 'private-schedule') {
      if (!force && tabCacheHit('private-schedule')) return;
      loadPrivateScheduleTab(force);
    } else if (activeTab === 'private-page') {
      if (!force && tabCacheHit('private-page')) return;
      loadPrivatePageTab(force);
    } else if (activeTab === 'settlement' || activeTab === 'settlement-private') {
      var settleKey = activeTab === 'settlement-private' ? 'settlement-private' : '';
      if (settleKey && !force && tabCacheHit(settleKey)) return;
      loadSettlementTab(settlementModeFromTab(activeTab), force);
    }
    else if (activeTab === 'course-ads') loadCourseAdsTab(force);
    else if (activeTab === 'pending-payment') { pendingPaymentPage = 1; loadPendingPaymentTab(); }
    else if (activeTab === 'course-decision') loadCourseDecisionTab();
    else if (activeTab === 'exposure-confirmed') loadConfirmedExposureTab();
    else if (!force && tabCacheHit('events')) return;
    // 首次進入／快取未命中必須走 structure：單一廠商的 soft reload
    // 只更新彙總與票券，不會 fetch／render 左側活動卡片。
    else loadEventsStructure();
  }

  function parseCsvText(text) {
    var rows = [];
    var row = [];
    var field = '';
    var inQuotes = false;
    var i = 0;
    var s = String(text || '').replace(/^\uFEFF/, '');
    while (i < s.length) {
      var ch = s.charAt(i);
      if (inQuotes) {
        if (ch === '"') {
          if (s.charAt(i + 1) === '"') {
            field += '"';
            i += 2;
            continue;
          }
          inQuotes = false;
          i += 1;
          continue;
        }
        field += ch;
        i += 1;
        continue;
      }
      if (ch === '"') {
        inQuotes = true;
        i += 1;
        continue;
      }
      if (ch === ',') {
        row.push(field);
        field = '';
        i += 1;
        continue;
      }
      if (ch === '\n' || (ch === '\r' && s.charAt(i + 1) === '\n')) {
        row.push(field);
        rows.push(row);
        row = [];
        field = '';
        i += ch === '\r' ? 2 : 1;
        continue;
      }
      if (ch === '\r') {
        row.push(field);
        rows.push(row);
        row = [];
        field = '';
        i += 1;
        continue;
      }
      field += ch;
      i += 1;
    }
    if (field.length || row.length) {
      row.push(field);
      rows.push(row);
    }
    if (rows.length && rows[rows.length - 1].length === 1 && rows[rows.length - 1][0] === '') {
      rows.pop();
    }
    return rows;
  }

  function spreadsheetMlFromRows(rows) {
    var xml = '<?xml version="1.0" encoding="UTF-8"?>\n' +
      '<?mso-application progid="Excel.Sheet"?>\n' +
      '<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"\n' +
      ' xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">\n' +
      '<Styles><Style ss:ID="hdr"><Font ss:Bold="1"/></Style></Styles>\n' +
      '<Worksheet ss:Name="Export"><Table>\n';
    (rows || []).forEach(function (cols, rowIndex) {
      xml += '<Row>';
      (cols || []).forEach(function (cell) {
        var value = cell == null ? '' : String(cell);
        var escaped = value
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
        var style = rowIndex === 0 ? ' ss:StyleID="hdr"' : '';
        xml += '<Cell' + style + '><Data ss:Type="String">' + escaped + '</Data></Cell>';
      });
      xml += '</Row>\n';
    });
    xml += '</Table></Worksheet></Workbook>';
    return xml;
  }

  function triggerBrowserDownload(blob, filename) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
  }

  async function downloadExportFile(exportUrl, format, filenameBase) {
    var isBinary = format === 'docx' || format === 'pdf';
    var response = await fetch(exportUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: isBinary
          ? 'application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/json'
          : 'text/csv, application/json',
      },
    });

    if (!response.ok) {
      var message = '匯出失敗';
      try {
        var errText = await response.text();
        var payload = JSON.parse(errText);
        var exportErr = extractApiError(payload);
        message = exportErr.code ? '[' + exportErr.code + '] ' + exportErr.message : (exportErr.message || message);
      } catch (e) { /* keep default */ }
      throw new Error(message);
    }

    var safeBase = String(filenameBase || 'vendor-portal-export').replace(/[^\w.-]+/g, '_');
    var disposition = response.headers.get('Content-Disposition') || '';
    var named = /filename=\"([^\"]+)\"/i.exec(disposition);
    var serverName = named && named[1] ? named[1] : '';

    if (format === 'docx') {
      var docxBuf = await response.arrayBuffer();
      triggerBrowserDownload(
        new Blob([docxBuf], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        }),
        serverName || safeBase + '.docx'
      );
      return;
    }

    if (format === 'pdf') {
      var pdfBuf = await response.arrayBuffer();
      triggerBrowserDownload(
        new Blob([pdfBuf], { type: 'application/pdf' }),
        serverName || safeBase + '.pdf'
      );
      return;
    }

    var text = await response.text();
    if (format === 'excel') {
      var rows = parseCsvText(text);
      var xml = spreadsheetMlFromRows(rows);
      triggerBrowserDownload(
        new Blob([xml], { type: 'application/vnd.ms-excel;charset=utf-8' }),
        safeBase + '.xls'
      );
      return;
    }

    triggerBrowserDownload(
      new Blob(['\uFEFF' + text], { type: 'text/csv;charset=utf-8' }),
      safeBase + '.csv'
    );
  }

  function openExportFormatModal(opts) {
    var title = opts.title;
    var bodyHtml = opts.bodyHtml;
    var exportUrl = opts.exportUrl;
    var filenameBase = opts.filenameBase;
    var confirmLabelPrefix = opts.confirmLabelPrefix || '下載';

    openModal({
      title: title,
      bodyHtml: bodyHtml +
        '<p style="margin:0.85rem 0 0.35rem"><strong>請選擇檔案格式</strong></p>' +
        '<p class="lb-v2-muted" style="margin:0">CSV 可用試算表開啟；Excel（.xls）可直接用 Excel／Numbers 開啟。</p>',
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: confirmLabelPrefix + ' CSV',
          close: true,
          onClick: function () {
            downloadExportFile(exportUrl, 'csv', filenameBase).catch(function (err) {
              openModal({
                title: '匯出失敗',
                bodyHtml: '<p>' + escapeHtml(err.message || '請稍後再試') + '</p>',
                actions: [{ label: '知道了', accent: true, close: true }],
              });
            });
          },
        },
        {
          label: confirmLabelPrefix + ' Excel',
          accent: true,
          close: true,
          onClick: function () {
            downloadExportFile(exportUrl, 'excel', filenameBase).catch(function (err) {
              openModal({
                title: '匯出失敗',
                bodyHtml: '<p>' + escapeHtml(err.message || '請稍後再試') + '</p>',
                actions: [{ label: '知道了', accent: true, close: true }],
              });
            });
          },
        },
      ],
    });
  }

  function openMaskedCsvExport() {
    var gate = getExportGate();
    if (!gate.allowed) return;
    var vendors = getActiveVendors();
    if (!vendors.length) return;
    var pageState = getPageState(activeTab);
    var slug = vendors[0];
    if (isAllMode() && vendors.length > 1) return;
    openExportFormatModal({
      title: '匯出報表（遮蔽版）',
      bodyHtml:
        '<p>將依目前篩選條件匯出票券報表。</p>' +
        '<p class="lb-v2-muted">遮蔽版不含完整姓名／電話／信箱／票券碼。</p>',
      exportUrl: buildExportUrl(slug, pageState, activeTab === 'events', false),
      filenameBase: 'vendor-portal-masked-' + slug,
      confirmLabelPrefix: '下載',
    });
  }

  function openFullPiiCsvExport() {
    var gate = getFullPiiGate();
    if (!gate.allowed) return;
    var vendors = getActiveVendors();
    if (!vendors.length) return;
    if (isAllMode() && vendors.length > 1) return;
    var pageState = getPageState(activeTab);
    var slug = vendors[0];
    openExportFormatModal({
      title: '匯出學員名單',
      bodyHtml:
        '<p>將依目前篩選條件匯出學員名單（含<strong>姓名、電話、電子信箱、票券碼</strong>）。</p>' +
        '<p class="lb-v2-muted">僅限核對報名身份與營運必要用途。此操作會留下稽核紀錄。</p>',
      exportUrl: buildExportUrl(slug, pageState, activeTab === 'events', true),
      filenameBase: 'vendor-portal-students-' + slug,
      confirmLabelPrefix: '下載',
    });
  }

  function openAttendanceSheetExport() {
    var gate = getAttendanceGate();
    if (!gate.allowed) {
      openModal({
        title: '無法匯出簽到表',
        bodyHtml: '<p>' + escapeHtml(gate.reason || '權限不足') + '</p>',
        actions: [{ label: '知道了', accent: true, close: true }],
      });
      return;
    }
    var vendors = getActiveVendors();
    if (!vendors.length) return;
    if (isAllMode() && vendors.length > 1) {
      openModal({
        title: '無法匯出簽到表',
        bodyHtml: '<p>請先選擇單一品牌後再匯出簽到表。</p>',
        actions: [{ label: '知道了', accent: true, close: true }],
      });
      return;
    }
    var pageState = getPageState(activeTab);
    var slug = vendors[0];
    var includeEvent = activeTab === 'events';
    var filenameBase = 'attendance-sheet-' + slug;
    var savedCols = readAttendanceColsPref(slug);

    function runAttendanceDownload(format) {
      var cols = readAttendanceColsFromModal();
      writeAttendanceColsPref(slug, cols);
      var colsParam = attendanceColsQueryValue(cols);
      return downloadExportFile(
        buildAttendanceExportUrl(slug, pageState, includeEvent, format, colsParam),
        format,
        filenameBase
      ).catch(function (err) {
        openModal({
          title: '匯出失敗',
          bodyHtml: '<p>' + escapeHtml(err.message || '請稍後再試') + '</p>',
          actions: [{ label: '知道了', accent: true, close: true }],
        });
      });
    }

    openModal({
      title: '匯出簽到表',
      bodyHtml:
        '<p>將依目前篩選條件匯出<strong>有效票</strong>簽到表。</p>' +
        '<p class="lb-v2-muted">同一檔案內依課程分節；簽名／備註欄空白供現場手寫。此操作會留下稽核紀錄。</p>' +
        attendanceColsCheckHtml(savedCols) +
        '<p class="lb-v2-att-cols__format"><strong>請選擇檔案格式</strong></p>',
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '下載 Word',
          close: true,
          onClick: function () {
            runAttendanceDownload('docx');
          },
        },
        {
          label: '下載 PDF',
          accent: true,
          close: true,
          onClick: function () {
            runAttendanceDownload('pdf');
          },
        },
      ],
    });
  }

  function setRevealFullPii(next, opts) {
    var silent = opts && opts.silent;
    var gate = getFullPiiGate();
    if (next && !gate.allowed) {
      revealFullPii = false;
      updateExportControls();
      return;
    }
    revealFullPii = !!next;
    updateExportControls();
    if (!silent) {
      // PII mask changes require re-render; drop soft cache for data tabs.
      if (tabDataCache.events) tabDataCache.events.loaded = false;
      if (tabDataCache.overview) tabDataCache.overview.loaded = false;
      loadActiveTab(false);
    }
  }

  function onRevealToggleChange(ev) {
    var input = ev && ev.target;
    var wantOn = !!(input && input.checked);
    if (!wantOn) {
      setRevealFullPii(false);
      return;
    }
    // Revert checkbox until user confirms
    if (input) input.checked = false;
    var gate = getFullPiiGate();
    if (!gate.allowed) {
      openModal({
        title: '無法顯示完整個資',
        bodyHtml: '<p>' + escapeHtml(gate.reason || '權限不足') + '</p>',
        actions: [{ label: '知道了', accent: true, close: true }],
      });
      return;
    }
    openModal({
      title: '確認顯示完整個資',
      bodyHtml:
        '<p>將在列表顯示<strong>完整學員／購買者姓名、電話、電子信箱</strong>。</p>' +
        '<p class="lb-v2-muted">僅限核對報名身份。關閉開關即恢復遮蔽；此操作會留下稽核紀錄。</p>',
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '確認顯示',
          accent: true,
          close: true,
          onClick: function () {
            setRevealFullPii(true);
          },
        },
      ],
    });
  }

  root.querySelectorAll('.lb-v2-tab').forEach(function (btn) {
    if (btn.hasAttribute('data-subnav')) return; // 子頁按鈕另有處理
    btn.addEventListener('click', function () {
      var t = btn.getAttribute('data-tab');
      var gate = evaluateTabGate(t, btn);
      if (gate && !gate.allowed) {
        handleLockedTabClick(t, gate);
        return;
      }
      // Direct click on 上架新課程 unlocks PRIVATE mode lock from 資格限定課 tab.
      if ((t === 'course-new' || t === 'listing') && !pendingPrivateListingCreate) {
        setListingModePrivateLocked(false);
      }
      switchTab(t);
      // 從 rail 進「上架新課程」就是要開新的；改既有課程走課程管理的編輯。
      if (t === 'course-new' && !pendingPrivateListingCreate && !pendingPrivateListingEditId) {
        var loadedIdEl = $('lb-v2-listing-id');
        if (loadedIdEl && loadedIdEl.value) {
          clearListingForm();
          showNotice(
            $('lb-v2-listing-notice'),
            '已開啟空白草稿。要修改既有課程請到「課程管理」按編輯。'
          );
        }
      }
    });
  });

  root.querySelectorAll('[data-subnav]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.getAttribute('data-subnav');
      var sub = btn.getAttribute('data-sub') || '';
      if (group === 'ads') {
        setCourseAdsView(sub);
        return;
      }
      var target = subNavTargetTab(group, sub);
      var gate = evaluateTabGate(target, btn);
      if (gate && !gate.allowed) {
        handleLockedTabClick(target, gate);
        return;
      }
      if (group === 'manage') manageSub = sub;
      else if (group === 'ops') opsSub = sub;
      switchTab(group === 'manage' ? 'course-manage' : 'ops-data');
    });
  });

  var privateApplyCta = $('lb-v2-private-apply-cta');
  if (privateApplyCta) {
    privateApplyCta.addEventListener('click', function () {
      if (isAllMode() || !vendorMode) {
        openModal({
          title: '請先選擇廠商',
          bodyHtml: '<p>資格限定課申請需先在「身分選擇」挑單一廠商（擁有者／管理員）。</p>',
          actions: [{ label: '知道了', accent: true, close: true }],
        });
        return;
      }
      var gate = evaluateTabGate('private', privateApplyCta);
      if (gate && !gate.allowed) {
        handleLockedTabClick('private', gate);
        return;
      }
      switchTab('private');
    });
  }

  var deckToggleBtn = $('lb-v2-deck-toggle');
  var deckEl = $('lb-v2-deck');
  if (deckToggleBtn && deckEl) {
    deckToggleBtn.addEventListener('click', function () {
      var open = !deckEl.classList.contains('is-open');
      deckEl.classList.toggle('is-open', open);
      deckToggleBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    deckEl.addEventListener('click', function (e) {
      var item = e.target && e.target.closest ? e.target.closest('.lb-v2-deck-item') : null;
      if (item) deckEl.classList.remove('is-open');
    });
  }

  renderSubNavState();
  applyListingPanelView();

  var reloadBtn = $('lb-v2-reload');
  if (reloadBtn) reloadBtn.addEventListener('click', function () { loadActiveTab(true); });
  var exportStudentsBtn = $('lb-v2-export-students');
  if (exportStudentsBtn) exportStudentsBtn.addEventListener('click', openFullPiiCsvExport);
  var exportAttendanceBtn = $('lb-v2-export-attendance');
  if (exportAttendanceBtn) exportAttendanceBtn.addEventListener('click', openAttendanceSheetExport);

  var eventSearchEl = $('lb-v2-event-search');
  var eventSearchTimer = null;
  if (eventSearchEl) {
    eventSearchEl.addEventListener('input', function () {
      eventSearchQuery = eventSearchEl.value || '';
      if (eventSearchTimer) clearTimeout(eventSearchTimer);
      eventSearchTimer = setTimeout(function () {
        eventSearchTimer = null;
        renderEventsList();
      }, 200);
    });
  }

  var rankSortEl = $('lb-v2-rank-sort');
  if (rankSortEl) {
    rankSortEl.addEventListener('change', function () {
      overviewRankSort = rankSortEl.value || 'sales';
      renderOverviewRanking(cachedEventsItems);
    });
  }

  // ═══════════════════════════════════════════════════════
  // Listing tab logic
  // ═══════════════════════════════════════════════════════

  var listingVariantCount = 0;
  var listingImageFiles = [];
  var listingImageSources = []; // preview: blob:/http(s)/data: — persist materializes on save
  var listingDescImageFiles = [];
  var listingDescImageSources = [];
  var MAX_IMAGES = 5;
  var MAX_DESC_IMAGES = 3;
  var MAX_VARIANTS = 50;

  function isBlobUrl(src) {
    return String(src || '').indexOf('blob:') === 0;
  }

  function revokeIfBlobUrl(src) {
    if (!isBlobUrl(src)) return;
    try { URL.revokeObjectURL(src); } catch (e) { /* ignore */ }
  }

  function isHttpsImageUrl(src) {
    return /^https:\/\//i.test(String(src || ''));
  }

  function isDurablePublicImageUrl(src) {
    var raw = String(src || '').trim();
    if (!raw) return false;
    try {
      var parsed = new URL(raw);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
      var host = parsed.hostname.toLowerCase();
      if (host === 'shopify-staged-uploads.storage.googleapis.com') return false;
      if (host.indexOf('shopify-staged-uploads') !== -1) return false;
      return true;
    } catch (err) {
      return false;
    }
  }

  function rewriteStagedShopifyFileUrl(src) {
    var raw = String(src || '').trim();
    var match = raw.match(/^https?:\/\/shopify-staged-uploads\.storage\.googleapis\.com\/tmp\/(\d+)\/files\/[^/]+\/([^/?#]+)/i);
    if (!match) return '';
    var filename = decodeURIComponent(match[2] || '');
    if (!filename || filename.indexOf('..') !== -1 || filename.indexOf('/') !== -1) return '';
    var digits = String(match[1] || '').replace(/\D/g, '');
    while (digits.length < 11) digits = '0' + digits;
    var a;
    var b;
    var c;
    if (digits.length >= 12) {
      digits = digits.slice(-12);
      a = digits.slice(0, 4);
      b = digits.slice(4, 8);
      c = digits.slice(8, 12);
    } else {
      a = digits.slice(0, 4);
      b = digits.slice(4, 8);
      c = digits.slice(8);
    }
    return 'https://cdn.shopify.com/s/files/1/' + a + '/' + b + '/' + c + '/files/' + filename;
  }

  function coerceDurablePublicImageUrl(src) {
    var raw = String(src || '').trim();
    if (isDurablePublicImageUrl(raw)) return raw;
    var rewritten = rewriteStagedShopifyFileUrl(raw);
    return rewritten && isDurablePublicImageUrl(rewritten) ? rewritten : '';
  }

  async function uploadListingImageFile(file, kind) {
    var slug = getListingVendorSlug();
    if (!slug || !file) return null;
    try {
      var sessionRes = await fetch(PATHS.listingImageUploadSession, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vendor_slug: slug,
          filename: file.name || 'listing-image',
          content_type: file.type || 'image/jpeg',
          size: file.size,
          kind: kind === 'description' ? 'description' : 'cover',
        }),
      });
      var sessionPayload = null;
      try { sessionPayload = await sessionRes.json(); } catch (e) { sessionPayload = null; }
      if (!sessionRes.ok || !sessionPayload || !sessionPayload.ok || !sessionPayload.upload_token) {
        return null;
      }
      var form = new FormData();
      form.append('image', file);
      form.append('vendor_slug', slug);
      var directRes = await fetch(sessionPayload.upload_url || LISTING_IMAGE_UPLOAD_DIRECT_DEFAULT, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + sessionPayload.upload_token,
        },
        body: form,
      });
      var directPayload = null;
      try { directPayload = await directRes.json(); } catch (e2) { directPayload = null; }
      if (!directRes.ok || !directPayload || !directPayload.ok || !directPayload.url) return null;
      return coerceDurablePublicImageUrl(String(directPayload.url)) || null;
    } catch (err) {
      return null;
    }
  }

  var listingImageUploadsInFlight = 0;

  function beginListingImageUpload() {
    listingImageUploadsInFlight += 1;
  }

  function endListingImageUpload() {
    if (listingImageUploadsInFlight > 0) listingImageUploadsInFlight -= 1;
  }

  function waitForListingImageUploads() {
    return new Promise(function (resolve) {
      var n = 0;
      function tick() {
        if (listingImageUploadsInFlight <= 0 || n >= 80) {
          resolve();
          return;
        }
        n += 1;
        setTimeout(tick, 250);
      }
      tick();
    });
  }

  function isDataImageUrl(src) {
    return String(src || '').indexOf('data:image/') === 0;
  }

  async function dataUrlToFile(src, name) {
    try {
      var res = await fetch(src);
      var blob = await res.blob();
      return new File([blob], name || 'listing-image.jpg', { type: blob.type || 'image/jpeg' });
    } catch (err) {
      return null;
    }
  }

  /**
   * listing/save 只能帶 https CDN。5MB 規則圖走 image-upload-direct，
   * 不可再把 data URL 塞進 App Proxy（Fastify 1MB 會 413→舊版變 HTML 500）。
   */
  async function ensureImagesOnCdn(sources, files, kind) {
    var out = [];
    var list = sources || [];
    var fileList = files || [];
    for (var i = 0; i < list.length; i++) {
      var src = list[i];
      if (!src || src === '[omitted-data-url]') continue;
      if (isHttpsImageUrl(src)) {
        var kept = coerceDurablePublicImageUrl(src);
        if (!kept) {
          return { ok: false, message: '圖片網址已過期，請重新上傳廣告圖。' };
        }
        out.push(kept);
        continue;
      }
      var file = fileList[i] || null;
      if (!file && isDataImageUrl(src)) {
        file = await dataUrlToFile(src, (kind || 'cover') + '-' + (i + 1) + '.jpg');
      }
      if (!file) {
        return { ok: false, message: '圖片尚未上傳完成，請再按一次儲存。' };
      }
      if (file.size > 5 * 1024 * 1024) {
        return { ok: false, message: '單張圖片請小於 5MB（目前第 ' + (out.length + 1) + ' 張過大）' };
      }
      var url = await uploadListingImageFile(file, kind);
      if (!url) {
        return { ok: false, message: '圖片上傳失敗，請再試一次。' };
      }
      list[i] = url;
      fileList[i] = null;
      out.push(url);
    }
    return { ok: true, sources: out };
  }

  function bindImageUpload() {
    var inp = $('lb-v2-listing-image-input');
    if (!inp || inp._lbBound) return;
    inp._lbBound = true;
    inp.addEventListener('change', function () {
      var files = Array.from(inp.files || []);
      var remaining = MAX_IMAGES - listingImageSources.filter(Boolean).length;
      if (remaining <= 0) {
        showListingAlert('最多上傳 ' + MAX_IMAGES + ' 張圖片');
        inp.value = '';
        return;
      }
      files.slice(0, remaining).forEach(function (file) {
        if (!file.type.startsWith('image/')) return;
        var idx = listingImageSources.length;
        listingImageFiles[idx] = file;
        var preview = URL.createObjectURL(file);
        listingImageSources[idx] = preview;
        addImagePreview(preview, idx);
        beginListingImageUpload();
        uploadListingImageFile(file, 'cover').then(function (cdnUrl) {
          if (!cdnUrl || listingImageSources[idx] == null) return;
          var localSrc = listingImageSources[idx];
          listingImageSources[idx] = cdnUrl;
          listingImageFiles[idx] = null;
          swapPreviewWhenLoadable('lb-v2-listing-images-preview', idx, cdnUrl, localSrc);
        }).finally(endListingImageUpload);
      });
      inp.value = '';
    });
  }

  function isAllowedDescImageFile(file) {
    if (!file) return false;
    var type = String(file.type || '').toLowerCase();
    if (type === 'image/png' || type === 'image/jpeg' || type === 'image/webp') return true;
    var name = String(file.name || '').toLowerCase();
    return /\.(png|jpe?g|webp)$/.test(name);
  }

  function bindDescImageUpload() {
    var inp = $('lb-v2-listing-desc-image-input');
    if (!inp || inp._lbBound) return;
    inp._lbBound = true;
    inp.addEventListener('change', function () {
      var files = Array.from(inp.files || []);
      var remaining = MAX_DESC_IMAGES - listingDescImageSources.filter(Boolean).length;
      if (remaining <= 0) {
        showListingAlert('說明圖片最多上傳 ' + MAX_DESC_IMAGES + ' 張');
        inp.value = '';
        return;
      }
      var rejected = false;
      files.slice(0, remaining).forEach(function (file) {
        if (!isAllowedDescImageFile(file)) {
          rejected = true;
          return;
        }
        var idx = listingDescImageSources.length;
        listingDescImageFiles[idx] = file;
        var preview = URL.createObjectURL(file);
        listingDescImageSources[idx] = preview;
        addDescImagePreview(preview, idx);
        beginListingImageUpload();
        uploadListingImageFile(file, 'description').then(function (cdnUrl) {
          if (!cdnUrl || listingDescImageSources[idx] == null) return;
          var localSrc = listingDescImageSources[idx];
          listingDescImageSources[idx] = cdnUrl;
          listingDescImageFiles[idx] = null;
          swapPreviewWhenLoadable('lb-v2-listing-desc-images-preview', idx, cdnUrl, localSrc);
        }).finally(endListingImageUpload);
      });
      if (rejected) {
        showListingAlert('說明圖片僅支援 JPG／PNG／WebP');
      }
      inp.value = '';
    });
  }

  /**
   * Shopify 剛建立的檔案有時要等幾秒才可讀，直接掛上去會變破圖（暫存後最常見）。
   * 讀不到就退幾秒再試，不要讓廠商以為圖沒存到。
   */
  function bindPreviewLoadRetry(img) {
    if (!img || img._lbRetryBound) return;
    img._lbRetryBound = true;
    img.addEventListener('error', function () {
      var src = String(img.getAttribute('src') || '');
      if (!/^https?:\/\//i.test(src) && src.indexOf('//') !== 0) return;
      var tries = Number(img.dataset.lbRetry || 0);
      if (tries >= 4) return;
      img.dataset.lbRetry = String(tries + 1);
      var base = src.split('#')[0].replace(/([?&])lbr=\d+/, '$1').replace(/[?&]$/, '');
      setTimeout(function () {
        img.src = base + (base.indexOf('?') >= 0 ? '&' : '?') + 'lbr=' + (tries + 1);
      }, 1200 * (tries + 1));
    });
  }

  /** 確認 CDN 圖真的讀得到才換掉本地預覽；期間縮圖維持顯示上傳的原圖。 */
  function swapPreviewWhenLoadable(containerId, idx, url, localSrc, attempt) {
    var tries = attempt || 0;
    loadImageElement(url).then(function () {
      var img = document.querySelector('#' + containerId + ' img[data-img-idx="' + idx + '"]');
      if (img) img.src = url;
      revokeIfBlobUrl(localSrc);
    }).catch(function () {
      if (tries >= 4) return;
      setTimeout(function () {
        swapPreviewWhenLoadable(containerId, idx, url, localSrc, tries + 1);
      }, 1200 * (tries + 1));
    });
  }

  function addImagePreview(src, idx) {
    var container = $('lb-v2-listing-images-preview');
    if (!container || !src || src === '[omitted-data-url]') return;
    var img = document.createElement('img');
    bindPreviewLoadRetry(img);
    img.src = src;
    img.title = '點擊移除';
    img.dataset.imgIdx = String(idx);
    img.addEventListener('click', function () {
      revokeIfBlobUrl(listingImageSources[idx]);
      listingImageFiles[idx] = null;
      listingImageSources[idx] = null;
      img.remove();
    });
    container.appendChild(img);
  }

  function addDescImagePreview(src, idx) {
    var container = $('lb-v2-listing-desc-images-preview');
    if (!container || !src || src === '[omitted-data-url]') return;
    var img = document.createElement('img');
    bindPreviewLoadRetry(img);
    img.src = src;
    img.title = '點擊移除';
    img.dataset.imgIdx = String(idx);
    img.addEventListener('click', function () {
      revokeIfBlobUrl(listingDescImageSources[idx]);
      listingDescImageFiles[idx] = null;
      listingDescImageSources[idx] = null;
      img.remove();
    });
    container.appendChild(img);
  }

  function clearImagePreviews() {
    listingImageSources.forEach(revokeIfBlobUrl);
    listingImageFiles = [];
    listingImageSources = [];
    var container = $('lb-v2-listing-images-preview');
    if (container) container.innerHTML = '';
  }

  function clearDescImagePreviews() {
    listingDescImageSources.forEach(revokeIfBlobUrl);
    listingDescImageFiles = [];
    listingDescImageSources = [];
    var container = $('lb-v2-listing-desc-images-preview');
    if (container) container.innerHTML = '';
  }

  function collectListingImageSources() {
    return listingImageSources.filter(function (s) {
      return !!s && s !== '[omitted-data-url]';
    });
  }

  function collectDescImageSources() {
    return listingDescImageSources.filter(function (s) {
      return !!s && s !== '[omitted-data-url]';
    });
  }

  /** Prefer https CDN; leftover File / data URL are uploaded, never inlined. */
  async function materializeImageSourcesForSave(sources, files, kind) {
    var ready = await ensureImagesOnCdn(sources, files, kind || 'cover');
    return ready;
  }

  function extractImageSourcesFromField(item, fieldKeys, maxCount) {
    var out = [];
    if (!item) return out;
    fieldKeys.forEach(function (key) {
      var imgs = item[key];
      if (typeof imgs === 'string') {
        try { imgs = JSON.parse(imgs); } catch (e) { imgs = []; }
      }
      if (!Array.isArray(imgs)) return;
      imgs.forEach(function (img) {
        var src = typeof img === 'string' ? img : (img && img.src);
        if (src && src !== '[omitted-data-url]' && out.indexOf(src) === -1) out.push(src);
      });
    });
    return out.slice(0, maxCount);
  }

  function extractListingImageSources(item) {
    var out = [];
    if (!item) return out;
    if (Array.isArray(item.image_urls)) {
      item.image_urls.forEach(function (u) {
        if (u && u !== '[omitted-data-url]') out.push(u);
      });
    }
    extractImageSourcesFromField(item, ['images_json'], MAX_IMAGES).forEach(function (src) {
      if (out.indexOf(src) === -1) out.push(src);
    });
    return out.slice(0, MAX_IMAGES);
  }

  function extractDescImageSources(item) {
    return extractImageSourcesFromField(item, ['description_images_json'], MAX_DESC_IMAGES);
  }

  function setListingImageSources(sources) {
    clearImagePreviews();
    (sources || []).forEach(function (src, i) {
      listingImageSources[i] = src;
      listingImageFiles[i] = null;
      addImagePreview(src, i);
    });
  }

  function setDescImageSources(sources) {
    clearDescImagePreviews();
    (sources || []).forEach(function (src, i) {
      listingDescImageSources[i] = src;
      listingDescImageFiles[i] = null;
      addDescImagePreview(src, i);
    });
  }

  function fileToBase64(file) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = function () { resolve(null); };
      reader.readAsDataURL(file);
    });
  }

  function getListingVendorSlug() {
    var vendors = getActiveVendors();
    return vendors.length === 1 ? vendors[0] : (isAllMode() ? '' : vendorMode);
  }

  function currentVariantRowCount() {
    var container = $('lb-v2-listing-variants');
    if (!container) return 0;
    return container.querySelectorAll('.lb-v2-variant-row').length;
  }

  function addVariantRow(name, price, qty) {
    var container = $('lb-v2-listing-variants');
    if (!container) return;
    if (currentVariantRowCount() >= MAX_VARIANTS) {
      showListingAlert('票種數量最多 ' + MAX_VARIANTS + ' 種');
      return;
    }
    var idx = listingVariantCount++;
    var row = document.createElement('div');
    row.className = 'lb-v2-variant-row';
    row.innerHTML =
      '<div class="lb-v2-variant-cell">' +
        '<label class="lb-v2-variant-label" for="lb-v2-var-name-' + idx + '">票種名稱</label>' +
        '<input type="text" id="lb-v2-var-name-' + idx + '" class="lb-v2-input lb-v2-input--sm" placeholder="例：早鳥票" data-var-name="' + idx + '" value="' + escapeHtml(name || '') + '" autocomplete="off">' +
      '</div>' +
      '<div class="lb-v2-variant-cell">' +
        '<label class="lb-v2-variant-label" for="lb-v2-var-price-' + idx + '">價格（NT$）</label>' +
        '<input type="number" id="lb-v2-var-price-' + idx + '" class="lb-v2-input lb-v2-input--sm" placeholder="例：750" min="0" step="1" data-var-price="' + idx + '" value="' +
          (price === 0 || price === '0' ? '0' : (price || '')) + '">' +
      '</div>' +
      '<div class="lb-v2-variant-cell">' +
        '<label class="lb-v2-variant-label" for="lb-v2-var-qty-' + idx + '">販售數量</label>' +
        '<input type="number" id="lb-v2-var-qty-' + idx + '" class="lb-v2-input lb-v2-input--sm" placeholder="例：20" min="1" step="1" data-var-qty="' + idx + '" value="' + (qty || '') + '">' +
      '</div>' +
      '<div class="lb-v2-variant-cell lb-v2-variant-cell--action">' +
        '<span class="lb-v2-variant-label lb-v2-variant-label--spacer" aria-hidden="true">刪除</span>' +
        '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--danger lb-v2-variant-remove" data-remove-variant="' + idx + '" aria-label="刪除此票種">✕</button>' +
      '</div>';
    row.querySelector('[data-remove-variant]').addEventListener('click', function () { row.remove(); });
    container.appendChild(row);
  }

  function collectVariants() {
    var container = $('lb-v2-listing-variants');
    if (!container) return [];
    var modeEl = $('lb-v2-listing-mode');
    var allowZeroPrice = modeEl && resolveListingMode(modeEl.value) === 'PRIVATE';
    var rows = container.querySelectorAll('.lb-v2-variant-row');
    var result = [];
    rows.forEach(function (row) {
      var nameEl = row.querySelector('[data-var-name]');
      var priceEl = row.querySelector('[data-var-price]');
      var qtyEl = row.querySelector('[data-var-qty]');
      var n = nameEl ? nameEl.value.trim() : '';
      // TWD must be a whole number; reject decimals / non-integers.
      var p = priceEl ? parseInt(priceEl.value, 10) : NaN;
      var q = qtyEl ? parseInt(qtyEl.value, 10) : 0;
      var priceOk = allowZeroPrice ? (Number.isInteger(p) && p >= 0) : (Number.isInteger(p) && p > 0);
      if (n && priceOk && q > 0) result.push({ name: n, price: p, quantity: q });
    });
    return result;
  }

  // ── Shopify taxonomy ──────────────────────────────────────
  var taxonomyProductTypes = [];
  var taxonomyCollections = []; // titles (compat)
  var taxonomyCollectionMeta = []; // [{ title, handle }]
  var taxonomyLoaded = false;

  var COLLECTION_GROUP_ORDER = ['mode', 'class', 'age', 'fee', 'cat', 'other'];
  var COLLECTION_GROUP_LABELS = {
    mode: '授課方式',
    class: '班別',
    age: '年齡區間',
    fee: '費用',
    cat: '主題分類',
    other: '其他系列',
  };
  // Mirror backend city-taxonomy labels (+ 台/臺 variants) to exclude from 商品系列
  var CITY_SERIES_LABELS = {
    '臺北市': 1, '台北市': 1, '新北市': 1, '桃園市': 1,
    '臺中市': 1, '台中市': 1, '臺南市': 1, '台南市': 1, '高雄市': 1,
    '基隆市': 1, '新竹市': 1, '新竹縣': 1, '苗栗縣': 1, '彰化縣': 1,
    '南投縣': 1, '雲林縣': 1, '嘉義市': 1, '嘉義縣': 1, '屏東縣': 1,
    '宜蘭縣': 1, '花蓮縣': 1, '臺東縣': 1, '台東縣': 1, '澎湖縣': 1,
    '金門縣': 1, '連江縣': 1,
  };

  function isCityCollectionHandle(handle) {
    return String(handle || '').trim().toLowerCase().indexOf('city-') === 0;
  }

  function isCityCollectionTitle(title) {
    return !!CITY_SERIES_LABELS[String(title || '').trim()];
  }

  function classifyCollectionHandle(handle) {
    var h = String(handle || '').trim().toLowerCase();
    if (!h) return 'other';
    if (h.indexOf('city-') === 0) return 'city';
    if (h.indexOf('mode-') === 0) return 'mode';
    if (h.indexOf('class-') === 0) return 'class';
    if (h.indexOf('age-') === 0 || h.indexOf('aged-') === 0) return 'age';
    if (h.indexOf('fee-') === 0) return 'fee';
    if (h.indexOf('cat-') === 0) return 'cat';
    return 'other';
  }

  function groupCollectionMeta(metaList) {
    var buckets = {};
    COLLECTION_GROUP_ORDER.forEach(function (k) { buckets[k] = []; });
    (metaList || []).forEach(function (item) {
      if (!item || !item.title) return;
      if (isCityCollectionHandle(item.handle) || isCityCollectionTitle(item.title)) return;
      var group = classifyCollectionHandle(item.handle);
      if (group === 'city') return;
      if (!buckets[group]) buckets[group] = [];
      buckets[group].push(item);
    });
    COLLECTION_GROUP_ORDER.forEach(function (k) {
      buckets[k].sort(function (a, b) {
        return String(a.title).localeCompare(String(b.title), 'zh-Hant');
      });
    });
    return buckets;
  }
  var INTERNAL_PRODUCT_TYPES = {
    VendorFeePlan: true,
    _internal_fee_plan: true,
  };

  function isInternalProductType(t) {
    var s = String(t || '').trim();
    if (!s) return true;
    if (INTERNAL_PRODUCT_TYPES[s]) return true;
    if (/^fee_plan_/i.test(s)) return true;
    return false;
  }

  function uniqSorted(arr) {
    var out = [];
    (arr || []).forEach(function (t) {
      if (!t || isInternalProductType(t)) return;
      if (out.indexOf(t) === -1) out.push(t);
    });
    out.sort(function (a, b) { return a.localeCompare(b, 'zh-Hant'); });
    return out;
  }

  function mergeProductTypes(extra) {
    taxonomyProductTypes = uniqSorted(taxonomyProductTypes.concat(extra || []));
  }

  function seedTaxonomyFromConfig() {
    var cols = (config.shopCollections || []).filter(function (t) {
      return t && !isCityCollectionTitle(t);
    });
    if (cols.length && !taxonomyCollections.length) {
      taxonomyCollections = cols;
      taxonomyCollectionMeta = cols.map(function (t) {
        return { title: t, handle: '' };
      });
    }
    // 不預先把全店 product types 塞進下拉，避免白名單被污染；等 API
  }

  /** 不需 Admin 權限：用商店公開 products.json 掃現有類型（僅作 API 失敗時備援） */
  async function loadProductTypesFromStorefront() {
    var found = [];
    try {
      for (var page = 1; page <= 20; page++) {
        var res = await fetch('/collections/all/products.json?limit=250&page=' + page, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) break;
        var data = await res.json();
        var products = data.products || [];
        if (!products.length) break;
        products.forEach(function (p) {
          var t = (p.product_type || '').trim();
          if (t && !isInternalProductType(t)) found.push(t);
        });
        if (products.length < 250) break;
      }
    } catch (e) {
      console.warn('[taxonomy] storefront products.json failed', e);
    }
    return uniqSorted(found);
  }

  var taxonomyLoadPromise = null;

  async function ensureTaxonomyLoaded() {
    seedTaxonomyFromConfig();
    if (taxonomyLoaded) {
      refreshCategoryOptions(getSelectedCategory());
      refreshSubcategoryOptions(getSelectedSubcategories());
      return;
    }
    if (taxonomyLoadPromise) return taxonomyLoadPromise;
    taxonomyLoadPromise = loadTaxonomy().finally(function () {
      taxonomyLoadPromise = null;
    });
    return taxonomyLoadPromise;
  }

  async function loadTaxonomy() {
    seedTaxonomyFromConfig();
    var selectedCat = getSelectedCategory();
    var selectedSubs = getSelectedSubcategories();
    if (taxonomyLoaded) {
      refreshCategoryOptions(selectedCat);
      refreshSubcategoryOptions(selectedSubs);
      return;
    }

    setCategoryHint('載入類型中…（不影響其他分頁）');
    var slug = getListingVendorSlug() || (activeVendors.length ? activeVendors[0] : '');
    var apiOk = false;
    var allowlistConfigured = false;

    for (var attempt = 0; attempt < 2; attempt++) {
      try {
        var res = await fetchAppProxy(PATHS.listingTaxonomy, slug);
        if (!res.ok) {
          console.warn('[taxonomy] api not ok', res.code, res.message);
          if (attempt === 0) await new Promise(function (r) { setTimeout(r, 1500); });
          continue;
        }
        var data = res.payload || {};
        var pt = (data.product_types || []).filter(function (t) {
          return t && !isInternalProductType(t);
        });
        var meta = [];
        var cl = [];
        (data.collections || []).forEach(function (c) {
          if (typeof c === 'string') {
            if (!c || isCityCollectionTitle(c)) return;
            meta.push({ title: c, handle: '' });
            cl.push(c);
            return;
          }
          var title = (c && c.title) || '';
          var handle = (c && c.handle) || '';
          if (!title || isCityCollectionHandle(handle) || isCityCollectionTitle(title)) return;
          meta.push({ title: title, handle: handle });
          cl.push(title);
        });
        allowlistConfigured = data.allowlist_configured === true;

        // 以 API 為唯一來源；已設白名單時絕不再 merge 全店
        taxonomyProductTypes = uniqSorted(pt);
        taxonomyCollections = uniqSorted(cl);
        taxonomyCollectionMeta = meta;
        taxonomyLoaded = true;
        apiOk = true;
        refreshCategoryOptions(selectedCat || getSelectedCategory());
        refreshSubcategoryOptions(selectedSubs.length ? selectedSubs : getSelectedSubcategories());
        if (allowlistConfigured) {
          setCategoryHint(
            '已套用管理員白名單：類型 ' + taxonomyProductTypes.length +
            ' 個、系列 ' + taxonomyCollections.length + ' 個。'
          );
        } else if (data.warning) {
          setCategoryHint(data.warning + ' 目前下拉有 ' + taxonomyProductTypes.length + ' 個現有類型。');
        } else {
          setCategoryHint(
            '管理員尚未設定白名單，目前顯示全店類型 ' + taxonomyProductTypes.length + ' 個。'
          );
        }
        return;
      } catch (e) {
        console.warn('[taxonomy] attempt ' + (attempt + 1) + ' failed', e);
      }
      if (attempt === 0) await new Promise(function (r) { setTimeout(r, 1500); });
    }

    // API 失敗：不回落成全店（避免出現 VendorFeePlan／未白名單類型）
    taxonomyProductTypes = [];
    taxonomyCollections = taxonomyCollections.length ? taxonomyCollections : [];
    taxonomyLoaded = false;
    refreshCategoryOptions(selectedCat);
    refreshSubcategoryOptions(selectedSubs);
    setCategoryHint('分類載入失敗，請重新整理。若持續發生請聯繫官方確認授權設定。');
  }

  // ── Dynamic element creation (avoids theme JS overrides) ──

  /** 拆掉主題 bv_mainselect，避免「Select Option」假 UI 與原生 select 雙重顯示 */
  function stripThemeSelectWrappers(scope) {
    var base = scope || root;
    if (!base || !base.querySelectorAll) return;
    var mains = base.querySelectorAll('.bv_mainselect');
    for (var i = 0; i < mains.length; i++) {
      var main = mains[i];
      var sel = main.querySelector('select');
      if (!sel || !main.parentNode) continue;
      main.parentNode.insertBefore(sel, main);
      main.parentNode.removeChild(main);
    }
  }

  var themeSelectWatchStarted = false;
  function watchThemeSelectWrappers() {
    if (themeSelectWatchStarted || !root) return;
    themeSelectWatchStarted = true;
    stripThemeSelectWrappers(root);
    // 主題常在 insert 後才包一層；縮成兩次延遲，其餘靠 mountInSlot + observer debounce
    [0, 200].forEach(function (ms) {
      setTimeout(function () { stripThemeSelectWrappers(root); }, ms);
    });
    if (typeof MutationObserver === 'undefined') return;
    var stripTimer = null;
    var obs = new MutationObserver(function (mutations) {
      var needs = false;
      for (var i = 0; i < mutations.length && !needs; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (!n || n.nodeType !== 1) continue;
          if ((n.classList && n.classList.contains('bv_mainselect')) ||
              (n.querySelector && n.querySelector('.bv_mainselect'))) {
            needs = true;
            break;
          }
        }
      }
      if (!needs) return;
      if (stripTimer) return;
      stripTimer = setTimeout(function () {
        stripTimer = null;
        stripThemeSelectWrappers(root);
      }, 48);
    });
    obs.observe(root, { childList: true, subtree: true });
    // Dyn selects strip on mount; stop watching after theme settle window.
    setTimeout(function () {
      try { obs.disconnect(); } catch (e) { /* ignore */ }
    }, 4000);
  }

  function createDynSelect(id, options, selectedValue, onChange) {
    var sel = document.createElement('select');
    sel.id = id;
    sel.className = 'lb-v2-select lb-v2-dyn';
    sel.required = true;
    sel.style.cssText = '-webkit-appearance:menulist!important;appearance:menulist!important;opacity:1!important;position:static!important;';
    options.forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o.value;
      opt.textContent = o.label;
      if (o.value === selectedValue) opt.selected = true;
      sel.appendChild(opt);
    });
    if (onChange) sel.addEventListener('change', onChange);
    return sel;
  }

  function createDynInput(id, type, step) {
    var inp = document.createElement('input');
    inp.type = type;
    inp.id = id;
    inp.className = 'lb-v2-input lb-v2-dyn';
    inp.required = true;
    inp.style.cssText = [
      '-webkit-appearance:auto!important',
      'appearance:auto!important',
      'color-scheme:light!important',
      'color:#1a1214!important',
      '-webkit-text-fill-color:#1a1214!important',
      'opacity:1!important',
      'background:#fff!important',
      'visibility:visible!important',
      'pointer-events:auto!important',
    ].join(';');
    if (step) inp.step = String(step);
    return inp;
  }

  /**
   * 日期／時間：可見值用 readonly text（主題不會洗白字）。
   * 原生 input 整格覆蓋在上面（透明、可點），月曆錨在真實尺寸上；
   * 舊的 1px + pointer-events:none 會讓月曆難開、點日期沒反應。
   */
  function neutralizeThemeDatepicker(el) {
    if (!el) return;
    try { el.setAttribute('data-datepicker', 'false'); } catch (e) { /* ignore */ }
    try {
      if (el.datepicker && typeof el.datepicker.destroy === 'function') el.datepicker.destroy();
    } catch (e2) { /* ignore */ }
  }

  function createDynPickerField(id, kind) {
    ensurePickerOverrideStyles();

    var wrap = document.createElement('div');
    wrap.className = 'lb-v2-picker-field';
    wrap.setAttribute('data-picker-kind', kind);

    var shell = document.createElement('div');
    shell.className = 'lb-v2-picker-shell';

    var emptyText = kind === 'time' ? '尚未選擇時間' : '尚未選擇日期';
    var visible = document.createElement('input');
    visible.type = 'text';
    visible.readOnly = true;
    visible.className = 'lb-v2-input lb-v2-picker-visible';
    visible.id = id + '-visible';
    visible.value = emptyText;
    visible.setAttribute('aria-hidden', 'true');
    visible.tabIndex = -1;
    visible.setAttribute('inputmode', 'none');
    visible.style.setProperty('color', '#1a1214', 'important');
    visible.style.setProperty('-webkit-text-fill-color', '#1a1214', 'important');
    visible.style.setProperty('background-color', '#ffffff', 'important');
    visible.style.setProperty('opacity', '1', 'important');
    visible.style.setProperty('caret-color', 'transparent', 'important');
    visible.style.setProperty('pointer-events', 'none', 'important');

    var inp = document.createElement('input');
    inp.type = kind === 'time' ? 'time' : 'date';
    inp.id = id;
    inp.className = 'lb-v2-picker-native';
    inp.required = true;
    if (kind === 'time') inp.step = '60';
    inp.setAttribute('aria-label', kind === 'time' ? '選擇時間' : '選擇日期');
    inp.setAttribute('data-datepicker', 'false');
    inp.setAttribute('data-lb-skip-datepicker', '1');
    neutralizeThemeDatepicker(inp);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lb-v2-btn lb-v2-picker-btn';
    btn.textContent = kind === 'time' ? '選時間' : '選日期';

    function formatDisplay(v) {
      if (!v) return emptyText;
      if (kind === 'date') {
        var m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (m) return m[1] + ' / ' + m[2] + ' / ' + m[3];
      }
      if (kind === 'time') {
        var tm = String(v).match(/^(\d{2}):(\d{2})/);
        if (tm) return tm[1] + ' : ' + tm[2];
      }
      return v;
    }

    function refreshDisplay() {
      var v = String(inp.value || '').trim();
      visible.value = formatDisplay(v);
      if (v) {
        visible.style.setProperty('color', '#1a1214', 'important');
        visible.style.setProperty('-webkit-text-fill-color', '#1a1214', 'important');
        visible.style.setProperty('font-weight', '700', 'important');
        visible.classList.add('is-set');
        visible.classList.remove('is-empty');
      } else {
        visible.style.setProperty('color', '#5c4e52', 'important');
        visible.style.setProperty('-webkit-text-fill-color', '#5c4e52', 'important');
        visible.style.setProperty('font-weight', '500', 'important');
        visible.classList.add('is-empty');
        visible.classList.remove('is-set');
      }
    }

    function setPickerOpen(on) {
      wrap.classList.toggle('is-picker-open', !!on);
      try { document.documentElement.classList.toggle('lb-v2-date-open', !!on); } catch (err) { /* ignore */ }
    }

    function openPicker(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      var want = kind === 'time' ? 'time' : 'date';
      if (inp.type !== want) {
        try { inp.type = want; } catch (err) { /* ignore */ }
      }
      neutralizeThemeDatepicker(inp);
      setPickerOpen(true);
      try { inp.focus(); } catch (errFocus) { /* ignore */ }
      try {
        if (typeof inp.showPicker === 'function') {
          inp.showPicker();
          return;
        }
      } catch (err2) { /* ignore */ }
      try { inp.click(); } catch (err3) { /* ignore */ }
    }

    btn.addEventListener('click', openPicker);
    inp.addEventListener('focus', function () { setPickerOpen(true); });
    inp.addEventListener('click', function () { setPickerOpen(true); });
    inp.addEventListener('change', function () {
      refreshDisplay();
      setPickerOpen(false);
    });
    inp.addEventListener('input', refreshDisplay);
    inp.addEventListener('blur', function () {
      // 系統月曆點日期時常先 blur 再 change；太早解除會讓隔壁欄把點擊吃掉
      setTimeout(function () {
        if (document.activeElement === inp) return;
        setPickerOpen(false);
      }, 500);
    });
    setTimeout(function () { neutralizeThemeDatepicker(inp); }, 0);
    setTimeout(function () { neutralizeThemeDatepicker(inp); }, 400);

    shell.appendChild(visible);
    shell.appendChild(inp);
    wrap.appendChild(shell);
    wrap.appendChild(btn);
    refreshDisplay();
    return wrap;
  }

  function refreshPickerVisible(id) {
    var inp = $(id);
    if (!inp) return;
    var visible = $(id + '-visible');
    if (!visible) return;
    var kind = (inp.type === 'time') ? 'time' : 'date';
    var v = String(inp.value || '').trim();
    if (!v) {
      visible.value = kind === 'time' ? '尚未選擇時間' : '尚未選擇日期';
      visible.classList.add('is-empty');
      visible.classList.remove('is-set');
      return;
    }
    if (kind === 'date') {
      var m = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      visible.value = m ? (m[1] + ' / ' + m[2] + ' / ' + m[3]) : v;
    } else {
      var tm = v.match(/^(\d{2}):(\d{2})/);
      visible.value = tm ? (tm[1] + ' : ' + tm[2]) : v;
    }
    visible.classList.add('is-set');
    visible.classList.remove('is-empty');
  }

  /**
   * End date/time cannot be earlier than start.
   * Uses native min attrs so the calendar hides earlier days.
   */
  function syncEndDateTimeMinFromStart() {
    var startDate = $('lb-v2-listing-start-date');
    var startTime = $('lb-v2-listing-start-time');
    var endDate = $('lb-v2-listing-end-date');
    var endTime = $('lb-v2-listing-end-time');
    if (!endDate || !endTime) return;

    var sd = startDate ? String(startDate.value || '').trim() : '';
    var st = startTime ? String(startTime.value || '').trim().slice(0, 5) : '';
    var ed = String(endDate.value || '').trim();
    var et = String(endTime.value || '').trim().slice(0, 5);

    if (sd) {
      endDate.min = sd;
      if (ed && ed < sd) {
        endDate.value = '';
        endTime.value = '';
        ed = '';
        et = '';
        refreshPickerVisible('lb-v2-listing-end-date');
        refreshPickerVisible('lb-v2-listing-end-time');
      }
    } else {
      endDate.removeAttribute('min');
    }

    if (sd && ed && sd === ed && st) {
      endTime.min = st;
      if (et && et <= st) {
        endTime.value = '';
        refreshPickerVisible('lb-v2-listing-end-time');
      }
    } else {
      endTime.removeAttribute('min');
    }
  }

  function bindCourseDateTimeGuards() {
    if (bindCourseDateTimeGuards._done) return;
    bindCourseDateTimeGuards._done = true;
    ['lb-v2-listing-start-date', 'lb-v2-listing-start-time', 'lb-v2-listing-end-date', 'lb-v2-listing-end-time'].forEach(function (id) {
      var el = $(id);
      if (!el) return;
      el.addEventListener('change', function () {
        syncEndDateTimeMinFromStart();
        updatePolicyExample();
      });
      el.addEventListener('input', function () {
        syncEndDateTimeMinFromStart();
        updatePolicyExample();
      });
    });
    syncEndDateTimeMinFromStart();
  }

  function ensurePickerOverrideStyles() {
    // Modal is moved to document.body, so selectors must cover #lb-v2-modal too.
    var scope = '#lb-v2-root .lb-v2-picker-field, #lb-v2-modal .lb-v2-picker-field, .lb-v2-modal .lb-v2-picker-field';
    var shell = '#lb-v2-root .lb-v2-picker-shell, #lb-v2-modal .lb-v2-picker-shell, .lb-v2-modal .lb-v2-picker-shell';
    var dateShell = '#lb-v2-root .lb-v2-picker-field[data-picker-kind="date"] .lb-v2-picker-shell, #lb-v2-modal .lb-v2-picker-field[data-picker-kind="date"] .lb-v2-picker-shell, .lb-v2-modal .lb-v2-picker-field[data-picker-kind="date"] .lb-v2-picker-shell';
    var timeShell = '#lb-v2-root .lb-v2-picker-field[data-picker-kind="time"] .lb-v2-picker-shell, #lb-v2-modal .lb-v2-picker-field[data-picker-kind="time"] .lb-v2-picker-shell, .lb-v2-modal .lb-v2-picker-field[data-picker-kind="time"] .lb-v2-picker-shell';
    var visible = '#lb-v2-root input.lb-v2-picker-visible, #lb-v2-modal input.lb-v2-picker-visible, .lb-v2-modal input.lb-v2-picker-visible';
    var native = '#lb-v2-root input.lb-v2-picker-native, #lb-v2-modal input.lb-v2-picker-native, .lb-v2-modal input.lb-v2-picker-native';
    var btn = '#lb-v2-root .lb-v2-picker-btn, #lb-v2-modal .lb-v2-picker-btn, .lb-v2-modal .lb-v2-picker-btn';
    var css = [
      // flex + wrap：格子變窄時讓按鈕換行。日期殼不可 min-width:0，
      // 否則「2026 / 08 / 20」會被裁成「2026 / 08 /」。
      scope + '{display:flex!important;flex-wrap:wrap!important;gap:.5rem!important;align-items:stretch!important;width:100%!important}',
      shell + '{position:relative!important;flex:1 1 8rem!important;min-width:0!important}',
      dateShell + '{flex:1 1 12.5rem!important;min-width:12.5rem!important}',
      timeShell + '{flex:1 1 7rem!important;min-width:7rem!important}',
      visible + '{width:100%!important;min-height:48px!important;padding:12px 14px!important;border:1.5px solid rgba(36,24,27,.18)!important;border-radius:12px!important;background:#fff!important;font-size:var(--lbt-body, 17px)!important;line-height:1.45!important;cursor:pointer!important;box-shadow:none!important;opacity:1!important;color:#1a1214!important;-webkit-text-fill-color:#1a1214!important;overflow:visible!important;pointer-events:none!important}',
      visible + '.is-empty{color:#5c4e52!important;-webkit-text-fill-color:#5c4e52!important;font-weight:500!important}',
      visible + '.is-set{color:#1a1214!important;-webkit-text-fill-color:#1a1214!important;font-weight:700!important;border-color:rgba(158,74,90,.35)!important;background:#fffafb!important}',
      // 整格覆蓋：月曆錨在真實尺寸。1px + pointer-events:none 會讓點日期沒反應。
      native + '{position:absolute!important;inset:0!important;left:0!important;top:0!important;width:100%!important;height:100%!important;min-height:48px!important;opacity:0!important;pointer-events:auto!important;border:0!important;margin:0!important;padding:0!important;z-index:3!important;cursor:pointer!important;font-size:16px!important;color-scheme:light!important;-webkit-appearance:none!important;appearance:none!important;background:transparent!important}',
      native + '::-webkit-calendar-picker-indicator{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;margin:0!important;padding:0!important;opacity:0!important;cursor:pointer!important}',
      scope + '.is-picker-open{z-index:10060!important;position:relative!important}',
      // 月曆常蓋住隔壁的時間欄；透明 overlay 會把點擊吃掉，感覺像「按了沒反應」
      'html.lb-v2-date-open .lb-v2-picker-field:not(.is-picker-open){pointer-events:none!important}',
      btn + '{flex:0 0 auto!important;min-height:48px!important;white-space:nowrap!important;padding:12px 16px!important;font-size:var(--lbt-body, 17px)!important;position:relative!important;z-index:4!important}'
    ].join('');
    var style = document.getElementById('lb-v2-picker-style');
    if (style) {
      style.textContent = css;
      return;
    }
    style = document.createElement('style');
    style.id = 'lb-v2-picker-style';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function mountInSlot(slotId, el) {
    var slot = $(slotId);
    if (!slot) return;
    slot.innerHTML = '';
    slot.appendChild(el);
    if (el && el.tagName === 'SELECT') {
      stripThemeSelectWrappers(slot);
      setTimeout(function () { stripThemeSelectWrappers(slot); }, 0);
    }
  }

  // ── Mount all dynamic form elements ───────────────────────
  var dynMounted = false;

  function mountDynamicFormElements() {
    if (dynMounted) return;
    dynMounted = true;

    // Mode select（含 PRIVATE；從「資格限定課」分頁新建時另會鎖定不可改）
    var modeOpts = [
      { value: 'FULL', label: '宣傳刊登（含金流）－平台代收＋開發票' },
      { value: 'EXPOSURE', label: '純上架（消費者自行向廠商購買）' },
      { value: 'PROMO', label: '宣傳刊登（不含金流）－文宣外連，不含票務' },
      { value: 'PRIVATE', label: '資格限定課（僅合格學員可見）' }
    ];
    var modeSel = createDynSelect('lb-v2-listing-mode', modeOpts, 'EXPOSURE', function () {
      applyListingModeUI(modeSel.value);
    });
    mountInSlot('lb-v2-listing-mode-slot', modeSel);

    // Mode filter select
    var filterOpts = [
      { value: '', label: '全部' },
      { value: 'FULL', label: '宣傳刊登（含金流）' },
      { value: 'EXPOSURE', label: '純上架' },
      { value: 'PROMO', label: '宣傳刊登（不含金流）' },
      { value: 'PRIVATE', label: '資格限定課' }
    ];
    var filterSel = createDynSelect('lb-v2-listing-mode-filter', filterOpts, '', function () {
      applyListingModeFilter();
    });
    filterSel.required = false;
    mountInSlot('lb-v2-listing-mode-filter-slot', filterSel);

    // Cancel policy: locked to official platform rule (no vendor select).
    var cpHidden = $('lb-v2-listing-cancel-policy');
    if (cpHidden) cpHidden.value = 'STANDARD';
    var cutoffHidden = $('lb-v2-listing-cutoff-mode');
    if (cutoffHidden) cutoffHidden.value = 'FIXED_TIME';
    var cutoffTimeEl = $('lb-v2-listing-cutoff-time');
    if (cutoffTimeEl) cutoffTimeEl.value = '23:59';
    var minAttEl = $('lb-v2-listing-min-attendees');
    if (minAttEl) {
      minAttEl.addEventListener('input', function () {
        updatePolicyExample();
        refreshAutoNotesPreview();
      });
      minAttEl.addEventListener('change', function () {
        updatePolicyExample();
        refreshAutoNotesPreview();
      });
    }
    var highlightNotesEl = $('lb-v2-listing-highlight-notes');
    if (highlightNotesEl) {
      highlightNotesEl.addEventListener('input', refreshAutoNotesPreview);
      highlightNotesEl.addEventListener('change', refreshAutoNotesPreview);
    }
    // Date + time pickers
    mountInSlot('lb-v2-listing-start-date-slot', createDynPickerField('lb-v2-listing-start-date', 'date'));
    mountInSlot('lb-v2-listing-start-time-slot', createDynPickerField('lb-v2-listing-start-time', 'time'));
    mountInSlot('lb-v2-listing-end-date-slot', createDynPickerField('lb-v2-listing-end-date', 'date'));
    mountInSlot('lb-v2-listing-end-time-slot', createDynPickerField('lb-v2-listing-end-time', 'time'));
    bindCourseDateTimeGuards();

    // Populate category datalist and subcategory checkboxes
    refreshCategoryOptions('');
    refreshSubcategoryOptions('');
    applyCancelPolicyDefaults();
    updateCancelPolicyDetail();
    updatePolicyExample();
  }

  function applyCancelPolicyDefaults() {
    // 開賣到活動的天數由廠商依實際販售日自行填寫，不預設固定數字
  }

  function setCategoryHint(text) {
    var hint = $('lb-v2-listing-category-hint');
    if (hint) hint.textContent = text;
  }

  function refreshCategoryOptions(selectedCategory) {
    var slot = $('lb-v2-listing-category-slot');
    if (!slot) return;

    var opts = [{ value: '', label: '請選擇商品類型' }];
    taxonomyProductTypes.forEach(function (t) {
      opts.push({ value: t, label: t });
    });
    if (selectedCategory && taxonomyProductTypes.indexOf(selectedCategory) === -1) {
      opts.push({ value: selectedCategory, label: selectedCategory + '（舊）' });
    }

    var existing = $('lb-v2-listing-category');
    if (existing && existing.tagName === 'SELECT') {
      existing.innerHTML = '';
      opts.forEach(function (o) {
        var opt = document.createElement('option');
        opt.value = o.value;
        opt.textContent = o.label;
        if (o.value === (selectedCategory || '')) opt.selected = true;
        existing.appendChild(opt);
      });
    } else {
      var sel = createDynSelect('lb-v2-listing-category', opts, selectedCategory || '');
      mountInSlot('lb-v2-listing-category-slot', sel);
    }

    var modeForCat = resolveListingMode((($('lb-v2-listing-mode') || {}).value) || '');
    var catEl = $('lb-v2-listing-category');
    // PRIVATE／PROMO：分類非硬必填（對齊 Excel 匯入與確認上架）。
    if (catEl) catEl.required = modeForCat !== 'PRIVATE' && modeForCat !== 'PROMO';

    if (!taxonomyProductTypes.length) {
      if (!taxonomyLoaded) {
        setCategoryHint(
          modeForCat === 'PRIVATE'
            ? '選填。載入中…資格限定課可不選類型；若選則僅能用店鋪現有類型。'
            : '載入中…僅能選擇店鋪現有類型，不可自行輸入新名詞。'
        );
      } else {
        setCategoryHint(
          modeForCat === 'PRIVATE'
            ? '選填。目前沒有可選商品類型；可不選，或請聯繫官方設定白名單。'
            : '目前沒有可選商品類型。請重新整理，或聯繫官方確認分類白名單。'
        );
      }
    } else if (modeForCat === 'PRIVATE') {
      setCategoryHint(
        '選填（Excel 匯入可不填）。已載入 ' + taxonomyProductTypes.length +
        ' 個現有類型；不選也可儲存／確認上架。'
      );
    } else {
      setCategoryHint(
        '對應 LadyBae「類型」。已載入 ' + taxonomyProductTypes.length +
        ' 個現有類型，請用下拉選單選擇（不可自訂）。'
      );
    }
  }

  function getSelectedCategory() {
    var el = $('lb-v2-listing-category');
    return el ? String(el.value || '').trim() : '';
  }

  function appendSubcategoryCheckbox(parent, title, checked, isLegacy) {
    var lbl = document.createElement('label');
    lbl.className = 'lb-v2-collection-option';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.value = title;
    cb.name = 'lb-v2-subcategory';
    if (checked) cb.checked = true;
    var text = document.createElement('span');
    text.className = 'lb-v2-collection-option__text';
    text.textContent = title + (isLegacy ? '（舊）' : '');
    lbl.appendChild(cb);
    lbl.appendChild(text);
    parent.appendChild(lbl);
  }

  function refreshSubcategoryOptions(selected) {
    var container = $('lb-v2-listing-subcategory-checks');
    if (!container) return;
    var selectedArr = [];
    if (typeof selected === 'string' && selected) {
      selectedArr = selected.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    } else if (Array.isArray(selected)) {
      selectedArr = selected.slice();
    }
    selectedArr = selectedArr.filter(function (s) { return s && !isCityCollectionTitle(s); });
    container.innerHTML = '';
    container.classList.add('lb-v2-checkbox-group--grouped');

    var meta = taxonomyCollectionMeta.length
      ? taxonomyCollectionMeta
      : taxonomyCollections.map(function (t) { return { title: t, handle: '' }; });
    meta = meta.filter(function (item) {
      return item && item.title && !isCityCollectionHandle(item.handle) && !isCityCollectionTitle(item.title);
    });

    if (!meta.length && !taxonomyLoaded) {
      container.textContent = '載入中…';
      return;
    }
    if (!meta.length) {
      container.textContent = '目前沒有可選商品系列';
      return;
    }

    var buckets = groupCollectionMeta(meta);
    var modeElSub = $('lb-v2-listing-mode');
    var isPromoSub = modeElSub && resolveListingMode(modeElSub.value) === 'PROMO';
    // Wall filters / card data-series only index cat-*; keep portal aligned.
    var groupOrder = isPromoSub ? ['cat'] : COLLECTION_GROUP_ORDER;
    if (isPromoSub) {
      // Drop ticket-taxonomy leftovers (mode/class/age/fee/other) when switching into PROMO.
      var promoAllowed = {};
      (buckets.cat || []).forEach(function (item) {
        if (item && item.title) promoAllowed[item.title] = true;
      });
      selectedArr = selectedArr.filter(function (s) { return !!promoAllowed[s]; });
    }
    var knownTitles = {};
    groupOrder.forEach(function (key) {
      var items = buckets[key] || [];
      if (!items.length) return;
      var section = document.createElement('div');
      section.className = 'lb-v2-collection-group';
      section.setAttribute('data-group', key);

      var head = document.createElement('div');
      head.className = 'lb-v2-collection-group__head';
      var titleEl = document.createElement('strong');
      titleEl.textContent = COLLECTION_GROUP_LABELS[key] || key;
      head.appendChild(titleEl);

      var actions = document.createElement('div');
      actions.className = 'lb-v2-collection-group__actions';
      var btnAll = document.createElement('button');
      btnAll.type = 'button';
      btnAll.className = 'lb-v2-collection-group__action';
      btnAll.textContent = '全選';
      btnAll.addEventListener('click', function () {
        section.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          input.checked = true;
        });
      });
      var btnNone = document.createElement('button');
      btnNone.type = 'button';
      btnNone.className = 'lb-v2-collection-group__action';
      btnNone.textContent = '全不選';
      btnNone.addEventListener('click', function () {
        section.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          input.checked = false;
        });
      });
      actions.appendChild(btnAll);
      actions.appendChild(btnNone);
      head.appendChild(actions);
      section.appendChild(head);

      var grid = document.createElement('div');
      grid.className = 'lb-v2-collection-group__grid';
      items.forEach(function (item) {
        knownTitles[item.title] = true;
        appendSubcategoryCheckbox(
          grid,
          item.title,
          selectedArr.indexOf(item.title) !== -1,
          false
        );
      });
      section.appendChild(grid);
      container.appendChild(section);
    });

    var legacy = selectedArr.filter(function (s) { return s && !knownTitles[s]; });
    if (legacy.length) {
      var legacySection = document.createElement('div');
      legacySection.className = 'lb-v2-collection-group';
      var legacyHead = document.createElement('div');
      legacyHead.className = 'lb-v2-collection-group__head';
      var legacyTitle = document.createElement('strong');
      legacyTitle.textContent = '已選（舊項目）';
      legacyHead.appendChild(legacyTitle);
      legacySection.appendChild(legacyHead);
      var legacyGrid = document.createElement('div');
      legacyGrid.className = 'lb-v2-collection-group__grid';
      legacy.forEach(function (s) {
        appendSubcategoryCheckbox(legacyGrid, s, true, true);
      });
      legacySection.appendChild(legacyGrid);
      container.appendChild(legacySection);
    }
  }

  function getSelectedSubcategories() {
    var container = $('lb-v2-listing-subcategory-checks');
    if (!container) return [];
    var checked = container.querySelectorAll('input[type="checkbox"]:checked');
    var arr = [];
    checked.forEach(function (cb) {
      if (cb.value && !isCityCollectionTitle(cb.value)) arr.push(cb.value);
    });
    return arr;
  }

  var CANCEL_POLICY_DETAIL = {
    STANDARD:
      '<p><strong>退費須知</strong></p>' +
      '<p>課程為單堂一次性授課；無法參加者（含個人／健康等因素）依下列規定辦理，無法提供補課及換課。</p>' +
      '<ul class="lb-v2-policy-list">' +
      '<li>於開課日 <strong>3 天前</strong>退費者：扣所繳費用 <strong>10%</strong> 手續費（退還 90%）</li>' +
      '<li>於開課日 <strong>3 天內</strong>提出退費申請：<strong>不予退費</strong></li>' +
      '<li>上述計算以<strong>實際天數</strong>計（含例假日），不以上班日計；判斷基準為開課日 <strong>23:59</strong>（台北）</li>' +
      '<li>天災／政府公告等不可抗力，或未達最低開課人數取消：依平台公告辦理，原則<strong>全額退費</strong></li>' +
      '</ul>'
  };

  function updateCancelPolicyDetail() {
    var box = $('lb-v2-listing-cancel-policy-detail');
    if (!box) return;
    box.innerHTML = CANCEL_POLICY_DETAIL.STANDARD;
  }

  function shiftYmd(ymd, deltaDays) {
    var m = String(ymd || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return '';
    var d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    d.setDate(d.getDate() + deltaDays);
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  /** 把各變數合在同一組例子，讓廠商一次看懂規則怎麼跑 */
  function updatePolicyExample() {
    var box = $('lb-v2-listing-policy-example');
    if (!box) return;

    var cutoffTime = '23:59';
    var minAttRaw = ($('lb-v2-listing-min-attendees') || {}).value;
    var minAtt = parseInt(minAttRaw, 10);
    if (!minAtt || isNaN(minAtt) || minAtt < 0) minAtt = 10;
    var startDate = (($('lb-v2-listing-start-date') || {}).value || '').trim();
    var eventLabel = startDate || '2026-04-04';
    var decideEvalDay = shiftYmd(eventLabel, -3) || '（活動日前第 3 天）';
    var decideDeadline = shiftYmd(eventLabel, -2) || '（活動日前第 2 天）';
    var refundOkDay = shiftYmd(eventLabel, -3) || '活動日前第 3 天';
    var refundNoneDay = shiftYmd(eventLabel, -2) || '活動日前第 2 天';

    box.innerHTML =
      '<p><strong>同一個例子一次講完（目前規則怎麼跑）</strong></p>' +
      '<p>退費天數以開課日 <strong>' + escapeHtml(cutoffTime) + '</strong>（台北）為判斷基準；以實際天數計。</p>' +
      '<p style="margin-top:0.55rem"><strong>假設這堂課：</strong></p>' +
      '<ul class="lb-v2-policy-list">' +
      '<li>活動日：<strong>' + escapeHtml(eventLabel) + '</strong>' + (startDate ? '' : '（範例日；上方開始日期有填會改用實際日期）') + '</li>' +
      '<li>最低開課人數：<strong>' + minAtt + '</strong> 人（以已售出票數計算）</li>' +
      '<li>取消政策：開課前 3 天退 90%；3 天內不退</li>' +
      '</ul>' +
      '<p style="margin-top:0.55rem"><strong>系統實際怎麼跑：</strong></p>' +
      '<ol class="lb-v2-policy-list" style="list-style:decimal;padding-left:1.35rem">' +
      '<li><strong>開課判斷</strong>：<strong>' + escapeHtml(decideEvalDay) + ' 00:00</strong>（台北）起評估是否達 <strong>' + minAtt + '</strong> 人；未達標請於 <strong>' + escapeHtml(decideDeadline) + ' 00:00</strong> 前決策，逾期自動取消並全額退費。</li>' +
      '<li><strong>退費</strong>：以取消當下距離開課日的實際天數判斷，切點用開課日 <strong>' + escapeHtml(cutoffTime) + '</strong>。</li>' +
      '<li>若在 <strong>' + escapeHtml(refundOkDay) + ' ' + escapeHtml(cutoffTime) + '</strong> 前（含當日）取消 → 退 <strong>90%</strong>（扣 10% 手續費）。例：課程費 500 元 → 退 <strong>450</strong> 元。</li>' +
      '<li>若在 <strong>' + escapeHtml(refundNoneDay) + '</strong>、開課日前 1 天或開課當日提出 → <strong>不予退費</strong>。</li>' +
      '</ol>' +
      '<p class="lb-v2-hint" style="margin-top:0.55rem">改「最低人數／開始日期」，這個例子會一起更新。退費門檻與截止時間由平台固定，無法更改。</p>';
  }

  function setModePanelVisible(el, visible) {
    if (!el) return;
    el.hidden = !visible;
    if (visible) {
      el.classList.remove('is-hidden');
      el.style.removeProperty('display');
    } else {
      el.classList.add('is-hidden');
      // sheet 表單 .lb-v2-field 有 display:grid !important，mode-panel 兼 field 時要強制藏。
      el.style.setProperty('display', 'none', 'important');
    }
  }

  function resolveListingMode(mode) {
    var m = String(mode || '').toUpperCase();
    if (m === 'EXPOSURE' || m === 'FULL' || m === 'PROMO' || m === 'PRIVATE') return m;
    // Do not collapse unknown → FULL (mis-routes PRIVATE / legacy values).
    return m || 'EXPOSURE';
  }

  /** When true, listing mode select stays locked to PRIVATE (opened from 資格限定課). */
  var privateModeLocked = false;
  var pendingPrivateListingCreate = false;
  var pendingPrivateListingEditId = null;
  var pendingPrivateListingConfirmAfterLoad = false;
  var pendingPrivateListingEditOpts = null;

  function ensurePrivateModeOption() {
    var modeEl = $('lb-v2-listing-mode');
    if (!modeEl) return;
    var has = false;
    Array.prototype.forEach.call(modeEl.options, function (o) {
      if (o.value === 'PRIVATE') has = true;
    });
    if (!has) {
      var opt = document.createElement('option');
      opt.value = 'PRIVATE';
      opt.textContent = '資格限定課（僅合格學員可見）';
      modeEl.appendChild(opt);
    }
  }

  function removePrivateModeOptionIfUnlocked() {
    // PRIVATE 常駐於模式下拉（與額度卡一致）；解鎖時只恢復可選，不再移除選項。
    if (privateModeLocked) return;
    var modeEl = $('lb-v2-listing-mode');
    if (!modeEl) return;
    ensurePrivateModeOption();
    modeEl.disabled = false;
  }

  function setListingModePrivateLocked(locked) {
    privateModeLocked = !!locked;
    var modeEl = $('lb-v2-listing-mode');
    if (!modeEl) return;
    if (privateModeLocked) {
      ensurePrivateModeOption();
      modeEl.value = 'PRIVATE';
      modeEl.disabled = true;
      applyListingModeUI('PRIVATE');
    } else {
      modeEl.disabled = false;
      removePrivateModeOptionIfUnlocked();
    }
  }

  function setFieldVisibleById(id, visible) {
    var el = $(id);
    if (!el) return;
    var field = el.closest ? el.closest('.lb-v2-field, .lb-v2-row') : el.parentElement;
    if (!field) field = el;
    field.hidden = !visible;
    // sheet 表單有 display:grid !important，必須用 important 才能真藏。
    if (visible) {
      field.style.removeProperty('display');
    } else {
      field.style.setProperty('display', 'none', 'important');
    }
  }

  /** Mirror backend buildAutoHighlightNotes (FULL/PRIVATE → 宣傳刊登（含金流）文案；EXPOSURE → 純上架). */
  function buildAutoHighlightNotesPreview(mode, minAttendees) {
    var notes = [];
    var min = Number(minAttendees);
    if (Number.isFinite(min) && min > 0) {
      notes.push(
        '開課人數：' + Math.round(min) + ' 人即開班（若未達開課門檻，將於課前通知取消或改期）'
      );
    }
    var resolved = resolveListingMode(mode);
    // PRIVATE uses FULL-like payment copy on product page.
    if (resolved === 'EXPOSURE') {
      notes.push('報名費請向廠商付款，LadyBae 僅提供 $0 名額登記；發票由廠商開立。');
    } else {
      notes.push(
        '本活動於 LadyBae 線上結帳付款；付款完成後即可使用報名 QR。發票依平台／訂單規則開立。'
      );
    }
    return notes;
  }

  function refreshAutoNotesPreview() {
    var box = $('lb-v2-listing-notes-preview');
    var list = $('lb-v2-listing-notes-preview-list') || $('lb-v2-listing-auto-notes-list');
    if (!list) return;
    var mode = resolveListingMode((($('lb-v2-listing-mode') || {}).value) || 'EXPOSURE');
    if (mode === 'PROMO') {
      list.innerHTML = '';
      if (box) box.hidden = true;
      return;
    }
    if (box) box.hidden = false;
    var minRaw = (($('lb-v2-listing-min-attendees') || {}).value || '').trim();
    var autoNotes = buildAutoHighlightNotesPreview(mode, minRaw === '' ? 0 : parseInt(minRaw, 10) || 0);
    var customNotes = String((($('lb-v2-listing-highlight-notes') || {}).value) || '')
      .replace(/\r\n/g, '\n')
      .split('\n')
      .map(function (line) { return line.trim(); })
      .filter(Boolean)
      .slice(0, 10);
    var html = autoNotes
      .map(function (n) {
        return '<li class="is-auto">' + escapeHtml(n) + '</li>';
      })
      .join('');
    html += customNotes
      .map(function (n) {
        return '<li>' + escapeHtml(n.slice(0, 200)) + '</li>';
      })
      .join('');
    list.innerHTML = html;
  }

  /** 講師／主辦／協辦／月曆顏色：僅資格限定課（PRIVATE）顯示。 */
  function setPrivateHostFieldsVisible(visible) {
    var row = document.querySelector('.lb-v2-listing-host-fields');
    if (row) {
      row.hidden = !visible;
      if (visible) {
        row.style.removeProperty('display');
      } else {
        // 蓋過 sheet／手機 CSS 的 display:flex !important
        row.style.setProperty('display', 'none', 'important');
      }
    } else {
      setFieldVisibleById('lb-v2-listing-instructor', visible);
      setFieldVisibleById('lb-v2-listing-organizer', visible);
      setFieldVisibleById('lb-v2-listing-co-organizer', visible);
    }
    var colorField = $('lb-v2-listing-cal-color-field');
    if (colorField) {
      colorField.hidden = !visible;
      if (visible) {
        colorField.style.removeProperty('display');
        mountCalSwatches(
          'lb-v2-listing-cal-swatches',
          'lb-v2-listing-calendar-color',
          readCalSwatchValue('lb-v2-listing-calendar-color')
        );
      } else {
        colorField.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function setPromoTicketFieldsVisible(showTicketFields) {
    // Category stays system-fixed for PROMO; series + desc images stay available.
    setFieldVisibleById('lb-v2-listing-category-slot', showTicketFields);
    setFieldVisibleById('lb-v2-listing-subcategory-checks', true);
    // PROMO 也要課程起迄（近期課程／總覽／日曆）；僅藏票務／場地欄。
    setFieldVisibleById('lb-v2-listing-start-date-slot', true);
    setFieldVisibleById('lb-v2-listing-end-date-slot', true);
    setFieldVisibleById('lb-v2-listing-venue', showTicketFields);
    setFieldVisibleById('lb-v2-listing-address-rows', showTicketFields);
    setFieldVisibleById('lb-v2-listing-maps-url', showTicketFields);
    setFieldVisibleById('lb-v2-listing-variants', showTicketFields);
    setFieldVisibleById('lb-v2-listing-add-variant', showTicketFields);
    /* of106: 說明圖片欄已移除 */
    var addVar = $('lb-v2-listing-add-variant');
    if (addVar) addVar.hidden = !showTicketFields;
    [
      'lb-v2-listing-start-date',
      'lb-v2-listing-start-time',
      'lb-v2-listing-end-date',
      'lb-v2-listing-end-time',
    ].forEach(function (pid) {
      var pEl = $(pid);
      if (!pEl) return;
      pEl.required = true;
    });
    var startLabel = document.querySelector('label[for="lb-v2-listing-start-date"]');
    var endLabel = document.querySelector('label[for="lb-v2-listing-end-date"]');
    if (startLabel) startLabel.textContent = showTicketFields ? '開課開始時間 *' : '課程開始 *';
    if (endLabel) endLabel.textContent = showTicketFields ? '開課結束時間 *' : '課程結束 *';
    var citiesLabel = document.querySelector('#lb-v2-listing-cities') &&
      document.querySelector('#lb-v2-listing-cities').closest('.lb-v2-field') &&
      document.querySelector('#lb-v2-listing-cities').closest('.lb-v2-field').querySelector('label');
    if (citiesLabel) {
      citiesLabel.textContent = showTicketFields ? '開課縣市（可多選）*' : '露出縣市（可多選）*';
    }
    var citiesHint = document.querySelector('#lb-v2-listing-cities') &&
      document.querySelector('#lb-v2-listing-cities').closest('.lb-v2-field') &&
      document.querySelector('#lb-v2-listing-cities').closest('.lb-v2-field').querySelector('.lb-v2-hint');
    if (citiesHint) {
      citiesHint.textContent = showTicketFields
        ? '請勾選實際開課縣市（逛課篩選用）。每勾一個縣市，下方會多一列地址（前綴自動帶入，只需填區／路／號）。'
        : '請勾選露出縣市（逛課篩選用）。僅需勾選，不必填專用連結；商品內頁也不會列出縣市。';
    }
    var titleLabel = document.querySelector('label[for="lb-v2-listing-title"]');
    if (titleLabel) titleLabel.textContent = showTicketFields ? '課程名稱 *' : '宣傳主題 *';
    var descLabel = document.querySelector('label[for="lb-v2-listing-desc"]');
    if (descLabel) descLabel.textContent = '活動介紹';
    var descHint = document.querySelector('label[for="lb-v2-listing-desc"]') &&
      document.querySelector('label[for="lb-v2-listing-desc"]').closest('.lb-v2-field') &&
      document.querySelector('label[for="lb-v2-listing-desc"]').closest('.lb-v2-field').querySelector('.lb-v2-hint');
    if (descHint) {
      descHint.textContent = showTicketFields
        ? '寫給消費者看的內容：對象、需自備物品、注意事項。上架後會出現在商品頁「活動介紹」；下方時間／地點／費用會組成「課程說明」，另有「重點備註」。'
        : '寫給消費者看的內容。上架後會以與含金流相同的「活動介紹」卡片呈現在宣傳商品頁。';
    }
    var subLabel = $('lb-v2-listing-subcategory-label') ||
      (document.querySelector('#lb-v2-listing-subcategory-checks') &&
        document.querySelector('#lb-v2-listing-subcategory-checks').closest('.lb-v2-field') &&
        document.querySelector('#lb-v2-listing-subcategory-checks').closest('.lb-v2-field').querySelector('label'));
    if (subLabel) {
      var modeNow = resolveListingMode((($('lb-v2-listing-mode') || {}).value) || '');
      if (modeNow === 'PRIVATE') {
        subLabel.textContent = '商品系列（選填）';
      } else {
        subLabel.textContent = showTicketFields ? '商品系列（可多選）*' : '主題系列（選填，cat-*）';
      }
    }
  }

  function syncCityCtaRows() {
    var host = $('lb-v2-listing-city-cta-rows');
    if (!host) return;
    var modeEl = $('lb-v2-listing-mode');
    if (!modeEl || resolveListingMode(modeEl.value) !== 'PROMO') {
      host.innerHTML = '';
      return;
    }
    var prev = {};
    host.querySelectorAll('input[data-city-cta]').forEach(function (inp) {
      prev[inp.getAttribute('data-city-cta')] = inp.value || '';
    });
    var checked = [];
    document.querySelectorAll('input[name="lb-v2-city"]:checked').forEach(function (el) {
      checked.push(el.value);
    });
    if (!checked.length) {
      host.innerHTML = '<p class="lb-v2-hint">請先勾選露出縣市</p>';
      return;
    }
    host.innerHTML = checked.map(function (code) {
      var label = code;
      CITY_OPTIONS.forEach(function (c) {
        if (c.code === code) label = c.label;
      });
      var val = prev[code] || '';
      return '<div class="lb-v2-field" style="margin-bottom:0.45rem">' +
        '<label>' + escapeHtml(label) + ' 專用連結</label>' +
        '<input type="url" class="lb-v2-input" data-city-cta="' + escapeHtml(code) +
        '" placeholder="空白＝用預設連結" value="' + escapeHtml(val) + '">' +
        '</div>';
    }).join('');
  }

  function readCityCtaUrls() {
    var out = {};
    document.querySelectorAll('input[data-city-cta]').forEach(function (inp) {
      var code = inp.getAttribute('data-city-cta');
      var url = String(inp.value || '').trim();
      // Only store city CTA urls with a valid http/https scheme (match default PROMO url rule).
      if (code && url && /^https?:\/\//i.test(url)) out[code] = url;
    });
    return out;
  }

  function applyListingModeUI(mode) {
    var resolved = resolveListingMode(mode);
    var isExposure = resolved === 'EXPOSURE';
    var isFull = resolved === 'FULL';
    var isPromo = resolved === 'PROMO';
    var isPrivate = resolved === 'PRIVATE';
    var isFullLike = isFull || isPrivate;
    setModePanelVisible($('lb-v2-listing-fee-notice'), true);
    setModePanelVisible($('lb-v2-listing-exposure-flow-hint'), isExposure);
    setModePanelVisible($('lb-v2-listing-external-url-wrap'), isExposure || isPromo);
    setModePanelVisible($('lb-v2-listing-city-cta-wrap'), false);
    setModePanelVisible($('lb-v2-listing-promo-hint'), isPromo);
    setModePanelVisible($('lb-v2-listing-course-rules-wrap'), isExposure || isFullLike);
    setModePanelVisible($('lb-v2-listing-course-rules-hint-full'), isFull || isPrivate);
    setModePanelVisible($('lb-v2-listing-course-rules-hint-exposure'), isExposure);
    setModePanelVisible($('lb-v2-listing-cancel-policy-wrap'), isFullLike);
    setModePanelVisible($('lb-v2-listing-full-hint'), isFull);
    setModePanelVisible($('lb-v2-listing-variants-hint'), isExposure);
    setPromoTicketFieldsVisible(!isPromo);
    setPrivateHostFieldsVisible(isPrivate);
    setFieldVisibleById('lb-v2-listing-highlight-notes', !isPromo);
    refreshAutoNotesPreview();

    // PRIVATE always needs exposure window (status-only auto shelf; no slot wall).
    var exposureWrapMode = $('lb-v2-listing-exposure-wrap');
    if (exposureWrapMode && isPrivate) {
      exposureWrapMode.hidden = false;
      var slotTitlePrivate = $('lb-v2-listing-exposure-slot-title');
      if (slotTitlePrivate) {
        slotTitlePrivate.textContent = '資格限定課曝光檔期（自動上下架；不上公開牆）';
      }
    }

    var urlLabel = $('lb-v2-listing-external-url-label');
    var urlHint = $('lb-v2-listing-external-url-hint');
    var urlInput = $('lb-v2-listing-external-url');
    if (isPromo) {
      if (urlLabel) urlLabel.textContent = '預設前往連結 *';
      if (urlHint) urlHint.textContent = '消費者點擊後前往的官網／活動頁（http/https）。';
      if (urlInput) urlInput.placeholder = 'https://example.com/your-promo';
    } else {
      if (urlLabel) urlLabel.textContent = '外部購票連結（消費者實際付款處）*';
      if (urlHint) urlHint.textContent = '請填消費者真正付錢的頁面（自家官網／Accupass 等）。';
      if (urlInput) urlInput.placeholder = 'https://book.example.com/your-course';
    }

    if (isFullLike) {
      updateCancelPolicyDetail();
      updatePolicyExample();
    }

    var idEl = $('lb-v2-listing-id');
    var hasId = idEl && idEl.value;
    if (!hasId) {
      var feeAmtEl = $('lb-v2-listing-fee-amount');
      var feeStatusEl = $('lb-v2-listing-fee-status-text');
      if (feeAmtEl && (feeAmtEl.textContent === '—' || !feeAmtEl.textContent.trim())) {
        feeAmtEl.textContent = '儲存草稿後帶入';
      }
      if (feeStatusEl && (feeStatusEl.textContent === '—' || !feeStatusEl.textContent.trim())) {
        feeStatusEl.textContent = '待付款';
        feeStatusEl.setAttribute('data-fee-status', 'PENDING');
      }
    }

    syncCityCtaRows();
    refreshSubcategoryOptions(getSelectedSubcategories());
    refreshListingEntitlementUI(resolved);

    var catLabel = $('lb-v2-listing-category-label') ||
      document.querySelector('label[for="lb-v2-listing-category"]') ||
      (document.querySelector('#lb-v2-listing-category-slot') &&
        document.querySelector('#lb-v2-listing-category-slot').closest('.lb-v2-field') &&
        document.querySelector('#lb-v2-listing-category-slot').closest('.lb-v2-field').querySelector('label'));
    if (catLabel && !isPromo) {
      catLabel.textContent = isPrivate ? '商品類型（選填）' : '商品類型 *';
    }
    var subLabelMode = $('lb-v2-listing-subcategory-label') ||
      (document.querySelector('#lb-v2-listing-subcategory-checks') &&
        document.querySelector('#lb-v2-listing-subcategory-checks').closest('.lb-v2-field') &&
        document.querySelector('#lb-v2-listing-subcategory-checks').closest('.lb-v2-field').querySelector('label'));
    if (subLabelMode && !isPromo) {
      subLabelMode.textContent = isPrivate ? '商品系列（選填）' : '商品系列（可複選）*';
    }
    var catElMode = $('lb-v2-listing-category');
    if (catElMode) catElMode.required = !isPrivate && !isPromo;
    var addrHint = $('lb-v2-listing-address-hint');
    if (addrHint) {
      addrHint.textContent = isPrivate
        ? '有完整地址即可（與 Excel 匯入相同）。多縣市可分列；拆不出來也不影響儲存／上架。'
        : '多縣市時每列各自組成完整地址，儲存後以換行合併；消費者會看到全部地址。';
    }
    var formHeadHint = $('lb-v2-listing-form-head-hint');
    if (formHeadHint) {
      formHeadHint.innerHTML = isPrivate
        ? '資格限定課硬必填：標題、課期、曝光起迄、縣市、地址、票種。分類／系列／圖片為選填（對齊 Excel 匯入）。'
        : '請依畫面提示填寫。帶 <strong>*</strong> 為必填；分類請用下拉選，不要自行發明名稱。宣傳刊登（含金流）／資格限定課之退費規則由平台固定，無法自訂。';
    }
    var actionsHint = $('lb-v2-listing-actions-hint');
    if (actionsHint) {
      actionsHint.textContent = isPrivate
        ? '請先儲存草稿，成功後再按「預覽並上架」確認內容。'
        : '請先儲存草稿，成功後再按「預覽並送審」確認內容。';
    }
    var submitReviewBtn = $('lb-v2-listing-submit-review');
    if (submitReviewBtn) {
      submitReviewBtn.textContent = isPrivate ? '預覽並上架' : '預覽並送審';
    }
  }

  /**
   * Build ISO datetime from picker values as Asia/Taipei wall clock.
   * Bare "YYYY-MM-DDTHH:mm" is treated as UTC on DO Node → displayed as +8h (15:00→23:00).
   */
  function taipeiDateTimeIso(dateYmd, timeHm) {
    var d = String(dateYmd || '').trim();
    var t = String(timeHm || '').trim().slice(0, 5);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(d) || !/^\d{2}:\d{2}$/.test(t)) return '';
    return d + 'T' + t + ':00+08:00';
  }

  function readDateTimePair(dateId, timeId) {
    var d = ($(dateId) || {}).value || '';
    var t = ($(timeId) || {}).value || '';
    if (!d || !t) return '';
    return taipeiDateTimeIso(d, t);
  }

  function writeDateTimePair(dateId, timeId, value) {
    if (!value) {
      var dEl = $(dateId); if (dEl) { dEl.value = ''; dEl.dispatchEvent(new Event('change')); }
      var tEl = $(timeId); if (tEl) { tEl.value = ''; tEl.dispatchEvent(new Event('change')); }
      return;
    }
    var s = String(value).trim();
    // Naive local wall clock (legacy saves / picker echo) — use date/time as-is.
    var naive = s.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2})(?::\d{2})?$/);
    if (naive) {
      var dEl2 = $(dateId); if (dEl2) { dEl2.value = naive[1]; dEl2.dispatchEvent(new Event('change')); }
      var tEl2 = $(timeId); if (tEl2) { tEl2.value = naive[2]; tEl2.dispatchEvent(new Event('change')); }
      return;
    }
    // ISO with Z / offset → Taipei calendar + clock for the pickers
    var dt = new Date(s);
    if (isNaN(dt.getTime())) return;
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Taipei',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(dt);
    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    var ymd = (map.year || '') + '-' + (map.month || '') + '-' + (map.day || '');
    var hm = (map.hour || '00') + ':' + (map.minute || '00');
    if (hm === '24:00') hm = '00:00';
    var dEl3 = $(dateId); if (dEl3) { dEl3.value = ymd; dEl3.dispatchEvent(new Event('change')); }
    var tEl3 = $(timeId); if (tEl3) { tEl3.value = hm; tEl3.dispatchEvent(new Event('change')); }
  }

  function clearDateTimeInputs() {
    writeDateTimePair('lb-v2-listing-start-date', 'lb-v2-listing-start-time', '');
    writeDateTimePair('lb-v2-listing-end-date', 'lb-v2-listing-end-time', '');
    var expStart = $('lb-v2-listing-exposure-start');
    var expEnd = $('lb-v2-listing-exposure-end');
    if (expStart) expStart.value = '';
    if (expEnd) expEnd.value = '';
    syncExposureDateDisplays();
    var exposureWrap = $('lb-v2-listing-exposure-wrap');
    if (exposureWrap) exposureWrap.hidden = true;
  }

  function renderCityCheckboxes() {
    var host = $('lb-v2-listing-cities');
    if (!host) return;
    var checked = {};
    host.querySelectorAll('input[name="lb-v2-city"]:checked').forEach(function (el) {
      checked[el.value] = true;
    });
    host.innerHTML = CITY_OPTIONS.map(function (c) {
      return '<label><input type="checkbox" name="lb-v2-city" value="' +
        escapeHtml(c.code) + '"' + (checked[c.code] ? ' checked' : '') +
        '> ' + escapeHtml(c.label) + '</label>';
    }).join('');
    host.dataset.ready = '1';
    host.querySelectorAll('input[name="lb-v2-city"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        syncCityCtaRows();
      });
    });
    syncCityCtaRows();
  }

  var cityTaxonomyLoaded = false;
  var cityTaxonomyInFlight = null;

  async function loadCityTaxonomyOptions() {
    if (cityTaxonomyLoaded) return;
    if (cityTaxonomyInFlight) return cityTaxonomyInFlight;
    cityTaxonomyInFlight = (async function () {
      try {
        var res = await fetch(PATHS.listingCityTaxonomy, {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        var payload = null;
        try { payload = await res.json(); } catch (e) { payload = null; }
        if (payload && payload.ok && Array.isArray(payload.cities) && payload.cities.length) {
          CITY_OPTIONS = payload.cities.map(function (c) {
            return { code: String(c.code || ''), label: String(c.label || c.code || '') };
          }).filter(function (c) { return c.code; });
          cityTaxonomyLoaded = true;
          var host = $('lb-v2-listing-cities');
          if (host) {
            host.dataset.ready = '0';
            renderCityCheckboxes();
            syncAddressPrefixUI();
          }
        }
      } catch (e) {
        /* keep fallback CITY_OPTIONS */
      } finally {
        cityTaxonomyInFlight = null;
      }
    })();
    return cityTaxonomyInFlight;
  }

  function ensureCityCheckboxes() {
    var host = $('lb-v2-listing-cities');
    if (!host) return;
    if (host.dataset.ready !== '1') {
      renderCityCheckboxes();
    }
    if (host.dataset.prefixBound !== '1') {
      host.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || t.name !== 'lb-v2-city') return;
        var code = t.value;
        if (t.checked) {
          if (cityCheckOrder.indexOf(code) === -1) cityCheckOrder.push(code);
        } else {
          cityCheckOrder = cityCheckOrder.filter(function (c) { return c !== code; });
          delete addressRestByCity[code];
        }
        syncAddressRowsUI();
      });
      host.dataset.prefixBound = '1';
    }
  }

  function collectCityCodes() {
    ensureCityCheckboxes();
    var host = $('lb-v2-listing-cities');
    if (!host) return [];
    var checked = {};
    Array.prototype.slice.call(host.querySelectorAll('input[name="lb-v2-city"]:checked'))
      .forEach(function (el) { checked[el.value] = true; });
    // Prefer check-order for stability of primary; append any checked not in order.
    var ordered = cityCheckOrder.filter(function (c) { return checked[c]; });
    Object.keys(checked).forEach(function (c) {
      if (ordered.indexOf(c) === -1) ordered.push(c);
    });
    cityCheckOrder = ordered.slice();
    return ordered;
  }

  function setCityCodes(codes) {
    ensureCityCheckboxes();
    var host = $('lb-v2-listing-cities');
    if (!host) return;
    var list = Array.isArray(codes) ? codes.map(String) : [];
    var set = {};
    list.forEach(function (c) { set[c] = true; });
    host.querySelectorAll('input[name="lb-v2-city"]').forEach(function (el) {
      el.checked = !!set[el.value];
    });
    cityCheckOrder = list.filter(function (c) { return set[c]; });
    Object.keys(addressRestByCity).forEach(function (code) {
      if (!set[code]) delete addressRestByCity[code];
    });
    syncAddressRowsUI();
  }

  function cityLabelForCode(code) {
    for (var i = 0; i < CITY_OPTIONS.length; i++) {
      if (CITY_OPTIONS[i].code === code) return CITY_OPTIONS[i].label;
    }
    return code;
  }

  function labelVariants(label) {
    var out = [label];
    var a = label.replace(/臺/g, '台');
    var b = label.replace(/台/g, '臺');
    if (a !== label) out.push(a);
    if (b !== label && out.indexOf(b) === -1) out.push(b);
    return out;
  }

  /** Match leading city label on one address line; returns { code, label, rest }. */
  function matchCityPrefixOnLine(line, preferredCodes) {
    var raw = String(line || '').trim();
    if (!raw) return null;
    var candidates = [];
    var preferred = Array.isArray(preferredCodes) ? preferredCodes : [];
    preferred.forEach(function (code) {
      labelVariants(cityLabelForCode(code)).forEach(function (lb) {
        candidates.push({ code: code, label: lb });
      });
    });
    CITY_OPTIONS.forEach(function (c) {
      labelVariants(c.label).forEach(function (lb) {
        var dup = false;
        for (var i = 0; i < candidates.length; i++) {
          if (candidates[i].label === lb) { dup = true; break; }
        }
        if (!dup) candidates.push({ code: c.code, label: lb });
      });
    });
    candidates.sort(function (a, b) { return b.label.length - a.label.length; });
    for (var j = 0; j < candidates.length; j++) {
      var hit = candidates[j];
      if (raw.indexOf(hit.label) === 0) {
        return {
          code: hit.code,
          label: hit.label,
          rest: raw.slice(hit.label.length).replace(/^[，,\s]+/, ''),
        };
      }
    }
    return null;
  }

  /** If rest starts with a different city label than own city, return that label. */
  function conflictingCityPrefixInRest(rest, ownCityLabel) {
    var raw = String(rest || '').trim();
    if (!raw || !ownCityLabel) return '';
    var ownSet = {};
    labelVariants(ownCityLabel).forEach(function (lb) { ownSet[lb] = true; });
    var candidates = [];
    CITY_OPTIONS.forEach(function (c) {
      labelVariants(c.label).forEach(function (lb) { candidates.push(lb); });
    });
    candidates.sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < candidates.length; i++) {
      var lb = candidates[i];
      if (raw.indexOf(lb) === 0) {
        if (ownSet[lb]) return '';
        return lb;
      }
    }
    return '';
  }

  function readAddressRestsFromDom() {
    var root = $('lb-v2-listing-address-rows');
    if (!root) return;
    Array.prototype.slice.call(root.querySelectorAll('input.lb-v2-listing-address-rest')).forEach(function (el) {
      var code = el.getAttribute('data-city-code');
      if (!code) return;
      addressRestByCity[code] = String(el.value || '');
    });
  }

  function composeListingAddress() {
    readAddressRestsFromDom();
    var codes = collectCityCodes();
    var lines = [];
    codes.forEach(function (code) {
      var prefix = cityLabelForCode(code);
      var rest = String(addressRestByCity[code] || '').trim();
      if (!rest) return;
      var ownVars = labelVariants(prefix);
      for (var i = 0; i < ownVars.length; i++) {
        if (rest.indexOf(ownVars[i]) === 0) {
          rest = rest.slice(ownVars[i].length).replace(/^[，,\s]+/, '');
          break;
        }
      }
      if (!rest) return;
      lines.push(prefix + rest);
    });
    return lines.join('\n');
  }

  function syncAddressRowsUI() {
    var root = $('lb-v2-listing-address-rows');
    if (!root) return;
    readAddressRestsFromDom();
    var codes = collectCityCodes();
    Object.keys(addressRestByCity).forEach(function (code) {
      if (codes.indexOf(code) === -1) delete addressRestByCity[code];
    });
    if (!codes.length) {
      root.innerHTML = '<p class="lb-v2-hint lb-v2-address-rows__empty">請先勾選開課縣市</p>';
      var emptyHidden = $('lb-v2-listing-address');
      if (emptyHidden) emptyHidden.value = '';
      return;
    }
    root.innerHTML = codes.map(function (code, idx) {
      var name = escapeHtml(cityLabelForCode(code));
      var rest = escapeHtml(String(addressRestByCity[code] || ''));
      var placeholder = idx === 0 ? '例：大安區忠孝東路四段〇〇號' : '例：區／路／號';
      return (
        '<div class="lb-v2-address-compose" data-city-code="' + escapeHtml(code) + '">' +
          '<span class="lb-v2-address-prefix" title="' + name + '">' + name + '</span>' +
          '<input type="text" class="lb-v2-input lb-v2-listing-address-rest" data-city-code="' +
            escapeHtml(code) +
            '" value="' + rest +
            '" placeholder="' + placeholder +
            '" autocomplete="street-address" aria-label="' + name + ' 地址">' +
        '</div>'
      );
    }).join('');
    if (root.dataset.rowsBound !== '1') {
      root.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || !t.classList || !t.classList.contains('lb-v2-listing-address-rest')) return;
        var code = t.getAttribute('data-city-code');
        if (code) addressRestByCity[code] = String(t.value || '');
        var h = $('lb-v2-listing-address');
        if (h) h.value = composeListingAddress();
      });
      root.dataset.rowsBound = '1';
    }
    var hidden = $('lb-v2-listing-address');
    if (hidden) hidden.value = composeListingAddress();
  }

  /** Alias kept for older call sites. */
  function syncAddressPrefixUI() {
    syncAddressRowsUI();
  }

  function applyAddressFromListing(fullAddress, cityCodes) {
    var addr = String(fullAddress || '').trim();
    addressRestByCity = {};
    var codes = Array.isArray(cityCodes) && cityCodes.length
      ? cityCodes.map(String)
      : collectCityCodes();
    var lines = addr
      ? addr.split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean)
      : [];

    if (codes.length && lines.length) {
      var used = {};
      lines.forEach(function (line) {
        var match = matchCityPrefixOnLine(line, codes.filter(function (c) { return !used[c]; }));
        if (match && codes.indexOf(match.code) !== -1 && !used[match.code]) {
          used[match.code] = true;
          addressRestByCity[match.code] = match.rest;
          return;
        }
        // Prefer mapping unused preferred codes in order for unmatched lines
        for (var i = 0; i < codes.length; i++) {
          if (!used[codes[i]]) {
            var fallback = matchCityPrefixOnLine(line, [codes[i]]);
            if (fallback && fallback.code === codes[i]) {
              used[codes[i]] = true;
              addressRestByCity[codes[i]] = fallback.rest;
              return;
            }
            // Legacy single blob / no prefix: put on first free city only once
            if (!match) {
              used[codes[i]] = true;
              addressRestByCity[codes[i]] = line;
              return;
            }
            break;
          }
        }
      });
    } else if (codes[0] && addr && !lines.length) {
      var one = matchCityPrefixOnLine(addr, codes);
      addressRestByCity[codes[0]] = one && one.code === codes[0] ? one.rest : addr;
    } else if (codes[0] && lines.length === 1) {
      var only = matchCityPrefixOnLine(lines[0], codes);
      addressRestByCity[codes[0]] = only ? only.rest : lines[0];
    }

    syncAddressRowsUI();
    // Excel／舊資料常是整段地址；若分列拆不出 rest，仍保留原字串供 PRIVATE 儲存。
    var composedAfter = composeListingAddress();
    var hiddenKeep = $('lb-v2-listing-address');
    if (hiddenKeep && addr && !composedAfter) {
      if (codes[0] && !String(addressRestByCity[codes[0]] || '').trim()) {
        var blobLine = lines.length === 1 ? lines[0] : addr.replace(/\r?\n/g, ' ').trim();
        var blobMatch = matchCityPrefixOnLine(blobLine, codes);
        addressRestByCity[codes[0]] = blobMatch && blobMatch.code === codes[0]
          ? blobMatch.rest
          : blobLine;
        syncAddressRowsUI();
      }
      if (!composeListingAddress()) hiddenKeep.value = addr;
    }
  }

  function clearListingForm() {
    setListingFormReadOnly(false);
    lockedWindowCtx = null;
    setListingFormTrackIds(null);
    var idEl = $('lb-v2-listing-id');
    if (idEl) idEl.value = '';
    var modeEl = $('lb-v2-listing-mode');
    if (modeEl) {
      if (privateModeLocked) {
        ensurePrivateModeOption();
        modeEl.value = 'PRIVATE';
        modeEl.disabled = true;
      } else {
        modeEl.disabled = false;
        removePrivateModeOptionIfUnlocked();
        if (canSubmitForMode('EXPOSURE')) modeEl.value = 'EXPOSURE';
        else if (canSubmitForMode('PROMO')) modeEl.value = 'PROMO';
        else if (canSubmitForMode('FULL')) modeEl.value = 'FULL';
        else if (canSubmitForMode('PRIVATE')) modeEl.value = 'PRIVATE';
        else modeEl.value = 'EXPOSURE';
      }
    }
    var feeAmtEl = $('lb-v2-listing-fee-amount');
    var feeStatusEl = $('lb-v2-listing-fee-status-text');
    if (feeAmtEl) feeAmtEl.textContent = '—';
    if (feeStatusEl) feeStatusEl.textContent = '—';
    applyListingModeUI(modeEl ? modeEl.value : 'EXPOSURE');
    ['lb-v2-listing-title', 'lb-v2-listing-desc', 'lb-v2-listing-highlight-notes',
     'lb-v2-listing-venue', 'lb-v2-listing-instructor', 'lb-v2-listing-organizer',
     'lb-v2-listing-co-organizer', 'lb-v2-listing-maps-url',
     'lb-v2-listing-external-url'].forEach(function (eid) {
      var el = $(eid);
      if (el) el.value = '';
    });
    mountCalSwatches(
      'lb-v2-listing-cal-swatches',
      'lb-v2-listing-calendar-color',
      defaultCalSwatchColor()
    );
    addressRestByCity = {};
    cityCheckOrder = [];
    setCityCodes([]);
    syncAddressRowsUI();
    clearDateTimeInputs();
    refreshCategoryOptions('');
    refreshSubcategoryOptions('');
    var cp = $('lb-v2-listing-cancel-policy');
    if (cp) cp.value = 'STANDARD';
    var cutoffMode = $('lb-v2-listing-cutoff-mode');
    if (cutoffMode) cutoffMode.value = 'FIXED_TIME';
    var cutoffTime = $('lb-v2-listing-cutoff-time');
    if (cutoffTime) cutoffTime.value = '23:59';
    var minAtt = $('lb-v2-listing-min-attendees');
    if (minAtt) minAtt.value = '';
    updateCancelPolicyDetail();
    updatePolicyExample();
    var vc = $('lb-v2-listing-variants');
    if (vc) vc.innerHTML = '';
    listingVariantCount = 0;
    addVariantRow('', '', '');
    clearImagePreviews();
    clearDescImagePreviews();
    refreshAutoNotesPreview();
    applySeatHoldHint(null);
  }

  function normalizeListingItem(item) {
    if (!item || typeof item !== 'object') return item;
    var out = Object.assign({}, item);
    if (typeof out.variants_json === 'string') {
      try { out.variants_json = JSON.parse(out.variants_json); } catch (e) { out.variants_json = []; }
    }
    if (!Array.isArray(out.variants_json)) out.variants_json = [];
    if (typeof out.images_json === 'string') {
      try { out.images_json = JSON.parse(out.images_json); } catch (e2) { out.images_json = []; }
    }
    if (typeof out.description_images_json === 'string') {
      try { out.description_images_json = JSON.parse(out.description_images_json); } catch (e3) { out.description_images_json = []; }
    }
    if (!Array.isArray(out.description_images_json)) out.description_images_json = [];
    return out;
  }

  function scrollToListingForm() {
    // 表單只在「上架新課程」分頁顯示；從課程管理按編輯要先把人帶過去。
    if (activeNav !== 'course-new') switchTab('course-new');
    var formSec = $('lb-v2-listing-form-section') || $('lb-v2-listing-form');
    if (formSec && typeof formSec.scrollIntoView === 'function') {
      formSec.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    if (listingFormReadOnly) return;
    var titleEl = $('lb-v2-listing-title');
    if (titleEl && typeof titleEl.focus === 'function') {
      setTimeout(function () { try { titleEl.focus(); } catch (e) { /* ignore */ } }, 350);
    }
  }

  async function loadListingIntoForm(listingId, opts) {
    var slug = getListingVendorSlug();
    if (!slug) {
      showListingAlert('請先選擇單一廠商');
      return;
    }
    var id = parseInt(listingId, 10);
    if (!id) return;

    setDataLoading(true, '載入草稿中…');
    try {
      var res = await fetchAppProxy(PATHS.listingDetail, slug, { listing_id: id });
      var listing = null;
      if (res.ok && res.payload && res.payload.listing) {
        listing = normalizeListingItem(res.payload.listing);
      } else {
        var match = (allListingItems || []).find(function (i) { return Number(i.id) === id; });
        if (match) listing = normalizeListingItem(match);
      }
      if (!listing) {
        showListingAlert((res && res.message) || '找不到此草稿');
        return;
      }
      populateListingForm(listing);
      var editable = isListingEditableStatus(listing.status, listing.listing_mode);
      setListingFormReadOnly(!editable, listing.status);
      scrollToListingForm();
      // 載入成功不再貼提示：課程編號與狀態已顯示在表單頂端。
    } catch (err) {
      showListingAlert(err.message || '載入草稿失敗');
    } finally {
      setDataLoading(false);
    }
  }

  async function fetchListingTicketCount(listingId) {
    var slug = getListingVendorSlug();
    if (!slug || !listingId) return 0;
    try {
      var res = await fetchAppProxy(PATHS.listingDetail, slug, { listing_id: listingId });
      if (res.ok && res.payload && res.payload.active_ticket_count != null) {
        return Math.max(0, Number(res.payload.active_ticket_count) || 0);
      }
    } catch (e) { /* ignore */ }
    return 0;
  }

  function confirmDeleteListing(listingId, title) {
    var id = parseInt(listingId, 10);
    if (!id) return;
    setDataLoading(true, '檢查售票中…');
    fetchListingTicketCount(id).then(function (sold) {
      setDataLoading(false);
      var soldWarn = sold > 0
        ? '<p class="lb-v2-hint" style="margin-top:0.6rem;color:#a61b3f"><strong>提醒：已售出／有效票 ' +
          sold +
          ' 張。</strong>刪除後會下架並封存商品，票務紀錄保留，無法復原上架狀態。</p>'
        : '<p class="lb-v2-hint" style="margin-top:0.6rem">未偵測到有效售票時將永久刪除此課（含商品）。</p>';
      openModal({
        title: sold > 0 ? '刪除／下架課程？' : '刪除課程？',
        bodyHtml:
          '<p class="lb-v2-modal__msg">確定刪除「' + escapeHtml(title || ('#' + id)) + '」？</p>' +
          soldWarn,
        actions: [
          { label: '取消', ghost: true, close: true },
          {
            label: sold > 0 ? '確認下架' : '確認刪除',
            accent: true,
            close: false,
            onClick: function () {
              closeModal();
              deleteListingById(id);
              return false;
            },
          },
        ],
      });
    });
  }

  /**
   * 廣告加購解套母課：檔期／費用保留，回到「建立廣告」待選。
   * @param {{ goCreate?: boolean }} opts goCreate=true 時切到建立廣告分頁
   */
  function confirmDetachAdListing(listingId, title, opts) {
    var id = parseInt(listingId, 10);
    if (!id) return;
    opts = opts || {};
    openModal({
      title: '解套母課？',
      bodyHtml:
        '<p class="lb-v2-modal__msg">確定不要用目前課程套用「' +
        escapeHtml(title || ('#' + id)) +
        '」？</p>' +
        '<p class="lb-v2-hint" style="margin-top:0.55rem">檔期與已付費用會保留，廣告會回到「建立廣告」待選，可再套到其他課程。不會刪除這筆檔期。</p>',
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '確認解套',
          accent: true,
          close: false,
          onClick: function () {
            closeModal();
            detachAdListingById(id, { goCreate: !!opts.goCreate });
            return false;
          },
        },
      ],
    });
  }

  async function detachAdListingById(listingId, opts) {
    opts = opts || {};
    var slug = getListingVendorSlug();
    if (!slug || !listingId) return;
    setDataLoading(true, '解套中…');
    try {
      var res = await postAppProxyJson(PATHS.listingDetachParent, {
        vendor_slug: slug,
        listing_id: listingId,
      });
      if (!res.ok) {
        adsNotice(
          (res.code ? '[' + res.code + '] ' : '') + (res.message || '解套失敗'),
          true
        );
        showListingAlert(
          (res.code ? '[' + res.code + '] ' : '') + (res.message || '解套失敗'),
          '解套失敗'
        );
        return;
      }
      await loadCourseAdsTab(true);
      if (typeof loadListingTab === 'function') {
        try { await loadListingTab(true); } catch (e) { /* ignore */ }
      }
      if (opts.goCreate) {
        if (typeof switchTab === 'function') switchTab('course-ads');
        setCourseAdsView('create');
        adsNotice('已解套：請在「建立廣告」重新選擇要套用的課程與檔期。', false);
      } else {
        adsNotice('已解套：檔期已回到建立廣告待選。', false);
        showListingAlert('已解套母課，檔期回到建立廣告待選。', '已解套');
      }
    } catch (err) {
      adsNotice(err.message || '解套失敗', true);
      showListingAlert(err.message || '解套失敗', '解套失敗');
    } finally {
      setDataLoading(false);
    }
  }

  function formatSeatHoldRange(payload) {
    var start = String((payload && payload.seat_hold_start) || '').slice(0, 10);
    var end = String((payload && payload.seat_hold_end) || '').slice(0, 10);
    if (!start || !end) return '';
    var until = String((payload && payload.seat_hold_until) || '').slice(0, 10);
    return start + ' ～ ' + end + (until ? '（保留至 ' + until + '）' : '');
  }

  /**
   * Unpublish flow. No active tickets → the vendor unpublishes immediately.
   * With tickets → only a request; official approval voids tickets and notifies
   * attendees through the existing course-cancellation flow.
   */
  function confirmUnpublishListing(listingId, title) {
    var id = parseInt(listingId, 10);
    if (!id) return;
    setDataLoading(true, '檢查售票中…');
    fetchListingTicketCount(id).then(function (sold) {
      setDataLoading(false);
      var name = escapeHtml(title || ('#' + id));
      if (sold > 0) {
        openModal({
          title: '申請下架（已有售票）',
          bodyHtml:
            '<p class="lb-v2-modal__msg">「' + name + '」已有 <strong>' + sold + '</strong> 張有效票，無法自行下架。</p>' +
            '<p class="lb-v2-hint" style="margin-top:0.6rem">送出申請後由 LadyBae 官方審核；核准時會作廢票券並通知已報名學員。</p>' +
            '<div class="lb-v2-field" style="margin-top:0.8rem">' +
            '<label for="lb-v2-unpublish-reason">下架原因（必填）</label>' +
            '<textarea id="lb-v2-unpublish-reason" class="lb-v2-input" rows="3" maxlength="500" placeholder="例如：場地臨時無法使用，需改期"></textarea>' +
            '</div>',
          actions: [
            { label: '取消', ghost: true, close: true },
            {
              label: '送出申請',
              accent: true,
              close: false,
              onClick: function () {
                var reasonEl = $('lb-v2-unpublish-reason');
                var reason = reasonEl ? String(reasonEl.value || '').trim() : '';
                if (!reason) {
                  if (reasonEl) reasonEl.focus();
                  return false;
                }
                closeModal();
                requestUnpublishById(id, reason);
                return false;
              },
            },
          ],
        });
        return;
      }
      openModal({
        title: '下架課程？',
        bodyHtml:
          '<p class="lb-v2-modal__msg">確定下架「' + name + '」？</p>' +
          '<p class="lb-v2-hint" style="margin-top:0.6rem">未偵測到有效票。下架後商品會從版位與前台移除，狀態改為<strong>已下架</strong>，' +
          '可再編輯並重新送審。<strong>原曝光檔期會為你保留一段時間</strong>，若新檔期被搶走仍可沿用原檔期。</p>' +
          '<div class="lb-v2-field" style="margin-top:0.8rem">' +
          '<label for="lb-v2-unpublish-reason">下架原因（選填）</label>' +
          '<textarea id="lb-v2-unpublish-reason" class="lb-v2-input" rows="2" maxlength="500" placeholder="例如：需要修改票種與價格"></textarea>' +
          '</div>',
        actions: [
          { label: '取消', ghost: true, close: true },
          {
            label: '確認下架',
            accent: true,
            close: false,
            onClick: function () {
              var reasonEl = $('lb-v2-unpublish-reason');
              var reason = reasonEl ? String(reasonEl.value || '').trim() : '';
              closeModal();
              unpublishListingById(id, reason);
              return false;
            },
          },
        ],
      });
    });
  }

  async function unpublishListingById(listingId, reason) {
    var slug = getListingVendorSlug();
    if (!slug) {
      showListingAlert('請先選擇單一廠商');
      return;
    }
    setDataLoading(true, '下架中…');
    try {
      var res = await postAppProxyJson(PATHS.listingUnpublish, {
        vendor_slug: slug,
        listing_id: listingId,
        reason: reason || undefined,
      });
      if (!res.ok) {
        showListingAlert(res.message || '下架失敗', '下架失敗');
        return;
      }
      await loadListingTab();
      var hold = formatSeatHoldRange(res.payload);
      var warning = (res.payload && res.payload.warning) || '';
      showListingSuccess(
        '#' + listingId + ' 已下架。' +
          (hold ? '原曝光檔期 ' + hold + ' 已為你保留，重新送審時可直接沿用。' : '') +
          (warning ? ' ' + warning : ''),
        '已下架'
      );
    } catch (err) {
      showListingAlert(err.message || '下架失敗');
    } finally {
      setDataLoading(false);
    }
  }

  async function requestUnpublishById(listingId, reason) {
    var slug = getListingVendorSlug();
    if (!slug) {
      showListingAlert('請先選擇單一廠商');
      return;
    }
    setDataLoading(true, '送出申請中…');
    try {
      var res = await postAppProxyJson(PATHS.listingUnpublishRequest, {
        vendor_slug: slug,
        listing_id: listingId,
        reason: reason,
      });
      if (!res.ok) {
        showListingAlert(res.message || '申請失敗', '申請失敗');
        return;
      }
      await loadListingTab();
      showListingSuccess(
        '#' + listingId + ' 下架申請已送出，請等待 LadyBae 官方處理。課程在核准前維持上架。',
        '已送出申請'
      );
    } catch (err) {
      showListingAlert(err.message || '申請失敗');
    } finally {
      setDataLoading(false);
    }
  }

  async function cancelUnpublishRequestById(listingId) {
    var slug = getListingVendorSlug();
    if (!slug) {
      showListingAlert('請先選擇單一廠商');
      return;
    }
    setDataLoading(true, '撤回中…');
    try {
      var res = await postAppProxyJson(PATHS.listingUnpublishRequestCancel, {
        vendor_slug: slug,
        listing_id: listingId,
      });
      if (!res.ok) {
        showListingAlert(res.message || '撤回失敗', '撤回失敗');
        return;
      }
      await loadListingTab();
      showListingSuccess('#' + listingId + ' 下架申請已撤回。', '已撤回');
    } catch (err) {
      showListingAlert(err.message || '撤回失敗');
    } finally {
      setDataLoading(false);
    }
  }

  function renderContentEditPreview() {
    var list = $('lb-v2-content-edit-preview');
    if (!list) return;
    var notesEl = $('lb-v2-content-edit-notes');
    var lines = String((notesEl && notesEl.value) || '')
      .replace(/\r\n/g, '\n')
      .split('\n')
      .map(function (line) { return line.trim(); })
      .filter(Boolean)
      .slice(0, 10);
    list.innerHTML = lines.length
      ? lines.map(function (l) { return '<li>' + escapeHtml(l.slice(0, 200)) + '</li>'; }).join('')
      : '<li class="is-auto">（未填額外備註，商品頁只會顯示系統自動備註）</li>';
  }

  /**
   * Light edit on a live listing: activity intro + highlight notes only. Price,
   * dates, tickets and slot still require unpublish → edit → re-submit, so what
   * buyers already paid for cannot change without review.
   */
  async function openContentEditModal(listingId) {
    var id = parseInt(listingId, 10);
    var slug = getListingVendorSlug();
    if (!id || !slug) return;
    setDataLoading(true, '載入中…');
    var item = null;
    try {
      var res = await fetchAppProxy(PATHS.listingDetail, slug, { listing_id: id });
      if (res.ok && res.payload && res.payload.listing) {
        item = normalizeListingItem(res.payload.listing);
      }
    } catch (e) { /* fall through to alert below */ }
    setDataLoading(false);
    if (!item) {
      showListingAlert('載入課程內容失敗，請稍後再試');
      return;
    }

    openModal({
      wide: true,
      title: '修改內容（免重新審核）',
      bodyHtml:
        '<p class="lb-v2-hint">僅「活動介紹」與「重點備註」可直接修改，儲存後立即更新前台商品頁。' +
        '售價、票種、日期、版位需先<strong>下架</strong>再編輯並重新送審。</p>' +
        '<div class="lb-v2-field" style="margin-top:0.8rem">' +
        '<label for="lb-v2-content-edit-desc">活動介紹</label>' +
        '<textarea id="lb-v2-content-edit-desc" class="lb-v2-input" rows="8" maxlength="5000"></textarea>' +
        '</div>' +
        '<div class="lb-v2-field" style="margin-top:0.8rem">' +
        '<label for="lb-v2-content-edit-notes">重點備註（每行一則，最多 10 則）</label>' +
        '<textarea id="lb-v2-content-edit-notes" class="lb-v2-input" rows="5" maxlength="2000"></textarea>' +
        '</div>' +
        '<div class="lb-v2-listing-notes-preview" style="margin-top:0.6rem">' +
        '<div class="lb-v2-listing-notes-preview__title">你的額外備註預覽</div>' +
        '<p class="lb-v2-hint" style="margin:0 0 0.35rem;">系統自動備註不受影響，會維持在你的備註前面。</p>' +
        '<ul id="lb-v2-content-edit-preview" class="lb-v2-listing-notes-preview__list"></ul>' +
        '</div>',
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '儲存並更新前台',
          accent: true,
          close: false,
          onClick: function () {
            var descEl = $('lb-v2-content-edit-desc');
            var notesEl = $('lb-v2-content-edit-notes');
            var payload = {
              description: descEl ? String(descEl.value || '') : '',
              highlight_notes: notesEl ? String(notesEl.value || '') : '',
            };
            closeModal();
            saveListingContentEdit(id, payload);
            return false;
          },
        },
      ],
    });

    var descEl = $('lb-v2-content-edit-desc');
    if (descEl) descEl.value = String(item.description || '');
    var notesEl = $('lb-v2-content-edit-notes');
    if (notesEl) {
      notesEl.value = String(item.highlight_notes || '');
      notesEl.addEventListener('input', renderContentEditPreview);
    }
    renderContentEditPreview();
  }

  async function saveListingContentEdit(listingId, patch) {
    var slug = getListingVendorSlug();
    if (!slug) return;
    setDataLoading(true, '更新中…');
    try {
      var res = await postAppProxyJson(PATHS.listingContentEdit, {
        vendor_slug: slug,
        listing_id: listingId,
        description: patch.description,
        highlight_notes: patch.highlight_notes,
      });
      if (!res.ok) {
        showListingAlert(res.message || '更新失敗', '更新失敗');
        return;
      }
      await loadListingTab();
      showListingSuccess('#' + listingId + ' 內容已更新，前台商品頁同步完成。', '已更新');
    } catch (err) {
      showListingAlert(err.message || '更新失敗');
    } finally {
      setDataLoading(false);
    }
  }

  // ── 廣告版位加購表單 ─────────────────────────────────────
  // 只問三件事：版位方案、廣告檔期、要不要換廣告圖。課程內容一律沿用母課。

  // 只是尚未取得 API 回應前的暫定值。後端的 MIN_EXPOSURE_LEAD_DAYS 才是權威，
  // 版位可用性 API 會在回應裡帶 min_lead_days。
  var SLOT_ADDON_MIN_LEAD_DAYS = 5;

  /**
   * 採用 API 回報的最少前置天數，取不到才退回暫定值。
   * 不可寫成 `api || fallback`：PRIVATE 版位的合法回應就是 0，會被 || 換成 5，
   * 讓月曆把後端其實接受的日期畫成不可選。
   */
  function resolveMinLeadDays(apiValue, fallback) {
    var n = Number(apiValue);
    if (Number.isFinite(n) && n >= 0) return n;
    var f = Number(fallback);
    return Number.isFinite(f) && f >= 0 ? f : SLOT_ADDON_MIN_LEAD_DAYS;
  }

  /**
   * 目前課程的上架費狀態（enum，非畫面文字）。
   * 這個值由 renderListing 寫進 data-fee-status；比對中文標籤會在文案調整時
   * 靜默失效，而失效方向可能是「該擋的沒擋」。
   */
  function currentListingFeeStatus() {
    var el = $('lb-v2-listing-fee-status-text');
    return el ? String(el.getAttribute('data-fee-status') || '').toUpperCase() : '';
  }

  /** 上架費已結清（已付款或已免除），可解鎖編輯與送審。 */
  function isListingFeeSettled() {
    var status = currentListingFeeStatus();
    return status === 'PAID' || status === 'WAIVED';
  }
  var slotAddonSubmitInFlight = false;
  var slotAddonImageSources = [];
  var slotAddonImageFiles = [];
  /** Per-index crop: { zoom, fx, fy, natW, natH } — baked to cover on submit. */
  var slotAddonImageCrops = [];
  /** Live canvas preview URLs (blob) matching crop; preferred in wall preview. */
  var slotAddonCroppedPreview = [];
  var slotAddonCropTimers = {};
  var slotAddonCalCtx = null; // { parentStart, parentEnd, durationDays, listingId, parent }

  function findListingItemById(id) {
    var want = String(id);
    return (allListingItems || []).find(function (item) {
      return String(item.id) === want;
    }) || null;
  }

  /** 還有未綁課額度且綁定版位的方案 = 這個彈窗還能直接用的廣告版位。 */
  function collectAddonPlans(plans, mode) {
    var modeEnt = findModeEntitlement(mode) || {};
    var balanceByPlanId = {};
    (modeEnt.slot_balances || []).forEach(function (b) {
      if (b && b.fee_plan_id) balanceByPlanId[String(b.fee_plan_id)] = b;
    });
    var out = [];
    (plans || []).forEach(function (p) {
      if (!p || p.id == null) return;
      var slotId = p.slot_id || null;
      if (!slotId) return;
      var bal = balanceByPlanId[String(p.id)] || null;
      var unused = parseInt(p.unused_single_count, 10) || 0;
      if (bal && bal.single_unused > 0) unused = Math.max(unused, bal.single_unused | 0);
      var hasDuration = !!p.has_active_grant || !!(bal && bal.has_duration);
      // 免費版位同樣要先到「營運結帳」領取檔期；這裡只列還沒綁課的既有額度。
      var usable = unused > 0 || hasDuration;
      if (!usable) return;
      out.push({
        id: p.id,
        name: p.name || ('方案 #' + p.id),
        slot_id: slotId,
        slot_name: p.slot_name || ('版位 #' + slotId),
        plan_type: p.plan_type || 'SINGLE',
        duration_days: p.duration_days || 0,
        unused_single_count: unused,
        has_active_grant: hasDuration,
      });
    });
    return out;
  }

  function slotAddonPlanMetaLabel(p) {
    var bits = [];
    if (p.plan_type === 'SINGLE' && p.duration_days) bits.push('短檔 ' + p.duration_days + ' 天');
    else if (p.plan_type === 'SINGLE') bits.push('單次');
    else bits.push('通行證');
    if (p.plan_type === 'SINGLE') bits.push('剩餘 ' + p.unused_single_count + ' 次');
    else if (p.has_active_grant) bits.push('已開通');
    return bits.join(' · ');
  }

  async function openSlotAddonModal(opts) {
    opts = opts || {};
    var slug = getListingVendorSlug();
    if (!slug) {
      showListingAlert('請先選擇單一廠商');
      return;
    }
    var addon = opts.addonId ? findListingItemById(opts.addonId) : null;
    var parentId = addon ? addon.parent_listing_id : opts.parentId;
    var parent = findListingItemById(parentId);
    if (!parent) {
      showListingAlert('找不到要加購的課程，請重新整理列表');
      return;
    }
    if (!canAddSlotAddon(parent)) {
      showListingAlert('此課程尚未通過審核或檔期已結束，無法加購廣告版位');
      return;
    }

    var mode = String(parent.listing_mode || '').toUpperCase();
    var parentStart = ymd(parent.exposure_start_at);
    var parentEnd = ymd(parent.exposure_end_at);
    var earliest = addDaysYmd(todayYmdTw(), SLOT_ADDON_MIN_LEAD_DAYS);
    var minStart = parentStart && parentStart > earliest ? parentStart : earliest;

    // 購買即鎖窗：付款當下就建好加購草稿並綁定版位與檔期，額度也綁進這張單，
    // 所以已鎖窗的加購不能再走「剩餘額度」重畫方案卡，只補圖後送審。
    var addonLocked = isWindowLockedListing(addon);

    var addonPlans = [];
    if (!addonLocked) {
      setDataLoading(true, '載入版位方案中…');
      try {
        delete cachedFeePlans[(mode || '') + '_' + slug];
        addonPlans = collectAddonPlans(await fetchFeePlans(mode, slug), mode);
      } catch (e) {
        addonPlans = [];
      }
      setDataLoading(false);

      if (!addonPlans.length) {
        showListingAlert(
          '廣告檔期改成購買時就選定：請到「營運結帳」鎖定版位檔期（或免費領取），再到「課程廣告刊登 → 建立廣告」套用到課程並上傳專用圖。',
          '請先到營運結帳鎖定檔期'
        );
        return;
      }
    }

    var planPickHtml = addonLocked
      ? '<div class="lb-v2-fee-plan-pick__item is-selected is-locked" aria-disabled="true"' +
          ' data-addon-plan="' + escapeHtml(String(addon.fee_plan_id || '')) + '"' +
          ' data-addon-slot="' + escapeHtml(String(addon.slot_id || '')) + '"' +
          ' data-addon-locked="1">' +
          '<span class="lb-v2-fee-plan-pick__name">' +
            escapeHtml(addon.slot_name || ('版位 #' + (addon.slot_id || '—'))) + '</span>' +
          '<span class="lb-v2-fee-plan-pick__meta">' +
            (String(addon.listing_fee_status || '').toUpperCase() === 'WAIVED' ? '已免除上架費' : '已付款') +
            ' · 檔期已鎖定，不可更換</span>' +
        '</div>'
      : addonPlans.map(function (p) {
          var selected = addon && String(addon.fee_plan_id) === String(p.id);
          return '<button type="button" class="lb-v2-fee-plan-pick__item' + (selected ? ' is-selected' : '') +
            '" data-addon-plan="' + p.id + '" data-addon-slot="' + p.slot_id +
            '" data-addon-duration="' + (p.duration_days || '') + '">' +
            '<span class="lb-v2-fee-plan-pick__name">' + escapeHtml(p.slot_name) + '</span>' +
            '<span class="lb-v2-fee-plan-pick__meta">' +
              escapeHtml(p.name + ' · ' + slotAddonPlanMetaLabel(p)) + '</span>' +
          '</button>';
        }).join('');

    openModal({
      wide: true,
      compose: true,
      title: addon ? '編輯廣告版位加購' : '加購廣告版位',
      bodyHtml:
        '<p class="lb-v2-hint">課程「<strong>' + escapeHtml(parent.title || ('#' + parent.id)) +
          '</strong>」上架檔期 ' + escapeHtml(parentStart || '—') + ' ~ ' + escapeHtml(parentEnd || '—') +
          '。' +
          (addonLocked
            ? '廣告檔期已於購買時鎖定，補上廣告圖後即可送審。'
            : ('廣告檔期需落在此範圍內，且最早需提前 ' + SLOT_ADDON_MIN_LEAD_DAYS + ' 天。')) +
        '</p>' +
        '<div class="lb-v2-field" style="margin-top:0.9rem">' +
          '<label>' + (addonLocked ? '已鎖定廣告版位' : '選擇廣告版位') + '</label>' +
          '<div id="lb-v2-addon-plan-list" class="lb-v2-fee-plan-pick" role="listbox">' + planPickHtml + '</div>' +
        '</div>' +
        (addonLocked
          ? '<div class="lb-v2-field" style="margin-top:0.9rem">' +
              '<label>廣告檔期（已鎖定）</label>' +
              '<p class="lb-v2-hint" style="margin:0.25rem 0 0;">' +
                escapeHtml(ymd(addon.exposure_start_at)) + ' ～ ' + escapeHtml(ymd(addon.exposure_end_at)) +
                '（購買時選定，不可修改）</p>' +
              '<input type="hidden" id="lb-v2-addon-start" value="' + escapeHtml(ymd(addon.exposure_start_at)) + '">' +
              '<input type="hidden" id="lb-v2-addon-end" value="' + escapeHtml(ymd(addon.exposure_end_at)) + '">' +
            '</div>'
          : '<div class="lb-v2-field" style="margin-top:0.9rem">' +
              '<label>廣告檔期（點月曆選起日；綠數字＝該日剩餘容量）</label>' +
              '<p id="lb-v2-addon-cal-hint" class="lb-v2-hint" style="margin:0.25rem 0 0.45rem;">請先選擇上方廣告版位。</p>' +
              '<div id="lb-v2-addon-exposure-calendar" class="lb-v2-exposure-calendar" style="margin-bottom:0.55rem;"></div>' +
              '<div class="lb-v2-field-row">' +
                '<div class="lb-v2-field">' +
                  '<label for="lb-v2-addon-start-display">廣告起日</label>' +
                  '<button type="button" id="lb-v2-addon-start-display" class="lb-v2-input lb-v2-exposure-date-display" aria-controls="lb-v2-addon-exposure-calendar">請於上方月曆選擇</button>' +
                  '<input type="hidden" id="lb-v2-addon-start" value="">' +
                '</div>' +
                '<div class="lb-v2-field">' +
                  '<label for="lb-v2-addon-end-display">廣告迄日</label>' +
                  '<button type="button" id="lb-v2-addon-end-display" class="lb-v2-input lb-v2-exposure-date-display" aria-controls="lb-v2-addon-exposure-calendar">選擇起日後自動帶入</button>' +
                  '<input type="hidden" id="lb-v2-addon-end" value="">' +
                '</div>' +
              '</div>' +
            '</div>') +
        '<div class="lb-v2-field lb-v2-addon-upload" style="margin-top:0.9rem">' +
          '<label for="lb-v2-addon-images">廣告專用圖（選填）</label>' +
          '<p class="lb-v2-hint">上傳後可調整構圖；左側（手機為上方）牆面會即時更新，無需來回捲動。送審時依版位比例裁切填滿，不留黑邊。不會刪改母課圖片。</p>' +
          '<input type="file" id="lb-v2-addon-images" class="lb-v2-input" accept="image/*" multiple>' +
          '<div id="lb-v2-addon-images-preview" class="lb-v2-images-preview"></div>' +
          '<div class="lb-v2-addon-compose">' +
            '<div id="lb-v2-addon-place-preview" class="lb-v2-addon-compose__wall"></div>' +
            '<div id="lb-v2-addon-crop-root" class="lb-v2-addon-crop-root lb-v2-addon-compose__crop"></div>' +
          '</div>' +
          '<p id="lb-v2-addon-images-hint" class="lb-v2-hint"></p>' +
        '</div>' +
        '<p id="lb-v2-addon-error" class="lb-v2-hint" style="margin-top:0.7rem;color:#c0392b;" hidden></p>',
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '送出審核',
          accent: true,
          close: false,
          onClick: function () {
            submitSlotAddon(parent, addon);
            return false;
          },
        },
      ],
    });

    clearSlotAddonImages();
    slotAddonCalCtx = {
      parent: parent,
      parentStart: parentStart,
      parentEnd: parentEnd,
      durationDays: 0,
      listingId: addon ? addon.id : null,
    };

    var planList = $('lb-v2-addon-plan-list');
    var startEl = $('lb-v2-addon-start');
    var endEl = $('lb-v2-addon-end');
    if (startEl) startEl.value = addon ? ymd(addon.exposure_start_at) : '';
    if (endEl) endEl.value = addon ? ymd(addon.exposure_end_at) : '';
    syncAddonExposureDateDisplays();
    bindAddonCalendarClick();
    bindSlotAddonImageUpload(parent);

    // 編輯既有加購：若已有專用圖，帶入縮圖（與母課圖不同才算專用）
    if (addon && Array.isArray(addon.images_json) && addon.images_json.length) {
      var parentSrcs = parentListingImageSrcs(parent);
      var addonSrcs = parentListingImageSrcs(addon);
      var sameAsParent =
        addonSrcs.length === parentSrcs.length &&
        addonSrcs.every(function (s, i) { return s === parentSrcs[i]; });
      if (!sameAsParent) {
        addonSrcs.slice(0, 4).forEach(function (src, idx) {
          slotAddonImageSources.push(src);
          slotAddonImageFiles.push(null);
          slotAddonImageCrops.push(defaultAddonCrop(0, 0));
          slotAddonCroppedPreview.push(null);
          addSlotAddonImagePreview(src, idx);
          loadImageElement(src).then(function (img) {
            ensureAddonCropState(idx, img.naturalWidth || img.width, img.naturalHeight || img.height);
            renderAddonCropEditors(parent);
            scheduleAddonCropPreview(idx, parent);
          }).catch(function () {
            renderAddonCropEditors(parent);
          });
        });
      }
    }

    if (planList) {
      planList.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-addon-plan]') : null;
        if (!btn || !planList.contains(btn)) return;
        if (btn.getAttribute('data-addon-locked') === '1') return;
        planList.querySelectorAll('[data-addon-plan]').forEach(function (el) {
          el.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        // 換版位容量不同，清掉舊檔期避免誤送
        if (startEl) startEl.value = '';
        if (endEl) endEl.value = '';
        if (startEl) delete startEl.dataset.lbLastCalPick;
        syncAddonExposureDateDisplays();
        showSlotAddonError('');
        onAddonPlanSelected(btn, parent, addon);
      });
    }
    var initialSel = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
    if (initialSel) {
      onAddonPlanSelected(initialSel, parent, addon);
    } else {
      updateSlotAddonImageHint(null);
      renderAddonPlacePreview(null, parent);
      var cal = $('lb-v2-addon-exposure-calendar');
      if (cal) cal.innerHTML = '';
    }
  }

  function onAddonPlanSelected(planBtn, parent, addon) {
    updateSlotAddonImageHint(planBtn);
    trimSlotAddonImagesToWallLimit(parent);
    renderAddonCropEditors(parent);
    renderAddonPlacePreview(planBtn, parent);
    var kind = resolveWallPreviewKind(
      (planBtn.querySelector('.lb-v2-fee-plan-pick__name') || {}).textContent || '',
      (planBtn.querySelector('.lb-v2-fee-plan-pick__meta') || {}).textContent || '',
      ''
    );
    for (var i = 0; i < slotAddonImageSources.length; i++) {
      if (slotAddonImageSources[i] && getAddonCropSpec(kind, i)) {
        scheduleAddonCropPreview(i, parent);
      }
    }
    var slotId = planBtn ? parseInt(planBtn.getAttribute('data-addon-slot') || '0', 10) : 0;
    var durationDays = planBtn ? parseInt(planBtn.getAttribute('data-addon-duration') || '0', 10) : 0;
    if (slotAddonCalCtx) {
      slotAddonCalCtx.durationDays = durationDays > 0 ? durationDays : 0;
      slotAddonCalCtx.listingId = addon ? addon.id : null;
    }
    if (!(slotId > 0)) {
      var cal = $('lb-v2-addon-exposure-calendar');
      if (cal) cal.innerHTML = '<p class="lb-v2-hint">此方案未綁定版位，無法顯示容量月曆。</p>';
      return;
    }
    // 檔期已鎖定的加購沒有月曆可畫，只需要版位對應的圖片提示與牆面預覽。
    if (!$('lb-v2-addon-exposure-calendar')) return;
    loadAddonSlotAvailability(slotId);
  }

  /** 加購專用圖只服務該版位牆（不取代母課商品頁圖庫）。張數＝牆面實際取圖數。 */
  function getAddonWallImageLimit(kind) {
    if (kind === 'home_carousel') return 2;      // 桌機 + 手機
    if (kind === 'event_spotlight') return 4;    // 1 大 + 3 小
    if (kind === 'home_popup') return 1;         // 彈窗主圖
    if (kind === 'popular_courses') return 1;    // 卡片封面
    return 0; // 尚未選版位
  }

  function getSelectedAddonWallLimit() {
    return getAddonWallImageLimit(getSelectedAddonKind());
  }

  function trimSlotAddonImagesToWallLimit(parent) {
    var limit = getSelectedAddonWallLimit();
    if (!(limit >= 0)) limit = 0;
    var removed = false;
    while (slotAddonImageSources.length > limit) {
      var last = slotAddonImageSources.length - 1;
      if (slotAddonCropTimers[last]) {
        clearTimeout(slotAddonCropTimers[last]);
        delete slotAddonCropTimers[last];
      }
      revokeIfBlobUrl(slotAddonImageSources[last]);
      revokeIfBlobUrl(slotAddonCroppedPreview[last]);
      slotAddonImageSources.pop();
      slotAddonImageFiles.pop();
      slotAddonImageCrops.pop();
      slotAddonCroppedPreview.pop();
      removed = true;
    }
    if (!removed) return;
    rebuildSlotAddonImageThumbs();
    renderAddonCropEditors(parent);
    var planList = $('lb-v2-addon-plan-list');
    var sel = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
    renderAddonPlacePreview(sel, parent);
  }

  function slotAddonImageHintText(slotName, planName) {
    var kind = resolveWallPreviewKind(slotName, planName, '');
    var limit = getAddonWallImageLimit(kind);
    var keepParent =
      '不上傳就沿用「基礎上架」的課程圖。上傳專用圖只影響此加購在版位牆上的顯示，' +
      '不會刪改母課／商品頁原本的圖。版位以「裁切填滿」呈現（不留黑邊）。';
    if (kind === 'home_carousel') {
      return (
        '首頁大輪播只要 2 張：第 1＝電腦橫幅（約 21:9，長邊建議 ≥1600–2400），第 2＝手機圖（約 9:14）；缺一張時互用。' +
        keepParent
      );
    }
    if (kind === 'event_spotlight') {
      return (
        '活動焦點要 4 張：第 1＝大圖（約 4:3），第 2–4＝右側小圖（約 1:1）。' +
        keepParent
      );
    }
    if (kind === 'home_popup') {
      return '首頁彈窗只要 1 張主圖（固定 5:4，構圖／預覽／廣告牆同一框）；桌機左右欄、手機上下堆用同一張。' + keepParent;
    }
    if (kind === 'popular_courses') {
      return '熱門課程只要 1 張卡片封面（固定 5:4）；桌機 3 格／手機橫滑用同一張。' + keepParent;
    }
    return '請先選擇廣告版位，再上傳對應張數的專用圖。' + keepParent;
  }

  function updateSlotAddonImageHint(planBtn) {
    var hint = $('lb-v2-addon-images-hint');
    if (!hint) return;
    var nameEl = planBtn ? planBtn.querySelector('.lb-v2-fee-plan-pick__name') : null;
    var slotName = nameEl ? String(nameEl.textContent || '').trim() : '';
    var metaEl = planBtn ? planBtn.querySelector('.lb-v2-fee-plan-pick__meta') : null;
    var planName = metaEl ? String(metaEl.textContent || '').trim() : '';
    hint.textContent = slotAddonImageHintText(slotName, planName);
  }

  function parentListingImageSrcs(parent) {
    var raw = parent && Array.isArray(parent.images_json) ? parent.images_json : [];
    var out = [];
    raw.forEach(function (item) {
      var src = '';
      if (typeof item === 'string') src = item;
      else if (item && typeof item === 'object') src = item.src || item.url || '';
      if (src && src !== '[omitted-data-url]') out.push(src);
    });
    return out;
  }

  function collectAddonPreviewSources(parent) {
    var own = [];
    for (var i = 0; i < slotAddonImageSources.length; i++) {
      if (!slotAddonImageSources[i]) continue;
      own.push(slotAddonCroppedPreview[i] || slotAddonImageSources[i]);
    }
    if (own.length) return own;
    return parentListingImageSrcs(parent);
  }

  function clearSlotAddonImages() {
    slotAddonImageSources.forEach(revokeIfBlobUrl);
    slotAddonCroppedPreview.forEach(revokeIfBlobUrl);
    Object.keys(slotAddonCropTimers).forEach(function (k) {
      clearTimeout(slotAddonCropTimers[k]);
    });
    slotAddonImageSources = [];
    slotAddonImageFiles = [];
    slotAddonImageCrops = [];
    slotAddonCroppedPreview = [];
    slotAddonCropTimers = {};
    var box = $('lb-v2-addon-images-preview');
    if (box) box.innerHTML = '';
    var cropRoot = $('lb-v2-addon-crop-root');
    if (cropRoot) cropRoot.innerHTML = '';
  }

  function getSelectedAddonKind() {
    var planList = $('lb-v2-addon-plan-list');
    var btn = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
    if (!btn) return '';
    var nameEl = btn.querySelector('.lb-v2-fee-plan-pick__name');
    var metaEl = btn.querySelector('.lb-v2-fee-plan-pick__meta');
    return resolveWallPreviewKind(
      nameEl ? nameEl.textContent : '',
      metaEl ? metaEl.textContent : '',
      ''
    );
  }

  /** 寫成分數，避免 `aspect-ratio:1.25` 被 `[style*="aspect-ratio:1"]` 誤判成 1:1。 */
  function cropFrameRatioCss(ratio) {
    var r = Number(ratio);
    if (!(r > 0)) return '1 / 1';
    if (Math.abs(r - 1) < 0.001) return '1 / 1';
    if (Math.abs(r - 5 / 4) < 0.001) return '5 / 4';
    if (Math.abs(r - 4 / 3) < 0.001) return '4 / 3';
    if (Math.abs(r - 21 / 9) < 0.001) return '21 / 9';
    if (Math.abs(r - 9 / 14) < 0.001) return '9 / 14';
    return String(r);
  }

  function cropFrameBoxClass(spec) {
    var r = spec && Number(spec.ratio);
    var cls = 'lb-v2-addon-crop__frame';
    if (r > 0 && r < 1) cls += ' lb-v2-addon-crop__frame--portrait';
    if (r > 0 && Math.abs(r - 1) < 0.001) cls += ' lb-v2-addon-crop__frame--square';
    return cls;
  }

  function cropFrameBoxOpenTag(spec) {
    return '<div class="' + cropFrameBoxClass(spec) + '" style="aspect-ratio:' +
      cropFrameRatioCss(spec && spec.ratio) + ';">';
  }

  /** 僅牆面實際用到的圖位可構圖（對齊各 slot section 取圖）。 */
  function getAddonCropSpec(kind, idx) {
    if (kind === 'home_carousel') {
      if (idx === 0) return { label: '電腦橫幅', ratio: 21 / 9, ratioLabel: '約 21:9', wall: true };
      if (idx === 1) return { label: '手機圖', ratio: 9 / 14, ratioLabel: '約 9:14', wall: true };
      return null;
    }
    if (kind === 'popular_courses') {
      if (idx === 0) return { label: '卡片封面', ratio: 5 / 4, ratioLabel: '5:4', wall: true };
      return null;
    }
    if (kind === 'home_popup') {
      if (idx === 0) return { label: '彈窗主圖', ratio: 5 / 4, ratioLabel: '5:4', wall: true };
      return null;
    }
    if (kind === 'event_spotlight') {
      if (idx === 0) return { label: '大圖', ratio: 4 / 3, ratioLabel: '4:3', wall: true };
      if (idx >= 1 && idx <= 3) return { label: '小圖 ' + idx, ratio: 1, ratioLabel: '1:1', wall: true };
      return null;
    }
    // 未知版位仍給第 1 張構圖，避免上傳後看不到縮放／左右／上下
    if (idx === 0) return { label: '廣告專用圖', ratio: 1, ratioLabel: '1:1', wall: true };
    return null;
  }

  function defaultAddonCrop(natW, natH) {
    return { zoom: 1, fx: 50, fy: 50, natW: natW || 0, natH: natH || 0 };
  }

  /**
   * 構圖框即時預覽：用 `computeCoverCropRect` 算出的同一個裁切框換算成版面尺寸。
   *
   * 不可改回 `object-position` + `scale()` 模擬：CSS 的縮放錨點與 canvas 的裁切框
   * 位移只有在 zoom=1、焦點居中時才等價，其餘情況構圖框會跟牆面／手機模擬（吃
   * bake 出來的圖）對不起來——這就是「調整圖跟模擬顯示位置不一樣」的來源。
   */
  function setCropImgStyle(imgEl, props) {
    if (!imgEl || !imgEl.style) return;
    Object.keys(props).forEach(function (key) {
      var val = props[key];
      if (val == null || val === '') imgEl.style.removeProperty(key);
      else imgEl.style.setProperty(key, String(val), 'important');
    });
  }

  function applyLiveCropFrameStyle(imgEl, crop, spec) {
    if (!imgEl) return;
    var zoom = Math.max(1, Math.min(3, Number(crop && crop.zoom) || 1));
    var fx = Math.max(0, Math.min(100, crop && crop.fx == null ? 50 : Number(crop.fx)));
    var fy = Math.max(0, Math.min(100, crop && crop.fy == null ? 50 : Number(crop.fy)));
    var ratio = spec && Number(spec.ratio) > 0 ? Number(spec.ratio) : 0;
    var natW = Number(crop && crop.natW) || imgEl.naturalWidth || 0;
    var natH = Number(crop && crop.natH) || imgEl.naturalHeight || 0;
    var frame = imgEl.parentElement;
    if (frame && frame._lbCropResizeObs) {
      try { frame._lbCropResizeObs.disconnect(); } catch (e) { /* ignore */ }
      frame._lbCropResizeObs = null;
    }

    setCropImgStyle(imgEl, {
      transform: 'none',
      'max-width': 'none',
      'max-height': 'none',
      right: 'auto',
      bottom: 'auto',
    });

    if (!(natW > 0 && natH > 0 && ratio > 0)) {
      setCropImgStyle(imgEl, {
        width: '100%',
        height: '100%',
        left: '0',
        top: '0',
        'object-fit': 'cover',
        'object-position': fx + '% ' + fy + '%',
      });
      if (ratio > 0 && !imgEl._lbCropRelayoutBound) {
        imgEl._lbCropRelayoutBound = true;
        imgEl.addEventListener('load', function () {
          var c = crop || {};
          if (!(Number(c.natW) > 0)) c.natW = imgEl.naturalWidth || 0;
          if (!(Number(c.natH) > 0)) c.natH = imgEl.naturalHeight || 0;
          applyLiveCropFrameStyle(imgEl, c, spec);
        });
      }
      return;
    }

    var rect = computeCoverCropRect(natW, natH, ratio, zoom, fx, fy);
    setCropImgStyle(imgEl, {
      'object-fit': 'fill',
      'object-position': '0 0',
      width: (natW / rect.w) * 100 + '%',
      height: (natH / rect.h) * 100 + '%',
      left: (-rect.x / rect.w) * 100 + '%',
      top: (-rect.y / rect.h) * 100 + '%',
    });
  }

  function cropFramePanHint(crop, spec) {
    if (!crop || !spec || !(crop.natW > 0 && crop.natH > 0)) {
      return '裁切填滿、不留黑邊；微調縮放／位置決定保留區域。';
    }
    var imgRatio = crop.natW / crop.natH;
    var zoom = Math.max(1, Number(crop.zoom) || 1);
    var wide = imgRatio > spec.ratio * 1.02;
    var tall = imgRatio < spec.ratio * 0.98;
    if (zoom <= 1.001 && wide) {
      return '已裁切填滿（不留黑邊）。寬圖在最小縮放下只能左右移動；要調整上下請先拉大「縮放」。';
    }
    if (zoom <= 1.001 && tall) {
      return '已裁切填滿（不留黑邊）。直圖在最小縮放下只能上下移動；要調整左右請先拉大「縮放」。';
    }
    return '已裁切填滿（不留黑邊）。微調縮放／位置決定保留區域。';
  }

  function computeCoverCropRect(natW, natH, targetRatio, zoom, fx, fy) {
    zoom = Math.max(1, Math.min(3, Number(zoom) || 1));
    fx = Math.max(0, Math.min(100, fx == null ? 50 : Number(fx)));
    fy = Math.max(0, Math.min(100, fy == null ? 50 : Number(fy)));
    var imgRatio = natW / Math.max(1, natH);
    var cropW;
    var cropH;
    if (imgRatio > targetRatio) {
      cropH = natH / zoom;
      cropW = cropH * targetRatio;
    } else {
      cropW = natW / zoom;
      cropH = cropW / targetRatio;
    }
    if (cropW > natW) {
      cropW = natW;
      cropH = cropW / targetRatio;
    }
    if (cropH > natH) {
      cropH = natH;
      cropW = cropH * targetRatio;
    }
    var x = (fx / 100) * natW - cropW / 2;
    var y = (fy / 100) * natH - cropH / 2;
    x = Math.max(0, Math.min(natW - cropW, x));
    y = Math.max(0, Math.min(natH - cropH, y));
    return { x: x, y: y, w: cropW, h: cropH };
  }

  function loadImageElement(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('無法讀取圖片')); };
      if (src && String(src).indexOf('blob:') !== 0 && String(src).indexOf('data:') !== 0) {
        try { img.crossOrigin = 'anonymous'; } catch (e) { /* ignore */ }
      }
      img.src = src;
    });
  }

  function canvasToJpegBlob(canvas, quality) {
    return new Promise(function (resolve) {
      if (canvas.toBlob) {
        canvas.toBlob(function (blob) { resolve(blob); }, 'image/jpeg', quality || 0.92);
        return;
      }
      try {
        var dataUrl = canvas.toDataURL('image/jpeg', quality || 0.92);
        var bin = atob(dataUrl.split(',')[1] || '');
        var arr = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
        resolve(new Blob([arr], { type: 'image/jpeg' }));
      } catch (e) {
        resolve(null);
      }
    });
  }

  async function bakeAddonCropToBlob(idx, spec) {
    var src = slotAddonImageSources[idx];
    if (!src || !spec) return null;
    var crop = slotAddonImageCrops[idx] || defaultAddonCrop(0, 0);
    var img = await loadImageElement(src);
    var natW = img.naturalWidth || img.width;
    var natH = img.naturalHeight || img.height;
    if (!(natW > 0 && natH > 0)) return null;
    crop.natW = natW;
    crop.natH = natH;
    slotAddonImageCrops[idx] = crop;
    var rect = computeCoverCropRect(natW, natH, spec.ratio, crop.zoom, crop.fx, crop.fy);
    var outW = Math.round(rect.w);
    var outH = Math.round(rect.h);
    var longEdge = Math.max(outW, outH);
    var maxLong = 2200;
    if (longEdge > maxLong) {
      var s = maxLong / longEdge;
      outW = Math.max(1, Math.round(outW * s));
      outH = Math.max(1, Math.round(outH * s));
    }
    var canvas = document.createElement('canvas');
    canvas.width = outW;
    canvas.height = outH;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, rect.x, rect.y, rect.w, rect.h, 0, 0, outW, outH);
    return canvasToJpegBlob(canvas, 0.92);
  }

  function scheduleAddonCropPreview(idx, parent) {
    if (slotAddonCropTimers[idx]) clearTimeout(slotAddonCropTimers[idx]);
    slotAddonCropTimers[idx] = setTimeout(function () {
      refreshAddonCropPreview(idx, parent);
    }, 120);
  }

  async function refreshAddonCropPreview(idx, parent) {
    var kind = getSelectedAddonKind();
    var spec = getAddonCropSpec(kind, idx);
    if (!spec || !slotAddonImageSources[idx]) return;
    try {
      var crop = slotAddonImageCrops[idx] || defaultAddonCrop(0, 0);
      var frameImg = document.querySelector(
        '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
      );
      if (frameImg) {
        // 構圖框永遠用原圖 + live cover，避免主題 height:auto 露出黑邊、也避免 bake 後無法對應滑桿
        if (frameImg.getAttribute('src') !== slotAddonImageSources[idx]) {
          frameImg.src = slotAddonImageSources[idx];
        }
        applyLiveCropFrameStyle(frameImg, crop, spec);
      }
      var warnEl = document.querySelector(
        '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__warn'
      );
      if (warnEl) warnEl.textContent = cropFramePanHint(crop, spec);

      var blob = await bakeAddonCropToBlob(idx, spec);
      if (blob) {
        revokeIfBlobUrl(slotAddonCroppedPreview[idx]);
        slotAddonCroppedPreview[idx] = URL.createObjectURL(blob);
      }
      var previewRoot = $('lb-v2-addon-place-preview');
      if (previewRoot && previewRoot.querySelector('.lb-v2-slot-preview-toggle')) {
        syncHomePopupWallPreview(previewRoot);
      } else {
        var planList = $('lb-v2-addon-plan-list');
        var sel = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
        renderAddonPlacePreview(sel, parent);
      }
    } catch (e) {
      /* CORS／讀圖失敗時仍用原圖 + live style */
      var crop2 = slotAddonImageCrops[idx] || defaultAddonCrop(0, 0);
      var frameImg2 = document.querySelector(
        '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
      );
      if (frameImg2) applyLiveCropFrameStyle(frameImg2, crop2, spec);
    }
  }

  function rebuildSlotAddonImageThumbs() {
    var container = $('lb-v2-addon-images-preview');
    if (!container) return;
    container.innerHTML = '';
    for (var i = 0; i < slotAddonImageSources.length; i++) {
      if (slotAddonImageSources[i]) addSlotAddonImagePreview(slotAddonImageSources[i], i);
    }
  }

  function removeSlotAddonImageAt(idx) {
    if (!(idx >= 0) || idx >= slotAddonImageSources.length) return;
    Object.keys(slotAddonCropTimers).forEach(function (k) {
      clearTimeout(slotAddonCropTimers[k]);
    });
    slotAddonCropTimers = {};
    revokeIfBlobUrl(slotAddonImageSources[idx]);
    revokeIfBlobUrl(slotAddonCroppedPreview[idx]);
    // 緊湊重排：避免 [null, 新圖] 被當成「第 2 張」而失去構圖規格
    slotAddonImageSources.splice(idx, 1);
    slotAddonImageFiles.splice(idx, 1);
    slotAddonImageCrops.splice(idx, 1);
    slotAddonCroppedPreview.splice(idx, 1);
    var parent = slotAddonCalCtx && slotAddonCalCtx.parent;
    rebuildSlotAddonImageThumbs();
    renderAddonCropEditors(parent);
    var planList = $('lb-v2-addon-plan-list');
    var sel = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
    renderAddonPlacePreview(sel, parent);
  }

  function addSlotAddonImagePreview(src, idx) {
    var container = $('lb-v2-addon-images-preview');
    if (!container || !src) return;
    var wrap = document.createElement('div');
    wrap.className = 'lb-v2-img-thumb';
    wrap.dataset.imgIdx = String(idx);
    var badge = document.createElement('span');
    badge.className = 'lb-v2-img-thumb__n';
    badge.textContent = String(idx + 1);
    var img = document.createElement('img');
    img.src = src;
    img.alt = '廣告專用圖 ' + (idx + 1);
    img.draggable = false;
    img.addEventListener('error', function () {
      wrap.classList.add('is-broken');
      img.alt = '無法預覽';
    });
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lb-v2-img-remove';
    btn.setAttribute('aria-label', '移除第 ' + (idx + 1) + ' 張');
    btn.title = '移除';
    btn.textContent = '×';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      removeSlotAddonImageAt(idx);
    });
    wrap.appendChild(img);
    wrap.appendChild(badge);
    wrap.appendChild(btn);
    container.appendChild(wrap);
  }

  function ensureAddonCropState(idx, natW, natH) {
    if (!slotAddonImageCrops[idx]) {
      slotAddonImageCrops[idx] = defaultAddonCrop(natW, natH);
    } else {
      if (natW) slotAddonImageCrops[idx].natW = natW;
      if (natH) slotAddonImageCrops[idx].natH = natH;
    }
    return slotAddonImageCrops[idx];
  }

  function renderAddonCropEditors(parent) {
    var root = $('lb-v2-addon-crop-root');
    if (!root) return;
    var kind = getSelectedAddonKind();
    var html = '';
    var any = false;
    for (var idx = 0; idx < slotAddonImageSources.length; idx++) {
      if (!slotAddonImageSources[idx]) continue;
      var spec = getAddonCropSpec(kind, idx);
      if (!spec) continue;
      any = true;
      var crop = slotAddonImageCrops[idx] || defaultAddonCrop(0, 0);
      var previewSrc = slotAddonImageSources[idx];
      var warn = cropFramePanHint(crop, spec);
      html += '<div class="lb-v2-addon-crop" data-crop-idx="' + idx + '">';
      html += '<div class="lb-v2-addon-crop__head">';
      html += '<div class="lb-v2-addon-crop__title">';
      html += '<span class="lb-v2-addon-crop__kicker">構圖</span>';
      html += '<strong>第 ' + (idx + 1) + ' 張 · ' + escapeHtml(spec.label) + '</strong>';
      html += '</div>';
      html += '<div class="lb-v2-addon-crop__head-actions">';
      html += '<span class="lb-v2-addon-crop__ratio">' + escapeHtml(spec.ratioLabel) + '</span>';
      html += '</div></div>';
      if (spec.wall === false) {
        warn = '此張不進目前版位牆面；仍可調整構圖後一併送審保存。' + (warn ? ' ' + warn : '');
      }
      html += '<div class="lb-v2-addon-crop__stage">';
      html += '<div class="lb-v2-addon-crop__viewport">';
      html += cropFrameBoxOpenTag(spec);
      html += '<img src="' + escapeHtml(previewSrc) + '" alt="裁切預覽" data-crop-live="1">';
      html += '<span class="lb-v2-addon-crop__guide" aria-hidden="true"></span>';
      html += '</div></div>';
      html += '<div class="lb-v2-addon-crop__controls" role="group" aria-label="構圖微調">';
      html += '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">縮放</span>';
      html += '<input class="lb-v2-addon-crop__range" type="range" min="100" max="300" step="1" value="' +
        Math.round((crop.zoom || 1) * 100) + '" data-crop-zoom="' + idx + '" aria-label="縮放"></div>';
      html += '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">左右</span>';
      html += '<input class="lb-v2-addon-crop__range" type="range" min="0" max="100" step="1" value="' +
        Math.round(crop.fx == null ? 50 : crop.fx) + '" data-crop-fx="' + idx + '" aria-label="左右"></div>';
      html += '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">上下</span>';
      html += '<input class="lb-v2-addon-crop__range" type="range" min="0" max="100" step="1" value="' +
        Math.round(crop.fy == null ? 50 : crop.fy) + '" data-crop-fy="' + idx + '" aria-label="上下"></div>';
      html += '</div></div>';
      html += '<p class="lb-v2-addon-crop__warn">' + escapeHtml(warn) + '</p>';
      html += '</div>';
    }
    if (!any) {
      root.innerHTML = '';
      return;
    }
    root.innerHTML = html;
    for (var j = 0; j < slotAddonImageSources.length; j++) {
      if (!slotAddonImageSources[j]) continue;
      var liveImg = root.querySelector(
        '.lb-v2-addon-crop[data-crop-idx="' + j + '"] .lb-v2-addon-crop__frame img'
      );
      applyLiveCropFrameStyle(
        liveImg,
        slotAddonImageCrops[j] || defaultAddonCrop(0, 0),
        getAddonCropSpec(kind, j)
      );
    }
    if (!root._lbCropBound) {
      root._lbCropBound = true;
      root.addEventListener('input', function (e) {
        var t = e.target;
        if (!t || !t.getAttribute) return;
        var idxZ = t.getAttribute('data-crop-zoom');
        var idxX = t.getAttribute('data-crop-fx');
        var idxY = t.getAttribute('data-crop-fy');
        var idx = idxZ != null ? parseInt(idxZ, 10)
          : (idxX != null ? parseInt(idxX, 10)
            : (idxY != null ? parseInt(idxY, 10) : -1));
        if (!(idx >= 0)) return;
        var crop = ensureAddonCropState(idx, 0, 0);
        if (idxZ != null) crop.zoom = Math.max(1, (parseInt(t.value, 10) || 100) / 100);
        if (idxX != null) crop.fx = parseInt(t.value, 10) || 0;
        if (idxY != null) crop.fy = parseInt(t.value, 10) || 0;
        slotAddonImageCrops[idx] = crop;
        var live = root.querySelector(
          '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
        );
        var kindNow = getSelectedAddonKind();
        var specNow = getAddonCropSpec(kindNow, idx);
        applyLiveCropFrameStyle(live, crop, specNow);
        syncHomePopupWallPreview($('lb-v2-addon-place-preview'));
        var warnNow = root.querySelector(
          '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__warn'
        );
        if (warnNow && specNow) warnNow.textContent = cropFramePanHint(crop, specNow);
        scheduleAddonCropPreview(idx, slotAddonCalCtx && slotAddonCalCtx.parent);
      });
    }
  }

  function bindSlotAddonImageUpload(parent) {
    var inp = $('lb-v2-addon-images');
    if (!inp || inp._lbAddonBound) return;
    inp._lbAddonBound = true;
    inp.addEventListener('change', function () {
      var files = Array.from(inp.files || []);
      var limit = getSelectedAddonWallLimit();
      if (!(limit > 0)) {
        showSlotAddonError('請先選擇廣告版位，再上傳專用圖');
        inp.value = '';
        return;
      }
      var remaining = limit - slotAddonImageSources.length;
      if (remaining <= 0) {
        showSlotAddonError('此版位牆面最多 ' + limit + ' 張專用圖');
        inp.value = '';
        return;
      }
      files.slice(0, remaining).forEach(function (file) {
        if (!file.type || !file.type.startsWith('image/')) return;
        if (file.size > 5 * 1024 * 1024) {
          showSlotAddonError('單張圖片請小於 5MB');
          return;
        }
        var preview = URL.createObjectURL(file);
        // 先驗證可解碼，避免空白縮圖佔位卻沒有構圖區
        loadImageElement(preview).then(function (img) {
          var wallLimit = getSelectedAddonWallLimit();
          var idx = slotAddonImageSources.length;
          if (!(wallLimit > 0) || idx >= wallLimit) {
            revokeIfBlobUrl(preview);
            showSlotAddonError(wallLimit > 0
              ? ('此版位牆面最多 ' + wallLimit + ' 張專用圖')
              : '請先選擇廣告版位，再上傳專用圖');
            return;
          }
          slotAddonImageFiles.push(file);
          slotAddonImageSources.push(preview);
          slotAddonImageCrops.push(defaultAddonCrop(
            img.naturalWidth || img.width,
            img.naturalHeight || img.height
          ));
          slotAddonCroppedPreview.push(null);
          addSlotAddonImagePreview(preview, idx);
          renderAddonCropEditors(parent);
          scheduleAddonCropPreview(idx, parent);
          var planList = $('lb-v2-addon-plan-list');
          var sel = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
          renderAddonPlacePreview(sel, parent);
          showSlotAddonError('');
        }).catch(function () {
          revokeIfBlobUrl(preview);
          showSlotAddonError('無法讀取圖片，請改用 JPG／PNG');
        });
      });
      inp.value = '';
    });
  }

  function renderAddonPlacePreview(planBtn, parent) {
    var box = $('lb-v2-addon-place-preview');
    if (!box) return;
    var nameEl = planBtn ? planBtn.querySelector('.lb-v2-fee-plan-pick__name') : null;
    var slotName = nameEl ? String(nameEl.textContent || '').trim() : '';
    var metaEl = planBtn ? planBtn.querySelector('.lb-v2-fee-plan-pick__meta') : null;
    var planName = metaEl ? String(metaEl.textContent || '').trim() : '';
    if (!slotName && !planName) {
      box.innerHTML = '';
      return;
    }
    var imgs = collectAddonPreviewSources(parent);
    var title = (parent && parent.title) || '（課程標題）';
    var desk = imgs[0] || '';
    var mob = imgs[1] || desk;
    var kind = resolveWallPreviewKind(slotName, planName, '');
    var usingParent = !(slotAddonImageSources.filter(Boolean).length);
    var html = '<div class="lb-v2-place-preview lb-v2-place-preview--compose">';
    html += '<p class="lb-v2-review-note">官網真實版位預覽' +
      (usingParent ? '（目前沿用基礎上架圖）' : '（目前為專用圖・已套裁切）') +
      '：HTML／CSS 與前台 section 相同；圖以<strong>裁切填滿</strong>顯示。同池<strong>不保證順位</strong>。調構圖時可一眼對照牆面。</p>';
    html += '<div class="lb-v2-place-preview__block">';
    html += '<h4 class="lb-v2-place-preview__h">' + escapeHtml(slotName || '廣告版位') + '</h4>';
    html += buildStorefrontSlotWallToggleHtml(kind, {
      title: title,
      desk: desk,
      mob: mob,
      imgs: imgs,
      desc: listingPreviewDesc(parent, 90),
      vendor: listingPreviewVendorName(parent),
      priceText: listingPreviewPriceText(parent),
      openDevice: readSlotPreviewDevice(box),
    });
    html += '</div></div>';
    box.innerHTML = html;
    bindSlotPreviewToggle(box);
    syncHomePopupWallPreview(box);
  }

  /** 預覽牆填滿 5:4 框（不留頂端底色）。有 bake 就用裁切圖；否則原圖 cover＋焦點。 */
  function applyPopupPreviewFillStyle(imgEl, crop) {
    var fx = crop && crop.fx == null ? 50 : Number(crop.fx);
    var fy = crop && crop.fy == null ? 50 : Number(crop.fy);
    setCropImgStyle(imgEl, {
      transform: 'none',
      'max-width': 'none',
      'max-height': 'none',
      inset: '0',
      left: '0',
      top: '0',
      right: '0',
      bottom: '0',
      width: '100%',
      height: '100%',
      'object-fit': 'cover',
      'object-position': fx + '% ' + fy + '%',
    });
  }

  function syncHomePopupWallPreview(root) {
    if (!root || getSelectedAddonKind() !== 'home_popup') return;
    var spec = getAddonCropSpec('home_popup', 0);
    var baked = slotAddonCroppedPreview[0];
    var src = baked || slotAddonImageSources[0];
    if (!spec || !src) return;
    var crop = slotAddonImageCrops[0] || defaultAddonCrop(0, 0);
    var fillCrop = baked ? { fx: 50, fy: 50 } : crop;
    var imgs = root.querySelectorAll('.lb-home-popup__media img');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('src') !== src) imgs[i].src = src;
      applyPopupPreviewFillStyle(imgs[i], fillCrop);
    }
  }

  function syncAddonExposureDateDisplays() {
    var startEl = $('lb-v2-addon-start');
    var endEl = $('lb-v2-addon-end');
    var startDisp = $('lb-v2-addon-start-display');
    var endDisp = $('lb-v2-addon-end-display');
    var durationDays = slotAddonCalCtx ? (slotAddonCalCtx.durationDays || 0) : 0;
    var sv = startEl ? String(startEl.value || '').trim() : '';
    var ev = endEl ? String(endEl.value || '').trim() : '';
    if (startDisp) {
      startDisp.textContent = sv ? formatDateZh(sv) : '請於上方月曆選擇';
      startDisp.classList.toggle('is-set', !!sv);
    }
    if (endDisp) {
      if (durationDays > 0) {
        endDisp.textContent = ev ? (formatDateZh(ev) + '（短檔自動）') : '選擇起日後自動帶入';
        endDisp.classList.add('is-locked');
      } else {
        endDisp.textContent = ev ? formatDateZh(ev) : '請於上方月曆選擇迄日';
        endDisp.classList.remove('is-locked');
      }
      endDisp.classList.toggle('is-set', !!ev);
    }
    highlightAddonExposureDays();
  }

  function highlightAddonExposureDays() {
    var cal = $('lb-v2-addon-exposure-calendar');
    if (!cal) return;
    var startEl = $('lb-v2-addon-start');
    var endEl = $('lb-v2-addon-end');
    var start = startEl ? startEl.value : '';
    var end = endEl ? endEl.value : '';
    var hasRange = !!(start && end && end >= start);
    var nodes = cal.querySelectorAll('.lb-v2-cal-day[data-day]');
    for (var i = 0; i < nodes.length; i++) {
      var day = nodes[i].getAttribute('data-day') || '';
      var inRange = !!(hasRange && day >= start && day <= end);
      var isStart = !!(start && day === start);
      nodes[i].classList.toggle('lb-v2-cal-day--selected', isStart);
      nodes[i].classList.toggle('lb-v2-cal-day--in-range', inRange && !isStart);
    }
  }

  function bindAddonCalendarClick() {
    var calEl = $('lb-v2-addon-exposure-calendar');
    if (!calEl || calEl._lbAddonCalBound) return;
    calEl._lbAddonCalBound = true;
    calEl.addEventListener('click', function (e) {
      var dayEl = e.target && e.target.closest ? e.target.closest('.lb-v2-cal-day') : null;
      if (!dayEl || dayEl.disabled || dayEl.getAttribute('data-can-start') !== '1') return;
      var ymdVal = dayEl.getAttribute('data-day') || '';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(ymdVal)) return;
      var maxEnd = calEl.getAttribute('data-max-end') || '';
      var durationDays = parseInt(calEl.getAttribute('data-duration-days') || '0', 10) || 0;
      if (maxEnd && ymdVal > maxEnd) return;

      var startEl = $('lb-v2-addon-start');
      var endEl = $('lb-v2-addon-end');
      if (!startEl) return;

      if (durationDays > 0) {
        var endYmd = addDaysYmd(ymdVal, durationDays - 1);
        startEl.value = ymdVal;
        if (endEl) endEl.value = endYmd;
        startEl.dataset.lbLastCalPick = ymdVal;
        syncAddonExposureDateDisplays();
        if (maxEnd && endYmd > maxEnd) {
          var overMsg = '此方案為 ' + durationDays + ' 天短檔，選定後檔期為 ' + ymdVal +
            ' ~ ' + endYmd + '，已超出基礎上架曝光範圍（最晚 ' + maxEnd + '），請改選較早的起日。';
          showSlotAddonError(overMsg);
          showPortalAlert(overMsg, '超出基礎上架曝光範圍');
          return;
        }
        showSlotAddonError('');
        return;
      }

      var prevStart = startEl.dataset.lbLastCalPick || startEl.value || '';
      if (prevStart && ymdVal === prevStart) {
        startEl.value = '';
        if (endEl) endEl.value = '';
        delete startEl.dataset.lbLastCalPick;
        syncAddonExposureDateDisplays();
        return;
      }
      if (endEl && prevStart && ymdVal > prevStart) {
        if (maxEnd && ymdVal > maxEnd) return;
        startEl.value = prevStart;
        endEl.value = ymdVal;
        startEl.dataset.lbLastCalPick = prevStart;
        showSlotAddonError('');
        syncAddonExposureDateDisplays();
      } else {
        startEl.value = ymdVal;
        if (endEl) endEl.value = '';
        startEl.dataset.lbLastCalPick = ymdVal;
        syncAddonExposureDateDisplays();
      }
    });
  }

  async function loadAddonSlotAvailability(slotId) {
    var cal = $('lb-v2-addon-exposure-calendar');
    var hintEl = $('lb-v2-addon-cal-hint');
    if (!cal || !slotAddonCalCtx) return;
    var parentStart = slotAddonCalCtx.parentStart || '';
    var parentEnd = slotAddonCalCtx.parentEnd || '';
    var durationDays = slotAddonCalCtx.durationDays || 0;
    var listingId = slotAddonCalCtx.listingId || '';
    var now = new Date();
    var start = ymdLocal(now);
    var endD = new Date(now.getFullYear(), now.getMonth(), now.getDate() + EXPOSURE_CALENDAR_DAYS);
    var windowEnd = ymdLocal(endD);
    var end = minYmd(windowEnd, parentEnd) || windowEnd;
    var slug = getListingVendorSlug();
    var key = 'addon_' + slotId + '_' + start + '_' + end + '_' + (slug || '') + '_' + listingId;
    if (hintEl) {
      hintEl.innerHTML = '綠數字＝該日剩餘容量（∞＝未設上限）。檔期須落在課程上架 ' +
        '<strong>' + escapeHtml(parentStart || '—') + ' ~ ' + escapeHtml(parentEnd || '—') + '</strong> 內' +
        (durationDays > 0 ? ('；短檔固定 <strong>' + durationDays + ' 天</strong>，點起日即自動帶迄日。') : '。');
    }
    if (slotAvailCache[key]) {
      renderAddonExposureCalendar(slotAvailCache[key].days, resolveMinLeadDays(slotAvailCache[key].min_lead_days, SLOT_ADDON_MIN_LEAD_DAYS), end, durationDays, parentStart);
      return;
    }
    cal.innerHTML = '<p class="lb-v2-hint">載入版位可用量中…</p>';
    try {
      var qs = '?slot_id=' + slotId + '&start_date=' + start + '&end_date=' + end +
        (slug ? '&vendor_slug=' + encodeURIComponent(slug) : '') +
        (listingId && /^\d+$/.test(String(listingId)) ? '&listing_id=' + listingId : '');
      var resp = await fetch(PATHS.slotAvailability + qs, {
        method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin',
      });
      var data = await resp.json();
      if (data && data.ok) {
        slotAvailCache[key] = data;
        renderAddonExposureCalendar(data.days, resolveMinLeadDays(data.min_lead_days, SLOT_ADDON_MIN_LEAD_DAYS), end, durationDays, parentStart);
      } else {
        cal.innerHTML = '<p class="lb-v2-hint" style="color:#c0392b">載入版位可用量失敗</p>';
      }
    } catch (e) {
      cal.innerHTML = '<p class="lb-v2-hint" style="color:#c0392b">載入版位可用量失敗</p>';
    }
  }

  function renderAddonExposureCalendar(days, minLeadDays, maxEndYmd, durationDays, minStartYmd) {
    var cal = $('lb-v2-addon-exposure-calendar');
    if (!cal) return;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var leadDays = Number(minLeadDays);
    if (!Number.isFinite(leadDays) || leadDays < 0) leadDays = SLOT_ADDON_MIN_LEAD_DAYS;
    var earliest = new Date(today);
    earliest.setDate(earliest.getDate() + leadDays);
    var earliestYmd = earliest.getFullYear() + '-' +
      String(earliest.getMonth() + 1).padStart(2, '0') + '-' +
      String(earliest.getDate()).padStart(2, '0');
    if (minStartYmd && minStartYmd > earliestYmd) earliestYmd = minStartYmd;

    var latestStartYmd = maxEndYmd || '';
    if (durationDays > 1 && maxEndYmd) {
      latestStartYmd = addDaysYmd(maxEndYmd, -(durationDays - 1));
    }
    cal.setAttribute('data-max-end', maxEndYmd || '');
    cal.setAttribute('data-latest-start', latestStartYmd || '');
    cal.setAttribute('data-duration-days', String(durationDays || 0));

    if (!days || !days.length) {
      cal.innerHTML = '<p class="lb-v2-hint">此區間無可用日期。</p>';
      syncAddonExposureDateDisplays();
      return;
    }

    var byDay = {};
    days.forEach(function (d) { byDay[d.day] = d; });
    var months = {};
    days.forEach(function (d) {
      var m = d.day.slice(0, 7);
      if (!months[m]) months[m] = true;
    });
    if (maxEndYmd) months[maxEndYmd.slice(0, 7)] = true;
    if (minStartYmd) months[minStartYmd.slice(0, 7)] = true;

    var WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];
    var html = '';
    Object.keys(months).sort().forEach(function (ym) {
      var parts = ym.split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10);
      var first = new Date(year, month - 1, 1);
      var daysInMonth = new Date(year, month, 0).getDate();
      var startWeekday = first.getDay();
      html += '<div class="lb-v2-cal-month">';
      html += '<div class="lb-v2-cal-month__head">' + year + ' 年 ' + month + ' 月</div>';
      html += '<div class="lb-v2-cal-weekdays">';
      WEEKDAYS.forEach(function (w) {
        html += '<span class="lb-v2-cal-weekday">' + w + '</span>';
      });
      html += '</div><div class="lb-v2-cal-grid">';
      var i;
      for (i = 0; i < startWeekday; i++) {
        html += '<span class="lb-v2-cal-day lb-v2-cal-day--empty" aria-hidden="true"></span>';
      }
      for (var dayNum = 1; dayNum <= daysInMonth; dayNum++) {
        var ymdVal = ym + '-' + String(dayNum).padStart(2, '0');
        var d = byDay[ymdVal];
        var dayDate = new Date(ymdVal + 'T00:00:00');
        var isPast = dayDate < earliest || !!(earliestYmd && ymdVal < earliestYmd);
        var heldByMe = !!(d && d.held_by_me);
        var isFull = d && d.max > 0 && d.available <= 0 && !heldByMe;
        var noData = !d;
        var beyondWindow = !!(maxEndYmd && ymdVal > maxEndYmd);
        var beforeParent = !!(minStartYmd && ymdVal < minStartYmd);
        var startTooLate = !!(latestStartYmd && durationDays > 0 && ymdVal > latestStartYmd);
        // 母課窗內天數仍可點（含短檔會超出者），點後警示；額度一律顯示。
        var canStart = !(noData || isPast || isFull || beyondWindow || beforeParent);
        var inParentRange = !beyondWindow && !beforeParent && !isPast;
        var cls = 'lb-v2-cal-day';
        if (!canStart) {
          if (isFull && inParentRange) cls += ' lb-v2-cal-day--full';
          else cls += ' lb-v2-cal-day--past';
        } else {
          cls += ' lb-v2-cal-day--ok';
          if (startTooLate) cls += ' lb-v2-cal-day--overflow-start';
          if (heldByMe) cls += ' lb-v2-cal-day--held';
        }
        var availText = d && d.max > 0 ? String(d.available) : (d ? '∞' : '—');
        if (heldByMe && canStart) availText = '保';
        var title = formatDateZh(ymdVal);
        if (beyondWindow || beforeParent) title += '　超出課程上架檔期';
        else if (startTooLate) title += '　短檔迄日會超出基礎上架曝光範圍';
        else if (isFull) title += '　已滿';
        else if (heldByMe) title += '　你的保留檔期（可沿用）';
        else if (d) title += '　剩餘 ' + availText;
        else title += '　無資料';
        html += '<button type="button" class="' + cls + '" data-day="' + ymdVal +
          '" data-can-start="' + (canStart ? '1' : '0') +
          '" title="' + title + '"' + (canStart ? '' : ' disabled tabindex="-1"') + '>' +
          '<span class="lb-v2-cal-day__num">' + dayNum + '</span>' +
          '<span class="lb-v2-cal-day__cap">' + (canStart || isFull || (inParentRange && d) ? availText : '') + '</span>' +
          '</button>';
      }
      html += '</div></div>';
    });
    cal.innerHTML = html;

    // 既有起迄若超出母課窗／太近才清掉（短檔會超出者保留，改由警示）
    var startEl = $('lb-v2-addon-start');
    var endEl = $('lb-v2-addon-end');
    if (startEl && startEl.value) {
      var endVal = endEl ? endEl.value : '';
      if (durationDays > 0) endVal = addDaysYmd(startEl.value, durationDays - 1);
      if ((earliestYmd && startEl.value < earliestYmd) ||
          (minStartYmd && startEl.value < minStartYmd) ||
          (maxEndYmd && startEl.value > maxEndYmd)) {
        startEl.value = '';
        if (endEl) endEl.value = '';
      } else if (durationDays > 0 && endEl) {
        endEl.value = endVal;
      }
    }
    syncAddonExposureDateDisplays();
  }

  function showSlotAddonError(msg) {
    var el = $('lb-v2-addon-error');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  async function submitSlotAddon(parent, existingAddon) {
    if (slotAddonSubmitInFlight) return;
    var slug = getListingVendorSlug();
    var planList = $('lb-v2-addon-plan-list');
    var selected = planList ? planList.querySelector('[data-addon-plan].is-selected') : null;
    if (!selected) {
      showSlotAddonError('請先選擇要加購的廣告版位');
      return;
    }
    var startEl = $('lb-v2-addon-start');
    var endEl = $('lb-v2-addon-end');
    var start = startEl ? String(startEl.value || '') : '';
    var end = endEl ? String(endEl.value || '') : '';
    if (!start || !end) {
      showSlotAddonError('請選擇廣告起迄日');
      return;
    }
    if (end < start) {
      showSlotAddonError('廣告迄日不能早於起日');
      return;
    }
    var parentStart = ymd(parent.exposure_start_at);
    var parentEnd = ymd(parent.exposure_end_at);
    if ((parentStart && start < parentStart) || (parentEnd && end > parentEnd)) {
      showSlotAddonError('廣告檔期需落在課程上架檔期內（' + parentStart + ' ~ ' + parentEnd + '）');
      return;
    }

    slotAddonSubmitInFlight = true;
    setDataLoading(true, '處理圖片並送出加購中…');
    try {
      var kind = resolveWallPreviewKind(
        (selected.querySelector('.lb-v2-fee-plan-pick__name') || {}).textContent || '',
        (selected.querySelector('.lb-v2-fee-plan-pick__meta') || {}).textContent || '',
        ''
      );
      var images = [];
      for (var i = 0; i < slotAddonImageSources.length; i++) {
        if (!slotAddonImageSources[i]) continue;
        var spec = getAddonCropSpec(kind, i);
        var url = null;
        if (spec) {
          var blob = null;
          try {
            blob = await bakeAddonCropToBlob(i, spec);
          } catch (bakeErr) {
            blob = null;
          }
          if (blob) {
            var croppedFile = new File(
              [blob],
              'addon-crop-' + (i + 1) + '.jpg',
              { type: 'image/jpeg' }
            );
            url = await uploadListingImageFile(croppedFile, 'cover');
          }
        }
        if (!url && slotAddonImageFiles[i]) {
          url = await uploadListingImageFile(slotAddonImageFiles[i], 'cover');
        }
        if (!url && isHttpsImageUrl(slotAddonImageSources[i])) {
          url = coerceDurablePublicImageUrl(slotAddonImageSources[i]);
        }
        if (!url) {
          showSlotAddonError('廣告圖上傳失敗，請再試一次。');
          return;
        }
        images.push({ src: url, uploaded: true });
      }

      var body = {
        vendor_slug: slug,
        parent_listing_id: parent.id,
        slot_id: parseInt(selected.getAttribute('data-addon-slot'), 10),
        fee_plan_id: parseInt(selected.getAttribute('data-addon-plan'), 10),
        exposure_start_at: start,
        exposure_end_at: end,
      };
      if (existingAddon) body.id = existingAddon.id;
      if (images.length) body.images_json = images;

      var saveRes = await fetch(PATHS.listingSave, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
      var savePayload = null;
      try { savePayload = await saveRes.json(); } catch (e) { savePayload = null; }
      if (!saveRes.ok || !savePayload || savePayload.ok !== true || !savePayload.listing) {
        var saveErr = extractApiError(savePayload || {});
        showSlotAddonError(saveErr.message || '加購儲存失敗');
        return;
      }

      var addonId = savePayload.listing.id;
      var submitRes = await fetch(PATHS.listingSubmit, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ vendor_slug: slug, listing_id: addonId }),
      });
      var submitPayload = null;
      try { submitPayload = await submitRes.json(); } catch (e) { submitPayload = null; }
      if (!submitRes.ok || !submitPayload || submitPayload.ok !== true) {
        var subErr = extractApiError(submitPayload || {});
        // 草稿已建立，維持在列表讓廠商修檔期後重送，不當成整筆失敗。
        closeModal();
        await loadListingTab();
        showListingAlert(
          (subErr.message || '送審失敗') + '（加購草稿 #' + addonId + ' 已保留，可修改檔期後再送審）',
          '送審未完成'
        );
        return;
      }

      closeModal();
      await loadListingTab();
      showListingSuccess(
        '廣告加購已送審（' + start + ' ~ ' + end + '）。官方核准後，未到檔期顯示「待上架」，到檔期自動進版位牆。',
        '已送出'
      );
    } catch (err) {
      showSlotAddonError(err.message || '加購失敗');
    } finally {
      slotAddonSubmitInFlight = false;
      setDataLoading(false);
    }
  }

  function confirmEditPrivateListing(listingId, onProceed) {
    var id = parseInt(listingId, 10);
    if (!id) return;
    var proceed = typeof onProceed === 'function'
      ? onProceed
      : function () { loadListingIntoForm(id); };
    setDataLoading(true, '檢查售票中…');
    fetchListingTicketCount(id).then(function (sold) {
      setDataLoading(false);
      if (!(sold > 0)) {
        proceed(id);
        return;
      }
      openModal({
        title: '編輯已上架／已下架課程？',
        bodyHtml:
          '<p class="lb-v2-modal__msg">此課已有 <strong>' + sold + '</strong> 張有效票。</p>' +
          '<p class="lb-v2-hint" style="margin-top:0.6rem">繼續編輯並儲存後，課程會改回<strong>草稿</strong>、商品會下架／封存；修改完成後需再按「確認上架」。已售票紀錄仍保留。</p>',
        actions: [
          { label: '取消', ghost: true, close: true },
          {
            label: '仍要編輯',
            accent: true,
            close: true,
            onClick: function () {
              proceed(id);
            },
          },
        ],
      });
    });
  }

  async function deleteListingById(listingId) {
    var slug = getListingVendorSlug();
    if (!slug) {
      showListingAlert('請先選擇單一廠商');
      return;
    }
    try {
      var response = await fetch(PATHS.listingDelete, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ vendor_slug: slug, listing_id: listingId }),
      });
      var rawText = await response.text();
      var payload = null;
      try { payload = rawText ? JSON.parse(rawText) : null; } catch (e) { payload = null; }
      if (payload && payload.ok) {
        var idEl = $('lb-v2-listing-id');
        if (idEl && String(idEl.value) === String(listingId)) clearListingForm();
        if (typeof loadPrivateScheduleTab === 'function') await loadPrivateScheduleTab();
        else await loadListingTab();
        var action = String(payload.action || 'deleted');
        var soldN = Number(payload.active_ticket_count || 0);
        showListingSuccess(
          action === 'retired'
            ? ('#' + listingId + ' 已下架並封存（有效票 ' + soldN + ' 張，紀錄保留）')
            : ('#' + listingId + ' 已刪除'),
          action === 'retired' ? '已下架' : '已刪除'
        );
      } else {
        var deleteErr = extractApiError(payload);
        showListingAlert(deleteErr.code ? '[' + deleteErr.code + '] ' + deleteErr.message : (deleteErr.message || '刪除失敗（後端可能尚未更新，請稍後再試）'), '刪除失敗');
      }
    } catch (err) {
      showListingAlert(err.message || '刪除失敗');
    }
  }

  // ── 購買即鎖曝光窗 ────────────────────────────────────
  // 付款／領取當下就把版位與檔期綁在課上，之後只能補內容。額度也在同一刻
  // 綁進這張課（single_unused 歸零），所以方案卡不能再走「剩餘額度」那條路
  // 重畫，否則載入草稿會看到「沒有可用方案」。

  var lockedWindowCtx = null;

  function isWindowLockedListing(item) {
    if (!item) return false;
    if (String(item.listing_mode || '').toUpperCase() === 'PRIVATE') return false;
    var st = String(item.listing_fee_status || '').toUpperCase();
    if (st !== 'PAID' && st !== 'WAIVED') return false;
    return !!(ymd(item.exposure_start_at) && ymd(item.exposure_end_at));
  }

  function setLockedWindowCtx(item) {
    lockedWindowCtx = isWindowLockedListing(item)
      ? {
          feePlanId: item.fee_plan_id || '',
          slotId: item.slot_id || '',
          slotName: item.slot_name || '',
          planName: resolveFeePlanLabelForListing(item),
          start: ymd(item.exposure_start_at),
          end: ymd(item.exposure_end_at),
          waived: String(item.listing_fee_status || '').toUpperCase() === 'WAIVED',
        }
      : null;
  }

  function lockedWindowPlanLabel() {
    if (!lockedWindowCtx) return '';
    if (lockedWindowCtx.planName) return lockedWindowCtx.planName;
    if (lockedWindowCtx.slotName) return '廣告版位：' + lockedWindowCtx.slotName;
    if (lockedWindowCtx.slotId) return '版位 #' + lockedWindowCtx.slotId;
    return '基礎上架（不綁版位）';
  }

  /** 一般廠商公開線：建課／編輯頁不可選日，只能選已鎖窗額度。官方／PRIVATE 除外。 */
  function usesPurchaseLockedListingForm(listingMode) {
    var mode = resolveListingMode(listingMode || '');
    if (mode === 'PRIVATE') return false;
    if (isOfficialFeeExemptVendor()) return false;
    return true;
  }

  function findListingItemById(id) {
    var want = String(id || '').trim();
    if (!want) return null;
    return (allListingItems || []).find(function (item) {
      return item && String(item.id) === want;
    }) || null;
  }

  /** 若編輯中草稿其實已鎖窗，把 ctx 救回（避免 async 重畫時誤開月曆）。 */
  function recoverLockedWindowCtxFromEditing() {
    if (lockedWindowCtx) return true;
    var editingId = String((($('lb-v2-listing-id') || {}).value) || '').trim();
    var item = findListingItemById(editingId);
    if (!item || !isWindowLockedListing(item)) return false;
    setLockedWindowCtx(item);
    return true;
  }

  /**
   * 購買即鎖窗後額度已綁進草稿，新建表單不會再看到「剩餘未綁」方案。
   * 這裡只列「基礎上架」（不綁公開牆）：slot_id 空、非加購子單。
   * 首頁彈窗等廣告版位窗走「課程廣告刊登」，不可混進此方案區。
   */
  function isBaseListingWindowItem(item) {
    if (!item) return false;
    if (isSlotAddonListing(item)) return false;
    if (isUnattachedAdWindow(item)) return false;
    var slotId = item.slot_id;
    if (slotId != null && slotId !== '' && Number(slotId) > 0) return false;
    return true;
  }

  function listPendingLockedBaseListings(mode) {
    var want = String(mode || '').toUpperCase();
    var byId = {};
    // 優先用 entitlement.pending_windows（與「已鎖定 N 檔」同一口徑），避免課程列表快取漏卡。
    var ent = findModeEntitlement(want);
    var windows = (ent && Array.isArray(ent.pending_windows)) ? ent.pending_windows : [];
    windows.forEach(function (item) {
      if (!item || item.id == null) return;
      if (!isBaseListingWindowItem(item)) return;
      if (want && String(item.listing_mode || '').toUpperCase() !== want) return;
      byId[String(item.id)] = Object.assign({}, item);
    });
    (allListingItems || []).forEach(function (item) {
      if (!isBaseListingWindowItem(item)) return;
      if (!isWindowLockedListing(item)) return;
      if (want && String(item.listing_mode || '').toUpperCase() !== want) return;
      var st = String(item.status || '').toUpperCase();
      if (st !== 'DRAFT' && st !== 'REJECTED') return;
      var id = String(item.id);
      byId[id] = Object.assign({}, byId[id] || {}, item);
    });
    return Object.keys(byId).map(function (k) { return byId[k]; }).sort(function (a, b) {
      return Number(b.id) - Number(a.id);
    });
  }

  var PENDING_LOCKED_MODE_ORDER = ['FULL', 'PROMO', 'EXPOSURE', 'PRIVATE'];

  /**
   * 上架頁不再讓廠商自選上架模式：一次列出所有 mode 已鎖窗的基礎上架額度，
   * 點選哪一張就套用那張的 mode（populateListingForm 會帶 applyListingModeUI）。
   */
  function listPendingLockedBaseListingsAllModes() {
    var byId = {};
    PENDING_LOCKED_MODE_ORDER.forEach(function (mode) {
      listPendingLockedBaseListings(mode).forEach(function (item) {
        if (!item || item.id == null) return;
        byId[String(item.id)] = item;
      });
    });
    return Object.keys(byId)
      .map(function (k) { return byId[k]; })
      .sort(function (a, b) {
        var ai = PENDING_LOCKED_MODE_ORDER.indexOf(String(a.listing_mode || '').toUpperCase());
        var bi = PENDING_LOCKED_MODE_ORDER.indexOf(String(b.listing_mode || '').toUpperCase());
        if (ai !== bi) return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
        return Number(b.id) - Number(a.id);
      });
  }

  /** 購買時的方案商品名 + 系統草稿編號（listing id）。 */
  function resolveFeePlanLabelForListing(item) {
    if (!item) return '基礎上架方案';
    var planName = item.fee_plan_name || item.plan_name || '';
    if (!planName) {
      var planId = item.fee_plan_id;
      var mode = String(item.listing_mode || '').toUpperCase();
      var slug = getListingVendorSlug() || '';
      var m = findModeEntitlement(mode);
      var bals = (m && m.slot_balances) || [];
      for (var i = 0; i < bals.length; i++) {
        if (planId && String(bals[i].fee_plan_id) === String(planId) && bals[i].plan_name) {
          planName = String(bals[i].plan_name);
          break;
        }
      }
      if (!planName) {
        var cached = cachedFeePlans[mode + '_' + slug] || cachedFeePlans['_' + slug] || [];
        for (var j = 0; j < cached.length; j++) {
          if (planId && String(cached[j].id) === String(planId) && cached[j].name) {
            planName = String(cached[j].name);
            break;
          }
        }
      }
    }
    // （待填）{方案名} {起}~{迄} → 抽出方案名當後備
    if (!planName && item.title) {
      var rawTitle = String(item.title || '');
      if (rawTitle.indexOf('（待填）') === 0) {
        planName = rawTitle
          .replace(/^（待填）/, '')
          .replace(/\s+\d{4}-\d{2}-\d{2}\s*[~～].*$/, '')
          .trim();
      }
    }
    var listingId = item.id != null && String(item.id).trim() !== '' ? String(item.id) : '';
    if (planName && listingId) return planName + ' · #' + listingId;
    if (planName) return planName;
    if (listingId) return '基礎上架 · #' + listingId;
    return item.fee_plan_id ? ('方案 #' + item.fee_plan_id) : '基礎上架方案';
  }

  function hasListingPlanSelection() {
    // 購買即鎖窗：有草稿 id 不算已選方案（未鎖窗舊稿仍須點額度卡）。
    if (lockedWindowCtx) return true;
    var planHidden = $('lb-v2-listing-fee-plan');
    if (!planHidden) return false;
    if (planHidden.getAttribute('data-official-direct-slot') === '1') {
      return !!(planHidden.getAttribute('data-slot-id') || '').trim();
    }
    if (planHidden.getAttribute('data-pending-locked-id')) return true;
    return !!(String(planHidden.value || '').trim());
  }

  /** 點選「已鎖檔期」額度卡：載入該草稿（窗綁在那張單上，不能掛到別張未鎖窗稿）。 */
  function selectPendingLockedListing(item, opts) {
    opts = opts || {};
    if (!item || !item.id) return;
    if (listingFormReadOnly) return;
    var curId = String((($('lb-v2-listing-id') || {}).value) || '').trim();
    var targetId = String(item.id);
    if (curId && curId === targetId) {
      setLockedWindowCtx(item);
      renderLockedWindowUi();
      syncListingContentGate();
      return;
    }
    if (curId && curId !== targetId) {
      var curItem = findListingItemById(curId);
      var curLocked = !!(curItem && isWindowLockedListing(curItem)) || !!lockedWindowCtx;
      var msg = curLocked
        ? ('目前正在編輯已鎖定檔期的草稿 #' + curId +
          '。改選另一檔額度會改開草稿 #' + targetId + '（檔期綁在該草稿上）。確定切換？')
        : ('此額度的檔期綁在草稿 #' + targetId +
          '。將改開該草稿填寫內容；目前未鎖窗的草稿 #' + curId + ' 仍留在列表，不會自動帶入內容。確定開啟？');
      if (opts.skipConfirm) {
        loadListingIntoForm(item.id);
        return;
      }
      openModal({
        title: '改用此額度方案？',
        bodyHtml: '<p style="margin:0;">' + escapeHtml(msg) + '</p>',
        actions: [
          { label: '取消', ghost: true, close: true },
          {
            label: '開啟該草稿',
            accent: true,
            close: true,
            onClick: function () {
              loadListingIntoForm(item.id);
            },
          },
        ],
      });
      return;
    }
    loadListingIntoForm(item.id);
  }

  /** 有額度但尚未選方案時，鎖住方案區以下欄位，避免白填。 */
  function syncListingContentGate() {
    var form = $('lb-v2-listing-form');
    var formSection = $('lb-v2-listing-form-section');
    if (!form) return;
    var sectionLocked = !!(formSection && formSection.classList.contains('is-locked'));
    var awaiting = !sectionLocked && !hasListingPlanSelection();
    form.classList.toggle('is-awaiting-plan', awaiting);
    Array.prototype.forEach.call(form.children, function (child) {
      if (!child || child.nodeType !== 1) return;
      if (child.id === 'lb-v2-listing-id') return;
      if (child.id === 'lb-v2-listing-fee-notice') return;
      if (child.id === 'lb-v2-listing-plan-gate-hint') return;
      if (child.querySelector && child.querySelector('#lb-v2-listing-mode-slot')) return;
      child.classList.toggle('lb-v2-listing-content-locked', awaiting);
      var nodes = child.querySelectorAll('input, textarea, select, button');
      Array.prototype.forEach.call(nodes, function (el) {
        if (awaiting) {
          if (!el.hasAttribute('data-lb-content-prev-disabled')) {
            el.setAttribute('data-lb-content-prev-disabled', el.disabled ? '1' : '0');
          }
          el.disabled = true;
        } else if (el.hasAttribute('data-lb-content-prev-disabled')) {
          el.disabled = el.getAttribute('data-lb-content-prev-disabled') === '1';
          el.removeAttribute('data-lb-content-prev-disabled');
        }
      });
    });
    var gateHint = $('lb-v2-listing-plan-gate-hint');
    if (awaiting) {
      if (!gateHint) {
        gateHint = document.createElement('p');
        gateHint.id = 'lb-v2-listing-plan-gate-hint';
        gateHint.className = 'lb-v2-hint lb-v2-listing-plan-gate-hint';
        var feeNotice = $('lb-v2-listing-fee-notice');
        if (feeNotice && feeNotice.parentNode) {
          feeNotice.parentNode.insertBefore(gateHint, feeNotice.nextSibling);
        } else {
          form.insertBefore(gateHint, form.children[2] || null);
        }
      }
      gateHint.hidden = false;
      gateHint.textContent = '請先在上方選擇額度方案後，再填寫下方課程內容。';
    } else if (gateHint) {
      gateHint.hidden = true;
    }
  }

  var pendingPlanSelectItems = {};
  var pendingPlanSelectValue = '';
  var pendingPlanSelectBound = false;

  /** 官方／資格限定課仍用卡片挑方案；下拉只服務「購買即鎖窗」額度。 */
  function usePlanPickerCards() {
    var sel = $('lb-v2-listing-plan-select');
    var planList = $('lb-v2-listing-fee-plan-list');
    if (sel) sel.hidden = true;
    if (planList) planList.hidden = false;
  }

  /**
   * 方案下拉：依上架模式分組列出已鎖窗額度。
   * 選定哪一組就等於選定該模式，草稿載入後 applyListingModeUI 會換掉下方欄位。
   */
  function renderPendingLockedPlanSelect(items, selectedId) {
    var sel = $('lb-v2-listing-plan-select');
    var planList = $('lb-v2-listing-fee-plan-list');
    if (!sel) return false;
    pendingPlanSelectItems = {};
    sel.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = (items || []).length
      ? '請選擇方案（依上架模式分組）'
      : '目前沒有可用的基礎上架額度';
    sel.appendChild(placeholder);
    var groups = {};
    (items || []).forEach(function (item) {
      if (!item || item.id == null) return;
      var itemMode = String(item.listing_mode || '').toUpperCase();
      if (!groups[itemMode]) {
        var group = document.createElement('optgroup');
        group.label = modeLabel(itemMode);
        sel.appendChild(group);
        groups[itemMode] = group;
      }
      var start = ymd(item.exposure_start_at);
      var end = ymd(item.exposure_end_at);
      var bits = [resolveFeePlanLabelForListing(item)];
      if (start && end) bits.push(start + ' ～ ' + end);
      var opt = document.createElement('option');
      opt.value = String(item.id);
      opt.textContent = bits.join('  ·  ');
      groups[itemMode].appendChild(opt);
      pendingPlanSelectItems[String(item.id)] = item;
    });
    pendingPlanSelectValue = selectedId != null ? String(selectedId) : '';
    sel.value = pendingPlanSelectValue;
    sel.disabled = !!listingFormReadOnly;
    sel.hidden = false;
    if (planList) planList.hidden = true;
    if (!pendingPlanSelectBound) {
      pendingPlanSelectBound = true;
      sel.addEventListener('change', function () {
        var wanted = String(sel.value || '');
        // 先還原；切換成功後由 renderLockedWindowUi 重畫成新選項。
        sel.value = pendingPlanSelectValue;
        if (!wanted || wanted === pendingPlanSelectValue) return;
        var picked = pendingPlanSelectItems[wanted];
        if (picked) selectPendingLockedListing(picked);
      });
    }
    return true;
  }

  function renderPendingLockedPickUi(listingMode, pendingItems) {
    var planList = $('lb-v2-listing-fee-plan-list');
    var planHidden = $('lb-v2-listing-fee-plan');
    var slotWrap = $('lb-v2-listing-slot-wrap');
    var hint = document.querySelector('#lb-v2-listing-slot-wrap .lb-v2-slot-grant-hint');
    var exposureWrap = $('lb-v2-listing-exposure-wrap');
    if (!planList) return false;
    if (planHidden) {
      planHidden.value = '';
      planHidden.required = false;
      planHidden.removeAttribute('data-slot-id');
      planHidden.removeAttribute('data-duration-days');
      planHidden.removeAttribute('data-max-interval-days');
      planHidden.removeAttribute('data-grant-expires');
      planHidden.removeAttribute('data-plan-type');
      planHidden.removeAttribute('data-slot-name');
      planHidden.removeAttribute('data-plan-name');
      planHidden.removeAttribute('data-official-direct-slot');
    }
    planList.innerHTML = '';
    var lastGroup = '';
    (pendingItems || []).forEach(function (item) {
      var itemMode = String(item.listing_mode || '').toUpperCase();
      if (itemMode !== lastGroup) {
        lastGroup = itemMode;
        var group = document.createElement('p');
        group.className = 'lb-v2-fee-plan-pick__group';
        group.textContent = modeLabel(itemMode);
        planList.appendChild(group);
      }
      var start = ymd(item.exposure_start_at);
      var end = ymd(item.exposure_end_at);
      var planLabel = resolveFeePlanLabelForListing(item);
      var metaBits = [];
      if (start && end) metaBits.push('已鎖定 ' + start + ' ～ ' + end);
      metaBits.push(String(item.listing_fee_status || '').toUpperCase() === 'WAIVED' ? '已免除上架費' : '已付款');
      metaBits.push('點選後填寫內容');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lb-v2-fee-plan-pick__item';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-pending-locked-id', String(item.id));
      btn.setAttribute('data-listing-mode', itemMode);
      btn.setAttribute('data-plan-id', item.fee_plan_id ? String(item.fee_plan_id) : '');
      btn.setAttribute('data-plan-name', planLabel);
      btn.innerHTML =
        '<span class="lb-v2-fee-plan-pick__name">' + escapeHtml(planLabel) + '</span>' +
        '<span class="lb-v2-fee-plan-pick__meta">' + escapeHtml(metaBits.join(' · ')) + '</span>';
      btn.addEventListener('click', function () {
        if (listingFormReadOnly) return;
        selectPendingLockedListing(item);
      });
      planList.appendChild(btn);
    });
    renderPendingLockedPlanSelect(pendingItems || [], '');
    if (slotWrap) slotWrap.hidden = false;
    if (hint) {
      hint.textContent = '請點選上方基礎上架額度後再填寫課程內容；檔期於購買時已鎖定，不可更換。';
    }
    if (exposureWrap) {
      exposureWrap.hidden = true;
      var cal = $('lb-v2-exposure-calendar');
      if (cal) cal.innerHTML = '';
    }
    syncListingContentGate();
    return true;
  }

  /** 把方案卡與月曆換成唯讀說明；回傳 false 代表這張課沒鎖窗，走原流程。 */
  function renderLockedWindowUi() {
    if (!lockedWindowCtx) return false;
    var planList = $('lb-v2-listing-fee-plan-list');
    var planHidden = $('lb-v2-listing-fee-plan');
    var slotHidden = $('lb-v2-listing-slot');
    var slotWrap = $('lb-v2-listing-slot-wrap');
    var exposureWrap = $('lb-v2-listing-exposure-wrap');
    var slotTitle = $('lb-v2-listing-exposure-slot-title');
    var hint = document.querySelector('#lb-v2-listing-slot-wrap .lb-v2-slot-grant-hint');
    var cal = $('lb-v2-exposure-calendar');
    var editingIdForLabel = String((($('lb-v2-listing-id') || {}).value) || '').trim();
    var modeForLabel = resolveListingMode((($('lb-v2-listing-mode') || {}).value) || '');
    var labelItem =
      findListingItemById(editingIdForLabel) ||
      listPendingLockedBaseListings(modeForLabel).find(function (it) {
        return it && String(it.id) === editingIdForLabel;
      }) ||
      null;
    var label = labelItem
      ? resolveFeePlanLabelForListing(labelItem)
      : lockedWindowPlanLabel();
    if (labelItem) {
      lockedWindowCtx.planName = label;
      if (labelItem.fee_plan_name) lockedWindowCtx.feePlanName = labelItem.fee_plan_name;
    }

    updateListingImageHint(
      lockedWindowCtx.slotName,
      label,
      resolveListingMode((($('lb-v2-listing-mode') || {}).value) || '')
    );
    if (planHidden) {
      planHidden.value = lockedWindowCtx.feePlanId ? String(lockedWindowCtx.feePlanId) : '';
      planHidden.required = false;
      planHidden.setAttribute('data-slot-id', lockedWindowCtx.slotId ? String(lockedWindowCtx.slotId) : '');
      planHidden.setAttribute('data-slot-name', lockedWindowCtx.slotName || '');
      planHidden.setAttribute('data-plan-name', label);
      planHidden.setAttribute('data-plan-type', 'SINGLE');
      planHidden.setAttribute('data-duration-days', '');
      planHidden.setAttribute('data-max-interval-days', '');
      planHidden.setAttribute('data-grant-expires', '');
      planHidden.setAttribute('data-official-direct-slot', '0');
      var editingIdForPlan = String((($('lb-v2-listing-id') || {}).value) || '').trim();
      if (editingIdForPlan) planHidden.setAttribute('data-pending-locked-id', editingIdForPlan);
      else planHidden.removeAttribute('data-pending-locked-id');
    }
    if (slotHidden) slotHidden.value = lockedWindowCtx.slotId ? String(lockedWindowCtx.slotId) : '';
    var editingIdForOthers = String((($('lb-v2-listing-id') || {}).value) || '').trim();
    var otherPending = listPendingLockedBaseListingsAllModes().filter(function (item) {
      return item && String(item.id) !== editingIdForOthers;
    });
    var currentIsBase = isBaseListingWindowItem(
      labelItem || {
        slot_id: lockedWindowCtx.slotId,
        parent_listing_id: null,
      }
    );
    if (planList) {
      planList.innerHTML = '';
      var headCur = document.createElement('p');
      headCur.className = 'lb-v2-fee-plan-pick__group';
      headCur.textContent = currentIsBase
        ? '目前使用中的額度（基礎上架）'
        : '目前草稿綁的是廣告版位（不是基礎上架）';
      planList.appendChild(headCur);
      var lockedCard = document.createElement('div');
      lockedCard.className = 'lb-v2-fee-plan-pick__item is-selected is-locked';
      lockedCard.setAttribute('aria-disabled', 'true');
      lockedCard.innerHTML =
        '<span class="lb-v2-fee-plan-pick__name">' + escapeHtml(label) + '</span>' +
        '<span class="lb-v2-fee-plan-pick__meta">' +
          (lockedWindowCtx.waived ? '已免除上架費' : '已付款') +
          ' · 已鎖定 ' + escapeHtml(lockedWindowCtx.start) + ' ～ ' + escapeHtml(lockedWindowCtx.end) +
          ' · 不可更換</span>';
      planList.appendChild(lockedCard);

      if (otherPending.length) {
        var lastOtherGroup = '';
        otherPending.forEach(function (item) {
          var itemMode = String(item.listing_mode || '').toUpperCase();
          if (itemMode !== lastOtherGroup) {
            lastOtherGroup = itemMode;
            var headOther = document.createElement('p');
            headOther.className = 'lb-v2-fee-plan-pick__group';
            headOther.textContent = modeLabel(itemMode);
            planList.appendChild(headOther);
          }
          var start = ymd(item.exposure_start_at);
          var end = ymd(item.exposure_end_at);
          var planLabel = resolveFeePlanLabelForListing(item);
          var metaBits = [];
          if (start && end) metaBits.push('已鎖定 ' + start + ' ～ ' + end);
          metaBits.push(String(item.listing_fee_status || '').toUpperCase() === 'WAIVED' ? '已免除上架費' : '已付款');
          metaBits.push('點選改開該草稿');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lb-v2-fee-plan-pick__item';
          btn.setAttribute('role', 'option');
          btn.setAttribute('data-pending-locked-id', String(item.id));
          btn.setAttribute('data-listing-mode', itemMode);
          btn.setAttribute('data-plan-id', item.fee_plan_id ? String(item.fee_plan_id) : '');
          btn.setAttribute('data-plan-name', planLabel);
          btn.innerHTML =
            '<span class="lb-v2-fee-plan-pick__name">' + escapeHtml(planLabel) + '</span>' +
            '<span class="lb-v2-fee-plan-pick__meta">' + escapeHtml(metaBits.join(' · ')) + '</span>';
          btn.addEventListener('click', function () {
            selectPendingLockedListing(item);
          });
          planList.appendChild(btn);
        });
      }
    }
    var currentPlanItem = labelItem || {
      id: editingIdForOthers,
      listing_mode: resolveListingMode((($('lb-v2-listing-mode') || {}).value) || ''),
      fee_plan_id: lockedWindowCtx.feePlanId,
      fee_plan_name: lockedWindowCtx.feePlanName || lockedWindowCtx.planName || '',
      exposure_start_at: lockedWindowCtx.start,
      exposure_end_at: lockedWindowCtx.end,
      listing_fee_status: lockedWindowCtx.waived ? 'WAIVED' : 'PAID',
    };
    renderPendingLockedPlanSelect(
      (currentPlanItem.id ? [currentPlanItem] : []).concat(otherPending),
      currentPlanItem.id ? String(currentPlanItem.id) : ''
    );
    if (slotWrap) slotWrap.hidden = false;
    if (hint) {
      if (!currentIsBase) {
        hint.textContent =
          '「基礎上架」是指不綁公開牆的方案。首頁彈窗等廣告版位請到「課程廣告刊登」處理；下方若有基礎上架額度，可點選改開對應草稿。';
      } else {
        hint.textContent = otherPending.length
          ? '此課檔期已鎖定（上方第一張）。若要改用其他已鎖定基礎上架額度，請點選下方方案改開對應草稿；需要改期請重新購買檔期。'
          : '此課的版位與檔期在購買時已鎖定，補完內容即可送審；需要改期請重新購買檔期。';
      }
    }
    // 檔期購買時已鎖定且不可改，方案卡上已標日期：整個曝光檔期區塊不再呈現。
    if (exposureWrap) exposureWrap.hidden = true;
    if (slotTitle) slotTitle.textContent = label + ' → 已鎖定檔期';
    if (cal) cal.innerHTML = '';
    var startEl = $('lb-v2-listing-exposure-start');
    var endEl = $('lb-v2-listing-exposure-end');
    if (startEl) startEl.value = lockedWindowCtx.start;
    if (endEl) endEl.value = lockedWindowCtx.end;
    syncExposureDateDisplays();
    syncListingContentGate();
    return true;
  }

  function populateListingForm(item) {
    item = normalizeListingItem(item) || {};
    setLockedWindowCtx(item);
    var idEl = $('lb-v2-listing-id');
    if (idEl) idEl.value = item.id || '';
    setListingFormTrackIds(item.id ? item : null);

    var modeEl = $('lb-v2-listing-mode');
    var mode = item.listing_mode || 'FULL';
    if (modeEl) {
      if (mode === 'PRIVATE') {
        privateModeLocked = true;
        ensurePrivateModeOption();
        modeEl.value = 'PRIVATE';
        modeEl.disabled = true;
      } else {
        privateModeLocked = false;
        modeEl.disabled = false;
        removePrivateModeOptionIfUnlocked();
        modeEl.value = mode;
      }
    }
    applyListingModeUI(mode);

    var pendingTitle = item.title || '';
    if (/^（待填）/.test(String(pendingTitle).trim()) || isUnattachedAdWindow(item)) {
      pendingTitle = '';
    }
    var map = {
      'lb-v2-listing-title': pendingTitle,
      'lb-v2-listing-desc': item.description,
      'lb-v2-listing-highlight-notes': item.highlight_notes || '',
      'lb-v2-listing-venue': item.venue_name,
      'lb-v2-listing-instructor': item.instructor || '',
      'lb-v2-listing-organizer': item.organizer || '',
      'lb-v2-listing-co-organizer': item.co_organizer || '',
      'lb-v2-listing-maps-url': item.maps_url,
      'lb-v2-listing-external-url': item.external_purchase_url,
    };
    Object.keys(map).forEach(function (eid) {
      var el = $(eid);
      if (el) el.value = map[eid] || '';
    });
    if (mode === 'PRIVATE') {
      mountCalSwatches(
        'lb-v2-listing-cal-swatches',
        'lb-v2-listing-calendar-color',
        item.calendar_color || defaultCalSwatchColor()
      );
    }
    setCityCodes(item.city_codes || []);
    applyAddressFromListing(item.address || '', item.city_codes || []);
    writeDateTimePair('lb-v2-listing-start-date', 'lb-v2-listing-start-time', item.start_at);
    writeDateTimePair('lb-v2-listing-end-date', 'lb-v2-listing-end-time', item.end_at);

    var pendingCat = item.category || '';
    var pendingSub = item.subcategory || '';
    refreshCategoryOptions(pendingCat);
    refreshSubcategoryOptions(pendingSub);
    ensureTaxonomyLoaded().then(function () {
      refreshCategoryOptions(pendingCat);
      refreshSubcategoryOptions(pendingSub);
    });

    var cp = $('lb-v2-listing-cancel-policy');
    if (cp) cp.value = 'STANDARD';
    updateCancelPolicyDetail();

    var cutoffMode = $('lb-v2-listing-cutoff-mode');
    if (cutoffMode) cutoffMode.value = 'FIXED_TIME';
    var cutoffTime = $('lb-v2-listing-cutoff-time');
    if (cutoffTime) cutoffTime.value = '23:59';
    var minAtt = $('lb-v2-listing-min-attendees');
    if (minAtt) minAtt.value = item.course_min_attendees || '';
    updateCancelPolicyDetail();
    updatePolicyExample();
    refreshAutoNotesPreview();

    var feeAmtEl = $('lb-v2-listing-fee-amount');
    var feeStatusEl = $('lb-v2-listing-fee-status-text');
    if (feeAmtEl) feeAmtEl.textContent = item.listing_fee != null ? 'NT$' + item.listing_fee : '未設定';
    var feeLabels = { NOT_REQUIRED: '不需要', PENDING: '待付款', PAID: '已付款', WAIVED: '已免除', PENDING_REVIEW: '待審核' };
    if (feeStatusEl) {
      feeStatusEl.textContent = feeLabels[item.listing_fee_status] || item.listing_fee_status || '—';
      // 送審與編輯器的解鎖判斷改讀這個 enum，不再比對上面那行的中文字。
      // 比對顯示文字的話，只要有人改了 feeLabels 的措辭，權限判斷就會靜默失效。
      feeStatusEl.setAttribute('data-fee-status', String(item.listing_fee_status || '').toUpperCase());
    }

    var planSel = $('lb-v2-listing-fee-plan');
    if (planSel && item.fee_plan_id) {
      planSel.setAttribute('data-pending-plan-id', String(item.fee_plan_id));
      planSel.value = String(item.fee_plan_id);
    }
    var slotSel = $('lb-v2-listing-slot');
    if (slotSel) slotSel.value = item.slot_id || '';

    var expStart = $('lb-v2-listing-exposure-start');
    var expEnd = $('lb-v2-listing-exposure-end');
    if (expStart) expStart.value = item.exposure_start_at ? item.exposure_start_at.slice(0, 10) : '';
    if (expEnd) expEnd.value = item.exposure_end_at ? item.exposure_end_at.slice(0, 10) : '';
    syncExposureDateDisplays();
    // 已鎖窗：立刻畫唯讀 UI，勿等 refreshListingSlotOptions 才補；也避免誤開月曆。
    if (lockedWindowCtx) {
      renderLockedWindowUi();
    } else {
      applySelectedFeePlan({ keepDates: true });
    }

    var vc = $('lb-v2-listing-variants');
    if (vc) vc.innerHTML = '';
    listingVariantCount = 0;
    var variants = Array.isArray(item.variants_json) ? item.variants_json : [];
    variants.forEach(function (v) { addVariantRow(v.name, v.price, v.quantity); });
    if (variants.length === 0) addVariantRow('', '', '');

    clearImagePreviews();
    setListingImageSources(extractListingImageSources(item));
    clearDescImagePreviews();
    setDescImageSources(extractDescImageSources(item));

    applySeatHoldHint(item);
    applyListingGate();
  }

  /**
   * After an unpublish the original window stays reserved, so offer a one-click
   * way back to it: the vendor may find their preferred new dates already taken.
   */
  function applySeatHoldHint(item) {
    var existing = $('lb-v2-listing-seat-hold-hint');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    var wrap = $('lb-v2-listing-exposure-wrap');
    if (!wrap || !listingSeatHoldActive(item)) return;
    var start = String(item.seat_hold_start).slice(0, 10);
    var end = String(item.seat_hold_end).slice(0, 10);
    var until = String(item.seat_hold_until).slice(0, 10);
    var box = document.createElement('div');
    box.id = 'lb-v2-listing-seat-hold-hint';
    box.className = 'lb-v2-notice lb-v2-notice--info';
    box.style.marginTop = '0.5rem';
    box.innerHTML =
      '<p style="margin:0 0 0.4rem">原曝光檔期 <strong>' + escapeHtml(start) + ' ～ ' + escapeHtml(end) +
      '</strong> 已為你保留至 <strong>' + escapeHtml(until) + '</strong>，其他廠商無法選走。</p>' +
      '<button type="button" class="lb-v2-btn lb-v2-btn--sm" id="lb-v2-listing-seat-hold-apply">沿用原檔期</button>';
    wrap.appendChild(box);
    var btn = $('lb-v2-listing-seat-hold-apply');
    if (btn) {
      btn.addEventListener('click', function () {
        var startEl = $('lb-v2-listing-exposure-start');
        var endEl = $('lb-v2-listing-exposure-end');
        if (startEl) startEl.value = start;
        if (endEl) endEl.value = end;
        highlightSelectedExposureDays();
        syncExposureDateDisplays();
        focusExposureCalendar();
      });
    }
  }

  var STATUS_LABELS = {
    DRAFT: '草稿', PENDING_REVIEW: '審核中', REJECTED: '駁回',
    APPROVED: '待上架', PUBLISHED: '已上架', UNPUBLISHED: '已下架',
  };

  // ── 廣告版位加購（子單）─────────────────────────────────
  // 加購單 parent_listing_id 指向基礎上架單，共用同一個 LadyBae 商品，
  // 只負責自己的檔期進出該版位牆。

  var ADDON_PARENT_STATUSES = { APPROVED: 1, PUBLISHED: 1, UNPUBLISHED: 1 };
  var LISTING_MODE_TEXT = {
    FULL: '宣傳刊登（含金流）', EXPOSURE: '純上架', PROMO: '宣傳刊登（不含金流）', PRIVATE: '資格限定課',
  };

  function todayYmdTw() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit',
      }).format(new Date());
    } catch (e) {
      return new Date().toISOString().slice(0, 10);
    }
  }

  function ymd(value) {
    var raw = String(value || '').trim();
    return raw ? raw.slice(0, 10) : '';
  }

  var STATUS_COLORS = {
    DRAFT: '#888', PENDING_REVIEW: '#e8a317', REJECTED: '#c0392b',
    APPROVED: '#27ae60', PUBLISHED: '#2980b9', UNPUBLISHED: '#95a5a6',
  };

  /** True when UNPUBLISHED looks like pre-window park (not manual take-down). */
  function isParkedBeforeExposure(item) {
    if (!item) return false;
    if (String(item.status || '').toUpperCase() !== 'UNPUBLISHED') return false;
    if (item.unpublished_at || item.unpublish_reason) return false;
    if (item.unpublish_request_at && !item.unpublish_request_resolved_at) return false;
    var start = ymd(item.exposure_start_at);
    if (!start) return false;
    return start > todayYmdTw();
  }

  /**
   * 廠商可見狀態（圖一）：草稿／審核中／待上架／已上架／已完成
   * 支線保留：駁回、已下架（真的下架，非未到檔期 park）。
   */
  function listingDisplayStatus(item) {
    if (!item) return { key: '', label: '—', color: '#888' };
    var status = String(item.status || '').toUpperCase();
    var today = todayYmdTw();
    var start = ymd(item.exposure_start_at);
    var end = ymd(item.exposure_end_at);
    var colors = STATUS_COLORS;

    if (status === 'DRAFT') {
      return { key: 'DRAFT', label: '草稿', color: colors.DRAFT };
    }
    if (status === 'PENDING_REVIEW') {
      return { key: 'PENDING_REVIEW', label: '審核中', color: colors.PENDING_REVIEW };
    }
    if (status === 'REJECTED') {
      return { key: 'REJECTED', label: '駁回', color: colors.REJECTED };
    }

    // 檔期已過：自然結束＝已完成（優先於「已下架」主標，除非明確人工下架紀錄）
    if (end && end < today) {
      if (status === 'UNPUBLISHED' && (item.unpublished_at || item.unpublish_reason)) {
        return { key: 'UNPUBLISHED', label: '已下架', color: colors.UNPUBLISHED };
      }
      return { key: 'COMPLETED', label: '已完成', color: '#7f8c8d' };
    }

    // 核准後／未到曝光日：待上架（含誤寫成 UNPUBLISHED 的 park）
    if (status === 'APPROVED') {
      return { key: 'PENDING_SHELF', label: '待上架', color: '#2980b9' };
    }
    if (status === 'PUBLISHED' && start && start > today) {
      return { key: 'PENDING_SHELF', label: '待上架', color: '#2980b9' };
    }
    if (isParkedBeforeExposure(item)) {
      return { key: 'PENDING_SHELF', label: '待上架', color: '#2980b9' };
    }

    if (status === 'UNPUBLISHED') {
      return { key: 'UNPUBLISHED', label: '已下架', color: colors.UNPUBLISHED };
    }

    if (status === 'PUBLISHED' || item.slot_wall_state === 'IN') {
      return { key: 'PUBLISHED', label: '已上架', color: colors.PUBLISHED };
    }

    return {
      key: status || 'UNKNOWN',
      label: STATUS_LABELS[status] || status || '—',
      color: colors[status] || '#888',
    };
  }

  /** 待上架／已上架／已完成 — 與 listingDisplayStatus 同口徑（給加購列／副標）。 */
  function exposureStageLabel(item) {
    if (!item) return '';
    return listingDisplayStatus(item).label || '';
  }

  function isSlotAddonListing(item) {
    return !!(item && item.parent_listing_id != null && item.parent_listing_id !== '');
  }

  /**
   * 營運結帳先買的版位窗（待套用）。
   * 不可用「有 slot 且無 parent」一刀切——官方／舊主單也可能帶 slot。
   * 與後端 isUnattachedAdWindowListing 對齊：PURCHASE_HOLD 或標題「（待填）」。
   */
  function isUnattachedAdWindow(item) {
    if (!item || isSlotAddonListing(item)) return false;
    var slotId = item.slot_id;
    if (slotId == null || slotId === '' || Number(slotId) <= 0) return false;
    var src = String(item.listing_fee_source || '').toUpperCase();
    if (src === 'PURCHASE_HOLD') return true;
    return String(item.title || '').indexOf('（待填）') === 0;
  }

  function isPayableUnattachedAdWindow(item) {
    if (!isUnattachedAdWindow(item)) return false;
    var fee = String(item.listing_fee_status || '').toUpperCase();
    if (fee !== 'PAID' && fee !== 'WAIVED') return false;
    var st = String(item.status || '').toUpperCase();
    return st === 'DRAFT' || st === 'REJECTED';
  }

  /**
   * 已通過審核、檔期未過的基礎上架單才能再掛廣告。
   * 條件必須與後端 loadAddonParent 一致，否則按鈕點下去才被打回。
   */
  function canAddSlotAddon(item) {
    if (!item || isSlotAddonListing(item) || isUnattachedAdWindow(item)) return false;
    if (String(item.listing_mode || '').toUpperCase() === 'PRIVATE') return false;
    var status = String(item.status || '').toUpperCase();
    if (!ADDON_PARENT_STATUSES[status]) return false;
    if (String(item.course_decision_status || '').toUpperCase() === 'CANCELLED') return false;
    var today = todayYmdTw();
    var start = ymd(item.exposure_start_at);
    var end = ymd(item.exposure_end_at);
    if (end && end < today) return false;
    // 檔期尚未開始的 UNPUBLISHED 只是上架排程還沒到；檔期已開始卻 UNPUBLISHED
    // 代表課程真的被下架了，商品已封存，此時掛廣告只會得到一張死卡。
    if (status === 'UNPUBLISHED' && (!start || start <= today)) return false;
    return true;
  }

  function hasAddonEligibleParent(mode) {
    var want = String(mode || '').toUpperCase();
    return (allListingItems || []).some(function (item) {
      if (want && String(item.listing_mode || '').toUpperCase() !== want) return false;
      return canAddSlotAddon(item);
    });
  }

  /** 加購閘道文案：前台有課 ≠ 此模式可加購，把真正原因說清楚。 */
  function addonEligibleGateMessage(mode) {
    var want = String(mode || '').toUpperCase();
    var modeLabel = LISTING_MODE_TEXT[want] || want || '此模式';
    var sameModeBase = [];
    var pending = [];
    var expired = [];
    var cancelled = [];
    var today = todayYmdTw();
    (allListingItems || []).forEach(function (item) {
      if (!item || isSlotAddonListing(item) || isUnattachedAdWindow(item)) return;
      if (String(item.listing_mode || '').toUpperCase() === 'PRIVATE') return;
      if (want && String(item.listing_mode || '').toUpperCase() !== want) return;
      sameModeBase.push(item);
      var status = String(item.status || '').toUpperCase();
      var end = ymd(item.exposure_end_at);
      if (String(item.course_decision_status || '').toUpperCase() === 'CANCELLED') cancelled.push(item);
      else if (end && end < today) expired.push(item);
      else if (!ADDON_PARENT_STATUSES[status]) pending.push(item);
    });
    if (hasAddonEligibleParent(want)) return '';

    var otherEligible = (allListingItems || []).filter(canAddSlotAddon);
    if (!sameModeBase.length && otherEligible.length) {
      var counts = {};
      otherEligible.forEach(function (item) {
        var m = String(item.listing_mode || '').toUpperCase();
        counts[m] = (counts[m] || 0) + 1;
      });
      var bits = Object.keys(counts).map(function (m) {
        return (LISTING_MODE_TEXT[m] || m) + ' ' + counts[m] + ' 堂';
      });
      return '「' + modeLabel + '」尚無可加購課程。你目前可加購的課在：' + bits.join('、') +
        '（請切到對應分頁）。前台近期課程若屬其他模式，這裡不會算進來。';
    }
    if (!sameModeBase.length) {
      return '「' + modeLabel + '」尚無已審核的基礎上架課可掛廣告。' +
        '前台有課不代表可加購：需為同一廠商、同一模式，且狀態為已核准／已上架（草稿／待審不算）。';
    }
    if (pending.length) {
      return '「' + modeLabel + '」有 ' + sameModeBase.length +
        ' 堂基礎課，但尚未通過審核（草稿／待審／拒件不能加購）。請到「課程管理」送審並等官方核准。';
    }
    if (expired.length) {
      return '「' + modeLabel + '」的基礎課曝光檔期已結束，無法再加購廣告版位。';
    }
    if (cancelled.length) {
      return '「' + modeLabel + '」相關課程已取消開課，無法加購。';
    }
    return '尚無可加購的課程 — 請先完成基礎上架並通過審核。';
  }

  /** 課程日期欄：課程起（～迄）台北日；沒有課程時間就退回曝光檔期。 */
  function listingCourseDateLabel(item) {
    var start = ymdFromListingStart(item && item.start_at);
    var end = ymdFromListingStart(item && item.end_at);
    if (start) return end && end !== start ? start + ' ~ ' + end : start;
    var expStart = ymd(item && item.exposure_start_at);
    var expEnd = ymd(item && item.exposure_end_at);
    if (!expStart) return '—';
    return (expEnd && expEnd !== expStart ? expStart + ' ~ ' + expEnd : expStart) + '（曝光）';
  }

  /** 複數日期改兩行，避免被右側名稱 chip 蓋住。 */
  function listingCourseDateHtml(item) {
    var start = ymdFromListingStart(item && item.start_at);
    var end = ymdFromListingStart(item && item.end_at);
    var suffix = '';
    if (!start) {
      start = ymd(item && item.exposure_start_at);
      end = ymd(item && item.exposure_end_at);
      if (!start) return escapeHtml('—');
      suffix = '<span class="lb-v2-course-date__tag">曝光</span>';
    }
    if (end && end !== start) {
      return '<span class="lb-v2-course-date lb-v2-course-date--range">' +
        '<span class="lb-v2-course-date__start">' + escapeHtml(start) + '</span>' +
        '<span class="lb-v2-course-date__end"><span class="lb-v2-course-date__tilde">～</span>' +
          escapeHtml(end) + '</span>' +
        suffix +
      '</span>';
    }
    return '<span class="lb-v2-course-date">' + escapeHtml(start) + suffix + '</span>';
  }

  /** 複製：把既有課程內容帶成一張新草稿（版位與檔期要重買，不跟著複製）。 */
  function canDuplicateListing(item) {
    if (!item || isSlotAddonListing(item)) return false;
    return String(item.listing_mode || '').toUpperCase() !== 'PRIVATE';
  }

  function canCancelCourseForSelectedVendor() {
    var role = getSelectedVendorRole();
    return role === 'owner' || role === 'admin';
  }

  /** 開課人數設定欄：狀態 chip + 關鍵數字／時程 + 決策詳情（開課／不開課只在未達開課人數決策子頁）。 */
  function buildCourseDecisionCell(item, needsDecision, decisionLabel) {
    var base = courseDecisionLabel(item);
    var min = Number((item && item.course_min_attendees) || 0);
    var statusKey = String((item && item.course_decision_status) || '').toUpperCase();
    var tone =
      needsDecision || statusKey === 'VENDOR_REVIEW' ? 'pending'
        : statusKey === 'CONFIRMED' ? 'ok'
          : statusKey === 'CANCELLED' ? 'danger'
            : statusKey === 'FULL_PENDING' || statusKey === 'EXPOSURE_PENDING' ? 'wait'
              : min > 0 ? 'wait'
                : 'muted';
    // 沒設最低人數（含不適用的 mode）就直接寫明白，不要留一個「—」讓人猜。
    var noMinimum = min <= 0 && (base === '未啟用' || base === '—');
    var html = '<div class="lb-v2-decision-cell lb-v2-decision-cell--' + tone + '">';
    html +=
      '<div class="lb-v2-decision-cell__status">' +
        '<span class="lb-v2-decision-cell__pill">' +
          escapeHtml(noMinimum ? '無需設定最低人數' : base) +
        '</span>' +
      '</div>';

    if (min > 0) {
      var win = formatCourseDecideWindowFromStart(item && item.start_at);
      var sold = item.course_confirmed_count_snapshot != null
        ? Number(item.course_confirmed_count_snapshot)
        : (item.confirmed_count != null ? Number(item.confirmed_count) : null);
      html += '<div class="lb-v2-decision-cell__meta">';
      html +=
        '<div class="lb-v2-decision-cell__row">' +
          '<span class="lb-v2-decision-cell__k">最低人數</span>' +
          '<span class="lb-v2-decision-cell__v">' + min + ' 人</span>' +
        '</div>';
      if (sold != null && !isNaN(sold)) {
        html +=
          '<div class="lb-v2-decision-cell__row">' +
            '<span class="lb-v2-decision-cell__k">目前票數</span>' +
            '<span class="lb-v2-decision-cell__v">' + sold + ' / ' + min + '</span>' +
          '</div>';
      }
      if (win) {
        html +=
          '<div class="lb-v2-decision-cell__row">' +
            '<span class="lb-v2-decision-cell__k">判斷日</span>' +
            '<span class="lb-v2-decision-cell__v">' + escapeHtml(win.evalYmd.replace(/-/g, '/')) + '</span>' +
          '</div>';
        html +=
          '<div class="lb-v2-decision-cell__row">' +
            '<span class="lb-v2-decision-cell__k">判斷截止日</span>' +
            '<span class="lb-v2-decision-cell__v">' + escapeHtml(win.deadlineYmd.replace(/-/g, '/')) + '</span>' +
          '</div>';
      }
      html += '</div>';
    }

    if (min > 0) {
      html +=
        '<button type="button" class="lb-v2-decision-cell__detail" data-course-detail="' + item.id +
        '" data-decision-detail="' + escapeHtml(decisionLabel || base) + '">決策詳情</button>';
    }
    html += '</div>';
    return html;
  }

  function ensureListingListDelegation(container) {
    if (!container || container._lbListingDelegated) return;
    container._lbListingDelegated = true;
    container.addEventListener('click', function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest(
          '[data-listing-page],[data-edit-listing],[data-confirm-listing],' +
          '[data-revert-listing],[data-view-listing],[data-delete-listing],[data-go-course-decision],' +
          '[data-unpublish-listing],[data-cancel-unpublish],[data-content-edit],' +
          '[data-add-slot-addon],[data-edit-addon],[data-detach-addon],[data-duplicate-listing],' +
          '[data-course-confirm],[data-course-cancel],[data-course-detail]'
        )
        : null;
      if (!t || !container.contains(t)) return;
      if (t.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      var opts = container._lbListingOpts || {};
      var items = container._lbListingItems || [];
      var pageSize = container._lbListingPageSize || 10;
      var page = parseInt(container.getAttribute('data-list-page') || '1', 10) || 1;
      if (t.hasAttribute('data-listing-page')) {
        var dir = t.getAttribute('data-listing-page');
        var next = page + (dir === 'next' ? 1 : -1);
        renderListingList(items, Object.assign({}, opts, { page: next, pageSize: pageSize, container: container }));
        return;
      }
      if (t.hasAttribute('data-edit-listing')) {
        var editId = t.getAttribute('data-edit-listing');
        if (t.getAttribute('data-edit-live-private') === '1') {
          if (typeof opts.onEditLivePrivate === 'function') opts.onEditLivePrivate(editId);
          else confirmEditPrivateListing(editId);
          return;
        }
        if (typeof opts.onEdit === 'function') opts.onEdit(editId);
        else loadListingIntoForm(editId);
        return;
      }
      if (t.hasAttribute('data-confirm-listing')) {
        var confirmId = t.getAttribute('data-confirm-listing');
        if (typeof opts.onConfirm === 'function') opts.onConfirm(confirmId);
        else loadListingIntoForm(confirmId);
        return;
      }
      if (t.hasAttribute('data-revert-listing')) {
        var revertId = t.getAttribute('data-revert-listing');
        if (typeof opts.onRevert === 'function') opts.onRevert(revertId);
        return;
      }
      if (t.hasAttribute('data-view-listing')) {
        var viewId = t.getAttribute('data-view-listing');
        if (typeof opts.onView === 'function') opts.onView(viewId);
        else loadListingIntoForm(viewId, { silent: true });
        return;
      }
      if (t.hasAttribute('data-delete-listing')) {
        confirmDeleteListing(
          t.getAttribute('data-delete-listing'),
          t.getAttribute('data-delete-title') || ''
        );
        return;
      }
      if (t.hasAttribute('data-unpublish-listing')) {
        confirmUnpublishListing(
          t.getAttribute('data-unpublish-listing'),
          t.getAttribute('data-listing-title') || ''
        );
        return;
      }
      if (t.hasAttribute('data-cancel-unpublish')) {
        cancelUnpublishRequestById(parseInt(t.getAttribute('data-cancel-unpublish'), 10));
        return;
      }
      if (t.hasAttribute('data-content-edit')) {
        openContentEditModal(t.getAttribute('data-content-edit'));
        return;
      }
      if (t.hasAttribute('data-add-slot-addon')) {
        goCreateAdForParent(parseInt(t.getAttribute('data-add-slot-addon'), 10));
        return;
      }
      if (t.hasAttribute('data-edit-addon')) {
        openSlotAddonModal({ addonId: parseInt(t.getAttribute('data-edit-addon'), 10) });
        return;
      }
      if (t.hasAttribute('data-detach-addon')) {
        confirmDetachAdListing(
          t.getAttribute('data-detach-addon'),
          t.getAttribute('data-detach-title') || '',
          { goCreate: true }
        );
        return;
      }
      if (t.hasAttribute('data-duplicate-listing')) {
        duplicateListingIntoForm(parseInt(t.getAttribute('data-duplicate-listing'), 10));
        return;
      }
      if (t.hasAttribute('data-course-confirm')) {
        submitCourseDecision(t.getAttribute('data-course-confirm'), 'CONFIRM', t);
        return;
      }
      if (t.hasAttribute('data-course-cancel')) {
        openCourseCancelConfirm(
          t.getAttribute('data-course-cancel'),
          t,
          t.getAttribute('data-listing-mode')
        );
        return;
      }
      if (t.hasAttribute('data-course-detail')) {
        openCourseDecisionDetail(parseInt(t.getAttribute('data-course-detail'), 10));
        return;
      }
      if (t.hasAttribute('data-go-course-decision')) {
        switchTab('course-decision');
      }
    });
  }

  /** 開課人數設定的「決策詳情」：判斷日、截止、最低人數，與未達開課人數決策子頁同一組規則。 */
  function openCourseDecisionDetail(listingId) {
    var item = (allListingItems || []).find(function (i) { return Number(i.id) === Number(listingId); });
    if (!item) return;
    var min = Number(item.course_min_attendees || 0);
    var win = formatCourseDecideWindowFromStart(item.start_at);
    var mode = String(item.listing_mode || '').toUpperCase();
    var countLabel = (mode === 'FULL' || mode === 'PRIVATE') ? '已售出' : '已確認收款';
    openModal({
      title: '開課人數設定 · #' + item.id,
      bodyHtml:
        '<p><strong>目前狀態：</strong>' + escapeHtml(courseDecisionLabel(item)) + '</p>' +
        '<p><strong>最低開課人數：</strong>' + min + '（以' + escapeHtml(countLabel) + '票數計算）</p>' +
        (win
          ? '<p><strong>判斷日（開課日3天前）：</strong>' + escapeHtml(win.evalLabel) + '</p>' +
            '<p><strong>判斷截止日（開課日2天前）：</strong>' + escapeHtml(win.deadlineLabel) + '</p>'
          : '<p class="lb-v2-muted">尚未取得課程開始時間，無法推算決策時程。</p>') +
        '<p class="lb-v2-hint">逾期未決策將自動取消開課。取消開課僅擁有者／管理員可執行：純上架由貴司自行退款，宣傳刊登（含金流）／資格限定課由平台依規則退款。</p>',
      actions: [{ label: '知道了', accent: true, close: true }],
    });
  }

  /** 複製課程：沿用內容、清掉版位與檔期（檔期要重新購買）。 */
  async function duplicateListingIntoForm(listingId) {
    var slug = getListingVendorSlug();
    var id = parseInt(listingId, 10);
    if (!slug || !id) return;
    setDataLoading(true, '複製課程中…');
    try {
      var res = await fetchAppProxy(PATHS.listingDetail, slug, { listing_id: id });
      var source = res.ok && res.payload && res.payload.listing
        ? res.payload.listing
        : (allListingItems || []).find(function (i) { return Number(i.id) === id; });
      if (!source) {
        showListingAlert((res && res.message) || '找不到要複製的課程');
        return;
      }
      var copy = Object.assign({}, normalizeListingItem(source));
      delete copy.id;
      copy.status = 'DRAFT';
      copy.parent_listing_id = null;
      copy.slot_id = null;
      copy.slot_name = '';
      copy.fee_plan_id = null;
      copy.fee_grant_id = null;
      copy.listing_fee_status = 'PENDING';
      copy.listing_fee_source = null;
      copy.exposure_start_at = null;
      copy.exposure_end_at = null;
      copy.seat_hold_until = null;
      copy.submitted_at = null;
      copy.rejected_reason = null;
      copy.shopify_product_id = null;
      copy.event_id_preview = null;
      copy.course_decision_status = null;
      copy.title = (copy.title || '') ? copy.title + '（複製）' : '';
      populateListingForm(copy);
      setListingFormReadOnly(false);
      scrollToListingForm();
      showNotice(
        $('lb-v2-listing-notice'),
        '已複製 #' + id + ' 的內容為新草稿。版位與曝光檔期需重新於「營運結帳」購買。'
      );
    } catch (err) {
      showListingAlert(err.message || '複製失敗');
    } finally {
      setDataLoading(false);
    }
  }

  /** 廣告加購檔期摺疊列：版位、起迄、待上架／已上架／已完成。 */
  function buildAddonRowsHtml(addons) {
    if (!addons || !addons.length) return '';
    var rows = addons.map(function (a) {
      var stage = exposureStageLabel(a);
      var stageClass = stage === '已上架'
        ? 'is-live'
        : stage === '待上架'
          ? 'is-pending'
          : stage === '已完成'
            ? 'is-done'
            : '';
      var window = ymd(a.exposure_start_at) && ymd(a.exposure_end_at)
        ? ymd(a.exposure_start_at) + ' ~ ' + ymd(a.exposure_end_at)
        : '檔期未設定';
      var actions = (a.status === 'DRAFT' || a.status === 'REJECTED')
        ? '<button type="button" class="lb-v2-btn lb-v2-btn--sm" data-edit-addon="' + a.id + '">編輯</button>' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--sm" data-detach-addon="' + a.id +
          '" data-detach-title="' + escapeHtml(a.slot_name || ('廣告加購 #' + a.id)) + '">解套</button>'
        : '';
      return '<li class="lb-v2-addon-row">' +
        '<span class="lb-v2-addon-row__slot">' + escapeHtml(a.slot_name || ('版位 #' + (a.slot_id || '—'))) + '</span>' +
        '<span class="lb-v2-addon-row__id">廣告 #' + escapeHtml(String(a.id)) + '</span>' +
        '<span class="lb-v2-addon-row__window">' + escapeHtml(window) + '</span>' +
        '<span class="lb-v2-addon-row__stage ' + stageClass + '">' + escapeHtml(stage) + '</span>' +
        (a.rejected_reason
          ? '<span class="lb-v2-addon-row__reason">' + escapeHtml(a.rejected_reason) + '</span>'
          : '') +
        (actions ? '<span class="lb-v2-addon-row__actions">' + actions + '</span>' : '') +
      '</li>';
    }).join('');
    return '<div class="lb-v2-addon-block">' +
      '<div class="lb-v2-addon-block__title">廣告檔期（' + addons.length + '）</div>' +
      '<ul class="lb-v2-addon-list">' + rows + '</ul>' +
    '</div>';
  }

  /** 列表「送審」時間：短格式避免狀態欄被裁成「下午1…」。 */
  function formatListingSubmittedAt(raw) {
    if (!raw) return '—';
    try {
      var d = new Date(raw);
      if (isNaN(d.getTime())) return '—';
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Taipei',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      }).formatToParts(d);
      var map = {};
      parts.forEach(function (p) { if (p.type !== 'literal') map[p.type] = p.value; });
      return map.year + '/' + Number(map.month) + '/' + Number(map.day) +
        ' ' + map.hour + ':' + map.minute;
    } catch (e) {
      return '—';
    }
  }

  function renderListingList(items, opts) {
    opts = opts || {};
    var container = opts.container || $('lb-v2-listing-list');
    if (!container) return;
    ensureListingListDelegation(container);
    // 加購單不佔一列課程，改摺疊在母課下方；分頁仍以母課為單位。
    var allRows = items || [];
    var addonsByParent = {};
    allRows.forEach(function (item) {
      if (!isSlotAddonListing(item)) return;
      var key = String(item.parent_listing_id);
      (addonsByParent[key] = addonsByParent[key] || []).push(item);
    });
    var parentRows = allRows.filter(function (item) { return !isSlotAddonListing(item) && !isUnattachedAdWindow(item); });
    var emptyMsg = opts.emptyMessage || '尚無上架申請。請在下方填寫表單建立草稿。';
    if (parentRows.length === 0) {
      container.innerHTML = '<div class="lb-v2-empty">' + emptyMsg + '</div>';
      container.removeAttribute('data-list-page');
      container._lbListingItems = [];
      container._lbListingOpts = opts;
      return;
    }
    var pageSize = opts.pageSize > 0 ? opts.pageSize : 10;
    var total = parentRows.length;
    var totalPages = Math.max(1, Math.ceil(total / pageSize));
    var page = opts.page != null
      ? parseInt(opts.page, 10)
      : parseInt(container.getAttribute('data-list-page') || '1', 10);
    if (!Number.isFinite(page) || page < 1) page = 1;
    if (page > totalPages) page = totalPages;
    container.setAttribute('data-list-page', String(page));
    container._lbListingItems = allRows;
    container._lbListingOpts = opts;
    container._lbListingPageSize = pageSize;
    var pageItems = parentRows.slice((page - 1) * pageSize, page * pageSize);
    var MODE_LABELS = LISTING_MODE_TEXT;
    var mobile = preferMobileTicketList();
    var html = '<div class="lb-v2-listing-list-scroll">';
    if (!mobile) {
      html += '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table lb-v2-table--listings"><thead><tr>' +
        '<th class="lb-v2-col-id">編號</th><th class="lb-v2-col-date">課程日期</th><th class="lb-v2-col-title">課程名稱</th>' +
        '<th class="lb-v2-col-mode">作業模式</th><th class="lb-v2-col-decision">開課人數設定</th><th class="lb-v2-col-status">狀態</th>' +
        '<th class="lb-v2-col-actions">操作</th><th class="lb-v2-col-ads">廣告購買</th>' +
        '</tr></thead><tbody>';
    } else {
      html += '<div class="lb-v2-m-cards lb-v2-m-cards--force" aria-label="課程列表">';
    }
    pageItems.forEach(function (item) {
      var disp = listingDisplayStatus(item);
      var color = disp.color || STATUS_COLORS[item.status] || '#888';
      var modeClass = item.listing_mode === 'PROMO'
        ? 'lb-v2-badge--promo'
        : item.listing_mode === 'EXPOSURE'
          ? 'lb-v2-badge--exposure'
          : item.listing_mode === 'PRIVATE'
            ? 'lb-v2-badge--ok'
            : 'lb-v2-badge--full';
      var modeLabel = MODE_LABELS[item.listing_mode] || item.listing_mode || '—';
      var statusLabel = disp.label;
      var decisionLabel = courseDecisionCellLabel(item);
      var needsDecision = listingNeedsCourseDecision(item);
      var submitted = formatListingSubmittedAt(item.submitted_at);
      var hasSubmittedAt = !!item.submitted_at && submitted !== '—';
      var canMutateDraft = item.status === 'DRAFT' || item.status === 'REJECTED';
      // 未到檔期被 park 的 UNPUBLISHED：操作比照已核准未上架（可編輯／檢視），勿當「真下架」。
      var parkedPending = isParkedBeforeExposure(item);
      var canMutateLivePrivate = !!(opts.allowLivePrivateMutate && isPrivateLiveMutable(item));
      var titleAttr = ' data-listing-title="' + escapeHtml(item.title || '') + '"';
      var viewBtnHtml =
        '<button type="button" class="lb-v2-list-act" data-view-listing="' + item.id + '">檢視</button>';
      var deleteBtnHtml =
        '<button type="button" class="lb-v2-list-act lb-v2-list-act--danger" data-delete-listing="' + item.id + '" data-delete-title="' + escapeHtml(item.title || '') + '">刪除</button>';
      var actionBtn;
      if (canMutateDraft) {
        actionBtn =
          ((opts.confirmPublish && item.status === 'DRAFT')
            ? '<button type="button" class="lb-v2-list-act lb-v2-list-act--accent" data-confirm-listing="' + item.id + '">確認上架</button>'
            : '') +
          '<button type="button" class="lb-v2-list-act" data-edit-listing="' + item.id + '">編輯</button>' +
          deleteBtnHtml;
      } else if (canMutateLivePrivate) {
        actionBtn =
          '<button type="button" class="lb-v2-list-act" data-edit-listing="' + item.id + '" data-edit-live-private="1">編輯</button>' +
          deleteBtnHtml +
          viewBtnHtml;
      } else if (item.status === 'PUBLISHED' || parkedPending) {
        // Live / pre-window park：可檢視；park 用一般編輯，已上架用輕量改內容。
        actionBtn =
          (parkedPending
            ? '<button type="button" class="lb-v2-list-act" data-edit-listing="' + item.id + '">編輯</button>'
            : (canContentEditListing(item)
              ? '<button type="button" class="lb-v2-list-act" data-content-edit="' + item.id + '">修改內容</button>'
              : '')) +
          (hasOpenUnpublishRequest(item)
            ? '<button type="button" class="lb-v2-list-act" data-cancel-unpublish="' + item.id + '">撤回下架申請</button>'
            : '<button type="button" class="lb-v2-list-act lb-v2-list-act--danger" data-unpublish-listing="' + item.id + '"' + titleAttr + '>下架</button>') +
          viewBtnHtml;
      } else if (item.status === 'UNPUBLISHED') {
        actionBtn =
          '<button type="button" class="lb-v2-list-act" data-edit-listing="' + item.id + '">編輯</button>' +
          deleteBtnHtml +
          viewBtnHtml;
      } else if (opts.confirmPublish && item.status === 'PENDING_REVIEW') {
        actionBtn =
          '<button type="button" class="lb-v2-list-act" data-revert-listing="' + item.id + '">退回草稿</button>' +
          viewBtnHtml;
      } else {
        actionBtn = viewBtnHtml;
      }
      var statusNote = '';
      if (hasOpenUnpublishRequest(item)) {
        statusNote = '<br><small style="color:#a61b3f">下架申請待官方處理</small>';
      } else if (unpublishRequestRejected(item)) {
        // Otherwise the「下架」button silently reappears with no word on why the
        // request was turned down.
        statusNote = '<br><small style="color:#a61b3f">下架申請未通過' +
          (item.unpublish_request_reject_reason
            ? '：' + escapeHtml(String(item.unpublish_request_reject_reason))
            : '') + '</small>';
      } else if (item.status === 'UNPUBLISHED' && listingSeatHoldActive(item)) {
        statusNote = '<br><small style="color:#2980b9">原檔期保留至 ' +
          escapeHtml(String(item.seat_hold_until).slice(0, 10)) + '</small>';
      }
      if (needsDecision) {
        actionBtn += '<button type="button" class="lb-v2-list-act lb-v2-list-act--accent" data-go-course-decision>去決策</button>';
      }
      if (canDuplicateListing(item)) {
        actionBtn +=
          '<button type="button" class="lb-v2-list-act" data-duplicate-listing="' + item.id + '">複製</button>';
      }
      var myAddons = addonsByParent[String(item.id)] || [];
      var adsCellInner = canAddSlotAddon(item)
        ? '<button type="button" class="lb-v2-list-ads-btn" data-add-slot-addon="' + item.id +
          '"' + titleAttr + '>加購廣告</button>'
        : '<span class="lb-v2-muted">—</span>';
      if (myAddons.length) {
        adsCellInner += '<div class="lb-v2-ads-count">已購 ' + myAddons.length + ' 檔</div>';
      }
      var adsCell = '<div class="lb-v2-list-ads">' + adsCellInner + '</div>';
      var addonHtml = buildAddonRowsHtml(myAddons);
      var decisionCell = buildCourseDecisionCell(item, needsDecision, decisionLabel);
      var courseDate = listingCourseDateLabel(item);
      // 主標已用 listingDisplayStatus；副標只補原因／下架申請，不再重複「已上架＋待上架」。
      if (!mobile) {
        var statusExtra = '';
        if (disp.key === 'PENDING_SHELF' && ymd(item.exposure_start_at)) {
          statusExtra += '<span class="lb-v2-list-status__meta">' +
            escapeHtml(ymd(item.exposure_start_at)) + ' 起曝光</span>';
        }
        if (item.rejected_reason) {
          statusExtra += '<span class="lb-v2-list-status__reason">' + escapeHtml(item.rejected_reason) + '</span>';
        }
        if (hasOpenUnpublishRequest(item)) {
          statusExtra += '<span class="lb-v2-list-status__reason">下架申請待官方處理</span>';
        } else if (unpublishRequestRejected(item)) {
          statusExtra += '<span class="lb-v2-list-status__reason">下架申請未通過' +
            (item.unpublish_request_reject_reason
              ? '：' + escapeHtml(String(item.unpublish_request_reject_reason))
              : '') + '</span>';
        } else if (item.status === 'UNPUBLISHED' && listingSeatHoldActive(item)) {
          statusExtra += '<span class="lb-v2-list-status__meta">原檔期保留至 ' +
            escapeHtml(String(item.seat_hold_until).slice(0, 10)) + '</span>';
        }
        html += '<tr>' +
          '<td class="lb-v2-col-id">' + listingTrackIdsHtml(item) + '</td>' +
          '<td class="lb-v2-col-date">' + listingCourseDateHtml(item) + '</td>' +
          '<td class="lb-v2-col-title"><span class="lb-v2-ads-title-chip">' + escapeHtml(item.title || '') + '</span></td>' +
          '<td class="lb-v2-col-mode"><span class="lb-v2-badge ' + modeClass + '">' + modeLabel + '</span></td>' +
          '<td class="lb-v2-col-decision">' + decisionCell + '</td>' +
          '<td class="lb-v2-col-status"><div class="lb-v2-list-status">' +
            '<span class="lb-v2-list-status__label" style="color:' + color + '">' + escapeHtml(statusLabel) + '</span>' +
            statusExtra +
            // 還沒送審就不要留一行「送審 —」佔位
            (hasSubmittedAt
              ? '<span class="lb-v2-list-status__meta">送審 ' + escapeHtml(submitted) + '</span>'
              : '') +
          '</div></td>' +
          '<td class="lb-v2-col-actions"><div class="lb-v2-list-acts">' + actionBtn + '</div></td>' +
          '<td class="lb-v2-col-ads">' + adsCell + '</td></tr>';
        if (addonHtml) {
          html += '<tr class="lb-v2-addon-tr"><td colspan="8">' + addonHtml + '</td></tr>';
        }
      } else {
        var mobileStatusExtra = '';
        if (item.rejected_reason) {
          mobileStatusExtra += '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">原因</span><span class="lb-v2-m-card__value lb-v2-m-card__value--danger">' + escapeHtml(item.rejected_reason) + '</span></div>';
        }
        html += '<article class="lb-v2-m-card lb-v2-m-card--board">' +
          '<div class="lb-v2-m-card__head">' +
            '<span class="lb-v2-ads-title-chip">' + escapeHtml(item.title || ('#' + item.id)) + '</span>' +
            '<span class="lb-v2-m-card__status" style="color:' + color + '">' + escapeHtml(statusLabel) + '</span>' +
          '</div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">編號</span><span class="lb-v2-m-card__value">' + listingTrackIdsHtml(item) + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">課程日期</span><span class="lb-v2-m-card__value">' + escapeHtml(courseDate) + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">作業模式</span><span class="lb-v2-m-card__value"><span class="lb-v2-badge ' + modeClass + '">' + escapeHtml(modeLabel) + '</span></span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">開課人數設定</span><span class="lb-v2-m-card__value">' + decisionCell + '</span></div>' +
          (hasSubmittedAt
            ? '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">送審時間</span><span class="lb-v2-m-card__value">' + escapeHtml(submitted) + '</span></div>'
            : '') +
          mobileStatusExtra +
          (addonHtml || '') +
          '<div class="lb-v2-m-card__row lb-v2-m-card__row--ads"><span class="lb-v2-m-card__label">廣告購買</span><span class="lb-v2-m-card__value">' + adsCell + '</span></div>' +
          '<div class="lb-v2-m-card__actions lb-v2-list-acts">' + actionBtn + '</div>' +
        '</article>';
      }
    });
    if (!mobile) {
      html += '</tbody></table></div></div>';
    } else {
      html += '</div></div>';
    }
    if (totalPages > 1 || total > pageSize) {
      var from = (page - 1) * pageSize + 1;
      var to = Math.min(page * pageSize, total);
      html +=
        '<div class="lb-v2-listing-pager" role="navigation" aria-label="課程列表分頁">' +
        '<span class="lb-v2-listing-pager__meta">第 ' + from + '–' + to + ' 筆／共 ' + total + ' 筆</span>' +
        '<div class="lb-v2-listing-pager__btns">' +
        '<button type="button" class="lb-v2-btn lb-v2-btn--sm" data-listing-page="prev"' +
        (page <= 1 ? ' disabled' : '') +
        '>上一頁</button>' +
        '<span class="lb-v2-listing-pager__page">' + page + ' / ' + totalPages + '</span>' +
        '<button type="button" class="lb-v2-btn lb-v2-btn--sm" data-listing-page="next"' +
        (page >= totalPages ? ' disabled' : '') +
        '>下一頁</button>' +
        '</div></div>';
    }
    container.innerHTML = html;
  }

  var allListingItems = [];

  function applyListingModeFilter() {
    var filterEl = $('lb-v2-listing-mode-filter');
    var modeFilter = filterEl ? filterEl.value : '';
    var fromEl = $('lb-v2-listing-date-from');
    var toEl = $('lb-v2-listing-date-to');
    var from = fromEl ? String(fromEl.value || '') : '';
    var to = toEl ? String(toEl.value || '') : '';
    var filtered = (allListingItems || []).filter(function (i) {
      if (modeFilter && i.listing_mode !== modeFilter) return false;
      if (!from && !to) return true;
      // 加購子單跟著母課顯示，日期以母課為準，不在這層過濾。
      if (isSlotAddonListing(i)) return true;
      var day = ymdFromListingStart(i.start_at) || ymd(i.exposure_start_at);
      if (!day) return false;
      if (from && day < from) return false;
      if (to && day > to) return false;
      return true;
    });
    var listEl = $('lb-v2-listing-list');
    if (listEl) listEl.setAttribute('data-list-page', '1');
    renderListingList(filtered, { page: 1 });
  }

  function bindBoardDatePicker(el, shellEl, onEnter) {
    if (!el) return;
    function setDateOpen(on) {
      try {
        document.documentElement.classList.toggle('lb-v2-date-open', !!on);
        var field = el.closest('.lb-v2-ads-board__filter, .lb-v2-listing-toolbar__field');
        if (field) field.classList.toggle('is-date-open', !!on);
      } catch (err) { /* ignore */ }
    }
    function openNativePicker() {
      if (typeof el.showPicker !== 'function') return;
      try {
        el.showPicker();
      } catch (err) {
        // NotAllowedError / unsupported — ignore, browser may still open on tap
      }
    }
    // click／pointerup 才開 picker；勿在 focus 做 scrollIntoView（會把原生日曆打斷）
    el.addEventListener('focus', function () { setDateOpen(true); });
    el.addEventListener('blur', function () {
      // Vanila Datepicker 點選日期時會先 blur；稍等再關，避免月曆瞬間被下欄蓋住
      setTimeout(function () {
        try {
          if (document.activeElement === el) return;
          var openDd = document.querySelector('.datepicker-dropdown.active, .datepicker-dropdown:not([style*="display: none"])');
          if (openDd) {
            var cs = window.getComputedStyle(openDd);
            if (cs.display !== 'none' && cs.visibility !== 'hidden') return;
          }
        } catch (err) { /* ignore */ }
        setDateOpen(false);
      }, 220);
    });
    el.addEventListener('click', function () {
      setDateOpen(true);
      openNativePicker();
    });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (typeof onEnter === 'function') onEnter();
      } else if (e.key === ' ' || e.key === 'ArrowDown') {
        setDateOpen(true);
        openNativePicker();
      }
    });
    el.addEventListener('changeDate', function () { setDateOpen(true); });
    el.addEventListener('hide', function () { setDateOpen(false); });
  }
  var listingToolbar = document.querySelector('#lb-v2-listing-list-view .lb-v2-listing-toolbar');
  ['lb-v2-listing-date-from', 'lb-v2-listing-date-to'].forEach(function (id) {
    bindBoardDatePicker($(id), listingToolbar, applyListingModeFilter);
  });
  var listingFilterApply = $('lb-v2-listing-filter-apply');
  if (listingFilterApply) {
    listingFilterApply.addEventListener('click', applyListingModeFilter);
  }
  var listingDateClear = $('lb-v2-listing-date-clear');
  if (listingDateClear) {
    listingDateClear.addEventListener('click', function () {
      var fromEl = $('lb-v2-listing-date-from');
      var toEl = $('lb-v2-listing-date-to');
      var modeEl = $('lb-v2-listing-mode-filter');
      if (fromEl) fromEl.value = '';
      if (toEl) toEl.value = '';
      if (modeEl) modeEl.value = '';
      applyListingModeFilter();
    });
  }

  async function loadListingTab(forceReload) {
    await LbV2.ensureChunk('listing');
    var slug = getListingVendorSlug();
    if (!slug) {
      showNotice($('lb-v2-listing-notice'), '請先選擇單一廠商');
      return;
    }
    hideNotice($('lb-v2-listing-notice'));
    // Only soft tab-switch passes false; mutations call loadListingTab() and must refetch.
    if (forceReload === false && tabCacheHit('listing')) return;
    if (forceReload !== false && tabDataCache.listing) {
      tabDataCache.listing.loaded = false;
    }

    // City taxonomy in background — do not block list paint.
    var cityPromise = loadCityTaxonomyOptions();
    await bindListingFormEvents();
    setDataLoading(true);
    try {
      var listingBundle = await Promise.all([
        loadFeeEntitlement(slug).catch(function () { return null; }),
        fetchAppProxy(PATHS.listingList, slug),
      ]);
      var res = listingBundle[1];
      if (!listingBundle[0] && !cachedEntitlement) {
        showNotice($('lb-v2-listing-notice'), '額度資訊載入失敗，上架列表仍可檢視。');
      }
      // 先灌列表再 gate：鎖窗待補草稿才能畫成方案區可選卡片（額度已綁 listing）。
      if (res.ok) {
        var data = res.payload || res;
        allListingItems = data.items || [];
        updateCourseDecisionBadge(allListingItems.filter(listingNeedsCourseDecision).length);
        applyListingModeFilter();
        markTabCache('listing');
      } else {
        showNotice($('lb-v2-listing-notice'), res.message || '載入失敗');
      }
      applyListingGate();
    } catch (err) {
      showNotice($('lb-v2-listing-notice'), err.message || '載入失敗');
    } finally {
      setDataLoading(false);
    }
    cityPromise.then(function () { ensureCityCheckboxes(); }).catch(function () { ensureCityCheckboxes(); });
    if (pendingPrivateListingCreate) {
      pendingPrivateListingCreate = false;
      pendingPrivateListingEditId = null;
      pendingPrivateListingEditOpts = null;
      privateModeLocked = true;
      clearListingForm();
      setListingModePrivateLocked(true);
      scrollToListingForm();
    } else if (pendingPrivateListingEditId) {
      var editId = pendingPrivateListingEditId;
      var editOpts = pendingPrivateListingEditOpts || {};
      var openConfirm = pendingPrivateListingConfirmAfterLoad;
      pendingPrivateListingEditId = null;
      pendingPrivateListingEditOpts = null;
      pendingPrivateListingConfirmAfterLoad = false;
      privateModeLocked = true;
      await loadListingIntoForm(editId, editOpts);
      setListingModePrivateLocked(true);
      scrollToListingForm();
      if (openConfirm && !listingFormReadOnly) {
        openListingReviewModal();
      }
    } else if (privateModeLocked) {
      setListingModePrivateLocked(true);
    }
  }

  // In-flight guards to prevent double-submit (no direct trigger button ref).
  var saveListingDraftInFlight = false;
  var submitListingForReviewInFlight = false;
  var upsertPrivateEligibilityInFlight = false;

  function readListingFormBasics() {
    var modeEl = $('lb-v2-listing-mode');
    var mode = modeEl ? modeEl.value : 'FULL';
    return {
      mode: mode,
      isPromo: mode === 'PROMO',
      title: (($('lb-v2-listing-title') || {}).value || '').trim(),
      category: getSelectedCategory(),
      subcategories: getSelectedSubcategories(),
      startAt: readDateTimePair('lb-v2-listing-start-date', 'lb-v2-listing-start-time'),
      endAt: readDateTimePair('lb-v2-listing-end-date', 'lb-v2-listing-end-time'),
      expStart: (($('lb-v2-listing-exposure-start') || {}).value || '').trim(),
      expEnd: (($('lb-v2-listing-exposure-end') || {}).value || '').trim(),
      externalUrl: (($('lb-v2-listing-external-url') || {}).value || '').trim(),
      cityCodes: collectCityCodes(),
    };
  }

  /**
   * 草稿只擋「已填的欄位互相矛盾」——存下去只會變成之後更難修的壞資料。
   * 「還沒填」一律留到送審再擋（後端草稿存檔本身只硬性要求標題）。
   */
  function validateListingDraftShape(st) {
    if (!st.title) {
      showListingAlert(st.isPromo ? '請填寫宣傳主題' : '請填寫課程／活動標題');
      return false;
    }
    if (st.startAt && st.endAt &&
      new Date(st.endAt).getTime() <= new Date(st.startAt).getTime()) {
      showListingAlert(st.isPromo ? '課程結束時間必須晚於開始時間' : '結束時間必須晚於開始時間');
      return false;
    }
    if (st.expStart && st.expEnd && st.expEnd < st.expStart) {
      showListingAlert('曝光結束日不能早於開始日');
      return false;
    }
    if (st.mode !== 'PRIVATE' && st.expStart && st.expEnd && st.startAt && st.endAt) {
      if (st.startAt.slice(0, 10) < st.expStart) {
        showListingAlert('課程開始日不得早於曝光起日（課程時間須落在曝光檔期內）');
        return false;
      }
      if (st.endAt.slice(0, 10) > st.expEnd) {
        showListingAlert('課程結束日不得晚於曝光迄日（課程時間須落在曝光檔期內）');
        return false;
      }
    }
    if (st.isPromo && st.externalUrl && !/^https?:\/\//i.test(st.externalUrl)) {
      showListingAlert('預設前往連結請填完整網址（http／https）');
      return false;
    }
    var planEl = $('lb-v2-listing-fee-plan');
    if (st.mode !== 'PRIVATE' && planEl && planEl.value) {
      var planBoundSlot = String(planEl.getAttribute('data-slot-id') || '').trim();
      var slotEl = $('lb-v2-listing-slot');
      if (planBoundSlot && slotEl && !slotEl.value) {
        showListingAlert('所選方案對應版位載入失敗，請重新選擇方案');
        return false;
      }
    }
    if (!st.isPromo && st.mode !== 'PRIVATE') {
      readAddressRestsFromDom();
      for (var ci = 0; ci < st.cityCodes.length; ci++) {
        var cityLabel = cityLabelForCode(st.cityCodes[ci]);
        var restRaw = String(addressRestByCity[st.cityCodes[ci]] || '').trim();
        if (!restRaw) continue;
        var conflict = conflictingCityPrefixInRest(restRaw, cityLabel);
        if (conflict) {
          showListingAlert(
            '「' + cityLabel + '」那列地址開頭是「' + conflict +
              '」。請只填區／路／號，不要再貼一次其他縣市名。'
          );
          return false;
        }
      }
    }
    return true;
  }

  /** 送審／上架才需要的整套必填（草稿不擋，讓廠商先存起來慢慢補）。 */
  function validateListingSubmitRequirements(st) {
    if (st.isPromo) {
      if (!st.startAt || !st.endAt) {
        showListingAlert('請選擇課程日期起訖（用於近期課程、課程總覽、活動日曆）');
        return false;
      }
    } else {
      if (st.mode !== 'PRIVATE') {
        if (!st.category) {
          showListingAlert('請選擇分類（商品類型）');
          return false;
        }
        if (!st.subcategories.length) {
          showListingAlert('請至少勾選一個商品系列');
          return false;
        }
      }
      if (!st.startAt || !st.endAt) {
        showListingAlert('請選擇開始與結束的日期與時間（使用月曆／時間選擇器）');
        return false;
      }
    }
    if (st.mode === 'EXPOSURE' && !st.externalUrl) {
      showListingAlert('純上架模式請填寫外部購票連結');
      return false;
    }
    if (st.mode === 'EXPOSURE' || st.mode === 'FULL' || st.isPromo) {
      if (!st.expStart || !st.expEnd) {
        showListingAlert('請選擇曝光起迄日');
        return false;
      }
    }
    if (st.mode === 'PRIVATE' && (!st.expStart || !st.expEnd)) {
      showListingAlert('資格限定課請選擇曝光起迄日（系統依此自動上下架）');
      return false;
    }
    if (st.isPromo) {
      if (!st.externalUrl || !/^https?:\/\//i.test(st.externalUrl)) {
        showListingAlert('宣傳刊登（不含金流）請填寫預設前往連結（http/https）');
        return false;
      }
      if (!collectListingImageSources().length && !listingImageFiles.filter(Boolean).length) {
        showListingAlert('宣傳刊登（不含金流）請至少上傳 1 張圖片');
        return false;
      }
    }
    // 活動焦點：牆面要 1 大 + 3 小（只靠 Portal；後端本階段不加硬檢）。
    if (st.mode !== 'PRIVATE') {
      var spotlightMeta = getListingPreviewSlotMeta();
      if (isEventSpotlightSlot(spotlightMeta.slotName, spotlightMeta.planName)) {
        var spotlightImgCount =
          collectListingImageSources().length || listingImageFiles.filter(Boolean).length;
        if (spotlightImgCount < 4) {
          showListingAlert('活動焦點請至少上傳 4 張圖片（第 1 張大圖、第 2–4 張小圖）');
          return false;
        }
      }
    }
    var planEl = $('lb-v2-listing-fee-plan');
    // PRIVATE year-plan：不必選（匯入會預填；上架時後端自動綁 grant）。
    if (st.mode !== 'PRIVATE' && planEl && planEl.required && !planEl.value) {
      showListingAlert('請選擇要用的方案（例如單次 3 天）');
      return false;
    }
    if (!st.cityCodes.length) {
      showListingAlert(st.isPromo ? '請至少選擇一個露出縣市' : '請至少選擇一個開課縣市');
      return false;
    }
    if (!st.isPromo) {
      readAddressRestsFromDom();
      if (st.mode === 'PRIVATE') {
        var addrHidden = $('lb-v2-listing-address');
        var fallbackAddr = addrHidden ? String(addrHidden.value || '').trim() : '';
        if (!composeListingAddress() && !fallbackAddr) {
          showListingAlert('請填寫地址');
          return false;
        }
      } else {
        for (var ai = 0; ai < st.cityCodes.length; ai++) {
          if (!String(addressRestByCity[st.cityCodes[ai]] || '').trim()) {
            showListingAlert(
              '請填寫「' + cityLabelForCode(st.cityCodes[ai]) +
                '」的地址（前綴已帶入，請接著填區／路／號）'
            );
            return false;
          }
        }
      }
      if (!collectVariants().length) {
        showListingAlert('請至少新增一組票種（名稱、價格、數量）');
        return false;
      }
    }
    return true;
  }

  async function saveListingDraft(opts) {
    opts = opts || {};
    var skipReview = !!opts.skipReview;
    // 送審流程內部才要跑整套必填；「儲存草稿」只驗資料形狀。
    var strict = skipReview || !!opts.strict;
    if (listingFormReadOnly) {
      showListingAlert('目前為唯讀檢視，無法儲存草稿。請等候審核結果。', '無法編輯');
      return false;
    }
    var slug = getListingVendorSlug();
    if (!slug) return false;
    var idEl = $('lb-v2-listing-id');
    var modeEl = $('lb-v2-listing-mode');
    var mode = modeEl ? modeEl.value : 'FULL';
    var category = getSelectedCategory();
    var subcategories = getSelectedSubcategories();
    var subcategory = subcategories.join(',');
    var startAt = readDateTimePair('lb-v2-listing-start-date', 'lb-v2-listing-start-time');
    var endAt = readDateTimePair('lb-v2-listing-end-date', 'lb-v2-listing-end-time');
    var title = (($('lb-v2-listing-title') || {}).value || '').trim();

    var isPromo = mode === 'PROMO';
    var formState = readListingFormBasics();
    if (!validateListingDraftShape(formState)) return false;
    if (strict && !validateListingSubmitRequirements(formState)) return false;

    var cityCodes = formState.cityCodes;
    var composedAddress = '';
    if (!isPromo) {
      readAddressRestsFromDom();
      var addrHidden = $('lb-v2-listing-address');
      composedAddress = composeListingAddress();
      if (mode === 'PRIVATE' && !composedAddress && addrHidden) {
        // PRIVATE：與 Excel／確認上架對齊——有完整地址即可，分列區／路／號僅輔助。
        composedAddress = String(addrHidden.value || '').trim();
      }
      if (addrHidden) addrHidden.value = composedAddress;
    }

    var body = {
      vendor_slug: slug,
      listing_mode: mode,
      title: title,
      description: ($('lb-v2-listing-desc') || {}).value || '',
      highlight_notes: isPromo ? '' : (($('lb-v2-listing-highlight-notes') || {}).value || ''),
      // '宣傳刊登' 是 Shopify product_type 資料值（PROMO_PRODUCT_TYPE），不是顯示名稱，不可跟著改名
      category: isPromo ? '宣傳刊登' : category,
      subcategory: subcategory,
      start_at: startAt,
      end_at: endAt,
      venue_name: isPromo ? '' : (($('lb-v2-listing-venue') || {}).value || ''),
      instructor: mode === 'PRIVATE' ? (($('lb-v2-listing-instructor') || {}).value || '') : '',
      organizer: mode === 'PRIVATE' ? (($('lb-v2-listing-organizer') || {}).value || '') : '',
      co_organizer: mode === 'PRIVATE' ? (($('lb-v2-listing-co-organizer') || {}).value || '') : '',
      calendar_color: mode === 'PRIVATE' ? readCalSwatchValue('lb-v2-listing-calendar-color') : undefined,
      address: isPromo ? '' : composedAddress,
      maps_url: isPromo ? '' : (($('lb-v2-listing-maps-url') || {}).value || ''),
      city_codes: cityCodes,
      variants_json: isPromo ? [] : collectVariants(),
      cancel_policy_template: 'STANDARD',
      policy_cutoff_mode: 'FIXED_TIME',
      policy_cutoff_time: '23:59',
      course_min_attendees: isPromo ? 0 : (parseInt(($('lb-v2-listing-min-attendees') || {}).value, 10) || 0),
      // Course decide v2: T-3 / T-2 fixed; do not collect decide-days from vendors
      course_decide_days: 0,
      external_purchase_url: (mode === 'EXPOSURE' || isPromo)
        ? (($('lb-v2-listing-external-url') || {}).value || '')
        : '',
      city_cta_urls_json: {},
      slot_id: parseInt(($('lb-v2-listing-slot') || {}).value, 10) || null,
      fee_plan_id: parseInt(($('lb-v2-listing-fee-plan') || {}).value, 10) || null,
      exposure_start_at: ($('lb-v2-listing-exposure-start') || {}).value || '',
      exposure_end_at: ($('lb-v2-listing-exposure-end') || {}).value || '',
    };
    var planHiddenSave = $('lb-v2-listing-fee-plan');
    var officialDirectSlot =
      !!(planHiddenSave && planHiddenSave.getAttribute('data-official-direct-slot') === '1');
    if (officialDirectSlot) {
      body.clear_fee_plan = true;
      body.fee_plan_id = null;
    }
    if (idEl && idEl.value) body.id = parseInt(idEl.value, 10);
    // Don't send empty optional date strings (backend rejects "")
    if (!body.exposure_start_at) delete body.exposure_start_at;
    if (!body.exposure_end_at) delete body.exposure_end_at;
    if (!body.start_at) delete body.start_at;
    if (!body.end_at) delete body.end_at;
    if (!body.external_purchase_url) delete body.external_purchase_url;
    // Avoid sending 0/null that Zod coerce may turn into invalid FK ids
    if (!body.fee_plan_id) delete body.fee_plan_id;
    if (!body.slot_id) delete body.slot_id;
    if (!body.clear_fee_plan) delete body.clear_fee_plan;
    if (!isPromo) delete body.city_cta_urls_json;

    if (strict && !isPromo && !body.variants_json.length) {
      showListingAlert('請至少新增一組票種（名稱、價格、數量）');
      return false;
    }

    var activeImages = listingImageFiles.filter(Boolean).concat(listingDescImageFiles.filter(Boolean));
    if (activeImages.length) {
      var maxBytes = 5 * 1024 * 1024;
      for (var ci = 0; ci < activeImages.length; ci++) {
        if (activeImages[ci].size > maxBytes) {
          showListingAlert('單張圖片請小於 5MB（目前第 ' + (ci + 1) + ' 張過大）');
          return false;
        }
      }
    }

    if (saveListingDraftInFlight) return false;
    saveListingDraftInFlight = true;
    try {
      if (listingImageUploadsInFlight > 0) {
        await waitForListingImageUploads();
      }
      var coverReady = await materializeImageSourcesForSave(
        listingImageSources,
        listingImageFiles,
        'cover'
      );
      if (!coverReady.ok) {
        showListingAlert(coverReady.message || '圖片尚未上傳完成，請再試一次。');
        return false;
      }
      var descReady = await materializeImageSourcesForSave(
        listingDescImageSources,
        listingDescImageFiles,
        'description'
      );
      if (!descReady.ok) {
        showListingAlert(descReady.message || '說明圖片尚未上傳完成，請再試一次。');
        return false;
      }
      var retainedSources = coverReady.sources || [];
      var retainedDescSources = descReady.sources || [];
      // Always send current gallery so re-save does not wipe images
      if (retainedSources.length) {
        body.images_json = retainedSources.map(function (src) {
          return { src: src, uploaded: true };
        });
      }
      // Always send description gallery (incl. empty) so clear is persisted
      body.description_images_json = retainedDescSources.map(function (src) {
        return { src: src, uploaded: true };
      });

      var response = await fetch(PATHS.listingSave, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body),
      });
      var rawText = await response.text();
      var payload = null;
      try {
        payload = rawText ? JSON.parse(rawText) : null;
      } catch (parseErr) {
        showListingAlert('儲存失敗，請稍後再試。若剛選完圖片，請等上傳完成後再存。');
        return false;
      }
      if (payload && payload.ok && payload.listing) {
        var keepSources = retainedSources.slice();
        var keepDescSources = retainedDescSources.slice();
        // Drop local File handles; previews will use data:/http from keep* or server.
        listingImageFiles = [];
        listingDescImageFiles = [];
        populateListingForm(payload.listing);
        // Server may omit data: URLs in response — restore local previews
        if (!collectListingImageSources().length && keepSources.length) {
          setListingImageSources(keepSources);
        }
        if (!collectDescImageSources().length && keepDescSources.length) {
          setDescImageSources(keepDescSources);
        }
        setListingFormReadOnly(false, payload.listing.status);
        loadListingTab();
        if (payload.demoted_from_live) {
          var soldHint = Number(payload.active_ticket_count || 0) > 0
            ? '（原有效票 ' + payload.active_ticket_count + ' 張仍保留）'
            : '';
          showListingSuccess(
            '已改回草稿並下架商品' + soldHint + '。請確認內容後再按「預覽並上架」／「預覽並送審」。',
            '已存成草稿'
          );
        } else if (!skipReview) {
          var modeAfterSave = (($('lb-v2-listing-mode') || {}).value || '').toUpperCase();
          var isPrivateAfterSave = modeAfterSave === 'PRIVATE';
          showListingSuccess(
            isPrivateAfterSave
              ? '草稿已儲存。請再按「預覽並上架」確認內容後上架。'
              : '草稿已儲存。請再按「預覽並送審」確認內容後送審。',
            '儲存草稿成功'
          );
        }
        return true;
      } else {
        var saveErr = extractApiError(payload);
        showListingAlert(saveErr.code ? '[' + saveErr.code + '] ' + saveErr.message : (saveErr.message || '儲存失敗'));
        return false;
      }
    } catch (err) {
      showListingAlert(err.message || '儲存失敗');
      return false;
    } finally {
      saveListingDraftInFlight = false;
    }
  }

  async function submitListingForReview() {
    var idEl = $('lb-v2-listing-id');
    var slug = getListingVendorSlug();
    if (!slug || !idEl || !idEl.value) return;

    var modeEl = $('lb-v2-listing-mode');
    var mode = modeEl ? modeEl.value : 'FULL';
    if (mode === 'FULL' && !isFullServiceEnabled()) {
      showListingAlert('無申請宣傳刊登（含金流）服務');
      return;
    }
    // FULL/EXPOSURE/PROMO/PRIVATE all require PAID/WAIVED or can_submit quota (no NOT_REQUIRED skip).
    var alreadyPaid = isListingFeeSettled();
    if (!alreadyPaid && !canSubmitForMode(mode)) {
      showListingAlert(mode === 'FULL' && !isFullServiceEnabled()
        ? '無申請宣傳刊登（含金流）服務'
        : isOfficialFeeExemptVendor()
          ? '目前無法送審（模組可能已關閉，或宣傳刊登（含金流）尚未設定手續費率）。'
          : '目前沒有可送審額度，請先到「營運結帳」購買方案（可為免費方案）。');
      return;
    }
    var planElSubmit = $('lb-v2-listing-fee-plan');
    var slotElSubmit = $('lb-v2-listing-slot');
    if (mode !== 'PRIVATE') {
      if (isOfficialFeeExemptVendor()) {
        var hasPlan = !!(planElSubmit && planElSubmit.value);
        var hasSlot = !!(slotElSubmit && slotElSubmit.value);
        if (!hasPlan && !hasSlot) {
          showListingAlert('請選擇上架方案或版位並儲存草稿後再送審');
          return;
        }
      } else if (planElSubmit && planElSubmit.required && !planElSubmit.value) {
        showListingAlert('請先選擇要用的方案並儲存草稿後再送審');
        return;
      }
    }

    if (submitListingForReviewInFlight) return;
    submitListingForReviewInFlight = true;
    var isPrivateSubmit = mode === 'PRIVATE';
    try {
      var response = await fetch(PATHS.listingSubmit, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ vendor_slug: slug, listing_id: parseInt(idEl.value, 10) }),
      });
      var payload = null;
      try {
        payload = await response.json();
      } catch (parseErr) {
        showListingAlert(
          (isPrivateSubmit ? '確認上架' : '送審') + '失敗，請稍後再試。',
          isPrivateSubmit ? '確認上架失敗' : '送審失敗'
        );
        return;
      }
      if (payload && payload.ok) {
        clearListingForm();
        cachedEntitlement = null;
        clearFeeEntitlementTtlCache();
        loadListingTab();
        if (isPrivateSubmit && payload.private_direct_publish) {
          showListingSuccess('已確認並上架。', '確認上架成功');
        } else if (isPrivateSubmit) {
          showListingSuccess('已送出，等候官方審核（此廠商已設為需官方審）。', '已送審');
        } else {
          showListingSuccess('已送出審核，請等候官方回覆。', '送審成功');
        }
      } else {
        var submitErr = extractApiError(payload);
        showListingAlert(
          submitErr.code ? '[' + submitErr.code + '] ' + submitErr.message : (submitErr.message || (isPrivateSubmit ? '確認上架失敗' : '送審失敗')),
          isPrivateSubmit ? '確認上架失敗' : '送審失敗'
        );
      }
    } catch (err) {
      showListingAlert(err.message || (isPrivateSubmit ? '確認上架失敗' : '送審失敗'));
    } finally {
      submitListingForReviewInFlight = false;
    }
  }

  // ═══════════════════════════════════════════════════════
  // Settlement tab logic (FULL / PRIVATE UI split; same payout batches)
  // ═══════════════════════════════════════════════════════

  var settlementViewMode = 'FULL'; // FULL | PRIVATE

  function settlementModeFromTab(tab) {
    return tab === 'settlement-private' ? 'PRIVATE' : 'FULL';
  }

  function syncSettlementPanelCopy(mode) {
    var title = $('lb-v2-settlement-title');
    var hint = $('lb-v2-settlement-hint');
    var isPrivate = mode === 'PRIVATE';
    if (title) {
      title.textContent = isPrivate ? '結算明細（資格限定課）' : '宣傳刊登（含金流）結算明細';
    }
    if (hint) {
      hint.innerHTML = isPrivate
        ? '此頁僅顯示<strong>資格限定課</strong>票券分潤；與宣傳刊登（含金流）可能同批次匯款，金額已分開列示。官方<strong>確認貴廠商已匯款</strong>後可下載。'
        : '此頁僅顯示<strong>宣傳刊登（含金流）</strong>票券分潤。雙週結算並由官方<strong>確認貴廠商已匯款</strong>後，可下載結算資料。';
    }
  }

  function renderSettlementKpiFromItems(items) {
    var kpiEl = $('lb-v2-settlement-kpi');
    if (!kpiEl) return;
    if (!items || !items.length) {
      kpiEl.hidden = true;
      kpiEl.innerHTML = '';
      return;
    }
    var payout = 0;
    var fee = 0;
    var base = 0;
    var paidCount = 0;
    (items || []).forEach(function (item) {
      payout += moneyCents(item.vendor_payout);
      fee += moneyCents(item.platform_fee);
      base += moneyCents(item.share_base);
      // 以廠商列狀態為準（逐筆匯款）
      if (String(item.status || '').toUpperCase() === 'PAID') paidCount += 1;
    });
    kpiEl.hidden = false;
    kpiEl.innerHTML =
      '<div class="lb-v2-kpi-card"><div class="lb-v2-kpi-label">結算基數合計</div><div class="lb-v2-kpi-value">' + formatCurrency(base) + '</div></div>' +
      '<div class="lb-v2-kpi-card"><div class="lb-v2-kpi-label">平台手續費</div><div class="lb-v2-kpi-value">' + formatCurrency(fee) + '</div></div>' +
      '<div class="lb-v2-kpi-card"><div class="lb-v2-kpi-label">應付／已付合計</div><div class="lb-v2-kpi-value">' + formatCurrency(payout) + '</div></div>' +
      '<div class="lb-v2-kpi-card"><div class="lb-v2-kpi-label">已匯款批次</div><div class="lb-v2-kpi-value">' + paidCount + '</div></div>';
  }

  function settlementPortalStatusLabel(status) {
    var s = String(status || '').toUpperCase();
    if (s === 'READY' || s === 'PENDING') return '待匯款';
    if (s === 'PAID') return '已匯款';
    if (s === 'DRAFT') return '草稿';
    return status || '—';
  }

  function settlementPortalPillClass(status) {
    var s = String(status || '').toUpperCase();
    if (s === 'PAID') return 'lb-v2-pill lb-v2-pill--paid';
    if (s === 'READY' || s === 'PENDING') return 'lb-v2-pill lb-v2-pill--ready';
    return 'lb-v2-pill lb-v2-pill--pending';
  }

  function renderSettlementList(items, slug, mode) {
    var listEl = $('lb-v2-settlement-list');
    if (!listEl) return;
    var modeLabelText = mode === 'PRIVATE' ? '資格限定課' : '宣傳刊登（含金流）';
    if (!items || !items.length) {
      listEl.innerHTML = '<p class="lb-v2-muted">尚無' + modeLabelText +
        '結算批次。活動結束並完成雙週結算後會顯示於此。</p>';
      return;
    }
    var modeQs = '&listing_mode=' + encodeURIComponent(mode || 'FULL');
    listEl.innerHTML = items.map(function (item) {
      var batchId = item.batch_id || item.batch_key;
      // 廠商列狀態決定可否下載；batch 可能仍為 READY（其他廠商尚未匯）
      var vendorStatus = String(item.status || 'PENDING').toUpperCase();
      var isPaid = vendorStatus === 'PAID';
      var eventsUrl = PATHS.settlements + '/' + encodeURIComponent(batchId) +
        '/events.csv?vendor_slug=' + encodeURIComponent(slug) + modeQs;
      var ticketsUrl = PATHS.settlements + '/' + encodeURIComponent(batchId) +
        '/tickets.csv?vendor_slug=' + encodeURIComponent(slug) + modeQs;
      var mix = item.mode_mix || {};
      var otherCount = mode === 'PRIVATE'
        ? (parseInt(mix.full_tickets, 10) || 0)
        : (parseInt(mix.private_tickets, 10) || 0);
      var mixHint = otherCount > 0
        ? '<p class="lb-v2-muted" style="margin:0.45rem 0 0;">同一匯款批次另含 ' +
          otherCount + ' 張' + (mode === 'PRIVATE' ? '宣傳刊登（含金流）' : '資格限定課') +
          '票券；此頁僅顯示本模式分潤。</p>'
        : '';
      var paidRecord = isPaid
        ? '<div class="lb-v2-settlement-card__paid-record">' +
            '匯款紀錄（批次 ' + escapeHtml(item.batch_key || batchId) + '）：匯款日 ' +
            escapeHtml(item.paid_transfer_date || '—') +
            ' · 金額 ' + (item.paid_amount != null ? formatCurrency(item.paid_amount) : formatCurrency(item.vendor_payout)) +
            ' · 參考號 ' + escapeHtml(item.paid_ref || '—') +
            (item.paid_at
              ? ' · 確認時間 ' + escapeHtml(String(item.paid_at).slice(0, 19).replace('T', ' '))
              : '') +
            (item.paid_note ? ' · ' + escapeHtml(item.paid_note) : '') +
          '</div>'
        : '';
      return (
        '<article class="lb-v2-settlement-card">' +
          '<div class="lb-v2-settlement-card__head">' +
            '<strong>' + escapeHtml(item.batch_key || batchId) + '</strong>' +
            '<span class="' + settlementPortalPillClass(vendorStatus) + '">' +
              escapeHtml(settlementPortalStatusLabel(vendorStatus)) + '</span>' +
          '</div>' +
          '<div class="lb-v2-settlement-card__meta">' +
            '期間 ' + escapeHtml(item.period_start || '—') + ' ~ ' + escapeHtml(item.period_end || '—') +
            ' · 撥款日 ' + escapeHtml(item.payout_date || '—') +
            ' · ' + modeLabelText +
          '</div>' +
          '<div class="lb-v2-settlement-card__amounts">' +
            '<span>票數 ' + escapeHtml(item.ticket_count) + '</span>' +
            '<span>應付 <strong>' + formatCurrency(item.vendor_payout) + '</strong></span>' +
            '<span>平台費 ' + formatCurrency(item.platform_fee) + '</span>' +
            '<span>基數 ' + formatCurrency(item.share_base) + '</span>' +
            '<span>實退 ' + formatCurrency(item.refund_amount) + '</span>' +
          '</div>' +
          mixHint +
          paidRecord +
          (isPaid
            ? '<div class="lb-v2-settlement-card__actions">' +
                '<a class="lb-v2-btn lb-v2-btn--sm" href="' + eventsUrl + '">下載活動統計</a>' +
                '<a class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--ghost" href="' + ticketsUrl + '">下載票券明細</a>' +
              '</div>'
            : '<p class="lb-v2-muted" style="margin:0.5rem 0 0;">待官方完成對貴廠商匯款後即可下載結算單。</p>') +
        '</article>'
      );
    }).join('');
  }

  async function loadSettlementTab(mode, forceReload) {
    settlementViewMode = mode === 'PRIVATE' ? 'PRIVATE' : 'FULL';
    syncSettlementPanelCopy(settlementViewMode);
    var cacheKey = settlementViewMode === 'PRIVATE' ? 'settlement-private' : '';
    if (cacheKey && !beginTabLoad(cacheKey, forceReload)) return;
    var slug = getListingVendorSlug();
    if (!slug) {
      showNotice($('lb-v2-settlement-notice'), '請先選擇單一廠商');
      renderSettlementKpiFromItems([]);
      renderSettlementList([], slug, settlementViewMode);
      return;
    }
    hideNotice($('lb-v2-settlement-notice'));
    setDataLoading(true);
    try {
      var res = await fetchAppProxy(PATHS.settlements, slug, {
        listing_mode: settlementViewMode,
      });
      if (res.ok) {
        var payload = res.payload || res;
        var items = payload.items || [];
        renderSettlementKpiFromItems(items);
        renderSettlementList(items, slug, settlementViewMode);
        if (cacheKey) markTabCache(cacheKey);
      } else {
        showNotice($('lb-v2-settlement-notice'), res.message || '載入失敗');
      }
    } catch (err) {
      showNotice($('lb-v2-settlement-notice'), err.message || '載入失敗');
    } finally {
      setDataLoading(false);
    }
  }

  // ═══════════════════════════════════════════════════════
  // Listing form event bindings (deferred to after DOM ready)
  // ═══════════════════════════════════════════════════════

  var listingFormBound = false;

  async function bindListingFormEvents() {
    seedTaxonomyFromConfig();
    mountDynamicFormElements();
    // 新建／編輯都會走到這裡；不可只在 fillListingForm 才拉 taxonomy，否則會永遠「載入中…」
    ensureTaxonomyLoaded().catch(function (err) {
      console.warn('[taxonomy] ensureTaxonomyLoaded failed', err);
    });

    if (listingFormBound) {
      updateCancelPolicyDetail();
      return;
    }
    listingFormBound = true;

    var form = $('lb-v2-listing-form');
    if (form) {
      // 模式切換會藏欄位；交給 JS 驗證＋彈窗，避免 HTML5 對隱藏 required 靜默擋 submit。
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (e) { e.preventDefault(); saveListingDraft(); });
    }

    var submitReviewBtnBind = $('lb-v2-listing-submit-review');
    if (submitReviewBtnBind && !submitReviewBtnBind._lbSubmitBound) {
      submitReviewBtnBind._lbSubmitBound = true;
      submitReviewBtnBind.addEventListener('click', function () {
        if (listingFormReadOnly) {
          showListingAlert('目前為唯讀檢視，無法送審。請等候審核結果。', '無法編輯');
          return;
        }
        var idEl = $('lb-v2-listing-id');
        if (!idEl || !idEl.value) {
          showListingAlert('請先按「儲存草稿」，成功後再預覽送審。');
          return;
        }
        // 必填在開預覽前就擋，不要讓廠商看完預覽按確認才吃錯誤
        var reviewState = readListingFormBasics();
        if (!validateListingDraftShape(reviewState)) return;
        if (!validateListingSubmitRequirements(reviewState)) return;
        try {
          openListingReviewModal();
        } catch (reviewErr) {
          showListingAlert(
            (reviewErr && reviewErr.message) || '無法開啟預覽，請稍後再試。',
            '預覽失敗'
          );
          console.warn('[lb-v2] review modal', reviewErr);
        }
      });
    }

    var modeElInit = $('lb-v2-listing-mode');
    applyListingModeUI(modeElInit ? modeElInit.value : 'EXPOSURE');
    updateCancelPolicyDetail();
    bindImageUpload();
    bindDescImageUpload();

    bindExposureDateAutoFill();
    var calEl = $('lb-v2-exposure-calendar');
    if (calEl && !calEl._lbCalClickBound) {
      calEl._lbCalClickBound = true;
      calEl.addEventListener('click', function (e) {
        var dayEl = e.target && e.target.closest ? e.target.closest('.lb-v2-cal-day') : null;
        if (!dayEl || dayEl.disabled || dayEl.getAttribute('data-can-start') !== '1') return;
        var ymd = dayEl.getAttribute('data-day') || '';
        if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return;
        var maxEnd = calEl.getAttribute('data-max-end') || '';
        var latestStart = calEl.getAttribute('data-latest-start') || maxEnd;
        var durationDays = parseInt(calEl.getAttribute('data-duration-days') || '0', 10) || getSelectedPlanDurationDays();
        var maxInterval = getSelectedPlanMaxIntervalDays();
        if (maxEnd && ymd > maxEnd) return;
        if (durationDays > 0 && latestStart && ymd > latestStart) return;

        var startEl = $('lb-v2-listing-exposure-start');
        var endEl = $('lb-v2-listing-exposure-end');
        if (!startEl) return;

        if (durationDays > 0) {
          var endYmd = addDaysYmd(ymd, durationDays - 1);
          if (maxEnd && endYmd > maxEnd) return;
          startEl.value = ymd;
          if (endEl) endEl.value = endYmd;
          startEl.dataset.lbLastCalPick = ymd;
          syncExposureDateDisplays();
          highlightSelectedExposureDays();
          return;
        }

        var prevStart = startEl.dataset.lbLastCalPick || startEl.value || '';
        // 再點同一日起日 → 取消選取（才能重選其他起日）
        if (prevStart && ymd === prevStart) {
          startEl.value = '';
          if (endEl) endEl.value = '';
          delete startEl.dataset.lbLastCalPick;
          syncExposureDateDisplays();
          highlightSelectedExposureDays();
          return;
        }
        if (endEl && prevStart && ymd > prevStart) {
          if (maxEnd && ymd > maxEnd) return;
          if (maxInterval > 0) {
            var latestEnd = addDaysYmd(prevStart, maxInterval - 1);
            if (ymd > latestEnd) {
              showListingAlert('單次排程最長 ' + maxInterval + ' 天（迄日最晚 ' + formatDateZh(latestEnd) + '）');
              return;
            }
          }
          startEl.value = prevStart;
          endEl.value = ymd;
          startEl.dataset.lbLastCalPick = prevStart;
          syncExposureDateDisplays();
          highlightSelectedExposureDays();
        } else {
          startEl.value = ymd;
          if (endEl) endEl.value = '';
          startEl.dataset.lbLastCalPick = ymd;
          syncExposureDateDisplays();
          highlightSelectedExposureDays();
        }
      });
    }

    var addBtn = $('lb-v2-listing-add-variant');
    if (addBtn) {
      addBtn.addEventListener('click', function () { addVariantRow('', '', ''); });
    }
    bindModalChrome();
    var resetBtn = $('lb-v2-listing-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', clearListingForm);
    }
    // Mode filter onChange is wired once via createDynSelect (avoid double applyListingModeFilter).
    var gotoPurchase = $('lb-v2-listing-goto-purchase');
    if (gotoPurchase) {
      gotoPurchase.addEventListener('click', function () { switchTab('fee-purchase'); });
    }
    var lockGoto = $('lb-v2-listing-lock-goto-purchase');
    if (lockGoto) {
      lockGoto.addEventListener('click', function () { switchTab('fee-purchase'); });
    }
    var buyMore = $('lb-v2-listing-buy-more');
    if (buyMore) {
      buyMore.addEventListener('click', function () { switchTab('fee-purchase'); });
    }
    // Taxonomy deferred until listing tab / ensureTaxonomyLoaded().
  }

  async function boot() {
    bindModalChrome();
    watchThemeSelectWrappers();

    if (!config.loggedIn) {
      $('lb-v2-login').hidden = false;
      var link = $('lb-v2-login-link');
      if (link && config.loginUrl) {
        link.href = config.loginUrl + (config.returnPath
          ? '?return_url=' + encodeURIComponent(config.returnPath) : '');
      }
      return;
    }

    setBootstrapText('授權確認中…');
    $('lb-v2-bootstrap').hidden = false;

    try {
      var authResult = await fetchAuthorizedVendors();

      if (!authResult.ok) {
        $('lb-v2-bootstrap').hidden = true;
        $('lb-v2-no-backend-auth').hidden = false;
        $('lb-v2-no-backend-auth').querySelector('p:last-child').textContent =
          friendlyError(authResult.code, authResult.message);
        return;
      }

      activeVendors = authResult.slugs.slice();
      vendorRoleBySlug = authResult.roles || {};
      vendorNameBySlug = authResult.names || {};

      if (!activeVendors.length) {
        $('lb-v2-bootstrap').hidden = true;
        $('lb-v2-no-backend-auth').hidden = false;
        return;
      }

      accountIsScanOnlyOnly = isScanOnlyOnlyAccount();
      if (accountIsScanOnlyOnly) {
        $('lb-v2-bootstrap').hidden = true;
        $('lb-v2-scan-only').hidden = false;
        var scanLink = $('lb-v2-scan-only-link');
        if (scanLink && activeVendors[0]) {
          scanLink.href = (config.scanUrl || '/pages/vendor-scan-v2') +
            '?vendor=' + encodeURIComponent(activeVendors[0]);
        }
        return;
      }

      vendorMode = activeVendors.length === 1 ? activeVendors[0] : ALL_MODE;
      // Show app shell early; data fills via events progressive load.
      // Listing form (dyn selects / taxonomy UI) lazy-inits on first listing/private visit.
      setBootstrapText('載入活動與報表…');
      $('lb-v2-app').hidden = false;

      renderVendorSelector();
      renderMetafieldWarning();
      mountFilters('lb-v2-filters', eventsPage, loadEventsData);
      mountFilters('lb-v2-overview-filters', overviewPage, function () { loadOverviewTab(false); });
      refreshCourseDecisionBadge();
      switchTab('events');
      refreshTabNavCapability();
      $('lb-v2-bootstrap').hidden = true;
    } catch (err) {
      $('lb-v2-bootstrap').hidden = true;
      $('lb-v2-no-backend-auth').hidden = false;
      $('lb-v2-no-backend-auth').querySelector('p:last-child').textContent =
        err && err.message ? err.message : '載入失敗';
    }
  }

  // ── PRIVATE（資格限定課）tab ────────────────────────────────

  var privateTabBound = false;

  function formatDateTimeTw(iso) {
    if (!iso) return '—';
    try { return new Date(iso).toLocaleString('zh-TW'); } catch (e) { return String(iso); }
  }

  async function postAppProxyJson(path, body) {
    var response = await fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body || {}),
    });
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    if (!response.ok || !payload || payload.ok !== true) {
      var code = payload && payload.error && payload.error.code ? payload.error.code : 'HTTP_' + response.status;
      var message = payload && payload.error && payload.error.message ? payload.error.message : '';
      return { ok: false, code: code, message: message, payload: payload };
    }
    return { ok: true, payload: payload };
  }

  function privateAppField(app, key) {
    return String((app && app[key]) || '').trim();
  }

  function applicationDetailsComplete(app) {
    if (!app) return false;
    return !!(
      privateAppField(app, 'company_name') &&
      privateAppField(app, 'brand_name') &&
      privateAppField(app, 'owner_name') &&
      privateAppField(app, 'contact_name') &&
      privateAppField(app, 'contact_phone') &&
      privateAppField(app, 'business_description') &&
      privateAppField(app, 'course_format')
    );
  }

  function applicationNeedsFill(app) {
    if (!app || String(app.status || '').toUpperCase() !== 'PENDING') return false;
    return !applicationDetailsComplete(app);
  }

  function privateAppStatusMeta(app) {
    var st = String(app.status || '').toUpperCase();
    if (st === 'APPROVED') {
      return { label: '已核准', badge: 'lb-v2-badge--ok', readonly: true, canSubmit: false };
    }
    if (st === 'REJECTED') {
      return { label: '已駁回', badge: 'lb-v2-badge--pending', readonly: false, canSubmit: true };
    }
    if (applicationNeedsFill(app)) {
      return { label: '待補填', badge: 'lb-v2-badge--pending', readonly: false, canSubmit: true };
    }
    return { label: '審核中', badge: 'lb-v2-badge--ok', readonly: true, canSubmit: false };
  }

  function privateAppFieldHtml(opts) {
    var label = opts.label;
    var key = opts.key;
    var value = opts.value || '';
    var readonly = !!opts.readonly;
    var rows = opts.rows || 1;
    var placeholder = opts.placeholder || '';
    var maxlength = opts.maxlength || 256;
    var type = opts.type || 'text';
    if (readonly) {
      return '<div class="lb-v2-field" style="margin-top:0.55rem">' +
        '<label>' + escapeHtml(label) + '</label>' +
        '<div class="lb-v2-input" style="min-height:2.4rem;white-space:pre-wrap;background:#f7f5f6;">' +
          (escapeHtml(value) || '—') +
        '</div></div>';
    }
    if (rows > 1) {
      return '<div class="lb-v2-field" style="margin-top:0.55rem">' +
        '<label>' + escapeHtml(label) + '</label>' +
        '<textarea class="lb-v2-input" rows="' + rows + '" data-private-app-' + key +
          ' maxlength="' + maxlength + '" placeholder="' + escapeHtml(placeholder) + '">' +
          escapeHtml(value) + '</textarea></div>';
    }
    return '<div class="lb-v2-field" style="margin-top:0.55rem">' +
      '<label>' + escapeHtml(label) + '</label>' +
      '<input type="' + type + '" class="lb-v2-input" data-private-app-' + key +
        ' maxlength="' + maxlength + '" placeholder="' + escapeHtml(placeholder) +
        '" value="' + escapeHtml(value) + '"></div>';
  }

  function renderPrivateApplications(items) {
    var host = $('lb-v2-private-applications');
    if (!host) return;
    var list = (items || []).slice();
    if (!list.length) {
      host.innerHTML = '<p class="lb-v2-muted">目前沒有年約申請。請先至「營運結帳」購買，或申請免費資格限定課年約。</p>';
      return;
    }
    var html = '';
    list.forEach(function (app) {
      var meta = privateAppStatusMeta(app);
      var st = String(app.status || '').toUpperCase();
      html += '<article class="lb-v2-m-card" data-private-app-id="' + app.id + '">' +
        '<div class="lb-v2-m-card__head">' +
          '<div class="lb-v2-m-card__title">申請 #' + app.id +
            (app.shopify_order_name ? ' · ' + escapeHtml(app.shopify_order_name) : '') + '</div>' +
          '<span class="lb-v2-badge ' + meta.badge + '">' + meta.label + '</span>' +
        '</div>' +
        '<p class="lb-v2-hint">建立於 ' + escapeHtml(formatDateTimeTw(app.created_at)) +
          (app.reviewed_at ? ' · 審核於 ' + escapeHtml(formatDateTimeTw(app.reviewed_at)) : '') +
        '</p>';

      if (st === 'REJECTED') {
        html += '<div style="margin:0.65rem 0;padding:0.7rem 0.85rem;border-radius:10px;background:rgba(166,27,63,0.08);border:1px solid rgba(166,27,63,0.22);">' +
          '<strong style="color:#a61b3f;">駁回原因</strong>' +
          '<div style="margin-top:0.25rem;white-space:pre-wrap;">' +
            escapeHtml(app.review_note || '（未填寫）') +
          '</div>' +
          '<p class="lb-v2-hint" style="margin:0.45rem 0 0;">修改資料後可重新送審' +
            (app.shopify_order_id || (app.shopify_order_name && app.shopify_order_name !== '免費申請')
              ? '，無需再次付款。'
              : '。') +
          '</p></div>';
      }

      if (st === 'APPROVED') {
        var expiresLabel = app.grant_expires_at
          ? ('有效至 <strong>' + escapeHtml(formatDateTw(app.grant_expires_at)) + '</strong>')
          : '有效期限：依核准當日開通天數計算';
        html += '<div style="margin:0.65rem 0;padding:0.7rem 0.85rem;border-radius:10px;background:rgba(39,174,96,0.08);border:1px solid rgba(39,174,96,0.25);">' +
          '<strong style="color:#1e7e46;">年約已開通</strong>' +
          '<div style="margin-top:0.35rem;">' + expiresLabel + '</div>' +
          (app.review_note
            ? '<div class="lb-v2-hint" style="margin-top:0.25rem;white-space:pre-wrap;">備註：' + escapeHtml(app.review_note) + '</div>'
            : '') +
          '<div class="lb-v2-m-card__actions" style="margin-top:0.65rem;">' +
            '<a class="lb-v2-btn lb-v2-btn--accent lb-v2-btn--sm" style="text-decoration:none;" href="/pages/private-courses" target="_blank" rel="noopener">前往學員端資格限定課</a>' +
          '</div></div>';
      }

      html += '<div class="lb-v2-private-app-grid">';
      html += privateAppFieldHtml({
        label: '公司行號 *', key: 'company', value: app.company_name,
        readonly: meta.readonly, maxlength: 256, placeholder: '例：某某有限公司'
      });
      html += privateAppFieldHtml({
        label: '品牌名稱 *', key: 'brand', value: app.brand_name,
        readonly: meta.readonly, maxlength: 256, placeholder: '例：品牌對外名稱'
      });
      html += privateAppFieldHtml({
        label: '負責人姓名 *', key: 'owner', value: app.owner_name,
        readonly: meta.readonly, maxlength: 128, placeholder: '例：王小明'
      });
      html += privateAppFieldHtml({
        label: '聯絡人姓名 *', key: 'contact-name', value: app.contact_name,
        readonly: meta.readonly, maxlength: 128, placeholder: '例：聯絡窗口'
      });
      html += privateAppFieldHtml({
        label: '聯絡人電話 *', key: 'contact-phone', value: app.contact_phone,
        readonly: meta.readonly, maxlength: 32, type: 'tel', placeholder: '例：0912345678'
      });
      html += '<div class="lb-v2-private-app-span2">' + privateAppFieldHtml({
        label: '業務內容說明 *', key: 'biz', value: app.business_description,
        readonly: meta.readonly, rows: 3, maxlength: 5000,
        placeholder: '例：主要服務對象、教學理念、既有學員來源'
      }) + '</div>';
      html += '<div class="lb-v2-private-app-span2">' + privateAppFieldHtml({
        label: '課程形式 *', key: 'format', value: app.course_format,
        readonly: meta.readonly, rows: 2, maxlength: 2000,
        placeholder: '例：一對一／小班、線下教室、每週次數'
      }) + '</div>';
      html += '</div>';

      if (meta.canSubmit) {
        html += '<div class="lb-v2-m-card__actions">' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--accent lb-v2-btn--sm" data-private-app-submit="' +
            app.id + '">' + (st === 'REJECTED' ? '修改並重新送審' : '送出申請資料') + '</button>' +
        '</div>';
      } else if (st === 'PENDING') {
        html += '<p class="lb-v2-hint" style="margin-top:0.75rem;">審核中資料已鎖定，無法重送；若需修改請等候官方駁回後再申請（付費訂單無需再付款）。</p>';
      }

      html += '</article>';
    });
    host.innerHTML = html;
    host.querySelectorAll('[data-private-app-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        submitPrivateApplication(btn.getAttribute('data-private-app-submit'), btn);
      });
    });
  }

  function readPrivateAppField(card, attr) {
    var el = card.querySelector('[data-private-app-' + attr + ']');
    return el ? String(el.value || '').trim() : '';
  }

  async function submitPrivateApplication(id, btn) {
    var slug = getListingVendorSlug();
    if (!slug || !id) return;
    var card = root.querySelector('[data-private-app-id="' + id + '"]');
    if (!card) return;
    var payload = {
      vendor_slug: slug,
      id: parseInt(id, 10),
      company_name: readPrivateAppField(card, 'company'),
      brand_name: readPrivateAppField(card, 'brand'),
      owner_name: readPrivateAppField(card, 'owner'),
      contact_name: readPrivateAppField(card, 'contact-name'),
      contact_phone: readPrivateAppField(card, 'contact-phone'),
      business_description: readPrivateAppField(card, 'biz'),
      course_format: readPrivateAppField(card, 'format'),
    };
    if (!payload.company_name) {
      showNotice($('lb-v2-private-notice'), '請填寫公司行號');
      return;
    }
    if (!payload.brand_name) {
      showNotice($('lb-v2-private-notice'), '請填寫品牌名稱');
      return;
    }
    if (!payload.owner_name) {
      showNotice($('lb-v2-private-notice'), '請填寫負責人姓名');
      return;
    }
    if (!payload.contact_name) {
      showNotice($('lb-v2-private-notice'), '請填寫聯絡人姓名');
      return;
    }
    if (!payload.contact_phone) {
      showNotice($('lb-v2-private-notice'), '請填寫聯絡人電話');
      return;
    }
    if (!payload.business_description) {
      showNotice($('lb-v2-private-notice'), '請填寫業務內容說明');
      return;
    }
    if (!payload.course_format) {
      showNotice($('lb-v2-private-notice'), '請填寫課程形式');
      return;
    }
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.privateApplicationSubmit, payload);
      if (res.ok) {
        showNotice($('lb-v2-private-notice'), '已送出申請資料，請等候官方審核。');
        loadPrivateTab();
      } else {
        showNotice($('lb-v2-private-notice'), res.message || '送出失敗');
      }
    } catch (err) {
      showNotice($('lb-v2-private-notice'), err.message || '送出失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  var ELIG_WINDOW_LABELS = {
    active: '生效中',
    upcoming: '尚未生效',
    expired: '已過期',
    cancelled: '已取消',
  };
  var privateEligItemsCache = [];
  var privateEligFilter = 'all';
  var privateEligPickersMounted = false;
  var privateEligReqItemsCache = [];
  var privateEligReqFilter = 'PENDING';
  var privateEligReqGrantExpiresAt = null;
  var privateEligTabBound = false;

  function getPrivateGrantExpiresAt() {
    if (privateEligReqGrantExpiresAt) return privateEligReqGrantExpiresAt;
    var mode = findModeEntitlement('PRIVATE');
    return (mode && mode.duration_expires_at) || null;
  }

  function syncPrivateEligGrantNote() {
    var el = $('lb-v2-private-elig-grant-note');
    if (!el) return;
    var grantExp = getPrivateGrantExpiresAt();
    if (!grantExp) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.innerHTML =
      '提醒：本廠商「資格限定課」年約到期日為 <strong>' +
      escapeHtml(formatDateTw(grantExp)) +
      '</strong>。核發通行證時，失效時間須早於此日。';
  }

  function endOfLocalDayFromYmd(ymd) {
    var m = String(ymd || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return null;
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 23, 59, 59, 999);
  }

  function todayLocalYmd() {
    var d = new Date();
    var yyyy = d.getFullYear();
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return yyyy + '-' + mm + '-' + dd;
  }

  function grantExpiresMaxSelectableYmd(grantExp) {
    if (!grantExp) return '';
    var g = new Date(grantExp);
    if (!isFinite(g.getTime())) return '';
    // Latest local calendar day whose 23:59:59.999 is still strictly before grantExp.
    var cursor = new Date(g.getTime() - 1);
    for (var i = 0; i < 4; i++) {
      var yyyy = cursor.getFullYear();
      var mm = String(cursor.getMonth() + 1).padStart(2, '0');
      var dd = String(cursor.getDate()).padStart(2, '0');
      var ymd = yyyy + '-' + mm + '-' + dd;
      var eod = endOfLocalDayFromYmd(ymd);
      if (eod && eod.getTime() < g.getTime()) return ymd;
      cursor = new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate() - 1, 12, 0, 0);
    }
    return '';
  }

  function eligNoticeEl() {
    return $('lb-v2-private-elig-notice') || $('lb-v2-private-notice');
  }

  function eligWindowState(row) {
    var st = String((row && row.status) || '').toUpperCase();
    if (st === 'CANCELLED') return 'cancelled';
    var now = Date.now();
    var s = new Date(row.starts_at).getTime();
    var e = new Date(row.ends_at).getTime();
    if (!isFinite(s) || !isFinite(e)) return 'expired';
    if (s <= now && now < e) return 'active';
    if (s > now) return 'upcoming';
    return 'expired';
  }

  function eligWindowBadgeClass(state) {
    if (state === 'active') return 'lb-v2-badge--ok';
    if (state === 'upcoming') return 'lb-v2-badge--pending';
    if (state === 'cancelled') return 'lb-v2-badge--void';
    return 'lb-v2-badge--muted';
  }

  function syncEligFilterButtons() {
    var rootFilters = $('lb-v2-private-elig-filters');
    if (!rootFilters) return;
    rootFilters.querySelectorAll('[data-elig-filter]').forEach(function (btn) {
      var key = btn.getAttribute('data-elig-filter') || 'all';
      var on = key === privateEligFilter;
      btn.classList.toggle('lb-v2-btn--accent', on);
      btn.classList.toggle('lb-v2-btn--ghost', !on);
    });
  }

  function syncEligReqFilterButtons() {
    var rootFilters = $('lb-v2-private-elig-req-filters');
    if (!rootFilters) return;
    rootFilters.querySelectorAll('[data-elig-req-filter]').forEach(function (btn) {
      var key = btn.getAttribute('data-elig-req-filter') || 'PENDING';
      var on = key === privateEligReqFilter;
      btn.classList.toggle('lb-v2-btn--accent', on);
      btn.classList.toggle('lb-v2-btn--ghost', !on);
    });
  }

  function renderPrivateEligibilityRequests(items) {
    privateEligReqItemsCache = Array.isArray(items) ? items.slice() : [];
    renderPrivateEligibilityRequestsFiltered();
  }

  function renderPrivateEligibilityRequestsFiltered() {
    var host = $('lb-v2-private-elig-requests');
    if (!host) return;
    syncEligReqFilterButtons();
    var items = privateEligReqItemsCache.filter(function (row) {
      if (privateEligReqFilter === 'ALL') return true;
      return String(row.status || '').toUpperCase() === privateEligReqFilter;
    });
    if (!privateEligReqItemsCache.length) {
      host.innerHTML = '<p class="lb-v2-muted">尚無學員申請。</p>';
      return;
    }
    if (!items.length) {
      host.innerHTML = '<p class="lb-v2-muted">此篩選條件下沒有申請。</p>';
      return;
    }
    var html = '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
      '<th>Email</th><th>原因</th><th>申請時間</th><th>狀態</th><th>操作</th>' +
      '</tr></thead><tbody>';
    var cards = '';
    items.forEach(function (row) {
      var st = String(row.status || '').toUpperCase();
      var stLabel = st === 'PENDING' ? '待審核' : st === 'APPROVED' ? '已核准' : st === 'REJECTED' ? '已駁回' : st;
      var stClass = st === 'PENDING' ? 'lb-v2-badge--pending' : st === 'APPROVED' ? 'lb-v2-badge--ok' : 'lb-v2-badge--muted';
      var actions = '—';
      if (st === 'PENDING') {
        actions =
          '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--accent" data-elig-req-approve="' +
          row.id + '">核准</button> ' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--danger" data-elig-req-reject="' +
          row.id + '">駁回</button>';
      } else if (st === 'REJECTED' && row.reject_reason) {
        actions = '<span class="lb-v2-muted">' + escapeHtml(row.reject_reason) + '</span>';
      }
      html += '<tr>' +
        '<td>' + escapeHtml(row.email || '—') + '</td>' +
        '<td>' + escapeHtml(row.reason || '—') + '</td>' +
        '<td>' + escapeHtml(formatDateTimeTw(row.created_at)) + '</td>' +
        '<td><span class="lb-v2-badge ' + stClass + '">' + escapeHtml(stLabel) + '</span></td>' +
        '<td class="lb-v2-table-actions">' + actions + '</td></tr>';
      cards += '<article class="lb-v2-m-card">' +
        '<div class="lb-v2-m-card__head">' +
          '<div class="lb-v2-m-card__title">' + escapeHtml(row.email || '—') + '</div>' +
          '<span class="lb-v2-badge ' + stClass + '">' + escapeHtml(stLabel) + '</span>' +
        '</div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">原因</span><span>' +
          escapeHtml(row.reason || '—') + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">申請</span><span>' +
          escapeHtml(formatDateTimeTw(row.created_at)) + '</span></div>' +
        (st === 'PENDING' ? '<div class="lb-v2-m-card__actions">' + actions + '</div>' : '') +
        (st === 'REJECTED' && row.reject_reason
          ? '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">駁回</span><span>' +
            escapeHtml(row.reject_reason) + '</span></div>'
          : '') +
      '</article>';
    });
    html += '</tbody></table></div><div class="lb-v2-m-cards">' + cards + '</div>';
    host.innerHTML = html;
    host.querySelectorAll('[data-elig-req-approve]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        approveEligibilityRequest(btn.getAttribute('data-elig-req-approve'), btn);
      });
    });
    host.querySelectorAll('[data-elig-req-reject]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        rejectEligibilityRequest(btn.getAttribute('data-elig-req-reject'), btn);
      });
    });
  }

  function parseApproveEligibilityInput(grantExp) {
    var modeEl = document.querySelector('input[name="lb-v2-elig-approve-mode"]:checked');
    var mode = modeEl ? modeEl.value : 'days';
    var starts = new Date();
    var ends = null;
    var summary = '';
    if (mode === 'date') {
      var ymd = (($('lb-v2-elig-approve-ends') || {}).value || '').trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
        return { ok: false, message: '請選擇到期日' };
      }
      ends = endOfLocalDayFromYmd(ymd);
      if (!ends) return { ok: false, message: '到期日格式無效' };
      if (ends.getTime() <= starts.getTime()) {
        return { ok: false, message: '到期日必須晚於現在' };
      }
      summary = '至 ' + ends.toLocaleString('zh-TW');
    } else {
      var days = parseInt(String((($('lb-v2-elig-approve-days') || {}).value || '')).trim(), 10);
      if (!isFinite(days) || days < 1) {
        return { ok: false, message: '請輸入有效天數（至少 1 天）' };
      }
      ends = new Date(starts.getTime() + days * 24 * 60 * 60 * 1000);
      summary = days + ' 天（至 ' + ends.toLocaleString('zh-TW') + '）';
    }
    if (grantExp && ends.getTime() >= new Date(grantExp).getTime()) {
      return {
        ok: false,
        message: '效期必須早於資格限定課年約到期日（' + formatDateTw(grantExp) + '）',
      };
    }
    return { ok: true, starts: starts, ends: ends, summary: summary };
  }

  function findEligRequestById(id) {
    var items = privateEligReqItemsCache || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(id)) return items[i];
    }
    return null;
  }

  function existingPassLabelForEmail(email) {
    var key = String(email || '').trim().toLowerCase();
    if (!key) return '';
    var items = privateEligItemsCache || [];
    var fallback = '';
    for (var i = 0; i < items.length; i++) {
      var rowEmail = String(items[i].email || '').trim().toLowerCase();
      if (rowEmail !== key) continue;
      var lab = String(items[i].label || '').trim();
      if (!lab) continue;
      if (eligWindowState(items[i]) !== 'cancelled') return lab.slice(0, 128);
      if (!fallback) fallback = lab.slice(0, 128);
    }
    return fallback;
  }

  function readApproveEligibilityLabel() {
    return String((($('lb-v2-elig-approve-label') || {}).value || '')).trim().slice(0, 128);
  }

  function openApproveEligibilityModal(id, btn) {
    var slug = getListingVendorSlug();
    if (!slug || !id) return;
    var grantExp = getPrivateGrantExpiresAt();
    var grantNote = grantExp
      ? ('<div class="lb-v2-elig-approve__grant">提醒：本廠商「資格限定課」年約到期日為 <strong>' +
        escapeHtml(formatDateTw(grantExp)) +
        '</strong>。<br>通行證失效時間須早於此日。</div>')
      : '<div class="lb-v2-elig-approve__grant">提醒：通行證效期須小於本廠商「資格限定課」年約期限。</div>';
    var maxYmd = grantExpiresMaxSelectableYmd(grantExp);
    var todayYmd = todayLocalYmd();
    var bodyHtml =
      grantNote +
      '<div class="lb-v2-elig-approve">' +
        '<div class="lb-v2-elig-approve__modes" role="radiogroup" aria-label="效期輸入方式">' +
          '<label class="lb-v2-elig-approve__mode">' +
            '<input type="radio" name="lb-v2-elig-approve-mode" value="days" checked> 輸入天數' +
          '</label>' +
          '<label class="lb-v2-elig-approve__mode">' +
            '<input type="radio" name="lb-v2-elig-approve-mode" value="date"> 選擇到期日' +
          '</label>' +
        '</div>' +
        '<div class="lb-v2-field" data-approve-panel="days">' +
          '<label for="lb-v2-elig-approve-days">效期天數（自此刻起算）</label>' +
          '<input type="number" id="lb-v2-elig-approve-days" class="lb-v2-input" min="1" step="1" inputmode="numeric" placeholder="例：30、90、180">' +
        '</div>' +
        '<div class="lb-v2-field" data-approve-panel="date" hidden>' +
          '<label for="lb-v2-elig-approve-ends-visible">到期日</label>' +
          '<div id="lb-v2-elig-approve-ends-slot" class="lb-v2-slot"></div>' +
          '<p class="lb-v2-hint">點「選日期」開啟月曆；選定當日 23:59:59 失效' +
            (maxYmd ? ('；最晚可選 ' + escapeHtml(maxYmd)) : '') +
          '</p>' +
        '</div>' +
        '<div class="lb-v2-field">' +
          '<label for="lb-v2-elig-approve-label">標籤（選填）</label>' +
          '<input type="text" id="lb-v2-elig-approve-label" class="lb-v2-input" maxlength="128" placeholder="例：第一期學員、502房" autocomplete="off">' +
          '<p class="lb-v2-hint">空白則保留既有標籤；申請原因不會寫入。</p>' +
        '</div>' +
        '<p id="lb-v2-elig-approve-error" class="lb-v2-elig-approve__error" hidden></p>' +
      '</div>';

    openModal({
      title: '核准並設定效期',
      bodyHtml: bodyHtml,
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '確定核准',
          accent: true,
          close: false,
          onClick: function () {
            var errEl = $('lb-v2-elig-approve-error');
            if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
            var parsed = parseApproveEligibilityInput(grantExp);
            if (!parsed.ok) {
              if (errEl) {
                errEl.hidden = false;
                errEl.textContent = parsed.message;
              }
              return false;
            }
            var passLabel = readApproveEligibilityLabel();
            closeModal();
            submitApproveEligibilityRequest(id, btn, parsed.starts, parsed.ends, parsed.summary, passLabel);
            return false;
          },
        },
      ],
    });

    // Reuse portal date picker (native type=date is often blocked by theme CSS).
    var endsPicker = createDynPickerField('lb-v2-elig-approve-ends', 'date');
    mountInSlot('lb-v2-elig-approve-ends-slot', endsPicker);
    var reqRow = findEligRequestById(id);
    var existingLabel = existingPassLabelForEmail(reqRow && reqRow.email);
    var labelEl = $('lb-v2-elig-approve-label');
    if (labelEl && existingLabel) labelEl.value = existingLabel;
    var endsInp = $('lb-v2-elig-approve-ends');
    if (endsInp) {
      endsInp.required = false;
      endsInp.min = todayYmd;
      if (maxYmd) endsInp.max = maxYmd;
    }

    function syncApproveModePanels() {
      var modeEl = document.querySelector('input[name="lb-v2-elig-approve-mode"]:checked');
      var mode = modeEl ? modeEl.value : 'days';
      document.querySelectorAll('[data-approve-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-approve-panel') !== mode;
      });
      if (mode === 'date') {
        var dateBtn = document.querySelector('#lb-v2-elig-approve-ends-slot .lb-v2-picker-btn');
        var dateVisible = $('lb-v2-elig-approve-ends-visible');
        if (dateBtn) dateBtn.focus();
        else if (dateVisible) dateVisible.focus();
      } else {
        var daysEl = $('lb-v2-elig-approve-days');
        if (daysEl) daysEl.focus();
      }
    }
    document.querySelectorAll('input[name="lb-v2-elig-approve-mode"]').forEach(function (radio) {
      radio.addEventListener('change', syncApproveModePanels);
    });
    syncApproveModePanels();
  }

  async function submitApproveEligibilityRequest(id, btn, starts, ends, summary, label) {
    var slug = getListingVendorSlug();
    if (!slug || !id || !starts || !ends) return;
    if (btn) btn.disabled = true;
    try {
      var body = {
        vendor_slug: slug,
        id: parseInt(id, 10),
        starts_at: starts.toISOString(),
        ends_at: ends.toISOString(),
      };
      var passLabel = String(label || '').trim().slice(0, 128);
      if (passLabel) body.label = passLabel;
      var res = await postAppProxyJson(PATHS.privateEligibilityRequestApprove, body);
      if (res.ok) {
        showNotice(eligNoticeEl(), '已核准並發放通行證（' + summary + '）');
        loadPrivateEligibilityTab();
      } else {
        var approveErr = extractApiError(res);
        showNotice(
          eligNoticeEl(),
          approveErr.code ? '[' + approveErr.code + '] ' + approveErr.message : (approveErr.message || res.message || '核准失敗')
        );
      }
    } catch (err) {
      showNotice(eligNoticeEl(), err.message || '核准失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function approveEligibilityRequest(id, btn) {
    openApproveEligibilityModal(id, btn);
  }

  async function rejectEligibilityRequest(id, btn) {
    var slug = getListingVendorSlug();
    if (!slug || !id) return;
    var reason = window.prompt('請填寫駁回原因（學員可見）');
    if (reason == null) return;
    reason = String(reason).trim();
    if (!reason) {
      showNotice(eligNoticeEl(), '駁回原因不可空白');
      return;
    }
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.privateEligibilityRequestReject, {
        vendor_slug: slug,
        id: parseInt(id, 10),
        reject_reason: reason.slice(0, 500),
      });
      if (res.ok) {
        showNotice(eligNoticeEl(), '已駁回申請');
        loadPrivateEligibilityTab();
      } else {
        showNotice(eligNoticeEl(), res.message || '駁回失敗');
      }
    } catch (err) {
      showNotice(eligNoticeEl(), err.message || '駁回失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function renderPrivateEligibility(items) {
    privateEligItemsCache = Array.isArray(items) ? items.slice() : [];
    renderPrivateEligibilityFiltered();
  }

  function renderPrivateEligibilityFiltered() {
    var host = $('lb-v2-private-eligibility-list');
    if (!host) return;
    syncEligFilterButtons();
    var items = privateEligItemsCache.filter(function (row) {
      if (privateEligFilter === 'all') return true;
      return eligWindowState(row) === privateEligFilter;
    });
    if (!privateEligItemsCache.length) {
      host.innerHTML = '<p class="lb-v2-muted">尚無資格通行證。請用下方表單新增，或匯入 Excel。</p>';
      return;
    }
    if (!items.length) {
      host.innerHTML = '<p class="lb-v2-muted">此篩選條件下沒有通行證。</p>';
      return;
    }
    var html = '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table lb-v2-table--elig"><thead><tr>' +
      '<th class="lb-v2-col-email">Email</th><th class="lb-v2-col-phone">手機</th><th class="lb-v2-col-label">標籤</th><th class="lb-v2-col-time">生效</th><th class="lb-v2-col-time">失效</th><th class="lb-v2-col-status">區間</th><th class="lb-v2-col-actions">操作</th>' +
      '</tr></thead><tbody>';
    var cards = '';
    items.forEach(function (row) {
      var win = eligWindowState(row);
      var winLabel = ELIG_WINDOW_LABELS[win] || win;
      var stClass = eligWindowBadgeClass(win);
      var identityTitle = row.email || row.phone || '';
      var cancelBtn = win !== 'cancelled'
        ? '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--danger" data-private-elig-cancel="' +
          row.id + '">取消</button>'
        : '—';
      html += '<tr>' +
        '<td class="lb-v2-col-email">' + escapeHtml(row.email || '—') + '</td>' +
        '<td class="lb-v2-col-phone">' + escapeHtml(row.phone || '—') + '</td>' +
        '<td class="lb-v2-col-label">' + escapeHtml(row.label || '—') + '</td>' +
        '<td class="lb-v2-col-time">' + escapeHtml(formatDateTimeTw(row.starts_at)) + '</td>' +
        '<td class="lb-v2-col-time">' + escapeHtml(formatDateTimeTw(row.ends_at)) + '</td>' +
        '<td class="lb-v2-col-status"><span class="lb-v2-badge ' + stClass + '">' + escapeHtml(winLabel) + '</span></td>' +
        '<td class="lb-v2-col-actions lb-v2-table-actions">' + cancelBtn + '</td></tr>';
      cards += '<article class="lb-v2-m-card">' +
        '<div class="lb-v2-m-card__head">' +
          '<div class="lb-v2-m-card__title">' + escapeHtml(identityTitle) + '</div>' +
          '<span class="lb-v2-badge ' + stClass + '">' + escapeHtml(winLabel) + '</span>' +
        '</div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">標籤</span><span>' +
          escapeHtml(row.label || '—') + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">生效</span><span>' +
          escapeHtml(formatDateTimeTw(row.starts_at)) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">失效</span><span>' +
          escapeHtml(formatDateTimeTw(row.ends_at)) + '</span></div>' +
        (win !== 'cancelled' ? '<div class="lb-v2-m-card__actions">' + cancelBtn + '</div>' : '') +
      '</article>';
    });
    html += '</tbody></table></div><div class="lb-v2-m-cards">' + cards + '</div>';
    host.innerHTML = html;
    host.querySelectorAll('[data-private-elig-cancel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        cancelPrivateEligibility(btn.getAttribute('data-private-elig-cancel'), btn);
      });
    });
  }

  async function cancelPrivateEligibility(id, btn) {
    var slug = getListingVendorSlug();
    if (!slug || !id) return;
    if (!window.confirm('確定取消此資格通行證？取消後學員將無法再以該通行證報名。')) return;
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.privateEligibilityCancel, {
        vendor_slug: slug,
        id: parseInt(id, 10),
      });
      if (res.ok) {
        showNotice(eligNoticeEl(), '已取消通行證');
        loadPrivateEligibilityTab();
      } else {
        showNotice(eligNoticeEl(), res.message || '取消失敗');
      }
    } catch (err) {
      showNotice(eligNoticeEl(), err.message || '取消失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function ensureEligibilityDateTimePickers() {
    if (privateEligPickersMounted) return;
    if (!$('lb-v2-private-elig-starts-date-slot')) return;
    privateEligPickersMounted = true;
    mountInSlot('lb-v2-private-elig-starts-date-slot', createDynPickerField('lb-v2-private-elig-starts-date', 'date'));
    mountInSlot('lb-v2-private-elig-starts-time-slot', createDynPickerField('lb-v2-private-elig-starts-time', 'time'));
    mountInSlot('lb-v2-private-elig-ends-date-slot', createDynPickerField('lb-v2-private-elig-ends-date', 'date'));
    mountInSlot('lb-v2-private-elig-ends-time-slot', createDynPickerField('lb-v2-private-elig-ends-time', 'time'));
  }

  function clearEligibilityForm() {
    var email = $('lb-v2-private-elig-email');
    if (email) email.value = '';
    var phone = $('lb-v2-private-elig-phone');
    if (phone) phone.value = '';
    var label = $('lb-v2-private-elig-label');
    if (label) label.value = '';
    writeDateTimePair('lb-v2-private-elig-starts-date', 'lb-v2-private-elig-starts-time', '');
    writeDateTimePair('lb-v2-private-elig-ends-date', 'lb-v2-private-elig-ends-time', '');
    var picked = $('lb-v2-private-elig-customer-picked');
    if (picked) {
      picked.hidden = true;
      picked.textContent = '';
      picked.classList.remove('is-warn');
    }
    var results = $('lb-v2-private-elig-customer-results');
    if (results) {
      results.hidden = true;
      results.innerHTML = '';
    }
  }

  function renderEligCustomerSearchResults(items) {
    var panel = $('lb-v2-private-elig-customer-results');
    if (!panel) return;
    if (!items || !items.length) {
      panel.innerHTML = '<p class="lb-v2-muted">查無顧客。可直接填寫 Email（或手機）。</p>';
      panel.hidden = false;
      return;
    }
    panel.innerHTML = items.map(function (item) {
      var hasEmail = !!(item.email && String(item.email).trim());
      var emailNote = hasEmail
        ? escapeHtml(item.email)
        : '<span class="lb-v2-elig-search__no-phone">無 Email（選取後需手填）</span>';
      var phoneNote = item.has_phone
        ? escapeHtml(item.phone || '')
        : '無電話';
      return '<button type="button" class="lb-v2-elig-search__item" role="option"' +
        ' data-phone="' + escapeHtml(item.phone || '') + '"' +
        ' data-name="' + escapeHtml(item.display_name || '') + '"' +
        ' data-email="' + escapeHtml(item.email || '') + '"' +
        ' data-has-email="' + (hasEmail ? '1' : '0') + '"' +
        ' data-has-phone="' + (item.has_phone ? '1' : '0') + '">' +
        '<strong>' + escapeHtml(item.display_name || '未命名') + '</strong>' +
        '<span>' + emailNote + ' · ' + phoneNote + '</span>' +
        '</button>';
    }).join('');
    panel.hidden = false;
    panel.querySelectorAll('.lb-v2-elig-search__item').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var phone = btn.getAttribute('data-phone') || '';
        var name = btn.getAttribute('data-name') || '';
        var email = btn.getAttribute('data-email') || '';
        var hasEmail = btn.getAttribute('data-has-email') === '1';
        var emailEl = $('lb-v2-private-elig-email');
        if (emailEl) emailEl.value = email;
        var phoneEl = $('lb-v2-private-elig-phone');
        if (phoneEl) phoneEl.value = phone;
        var labelEl = $('lb-v2-private-elig-label');
        if (labelEl && !String(labelEl.value || '').trim() && name) {
          labelEl.value = name.slice(0, 128);
        }
        var picked = $('lb-v2-private-elig-customer-picked');
        if (picked) {
          picked.hidden = false;
          if (hasEmail) {
            picked.classList.remove('is-warn');
            picked.textContent = '已帶入：' + name + ' · ' + email + (phone ? ' · ' + phone : '');
          } else {
            picked.classList.add('is-warn');
            picked.textContent = '已選 ' + name + '，但 LadyBae 無 Email，請手填 Email（或手機）後再儲存';
          }
        }
        panel.hidden = true;
        panel.innerHTML = '';
        if (!hasEmail && emailEl) emailEl.focus();
      });
    });
  }

  async function searchEligShopifyCustomers() {
    var slug = getListingVendorSlug();
    var q = (($('lb-v2-private-elig-customer-q') || {}).value || '').trim();
    if (!slug) {
      showNotice(eligNoticeEl(), '請先選擇單一廠商');
      return;
    }
    if (q.length < 2) {
      showNotice(eligNoticeEl(), '請輸入至少 2 個字（手機、姓名或 Email）');
      return;
    }
    var btn = $('lb-v2-private-elig-customer-search');
    if (btn) btn.disabled = true;
    try {
      var res = await fetchAppProxy(PATHS.privateEligibilityCustomerSearch, slug, { q: q });
      if (res.ok) {
        renderEligCustomerSearchResults((res.payload && res.payload.items) || []);
        hideNotice(eligNoticeEl());
      } else {
        renderEligCustomerSearchResults([]);
        showNotice(eligNoticeEl(), res.message || '搜尋失敗');
      }
    } catch (err) {
      showNotice(eligNoticeEl(), err.message || '搜尋失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  async function upsertPrivateEligibility(e) {
    if (e) e.preventDefault();
    var slug = getListingVendorSlug();
    if (!slug) {
      showNotice(eligNoticeEl(), '請先選擇單一廠商');
      return;
    }
    ensureEligibilityDateTimePickers();
    var email = (($('lb-v2-private-elig-email') || {}).value || '').trim();
    var phone = (($('lb-v2-private-elig-phone') || {}).value || '').trim();
    var label = (($('lb-v2-private-elig-label') || {}).value || '').trim();
    var starts = readDateTimePair('lb-v2-private-elig-starts-date', 'lb-v2-private-elig-starts-time');
    var ends = readDateTimePair('lb-v2-private-elig-ends-date', 'lb-v2-private-elig-ends-time');
    if (!email && !phone) {
      showNotice(eligNoticeEl(), '請填寫 Email（建議）或手機，至少一項');
      return;
    }
    if (email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      showNotice(eligNoticeEl(), 'Email 格式無效');
      return;
    }
    if (!email && phone.length < 6) {
      showNotice(eligNoticeEl(), '請填寫有效手機號碼');
      return;
    }
    if (!starts || !ends) {
      showNotice(eligNoticeEl(), '請選擇生效與失效的日期與時間');
      return;
    }
    if (new Date(ends).getTime() <= new Date(starts).getTime()) {
      showNotice(eligNoticeEl(), '失效時間必須晚於生效時間');
      return;
    }
    var upsertGrantExp = getPrivateGrantExpiresAt();
    if (upsertGrantExp && new Date(ends).getTime() >= new Date(upsertGrantExp).getTime()) {
      showNotice(
        eligNoticeEl(),
        '失效時間必須早於資格限定課年約到期日（' + formatDateTw(upsertGrantExp) + '）'
      );
      return;
    }
    if (upsertPrivateEligibilityInFlight) return;
    upsertPrivateEligibilityInFlight = true;
    try {
      var res = await postAppProxyJson(PATHS.privateEligibilityUpsert, {
        vendor_slug: slug,
        email: email || null,
        phone: phone || null,
        label: label || null,
        starts_at: starts,
        ends_at: ends,
      });
      if (res.ok) {
        showNotice(eligNoticeEl(), '通行證已儲存');
        clearEligibilityForm();
        loadPrivateEligibilityTab();
      } else {
        var eligErr = extractApiError(res);
        showNotice(eligNoticeEl(), eligErr.code ? '[' + eligErr.code + '] ' + eligErr.message : (eligErr.message || res.message || '儲存失敗'));
      }
    } catch (err) {
      showNotice(eligNoticeEl(), err.message || '儲存失敗');
    } finally {
      upsertPrivateEligibilityInFlight = false;
    }
  }

  function renderPrivateListingList(items) {
    var privateItems = (items || []).filter(function (i) {
      return String(i.listing_mode || '').toUpperCase() === 'PRIVATE';
    });
    renderListingList(privateItems, {
      container: $('lb-v2-private-listing-list'),
      emptyMessage: '尚無資格限定課。請按「新建資格限定課」建立。',
      confirmPublish: true,
      allowLivePrivateMutate: true,
      onEdit: function (id) { openPrivateListingEditor(id); },
      onEditLivePrivate: function (id) {
        confirmEditPrivateListing(id, function () { openPrivateListingEditor(id); });
      },
      onView: function (id) { openPrivateListingEditor(id, { silent: true }); },
      onConfirm: function (id) { openPrivateListingEditor(id, { confirmAfterLoad: true }); },
      onRevert: function (id) { revertPrivateListingToDraft(id); },
    });
  }

  async function revertPrivateListingToDraft(listingId) {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug || !listingId) return;
    if (!window.confirm('將此課退回草稿以便重新確認上架？')) return;
    var res = await postAppProxyJson(PATHS.listingRevertDraft, {
      vendor_slug: slug,
      listing_id: parseInt(listingId, 10),
    });
    if (res.ok) {
      showNotice(notice, '已退回草稿，可再按「確認上架」');
      loadPrivateScheduleTab();
    } else {
      showNotice(notice, res.message || '退回草稿失敗');
    }
  }

  function openNewPrivateListing() {
    pendingPrivateListingCreate = true;
    pendingPrivateListingEditId = null;
    pendingPrivateListingEditOpts = null;
    pendingPrivateListingConfirmAfterLoad = false;
    privateModeLocked = true;
    switchTab('listing');
  }

  function openPrivateListingEditor(id, opts) {
    if (!id) return;
    opts = opts || {};
    pendingPrivateListingCreate = false;
    pendingPrivateListingEditId = id;
    pendingPrivateListingEditOpts = opts;
    pendingPrivateListingConfirmAfterLoad = !!opts.confirmAfterLoad;
    privateModeLocked = true;
    switchTab('listing');
  }

  var privateImportPendingItems = [];
  var privateCalItems = []; // pending drafts + PRIVATE listings (deduped)
  var privateCalCursor = null; // Date at month start
  var privateCalShowExposure = false;
  var privateCalAlignedOnce = false;

  function ensurePrivateCalCursor() {
    if (!privateCalCursor) {
      privateCalCursor = new Date();
      privateCalCursor.setDate(1);
      privateCalCursor.setHours(0, 0, 0, 0);
    }
    return privateCalCursor;
  }

  function parseListingLocalDate(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      var p = value.trim().split('-');
      return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    }
    var d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  function isPrivateImportSelectable(row) {
    if (!row || row.id == null) return false;
    if (String(row.listing_mode || '').toUpperCase() !== 'PRIVATE') return false;
    return String(row.status || '').toUpperCase() === 'DRAFT';
  }

  function rebuildPrivateCalItems() {
    var byId = {};
    (privateImportPendingItems || []).forEach(function (row) {
      if (row && row.id != null) byId[row.id] = row;
    });
    (allListingItems || []).forEach(function (row) {
      if (!row || row.id == null) return;
      if (String(row.listing_mode || '').toUpperCase() !== 'PRIVATE') return;
      if (!row.start_at) return;
      if (byId[row.id]) return; // pending wins (keeps checkbox / import fields)
      byId[row.id] = row;
    });
    privateCalItems = Object.keys(byId).map(function (k) { return byId[k]; });
  }

  function pendingItemsForCalMonth() {
    ensurePrivateCalCursor();
    var y = privateCalCursor.getFullYear();
    var m = privateCalCursor.getMonth();
    return (privateImportPendingItems || []).filter(function (row) {
      var d = parseListingLocalDate(row && row.start_at);
      return !!(d && d.getFullYear() === y && d.getMonth() === m);
    });
  }

  function calItemsForCalMonth() {
    ensurePrivateCalCursor();
    var y = privateCalCursor.getFullYear();
    var m = privateCalCursor.getMonth();
    return (privateCalItems || []).filter(function (row) {
      var d = parseListingLocalDate(row && row.start_at);
      return !!(d && d.getFullYear() === y && d.getMonth() === m);
    });
  }

  function maybeAlignCalCursorToPending() {
    if (privateCalAlignedOnce) return;
    privateCalAlignedOnce = true;
    ensurePrivateCalCursor();
    if (calItemsForCalMonth().length) return;
    var earliest = null;
    (privateCalItems || []).forEach(function (row) {
      var d = parseListingLocalDate(row && row.start_at);
      if (!d) return;
      if (!earliest || d < earliest) earliest = d;
    });
    if (earliest) {
      privateCalCursor = new Date(earliest.getFullYear(), earliest.getMonth(), 1);
    }
  }

  function syncPrivateCalExposureToggle() {
    var btn = $('lb-v2-private-cal-exposure-toggle');
    if (!btn) return;
    btn.setAttribute('aria-pressed', privateCalShowExposure ? 'true' : 'false');
    btn.classList.toggle('lb-v2-btn--accent', privateCalShowExposure);
    btn.classList.toggle('lb-v2-btn--ghost', !privateCalShowExposure);
    btn.textContent = privateCalShowExposure ? '隱藏曝光時間' : '顯示曝光時間';
  }

  function refreshPrivateImportMonthView() {
    syncPrivateCalExposureToggle();
    renderPrivateImportPendingList();
    renderPrivateImportCalendar();
  }

  function ticketSummaryFromVariants(variants) {
    if (!Array.isArray(variants) || !variants.length) return '—';
    return variants.map(function (v) {
      var name = (v && v.name) ? String(v.name) : '票種';
      var price = v && v.price != null ? Number(v.price) : NaN;
      if (!isFinite(price)) return name;
      return price === 0 ? name + ' $0' : name + ' $' + Math.round(price);
    }).join(' · ');
  }

  function privateSharePageUrl(token) {
    var origin = window.location.origin || 'https://ladybaeshop.com';
    return origin + '/pages/private-calendar?token=' + encodeURIComponent(token);
  }

  function privateScheduleNoticeEl() {
    return $('lb-v2-private-schedule-notice') || $('lb-v2-private-notice');
  }

  var privateCalendarNotices = [];

  function padCal2(n) {
    n = Number(n) || 0;
    return (n < 10 ? '0' : '') + n;
  }

  function isoWeekdayYmd(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d)).getUTCDay() || 7;
  }

  function isoWeekNumberYmd(y, m, d) {
    var utc = new Date(Date.UTC(y, m - 1, d));
    var dow = utc.getUTCDay() || 7;
    var thu = new Date(utc);
    thu.setUTCDate(utc.getUTCDate() + 4 - dow);
    var yearStart = new Date(Date.UTC(thu.getUTCFullYear(), 0, 1));
    return Math.ceil((((thu.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  }

  function noticeMatchesDay(n, y, m, d) {
    if (!n || n.is_enabled === false) return false;
    var kind = String(n.rule_kind || '');
    var days = n.weekdays || [];
    if (kind === 'WEEKLY') return days.indexOf(isoWeekdayYmd(y, m, d)) >= 0;
    if (kind === 'ISO_WEEK') {
      var odd = isoWeekNumberYmd(y, m, d) % 2 === 1;
      if (n.iso_parity === 'ODD' && !odd) return false;
      if (n.iso_parity === 'EVEN' && odd) return false;
      return days.indexOf(isoWeekdayYmd(y, m, d)) >= 0;
    }
    if (kind === 'MONTHLY_DAYS') return (n.month_days || []).indexOf(d) >= 0;
    return false;
  }

  function expandNoticesForMonth(list, y, m) {
    var last = new Date(y, m, 0).getDate();
    var out = [];
    (list || []).forEach(function (n) {
      if (!n || n.is_enabled === false) return;
      for (var d = 1; d <= last; d++) {
        if (!noticeMatchesDay(n, y, m, d)) continue;
        out.push({
          id: n.id,
          title: n.title,
          calendar_color: n.calendar_color,
          sort_order: n.sort_order || 0,
          ymd: y + '-' + padCal2(m) + '-' + padCal2(d),
          day: d
        });
      }
    });
    out.sort(function (a, b) {
      if (a.ymd !== b.ymd) return a.ymd < b.ymd ? -1 : 1;
      if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
      return Number(a.id) - Number(b.id);
    });
    return out;
  }

  function noticeRuleLabel(n) {
    var dow = { 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六', 7: '日' };
    var days = (n.weekdays || []).map(function (d) { return dow[d] || d; }).join('／');
    if (n.rule_kind === 'WEEKLY') return '每週' + days;
    if (n.rule_kind === 'ISO_WEEK') {
      return (n.iso_parity === 'EVEN' ? '雙週' : '單週') + days;
    }
    return '每月 ' + (n.month_days || []).join('、') + ' 日';
  }

  function readNoticeFormKind() {
    var el = document.querySelector('input[name="lb-v2-notice-kind"]:checked');
    return el ? String(el.value || 'WEEKLY') : 'WEEKLY';
  }

  function syncNoticeFormKindUi() {
    var kind = readNoticeFormKind();
    var weekly = $('lb-v2-private-notice-weekdays-wrap');
    var monthly = $('lb-v2-private-notice-monthdays-wrap');
    var isMonth = kind === 'MONTHLY_DAYS';
    if (weekly) weekly.hidden = isMonth;
    if (monthly) monthly.hidden = !isMonth;
  }

  function resetNoticeForm() {
    var idEl = $('lb-v2-private-notice-id');
    var titleEl = $('lb-v2-private-notice-title');
    var colorEl = $('lb-v2-private-notice-color');
    var monthEl = $('lb-v2-private-notice-monthdays');
    var enEl = $('lb-v2-private-notice-enabled');
    if (idEl) idEl.value = '';
    if (titleEl) titleEl.value = '';
    if (colorEl) colorEl.value = defaultCalSwatchColor();
    if (monthEl) monthEl.value = '';
    if (enEl) enEl.checked = true;
    document.querySelectorAll('input[name="lb-v2-notice-kind"]').forEach(function (el) {
      el.checked = el.value === 'WEEKLY';
    });
    document.querySelectorAll('[data-notice-dow]').forEach(function (el) { el.checked = false; });
    mountCalSwatches('lb-v2-private-notice-swatches', 'lb-v2-private-notice-color', colorEl ? colorEl.value : '');
    syncNoticeFormKindUi();
  }

  function fillNoticeForm(n) {
    if (!n) return resetNoticeForm();
    var idEl = $('lb-v2-private-notice-id');
    var titleEl = $('lb-v2-private-notice-title');
    var colorEl = $('lb-v2-private-notice-color');
    var monthEl = $('lb-v2-private-notice-monthdays');
    var enEl = $('lb-v2-private-notice-enabled');
    if (idEl) idEl.value = String(n.id || '');
    if (titleEl) titleEl.value = n.title || '';
    if (colorEl) colorEl.value = normalizeCalHex(n.calendar_color) || defaultCalSwatchColor();
    if (monthEl) monthEl.value = (n.month_days || []).join(',');
    if (enEl) enEl.checked = n.is_enabled !== false;
    var kindVal = 'WEEKLY';
    if (n.rule_kind === 'MONTHLY_DAYS') kindVal = 'MONTHLY_DAYS';
    else if (n.rule_kind === 'ISO_WEEK') kindVal = n.iso_parity === 'EVEN' ? 'ISO_EVEN' : 'ISO_ODD';
    document.querySelectorAll('input[name="lb-v2-notice-kind"]').forEach(function (el) {
      el.checked = el.value === kindVal;
    });
    var set = {};
    (n.weekdays || []).forEach(function (d) { set[d] = true; });
    document.querySelectorAll('[data-notice-dow]').forEach(function (el) {
      el.checked = !!set[Number(el.getAttribute('data-notice-dow'))];
    });
    mountCalSwatches('lb-v2-private-notice-swatches', 'lb-v2-private-notice-color', colorEl ? colorEl.value : '');
    syncNoticeFormKindUi();
  }

  function collectNoticeForm() {
    var kindUi = readNoticeFormKind();
    var weekdays = [];
    document.querySelectorAll('[data-notice-dow]:checked').forEach(function (el) {
      weekdays.push(Number(el.getAttribute('data-notice-dow')));
    });
    var monthDays = String(($('lb-v2-private-notice-monthdays') || {}).value || '')
      .split(/[,，\s]+/)
      .map(function (s) { return parseInt(s, 10); })
      .filter(function (n) { return n >= 1 && n <= 31; });
    var ruleKind = 'WEEKLY';
    var isoParity = null;
    if (kindUi === 'ISO_ODD') { ruleKind = 'ISO_WEEK'; isoParity = 'ODD'; }
    else if (kindUi === 'ISO_EVEN') { ruleKind = 'ISO_WEEK'; isoParity = 'EVEN'; }
    else if (kindUi === 'MONTHLY_DAYS') ruleKind = 'MONTHLY_DAYS';
    var idRaw = String(($('lb-v2-private-notice-id') || {}).value || '').trim();
    return {
      id: idRaw ? parseInt(idRaw, 10) : null,
      title: String(($('lb-v2-private-notice-title') || {}).value || '').trim(),
      calendar_color: readCalSwatchValue('lb-v2-private-notice-color') || defaultCalSwatchColor(),
      rule_kind: ruleKind,
      weekdays: weekdays,
      iso_parity: isoParity,
      month_days: monthDays,
      is_enabled: !($('lb-v2-private-notice-enabled') && !$('lb-v2-private-notice-enabled').checked)
    };
  }

  function renderPrivateCalendarNotices(items, hint) {
    privateCalendarNotices = items || [];
    var host = $('lb-v2-private-notice-list');
    var hintEl = $('lb-v2-private-notice-week-hint');
    if (hintEl) hintEl.textContent = (hint && hint.label) || '';
    if (!host) return;
    if (!privateCalendarNotices.length) {
      host.innerHTML = '<p class="lb-v2-hint">尚未設定每日事項。儲存後會出現在月曆每格最上方。</p>';
      return;
    }
    host.innerHTML = privateCalendarNotices.map(function (n) {
      var bg = resolveCalChipColor(n.calendar_color, n.id + ':' + (n.title || ''));
      return '<div class="lb-v2-private-notice-row">' +
        '<div>' +
          '<span class="lb-v2-private-notice-chip" style="background:' + bg + '"></span>' +
          '<strong>' + escapeHtml(n.title || '') + '</strong>' +
          (n.is_enabled === false ? ' <span class="lb-v2-badge">已關閉</span>' : '') +
          '<div class="lb-v2-private-notice-row__meta">' + escapeHtml(noticeRuleLabel(n)) + '</div>' +
        '</div>' +
        '<div class="lb-v2-private-notice-row__actions">' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--ghost lb-v2-btn--sm" data-notice-edit="' + n.id + '">編輯</button>' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--danger lb-v2-btn--sm" data-notice-del="' + n.id + '">刪除</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  async function loadPrivateCalendarNotices() {
    var slug = getListingVendorSlug();
    if (!slug) return;
    var res = await fetchAppProxy(PATHS.privateCalendarNotices, slug);
    if (!res.ok) {
      renderPrivateCalendarNotices([], null);
      return;
    }
    var payload = res.payload || res;
    renderPrivateCalendarNotices(payload.items || [], payload.iso_week_hint || null);
    mountCalSwatches('lb-v2-private-notice-swatches', 'lb-v2-private-notice-color', defaultCalSwatchColor());
    syncNoticeFormKindUi();
  }

  async function savePrivateCalendarNotice(ev) {
    if (ev) ev.preventDefault();
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    var body = collectNoticeForm();
    if (!body.title) {
      showNotice(notice, '請填標題');
      return;
    }
    var res = await postAppProxyJson(PATHS.privateCalendarNoticeUpsert, Object.assign({
      vendor_slug: slug
    }, body));
    if (!res.ok) {
      showNotice(notice, res.message || '儲存失敗');
      return;
    }
    hideNotice(notice);
    resetNoticeForm();
    await loadPrivateCalendarNotices();
    renderPrivateImportCalendar();
  }

  async function deletePrivateCalendarNotice(id) {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug || !id) return;
    if (!window.confirm('刪除這筆每日事項？')) return;
    var res = await postAppProxyJson(PATHS.privateCalendarNoticeDelete, {
      vendor_slug: slug,
      id: id
    });
    if (!res.ok) {
      showNotice(notice, res.message || '刪除失敗');
      return;
    }
    hideNotice(notice);
    if (String(($('lb-v2-private-notice-id') || {}).value || '') === String(id)) resetNoticeForm();
    await loadPrivateCalendarNotices();
    renderPrivateImportCalendar();
  }

  function bindPrivateNoticeUiOnce() {
    var form = $('lb-v2-private-notice-form');
    if (form && form.getAttribute('data-bound') !== '1') {
      form.setAttribute('data-bound', '1');
      form.addEventListener('submit', savePrivateCalendarNotice);
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.name === 'lb-v2-notice-kind') syncNoticeFormKindUi();
      });
    }
    var resetBtn = $('lb-v2-private-notice-reset');
    if (resetBtn && resetBtn.getAttribute('data-bound') !== '1') {
      resetBtn.setAttribute('data-bound', '1');
      resetBtn.addEventListener('click', resetNoticeForm);
    }
    var list = $('lb-v2-private-notice-list');
    if (list && list.getAttribute('data-bound') !== '1') {
      list.setAttribute('data-bound', '1');
      list.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var edit = t.closest('[data-notice-edit]');
        if (edit) {
          var eid = Number(edit.getAttribute('data-notice-edit'));
          var row = privateCalendarNotices.filter(function (n) { return n.id === eid; })[0];
          fillNoticeForm(row);
          return;
        }
        var del = t.closest('[data-notice-del]');
        if (del) deletePrivateCalendarNotice(Number(del.getAttribute('data-notice-del')));
      });
    }
  }

  function getSelectedImportListingIds() {
    var panel = $('lb-v2-panel-private-schedule') || $('lb-v2-panel-private') || root;
    if (!panel) return [];
    var seen = {};
    var ids = [];
    panel.querySelectorAll('input[data-private-import-check]:checked').forEach(function (el) {
      var id = parseInt(el.getAttribute('data-private-import-check'), 10);
      if (id > 0 && !seen[id]) {
        seen[id] = true;
        ids.push(id);
      }
    });
    return ids;
  }

  function renderPrivateImportBatches(items, opts) {
    opts = opts || {};
    var host = $(opts.hostId || 'lb-v2-private-import-batches');
    if (!host) return;
    var typeFilter = opts.typeFilter || null;
    var filtered = (items || []).filter(function (b) {
      if (!typeFilter) return true;
      return String(b.batch_type || '').toUpperCase() === String(typeFilter).toUpperCase();
    });
    if (!filtered.length) {
      host.innerHTML = '<p class="lb-v2-muted">尚無匯入批次。</p>';
      return;
    }
    var html = '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
      '<th>批次</th><th>類型</th><th>檔名</th><th>成功</th><th>失敗</th><th>時間</th><th>操作</th>' +
      '</tr></thead><tbody>';
    filtered.forEach(function (b) {
      var typeLabel = String(b.batch_type || '') === 'ELIGIBILITY' ? '資格' : '課程';
      var errBtn = (b.error_count > 0)
        ? '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--ghost" data-private-import-errors="' +
          b.id + '">錯誤報告</button>'
        : '—';
      html += '<tr>' +
        '<td>#' + b.id + '</td>' +
        '<td>' + typeLabel + '</td>' +
        '<td>' + escapeHtml(b.filename || '—') + '</td>' +
        '<td>' + (b.success_count || 0) + '</td>' +
        '<td>' + (b.error_count || 0) + '</td>' +
        '<td>' + escapeHtml(formatDateTimeTw(b.created_at)) + '</td>' +
        '<td class="lb-v2-table-actions">' + errBtn + '</td></tr>';
    });
    html += '</tbody></table></div>';
    host.innerHTML = html;
    host.querySelectorAll('[data-private-import-errors]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        downloadPrivateImportErrors(btn.getAttribute('data-private-import-errors'));
      });
    });
  }

  function renderPrivateImportPending(items) {
    privateImportPendingItems = items || [];
    rebuildPrivateCalItems();
    privateCalAlignedOnce = false;
    maybeAlignCalCursorToPending();
    refreshPrivateImportMonthView();
  }

  function renderPrivateImportPendingList() {
    var host = $('lb-v2-private-import-pending-list');
    if (!host) return;
    ensurePrivateCalCursor();
    var y = privateCalCursor.getFullYear();
    var m = privateCalCursor.getMonth() + 1;
    var total = (privateImportPendingItems || []).length;
    if (!total) {
      host.innerHTML = '<p class="lb-v2-muted">目前沒有待確認的匯入草稿。</p>';
      return;
    }
    var monthItems = pendingItemsForCalMonth();
    if (!monthItems.length) {
      host.innerHTML = '<p class="lb-v2-muted">本月（' + y + '/' + m +
        '）無匯入草稿。全部草稿共 ' + total +
        ' 筆，請用上方「上月／下月」切換。</p>';
      return;
    }
    var html = '<p class="lb-v2-hint lb-v2-private-cal-month-count">' + y + '年' + m +
      '月・上課 ' + monthItems.length + ' 筆' +
      (total > monthItems.length ? '（全部草稿 ' + total + ' 筆）' : '') +
      '</p>';
    html += '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
      '<th><input type="checkbox" id="lb-v2-private-import-check-all" title="全選本月"></th>' +
      '<th>列號</th><th>標題</th><th>上課起迄</th><th>票種</th><th>狀態</th>' +
      '</tr></thead><tbody>';
    monthItems.forEach(function (row) {
      html += '<tr>' +
        '<td><input type="checkbox" data-private-import-check="' + row.id + '"></td>' +
        '<td>' + escapeHtml(row.import_row_key || '—') + '</td>' +
        '<td>' + escapeHtml(row.title || '') + '</td>' +
        '<td>' + escapeHtml(formatDateTimeTw(row.start_at)) + '<br>' +
          escapeHtml(formatDateTimeTw(row.end_at)) + '</td>' +
        '<td>' + escapeHtml(ticketSummaryFromVariants(row.variants_json)) + '</td>' +
        '<td><span class="lb-v2-badge lb-v2-badge--pending">待確認</span></td></tr>';
    });
    html += '</tbody></table></div>';
    host.innerHTML = html;
    var all = $('lb-v2-private-import-check-all');
    if (all) {
      all.addEventListener('change', function () {
        host.querySelectorAll('input[data-private-import-check]').forEach(function (el) {
          el.checked = all.checked;
        });
      });
    }
  }

  function ymdKeyFromDate(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function formatMdTw(d) {
    return (d.getMonth() + 1) + '/' + d.getDate();
  }

  function renderPrivateImportCalendar() {
    var host = $('lb-v2-private-import-calendar');
    var labelEl = $('lb-v2-private-cal-label');
    if (!host) return;
    ensurePrivateCalCursor();
    var y = privateCalCursor.getFullYear();
    var m = privateCalCursor.getMonth();
    if (labelEl) labelEl.textContent = y + '年' + (m + 1) + '月';

    var firstDow = new Date(y, m, 1).getDay();
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var monthItems = calItemsForCalMonth();
    var byDay = {};
    monthItems.forEach(function (row) {
      var d = parseListingLocalDate(row.start_at);
      if (!d) return;
      var day = d.getDate();
      if (!byDay[day]) byDay[day] = [];
      byDay[day].push(row);
    });
    var noticeByDay = {};
    expandNoticesForMonth(privateCalendarNotices, y, m + 1).forEach(function (n) {
      if (!noticeByDay[n.day]) noticeByDay[n.day] = [];
      noticeByDay[n.day].push(n);
    });

    var html = '';
    if (privateCalShowExposure) {
      html += '<p class="lb-v2-private-cal-exp-legend">長條＝<strong>曝光時間</strong>（非上課）；色塊與課程色相同，跨日會切週顯示。</p>';
    }

    // Week rows: day cells + optional exposure lanes spanning columns
    var cells = [];
    for (var i = 0; i < firstDow; i++) cells.push({ empty: true });
    for (var day = 1; day <= daysInMonth; day++) {
      cells.push({ empty: false, day: day, events: byDay[day] || [] });
    }
    while (cells.length % 7 !== 0) cells.push({ empty: true });

    var fields = readCalDisplayFields();
    html += '<div class="lb-v2-private-cal__month">';
    html += '<div class="lb-v2-private-cal__dow-row">';
    ['日', '一', '二', '三', '四', '五', '六'].forEach(function (w) {
      html += '<div class="lb-v2-private-cal__dow">' + w + '</div>';
    });
    html += '</div>';

    for (var wIdx = 0; wIdx < cells.length / 7; wIdx++) {
      var weekCells = cells.slice(wIdx * 7, wIdx * 7 + 7);
      var weekStartDay = null;
      var weekEndDay = null;
      weekCells.forEach(function (c) {
        if (c.empty) return;
        if (weekStartDay == null) weekStartDay = c.day;
        weekEndDay = c.day;
      });
      html += '<div class="lb-v2-private-cal__week">';
      html += '<div class="lb-v2-private-cal__grid lb-v2-private-cal__grid--days">';
      weekCells.forEach(function (c) {
        if (c.empty) {
          html += '<div class="lb-v2-private-cal__cell lb-v2-private-cal__cell--empty"></div>';
          return;
        }
        var ymd = y + '-' + String(m + 1).padStart(2, '0') + '-' + String(c.day).padStart(2, '0');
        html += '<div class="lb-v2-private-cal__cell lb-v2-private-cal__cell--day" data-private-cal-day="' +
          ymd + '" role="button" tabindex="0" title="點空白處快速建立課程草稿">';
        html += '<div class="lb-v2-private-cal__day">' + c.day +
          '<span class="lb-v2-private-cal__day-add" aria-hidden="true">＋</span></div>';
        (noticeByDay[c.day] || []).forEach(function (n) {
          var nbg = resolveCalChipColor(n.calendar_color, n.id + ':' + (n.title || ''));
          html += '<div class="lb-v2-private-cal__event lb-v2-private-cal__event--static lb-v2-private-cal__event--notice" style="background:' + nbg + '" title="每日事項（無需報名）">' +
            '<em class="lb-v2-private-cal__badge">事項</em>' +
            '<span>' + escapeHtml(n.title || '') + '</span></div>';
        });
        (c.events || []).forEach(function (ev) {
          var bg = resolveCalChipColor(ev.calendar_color, ev.id + ':' + (ev.title || ''));
          var label = formatCalEventLabel(ev, fields);
          if (isPrivateImportSelectable(ev)) {
            html += '<label class="lb-v2-private-cal__event" style="background:' + bg + '" title="上課時間（待確認草稿）">' +
              '<input type="checkbox" data-private-import-check="' + ev.id + '"> ' +
              '<span>' + escapeHtml(label) + '</span></label>';
          } else {
            var published = String(ev.status || '').toUpperCase() === 'PUBLISHED';
            html += '<div class="lb-v2-private-cal__event lb-v2-private-cal__event--static" style="background:' + bg +
              '" title="上課時間">' +
              (published ? '<em class="lb-v2-private-cal__badge">已上架</em>' : '') +
              '<span>' + escapeHtml(label) + '</span></div>';
          }
        });
        html += '</div>';
      });
      html += '</div>';

      if (privateCalShowExposure && weekStartDay != null) {
        var weekStart = new Date(y, m, weekStartDay);
        var weekEnd = new Date(y, m, weekEndDay);
        html += '<div class="lb-v2-private-cal__exp-lanes" aria-label="曝光時間">';
        (privateCalItems || []).forEach(function (ev) {
          var expStart = parseListingLocalDate(ev.exposure_start_at);
          var expEnd = parseListingLocalDate(ev.exposure_end_at);
          if (!expStart || !expEnd) return;
          if (expEnd < weekStart || expStart > weekEnd) return;
          var segStart = expStart > weekStart ? expStart : weekStart;
          var segEnd = expEnd < weekEnd ? expEnd : weekEnd;
          // Map to column 1-7 within this week row (including leading empties)
          var colStart = -1;
          var colEnd = -1;
          weekCells.forEach(function (c, idx) {
            if (c.empty) return;
            var cellDate = new Date(y, m, c.day);
            if (cellDate >= segStart && cellDate <= segEnd) {
              if (colStart < 0) colStart = idx + 1;
              colEnd = idx + 2; // CSS grid end is exclusive
            }
          });
          if (colStart < 0 || colEnd < 0) return;
          var bg = resolveCalChipColor(ev.calendar_color, ev.id + ':' + (ev.title || ''));
          var title = String(ev.title || '').trim() || ('#' + ev.id);
          var rangeLabel = formatMdTw(expStart) + '–' + formatMdTw(expEnd);
          var showRange = ymdKeyFromDate(segStart) === ymdKeyFromDate(expStart);
          html += '<div class="lb-v2-private-cal__exp-bar" style="grid-column:' + colStart +
            ' / ' + colEnd + '; --exp-bg:' + bg + '" title="曝光時間 ' + escapeHtml(rangeLabel) +
            ' · ' + escapeHtml(title) + '">' +
            '<span class="lb-v2-private-cal__exp-tag">曝光</span>' +
            '<span class="lb-v2-private-cal__exp-text">' + escapeHtml(title) +
            (showRange ? ' <em>' + escapeHtml(rangeLabel) + '</em>' : '') +
            '</span></div>';
        });
        html += '</div>';
      }
      html += '</div>';
    }
    html += '</div>';
    host.innerHTML = html;
    bindPrivateCalQuickCreate();
  }

  var privateCalQuickCreateBound = false;
  var privateQuickCreateInFlight = false;

  function bindPrivateCalQuickCreate() {
    var host = $('lb-v2-private-import-calendar');
    if (!host || privateCalQuickCreateBound) return;
    privateCalQuickCreateBound = true;
    host.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      if (t.closest('.lb-v2-private-cal__event') || t.closest('[data-private-import-check]')) return;
      var cell = t.closest('[data-private-cal-day]');
      if (!cell) return;
      var ymd = cell.getAttribute('data-private-cal-day');
      if (!ymd) return;
      openPrivateQuickCreateModal(ymd);
    });
    host.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' && ev.key !== ' ') return;
      var t = ev.target;
      if (!t || !t.getAttribute) return;
      var ymd = t.getAttribute('data-private-cal-day');
      if (!ymd) return;
      ev.preventDefault();
      openPrivateQuickCreateModal(ymd);
    });
  }

  function cityOptionsHtmlForQuickCreate(selected) {
    var html = '<option value="">請選擇縣市</option>';
    (CITY_OPTIONS || []).forEach(function (c) {
      html += '<option value="' + escapeHtml(c.code) + '"' +
        (selected === c.code ? ' selected' : '') + '>' +
        escapeHtml(c.label) + '</option>';
    });
    return html;
  }

  function privateQcDefaultsKey(slug) {
    return 'lb-v2-private-qc-defaults:' + String(slug || '');
  }

  function readPrivateQcSavedDefaults(slug) {
    try {
      var raw = localStorage.getItem(privateQcDefaultsKey(slug));
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (!obj || typeof obj !== 'object') return null;
      return {
        city: String(obj.city || '').trim(),
        address: String(obj.address || '').trim(),
        venue_name: String(obj.venue_name || '').trim(),
        description: String(obj.description || '').trim(),
        ticket_qty: parsePrivateQcTicketQty(obj.ticket_qty),
        calendar_color: normalizeCalHex(obj.calendar_color) || ''
      };
    } catch (e) {
      return null;
    }
  }

  function parsePrivateQcTicketQty(raw) {
    var q = parseInt(raw, 10);
    return Number.isInteger(q) && q >= 1 ? q : 0;
  }

  function firstListingTicketQty(row) {
    var vs = row && row.variants_json;
    if (!Array.isArray(vs) || !vs.length) return 0;
    return parsePrivateQcTicketQty(vs[0] && vs[0].quantity);
  }

  function writePrivateQcSavedDefaults(slug, city, address, venueName, description, ticketQty, calendarColor) {
    try {
      localStorage.setItem(privateQcDefaultsKey(slug), JSON.stringify({
        city: String(city || '').trim(),
        address: String(address || '').trim(),
        venue_name: String(venueName || '').trim(),
        description: String(description || '').trim(),
        ticket_qty: parsePrivateQcTicketQty(ticketQty),
        calendar_color: normalizeCalHex(calendarColor) || ''
      }));
    } catch (e) { /* ignore */ }
  }

  function latestPrivateListingLocation() {
    var best = null;
    (allListingItems || []).forEach(function (row) {
      if (!row || String(row.listing_mode || '').toUpperCase() !== 'PRIVATE') return;
      var codes = Array.isArray(row.city_codes) ? row.city_codes : [];
      var city = codes.length ? String(codes[0] || '').trim() : '';
      var address = String(row.address || '').trim();
      var venueName = String(row.venue_name || '').trim();
      var description = String(row.description || '').trim();
      var ticketQty = firstListingTicketQty(row);
      if (!city && !address && !venueName && !description && !ticketQty) return;
      var id = Number(row.id) || 0;
      if (!best || id > best.id) {
        best = {
          id: id,
          city: city,
          address: address,
          venue_name: venueName,
          description: description,
          ticket_qty: ticketQty
        };
      }
    });
    return best;
  }

  function resolvePrivateQcLocationDefaults(slug) {
    var saved = readPrivateQcSavedDefaults(slug);
    var latest = latestPrivateListingLocation();
    var hasSaved = saved && (
      saved.city || saved.address || saved.venue_name || saved.description || saved.ticket_qty
    );
    if (hasSaved) {
      return {
        city: saved.city || (latest && latest.city) || '',
        address: saved.address || (latest && latest.address) || '',
        venue_name: saved.venue_name || (latest && latest.venue_name) || '',
        description: saved.description || (latest && latest.description) || '',
        ticket_qty: saved.ticket_qty || (latest && latest.ticket_qty) || 0,
        calendar_color: saved.calendar_color || ''
      };
    }
    if (latest) {
      return {
        city: latest.city || '',
        address: latest.address || '',
        venue_name: latest.venue_name || '',
        description: latest.description || '',
        ticket_qty: latest.ticket_qty || 0,
        calendar_color: ''
      };
    }
    return { city: '', address: '', venue_name: '', description: '', ticket_qty: 0, calendar_color: '' };
  }

  function setPrivateQcPickerValue(id, value) {
    var inp = $(id);
    if (!inp) return;
    inp.value = value || '';
    refreshPickerVisible(id);
  }

  function mountPrivateQcPickers(ymd) {
    mountInSlot('lb-v2-private-qc-start-date-slot', createDynPickerField('lb-v2-private-qc-start-date', 'date'));
    mountInSlot('lb-v2-private-qc-start-time-slot', createDynPickerField('lb-v2-private-qc-start-time', 'time'));
    mountInSlot('lb-v2-private-qc-end-date-slot', createDynPickerField('lb-v2-private-qc-end-date', 'date'));
    mountInSlot('lb-v2-private-qc-end-time-slot', createDynPickerField('lb-v2-private-qc-end-time', 'time'));
    mountInSlot('lb-v2-private-qc-exp-start-slot', createDynPickerField('lb-v2-private-qc-exp-start', 'date'));
    mountInSlot('lb-v2-private-qc-exp-end-slot', createDynPickerField('lb-v2-private-qc-exp-end', 'date'));
    setPrivateQcPickerValue('lb-v2-private-qc-start-date', ymd);
    setPrivateQcPickerValue('lb-v2-private-qc-start-time', '19:00');
    setPrivateQcPickerValue('lb-v2-private-qc-end-date', ymd);
    setPrivateQcPickerValue('lb-v2-private-qc-end-time', '21:00');
    setPrivateQcPickerValue('lb-v2-private-qc-exp-start', ymd);
    setPrivateQcPickerValue('lb-v2-private-qc-exp-end', ymd);
    var startInp = $('lb-v2-private-qc-start-date');
    if (startInp && !startInp.getAttribute('data-qc-min-bound')) {
      startInp.setAttribute('data-qc-min-bound', '1');
      startInp.addEventListener('change', updatePrivateQcDecideHint);
      startInp.addEventListener('input', updatePrivateQcDecideHint);
    }
  }

  function openPrivateQuickCreateModal(ymd) {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(ymd || ''))) return;

    privateQuickCreateInFlight = false;
    var loc = resolvePrivateQcLocationDefaults(slug);
    var bodyHtml =
      '<p class="lb-v2-hint">填妥後按「建立並上架」會直接送審／上架（資格限定課通常可直上）。日期請按「選日期／選時間」。</p>' +
      '<p class="lb-v2-hint">最低開課人數預設 0（不啟用未達開課人數決策）。若填大於 0：須 ≤ 名額，且上課日須夠遠（評估起＝上課日前第 3 天 00:00 尚未到）。</p>' +
      '<div id="lb-v2-private-qc-error" class="lb-v2-inline-notice lb-v2-private-qc-error" hidden></div>' +
      '<div class="lb-v2-private-qc-form">' +
        '<label class="lb-v2-private-qc-field">' +
          '<span>標題 *</span>' +
          '<input type="text" class="lb-v2-input" id="lb-v2-private-qc-title" maxlength="512" placeholder="例：週三瑜珈">' +
        '</label>' +
        '<div class="lb-v2-private-qc-field">' +
          '<span>月曆顏色</span>' +
          '<div id="lb-v2-private-qc-color-swatches"></div>' +
          '<input type="hidden" id="lb-v2-private-qc-color" value="">' +
          '<span class="lb-v2-hint">月曆方塊底色，與 Excel 匯入填色同一組。</span>' +
        '</div>' +
        '<div class="lb-v2-private-qc-field lb-v2-private-qc-field--date">' +
          '<span>上課日 *</span>' +
          '<div id="lb-v2-private-qc-start-date-slot" class="lb-v2-slot"></div>' +
        '</div>' +
        '<div class="lb-v2-private-qc-row">' +
          '<div class="lb-v2-private-qc-field">' +
            '<span>開始時間 *</span>' +
            '<div id="lb-v2-private-qc-start-time-slot" class="lb-v2-slot"></div>' +
          '</div>' +
          '<div class="lb-v2-private-qc-field">' +
            '<span>結束時間 *</span>' +
            '<div id="lb-v2-private-qc-end-time-slot" class="lb-v2-slot"></div>' +
          '</div>' +
        '</div>' +
        '<div class="lb-v2-private-qc-field">' +
          '<span>結束日（跨日時再改）</span>' +
          '<div id="lb-v2-private-qc-end-date-slot" class="lb-v2-slot"></div>' +
        '</div>' +
        '<div class="lb-v2-private-qc-row">' +
          '<div class="lb-v2-private-qc-field">' +
            '<span>曝光起日 *</span>' +
            '<div id="lb-v2-private-qc-exp-start-slot" class="lb-v2-slot"></div>' +
          '</div>' +
          '<div class="lb-v2-private-qc-field">' +
            '<span>曝光迄日 *</span>' +
            '<div id="lb-v2-private-qc-exp-end-slot" class="lb-v2-slot"></div>' +
          '</div>' +
        '</div>' +
        '<div class="lb-v2-private-qc-row">' +
          '<label class="lb-v2-private-qc-field">' +
            '<span>縣市 *</span>' +
            '<select class="lb-v2-input" id="lb-v2-private-qc-city">' +
              cityOptionsHtmlForQuickCreate(loc.city) +
            '</select>' +
          '</label>' +
          '<label class="lb-v2-private-qc-field lb-v2-private-qc-field--grow">' +
            '<span>地址 *</span>' +
            '<input type="text" class="lb-v2-input" id="lb-v2-private-qc-address" maxlength="512" ' +
              'placeholder="區／路／號" value="' + escapeHtml(loc.address) + '">' +
          '</label>' +
        '</div>' +
        '<label class="lb-v2-private-qc-field">' +
          '<span>場地名稱</span>' +
          '<input type="text" class="lb-v2-input" id="lb-v2-private-qc-venue" maxlength="256" ' +
            'placeholder="例：LadyBae 新營教室／線上教室" value="' + escapeHtml(loc.venue_name || '') + '">' +
        '</label>' +
        '<label class="lb-v2-private-qc-field">' +
          '<span>講師</span>' +
          '<input type="text" class="lb-v2-input" id="lb-v2-private-qc-instructor" maxlength="256" ' +
            'placeholder="例：王老師">' +
          '<span class="lb-v2-hint">選填。簽到表會顯示為「授課老師」；月曆可勾選「講師」。</span>' +
        '</label>' +
        '<label class="lb-v2-private-qc-field">' +
          '<span>課程說明</span>' +
          '<textarea class="lb-v2-input" id="lb-v2-private-qc-desc" rows="3" maxlength="5000" ' +
            'placeholder="例：適合 0-5 歲親子共學。請自備水壺與毯子；課前 10 分鐘報到。">' +
            escapeHtml(loc.description || '') +
          '</textarea>' +
        '</label>' +
        '<div class="lb-v2-private-qc-row">' +
          '<label class="lb-v2-private-qc-field">' +
            '<span>票種名稱 *</span>' +
            '<input type="text" class="lb-v2-input" id="lb-v2-private-qc-ticket-name" value="一般" maxlength="128">' +
          '</label>' +
          '<label class="lb-v2-private-qc-field">' +
            '<span>票價 *</span>' +
            '<input type="number" class="lb-v2-input" id="lb-v2-private-qc-ticket-price" value="0" min="0" step="1">' +
          '</label>' +
          '<label class="lb-v2-private-qc-field">' +
            '<span>名額 *</span>' +
            '<input type="number" class="lb-v2-input" id="lb-v2-private-qc-ticket-qty" min="1" step="1" placeholder="例：20"' +
              (loc.ticket_qty ? ' value="' + loc.ticket_qty + '"' : '') + '>' +
          '</label>' +
        '</div>' +
        '<label class="lb-v2-private-qc-field">' +
          '<span>最低開課人數</span>' +
          '<input type="number" class="lb-v2-input" id="lb-v2-private-qc-min-attendees" value="0" min="0" step="1" placeholder="0＝不啟用">' +
          '<span class="lb-v2-hint">0 或空白＝不走未達開課人數決策。大於 0 時以已售票數判斷。</span>' +
        '</label>' +
        '<div id="lb-v2-private-qc-decide-hint" class="lb-v2-notice lb-v2-notice--info lb-v2-private-qc-decide-hint" hidden></div>' +
        '<div id="lb-v2-private-qc-error-foot" class="lb-v2-inline-notice lb-v2-private-qc-error" hidden></div>' +
      '</div>';

    openModal({
      title: '快速建立課程（' + ymd + '）',
      wide: true,
      bodyHtml: bodyHtml,
      actions: [
        { label: '取消', ghost: true, close: true },
        {
          label: '建立並上架',
          accent: true,
          close: false,
          onClick: function () {
            try {
              submitPrivateQuickCreate();
            } catch (err) {
              showPrivateQcError(err && err.message ? err.message : '無法送出，請重試');
              setPrivateQcSubmitLoading(false);
            }
            return false;
          }
        }
      ]
    });
    mountPrivateQcPickers(ymd);
    mountCalSwatches(
      'lb-v2-private-qc-color-swatches',
      'lb-v2-private-qc-color',
      loc.calendar_color || defaultCalSwatchColor()
    );
    bindPrivateQcMinAttendeesHint();
    updatePrivateQcDecideHint();
    var submitBtn = document.querySelector('#lb-v2-modal-actions .lb-v2-btn--accent');
    if (submitBtn) submitBtn.setAttribute('data-private-qc-submit', '1');
  }

  function bindPrivateQcMinAttendeesHint() {
    ['lb-v2-private-qc-min-attendees', 'lb-v2-private-qc-ticket-qty'].forEach(function (id) {
      var el = $(id);
      if (!el || el.getAttribute('data-qc-min-bound')) return;
      el.setAttribute('data-qc-min-bound', '1');
      el.addEventListener('input', updatePrivateQcDecideHint);
      el.addEventListener('change', updatePrivateQcDecideHint);
    });
    var startHidden = $('lb-v2-private-qc-start-date');
    if (startHidden && !startHidden.getAttribute('data-qc-min-bound')) {
      startHidden.setAttribute('data-qc-min-bound', '1');
      startHidden.addEventListener('change', updatePrivateQcDecideHint);
    }
  }

  function updatePrivateQcDecideHint() {
    var box = $('lb-v2-private-qc-decide-hint');
    if (!box) return;
    var minParsed = parseCourseMinAttendeesInput(privateQcVal('lb-v2-private-qc-min-attendees'));
    var min = minParsed.ok ? minParsed.value : 0;
    var startDate = privateQcVal('lb-v2-private-qc-start-date');
    var ticketQty = parseInt(privateQcVal('lb-v2-private-qc-ticket-qty'), 10);
    if (!(min > 0)) {
      box.hidden = true;
      box.innerHTML = '';
      return;
    }
    var win = formatCourseDecideWindowFromStart(startDate);
    var qtyNote = Number.isInteger(ticketQty) && ticketQty >= 1
      ? '（須 ≤ 名額 ' + ticketQty + '）'
      : '（須 ≤ 票券名額）';
    var html =
      '<strong>將啟用未達開課人數決策</strong>：最低 <strong>' + min + '</strong> 人' + qtyNote + '。';
    if (win) {
      html +=
        ' 評估起 <strong>' +
        escapeHtml(win.evalLabel) +
        '</strong>（台北）；截止 <strong>' +
        escapeHtml(win.deadlineLabel) +
        '</strong> 前須決策，逾期自動取消。';
    } else {
      html += ' 請先選定上課日以計算評估起／截止。';
    }
    var gate = validateCourseMinForQuickCreate(min, ticketQty, startDate);
    if (!gate.ok) {
      html += '<br><span style="color:#a61b3f">' + escapeHtml(gate.message) + '</span>';
    }
    box.innerHTML = html;
    box.hidden = false;
  }

  function privateQcVal(id) {
    var el = $(id);
    return el ? String(el.value || '').trim() : '';
  }

  function setPrivateQcSubmitLoading(loading, label) {
    var btn =
      document.querySelector('#lb-v2-modal-actions [data-private-qc-submit]') ||
      document.querySelector('#lb-v2-modal-actions .lb-v2-btn--accent');
    if (!btn) return;
    btn.disabled = !!loading;
    btn.setAttribute('aria-busy', loading ? 'true' : 'false');
    btn.classList.toggle('is-loading', !!loading);
    btn.textContent = loading ? (label || '處理中…') : '建立並上架';
  }

  function showPrivateQcError(msg) {
    var text = String(msg || '').trim();
    ['lb-v2-private-qc-error', 'lb-v2-private-qc-error-foot'].forEach(function (id) {
      var el = $(id);
      showNotice(el, text);
      if (el) el.classList.toggle('is-error', !!text);
    });
    var foot = $('lb-v2-private-qc-error-foot');
    if (foot && text && typeof foot.scrollIntoView === 'function') {
      try { foot.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) { /* ignore */ }
    }
  }

  async function submitPrivateQuickCreate() {
    if (privateQuickCreateInFlight) return;
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showPrivateQcError('請先選擇單一廠商');
      return;
    }

    var title = privateQcVal('lb-v2-private-qc-title');
    var startDate = privateQcVal('lb-v2-private-qc-start-date');
    var startTime = privateQcVal('lb-v2-private-qc-start-time').slice(0, 5);
    var endDate = privateQcVal('lb-v2-private-qc-end-date') || startDate;
    var endTime = privateQcVal('lb-v2-private-qc-end-time').slice(0, 5);
    var expStart = privateQcVal('lb-v2-private-qc-exp-start');
    var expEnd = privateQcVal('lb-v2-private-qc-exp-end');
    var city = privateQcVal('lb-v2-private-qc-city');
    var address = privateQcVal('lb-v2-private-qc-address');
    var venueName = privateQcVal('lb-v2-private-qc-venue');
    var instructor = privateQcVal('lb-v2-private-qc-instructor');
    var description = privateQcVal('lb-v2-private-qc-desc');
    var calendarColor = readCalSwatchValue('lb-v2-private-qc-color');
    var ticketName = privateQcVal('lb-v2-private-qc-ticket-name');
    var ticketPrice = parseInt(privateQcVal('lb-v2-private-qc-ticket-price'), 10);
    var ticketQty = parseInt(privateQcVal('lb-v2-private-qc-ticket-qty'), 10);
    var minParsed = parseCourseMinAttendeesInput(privateQcVal('lb-v2-private-qc-min-attendees'));
    if (!minParsed.ok) {
      showPrivateQcError(minParsed.message);
      return;
    }
    var courseMinAttendees = minParsed.value;

    if (!title) { showPrivateQcError('請填寫標題'); return; }
    if (!startDate || !startTime || !endDate || !endTime) {
      showPrivateQcError('請填寫課期日期與時間（按選日期／選時間）');
      return;
    }
    var startAt = taipeiDateTimeIso(startDate, startTime);
    var endAt = taipeiDateTimeIso(endDate, endTime);
    if (!startAt || !endAt) {
      showPrivateQcError('請填寫課期日期與時間（按選日期／選時間）');
      return;
    }
    if (new Date(endAt).getTime() <= new Date(startAt).getTime()) {
      showPrivateQcError('結束時間必須晚於開始時間');
      return;
    }
    if (!expStart || !expEnd) {
      showPrivateQcError('請填寫曝光起迄日');
      return;
    }
    if (expEnd < expStart) {
      showPrivateQcError('曝光迄日不能早於起日');
      return;
    }
    if (!city) { showPrivateQcError('請選擇縣市'); return; }
    if (!address) { showPrivateQcError('請填寫地址'); return; }
    if (!ticketName) { showPrivateQcError('請填寫票種名稱'); return; }
    if (!Number.isInteger(ticketPrice) || ticketPrice < 0) {
      showPrivateQcError('票價須為 0 以上的整數');
      return;
    }
    if (!Number.isInteger(ticketQty) || ticketQty < 1) {
      showPrivateQcError('請填寫名額（正整數，例：20）');
      return;
    }
    var minGate = validateCourseMinForQuickCreate(courseMinAttendees, ticketQty, startDate);
    if (!minGate.ok) {
      showPrivateQcError(minGate.message);
      updatePrivateQcDecideHint();
      return;
    }
    if (courseMinAttendees > 0 && minGate.window) {
      var okCreate = window.confirm(
        '此課將啟用未達開課人數決策：\n' +
          '最低開課人數：' + courseMinAttendees + ' 人\n' +
          '評估起：' + minGate.window.evalLabel + '（台北）\n' +
          '截止：' + minGate.window.deadlineLabel + '（台北）前須決策，逾期自動取消。\n\n' +
          '確定建立並上架？'
      );
      if (!okCreate) return;
    }

    var body = {
      vendor_slug: slug,
      listing_mode: 'PRIVATE',
      title: title,
      description: description,
      category: '',
      subcategory: '',
      start_at: startAt,
      end_at: endAt,
      // Shopify event.venue_name is required; reuse address when vendor skips venue.
      venue_name: venueName || address,
      instructor: instructor,
      organizer: '',
      co_organizer: '',
      address: address,
      maps_url: '',
      city_codes: [city],
      variants_json: [{ name: ticketName, price: ticketPrice, quantity: ticketQty }],
      cancel_policy_template: 'STANDARD',
      policy_cutoff_mode: 'FIXED_TIME',
      policy_cutoff_time: '23:59',
      course_min_attendees: courseMinAttendees,
      course_decide_days: 0,
      exposure_start_at: expStart,
      exposure_end_at: expEnd,
      calendar_color: calendarColor,
      description_images_json: []
    };

    privateQuickCreateInFlight = true;
    setPrivateQcSubmitLoading(true, '建立並上架中…');
    showPrivateQcError('建立並上架中，請稍候…');
    try {
      var response = await fetch(PATHS.listingSave, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(body)
      });
      var payload = null;
      try { payload = await response.json(); } catch (e) { payload = null; }
      if (!response.ok || !payload || payload.ok !== true) {
        var err = extractApiError(payload || {});
        var code = err.code || ('HTTP_' + response.status);
        showPrivateQcError(
          (code ? '[' + code + '] ' : '') + (err.message || '建立失敗')
        );
        return;
      }
      var listingId = payload.listing && payload.listing.id != null
        ? Number(payload.listing.id)
        : 0;
      if (!(listingId > 0)) {
        showPrivateQcError('已儲存但無法取得課程 ID，請至列表確認上架');
        return;
      }

      setPrivateQcSubmitLoading(true, '上架中…');
      showPrivateQcError('正在上架（#' + listingId + '）…');
      var confirmRes = await postAppProxyJson(PATHS.privateImportConfirm, {
        vendor_slug: slug,
        listing_ids: [listingId]
      });
      if (!confirmRes.ok) {
        var ce = extractApiError(confirmRes);
        showPrivateQcError(
          '草稿已建立，但上架失敗：' +
          (ce.code ? '[' + ce.code + '] ' : '') +
          (ce.message || confirmRes.message || '請至月曆勾選後再確認')
        );
        await loadPrivateScheduleTab();
        return;
      }

      var cp = confirmRes.payload || {};
      var results = Array.isArray(cp.results) ? cp.results : [];
      var first = results[0] || null;
      if (first && first.ok === false) {
        showPrivateQcError(
          '草稿已建立，但上架失敗：' +
          (first.code ? '[' + first.code + '] ' : '') +
          (first.message || '請至月曆勾選後再確認')
        );
        await loadPrivateScheduleTab();
        return;
      }

      writePrivateQcSavedDefaults(
        slug, city, address, venueName, description, ticketQty, calendarColor
      );
      var published = !!(first && (
        first.private_direct_publish === true ||
        String(first.status || '').toUpperCase() === 'PUBLISHED'
      ));
      closeModal();
      showNotice(
        notice,
        published
          ? '已建立並上架（#' + listingId + '）'
          : '已建立並送審（#' + listingId + '）'
      );
      await loadPrivateScheduleTab();
    } catch (err) {
      showPrivateQcError(err.message || '建立失敗');
    } finally {
      privateQuickCreateInFlight = false;
      setPrivateQcSubmitLoading(false);
    }
  }

  function privateCalMonthParam() {
    ensurePrivateCalCursor();
    var y = privateCalCursor.getFullYear();
    var m = privateCalCursor.getMonth() + 1;
    return y + '-' + String(m).padStart(2, '0');
  }

  async function exportPrivateCalendarMonth(format) {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    var month = privateCalMonthParam();
    var fields = readCalDisplayFields().join(',');
    var url = PATHS.privateCalendarExport +
      '?vendor_slug=' + encodeURIComponent(slug) +
      '&month=' + encodeURIComponent(month) +
      '&scope=published' +
      '&fields=' + encodeURIComponent(fields) +
      '&format=' + encodeURIComponent(format === 'pdf' ? 'pdf' : 'xlsx');
    try {
      if (format === 'pdf') {
        var response = await fetch(url, {
          method: 'GET',
          credentials: 'same-origin',
          headers: { Accept: 'text/html, application/json' },
        });
        var html = await response.text();
        if (!response.ok) {
          var message = '匯出失敗';
          try {
            var payload = JSON.parse(html);
            var err = extractApiError(payload);
            message = err.message || message;
          } catch (e) { /* keep */ }
          throw new Error(message);
        }
        var w = window.open('', '_blank');
        if (!w) throw new Error('瀏覽器封鎖了彈出視窗，請允許後再試');
        w.document.open();
        w.document.write(html);
        w.document.close();
      } else {
        await downloadPrivateXlsx(url, 'lb-private-calendar-' + month + '.xlsx');
      }
    } catch (err) {
      showNotice(notice, err.message || '月曆匯出失敗');
    }
  }

  function renderPrivateShareList(items) {
    var host = $('lb-v2-private-share-list');
    if (!host) return;
    if (!items || !items.length) {
      host.innerHTML = '<p class="lb-v2-muted">尚未產生分享連結。</p>';
      return;
    }
    var html = '';
    items.forEach(function (s) {
      var active = String(s.status || '').toUpperCase() === 'ACTIVE';
      var url = active ? privateSharePageUrl(s.token) : '';
      html += '<article class="lb-v2-m-card">' +
        '<div class="lb-v2-m-card__head">' +
          '<div class="lb-v2-m-card__title">#' + s.id +
            (s.label ? ' · ' + escapeHtml(s.label) : '') + '</div>' +
          '<span class="lb-v2-badge ' + (active ? 'lb-v2-badge--ok' : 'lb-v2-badge--void') + '">' +
            (active ? '有效' : '已作廢') + '</span>' +
        '</div>' +
        (active
          ? '<p class="lb-v2-hint" style="word-break:break-all">' + escapeHtml(url) + '</p>' +
            '<div class="lb-v2-m-card__actions">' +
              '<button type="button" class="lb-v2-btn lb-v2-btn--sm" data-private-share-copy="' +
                escapeHtml(url) + '">複製連結</button>' +
              '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--danger" data-private-share-revoke="' +
                s.id + '">作廢</button>' +
            '</div>'
          : '<p class="lb-v2-hint">作廢於 ' + escapeHtml(formatDateTimeTw(s.revoked_at)) + '</p>') +
      '</article>';
    });
    host.innerHTML = html;
    host.querySelectorAll('[data-private-share-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var u = btn.getAttribute('data-private-share-copy') || '';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(u).then(function () {
            showNotice(privateScheduleNoticeEl(), '已複製分享連結');
          }).catch(function () {
            window.prompt('複製連結：', u);
          });
        } else {
          window.prompt('複製連結：', u);
        }
      });
    });
    host.querySelectorAll('[data-private-share-revoke]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        revokePrivateShare(btn.getAttribute('data-private-share-revoke'), btn);
      });
    });
  }

  async function downloadPrivateXlsx(url, filename) {
    var response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/json' },
    });
    if (!response.ok) {
      var message = '下載失敗';
      try {
        var payload = await response.json();
        var dlErr = extractApiError(payload);
        message = dlErr.code ? '[' + dlErr.code + '] ' + dlErr.message : (dlErr.message || message);
      } catch (e) { /* keep */ }
      throw new Error(message);
    }
    var blob = await response.blob();
    triggerBrowserDownload(blob, filename);
  }

  async function downloadPrivateImportTemplate(type) {
    var notice = type === 'ELIGIBILITY' ? eligNoticeEl() : privateScheduleNoticeEl();
    var slug = getListingVendorSlug();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    var kind = type === 'ELIGIBILITY' ? 'eligibility' : 'courses';
    var url = PATHS.privateImportTemplate +
      '?vendor_slug=' + encodeURIComponent(slug) +
      '&type=' + encodeURIComponent(kind);
    var filename = kind === 'eligibility'
      ? 'lb-private-eligibility-template.xlsx'
      : 'lb-private-courses-template.xlsx';
    try {
      await downloadPrivateXlsx(url, filename);
    } catch (err) {
      showNotice(notice, err.message || '範本下載失敗');
    }
  }

  async function downloadPrivateImportErrors(batchId) {
    var notice = activeTab === 'private-eligibility' ? eligNoticeEl() : privateScheduleNoticeEl();
    var slug = getListingVendorSlug();
    if (!slug || !batchId) return;
    var url = PATHS.privateImportErrors +
      '?vendor_slug=' + encodeURIComponent(slug) +
      '&batch_id=' + encodeURIComponent(batchId);
    try {
      await downloadPrivateXlsx(url, 'lb-private-import-errors-' + batchId + '.xlsx');
    } catch (err) {
      showNotice(notice, err.message || '錯誤報告下載失敗');
    }
  }

  async function uploadPrivateImport() {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    var typeEl = $('lb-v2-private-import-type');
    var fileEl = $('lb-v2-private-import-file');
    var type = typeEl ? String(typeEl.value || 'COURSES') : 'COURSES';
    var file = fileEl && fileEl.files && fileEl.files[0] ? fileEl.files[0] : null;
    if (!file) {
      showNotice(notice, '請選擇 Excel 檔案');
      return;
    }
    var fd = new FormData();
    fd.append('vendor_slug', slug);
    fd.append('type', type);
    fd.append('file', file, file.name);
    var btn = $('lb-v2-private-import-upload');
    if (btn) btn.disabled = true;
    try {
      var response = await fetch(PATHS.privateImportUpload, {
        method: 'POST',
        credentials: 'same-origin',
        body: fd,
      });
      var payload = null;
      try { payload = await response.json(); } catch (e) { payload = null; }
      if (!response.ok || !payload || payload.ok !== true) {
        var importErr = extractApiError(payload);
        var msg = importErr.code ? '[' + importErr.code + '] ' + importErr.message : (importErr.message || '匯入失敗');
        showNotice(notice, msg);
        return;
      }
      var batch = payload.batch || {};
      showNotice(notice,
        '匯入完成：成功 ' + (batch.success_count || 0) +
        '／失敗 ' + (batch.error_count || 0) +
        (batch.id ? '（批次 #' + batch.id + '）' : ''));
      if (fileEl) fileEl.value = '';
      loadPrivateScheduleTab();
    } catch (err) {
      showNotice(notice, err.message || '匯入失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  async function uploadPrivateEligImport() {
    var slug = getListingVendorSlug();
    var notice = eligNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    var fileEl = $('lb-v2-private-elig-import-file');
    var file = fileEl && fileEl.files && fileEl.files[0] ? fileEl.files[0] : null;
    if (!file) {
      showNotice(notice, '請選擇 Excel 檔案');
      return;
    }
    var fd = new FormData();
    fd.append('vendor_slug', slug);
    fd.append('type', 'ELIGIBILITY');
    fd.append('file', file, file.name);
    var btn = $('lb-v2-private-elig-import-upload');
    if (btn) btn.disabled = true;
    try {
      var response = await fetch(PATHS.privateImportUpload, {
        method: 'POST',
        credentials: 'same-origin',
        body: fd,
      });
      var payload = null;
      try { payload = await response.json(); } catch (e) { payload = null; }
      if (!response.ok || !payload || payload.ok !== true) {
        var importErr = extractApiError(payload);
        var msg = importErr.code ? '[' + importErr.code + '] ' + importErr.message : (importErr.message || '匯入失敗');
        showNotice(notice, msg);
        return;
      }
      var batch = payload.batch || {};
      showNotice(notice,
        '匯入完成：成功 ' + (batch.success_count || 0) +
        '／失敗 ' + (batch.error_count || 0) +
        (batch.id ? '（批次 #' + batch.id + '）' : ''));
      if (fileEl) fileEl.value = '';
      loadPrivateEligibilityTab();
    } catch (err) {
      showNotice(notice, err.message || '匯入失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  async function confirmPrivateImportSelection() {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    var ids = getSelectedImportListingIds();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    if (!ids.length) {
      showNotice(notice, '請先勾選要確認的課程');
      return;
    }
    if (!window.confirm('確認上架 ' + ids.length + ' 筆待確認草稿（含匯入／手建）？預設由廠商確認後直上（不經官方審）。')) return;
    var res = await postAppProxyJson(PATHS.privateImportConfirm, {
      vendor_slug: slug,
      listing_ids: ids,
    });
    if (res.ok) {
      var p = res.payload || {};
      var failMsg = p.failed ? '，失敗 ' + p.failed + ' 筆' : '';
      var results = Array.isArray(p.results) ? p.results : [];
      var firstErr = results.find(function (r) { return r && !r.ok && r.message; });
      showNotice(
        notice,
        '已確認上架 ' + (p.confirmed || 0) + ' 筆' + failMsg +
          (firstErr ? '（例：' + firstErr.message + '）' : '')
      );
      loadPrivateScheduleTab();
    } else {
      showNotice(notice, res.message || '確認上架失敗');
    }
  }

  async function deletePrivateImportSelection() {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    var ids = getSelectedImportListingIds();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    if (!ids.length) {
      showNotice(notice, '請先勾選要刪除的草稿');
      return;
    }
    if (!window.confirm('確定刪除 ' + ids.length + ' 筆匯入草稿？此操作無法復原。')) return;
    var res = await postAppProxyJson(PATHS.privateImportDeleteDrafts, {
      vendor_slug: slug,
      listing_ids: ids,
    });
    if (res.ok) {
      showNotice(notice, '已刪除 ' + ((res.payload && res.payload.deleted) || 0) + ' 筆');
      loadPrivateScheduleTab();
    } else {
      showNotice(notice, res.message || '刪除失敗');
    }
  }

  async function createPrivateShare() {
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    var res = await postAppProxyJson(PATHS.privateCalendarShareCreate, {
      vendor_slug: slug,
      label: '課表分享',
    });
    if (res.ok) {
      showNotice(notice, '已產生分享連結');
      loadPrivateScheduleTab();
    } else {
      showNotice(notice, res.message || '產生失敗');
    }
  }

  async function revokePrivateShare(id, btn) {
    var slug = getListingVendorSlug();
    if (!slug || !id) return;
    if (!window.confirm('確定作廢此分享連結？')) return;
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.privateCalendarShareRevoke, {
        vendor_slug: slug,
        id: parseInt(id, 10),
      });
      if (res.ok) {
        showNotice(privateScheduleNoticeEl(), '已作廢分享連結');
        loadPrivateScheduleTab();
      } else {
        showNotice(privateScheduleNoticeEl(), res.message || '作廢失敗');
      }
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function bindPrivateEligibilityTabEvents() {
    if (privateEligTabBound) return;
    privateEligTabBound = true;
    ensureEligibilityDateTimePickers();
    var form = $('lb-v2-private-eligibility-form');
    if (form) {
      form.addEventListener('submit', upsertPrivateEligibility);
      form.addEventListener('reset', function (e) {
        e.preventDefault();
        clearEligibilityForm();
      });
    }
    var searchBtn = $('lb-v2-private-elig-customer-search');
    if (searchBtn) searchBtn.addEventListener('click', searchEligShopifyCustomers);
    var searchInput = $('lb-v2-private-elig-customer-q');
    if (searchInput) {
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          searchEligShopifyCustomers();
        }
      });
    }
    var filters = $('lb-v2-private-elig-filters');
    if (filters) {
      filters.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-elig-filter]') : null;
        if (!btn) return;
        privateEligFilter = btn.getAttribute('data-elig-filter') || 'all';
        renderPrivateEligibilityFiltered();
      });
    }
    var reqFilters = $('lb-v2-private-elig-req-filters');
    if (reqFilters) {
      reqFilters.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-elig-req-filter]') : null;
        if (!btn) return;
        privateEligReqFilter = btn.getAttribute('data-elig-req-filter') || 'PENDING';
        renderPrivateEligibilityRequestsFiltered();
      });
    }
    var dlE = $('lb-v2-private-dl-elig-tpl');
    if (dlE) dlE.addEventListener('click', function () { downloadPrivateImportTemplate('ELIGIBILITY'); });
    var upE = $('lb-v2-private-elig-import-upload');
    if (upE) upE.addEventListener('click', uploadPrivateEligImport);
  }

  function bindPrivateTabEvents() {
    if (privateTabBound) return;
    privateTabBound = true;
    var newBtn = $('lb-v2-private-new-listing');
    if (newBtn) {
      newBtn.addEventListener('click', function () { openNewPrivateListing(); });
    }
    var dlC = $('lb-v2-private-dl-courses-tpl');
    if (dlC) dlC.addEventListener('click', function () { downloadPrivateImportTemplate('COURSES'); });
    var pageReload = $('lb-v2-private-page-reload');
    if (pageReload) pageReload.addEventListener('click', function () { loadPrivatePagePlacements(); });
    bindPrivatePageTopSaveBar();
    var up = $('lb-v2-private-import-upload');
    if (up) up.addEventListener('click', uploadPrivateImport);
    var conf = $('lb-v2-private-import-confirm');
    if (conf) conf.addEventListener('click', confirmPrivateImportSelection);
    var del = $('lb-v2-private-import-delete');
    if (del) del.addEventListener('click', deletePrivateImportSelection);
    var prev = $('lb-v2-private-cal-prev');
    if (prev) {
      prev.addEventListener('click', function () {
        ensurePrivateCalCursor();
        privateCalCursor.setMonth(privateCalCursor.getMonth() - 1);
        refreshPrivateImportMonthView();
      });
    }
    var next = $('lb-v2-private-cal-next');
    if (next) {
      next.addEventListener('click', function () {
        ensurePrivateCalCursor();
        privateCalCursor.setMonth(privateCalCursor.getMonth() + 1);
        refreshPrivateImportMonthView();
      });
    }
    var expToggle = $('lb-v2-private-cal-exposure-toggle');
    if (expToggle) {
      expToggle.addEventListener('click', function () {
        privateCalShowExposure = !privateCalShowExposure;
        refreshPrivateImportMonthView();
      });
    }
    var exX = $('lb-v2-private-cal-export-xlsx');
    if (exX) exX.addEventListener('click', function () { exportPrivateCalendarMonth('xlsx'); });
    var exP = $('lb-v2-private-cal-export-pdf');
    if (exP) exP.addEventListener('click', function () { exportPrivateCalendarMonth('pdf'); });
    var fieldRoot = $('lb-v2-private-cal-fields');
    if (fieldRoot) {
      restoreCalDisplayFields();
      fieldRoot.addEventListener('change', function () {
        persistCalDisplayFields();
        refreshPrivateImportMonthView();
      });
    }
    var shareBtn = $('lb-v2-private-share-create');
    if (shareBtn) shareBtn.addEventListener('click', createPrivateShare);
    bindPrivateNoticeUiOnce();
  }

  /** Merge mode-filtered listing rows into allListingItems without wiping other modes. */
  function upsertListingItemsByMode(incoming, mode) {
    var modeU = String(mode || '').toUpperCase();
    var kept = (allListingItems || []).filter(function (i) {
      return String(i.listing_mode || '').toUpperCase() !== modeU;
    });
    allListingItems = kept.concat(incoming || []);
  }

  async function loadPrivateTab(forceReload) {
    await LbV2.ensureChunk('private');
    if (!beginTabLoad('private', forceReload)) return;
    var slug = getListingVendorSlug();
    var notice = $('lb-v2-private-notice');
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    hideNotice(notice);
    setDataLoading(true);
    try {
      var bundle = await Promise.all([
        loadFeeEntitlement(slug).catch(function () { return null; }),
        fetchAppProxy(PATHS.privateApplications, slug),
      ]);
      var res = bundle[1];
      if (res.ok) {
        renderPrivateApplications((res.payload && res.payload.items) || []);
        markTabCache('private');
      } else {
        renderPrivateApplications([]);
        showNotice(notice, res.message || '年約申請載入失敗');
      }
    } catch (err) {
      showNotice(notice, err.message || '載入失敗');
    } finally {
      setDataLoading(false);
    }
  }

  async function loadPrivateScheduleTab(forceReload) {
    await LbV2.ensureChunk('private');
    bindPrivateTabEvents();
    if (!beginTabLoad('private-schedule', forceReload)) return;
    var slug = getListingVendorSlug();
    var notice = privateScheduleNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    hideNotice(notice);
    setDataLoading(true);
    try {
      var bundle = await Promise.all([
        loadFeeEntitlement(slug).catch(function () { return null; }),
        fetchAppProxy(PATHS.listingList, slug, { listing_mode: 'PRIVATE' }),
        fetchAppProxy(PATHS.privateImportBatches, slug),
        fetchAppProxy(PATHS.privateImportPending, slug),
        fetchAppProxy(PATHS.privateCalendarShare, slug),
        fetchAppProxy(PATHS.privateCalendarNotices, slug),
      ]);
      if (bundle[1].ok) {
        var data = bundle[1].payload || bundle[1];
        var privateItems = data.items || [];
        upsertListingItemsByMode(privateItems, 'PRIVATE');
        renderPrivateListingList(privateItems);
      } else {
        renderPrivateListingList([]);
      }
      if (bundle[2].ok) {
        renderPrivateImportBatches((bundle[2].payload && bundle[2].payload.items) || [], {
          hostId: 'lb-v2-private-import-batches',
          typeFilter: 'COURSES',
        });
      } else {
        renderPrivateImportBatches([], { hostId: 'lb-v2-private-import-batches', typeFilter: 'COURSES' });
      }
      if (bundle[3].ok) {
        renderPrivateImportPending((bundle[3].payload && bundle[3].payload.items) || []);
      } else {
        renderPrivateImportPending([]);
      }
      if (bundle[4].ok) {
        renderPrivateShareList((bundle[4].payload && bundle[4].payload.items) || []);
      } else {
        renderPrivateShareList([]);
      }
      if (bundle[5] && bundle[5].ok) {
        var noticePayload = bundle[5].payload || bundle[5];
        renderPrivateCalendarNotices(noticePayload.items || [], noticePayload.iso_week_hint || null);
      } else {
        renderPrivateCalendarNotices([], null);
      }
      mountCalSwatches('lb-v2-private-notice-swatches', 'lb-v2-private-notice-color', defaultCalSwatchColor());
      syncNoticeFormKindUi();
      renderPrivateImportCalendar();
      markTabCache('private-schedule');
    } catch (err) {
      showNotice(notice, err.message || '載入失敗');
    } finally {
      setDataLoading(false);
    }
  }

  async function loadPrivatePageTab(forceReload) {
    await LbV2.ensureChunk('private');
    bindPrivateTabEvents();
    if (!beginTabLoad('private-page', forceReload)) return;
    var slug = getListingVendorSlug();
    var notice = $('lb-v2-private-page-notice');
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    hideNotice(notice);
    setDataLoading(true);
    try {
      var pageBundle = await Promise.all([
        loadFeeEntitlement(slug).catch(function () { return null; }),
        loadPrivatePagePlacements(slug),
      ]);
      if (pageBundle[1]) markTabCache('private-page');
    } catch (err) {
      showNotice(notice, err.message || '載入失敗');
    } finally {
      setDataLoading(false);
    }
  }

  var SECTION_TYPE_LABELS = {
    HERO_CAROUSEL: '精選主打（輪播）',
    FEATURED: '主打課程',
    SHELF_SCROLL: '課程系列（可橫向滑動）',
    COURSE_CARD: '全部課程',
    NOTICE_BANNER: '公告橫幅',
    CALENDAR_EMBED: '課表嵌入'
  };

  var PREVIEW_VIS_LABELS = {
    LIVE: '曝光中',
    DRAFT: '草稿',
    OUT_OF_WINDOW: '已上架・未進曝光',
    UNPUBLISHED: '已下架'
  };

  var privatePagePlacementCache = {
    slots: [],
    placements: [],
    listings: [],
    previewMode: 'wireframe',
    livePreviewLoaded: false,
    surfaceSaved: null,
    surfaceDraft: null
  };
  var privatePagePreviewEventsBound = false;

  function defaultScheduleCardFields() {
    return {
      time: true,
      venue: true,
      address: false,
      description: true,
      capacity: true,
      price: true
    };
  }

  function normalizeScheduleCardFields(raw) {
    var src = raw && typeof raw === 'object' ? raw : {};
    return {
      time: true,
      venue: src.venue !== false && src.venue !== 0 && src.venue !== '0',
      address: src.address === true || src.address === 1 || src.address === '1',
      description: src.description !== false && src.description !== 0 && src.description !== '0',
      capacity: src.capacity !== false && src.capacity !== 0 && src.capacity !== '0',
      price: src.price !== false && src.price !== 0 && src.price !== '0'
    };
  }

  function scheduleCardFieldsEqual(a, b) {
    var x = normalizeScheduleCardFields(a);
    var y = normalizeScheduleCardFields(b);
    return x.time === y.time &&
      x.venue === y.venue &&
      x.address === y.address &&
      x.description === y.description &&
      x.capacity === y.capacity &&
      x.price === y.price;
  }

  function defaultLearnerSurface() {
    return {
      show_brand_page: true,
      show_schedule: true,
      default_layer: 'brand',
      schedule_card_fields: defaultScheduleCardFields(),
      wall_tagline: '',
      eligibility_reason_hint: ''
    };
  }

  function normalizeWallTagline(raw) {
    var s = String(raw == null ? '' : raw)
      .replace(/<[^>]*>/g, '')
      .replace(/[\u0000-\u001F\u007F]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (Array.from(s).length > 36) s = Array.from(s).slice(0, 36).join('').trim();
    return s;
  }

  function normalizeEligibilityReasonHint(raw) {
    var s = String(raw == null ? '' : raw)
      .replace(/<[^>]*>/g, '')
      .replace(/[\u0000-\u001F\u007F]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    if (Array.from(s).length > 60) s = Array.from(s).slice(0, 60).join('').trim();
    return s;
  }

  function normalizeLearnerSurface(raw) {
    var src = raw && typeof raw === 'object' ? raw : {};
    var showBrand = src.show_brand_page !== false;
    var showSchedule = src.show_schedule !== false;
    if (!showBrand && !showSchedule) showSchedule = true;
    var defaultLayer = src.default_layer === 'schedule' ? 'schedule' : 'brand';
    if (showBrand && !showSchedule) defaultLayer = 'brand';
    if (!showBrand && showSchedule) defaultLayer = 'schedule';
    return {
      show_brand_page: showBrand,
      show_schedule: showSchedule,
      default_layer: defaultLayer,
      schedule_card_fields: normalizeScheduleCardFields(src.schedule_card_fields),
      wall_tagline: normalizeWallTagline(src.wall_tagline),
      eligibility_reason_hint: normalizeEligibilityReasonHint(src.eligibility_reason_hint)
    };
  }

  function cloneLearnerSurface(s) {
    var n = normalizeLearnerSurface(s);
    return {
      show_brand_page: n.show_brand_page,
      show_schedule: n.show_schedule,
      default_layer: n.default_layer,
      schedule_card_fields: normalizeScheduleCardFields(n.schedule_card_fields),
      wall_tagline: n.wall_tagline || '',
      eligibility_reason_hint: n.eligibility_reason_hint || ''
    };
  }

  if (!privatePagePlacementCache.surfaceSaved) {
    privatePagePlacementCache.surfaceSaved = defaultLearnerSurface();
  }
  if (!privatePagePlacementCache.surfaceDraft) {
    privatePagePlacementCache.surfaceDraft = defaultLearnerSurface();
  }

  function isPrivateLearnerSurfaceDirty() {
    var d = normalizeLearnerSurface(privatePagePlacementCache.surfaceDraft);
    var s = normalizeLearnerSurface(privatePagePlacementCache.surfaceSaved);
    return d.show_brand_page !== s.show_brand_page ||
      d.show_schedule !== s.show_schedule ||
      d.default_layer !== s.default_layer ||
      d.wall_tagline !== s.wall_tagline ||
      d.eligibility_reason_hint !== s.eligibility_reason_hint ||
      !scheduleCardFieldsEqual(d.schedule_card_fields, s.schedule_card_fields);
  }

  function syncPrivatePagePlacementsDisabledUi() {
    var draft = normalizeLearnerSurface(privatePagePlacementCache.surfaceDraft);
    var block = $('lb-v2-private-page-placements-block');
    var hint = $('lb-v2-private-page-placements-disabled-hint');
    if (block) block.classList.toggle('is-surface-disabled', !draft.show_brand_page);
    if (hint) hint.hidden = !!draft.show_brand_page;
  }

  function learnerSurfaceSummaryHtml(draft) {
    var both = draft.show_brand_page && draft.show_schedule;
    if (both) {
      var first = draft.default_layer === 'schedule' ? '課表' : '專屬頁';
      return (
        '<p class="lb-v2-page-surface__summary">' +
          '學員進廠商後：可在<strong>專屬頁</strong>與<strong>課表</strong>之間切換；一進來先看到<strong>' +
          first + '</strong>。' +
        '</p>'
      );
    }
    if (draft.show_brand_page) {
      return (
        '<p class="lb-v2-page-surface__summary">' +
          '學員進廠商後：只會看到<strong>專屬頁</strong>（下方版位配置的內容），不會出現課表、也沒有頁面切換。' +
        '</p>'
      );
    }
    return (
      '<p class="lb-v2-page-surface__summary">' +
        '學員進廠商後：只會看到<strong>課表</strong>（可勾選多堂報名），不會出現專屬頁、也沒有頁面切換。' +
      '</p>'
    );
  }

  function scheduleCardFieldsControlsHtml(fields, scheduleOn) {
    var f = normalizeScheduleCardFields(fields);
    var disabled = !scheduleOn;
    function fieldToggle(key, label, locked) {
      return (
        '<label class="lb-v2-page-surface__field' + (disabled ? ' is-disabled' : '') + '">' +
          '<input type="checkbox" data-surface-field="' + key + '"' +
            (f[key] ? ' checked' : '') +
            (disabled || locked ? ' disabled' : '') + '>' +
          '<span>' + label + '</span>' +
        '</label>'
      );
    }
    return (
      '<div class="lb-v2-page-surface__fields" data-surface-fields' +
        (disabled ? ' hidden' : '') + '>' +
        '<div class="lb-v2-page-surface__fields-head">' +
          '<strong>課表卡片顯示欄位</strong>' +
          '<small>整份課表統一；時間固定顯示</small>' +
        '</div>' +
        '<div class="lb-v2-page-surface__fields-grid">' +
          fieldToggle('time', '時間', true) +
          fieldToggle('venue', '教室／場地名稱', false) +
          fieldToggle('address', '地址', false) +
          fieldToggle('description', '課程說明', false) +
          fieldToggle('capacity', '名額', false) +
          fieldToggle('price', '價格', false) +
        '</div>' +
      '</div>'
    );
  }

  function renderPrivatePageSurfaceControls() {
    var host = $('lb-v2-private-page-surface');
    if (!host) return;
    var draft = normalizeLearnerSurface(privatePagePlacementCache.surfaceDraft);
    privatePagePlacementCache.surfaceDraft = draft;
    var both = draft.show_brand_page && draft.show_schedule;
    var brandLocked = draft.show_brand_page && !draft.show_schedule;
    var scheduleLocked = draft.show_schedule && !draft.show_brand_page;
    host.innerHTML =
      '<div class="lb-v2-page-surface__fields">' +
        '<div class="lb-v2-page-surface__fields-head">' +
          '<strong>宣傳牆短標</strong>' +
          '<small>廠商卡片、名稱下方；字色固定 LadyBae 酒紅。空白＝不顯示。最多 36 字</small>' +
        '</div>' +
        '<input type="text" class="lb-v2-input" data-surface-tagline maxlength="36" ' +
          'value="' + escapeHtml(draft.wall_tagline || '') + '" placeholder="例：住房中限定課程">' +
      '</div>' +
      '<div class="lb-v2-page-surface__fields">' +
        '<div class="lb-v2-page-surface__fields-head">' +
          '<strong>申請原因提示</strong>' +
          '<small>學員申請通行證時，原因欄的預設提示。空白＝平台預設。最多 60 字</small>' +
        '</div>' +
        '<input type="text" class="lb-v2-input" data-surface-reason-hint maxlength="60" ' +
          'value="' + escapeHtml(draft.eligibility_reason_hint || '') +
          '" placeholder="例：我是咪寶501房-OOO媽咪">' +
      '</div>' +
      '<div class="lb-v2-page-surface__toggles">' +
        '<label class="lb-v2-page-surface__toggle">' +
          '<input type="checkbox" data-surface-brand' +
            (draft.show_brand_page ? ' checked' : '') +
            (brandLocked ? ' disabled' : '') + '>' +
          '<span class="lb-v2-page-surface__toggle-text">' +
            '<strong>專屬頁</strong>' +
            '<small>輪播／主打／系列等品牌版面（下方可配置版位）</small>' +
          '</span>' +
        '</label>' +
        '<label class="lb-v2-page-surface__toggle">' +
          '<input type="checkbox" data-surface-schedule' +
            (draft.show_schedule ? ' checked' : '') +
            (scheduleLocked ? ' disabled' : '') + '>' +
          '<span class="lb-v2-page-surface__toggle-text">' +
            '<strong>課表</strong>' +
            '<small>自動月曆＋可勾選多堂課一次結帳</small>' +
          '</span>' +
        '</label>' +
      '</div>' +
      learnerSurfaceSummaryHtml(draft) +
      (both
        ? '<label class="lb-v2-page-surface__default">' +
            '<span>兩者都開時，學員一進來先看到</span>' +
            '<select class="lb-v2-input" data-surface-default>' +
              '<option value="brand"' + (draft.default_layer === 'brand' ? ' selected' : '') + '>專屬頁</option>' +
              '<option value="schedule"' + (draft.default_layer === 'schedule' ? ' selected' : '') + '>課表</option>' +
            '</select>' +
          '</label>'
        : '') +
      scheduleCardFieldsControlsHtml(draft.schedule_card_fields, draft.show_schedule) +
      '<p class="lb-v2-hint">至少要開一種；最後一種不能關。改完請按下方「儲存全部」才會套用到前台。</p>';
    var brandInp = host.querySelector('[data-surface-brand]');
    var scheduleInp = host.querySelector('[data-surface-schedule]');
    var defaultSel = host.querySelector('[data-surface-default]');
    var taglineInp = host.querySelector('[data-surface-tagline]');
    var reasonHintInp = host.querySelector('[data-surface-reason-hint]');
    if (taglineInp) {
      taglineInp.addEventListener('input', function () {
        var next = cloneLearnerSurface(privatePagePlacementCache.surfaceDraft);
        next.wall_tagline = normalizeWallTagline(taglineInp.value);
        privatePagePlacementCache.surfaceDraft = normalizeLearnerSurface(next);
        syncPrivatePageSaveButtons();
      });
    }
    if (reasonHintInp) {
      reasonHintInp.addEventListener('input', function () {
        var next = cloneLearnerSurface(privatePagePlacementCache.surfaceDraft);
        next.eligibility_reason_hint = normalizeEligibilityReasonHint(reasonHintInp.value);
        privatePagePlacementCache.surfaceDraft = normalizeLearnerSurface(next);
        syncPrivatePageSaveButtons();
      });
    }
    if (brandInp) {
      brandInp.addEventListener('change', function () {
        var next = cloneLearnerSurface(privatePagePlacementCache.surfaceDraft);
        if (!brandInp.checked && !next.show_schedule) {
          brandInp.checked = true;
          showNotice($('lb-v2-private-page-notice'), '至少須開啟專屬頁或課表其中一種');
          return;
        }
        next.show_brand_page = !!brandInp.checked;
        privatePagePlacementCache.surfaceDraft = normalizeLearnerSurface(next);
        renderPrivatePageSurfaceControls();
        syncPrivatePagePlacementsDisabledUi();
        syncPrivatePageSaveButtons();
      });
    }
    if (scheduleInp) {
      scheduleInp.addEventListener('change', function () {
        var next = cloneLearnerSurface(privatePagePlacementCache.surfaceDraft);
        if (!scheduleInp.checked && !next.show_brand_page) {
          scheduleInp.checked = true;
          showNotice($('lb-v2-private-page-notice'), '至少須開啟專屬頁或課表其中一種');
          return;
        }
        next.show_schedule = !!scheduleInp.checked;
        privatePagePlacementCache.surfaceDraft = normalizeLearnerSurface(next);
        renderPrivatePageSurfaceControls();
        syncPrivatePagePlacementsDisabledUi();
        syncPrivatePageSaveButtons();
      });
    }
    if (defaultSel) {
      defaultSel.addEventListener('change', function () {
        var next = cloneLearnerSurface(privatePagePlacementCache.surfaceDraft);
        next.default_layer = defaultSel.value === 'schedule' ? 'schedule' : 'brand';
        privatePagePlacementCache.surfaceDraft = normalizeLearnerSurface(next);
        syncPrivatePageSaveButtons();
      });
    }
    host.querySelectorAll('[data-surface-field]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var key = inp.getAttribute('data-surface-field');
        if (!key || key === 'time') {
          inp.checked = true;
          return;
        }
        var next = cloneLearnerSurface(privatePagePlacementCache.surfaceDraft);
        next.schedule_card_fields = normalizeScheduleCardFields(next.schedule_card_fields);
        next.schedule_card_fields[key] = !!inp.checked;
        privatePagePlacementCache.surfaceDraft = normalizeLearnerSurface(next);
        syncPrivatePageSaveButtons();
      });
    });
    syncPrivatePagePlacementsDisabledUi();
  }

  function slotHumanLabel(slotKey, sectionType) {
    var key = String(slotKey || '');
    var m;
    if ((m = key.match(/^hero_(\d+)$/))) return '輪播第 ' + m[1] + ' 張';
    if ((m = key.match(/^feature_(\d+)$/))) return '主打第 ' + m[1] + ' 卡';
    if ((m = key.match(/^shelf_a_(\d+)$/))) return '系列 A · 第 ' + m[1] + ' 格';
    if ((m = key.match(/^shelf_b_(\d+)$/))) return '系列 B · 第 ' + m[1] + ' 格';
    if ((m = key.match(/^card_(\d+)$/))) return '課卡第 ' + m[1] + ' 格';
    if (key === 'notice' || sectionType === 'NOTICE_BANNER') return '公告文字';
    if (key === 'calendar' || sectionType === 'CALENDAR_EMBED') return '課表區塊';
    return key;
  }

  function listingById(listings, id) {
    if (id == null || id === '') return null;
    var sid = String(id);
    for (var i = 0; i < (listings || []).length; i++) {
      if (String(listings[i].id) === sid) return listings[i];
    }
    return null;
  }

  function listingVisLabel(listing) {
    if (!listing) return '';
    var st = String(listing.status || '').toUpperCase();
    if (st === 'PENDING_REVIEW') return '審核中';
    if (st === 'REJECTED') return '已駁回';
    var v = String(listing.preview_visibility || '').toUpperCase();
    if (PREVIEW_VIS_LABELS[v]) return PREVIEW_VIS_LABELS[v];
    if (st === 'DRAFT') return '草稿';
    if (st === 'PUBLISHED') return '已上架';
    if (st === 'UNPUBLISHED') return '已下架';
    return st || '';
  }

  function placeableOptionsHtml(listings, selectedId) {
    var opts = ['<option value="">（不放置）</option>'];
    (listings || []).forEach(function (l) {
      var vis = listingVisLabel(l);
      var tag = vis ? '（' + escapeHtml(vis) + '）' : '';
      var sel = String(l.id) === String(selectedId) ? ' selected' : '';
      opts.push('<option value="' + l.id + '"' + sel + '>' + escapeHtml(l.title || ('#' + l.id)) + ' ' + tag + '</option>');
    });
    return opts.join('');
  }

  function readPlacementDraftFromDom() {
    var host = $('lb-v2-private-page-slots');
    var bySlot = {};
    (privatePagePlacementCache.placements || []).forEach(function (p) {
      bySlot[p.slot_key] = {
        slot_key: p.slot_key,
        listing_id: p.listing_id,
        shelf_title: p.shelf_title || ''
      };
    });
    if (!host) return bySlot;
    host.querySelectorAll('[data-slot]').forEach(function (wrap) {
      var key = wrap.getAttribute('data-slot');
      if (!key) return;
      var listingSel = wrap.querySelector('[data-slot-listing]');
      var titleEl = wrap.querySelector('[data-slot-title]');
      var prev = bySlot[key] || {};
      bySlot[key] = {
        slot_key: key,
        listing_id: listingSel && listingSel.value ? Number(listingSel.value) : null,
        // Keep prior title when card has no title input (shelf title lives on section head)
        shelf_title: titleEl ? titleEl.value : (prev.shelf_title || '')
      };
    });
    // Section-level shelf titles write onto the first slot of that shelf row
    host.querySelectorAll('[data-shelf-title-slot]').forEach(function (inp) {
      var key = inp.getAttribute('data-shelf-title-slot');
      if (!key) return;
      if (!bySlot[key]) {
        bySlot[key] = { slot_key: key, listing_id: null, shelf_title: '' };
      }
      bySlot[key].shelf_title = inp.value || '';
    });
    return bySlot;
  }

  /** Preferred editor/preview order (notice top, calendar mid) independent of stale DB sort. */
  function rankPrivatePageGroupKey(groupKey) {
    if (groupKey === 'NOTICE_BANNER') return 10;
    if (groupKey === 'HERO_CAROUSEL') return 20;
    if (groupKey === 'FEATURED') return 30;
    if (groupKey === 'CALENDAR_EMBED') return 40;
    if (groupKey === 'SHELF_SCROLL:shelf_a') return 50;
    if (groupKey === 'SHELF_SCROLL:shelf_b') return 60;
    if (String(groupKey).indexOf('SHELF_SCROLL:') === 0) return 55;
    if (groupKey === 'COURSE_CARD') return 70;
    return 80;
  }

  /** Group blueprint slots for preview/editor; split SHELF_SCROLL into shelf_a / shelf_b rows. */
  function groupSlotsByType(slots) {
    var order = [];
    var groups = {};
    (slots || []).forEach(function (s) {
      var groupKey = s.section_type;
      if (s.section_type === 'SHELF_SCROLL') {
        var m = String(s.slot_key || '').match(/^(shelf_[a-z]+)_/i);
        groupKey = m ? 'SHELF_SCROLL:' + m[1].toLowerCase() : 'SHELF_SCROLL';
      }
      if (!groups[groupKey]) {
        groups[groupKey] = [];
        order.push(groupKey);
      }
      groups[groupKey].push(s);
    });
    order.sort(function (a, b) {
      return rankPrivatePageGroupKey(a) - rankPrivatePageGroupKey(b);
    });
    return { order: order, groups: groups };
  }

  function sectionTypeFromGroupKey(groupKey) {
    if (String(groupKey).indexOf('SHELF_SCROLL:') === 0) return 'SHELF_SCROLL';
    return groupKey;
  }

  function sectionLabelFromGroupKey(groupKey) {
    if (groupKey === 'SHELF_SCROLL:shelf_a') return '課程系列 A（可橫向滑動）';
    if (groupKey === 'SHELF_SCROLL:shelf_b') return '課程系列 B（可橫向滑動）';
    if (String(groupKey).indexOf('SHELF_SCROLL:') === 0) return '課程系列（可橫向滑動）';
    return SECTION_TYPE_LABELS[groupKey] || groupKey;
  }

  function wireframeCellHtml(slot, draft, listings) {
    var isText = slot.section_type === 'NOTICE_BANNER' || slot.section_type === 'CALENDAR_EMBED';
    var title = '';
    var vis = '';
    var visKey = '';
    var empty = true;
    if (isText) {
      title = (draft && draft.shelf_title) || '';
      empty = !String(title).trim();
    } else {
      var listing = listingById(listings, draft && draft.listing_id);
      if (listing) {
        title = listing.title || ('#' + listing.id);
        vis = listingVisLabel(listing);
        visKey = String(listing.preview_visibility || 'DRAFT').toLowerCase();
        empty = false;
      }
    }
    return (
      '<div class="lb-v2-page-wireframe__cell' + (empty ? ' is-empty' : '') + '" data-wire-slot="' +
      escapeHtml(slot.slot_key) + '">' +
        '<div class="lb-v2-page-wireframe__cell-key">' + escapeHtml(slotHumanLabel(slot.slot_key, slot.section_type)) +
          '<span class="lb-v2-page-wireframe__cell-code">' + escapeHtml(slot.slot_key) + '</span></div>' +
        '<div class="lb-v2-page-wireframe__cell-title">' +
          escapeHtml(empty ? '未放置' : title) +
        '</div>' +
        (vis
          ? '<span class="lb-v2-page-wireframe__badge lb-v2-page-wireframe__badge--' +
            escapeHtml(visKey || 'draft') + '">' + escapeHtml(vis) + '</span>'
          : '') +
      '</div>'
    );
  }

  function renderPrivatePageWireframe() {
    var host = $('lb-v2-private-page-wireframe');
    if (!host) return;
    var slots = privatePagePlacementCache.slots || [];
    var listings = privatePagePlacementCache.listings || [];
    if (!slots.length) {
      host.innerHTML = '<p class="lb-v2-muted">尚未設定版型藍圖。</p>';
      return;
    }
    var draft = readPlacementDraftFromDom();
    var grouped = groupSlotsByType(slots);
    var html = '<div class="lb-v2-page-wireframe__legend">示意學員專屬頁區塊位置；選課後即時更新（不必先儲存）。</div>';
    grouped.order.forEach(function (groupKey) {
      var type = sectionTypeFromGroupKey(groupKey);
      var items = grouped.groups[groupKey];
      var layout =
        type === 'HERO_CAROUSEL' ? 'hero' :
        type === 'FEATURED' ? 'featured' :
        type === 'SHELF_SCROLL' ? 'shelf' :
        type === 'COURSE_CARD' ? 'grid' :
        'text';
      var shelfTitle = '';
      if (type === 'SHELF_SCROLL') {
        for (var si = 0; si < items.length; si++) {
          var d = draft[items[si].slot_key];
          if (d && d.shelf_title) { shelfTitle = d.shelf_title; break; }
        }
      }
      var wfLayout =
        type === 'NOTICE_BANNER' ? 'notice' :
        type === 'CALENDAR_EMBED' ? 'calendar' :
        layout;
      html += '<section class="lb-v2-page-wireframe__section lb-v2-page-wireframe__section--' + wfLayout + '">';
      html += '<header class="lb-v2-page-wireframe__section-head">' +
        '<span class="lb-v2-page-wireframe__section-title">' +
        escapeHtml(sectionLabelFromGroupKey(groupKey)) +
        '</span>' +
        (shelfTitle
          ? '<div class="lb-v2-page-wireframe__section-sub">' + escapeHtml(shelfTitle) + '</div>'
          : '') +
        '</header>';
      html += '<div class="lb-v2-page-wireframe__cells lb-v2-page-wireframe__cells--' + layout + '">';
      items.forEach(function (s) {
        html += wireframeCellHtml(s, draft[s.slot_key], listings);
      });
      html += '</div></section>';
    });
    host.innerHTML = html;
  }

  function previewCoverUrl(listing) {
    if (!listing) return '';
    var u = String(listing.cover_image_url || '').trim();
    if (/^https?:\/\//i.test(u)) return u;
    var raw = listing.images_json;
    if (typeof raw === 'string') {
      try { raw = JSON.parse(raw); } catch (e) { raw = null; }
    }
    if (Array.isArray(raw) && raw.length) {
      var first = raw[0];
      if (typeof first === 'string' && /^https?:\/\//i.test(first)) return first;
      if (first && first.src && /^https?:\/\//i.test(String(first.src))) return String(first.src);
    }
    return '';
  }

  function previewCourseCard(listing, variant) {
    if (!listing) return '';
    var v = variant || 'grid';
    var vis = listingVisLabel(listing);
    var visKey = String(listing.preview_visibility || 'DRAFT').toLowerCase();
    var cover = previewCoverUrl(listing);
    var media = cover
      ? '<div class="lb-priv__card-media"><img src="' + escapeHtml(cover) + '" alt="" loading="lazy"></div>'
      : '<div class="lb-priv__card-media lb-priv__card-media--ph" aria-hidden="true"></div>';
    return (
      '<article class="lb-priv__card lb-priv__card--' + escapeHtml(v) + '">' +
        media +
        '<div class="lb-priv__card-body">' +
          (vis && visKey !== 'live'
            ? '<span class="lb-v2-brand-preview__pill lb-v2-brand-preview__pill--' + escapeHtml(visKey) + '">' +
              escapeHtml(vis) + '</span>'
            : '') +
          '<h3>' + escapeHtml(listing.title || ('#' + listing.id)) + '</h3>' +
          '<div class="lb-priv__meta">開課：' + escapeHtml(listing.start_at ? formatDateTw(listing.start_at) : '—') + '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function previewHeroCarousel(filled) {
    if (!filled.length) return '';
    var slides = filled.map(function (s, i) {
      return (
        '<div class="lb-priv__carousel-slide' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '">' +
        previewCourseCard(s.listing, 'hero') +
        '</div>'
      );
    }).join('');
    var dots = filled.map(function (_s, i) {
      return '<button type="button" class="lb-priv__carousel-dot' + (i === 0 ? ' is-active' : '') +
        '" data-go="' + i + '" aria-label="第 ' + (i + 1) + ' 張"></button>';
    }).join('');
    return (
      '<div class="lb-priv__carousel" data-lb-carousel>' +
        '<div class="lb-priv__carousel-viewport"><div class="lb-priv__carousel-track">' + slides + '</div></div>' +
        (filled.length > 1
          ? '<div class="lb-priv__carousel-nav">' +
              '<button type="button" class="lb-priv__carousel-btn" data-dir="-1" aria-label="上一張">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>' +
              '</button>' +
              '<div class="lb-priv__carousel-dots">' + dots + '</div>' +
              '<button type="button" class="lb-priv__carousel-btn" data-dir="1" aria-label="下一張">' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>' +
              '</button>' +
            '</div>'
          : '') +
      '</div>'
    );
  }

  function initPreviewCarousels(root) {
    if (!root) return;
    root.querySelectorAll('[data-lb-carousel]').forEach(function (el) {
      if (el._lbCarouselBound) return;
      el._lbCarouselBound = true;
      var slides = el.querySelectorAll('.lb-priv__carousel-slide');
      var dots = el.querySelectorAll('.lb-priv__carousel-dot');
      if (slides.length < 2) return;
      var idx = 0;
      var timer = null;
      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () { show(idx + 1); }, 5000);
      }
      el.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(idx + (parseInt(btn.getAttribute('data-dir'), 10) || 1));
          restart();
        });
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.getAttribute('data-go'), 10) || 0);
          restart();
        });
      });
      restart();
    });
  }

  function renderPrivatePageLivePreview(data) {
    var body = $('lb-v2-private-page-live-preview-body');
    if (!body) return;
    var slots = (data && data.slots) || [];
    var rest = (data && data.rest) || [];
    var grouped = groupSlotsByType(slots);
    var html = '';
    grouped.order.forEach(function (groupKey) {
      var type = sectionTypeFromGroupKey(groupKey);
      var items = grouped.groups[groupKey];
      if (type === 'NOTICE_BANNER') {
        var notice = items.filter(function (s) { return s.shelf_title; }).map(function (s) {
          return '<div class="lb-priv__notice">' + escapeHtml(s.shelf_title) + '</div>';
        }).join('');
        if (notice) html += '<div class="lb-priv__brand-section">' + notice + '</div>';
        return;
      }
      if (type === 'CALENDAR_EMBED') {
        var calNote = items.some(function (s) { return s.shelf_title; })
          ? items.map(function (s) { return s.shelf_title; }).filter(Boolean).join('／')
          : '課表區塊（依實際分享月曆顯示）';
        html += '<div class="lb-priv__brand-section">' +
          '<div class="lb-priv__brand-title">課表</div>' +
          '<div class="lb-priv__card lb-priv__card--grid"><div class="lb-priv__card-body">' +
            '<div class="lb-priv__meta">' + escapeHtml(calNote) + '</div></div></div></div>';
        return;
      }
      var filled = items.filter(function (s) { return s.listing; });
      if (!filled.length) return;
      if (type === 'HERO_CAROUSEL') {
        html += '<div class="lb-priv__brand-section">' +
          '<div class="lb-priv__brand-title">' + escapeHtml(sectionLabelFromGroupKey(groupKey)) + '</div>' +
          previewHeroCarousel(filled) +
          '</div>';
        return;
      }
      if (type === 'FEATURED') {
        html += '<div class="lb-priv__brand-section">' +
          '<div class="lb-priv__brand-title">' + escapeHtml(sectionLabelFromGroupKey(groupKey)) + '</div>' +
          '<div class="lb-priv__featured">' +
          filled.map(function (s) { return previewCourseCard(s.listing, 'featured'); }).join('') +
          '</div></div>';
        return;
      }
      if (type === 'SHELF_SCROLL') {
        var shelfTitle = '';
        for (var fi = 0; fi < items.length; fi++) {
          if (items[fi].shelf_title) { shelfTitle = items[fi].shelf_title; break; }
        }
        if (!shelfTitle) shelfTitle = sectionLabelFromGroupKey(groupKey);
        html += '<div class="lb-priv__brand-section">' +
          '<div class="lb-priv__brand-title">' + escapeHtml(shelfTitle) + '</div>' +
          '<div class="lb-priv__shelf-wrap"><div class="lb-priv__shelf">' +
          filled.map(function (s) { return previewCourseCard(s.listing, 'shelf'); }).join('') +
          '</div></div></div>';
        return;
      }
      html += '<div class="lb-priv__brand-section">' +
        '<div class="lb-priv__brand-title">' + escapeHtml(sectionLabelFromGroupKey(groupKey)) + '</div>' +
        '<div class="lb-priv__grid">' +
        filled.map(function (s) { return previewCourseCard(s.listing, 'grid'); }).join('') +
        '</div></div>';
    });
    if (rest.length) {
      html += '<div class="lb-priv__brand-section">' +
        '<div class="lb-priv__brand-title">更多課程</div>' +
        '<div class="lb-priv__grid">' +
        rest.map(function (c) { return previewCourseCard(c, 'grid'); }).join('') +
        '</div></div>';
    }
    if (!html) {
      html = '<div class="lb-priv__card lb-priv__card--grid"><div class="lb-priv__card-body">' +
        '<div class="lb-priv__label">尚無可預覽內容</div>' +
        '<div class="lb-priv__meta">請先在下方版位選課或填寫公告文字後儲存，再重新整理真頁預覽。</div></div></div>';
    }
    body.innerHTML =
      '<div class="lb-priv__brand-section">' +
        '<div class="lb-priv__brand-title">廠商專屬頁預覽</div>' +
        '<div class="lb-priv__meta">資格限定・專屬頁</div>' +
      '</div>' + html;
    initPreviewCarousels(body);
  }

  async function loadPrivatePageLivePreview(force) {
    var wrap = $('lb-v2-private-page-live-preview');
    var body = $('lb-v2-private-page-live-preview-body');
    var slug = getListingVendorSlug();
    if (!wrap || !body || !slug) return;
    if (privatePagePlacementCache.livePreviewLoaded && !force) return;
    body.innerHTML = '<p class="lb-v2-muted">載入真頁預覽…</p>';
    try {
      var res = await fetchAppProxy(PATHS.privatePagePlacementsPreview, slug);
      if (res.ok) {
        var pl = res.payload || res;
        renderPrivatePageLivePreview(pl);
        privatePagePlacementCache.livePreviewLoaded = true;
      } else {
        body.innerHTML = '<p class="lb-v2-muted">' + escapeHtml(res.message || '真頁預覽載入失敗') + '</p>';
      }
    } catch (err) {
      body.innerHTML = '<p class="lb-v2-muted">' + escapeHtml(err.message || '真頁預覽載入失敗') + '</p>';
    }
  }

  function setPrivatePagePreviewMode(mode) {
    var next = mode === 'live' ? 'live' : 'wireframe';
    privatePagePlacementCache.previewMode = next;
    var wire = $('lb-v2-private-page-wireframe');
    var live = $('lb-v2-private-page-live-preview');
    if (wire) wire.hidden = next !== 'wireframe';
    if (live) live.hidden = next !== 'live';
    document.querySelectorAll('[data-page-preview-mode]').forEach(function (btn) {
      var on = btn.getAttribute('data-page-preview-mode') === next;
      btn.classList.toggle('lb-v2-btn--accent', on);
      btn.classList.toggle('lb-v2-btn--ghost', !on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    if (next === 'wireframe') renderPrivatePageWireframe();
    else loadPrivatePageLivePreview(false);
  }

  function bindPrivatePagePreviewEvents() {
    if (privatePagePreviewEventsBound) return;
    privatePagePreviewEventsBound = true;
    document.querySelectorAll('[data-page-preview-mode]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPrivatePagePreviewMode(btn.getAttribute('data-page-preview-mode'));
      });
    });
  }

  function placementSaveBarHtml() {
    return (
      '<div class="lb-v2-page-save-bar">' +
        '<span class="lb-v2-page-save-bar__hint" data-page-dirty-hint>尚未變更</span>' +
        '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-btn--muted" data-page-placements-save disabled>儲存全部</button>' +
      '</div>'
    );
  }

  function normalizePlacementTitle(v) {
    return String(v == null ? '' : v).trim();
  }

  function normalizePlacementListingId(v) {
    if (v == null || v === '') return null;
    var n = Number(v);
    return isFinite(n) && n > 0 ? n : null;
  }

  function isPrivatePagePlacementDirty() {
    var draft = readPlacementDraftFromDom();
    var saved = {};
    (privatePagePlacementCache.placements || []).forEach(function (p) {
      saved[p.slot_key] = p;
    });
    var slots = privatePagePlacementCache.slots || [];
    for (var i = 0; i < slots.length; i++) {
      var key = slots[i].slot_key;
      var d = draft[key] || {};
      var s = saved[key] || {};
      if (normalizePlacementListingId(d.listing_id) !== normalizePlacementListingId(s.listing_id)) return true;
      if (normalizePlacementTitle(d.shelf_title) !== normalizePlacementTitle(s.shelf_title)) return true;
    }
    return false;
  }

  function isPrivatePageTabDirty() {
    return isPrivatePagePlacementDirty() || isPrivateLearnerSurfaceDirty();
  }

  function privatePageSaveRoots() {
    return [
      $('lb-v2-private-page-save-bar'),
      $('lb-v2-private-page-slots')
    ].filter(Boolean);
  }

  function syncPrivatePageSaveButtons() {
    var dirty = isPrivatePageTabDirty();
    privatePageSaveRoots().forEach(function (host) {
      host.querySelectorAll('[data-page-placements-save]').forEach(function (btn) {
        btn.disabled = !dirty || savePlacementInFlight;
        btn.classList.toggle('lb-v2-btn--accent', dirty && !savePlacementInFlight);
        btn.classList.toggle('lb-v2-btn--muted', !dirty || savePlacementInFlight);
        btn.textContent = savePlacementInFlight ? '儲存中…' : '儲存全部';
      });
      host.querySelectorAll('[data-page-dirty-hint]').forEach(function (el) {
        el.textContent = dirty ? '有未儲存變更' : '尚未變更';
        el.classList.toggle('is-dirty', dirty);
      });
    });
  }

  var privatePageTopSaveBound = false;
  function bindPrivatePageTopSaveBar() {
    if (privatePageTopSaveBound) return;
    privatePageTopSaveBound = true;
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-page-placements-save]');
      if (!btn) return;
      ev.preventDefault();
      saveAllPrivatePagePlacements();
    });
  }

  function privatePageSaveNoticeEl() {
    return $('lb-v2-private-page-save-notice') || $('lb-v2-private-page-notice');
  }

  function renderPrivatePagePlacements(slots, placements, listings) {
    var host = $('lb-v2-private-page-slots');
    if (!host) return;
    slots = slots || [];
    privatePagePlacementCache.slots = slots;
    privatePagePlacementCache.placements = placements || [];
    privatePagePlacementCache.listings = listings || [];
    bindPrivatePagePreviewEvents();

    if (!slots.length) {
      host.innerHTML = '<p class="lb-v2-muted">尚未設定版型藍圖。</p>';
      renderPrivatePageWireframe();
      return;
    }
    var bySlot = {};
    (placements || []).forEach(function (p) { bySlot[p.slot_key] = p; });

    var grouped = groupSlotsByType(slots);
    var html = placementSaveBarHtml();
    html += '<div class="lb-v2-page-slots-grid">';
    grouped.order.forEach(function (groupKey) {
      var type = sectionTypeFromGroupKey(groupKey);
      var rowItems = grouped.groups[groupKey];
      var isShelf = type === 'SHELF_SCROLL';
      var isText = (type === 'NOTICE_BANNER' || type === 'CALENDAR_EMBED');
      var layout =
        type === 'HERO_CAROUSEL' ? 'hero' :
        type === 'FEATURED' ? 'featured' :
        isShelf ? 'shelf' :
        type === 'COURSE_CARD' ? 'grid' :
        type === 'NOTICE_BANNER' ? 'notice' :
        type === 'CALENDAR_EMBED' ? 'calendar' :
        'text';
      var shelfTitle = '';
      var shelfTitleSlot = '';
      if (isShelf && rowItems.length) {
        shelfTitleSlot = rowItems[0].slot_key;
        for (var ti = 0; ti < rowItems.length; ti++) {
          var tp = bySlot[rowItems[ti].slot_key];
          if (tp && tp.shelf_title) { shelfTitle = tp.shelf_title; break; }
        }
      }
      html += '<section class="lb-v2-page-slots-section lb-v2-page-slots-section--' + layout + '">';
      html += '<header class="lb-v2-page-slots-section__head">' +
        '<h4 class="lb-v2-page-slots-section__title">' +
        escapeHtml(sectionLabelFromGroupKey(groupKey)) + '</h4>';
      if (isShelf && shelfTitleSlot) {
        html += '<label class="lb-v2-page-slots-section__field">' +
          '<span class="lb-v2-page-slots-section__field-label">系列標題（顯示於區塊最上方）</span>' +
          '<input type="text" class="lb-v2-input" data-shelf-title-slot="' +
          escapeHtml(shelfTitleSlot) + '" maxlength="128" value="' +
          escapeHtml(shelfTitle) + '" placeholder="例：本週推薦">' +
          '</label>';
      }
      if (type === 'NOTICE_BANNER') {
        html += '<p class="lb-v2-page-slots-section__hint">學員專屬頁最上方公告</p>';
      }
      if (type === 'CALENDAR_EMBED') {
        html += '<p class="lb-v2-page-slots-section__hint">置於主打課程與系列之間（頁面中段）</p>';
      }
      html += '</header><div class="lb-v2-page-slots-section__body"><div class="lb-v2-page-slots-cards">';
      rowItems.forEach(function (s) {
        var p = bySlot[s.slot_key] || {};
        var human = slotHumanLabel(s.slot_key, type);
        html += '<div class="lb-v2-page-slot-card" data-slot="' + escapeHtml(s.slot_key) + '">';
        html += '<label class="lb-v2-page-slot-card__label">' + escapeHtml(human) +
          '<span class="lb-v2-page-slot-row__code">' + escapeHtml(s.slot_key) + '</span></label>';
        if (isText) {
          html += '<input type="text" class="lb-v2-input" data-slot-title maxlength="128" value="' +
            escapeHtml(p.shelf_title || '') + '" placeholder="文字內容（留白則不顯示）">';
        } else {
          html += '<select class="lb-v2-input" data-slot-listing>' +
            placeableOptionsHtml(listings, p.listing_id) + '</select>';
        }
        html += '</div>';
      });
      html += '</div></div></section>';
    });
    html += '</div>';
    html += placementSaveBarHtml();
    host.innerHTML = html;
    bindPrivatePageTopSaveBar();

    host.querySelectorAll('[data-slot-listing]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        renderPrivatePageWireframe();
        syncPrivatePageSaveButtons();
      });
    });
    host.querySelectorAll('[data-slot-title], [data-shelf-title-slot]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        renderPrivatePageWireframe();
        syncPrivatePageSaveButtons();
      });
    });

    syncPrivatePageSaveButtons();
    setPrivatePagePreviewMode(privatePagePlacementCache.previewMode || 'wireframe');
  }

  async function loadPrivatePagePlacements(slug) {
    slug = slug || getListingVendorSlug();
    var host = $('lb-v2-private-page-slots');
    if (!host || !slug) return false;
    bindPrivatePageTopSaveBar();
    host.innerHTML = '<p class="lb-v2-muted">載入中…</p>';
    var wire = $('lb-v2-private-page-wireframe');
    if (wire) wire.innerHTML = '<p class="lb-v2-muted">載入中…</p>';
    privatePagePlacementCache.livePreviewLoaded = false;
    try {
      var res = await fetchAppProxy(PATHS.privatePagePlacements, slug);
      if (res.ok) {
        var pl = res.payload || {};
        var surface = normalizeLearnerSurface(pl.learner_surface || defaultLearnerSurface());
        privatePagePlacementCache.surfaceSaved = cloneLearnerSurface(surface);
        privatePagePlacementCache.surfaceDraft = cloneLearnerSurface(surface);
        renderPrivatePageSurfaceControls();
        renderPrivatePagePlacements(pl.slots || [], pl.placements || [], pl.listings || []);
        syncPrivatePageSaveButtons();
        hideNotice($('lb-v2-private-page-notice'));
        if (privatePagePlacementCache.previewMode === 'live') {
          loadPrivatePageLivePreview(true);
        }
        return true;
      }
      host.innerHTML = '';
      if (wire) wire.innerHTML = '';
      showNotice($('lb-v2-private-page-notice'), res.message || '專屬頁排版載入失敗');
      return false;
    } catch (err) {
      host.innerHTML = '';
      if (wire) wire.innerHTML = '';
      showNotice($('lb-v2-private-page-notice'), err.message || '載入失敗');
      return false;
    }
  }

  var savePlacementInFlight = false;
  async function saveAllPrivatePagePlacements() {
    var notice = privatePageSaveNoticeEl();
    var slug = getListingVendorSlug();
    if (!slug) { showNotice(notice, '請先選擇單一廠商'); return; }
    if (savePlacementInFlight) return;
    if (!isPrivatePageTabDirty()) {
      showNotice(notice, '沒有需要儲存的變更');
      return;
    }
    savePlacementInFlight = true;
    syncPrivatePageSaveButtons();
    showNotice(notice, '儲存中…');
    var draft = readPlacementDraftFromDom();
    var slots = privatePagePlacementCache.slots || [];
    var okCount = 0;
    var failMsg = '';
    var surfaceWasDirty = isPrivateLearnerSurfaceDirty();
    var placementsWereDirty = isPrivatePagePlacementDirty();
    var surfaceSavedOk = false;
    try {
      if (surfaceWasDirty) {
        var surfaceDraft = normalizeLearnerSurface(privatePagePlacementCache.surfaceDraft);
        var surfaceRes = await postAppProxyJson(PATHS.privateLearnerSurfaceUpsert, {
          vendor_slug: slug,
          show_brand_page: surfaceDraft.show_brand_page,
          show_schedule: surfaceDraft.show_schedule,
          default_layer: surfaceDraft.default_layer,
          schedule_card_fields: surfaceDraft.schedule_card_fields,
          wall_tagline: surfaceDraft.wall_tagline || '',
          eligibility_reason_hint: surfaceDraft.eligibility_reason_hint || ''
        });
        if (!surfaceRes.ok) {
          var se = extractApiError(surfaceRes);
          showNotice(
            notice,
            se.code ? '[' + se.code + '] ' + se.message : (se.message || '學員端呈現儲存失敗')
          );
          return;
        }
        privatePagePlacementCache.surfaceSaved = cloneLearnerSurface(
          (surfaceRes.payload && surfaceRes.payload.learner_surface) || surfaceDraft
        );
        privatePagePlacementCache.surfaceDraft = cloneLearnerSurface(
          privatePagePlacementCache.surfaceSaved
        );
        surfaceSavedOk = true;
        renderPrivatePageSurfaceControls();
      }

      if (placementsWereDirty) {
        for (var i = 0; i < slots.length; i++) {
          var key = slots[i].slot_key;
          var d = draft[key] || {};
          var res = await postAppProxyJson(PATHS.privatePagePlacementUpsert, {
            vendor_slug: slug,
            slot_key: key,
            listing_id: normalizePlacementListingId(d.listing_id),
            shelf_title: normalizePlacementTitle(d.shelf_title) || null,
          });
          if (!res.ok) {
            var e = extractApiError(res);
            failMsg = e.code ? '[' + e.code + '] ' + e.message : (e.message || '儲存失敗');
            failMsg += '（' + key + '）';
            break;
          }
          okCount += 1;
        }
        if (failMsg) {
          showNotice(notice,
            (surfaceSavedOk ? '學員端呈現已儲存。' : '') +
            '版位已儲存 ' + okCount + '/' + slots.length + '，中斷：' + failMsg);
          await loadPrivatePagePlacements(slug);
          return;
        }
        privatePagePlacementCache.placements = slots.map(function (s) {
          var d2 = draft[s.slot_key] || {};
          return {
            slot_key: s.slot_key,
            listing_id: normalizePlacementListingId(d2.listing_id),
            shelf_title: normalizePlacementTitle(d2.shelf_title) || null
          };
        });
      }

      var msgs = [];
      if (surfaceSavedOk) msgs.push('學員端呈現');
      if (placementsWereDirty) msgs.push('版位 ' + okCount + ' 項');
      showNotice(
        notice,
        msgs.length ? ('已儲存：' + msgs.join('、')) : '已儲存'
      );
      renderPrivatePageWireframe();
      privatePagePlacementCache.livePreviewLoaded = false;
      if (privatePagePlacementCache.previewMode === 'live') {
        loadPrivatePageLivePreview(true);
      }
      syncPrivatePageSaveButtons();
    } catch (err) {
      showNotice(notice, err.message || '儲存失敗');
    } finally {
      savePlacementInFlight = false;
      syncPrivatePageSaveButtons();
    }
  }

  async function loadPrivateEligibilityTab(forceReload) {
    await LbV2.ensureChunk('private');
    bindPrivateEligibilityTabEvents();
    ensureEligibilityDateTimePickers();
    if (!beginTabLoad('private-eligibility', forceReload)) return;
    var slug = getListingVendorSlug();
    var notice = eligNoticeEl();
    if (!slug) {
      showNotice(notice, '請先選擇單一廠商');
      return;
    }
    hideNotice(notice);
    setDataLoading(true);
    try {
      var bundle = await Promise.all([
        loadFeeEntitlement(slug).catch(function () { return null; }),
        fetchAppProxy(PATHS.privateEligibilityList, slug),
        fetchAppProxy(PATHS.privateImportBatches, slug),
        fetchAppProxy(PATHS.privateEligibilityRequestList, slug),
      ]);
      if (bundle[1].ok) {
        renderPrivateEligibility((bundle[1].payload && bundle[1].payload.items) || []);
      } else {
        renderPrivateEligibility([]);
        showNotice(notice, bundle[1].message || '通行證載入失敗');
      }
      if (bundle[2].ok) {
        renderPrivateImportBatches((bundle[2].payload && bundle[2].payload.items) || [], {
          hostId: 'lb-v2-private-elig-import-batches',
          typeFilter: 'ELIGIBILITY',
        });
      } else {
        renderPrivateImportBatches([], {
          hostId: 'lb-v2-private-elig-import-batches',
          typeFilter: 'ELIGIBILITY',
        });
      }
      if (bundle[3].ok) {
        privateEligReqGrantExpiresAt =
          (bundle[3].payload && bundle[3].payload.grant_expires_at) || null;
        syncPrivateEligGrantNote();
        renderPrivateEligibilityRequests((bundle[3].payload && bundle[3].payload.items) || []);
      } else {
        privateEligReqGrantExpiresAt = null;
        syncPrivateEligGrantNote();
        renderPrivateEligibilityRequests([]);
        if (bundle[3].message) {
          showNotice(notice, bundle[3].message || '申請列表載入失敗');
        }
      }
      markTabCache('private-eligibility');
    } catch (err) {
      showNotice(notice, err.message || '載入失敗');
    } finally {
      setDataLoading(false);
    }
  }

  // ── Fee purchase + entitlement ─────────────────────────────

  var cachedFeePlans = {};
  var cachedEntitlement = null;
  /** Survives「全部」mode clearing entitlement — nav hide / closing badge. */
  var cachedModuleDisabled = {
    EXPOSURE: false,
    PROMO: false,
    FULL: false,
    PRIVATE: false,
  };
  var cachedModuleCanSubmit = {
    EXPOSURE: false,
    PROMO: false,
    FULL: false,
    PRIVATE: false,
  };
  var MODULE_NAV_MODES = ['EXPOSURE', 'PROMO', 'FULL', 'PRIVATE'];

  function clearModuleCanSubmitCache() {
    MODULE_NAV_MODES.forEach(function (mode) {
      cachedModuleCanSubmit[mode] = false;
    });
  }

  function clearModuleDisabledCache() {
    MODULE_NAV_MODES.forEach(function (mode) {
      cachedModuleDisabled[mode] = false;
    });
  }

  function rememberModuleDisabledFromEntitlement(ent) {
    // Reset both flags first — never inherit another vendor's leftover quota/state.
    clearModuleCanSubmitCache();
    clearModuleDisabledCache();
    if (!ent || !ent.modes) return;
    (ent.modes || []).forEach(function (m) {
      var mode = String(m.listing_mode || '').toUpperCase();
      if (!mode) return;
      cachedModuleDisabled[mode] = m.module_enabled === false;
      cachedModuleCanSubmit[mode] = !!m.can_submit;
    });
  }

  /** ALL view: OR module_enabled===false across a few vendors (not only activeVendors[0]). */
  async function probeModuleDisabledForAllView() {
    clearModuleCanSubmitCache();
    clearModuleDisabledCache();
    var slugs = (activeVendors || []).slice(0, 8);
    var probed = await fetchFeeEntitlementBatch(slugs);
    if (!probed) {
      probed = await mapPool(slugs, 4, async function (slug) {
        try { return await fetchFeeEntitlementRaw(slug); } catch (e) { return null; }
      });
    }
    // rememberModuleDisabledFromEntitlement() resets both caches, so folding must
    // stay in slug order even though the fetches above no longer are.
    probed.forEach(function (ent) {
      if (!ent) return;
      cachedEntitlement = ent;
      rememberModuleDisabledFromEntitlement(ent);
      (ent.modes || []).forEach(function (m) {
        var mode = String(m.listing_mode || '').toUpperCase();
        if (!mode) return;
        if (m.module_enabled === false) cachedModuleDisabled[mode] = true;
      });
    });
    clearModuleCanSubmitCache();
    cachedEntitlement = null;
    clearFeeEntitlementTtlCache();
  }
  var feePurchaseBound = false;

  function modeLabel(mode) {
    if (mode === 'PRIVATE') return '資格限定課';
    if (mode === 'PROMO') return '宣傳刊登（不含金流）';
    if (mode === 'EXPOSURE') return '純上架';
    if (mode === 'FULL') return '宣傳刊登（含金流）';
    return mode || '—';
  }

  function formatDateTw(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString('zh-TW'); } catch (e) { return String(iso); }
  }

  function isOfficialFeeExemptVendor() {
    return !!(cachedEntitlement && cachedEntitlement.official_fee_exempt);
  }

  /** Admin「Portal：廣告版位加購」整塊開關；缺欄位視為開啟（相容舊 API）。 */
  function isSlotAddonPurchaseEnabled() {
    if (!cachedEntitlement) return true;
    if (typeof cachedEntitlement.slot_addon_purchase_enabled === 'boolean') {
      return cachedEntitlement.slot_addon_purchase_enabled !== false;
    }
    return true;
  }

  /**
   * 這支旗標**只**收起「營運結帳」的廣告方案區（renderFeePurchase 判斷）。
   * 課程廣告刊登第 2 步是購買主路徑，永遠可買——不可再依這支旗標隱藏或鎖住，
   * 後端也已經不拿它擋 hold／claim／fee-order。
   */
  function syncSlotAddonPurchaseUi() {
    try {
      document.querySelectorAll('.lb-v2-ads-buy-more').forEach(function (el) {
        el.hidden = false;
        el.classList.remove('is-addon-purchase-closed');
        var actions = el.querySelector('.lb-v2-listing-actions');
        if (actions) actions.hidden = false;
      });
    } catch (e) { /* ignore */ }
  }

  function findModeEntitlement(mode) {
    if (!cachedEntitlement || !cachedEntitlement.modes) return null;
    for (var i = 0; i < cachedEntitlement.modes.length; i++) {
      if (cachedEntitlement.modes[i].listing_mode === mode) return cachedEntitlement.modes[i];
    }
    return null;
  }

  function canSubmitForMode(mode) {
    var key = String(mode || '').toUpperCase();
    // Prefer live entitlement for the selected vendor; cache is only a fallback
    // after probe / before paint — never mix vendors.
    if (cachedEntitlement && cachedEntitlement.modes) {
      var live = findModeEntitlement(key);
      return !!(live && live.can_submit);
    }
    return !!cachedModuleCanSubmit[key];
  }

  function isFullServiceEnabled() {
    if (!cachedEntitlement) return false;
    if (typeof cachedEntitlement.full_service_enabled === 'boolean') {
      return cachedEntitlement.full_service_enabled;
    }
    var rate = cachedEntitlement.fee_rate;
    return rate != null && rate !== '' && !isNaN(Number(rate));
  }

  function getModeOpen(mode) {
    var m = String(mode || '').toUpperCase();
    if (m === 'FULL') {
      return isFullServiceEnabled() && canSubmitForMode('FULL');
    }
    return canSubmitForMode(m);
  }

  /**
   * 結算明細可看（不需目前 can_submit）：
   * - FULL：主檔有手續費率
   * - PRIVATE：有手續費率，且年約曾／已核准（entitlement.private_year_ever）
   * 上架／送審仍走 getModeOpen。
   */
  function hasPrivateYearEverApproved() {
    if (!cachedEntitlement) return false;
    if (typeof cachedEntitlement.private_year_ever === 'boolean') {
      return cachedEntitlement.private_year_ever;
    }
    // 舊 API fallback：目前有 ACTIVE 年約，或 recent_grants 出現過 PRIVATE DURATION
    var mode = findModeEntitlement('PRIVATE');
    if (mode && mode.has_duration) return true;
    var grants = cachedEntitlement.recent_grants || [];
    for (var i = 0; i < grants.length; i++) {
      var g = grants[i];
      if (String(g.listing_mode || '').toUpperCase() === 'PRIVATE' &&
          String(g.plan_type || '').toUpperCase() === 'DURATION') {
        return true;
      }
    }
    return false;
  }

  function canViewSettlement(mode) {
    var m = String(mode || '').toUpperCase();
    if (m !== 'FULL' && m !== 'PRIVATE') return false;
    if (isAllMode() || !vendorMode) return false;
    if (!isFullServiceEnabled()) return false;
    if (m === 'PRIVATE') return hasPrivateYearEverApproved();
    return true;
  }

  function setModeGroupLock(groupEl, locked, reason) {
    if (!groupEl) return;
    groupEl.hidden = false;
    groupEl.removeAttribute('hidden');
    groupEl.setAttribute('aria-hidden', 'false');
    groupEl.classList.toggle('is-mode-locked', !!locked);
    groupEl.setAttribute('data-mode-locked', locked ? '1' : '0');
    groupEl.setAttribute('data-lock-reason', locked ? (reason || '尚未開通') : '');
    var badge = groupEl.querySelector('.lb-v2-mode-lock-badge');
    if (badge) {
      badge.hidden = !locked;
      badge.textContent = reason || '尚未開通';
      badge.title = groupEl.getAttribute('data-lock-reason') || reason || '尚未開通';
    }
    groupEl.querySelectorAll('.lb-v2-tab').forEach(function (tabBtn) {
      // Mode lock applies to all tabs in group; role lock layered later.
      if (locked) {
        tabBtn.classList.add('is-mode-locked');
        tabBtn.setAttribute('aria-disabled', 'true');
        tabBtn.title = groupEl.getAttribute('data-lock-reason') || reason || '尚未開通';
      } else {
        tabBtn.classList.remove('is-mode-locked');
        if (!tabBtn.classList.contains('is-role-locked')) {
          tabBtn.removeAttribute('aria-disabled');
          tabBtn.removeAttribute('title');
        }
      }
    });
  }

  function setTabRoleLock(tabBtn, locked, reason) {
    if (!tabBtn) return;
    tabBtn.classList.toggle('is-role-locked', !!locked);
    if (locked) {
      tabBtn.setAttribute('aria-disabled', 'true');
      tabBtn.title = reason || '此角色不可用';
    } else if (!tabBtn.classList.contains('is-mode-locked')) {
      tabBtn.removeAttribute('aria-disabled');
      tabBtn.removeAttribute('title');
    }
  }

  function applyStaffSharedTabLocks(forceLock) {
    var role = getSelectedVendorRole();
    var feeTab = root.querySelector('.lb-v2-tab[data-tab="checkout"]');
    if (!feeTab) return;
    // Clear then re-apply: staff cannot open 營運結帳
    setTabRoleLock(feeTab, false, '');
    if (forceLock) return;
    if (role === 'staff') {
      setTabRoleLock(feeTab, true, '此角色不可用（工作人員）');
    }
  }

  function applyPrivateTabLocks(privateOpen, forceLock) {
    var role = getSelectedVendorRole();
    var canApply = canManagePrivateVendorAdminRole(role);
    var reasonRole = '此角色不可用（工作人員）';
    var reasonMode = '尚未開通';

    root.querySelectorAll('#lb-v2-tab-group-private .lb-v2-tab').forEach(function (tabBtn) {
      var tab = tabBtn.getAttribute('data-tab') || '';
      // Clear prior locks; re-apply below.
      tabBtn.classList.remove('is-mode-locked', 'is-role-locked');
      tabBtn.removeAttribute('aria-disabled');
      tabBtn.removeAttribute('title');

      if (forceLock) {
        tabBtn.classList.add('is-mode-locked');
        tabBtn.setAttribute('aria-disabled', 'true');
        tabBtn.title = '請先選擇單一廠商';
        return;
      }

      // 申請：owner/admin 即使尚未開通年約也可進入補件／送審
      if (tab === 'private') {
        if (!canApply) {
          setTabRoleLock(tabBtn, true, reasonRole);
        }
        return;
      }

      if (!privateOpen) {
        tabBtn.classList.add('is-mode-locked');
        tabBtn.setAttribute('aria-disabled', 'true');
        tabBtn.title = reasonMode;
        return;
      }

      if (role === 'staff' && isStaffPrivateAdminTab(tab)) {
        setTabRoleLock(tabBtn, true, reasonRole);
      }
    });
  }

  var MODULE_CLOSING_BADGE = '已停售・可消化額度';
  var MODULE_CLOSING_TITLE =
    '此模組已由官方關閉，不可再購買；既有額度可送審至用完或到期，之後入口會隱藏。';

  function applyModuleClosingBadge(groupEl, closing) {
    if (!groupEl) return;
    groupEl.classList.toggle('is-module-closing', !!closing);
    if (!closing) return;
    var badge = groupEl.querySelector('.lb-v2-mode-lock-badge');
    if (!badge) return;
    badge.hidden = false;
    badge.textContent = MODULE_CLOSING_BADGE;
    badge.title = MODULE_CLOSING_TITLE;
  }

  /**
   * Grey mode groups that are not entitled for the selected vendor.
   * Closed + no quota → hide. Closed + remaining quota → show with closing badge.
   * 「全部」never shows closing/quota — pick a single vendor first.
   */
  function applyTabNavByCapability(opts) {
    var lockAllModes = !!(opts && opts.lockAllModes);
    var noEntitlement = !cachedEntitlement;
    var allMode = isAllMode() || !vendorMode;

    // ALL / no vendor / load failure: lock mode ops so users pick a single vendor first.
    var forceLock = lockAllModes || allMode || noEntitlement;

    var exposureOpen = forceLock ? false : getModeOpen('EXPOSURE');
    var fullOpen = forceLock ? false : getModeOpen('FULL');
    var privateOpen = forceLock ? false : getModeOpen('PRIVATE');
    // ALL view: closed modules stay hidden (quota is per-vendor).
    var hideExposure =
      isModuleDisabled('EXPOSURE') &&
      (allMode || !canSubmitForMode('EXPOSURE'));
    var hideFull =
      isModuleDisabled('FULL') && (allMode || !canSubmitForMode('FULL'));
    var hidePrivate =
      isModuleDisabled('PRIVATE') && (allMode || !canSubmitForMode('PRIVATE'));
    var closingExposure =
      !allMode && isModuleDisabled('EXPOSURE') && canSubmitForMode('EXPOSURE');
    var closingFull =
      !allMode && isModuleDisabled('FULL') && canSubmitForMode('FULL');
    var closingPrivate =
      !allMode && isModuleDisabled('PRIVATE') && canSubmitForMode('PRIVATE');

    var needVendor = forceLock && (allMode || !vendorMode);
    // Compact badge copy (full sentence stays on tab title / data-lock-reason).
    var lockReason = forceLock
      ? (needVendor ? '請先選廠商' : '尚未開通')
      : '尚未開通';
    var lockTitle = forceLock
      ? (needVendor ? '請先選擇單一廠商' : '尚未開通')
      : '尚未開通';

    var exposureGroup = $('lb-v2-tab-group-exposure');
    var fullGroup = $('lb-v2-tab-group-full');
    if (hideExposure) {
      if (exposureGroup) {
        exposureGroup.hidden = true;
        exposureGroup.setAttribute('hidden', '');
        exposureGroup.setAttribute('aria-hidden', 'true');
        exposureGroup.classList.remove('is-module-closing');
      }
    } else {
      if (exposureGroup) {
        exposureGroup.setAttribute('data-lock-reason', !exposureOpen ? lockTitle : '');
      }
      setModeGroupLock(exposureGroup, !exposureOpen && !closingExposure, lockReason);
      applyModuleClosingBadge(exposureGroup, closingExposure);
    }
    // 營運「宣傳刊登（含金流）結算明細」：符合可看條件才出現（不灰鎖、不佔位）。
    var settleFullOpen = forceLock ? false : canViewSettlement('FULL');
    if (fullGroup) {
      fullGroup.classList.remove('is-mode-locked', 'is-module-closing');
      fullGroup.removeAttribute('data-mode-locked');
      fullGroup.setAttribute('data-lock-reason', '');
      var fullSettleBtn = fullGroup.querySelector('.lb-v2-tab, .lb-v2-subnav__item');
      if (fullSettleBtn) {
        fullSettleBtn.classList.remove('is-mode-locked', 'is-role-locked');
        fullSettleBtn.removeAttribute('aria-disabled');
        fullSettleBtn.removeAttribute('title');
      }
      if (settleFullOpen) {
        fullGroup.hidden = false;
        fullGroup.removeAttribute('hidden');
        fullGroup.setAttribute('aria-hidden', 'false');
      } else {
        fullGroup.hidden = true;
        fullGroup.setAttribute('hidden', '');
        fullGroup.setAttribute('aria-hidden', 'true');
      }
    }

    // 資格限定課：已開通／可消化額度才顯示大區塊；未開通改 header 小 CTA「資格限定課申請」。
    var privateGroup = $('lb-v2-tab-group-private');
    var showPrivateDeck = !hidePrivate && (privateOpen || closingPrivate);
    if (privateGroup) {
      if (!showPrivateDeck) {
        privateGroup.hidden = true;
        privateGroup.setAttribute('hidden', '');
        privateGroup.setAttribute('aria-hidden', 'true');
        privateGroup.classList.remove('is-module-closing', 'is-mode-locked');
      } else {
        privateGroup.hidden = false;
        privateGroup.removeAttribute('hidden');
        privateGroup.setAttribute('aria-hidden', 'false');
        privateGroup.classList.remove('is-mode-locked');
        privateGroup.setAttribute('data-mode-locked', '0');
        privateGroup.setAttribute('data-lock-reason', '');
        var badge = privateGroup.querySelector('.lb-v2-mode-lock-badge');
        if (badge && !closingPrivate) {
          badge.hidden = true;
          badge.textContent = '';
        }
        applyModuleClosingBadge(privateGroup, closingPrivate);
      }
    }
    var privateCta = $('lb-v2-private-apply-cta');
    if (privateCta) {
      var canApplyPrivate = isAllMode()
        ? true
        : canManagePrivateVendorAdminRole(getSelectedVendorRole());
      // 模組未關、尚未開通 → 右上角小按鈕；已開通則藏起來。
      var showPrivateCta = !hidePrivate && !showPrivateDeck && canApplyPrivate;
      privateCta.hidden = !showPrivateCta;
    }
    if (showPrivateDeck) applyPrivateTabLocks(true, false);
    applyStaffSharedTabLocks(forceLock);

    // 營運「結算明細（資格限定課）」：可看且非 staff 才出現。
    var privSettleGroup = $('lb-v2-tab-group-private-settlement');
    if (privSettleGroup) {
      var privSettleBtn = privSettleGroup.querySelector('.lb-v2-tab, .lb-v2-subnav__item');
      var settlePrivOpen = forceLock
        ? false
        : (canViewSettlement('PRIVATE') && getSelectedVendorRole() !== 'staff');
      privSettleGroup.classList.remove('is-mode-locked', 'is-module-closing');
      privSettleGroup.removeAttribute('data-mode-locked');
      privSettleGroup.setAttribute('data-lock-reason', '');
      if (privSettleBtn) {
        privSettleBtn.classList.remove('is-mode-locked', 'is-role-locked');
        privSettleBtn.removeAttribute('aria-disabled');
        privSettleBtn.removeAttribute('title');
      }
      if (settlePrivOpen) {
        privSettleGroup.hidden = false;
        privSettleGroup.removeAttribute('hidden');
        privSettleGroup.setAttribute('aria-hidden', 'false');
      } else {
        privSettleGroup.hidden = true;
        privSettleGroup.setAttribute('hidden', '');
        privSettleGroup.setAttribute('aria-hidden', 'true');
      }
    }

    // 子頁被鎖時退回同頁的預設子頁，不要把人踢回課程數據。
    var subFellBack = false;
    if (activeTab === 'pending-payment' && hideExposure) { manageSub = 'list'; subFellBack = true; }
    if (activeTab === 'settlement' && !canViewSettlement('FULL')) { opsSub = 'overview'; subFellBack = true; }
    if (activeTab === 'settlement-private' && (
      !canViewSettlement('PRIVATE') || getSelectedVendorRole() === 'staff'
    )) { opsSub = 'overview'; subFellBack = true; }

    // 未開通時不可留在通行證／課表／排版；申請頁可經 header CTA 進入。
    if (
      !showPrivateDeck &&
      (activeTab === 'private-eligibility' ||
        activeTab === 'private-schedule' ||
        activeTab === 'private-page')
    ) {
      switchTab('course-data');
      return;
    }

    var activeBtn = root.querySelector('.lb-v2-tab--active');
    if (activeBtn) {
      var activeModes = (activeBtn.getAttribute('data-modes') || '');
      var activeSub = activeBtn.getAttribute('data-sub') || '';
      var isSettleSub = activeSub === 'settlement' || activeSub === 'settlement-private';
      var activeHidden =
        (activeModes === 'exposure' && hideExposure) ||
        (activeModes === 'full' && hideFull && !isSettleSub) ||
        (activeModes === 'private' && hidePrivate && activeSub !== 'settlement-private');
      var gate = evaluateTabGate(
        isSettleSub ? activeSub : navToTab(activeBtn.getAttribute('data-tab') || ''),
        activeBtn
      );
      if (activeHidden || (gate && !gate.allowed)) switchTab('course-data');
      else if (subFellBack) switchTab(activeNav);
    }
  }

  function evaluateTabGate(tab, btn) {
    var tabName = String(tab || '');
    var modes = (btn && btn.getAttribute('data-modes')) || '';
    var role = getSelectedVendorRole();

    // staff：營運結帳不可用（即使 data-modes=shared）
    if ((tabName === 'fee-purchase' || tabName === 'checkout') && role === 'staff') {
      return {
        allowed: false,
        kind: 'role',
        reason: '此角色不可用（工作人員）',
        redirect: '',
      };
    }

    if (modes === 'shared' || !modes) return { allowed: true, kind: '' };

    if (isAllMode() || !vendorMode) {
      return {
        allowed: false,
        kind: 'mode',
        reason: '請先選擇單一廠商',
        redirect: '',
      };
    }

    var modeKey =
      modes === 'exposure' ? 'EXPOSURE' : modes === 'full' ? 'FULL' : modes === 'private' ? 'PRIVATE' : '';

    // 申請 tab：owner/admin 可進（補件／送審），不需已開通年約
    if (tabName === 'private') {
      if (!canManagePrivateVendorAdminRole(role)) {
        return {
          allowed: false,
          kind: 'role',
          reason: '此角色不可用（工作人員）',
          redirect: '',
        };
      }
      return { allowed: true, kind: '' };
    }

    // 結算明細：只看手續費率（結算能力），不看 can_submit
    if (tabName === 'settlement' || tabName === 'settlement-private') {
      if (isAllMode() || !vendorMode) {
        return {
          allowed: false,
          kind: 'mode',
          reason: '請先選擇單一廠商',
          redirect: '',
        };
      }
      if (tabName === 'settlement-private' && role === 'staff') {
        return {
          allowed: false,
          kind: 'role',
          reason: '此角色不可用（工作人員）',
          redirect: '',
        };
      }
      if (!canViewSettlement(tabName === 'settlement-private' ? 'PRIVATE' : 'FULL')) {
        return {
          allowed: false,
          kind: 'mode',
          reason: tabName === 'settlement-private'
            ? '資格限定課結算需年約申請通過（且主檔已設定手續費率）'
            : '尚未設定手續費率（宣傳刊登（含金流）結算需先由官方設定）',
          redirect: tabName === 'settlement-private' ? 'private' : '',
        };
      }
      return { allowed: true, kind: '' };
    }

    if (modeKey && !getModeOpen(modeKey)) {
      var redirect = '';
      if (modeKey === 'PRIVATE' && canManagePrivateVendorAdminRole(role)) {
        redirect = 'private';
      } else if (role !== 'staff') {
        redirect = 'fee-purchase';
      }
      return {
        allowed: false,
        kind: 'mode',
        reason: role === 'staff'
          ? '此模組尚未開通，請聯繫擁有者購買／申請'
          : '此模組尚未開通，可前往營運結帳／申請',
        redirect: redirect,
      };
    }

    if (modeKey === 'PRIVATE' && role === 'staff' && isStaffPrivateAdminTab(tabName)) {
      return {
        allowed: false,
        kind: 'role',
        reason: '此角色不可用（工作人員）',
        redirect: '',
      };
    }

    return { allowed: true, kind: '' };
  }

  function handleLockedTabClick(tab, gate) {
    if (gate.kind === 'mode' && gate.redirect) {
      openModal({
        title: '尚未開通',
        bodyHtml:
          '<p>' +
          escapeHtml(gate.reason || '此模組尚未開通') +
          '</p>' +
          '<p class="lb-v2-muted">將帶您前往' +
          (gate.redirect === 'private' ? '「申請」' : '「營運結帳」') +
          '。</p>',
        actions: [
          { label: '取消', ghost: true, close: true },
          {
            label: gate.redirect === 'private' ? '前往申請' : '前往營運結帳',
            accent: true,
            close: true,
            onClick: function () {
              switchTab(gate.redirect);
            },
          },
        ],
      });
      return;
    }
    if (gate.kind === 'mode') {
      openModal({
        title: '尚未開通',
        bodyHtml: '<p>' + escapeHtml(gate.reason || '此模組尚未開通') + '</p>',
        actions: [{ label: '知道了', accent: true, close: true }],
      });
      return;
    }
    openModal({
      title: '無法使用',
      bodyHtml: '<p>' + escapeHtml(gate.reason || '此角色不可用') + '</p>',
      actions: [{ label: '知道了', accent: true, close: true }],
    });
  }

  async function refreshTabNavCapability() {
    if (isAllMode() || !vendorMode) {
      // Never paint「可消化額度」in ALL; hide modes closed on any probed vendor.
      await probeModuleDisabledForAllView();
      applyTabNavByCapability({ lockAllModes: true });
      return;
    }
    // Drop previous vendor's quota before fetch — failed loads must not inherit it.
    clearModuleCanSubmitCache();
    clearModuleDisabledCache();
    try {
      await loadFeeEntitlement(vendorMode);
      rememberModuleDisabledFromEntitlement(cachedEntitlement);
      applyTabNavByCapability({ lockAllModes: false });
    } catch (e) {
      clearModuleCanSubmitCache();
      clearModuleDisabledCache();
      cachedEntitlement = null;
      clearFeeEntitlementTtlCache();
      applyTabNavByCapability({ lockAllModes: true });
    }
  }

  function renderEntitlementCards(container, compact) {
    if (!container) return;
    if (!cachedEntitlement) {
      container.innerHTML = '<p class="lb-v2-muted">尚未載入額度</p>';
      return;
    }
    var html = '<div class="lb-v2-fee-entitlement-grid">';
    var shown = 0;
    (cachedEntitlement.modes || []).forEach(function (m) {
      var moduleOff = m.module_enabled === false;
      // Closed with no quota: omit. Closed with quota: show + emphasize sunset.
      if (moduleOff && !m.can_submit) return;

      var lines = [];
      var isFullBlocked = m.listing_mode === 'FULL' && !isFullServiceEnabled();
      if (isFullBlocked) {
        lines.push('<span style="color:#a61b3f;font-weight:600;">無申請宣傳刊登（含金流）服務</span>');
        lines.push('<span class="lb-v2-muted">請聯繫官方於廠商主檔設定手續費率</span>');
      } else {
        if (moduleOff) {
          lines.push('<span style="color:#a61b3f;font-weight:800;">此模組已關閉，不可再購買新方案</span>');
          lines.push('<span style="color:#a61b3f;font-weight:700;">請盡快消化既有額度；用完或到期後此入口會隱藏。</span>');
          if (m.module_force_stopped_at) {
            lines.push('<span class="lb-v2-muted">官方已強制停售，上架中課程已下架。</span>');
          }
        }
        var balances = m.slot_balances || [];
        if (balances.length) {
          balances.forEach(function (b) {
            var planLabel = b.plan_name || (b.fee_plan_id ? ('方案 #' + b.fee_plan_id) : '未命名方案');
            var bits = [];
            if (b.has_duration) {
              bits.push('有效' + (b.duration_expires_at ? '至 ' + formatDateTw(b.duration_expires_at) : ''));
            }
            if (b.single_unused > 0) {
              bits.push('剩餘 <strong>' + b.single_unused + '</strong> 次');
            }
            if (b.slot_name) bits.push(escapeHtml(b.slot_name));
            if (bits.length) {
              lines.push('<strong>' + escapeHtml(planLabel) + '</strong> · ' + bits.join(' · '));
            }
          });
        } else {
          if (m.has_duration) {
            lines.push('包月有效' + (m.duration_expires_at ? '至 ' + formatDateTw(m.duration_expires_at) : ''));
          }
          if (m.single_unused > 0) {
            lines.push('單次剩餘 <strong>' + m.single_unused + '</strong> 次');
          }
        }
        if (!moduleOff && Number(m.pending_window_listings) > 0) {
          lines.push('已鎖定待補內容的檔期 <strong>' + m.pending_window_listings + '</strong> 檔');
        }
        // 摘要就在營運結帳頁：不提示「請到營運結帳／有免費方案可領取」。
        if (
          !moduleOff &&
          isOfficialFeeExemptVendor() &&
          (m.listing_mode === 'EXPOSURE' || m.listing_mode === 'PROMO' || m.listing_mode === 'FULL') &&
          m.can_submit
        ) {
          lines.push('官方廠商：免上架費（系統豁免，不必購買）');
        }
        if (!lines.length) {
          lines.push('<span class="lb-v2-muted">尚無可用額度</span>');
        }
      }
      shown += 1;
      html += '<div class="lb-v2-fee-entitlement-card' +
        (m.can_submit ? ' is-ok' : ' is-empty') +
        (moduleOff ? ' is-closing' : '') + '">' +
        '<div class="lb-v2-fee-entitlement-mode">' + escapeHtml(modeLabel(m.listing_mode)) + '</div>' +
        '<div class="lb-v2-fee-entitlement-body">' + lines.join('<br>') + '</div>' +
        '<div class="lb-v2-fee-entitlement-flag' +
          (isFullBlocked ? ' is-blocked' : (m.can_submit ? ' is-ok' : ' is-need')) + '">' +
          (isFullBlocked
            ? '不可購買'
            : (m.can_submit
              ? (moduleOff ? '✓ 可送審（已關閉）' : '✓ 可送審')
              : '需購買')) +
        '</div>' +
        '</div>';
    });
    html += '</div>';
    if (!shown) {
      html = '<p class="lb-v2-muted">目前沒有可顯示的額度</p>';
    } else if (!compact && isOfficialFeeExemptVendor()) {
      html += '<p class="lb-v2-hint" style="margin-top:0.65rem;">官方廠商可直接至「上架新課程」選方案或版位送審，免購買上架費用；模組關閉時仍不可新上。</p>';
    } else if (!compact && !cachedEntitlement.can_submit_any) {
      html += '<p class="lb-v2-hint" style="margin-top:0.65rem;">購買下方方案並完成付款後，額度會自動開通（需已完成 LadyBae 設定）。額度綁定方案所屬版位，不可跨版位挪用。</p>';
    }
    container.innerHTML = html;
  }

  function grantRefundInfo(g) {
    return (g && g.refund) || {};
  }

  function grantRefundPending(g) {
    return !!(g && g.refund_request_at && !g.refund_request_resolved_at);
  }

  function grantRefundResolution(g) {
    return String((g && g.refund_request_resolution) || '').toUpperCase();
  }

  /**
   * 退款已送出但結果未確認（逾時／斷線）。錢有沒有動只有 Shopify 那側知道，
   * 後端在對完帳之前會擋掉撤回與重送，這裡也要收起入口，不然廠商只會白按。
   */
  function grantRefundInFlight(g) {
    return String((g && g.refund_shopify_state) || '').toUpperCase() === 'IN_FLIGHT';
  }

  /**
   * 錢已經退出去、申請卻還沒結案（退款成功但釋放檔期那步失敗）。撤回會把這筆從
   * 官方待辦上抹掉，錢退了、檔期還鎖著就沒人會發現，所以入口收起來只能等官方結案
   * （後端同樣擋，回 REFUND_ALREADY_PAID）。
   */
  function grantRefundAlreadyPaid(g) {
    if (!g) return false;
    if (String(g.shopify_refund_id || '').trim()) return true;
    var state = String(g.refund_shopify_state || '').toUpperCase();
    return state === 'SUCCEEDED' || state === 'MANUAL';
  }

  function formatMoneyTw(value) {
    var n = Number(value || 0);
    if (!isFinite(n)) n = 0;
    return 'NT$' + n.toLocaleString('zh-TW');
  }

  /**
   * 營運結帳紀錄「狀態」純顯示映射（不改 grant 核心）。
   * 優先序：已退款／已取消 → 退訂處理中 → 已過期 → 已上架 → 待上架 → 待審核 → 未使用
   * 草稿／退件／解套後／審核中 → 待審核（產品定稿）。
   */
  function grantHistoryStatusLabel(g) {
    var grantStatus = String((g && g.status) || '').toUpperCase();
    if (grantStatus === 'RELEASED') {
      var refunded = g && g.refund_amount;
      // 舊資料是官方手動釋放，沒有金額紀錄，維持原本的「已退款」文案
      if (refunded == null || refunded === '') return '已退款';
      return Number(refunded) > 0 ? '已退款' : '已取消';
    }
    if (grantRefundPending(g)) return '退訂處理中';

    var today = todayYmdTw();
    var endYmd = ymd(g && g.exposure_end_at);
    if (!endYmd && String((g && g.plan_type) || '').toUpperCase() === 'DURATION') {
      endYmd = ymd(g && g.expires_at);
    }
    if (grantStatus === 'EXPIRED') return '已過期';
    if (endYmd && today && endYmd < today) return '已過期';

    if (!(g && g.listing_id)) return '未使用';

    var listingStatus = String((g && g.listing_status) || '').toUpperCase();
    var startYmd = ymd(g && g.exposure_start_at);

    if (listingStatus === 'PUBLISHED') {
      if (startYmd && today && today < startYmd) return '待上架';
      return '已上架';
    }
    if (listingStatus === 'APPROVED') return '待上架';
    // 曾上架後下架、檔期未過：仍算已走完上架路徑
    if (listingStatus === 'UNPUBLISHED') return '已上架';

    // DRAFT／REJECTED／PENDING_REVIEW／缺 listing_status → 待審核
    return '待審核';
  }

  /**
   * New Customer Accounts 訂單頁（可退貨／退訂）。
   * 例：https://account.ladybaeshop.com/orders/7266154021093
   * 勿用 storefront /account/orders/{id}（只會落到帳號首頁）。
   */
  function grantAccountOrderHref(g) {
    var raw = String((g && g.shopify_order_id) || '').trim();
    if (!raw) return '';
    var m = raw.match(/gid:\/\/shopify\/Order\/(\d+)/i) || raw.match(/^(\d+)$/);
    var id = m ? m[1] : '';
    if (!id) {
      m = raw.match(/(\d{6,})/);
      id = m ? m[1] : '';
    }
    return id ? ('https://account.ladybaeshop.com/orders/' + id) : '';
  }

  /**
   * 退訂入口（docs/slot-refund-policy-spec.md）。
   * 曝光已開始／已過期／已結案的不出現按鈕——後端也會擋，這裡先收起來避免白按。
   */
  function grantRefundActionHtml(g) {
    var id = Number((g && g.id) || 0);
    if (!id) return '';
    if (grantRefundPending(g)) {
      if (grantRefundInFlight(g) || grantRefundAlreadyPaid(g)) return '';
      return '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-grant-refund-cancel" ' +
        'data-grant-id="' + id + '">撤回退訂</button>';
    }
    var info = grantRefundInfo(g);
    if (!info.eligible) return '';
    return '<button type="button" class="lb-v2-btn lb-v2-btn--sm lb-v2-grant-refund-btn" ' +
      'data-grant-id="' + id + '">申請退訂</button>';
  }

  function grantHistoryOrderCellHtml(g) {
    var href = grantAccountOrderHref(g);
    var name = String((g && g.shopify_order_name) || '').trim();
    var parts = [];
    if (href) {
      parts.push(
        '<a class="lb-v2-grant-order__name" href="' + escapeHtml(href) +
        '" target="_blank" rel="noopener noreferrer">' + escapeHtml(name || '查看訂單') + '</a>'
      );
    } else if (name) {
      parts.push('<span class="lb-v2-grant-order__name">' + escapeHtml(name) + '</span>');
    }
    var action = grantRefundActionHtml(g);
    if (action) parts.push(action);
    // 免費／$0 沒有 Shopify 訂單，退訂後按鈕消失會變成空白「—」。
    // 付費仍保留訂單連結；兩邊都補「已退訂」，跟「申請退訂」對得上。
    if (String((g && g.status) || '').toUpperCase() === 'RELEASED') {
      parts.push('<span class="lb-v2-grant-order__done">已退訂</span>');
    }
    if (!parts.length) return '—';
    return '<span class="lb-v2-grant-order">' + parts.join(' ') + '</span>';
  }

  /** 退訂申請的處理中／未通過說明，接在「權益」欄後面。 */
  function grantRefundNoteHtml(g) {
    if (grantRefundPending(g)) {
      if (grantRefundInFlight(g)) {
        return '<br><small style="color:#a61b3f">退款結果對帳中，官方確認後會完成，' +
          '期間無法撤回或重送</small>';
      }
      if (grantRefundAlreadyPaid(g)) {
        return '<br><small style="color:#a61b3f">退款已完成，檔期釋放由官方結案中，' +
          '期間無法撤回或重送</small>';
      }
      var pct = Number(g && g.refund_fee_percent);
      var expected = g && g.refund_expected_amount;
      var detail = isFinite(pct)
        ? (pct >= 100
          ? '取消不退費'
          : '扣 ' + pct + '% 手續費，預計退 ' + formatMoneyTw(expected))
        : '';
      return '<br><small style="color:#2980b9">退訂申請處理中' +
        (detail ? '（' + escapeHtml(detail) + '）' : '') + '</small>';
    }
    if (grantRefundResolution(g) === 'REJECTED') {
      return '<br><small style="color:#a61b3f">退訂申請未通過' +
        (g.refund_reject_reason ? '：' + escapeHtml(String(g.refund_reject_reason)) : '') +
        '</small>';
    }
    if (String((g && g.status) || '').toUpperCase() === 'RELEASED' && g.refund_amount != null) {
      return '<br><small class="lb-v2-muted">實退 ' +
        escapeHtml(formatMoneyTw(g.refund_amount)) + '</small>';
    }
    return '';
  }

  function findGrantById(grantId) {
    var grants = (cachedEntitlement && cachedEntitlement.recent_grants) || [];
    for (var i = 0; i < grants.length; i += 1) {
      if (Number(grants[i] && grants[i].id) === Number(grantId)) return grants[i];
    }
    return null;
  }

  /**
   * 送出退訂。級距在後端以「送出當下的台北日」定案並快照，送出即完成退款
   * （下架 → Shopify 退款 → 釋放檔期 → 連帶退底下的廣告加購），不需官方審核。
   * 只有自動退款失敗時才會留成待處理，由官方接手。
   */
  async function submitGrantRefundRequest(grantId, btn) {
    var slug = getListingVendorSlug();
    var notice = $('lb-v2-fee-purchase-notice');
    if (!slug) {
      showNotice(notice, '請先在上方選擇單一廠商');
      return;
    }
    var g = findGrantById(grantId);
    var info = grantRefundInfo(g);
    if (!info.eligible) {
      showNotice(notice, info.message || '此筆目前不可退訂');
      return;
    }
    var noRefund = Number(info.fee_percent) >= 100;
    var summary = noRefund
      ? '距曝光開始 ' + info.days_before + ' 天：依規定可取消並釋放檔期，但不退費。'
      : '距曝光開始 ' + info.days_before + ' 天：扣 ' + info.fee_percent +
        '% 手續費，預計可退 ' + formatMoneyTw(info.refundable_amount) +
        '（實付 ' + formatMoneyTw(info.paid_amount) + '）。';
    if (info.requires_unpublish) {
      summary += '\n此課程目前在線上，送出後會立即下架。';
    }
    summary += '\n若此課程有加購廣告版位，會一併退費（各自依其曝光起日計算手續費）。';
    summary += '\n送出後立即處理，無法復原；檔期一經退訂即釋出，如需再上架須重新購買。';
    var reason = window.prompt(summary + '\n\n請填寫退訂原因後送出（按取消則不送出）：', '');
    if (reason === null) return;
    if (!String(reason).trim()) {
      showNotice(notice, '請填寫退訂原因');
      return;
    }
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.feeGrantRefundRequest, {
        vendor_slug: slug,
        grant_id: Number(grantId),
        reason: String(reason).trim(),
      });
      if (!res.ok) {
        showNotice(notice, res.message || '退訂申請送出失敗');
        return;
      }
      cachedEntitlement = null;
      clearFeeEntitlementTtlCache();
      await loadFeePurchaseTab();
      // 回應資料在 payload 底下；直接讀 res.xxx 會全部是 undefined，
      // 於是 settled=false 永遠不成立，退款失敗也會謊報「已退款 NT$0」。
      var data = res.payload || {};
      var msg;
      if (data.settled === false) {
        // 申請已成立但自動退款沒跑完，錢與檔期都還沒動，由官方接手
        msg = '已送出退訂申請，但自動退款未完成，將由官方協助處理。';
      } else {
        // 母課 100% 手續費時，加購仍可能落在較寬鬆的級距而真的退到錢
        var addons = (data.addons || []).filter(function (a) { return a && a.ok; });
        var addonNote = addons.length
          ? '（含 ' + addons.length + ' 筆廣告加購一併退費）'
          : '';
        msg = Number(data.refund_amount) > 0
          ? '已退款 ' + formatMoneyTw(data.refund_amount) + '，檔期已釋放。' + addonNote
          : '已取消並釋放檔期（依規定不退費）。' + addonNote;
      }
      if (data.warning) msg += '\n' + data.warning;
      showNotice($('lb-v2-fee-purchase-notice'), msg);
    } catch (err) {
      showNotice(notice, (err && err.message) || '退訂申請送出失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  async function cancelGrantRefundRequest(grantId, btn) {
    var slug = getListingVendorSlug();
    var notice = $('lb-v2-fee-purchase-notice');
    if (!slug) return;
    if (!window.confirm('確定撤回這筆退訂申請？撤回後檔期維持原狀，重新申請會依當天日期重算級距。')) {
      return;
    }
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.feeGrantRefundRequestCancel, {
        vendor_slug: slug,
        grant_id: Number(grantId),
      });
      if (!res.ok) {
        showNotice(notice, res.message || '撤回失敗');
        return;
      }
      cachedEntitlement = null;
      clearFeeEntitlementTtlCache();
      await loadFeePurchaseTab();
      showNotice($('lb-v2-fee-purchase-notice'), '已撤回退訂申請');
    } catch (err) {
      showNotice(notice, (err && err.message) || '撤回失敗');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function bindGrantRefundActions(container) {
    if (!container || container.dataset.lbRefundBound === '1') return;
    container.dataset.lbRefundBound = '1';
    container.addEventListener('click', function (evt) {
      var requestBtn = evt.target.closest && evt.target.closest('.lb-v2-grant-refund-btn');
      if (requestBtn) {
        evt.preventDefault();
        submitGrantRefundRequest(requestBtn.getAttribute('data-grant-id'), requestBtn);
        return;
      }
      var cancelBtn = evt.target.closest && evt.target.closest('.lb-v2-grant-refund-cancel');
      if (cancelBtn) {
        evt.preventDefault();
        cancelGrantRefundRequest(cancelBtn.getAttribute('data-grant-id'), cancelBtn);
      }
    });
  }

  /**
   * 綁定課名（純顯示）。待套用的佔位單標題是「（待填）方案名 起~迄」，
   * 那不是課名，顯示成「待補內容」；舊 API 沒帶 listing_title 就整段不顯示。
   */
  function grantBoundListingTitle(g) {
    var title = String((g && g.listing_title) || '').trim();
    if (!title) return '';
    if (title.indexOf('（待填）') === 0) return '待補內容';
    return title;
  }

  function grantDetailHtml(g, detail) {
    return escapeHtml(detail) + grantRefundNoteHtml(g);
  }

  function grantCourseCellHtml(g) {
    var title = g && g.listing_id ? grantBoundListingTitle(g) : '';
    if (!title) return '<span class="lb-v2-muted">—</span>';
    return '<span class="lb-v2-grant-listing-title">' + escapeHtml(title) + '</span>';
  }


  function renderGrantHistory(container) {
    if (!container) return;
    var grants = (cachedEntitlement && cachedEntitlement.recent_grants) || [];
    if (!grants.length) {
      container.innerHTML = '<p class="lb-v2-muted">尚無開通紀錄</p>';
      return;
    }
    var rows = grants.map(function (g) {
      var typeLabel = g.plan_type === 'DURATION' ? '通行證' : '單次';
      var statusLabel = grantHistoryStatusLabel(g);
      var detail = g.plan_type === 'DURATION'
        ? (g.expires_at ? '可排檔期至 ' + formatDateTw(g.expires_at) : '—')
        : (g.listing_id ? '已綁上架編號 #' + g.listing_id : '未使用');
      var slotLabel = g.slot_name || (g.slot_id ? ('#' + g.slot_id) : '—');
      return '<tr>' +
        '<td>' + escapeHtml(g.plan_name || ('方案 #' + g.fee_plan_id)) + '</td>' +
        '<td>' + escapeHtml(slotLabel) + '</td>' +
        '<td>' + escapeHtml(modeLabel(g.listing_mode)) + '</td>' +
        '<td>' + escapeHtml(typeLabel) + '</td>' +
        '<td>' + escapeHtml(statusLabel) + '</td>' +
        '<td>' + grantDetailHtml(g, detail) + '</td>' +
        '<td class="lb-v2-grant-col-course">' + grantCourseCellHtml(g) + '</td>' +
        '<td>' + escapeHtml(formatDateTw(g.granted_at)) + '</td>' +
        '<td>' + grantHistoryOrderCellHtml(g) + '</td>' +
        '</tr>';
    }).join('');
    var cards = grants.map(function (g) {
      var typeLabel = g.plan_type === 'DURATION' ? '通行證' : '單次';
      var statusLabel = grantHistoryStatusLabel(g);
      var detail = g.plan_type === 'DURATION'
        ? (g.expires_at ? '可排檔期至 ' + formatDateTw(g.expires_at) : '—')
        : (g.listing_id ? '已綁上架編號 #' + g.listing_id : '未使用');
      var slotLabel = g.slot_name || (g.slot_id ? ('#' + g.slot_id) : '未綁版位');
      return '<article class="lb-v2-m-card">' +
        '<div class="lb-v2-m-card__head">' +
          '<div class="lb-v2-m-card__title">' + escapeHtml(g.plan_name || ('方案 #' + g.fee_plan_id)) + '</div>' +
          '<span class="lb-v2-badge lb-v2-badge--pending">' + escapeHtml(statusLabel) + '</span>' +
        '</div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">廣告版位</span><span>' + escapeHtml(slotLabel) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">模式</span><span>' + escapeHtml(modeLabel(g.listing_mode)) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">類型</span><span>' + escapeHtml(typeLabel) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">權益／可排檔期</span><span>' + grantDetailHtml(g, detail) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">課程名稱</span><span>' + grantCourseCellHtml(g) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">購買日</span><span>' + escapeHtml(formatDateTw(g.granted_at)) + '</span></div>' +
        '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">訂單</span><span>' + grantHistoryOrderCellHtml(g) + '</span></div>' +
      '</article>';
    }).join('');
    container.innerHTML =
      '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop"><table class="lb-v2-table"><thead><tr>' +
      '<th>方案</th><th>廣告版位</th><th>模式</th><th>類型</th><th>狀態</th><th>權益／可排檔期</th>' +
      '<th>課程名稱</th><th>購買日</th><th>訂單</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      '<div class="lb-v2-m-cards">' + cards + '</div>';
    bindGrantRefundActions(container);
  }

  /**
   * 免費贈送餘量（docs/single-plan-overlap-free-quota-spec.md §3.2）。
   * 桶＝(廠商 × 版位)，跨模式共用；slot_id 為 null 代表「不綁定」桶。
   * 後端只回傳「有設上限」的桶，沒回的桶就是不限。
   */
  function freeQuotaBucketForSlot(slotId) {
    var buckets = (cachedEntitlement && cachedEntitlement.free_quota_buckets) || [];
    if (!buckets.length) return null;
    var key = slotId ? String(slotId) : '';
    for (var i = 0; i < buckets.length; i += 1) {
      var b = buckets[i];
      if (!b) continue;
      var bKey = b.slot_id ? String(b.slot_id) : '';
      if (bKey === key) return b;
    }
    return null;
  }

  function isFreeQuotaExhaustedForSlot(slotId) {
    var bucket = freeQuotaBucketForSlot(slotId);
    return !!bucket && (parseInt(bucket.remaining, 10) || 0) <= 0;
  }

  /** 免費方案卡片／選項的餘量文案；不限或無上限時回空字串。 */
  function freeQuotaRemainLabel(slotId) {
    var bucket = freeQuotaBucketForSlot(slotId);
    if (!bucket) return '';
    var remaining = parseInt(bucket.remaining, 10) || 0;
    if (remaining <= 0) return '免費次數已用完，請改選付費方案';
    return '免費・可領取檔期（此版位剩 ' + remaining + '／' + bucket.limit + ' 次）';
  }

  var feeEntitlementInflight = {};
  var FEE_ENTITLEMENT_TTL_MS = 60000;
  var feeEntitlementTtl = { slug: '', at: 0, ent: null };

  function clearFeeEntitlementTtlCache() {
    feeEntitlementTtl = { slug: '', at: 0, ent: null };
  }

  async function fetchFeeEntitlementRaw(slug) {
    var response = await fetch(
      PATHS.feeEntitlement + '?vendor_slug=' + encodeURIComponent(slug),
      { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin' }
    );
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    if (payload && payload.ok && payload.entitlement) return payload.entitlement;
    var entErr = extractApiError(payload);
    throw new Error(entErr.code ? '[' + entErr.code + '] ' + entErr.message : (entErr.message || ('額度載入失敗 (HTTP ' + response.status + ')')));
  }

  // Resolves to entitlements aligned to `slugs` (missing ones null), or null when
  // the batch endpoint is unavailable so callers can fall back to per-vendor fetches.
  async function fetchFeeEntitlementBatch(slugs) {
    if (!slugs || !slugs.length) return [];
    try {
      var response = await fetch(
        PATHS.feeEntitlementBatch + '?vendor_slugs=' + encodeURIComponent(slugs.join(',')),
        { method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin' }
      );
      if (!response.ok) return null;
      var payload = null;
      try { payload = await response.json(); } catch (e) { payload = null; }
      if (!payload || payload.ok !== true || !Array.isArray(payload.entitlements)) return null;
      var bySlug = {};
      payload.entitlements.forEach(function (entry) {
        if (entry && entry.vendor_slug) bySlug[entry.vendor_slug] = entry.entitlement || null;
      });
      return slugs.map(function (slug) { return bySlug[slug] || null; });
    } catch (e) {
      return null;
    }
  }

  // Several tabs request the same slug concurrently; each App Proxy round-trip
  // costs ~500ms, so share in-flight + short success TTL instead of paying per tab.
  async function loadFeeEntitlement(slug) {
    if (!slug) {
      cachedEntitlement = null;
      clearFeeEntitlementTtlCache();
      return null;
    }
    var now = Date.now();
    if (
      feeEntitlementTtl.slug === slug &&
      feeEntitlementTtl.ent &&
      now - feeEntitlementTtl.at < FEE_ENTITLEMENT_TTL_MS
    ) {
      cachedEntitlement = feeEntitlementTtl.ent;
      rememberModuleDisabledFromEntitlement(cachedEntitlement);
      syncSlotAddonPurchaseUi();
      return feeEntitlementTtl.ent;
    }
    if (feeEntitlementInflight[slug]) return feeEntitlementInflight[slug];
    var pending = fetchFeeEntitlementRaw(slug).then(function (ent) {
      cachedEntitlement = ent;
      feeEntitlementTtl = { slug: slug, at: Date.now(), ent: ent };
      rememberModuleDisabledFromEntitlement(cachedEntitlement);
      syncSlotAddonPurchaseUi();
      return ent;
    });
    feeEntitlementInflight[slug] = pending;
    pending.then(
      function () { delete feeEntitlementInflight[slug]; },
      function () { delete feeEntitlementInflight[slug]; }
    );
    return pending;
  }

  function setListingFormLocked(locked) {
    var formSection = $('lb-v2-listing-form-section');
    if (!formSection) return;
    formSection.classList.toggle('is-locked', !!locked);
    formSection.setAttribute('aria-disabled', locked ? 'true' : 'false');

    var curtain = formSection.querySelector('.lb-v2-listing-lock-curtain');
    if (curtain) curtain.setAttribute('aria-hidden', locked ? 'false' : 'true');

    // Hard-disable controls so blurred fields cannot be focused / typed into
    var nodes = formSection.querySelectorAll('input, textarea, select, button');
    nodes.forEach(function (el) {
      if (el.id === 'lb-v2-listing-lock-goto-purchase') {
        el.disabled = false;
        return;
      }
      if (locked) {
        if (!el.hasAttribute('data-lb-prev-disabled')) {
          el.setAttribute('data-lb-prev-disabled', el.disabled ? '1' : '0');
        }
        el.disabled = true;
      } else if (el.hasAttribute('data-lb-prev-disabled')) {
        el.disabled = el.getAttribute('data-lb-prev-disabled') === '1';
        el.removeAttribute('data-lb-prev-disabled');
      }
    });
  }

  function applyListingGate() {
    var modeEl = $('lb-v2-listing-mode');
    var mode = modeEl ? modeEl.value : 'EXPOSURE';
    var idEl = $('lb-v2-listing-id');
    var editingExisting = !!(idEl && idEl.value);

    // New draft: if current mode has no quota but another mode does, switch automatically.
    // (Default used to be FULL — vendors with only EXPOSURE grants stayed locked.)
    // Never auto-switch away from locked PRIVATE (opened from 資格限定課 tab).
    if (!editingExisting && modeEl && !privateModeLocked && !canSubmitForMode(mode)) {
      var autoMode = null;
      if (canSubmitForMode('EXPOSURE')) autoMode = 'EXPOSURE';
      else if (canSubmitForMode('PROMO')) autoMode = 'PROMO';
      else if (canSubmitForMode('FULL')) autoMode = 'FULL';
      else if (canSubmitForMode('PRIVATE')) autoMode = 'PRIVATE';
      if (autoMode && autoMode !== mode) {
        ensurePrivateModeOption();
        modeEl.value = autoMode;
        mode = autoMode;
        syncListingModePanels(mode);
      }
    }

    var gate = $('lb-v2-listing-gate');
    var bar = $('lb-v2-listing-entitlement-bar');
    renderEntitlementCards(bar, true);

    // All modes need grants (PAID/WAIVED/can_submit); NOT_REQUIRED no longer unlocks FULL.
    var alreadyPaid = isListingFeeSettled();
    // Official WAIVED is not a purchased grant — when module is closed, only
    // leftover grant quota (can_submit) may unlock the editor.
    if (
      alreadyPaid &&
      isOfficialFeeExemptVendor() &&
      currentListingFeeStatus() === 'WAIVED'
    ) {
      var modeEntPaid = findModeEntitlement(mode);
      if (modeEntPaid && modeEntPaid.module_enabled === false) {
        alreadyPaid = false;
      }
    }
    var can = alreadyPaid || canSubmitForMode(mode);

    function findAlternateModeWithQuota(current) {
      var order = ['EXPOSURE', 'PROMO', 'FULL', 'PRIVATE'];
      for (var ai = 0; ai < order.length; ai++) {
        if (order[ai] !== current && canSubmitForMode(order[ai])) return order[ai];
      }
      return null;
    }

    if (gate) {
      gate.hidden = can;
      if (!can) {
        var other = findAlternateModeWithQuota(mode);
        var hint = '';
        if (other) {
          hint = '<p>您目前有「' + escapeHtml(modeLabel(other)) + '」額度。請在下方<strong>選擇基礎上架方案</strong>點選該方案，系統會自動套用對應模式的欄位。</p>';
        } else if (isOfficialFeeExemptVendor()) {
          hint = '<p>官方廠商通常免購買即可上架；若仍無法編輯，請確認該模組未關閉，或宣傳刊登（含金流）已設定手續費率。</p>';
        } else {
          hint = '<p>請先到「營運結帳」選好曝光檔期並完成付款（免費方案請按「領取此檔期」）。' +
            '檔期鎖定後系統會建立草稿，回到這裡補完內容即可送審。</p>';
        }
        gate.innerHTML =
          '<p><strong>尚無可送審的「' + escapeHtml(modeLabel(mode)) + '」額度。</strong></p>' +
          hint +
          '<p style="margin-top:0.6rem;">' +
          '<button type="button" class="lb-v2-btn lb-v2-btn--accent" id="lb-v2-listing-goto-purchase">前往營運結帳</button>' +
          '</p>';
        var gotoBtn = $('lb-v2-listing-goto-purchase');
        if (gotoBtn) {
          gotoBtn.addEventListener('click', function () { switchTab('fee-purchase'); });
        }
      }
    }
    setListingFormLocked(!can);

    var curtain = document.querySelector('#lb-v2-listing-form-section .lb-v2-listing-lock-card');
    if (curtain && !can) {
      var other2 = findAlternateModeWithQuota(mode);
      var lockTitle = curtain.querySelector('[data-lb-lock-title]');
      var p = curtain.querySelector('[data-lb-lock-msg]') || curtain.querySelector('p');
      if (other2) {
        if (lockTitle) lockTitle.textContent = '此模式尚無額度';
        if (p) {
          p.textContent =
            '此課目前是「' + modeLabel(mode) + '」，該模式尚無額度。請於「選擇基礎上架方案」點選「' +
            modeLabel(other2) + '」的方案即可編輯。';
        }
      } else {
        if (lockTitle) lockTitle.textContent = '目前無上架額度';
        if (p) p.textContent = '若有上課需求，請先至「營運結帳」選擇方案';
      }
    }

    var statusBox = $('lb-v2-listing-fee-status');
    if (statusBox) {
      var m = findModeEntitlement(mode);
      if (!m) {
        statusBox.innerHTML = '<p class="lb-v2-muted">額度未載入</p>';
      } else if ((m.slot_balances || []).length) {
        statusBox.innerHTML = (m.slot_balances || []).map(function (b) {
          var planLabel = b.plan_name || (b.fee_plan_id ? ('方案 #' + b.fee_plan_id) : '未命名方案');
          var bits = [];
          if (b.has_duration) {
            bits.push('有效' + (b.duration_expires_at ? '至 ' + formatDateTw(b.duration_expires_at) : ''));
          }
          if (b.single_unused > 0) bits.push('剩餘 ' + b.single_unused + ' 次');
          if (b.slot_name) bits.push(b.slot_name);
          return '<p style="color:#27ae60;font-weight:600;margin:0.2rem 0;">' +
            escapeHtml(planLabel) + ' · ' + escapeHtml(bits.join(' · ')) + '</p>';
        }).join('');
      } else if (m.has_duration) {
        statusBox.innerHTML = '<p style="color:#27ae60;font-weight:600;">包月方案有效' +
          (m.duration_expires_at ? '至 ' + formatDateTw(m.duration_expires_at) : '') + '</p>';
      } else if (m.single_unused > 0) {
        statusBox.innerHTML = '<p style="color:#27ae60;font-weight:600;">尚有單次額度 ' + m.single_unused + ' 次（請在下方選擇具體方案）</p>';
      } else if (Number(m.pending_window_listings) > 0) {
        statusBox.innerHTML = '<p style="color:#27ae60;font-weight:600;">已鎖定 ' +
          m.pending_window_listings + ' 檔曝光檔期，請選擇額度方案後補完內容送審</p>';
      } else if (m.free_plan_available) {
        statusBox.innerHTML = '<p style="color:#27ae60;">有免費方案，請到「營運結帳」領取檔期</p>';
      } else {
        statusBox.innerHTML = '<p style="color:#c0392b;font-weight:600;">此模式尚無額度，請先購買</p>';
      }
    }

    refreshListingSlotOptions(mode);
    syncListingContentGate();
  }

  /** Panel visibility only — avoids re-fetch loops when auto-switching mode in applyListingGate */
  function syncListingModePanels(mode) {
    var resolved = resolveListingMode(mode);
    var isExposure = resolved === 'EXPOSURE';
    var isFull = resolved === 'FULL';
    var isPromo = resolved === 'PROMO';
    var isPrivate = resolved === 'PRIVATE';
    var isFullLike = isFull || isPrivate;
    setModePanelVisible($('lb-v2-listing-fee-notice'), true);
    setModePanelVisible($('lb-v2-listing-exposure-flow-hint'), isExposure);
    setModePanelVisible($('lb-v2-listing-external-url-wrap'), isExposure || isPromo);
    setModePanelVisible($('lb-v2-listing-city-cta-wrap'), false);
    setModePanelVisible($('lb-v2-listing-promo-hint'), isPromo);
    setModePanelVisible($('lb-v2-listing-course-rules-wrap'), isExposure || isFullLike);
    setModePanelVisible($('lb-v2-listing-course-rules-hint-full'), isFull || isPrivate);
    setModePanelVisible($('lb-v2-listing-course-rules-hint-exposure'), isExposure);
    setModePanelVisible($('lb-v2-listing-cancel-policy-wrap'), isFullLike);
    setModePanelVisible($('lb-v2-listing-full-hint'), isFull);
    setModePanelVisible($('lb-v2-listing-variants-hint'), isExposure);
    setPromoTicketFieldsVisible(!isPromo);
    setPrivateHostFieldsVisible(isPrivate);
    var exposureWrapSync = $('lb-v2-listing-exposure-wrap');
    if (exposureWrapSync && isPrivate) {
      exposureWrapSync.hidden = false;
      var slotTitleSync = $('lb-v2-listing-exposure-slot-title');
      if (slotTitleSync) {
        slotTitleSync.textContent = '資格限定課曝光檔期（自動上下架；不上公開牆）';
      }
    }
    var urlLabel = $('lb-v2-listing-external-url-label');
    var urlHint = $('lb-v2-listing-external-url-hint');
    var urlInput = $('lb-v2-listing-external-url');
    if (isPromo) {
      if (urlLabel) urlLabel.textContent = '預設前往連結 *';
      if (urlHint) urlHint.textContent = '消費者點擊後前往的官網／活動頁（http/https）。';
      if (urlInput) urlInput.placeholder = 'https://example.com/your-promo';
    } else if (isExposure) {
      if (urlLabel) urlLabel.textContent = '外部購票連結（消費者實際付款處）*';
      if (urlHint) urlHint.textContent = '請填消費者真正付錢的頁面（自家官網／Accupass 等）。';
      if (urlInput) urlInput.placeholder = 'https://book.example.com/your-course';
    }
    syncCityCtaRows();
    refreshSubcategoryOptions(getSelectedSubcategories());
    if (isFullLike) {
      updateCancelPolicyDetail();
      updatePolicyExample();
    }
  }

  async function refreshListingEntitlementUI(listingMode) {
    var slug = getListingVendorSlug();
    try {
      if (slug) await loadFeeEntitlement(slug);
    } catch (err) {
      console.warn('[lb-v2] entitlement', err);
    }
    applyListingGate();
  }

  var EXPOSURE_CALENDAR_DAYS = 180; // 所有方案可預約視窗：今天起算 180 天

  function buildListingPlanPickButton(p, prefer) {
    var typeBit = '';
    if (p.plan_type === 'SINGLE' && p.duration_days) typeBit = '短檔 ' + p.duration_days + ' 天';
    else if (p.plan_type === 'SINGLE') typeBit = '單次';
    else if (p.plan_type === 'DURATION') {
      typeBit = p.validity_days ? ('通行證 ' + p.validity_days + ' 天') : '通行證';
    }
    var remain = '';
    if (p.official_fee_exempt) {
      remain = '官方免上架費';
    } else if (p.bound_to_editing) {
      remain = '已綁本草稿';
    } else if (p.plan_type === 'SINGLE') {
      remain = '剩餘 ' + (parseInt(p.unused_single_count, 10) || 0) + ' 次';
    } else if (p.has_active_grant) {
      remain = p.grant_expires_at ? ('有效至 ' + formatDateTw(p.grant_expires_at)) : '已開通';
    }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lb-v2-fee-plan-pick__item';
    btn.setAttribute('role', 'option');
    btn.setAttribute('data-plan-id', String(p.id));
    btn.setAttribute('data-official-direct-slot', '0');
    btn.setAttribute('data-slot-id', p.slot_id ? String(p.slot_id) : '');
    btn.setAttribute('data-duration-days', p.duration_days ? String(p.duration_days) : '');
    btn.setAttribute('data-max-interval-days', p.max_booking_interval_days ? String(p.max_booking_interval_days) : '');
    btn.setAttribute('data-grant-expires', toPlanYmd(p.grant_expires_at) || '');
    btn.setAttribute('data-plan-type', p.plan_type || '');
    btn.setAttribute('data-slot-name', p.slot_name || '');
    btn.setAttribute('data-plan-name', p.name || ('方案 #' + p.id));
    if (prefer && String(prefer) === String(p.id)) btn.classList.add('is-selected');
    btn.innerHTML =
      '<span class="lb-v2-fee-plan-pick__name">' + escapeHtml(p.name || ('方案 #' + p.id)) + '</span>' +
      '<span class="lb-v2-fee-plan-pick__meta">' +
        escapeHtml([typeBit, remain, p.slot_name ? ('版位：' + p.slot_name) : ''].filter(Boolean).join(' · ')) +
      '</span>';
    btn.addEventListener('click', function () {
      if (listingFormReadOnly) return;
      // 編輯既有草稿／已有檔期時保留曝光日與表單內容，避免「選方案就清空」。
      var editing = !!(($('lb-v2-listing-id') || {}).value);
      var startEl = $('lb-v2-listing-exposure-start');
      var endEl = $('lb-v2-listing-exposure-end');
      var hasDates = !!(startEl && startEl.value) || !!(endEl && endEl.value);
      selectFeePlanCard(btn, { keepDates: editing || hasDates });
    });
    return btn;
  }

  /**
   * 購買即鎖窗：建課表單只列出「已鎖檔期」的額度（待填草稿），絕不開月曆選日。
   * 未鎖窗的剩餘次數／舊 grant 請到營運結帳處理，不可在此頁自行選日。
   */
  async function refreshPurchaseLockedListingPlans(listingMode) {
    var slotWrap = $('lb-v2-listing-slot-wrap');
    var planHidden = $('lb-v2-listing-fee-plan');
    var planList = $('lb-v2-listing-fee-plan-list');
    var exposureWrap = $('lb-v2-listing-exposure-wrap');
    if (!slotWrap || !planHidden || !planList) return;

    recoverLockedWindowCtxFromEditing();
    if (renderLockedWindowUi()) {
      syncListingContentGate();
      return;
    }

    function hideExposure() {
      if (exposureWrap) {
        exposureWrap.hidden = true;
        var cal = $('lb-v2-exposure-calendar');
        if (cal) cal.innerHTML = '';
      }
    }

    function renderPlanMessage(msg, isError) {
      usePlanPickerCards();
      planList.innerHTML = '<p class="lb-v2-fee-plan-pick__empty' + (isError ? ' is-error' : '') + '">' +
        escapeHtml(msg) + '</p>';
      planHidden.value = '';
      planHidden.required = false;
      planHidden.removeAttribute('data-pending-plan-id');
      planHidden.removeAttribute('data-slot-id');
      planHidden.removeAttribute('data-duration-days');
      planHidden.removeAttribute('data-max-interval-days');
      planHidden.removeAttribute('data-grant-expires');
      planHidden.removeAttribute('data-plan-type');
      planHidden.removeAttribute('data-slot-name');
      planHidden.removeAttribute('data-plan-name');
      planHidden.removeAttribute('data-official-direct-slot');
      hideExposure();
    }

    var slug = getListingVendorSlug();
    if (!slug) {
      renderPlanMessage('請先在上方選擇廠商', false);
      slotWrap.hidden = false;
      syncListingContentGate();
      return;
    }

    try {
      if (typeof clearFeeEntitlementTtlCache === 'function') clearFeeEntitlementTtlCache();
      await loadFeeEntitlement(slug);
    } catch (err) {
      console.warn('[lb-v2] entitlement', err);
    }

    var editingListingId = String((($('lb-v2-listing-id') || {}).value) || '').trim();
    // 上架頁不再自選模式：一次列出所有模式的已鎖窗額度，點選即套用該模式欄位。
    var pendingLocked = listPendingLockedBaseListingsAllModes();

    if (editingListingId) {
      var editingItem = findListingItemById(editingListingId);
      if (editingItem && isWindowLockedListing(editingItem)) {
        setLockedWindowCtx(editingItem);
        renderLockedWindowUi();
        slotWrap.hidden = false;
        syncListingContentGate();
        return;
      }
      // 未鎖窗舊稿：仍列出可選的已鎖檔期額度（點選＝改開該鎖窗草稿）
      if (pendingLocked.length) {
        renderPendingLockedPickUi(listingMode, pendingLocked);
        slotWrap.hidden = false;
        return;
      }
      renderPlanMessage(
        '此草稿尚未鎖定曝光檔期，且目前沒有可選的已鎖定額度。請先到「營運結帳」購買或領取檔期；此頁不可自行選日。',
        false
      );
      slotWrap.hidden = false;
      syncListingContentGate();
      return;
    }

    if (pendingLocked.length) {
      renderPendingLockedPickUi(listingMode, pendingLocked);
      slotWrap.hidden = false;
      return;
    }

    var hasPendingAnyMode = PENDING_LOCKED_MODE_ORDER.some(function (m) {
      var ent = findModeEntitlement(m);
      return !!(ent && Number(ent.pending_window_listings) > 0);
    });
    var emptyMsg;
    if (hasPendingAnyMode) {
      emptyMsg =
        '已有鎖定檔期的額度方案，請重新整理後於上方選擇方案再填寫。若列表仍空白，請從課程列表點「編輯」，或再到「營運結帳」購買／領取新檔期。';
    } else {
      emptyMsg =
        '目前沒有可用的基礎上架額度，請先到「營運結帳」購買或領取檔期。此頁不可自行選日。';
    }
    renderPlanMessage(emptyMsg, false);
    slotWrap.hidden = false;
    syncListingContentGate();
  }

  async function refreshListingSlotOptions(listingMode) {
    var slotWrap = $('lb-v2-listing-slot-wrap');
    var planHidden = $('lb-v2-listing-fee-plan');
    var planList = $('lb-v2-listing-fee-plan-list');
    var slotHidden = $('lb-v2-listing-slot');
    var exposureWrap = $('lb-v2-listing-exposure-wrap');
    if (!slotWrap || !planHidden || !planList) return;
    recoverLockedWindowCtxFromEditing();
    if (renderLockedWindowUi()) {
      syncListingContentGate();
      return;
    }
    // 一般廠商公開線：不走「剩餘次數 → 開月曆選日」舊路徑。
    if (usesPurchaseLockedListingForm(listingMode)) {
      await refreshPurchaseLockedListingPlans(listingMode);
      return;
    }
    // 官方／資格限定課仍需卡片式方案＋月曆。
    usePlanPickerCards();
    var slug = getListingVendorSlug();

    function hideExposure() {
      if (slotHidden) slotHidden.value = '';
      var modeHide = resolveListingMode(listingMode || (($('lb-v2-listing-mode') || {}).value) || '');
      // PRIVATE 曝光窗與方案版位脫鉤；無可用方案時仍須能編輯／保留曝光起迄。
      if (modeHide === 'PRIVATE') {
        if (exposureWrap) {
          exposureWrap.hidden = false;
          loadPrivateExposureCalendar();
        }
        return;
      }
      if (exposureWrap) {
        exposureWrap.hidden = true;
        var cal = $('lb-v2-exposure-calendar');
        if (cal) cal.innerHTML = '';
      }
    }

    function renderPlanMessage(msg, isError) {
      planList.innerHTML = '<p class="lb-v2-fee-plan-pick__empty' + (isError ? ' is-error' : '') + '">' +
        escapeHtml(msg) + '</p>';
      planHidden.value = '';
      planHidden.removeAttribute('data-slot-id');
      planHidden.removeAttribute('data-duration-days');
      planHidden.removeAttribute('data-max-interval-days');
      planHidden.removeAttribute('data-grant-expires');
      planHidden.removeAttribute('data-plan-type');
      planHidden.removeAttribute('data-slot-name');
      planHidden.removeAttribute('data-plan-name');
      planHidden.removeAttribute('data-official-direct-slot');
      planHidden.required = false;
      hideExposure();
    }

    if (!slug) {
      renderPlanMessage('請先在上方選擇廠商', false);
      slotWrap.hidden = false;
      syncListingContentGate();
      return;
    }

    planList.innerHTML = '<p class="lb-v2-fee-plan-pick__empty">載入方案中…</p>';
    try {
      delete cachedFeePlans[(listingMode || '') + '_' + (slug || '')];
      var plans = await fetchFeePlans(listingMode, slug);

      var modeEnt = findModeEntitlement(listingMode) || {};
      var balances = modeEnt.slot_balances || [];
      var balanceByPlanId = {};
      balances.forEach(function (b) {
        if (b && b.fee_plan_id) balanceByPlanId[String(b.fee_plan_id)] = b;
      });

      // Official free UI only while module is enabled. Closed + leftover grant
      // still allows can_submit, but must use grant-matched plans (not free slots).
      var officialExempt =
        isOfficialFeeExemptVendor() &&
        (listingMode === 'EXPOSURE' || listingMode === 'PROMO' || listingMode === 'FULL') &&
        !!modeEnt.can_submit &&
        modeEnt.module_enabled !== false;
      // Switching away from official must not leave direct-slot sticky state.
      if (!officialExempt) {
        planHidden.removeAttribute('data-official-direct-slot');
      }
      var usable = [];
      var seen = {};
      var coveredSlotIds = {};
      (plans || []).forEach(function (p) {
        if (!p || p.id == null) return;
        var id = String(p.id);
        var bal = balanceByPlanId[id];
        var unused = parseInt(p.unused_single_count, 10) || 0;
        if (bal && bal.single_unused > 0) unused = Math.max(unused, bal.single_unused | 0);
        var hasDuration = !!p.has_active_grant || !!(bal && bal.has_duration);
        var usablePlan = p.plan_type === 'DURATION'
          ? hasDuration
          : unused > 0 || hasDuration;
        if (!usablePlan && bal && (bal.single_unused > 0 || bal.has_duration)) usablePlan = true;
        // Official: any active plan for this mode is selectable without grant/purchase.
        // Plans without a bound slot cannot place on a wall — skip (use direct-slot cards).
        if (!usablePlan && officialExempt) usablePlan = true;
        // 免費方案改成在「營運結帳」按「領取此檔期」時開通（購買即鎖窗），
        // 這裡不可再讓 0 元方案在沒有額度時被選，否則按下送審才會吃
        // FREE_WINDOW_CLAIM_REQUIRED。
        if (officialExempt && !(p.slot_id || (bal && bal.slot_id))) return;
        if (!usablePlan) return;
        usable.push(Object.assign({}, p, {
          unused_single_count: unused,
          has_active_grant: hasDuration,
          official_fee_exempt: officialExempt,
          free_mint_on_submit: false,
          slot_id: p.slot_id || (bal && bal.slot_id) || null,
          slot_name: p.slot_name || (bal && bal.slot_name) || '',
          name: p.name || (bal && bal.plan_name) || ('方案 #' + p.id),
        }));
        seen[id] = true;
        if (p.slot_id) coveredSlotIds[String(p.slot_id)] = true;
      });
      balances.forEach(function (b) {
        if (!b || !b.fee_plan_id) return;
        var id = String(b.fee_plan_id);
        if (seen[id]) return;
        if (!(b.single_unused > 0 || b.has_duration)) return;
        // Official wall path: skip grant rows with no bound slot (use direct-slot cards).
        if (officialExempt && !b.slot_id) return;
        usable.push({
          id: b.fee_plan_id,
          name: b.plan_name || ('方案 #' + b.fee_plan_id),
          plan_type: b.plan_type || 'SINGLE',
          duration_days: null,
          max_booking_interval_days: modeEnt.max_booking_interval_days || null,
          unused_single_count: b.single_unused || 0,
          has_active_grant: !!b.has_duration,
          grant_expires_at: b.duration_expires_at || null,
          slot_id: b.slot_id,
          slot_name: b.slot_name || '',
        });
        seen[id] = true;
        if (b.slot_id) coveredSlotIds[String(b.slot_id)] = true;
      });

      // Official option C: also allow picking an active slot directly (no fee plan).
      var directSlots = [];
      if (officialExempt && cachedEntitlement && Array.isArray(cachedEntitlement.active_slots)) {
        cachedEntitlement.active_slots.forEach(function (s) {
          if (!s || s.id == null) return;
          directSlots.push(s);
          if (s.id) coveredSlotIds[String(s.id)] = true;
        });
      }

      var prevPlan = planHidden.value;
      var pendingPlan = planHidden.getAttribute('data-pending-plan-id') || '';
      if (pendingPlan) planHidden.removeAttribute('data-pending-plan-id');
      var prefer = pendingPlan || prevPlan;
      var preferSlot = planHidden.getAttribute('data-slot-id') || '';
      var preferDirect =
        planHidden.getAttribute('data-official-direct-slot') === '1' ||
        (!prefer && !!preferSlot);
      var editingListingId = String((($('lb-v2-listing-id') || {}).value) || '').trim();

      // 編輯中的草稿若已綁 fee_plan，grant 多半已耗用（unused=0），usable 會漏掉。
      // 仍要把該方案加回列表，否則方案區空白／無法選、看起來像「不會刷新」。
      if (prefer && !seen[String(prefer)]) {
        var preferRaw = (plans || []).find(function (p) { return p && String(p.id) === String(prefer); });
        var preferBal = balanceByPlanId[String(prefer)];
        if (preferRaw || preferBal) {
          usable.push({
            id: preferRaw ? preferRaw.id : preferBal.fee_plan_id,
            name: (preferRaw && preferRaw.name) || (preferBal && preferBal.plan_name) || ('方案 #' + prefer),
            plan_type: (preferRaw && preferRaw.plan_type) || (preferBal && preferBal.plan_type) || 'SINGLE',
            duration_days: preferRaw ? preferRaw.duration_days : null,
            max_booking_interval_days: (preferRaw && preferRaw.max_booking_interval_days) ||
              modeEnt.max_booking_interval_days || null,
            unused_single_count: 0,
            has_active_grant: true,
            grant_expires_at: (preferRaw && preferRaw.grant_expires_at) ||
              (preferBal && preferBal.duration_expires_at) || null,
            slot_id: (preferRaw && preferRaw.slot_id) || (preferBal && preferBal.slot_id) || null,
            slot_name: (preferRaw && preferRaw.slot_name) || (preferBal && preferBal.slot_name) || '',
            bound_to_editing: true,
          });
          seen[String(prefer)] = true;
        }
      }

      // 新架構：建課表單只選「基礎上架」。廣告版位改走課程列表的「加購廣告版位」，
      // 內容沿用母課、只壓檔期。舊草稿若已綁版位方案，仍保留那一筆以便編輯／送審。
      var basePlans = usable.filter(function (p) { return !p.slot_id; });
      var slotPlans = usable.filter(function (p) { return !!p.slot_id; });
      var listingPlans;
      if (officialExempt || resolveListingMode(listingMode || '') === 'PRIVATE') {
        listingPlans = usable.slice();
      } else {
        listingPlans = basePlans.slice();
        if (prefer) {
          slotPlans.forEach(function (p) {
            if (String(p.id) === String(prefer)) listingPlans.push(p);
          });
        }
      }

      if (!listingPlans.length && !directSlots.length) {
        var pendingLocked = listPendingLockedBaseListings(listingMode);
        if (editingListingId) {
          var selfPending = pendingLocked.filter(function (item) {
            return String(item.id) === String(editingListingId);
          });
          if (selfPending.length) {
            setLockedWindowCtx(selfPending[0]);
            renderLockedWindowUi();
            slotWrap.hidden = false;
            syncListingContentGate();
            return;
          }
          // 編輯中不要把「其他草稿的鎖窗額度」當成可選方案，點下去會整表覆寫、內容消失。
          renderPlanMessage(
            '此草稿尚未綁定可選的額度方案。請先到「營運結帳」購買或領取檔期；若額度已鎖定在其他草稿，請到「課程管理」開啟該筆繼續填寫。',
            false
          );
          slotWrap.hidden = false;
          syncListingContentGate();
          return;
        }
        if (pendingLocked.length) {
          renderPendingLockedPickUi(listingMode, pendingLocked);
          slotWrap.hidden = false;
          return;
        }
        var emptyMsg;
        if (officialExempt) {
          emptyMsg = '目前沒有可用方案或版位，請先在 Admin 建立版位／方案';
        } else if (slotPlans.length && !basePlans.length) {
          emptyMsg =
            '建課請先購買「基礎上架（不綁版位）」方案。廣告版位額度請到課程通過審核後，在「課程廣告刊登」用「加購廣告版位」使用。';
        } else if (Number(modeEnt.pending_window_listings) > 0) {
          emptyMsg =
            '已有鎖定檔期的額度方案，請重新整理後於上方選擇方案再填寫。若列表仍空白，請從課程列表點「編輯」，或再到「營運結帳」購買／領取新檔期。';
        } else {
          emptyMsg = '目前沒有可用的基礎上架額度，請先到「營運結帳」購買基礎上架方案';
        }
        renderPlanMessage(emptyMsg, false);
        slotWrap.hidden = false;
        syncListingContentGate();
        return;
      }

      if (!prefer && !preferDirect && listingPlans.length === 1 && !directSlots.length) {
        prefer = String(listingPlans[0].id);
      }

      planList.innerHTML = '';
      function appendPlanGroup(groupPlans, heading) {
        if (!groupPlans.length) return;
        if (heading) {
          var head = document.createElement('p');
          head.className = 'lb-v2-fee-plan-pick__group';
          head.textContent = heading;
          planList.appendChild(head);
        }
        groupPlans.forEach(function (p) {
          planList.appendChild(buildListingPlanPickButton(p, prefer));
        });
      }
      if (officialExempt) {
        appendPlanGroup(listingPlans, '');
      } else if (resolveListingMode(listingMode || '') === 'PRIVATE') {
        appendPlanGroup(listingPlans, '');
      } else {
        appendPlanGroup(
          listingPlans.filter(function (p) { return !p.slot_id; }),
          '基礎上架（不綁版位）'
        );
        // 僅編輯舊草稿時才會出現；新建不會再看到版位方案。
        appendPlanGroup(
          listingPlans.filter(function (p) { return !!p.slot_id; }),
          '舊草稿已選版位（新建請改用課程列表「加購廣告版位」）'
        );
        var tip = document.createElement('p');
        tip.className = 'lb-v2-hint';
        tip.style.margin = '0.55rem 0 0';
        tip.textContent =
          slotPlans.length
            ? '首頁大輪播等廣告版位，請等課程通過審核後，在「課程廣告刊登」按「加購廣告版位」；會沿用本課內容，只需選檔期。'
            : '課程審核通過後，可在「課程廣告刊登」加購廣告版位（沿用本課內容，只需選檔期）。';
        planList.appendChild(tip);
      }

      directSlots.forEach(function (s) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lb-v2-fee-plan-pick__item';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-plan-id', '');
        btn.setAttribute('data-official-direct-slot', '1');
        btn.setAttribute('data-slot-id', String(s.id));
        btn.setAttribute('data-duration-days', '');
        btn.setAttribute('data-max-interval-days', '');
        btn.setAttribute('data-grant-expires', '');
        btn.setAttribute('data-plan-type', '');
        btn.setAttribute('data-slot-name', s.name || '');
        btn.setAttribute('data-plan-name', '版位：' + (s.name || ('#' + s.id)));
        if (preferDirect && String(preferSlot) === String(s.id)) btn.classList.add('is-selected');
        btn.innerHTML =
          '<span class="lb-v2-fee-plan-pick__name">' + escapeHtml(s.name || ('版位 #' + s.id)) + '</span>' +
          '<span class="lb-v2-fee-plan-pick__meta">直接選版位 · 官方免上架費</span>';
        btn.addEventListener('click', function () {
          if (listingFormReadOnly) return;
          var editing = !!(($('lb-v2-listing-id') || {}).value);
          var startEl = $('lb-v2-listing-exposure-start');
          var endEl = $('lb-v2-listing-exposure-end');
          var hasDates = !!(startEl && startEl.value) || !!(endEl && endEl.value);
          selectFeePlanCard(btn, { keepDates: editing || hasDates });
        });
        planList.appendChild(btn);
      });

      // PRIVATE / official: do not force HTML5 required on fee_plan (slot-only allowed).
      planHidden.required =
        resolveListingMode(listingMode || '') !== 'PRIVATE' && !officialExempt;
      slotWrap.hidden = false;

      var selectedBtn = planList.querySelector('.lb-v2-fee-plan-pick__item.is-selected');
      if (selectedBtn) {
        selectFeePlanCard(selectedBtn, { keepDates: true });
      } else {
        planHidden.value = '';
        hideExposure();
        applySelectedFeePlan({ keepDates: true });
      }
      bindExposureDateAutoFill();
      if (listingFormReadOnly) {
        planList.querySelectorAll('.lb-v2-fee-plan-pick__item').forEach(function (el) {
          if (!el.hasAttribute('data-lb-ro-prev')) el.setAttribute('data-lb-ro-prev', '0');
          el.disabled = true;
        });
      }
    } catch (e) {
      console.warn('[lb-v2] fee plans', e);
      renderPlanMessage('方案載入失敗，請重新整理頁面', true);
      slotWrap.hidden = false;
    }
    syncListingContentGate();
  }

  function selectFeePlanCard(btn, opts) {
    var planList = $('lb-v2-listing-fee-plan-list');
    var planHidden = $('lb-v2-listing-fee-plan');
    if (!btn || !planHidden) return;
    if (planList) {
      var items = planList.querySelectorAll('.lb-v2-fee-plan-pick__item');
      for (var i = 0; i < items.length; i++) items[i].classList.remove('is-selected');
    }
    btn.classList.add('is-selected');
    planHidden.value = btn.getAttribute('data-plan-id') || '';
    planHidden.setAttribute(
      'data-official-direct-slot',
      btn.getAttribute('data-official-direct-slot') || '0'
    );
    planHidden.setAttribute('data-slot-id', btn.getAttribute('data-slot-id') || '');
    planHidden.setAttribute('data-duration-days', btn.getAttribute('data-duration-days') || '');
    planHidden.setAttribute('data-max-interval-days', btn.getAttribute('data-max-interval-days') || '');
    planHidden.setAttribute('data-grant-expires', btn.getAttribute('data-grant-expires') || '');
    planHidden.setAttribute('data-plan-type', btn.getAttribute('data-plan-type') || '');
    planHidden.setAttribute('data-slot-name', btn.getAttribute('data-slot-name') || '');
    planHidden.setAttribute('data-plan-name', btn.getAttribute('data-plan-name') || '');
    applySelectedFeePlan(opts || { keepDates: false });
    syncListingContentGate();
  }

  function getSelectedFeePlanOption() {
    var planHidden = $('lb-v2-listing-fee-plan');
    if (!planHidden) return null;
    var directSlot = planHidden.getAttribute('data-official-direct-slot') === '1';
    if (!planHidden.value && !directSlot) return null;
    return {
      value: planHidden.value,
      textContent: planHidden.getAttribute('data-plan-name') || '',
      getAttribute: function (name) {
        return planHidden.getAttribute(name);
      },
    };
  }

  /** 版位不同，圖片張數與比例就不同；提示必須跟著已選（或已鎖定）的版位走。 */
  function updateListingImageHint(slotName, planName, modeNow) {
    var imgHint = $('lb-v2-listing-images-hint');
    if (!imgHint) return;
    var homeCarouselSlot =
      modeNow !== 'PRIVATE' &&
      /首頁大輪播|首頁輪播|輪播廣告|home[-_\s]?ad[-_\s]?carousel/i.test(
        String(slotName || '') + ' ' + String(planName || '')
      );
    var eventSpotlightSlot =
      modeNow !== 'PRIVATE' && isEventSpotlightSlot(slotName, planName);
    if (homeCarouselSlot) {
      imgHint.textContent =
        '首頁大輪播：第 1 張＝電腦橫幅（長邊建議 ≥1600–2400），第 2 張＝手機圖；缺一張時用另一張代替。第 3–5 張只出現在商品頁，不會進首頁輪播。最多 5 張 JPG / PNG。';
    } else if (eventSpotlightSlot) {
      imgHint.textContent =
        '活動焦點：第 1 張＝大圖（長邊建議 ≥1600），第 2–4 張＝右側小圖；送審至少 4 張。第 5 張只出現在商品頁。副標取自課程說明前段。最多 5 張 JPG / PNG。';
    } else {
      imgHint.textContent =
        '支援 JPG / PNG，最多 5 張。第一張為商品封面。審核通過後會上傳至商品頁多媒體。';
    }
  }

  function applySelectedFeePlan(opts) {
    opts = opts || {};
    var slotHidden = $('lb-v2-listing-slot');
    var exposureWrap = $('lb-v2-listing-exposure-wrap');
    var hint = document.querySelector('#lb-v2-listing-slot-wrap .lb-v2-slot-grant-hint');
    var slotTitle = $('lb-v2-listing-exposure-slot-title');
    var opt = getSelectedFeePlanOption();
    var slotId = opt ? (opt.getAttribute('data-slot-id') || '') : '';
    var durationDays = opt ? parseInt(opt.getAttribute('data-duration-days') || '0', 10) : 0;
    var maxIntervalDays = opt ? parseInt(opt.getAttribute('data-max-interval-days') || '0', 10) : 0;
    var grantExpiresYmd = opt ? (opt.getAttribute('data-grant-expires') || '') : '';
    var slotName = opt ? (opt.getAttribute('data-slot-name') || '') : '';
    var planName = opt ? (opt.getAttribute('data-plan-name') || opt.textContent || '') : '';
    var modeNow = resolveListingMode((($('lb-v2-listing-mode') || {}).value) || '');
    var directSlot = !!(opt && opt.getAttribute('data-official-direct-slot') === '1');
    updateListingImageHint(slotName, planName, modeNow);
    recoverLockedWindowCtxFromEditing();
    if (lockedWindowCtx) {
      renderLockedWindowUi();
      return;
    }
    // 一般廠商公開線：此頁禁止開月曆選日（購買／領取時已選定）。
    if (usesPurchaseLockedListingForm(modeNow)) {
      if (slotHidden) slotHidden.value = slotId || '';
      if (exposureWrap) {
        exposureWrap.hidden = true;
        var calLockedForm = $('lb-v2-exposure-calendar');
        if (calLockedForm) calLockedForm.innerHTML = '';
      }
      // 文案交給 refreshPurchaseLockedListingPlans／renderPendingLockedPickUi，避免蓋掉可選方案提示
      return;
    }
    // PRIVATE year-plan must never bind/require a public slot wall.
    if (slotHidden) slotHidden.value = modeNow === 'PRIVATE' ? '' : slotId;
    if (exposureWrap) {
      if (modeNow === 'PRIVATE') {
        exposureWrap.hidden = false;
        if (slotTitle) {
          slotTitle.textContent = '資格限定課曝光檔期（自動上下架；不上公開牆）';
        }
        loadPrivateExposureCalendar();
      } else if (opt && slotId && (opt.value || directSlot)) {
        exposureWrap.hidden = false;
        if (slotTitle) {
          slotTitle.textContent = directSlot
            ? ('版位「' + (slotName || slotId) + '」檔期（官方免上架費）')
            : ((planName || '已選方案') +
              (slotName ? (' → 版位「' + slotName + '」檔期') : ' → 曝光檔期'));
        }
        loadSlotAvailability(parseInt(slotId, 10));
      } else if (opt && opt.value && !slotId) {
        // Admin「不綁定」方案：不上公開牆，但仍可選曝光起迄（短檔／自動上下架）。
        exposureWrap.hidden = false;
        if (slotTitle) {
          slotTitle.textContent = (planName || '已選方案') + ' → 曝光檔期（不綁公開版位牆）';
        }
        loadPrivateExposureCalendar();
      } else {
        exposureWrap.hidden = true;
        var cal = $('lb-v2-exposure-calendar');
        if (cal) cal.innerHTML = '';
        if (!opts.keepDates) {
          var startEl = $('lb-v2-listing-exposure-start');
          var endEl = $('lb-v2-listing-exposure-end');
          if (startEl) startEl.value = '';
          if (endEl) endEl.value = '';
          syncExposureDateDisplays();
        }
      }
    }
    if (hint) {
      if (!opt || (!opt.value && !directSlot)) {
        hint.textContent = modeNow === 'PRIVATE'
          ? '請先點選要消耗的年約方案；選定後即可在下方月曆選曝光起迄。'
          : (isOfficialFeeExemptVendor()
            ? '官方廠商：請點選方案或版位（免購買）；選定後顯示檔期月曆。'
            : '請先點選「基礎上架」方案；選定後於下方月曆選課程曝光檔期。廣告版位請之後在「課程廣告刊登」加購。');
      } else if (directSlot) {
        hint.textContent = '已選版位「' + (slotName || slotId) + '」（官方免上架費）。請於下方月曆點起日再點迄日；再點同一日起日可取消。';
      } else if (modeNow === 'PRIVATE') {
        var privBits = [];
        if (maxIntervalDays > 0) privBits.push('單次最多 ' + maxIntervalDays + ' 天');
        if (grantExpiresYmd) privBits.push('有效至 ' + formatDateZh(grantExpiresYmd));
        if (durationDays > 0) {
          hint.textContent = '已選「' + planName + '」。資格限定課不上公開版位牆；點月曆起日會自動帶入連續 ' +
            durationDays + ' 天' + (privBits.length ? '（' + privBits.join('，') + '）' : '') + '。';
        } else {
          hint.textContent = '已選「' + planName + '」。資格限定課不上公開版位牆；請於下方月曆點起日再點迄日' +
            (privBits.length ? '（' + privBits.join('，') + '）' : '') +
            '；再點同一日起日可取消。';
        }
      } else if (!slotId) {
        var unboundBits = [];
        if (maxIntervalDays > 0) unboundBits.push('單次最多 ' + maxIntervalDays + ' 天');
        if (grantExpiresYmd) unboundBits.push('有效至 ' + formatDateZh(grantExpiresYmd));
        if (durationDays > 0) {
          hint.textContent = '已選「' + planName + '」（不綁公開版位牆）。點月曆起日會自動帶入連續 ' +
            durationDays + ' 天' + (unboundBits.length ? '（' + unboundBits.join('，') + '）' : '') + '。';
        } else {
          hint.textContent = '已選「' + planName + '」（不綁公開版位牆）。請於下方月曆點起日再點迄日' +
            (unboundBits.length ? '（' + unboundBits.join('，') + '）' : '') +
            '；再點同一日起日可取消。';
        }
      } else if (durationDays > 0) {
        hint.textContent = '已選「' + planName + '」· 版位「' + (slotName || slotId) + '」。點月曆起日會自動帶入連續 ' + durationDays + ' 天。';
      } else {
        var passBits = [];
        if (maxIntervalDays > 0) passBits.push('單次最多 ' + maxIntervalDays + ' 天');
        if (grantExpiresYmd) passBits.push('有效至 ' + formatDateZh(grantExpiresYmd));
        hint.textContent = '已選「' + planName + '」' + (slotName ? '（版位：' + slotName + '）' : '') +
          '。請先點起日，再點迄日' +
          (passBits.length ? '（' + passBits.join('，') + '）' : '') +
          '；再點同一日起日可取消。';
      }
    }
    if (!opts.keepDates && durationDays > 0) {
      applyExposureDurationFromStart();
    }
  }

  function formatDateZh(ymd) {
    if (!ymd || !/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return '';
    var parts = ymd.split('-');
    return parts[0] + '年' + parseInt(parts[1], 10) + '月' + parseInt(parts[2], 10) + '日';
  }

  function syncExposureDateDisplays() {
    var startEl = $('lb-v2-listing-exposure-start');
    var endEl = $('lb-v2-listing-exposure-end');
    var startDisp = $('lb-v2-listing-exposure-start-display');
    var endDisp = $('lb-v2-listing-exposure-end-display');
    var durationDays = getSelectedPlanDurationDays();
    if (startDisp) {
      var sv = startEl ? startEl.value : '';
      startDisp.textContent = sv ? formatDateZh(sv) : '請於上方月曆選擇';
      startDisp.classList.toggle('is-set', !!sv);
    }
    if (endDisp) {
      var ev = endEl ? endEl.value : '';
      if (durationDays > 0) {
        endDisp.textContent = ev ? (formatDateZh(ev) + '（短檔自動）') : '選擇起日後自動帶入';
        endDisp.classList.add('is-locked');
      } else {
        endDisp.textContent = ev ? formatDateZh(ev) : '請於上方月曆選擇迄日';
        endDisp.classList.remove('is-locked');
      }
      endDisp.classList.toggle('is-set', !!ev);
    }
  }

  function focusExposureCalendar() {
    var cal = $('lb-v2-exposure-calendar');
    if (cal && typeof cal.scrollIntoView === 'function') {
      cal.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function addDaysYmd(ymd, days) {
    var d = new Date(ymd + 'T00:00:00');
    if (isNaN(d.getTime())) return '';
    d.setDate(d.getDate() + days);
    var yyyy = d.getFullYear();
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return yyyy + '-' + mm + '-' + dd;
  }

  function toPlanYmd(isoOrYmd) {
    if (!isoOrYmd) return '';
    var m = String(isoOrYmd).match(/^(\d{4}-\d{2}-\d{2})/);
    return m ? m[1] : '';
  }

  function minYmd(a, b) {
    if (!a) return b || '';
    if (!b) return a || '';
    return a <= b ? a : b;
  }

  function getSelectedPlanDurationDays() {
    var opt = getSelectedFeePlanOption();
    if (!opt) return 0;
    return parseInt(opt.getAttribute('data-duration-days') || '0', 10) || 0;
  }

  function getSelectedPlanMaxIntervalDays() {
    var opt = getSelectedFeePlanOption();
    if (!opt) return 0;
    return parseInt(opt.getAttribute('data-max-interval-days') || '0', 10) || 0;
  }

  function getSelectedPlanGrantExpiresYmd() {
    var opt = getSelectedFeePlanOption();
    if (!opt) return '';
    return toPlanYmd(opt.getAttribute('data-grant-expires') || '');
  }

  function applyExposureDurationFromStart() {
    var startEl = $('lb-v2-listing-exposure-start');
    var endEl = $('lb-v2-listing-exposure-end');
    if (!startEl || !endEl || !startEl.value) {
      syncExposureDateDisplays();
      highlightSelectedExposureDays();
      return;
    }
    var days = getSelectedPlanDurationDays();
    if (days > 0) {
      // 連續 N 天：起日算第 1 天 → 迄日 = 起日 + (N-1)
      endEl.value = addDaysYmd(startEl.value, days - 1);
    }
    syncExposureDateDisplays();
    highlightSelectedExposureDays();
  }

  function highlightSelectedExposureDays() {
    var cal = $('lb-v2-exposure-calendar');
    if (!cal) return;
    var startEl = $('lb-v2-listing-exposure-start');
    var endEl = $('lb-v2-listing-exposure-end');
    var start = startEl ? startEl.value : '';
    var end = endEl ? endEl.value : '';
    // 僅在起迄都選定後才標粉色區間；只選起日時不可鎖住後續日期
    var hasRange = !!(start && end && end >= start);
    var maxInterval = getSelectedPlanMaxIntervalDays();
    var grantExp = getSelectedPlanGrantExpiresYmd();
    var previewEnd = '';
    if (start && !hasRange) {
      previewEnd = start;
      if (maxInterval > 0) previewEnd = addDaysYmd(start, maxInterval - 1);
      previewEnd = minYmd(previewEnd, grantExp) || previewEnd;
      var calMax = cal.getAttribute('data-max-end') || '';
      previewEnd = minYmd(previewEnd, calMax) || previewEnd;
    }
    var nodes = cal.querySelectorAll('.lb-v2-cal-day[data-day]');
    for (var i = 0; i < nodes.length; i++) {
      var day = nodes[i].getAttribute('data-day') || '';
      var inRange = !!(hasRange && day >= start && day <= end);
      var isStart = !!(start && day === start);
      var endHint = !!(previewEnd && day > start && day <= previewEnd);
      nodes[i].classList.toggle('lb-v2-cal-day--selected', isStart);
      nodes[i].classList.toggle('lb-v2-cal-day--in-range', inRange && !isStart);
      nodes[i].classList.toggle('lb-v2-cal-day--end-hint', endHint);
    }
  }

  function bindExposureDateAutoFill() {
    var startDisp = $('lb-v2-listing-exposure-start-display');
    var endDisp = $('lb-v2-listing-exposure-end-display');
    if (startDisp && !startDisp._lbCalFocusBound) {
      startDisp._lbCalFocusBound = true;
      startDisp.addEventListener('click', focusExposureCalendar);
    }
    if (endDisp && !endDisp._lbCalFocusBound) {
      endDisp._lbCalFocusBound = true;
      endDisp.addEventListener('click', function () {
        if (getSelectedPlanDurationDays() > 0) return;
        focusExposureCalendar();
      });
    }
  }

  function toggleExposureSection() {
    applySelectedFeePlan({ keepDates: true });
  }

  function ymdLocal(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  var slotAvailCache = {};

  /** PRIVATE has no public slot wall — synthesize open days within grant / 180d window. */
  function buildOpenExposureDays(startYmd, endYmd) {
    var days = [];
    if (!startYmd || !endYmd || endYmd < startYmd) return days;
    var cur = startYmd;
    var guard = 0;
    while (cur && cur <= endYmd && guard < EXPOSURE_CALENDAR_DAYS + 14) {
      days.push({ day: cur, available: 1, max: 0 });
      cur = addDaysYmd(cur, 1);
      guard += 1;
    }
    return days;
  }

  function loadPrivateExposureCalendar() {
    var cal = $('lb-v2-exposure-calendar');
    if (!cal) return;
    var now = new Date();
    var start = ymdLocal(now);
    var endD = new Date(now.getFullYear(), now.getMonth(), now.getDate() + EXPOSURE_CALENDAR_DAYS);
    var windowEnd = ymdLocal(endD);
    var grantExp = getSelectedPlanGrantExpiresYmd();
    var end = minYmd(windowEnd, grantExp) || windowEnd;
    // PRIVATE 無公開版位牆，後端不套 MIN_EXPOSURE_LEAD_DAYS；月曆允許當日起曝光。
    renderExposureCalendar(buildOpenExposureDays(start, end), 0, end, { privateMode: true });
  }

  async function loadSlotAvailability(slotId) {
    var cal = $('lb-v2-exposure-calendar');
    if (!cal) return;
    var now = new Date();
    var start = ymdLocal(now);
    var endD = new Date(now.getFullYear(), now.getMonth(), now.getDate() + EXPOSURE_CALENDAR_DAYS);
    var windowEnd = ymdLocal(endD);
    var grantExp = getSelectedPlanGrantExpiresYmd();
    var end = minYmd(windowEnd, grantExp) || windowEnd;
    // Sending the slug + the listing being edited lets the backend flag days this
    // listing still holds from a previous unpublish, so its own reserved window is
    // not shown as full. Another listing's hold must stay "full" — only the listing
    // that owns a hold may reuse it at submit.
    var slug = getListingVendorSlug();
    var editingIdEl = $('lb-v2-listing-id');
    var editingId = editingIdEl ? String(editingIdEl.value || '').trim() : '';
    var key = slotId + '_' + start + '_' + end + '_' + (slug || '') + '_' + editingId;
    if (slotAvailCache[key]) {
      renderExposureCalendar(slotAvailCache[key].days, resolveMinLeadDays(slotAvailCache[key].min_lead_days, SLOT_ADDON_MIN_LEAD_DAYS), end);
      return;
    }
    cal.innerHTML = '<p class="lb-v2-hint">載入版位可用量中…</p>';
    try {
      var qs = '?slot_id=' + slotId + '&start_date=' + start + '&end_date=' + end +
        (slug ? '&vendor_slug=' + encodeURIComponent(slug) : '') +
        (editingId && /^\d+$/.test(editingId) ? '&listing_id=' + editingId : '');
      var resp = await fetch(PATHS.slotAvailability + qs, {
        method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin',
      });
      var data = await resp.json();
      if (data && data.ok) {
        slotAvailCache[key] = data;
        renderExposureCalendar(data.days, resolveMinLeadDays(data.min_lead_days, SLOT_ADDON_MIN_LEAD_DAYS), end);
      } else {
        cal.innerHTML = '<p class="lb-v2-hint" style="color:#c0392b">載入版位可用量失敗</p>';
      }
    } catch (e) {
      cal.innerHTML = '<p class="lb-v2-hint" style="color:#c0392b">載入版位可用量失敗</p>';
    }
  }

  function renderExposureCalendar(days, minLeadDays, maxEndYmd, calOpts) {
    calOpts = calOpts || {};
    var isPrivateCal = !!calOpts.privateMode;
    var cal = $('lb-v2-exposure-calendar');
    var hintEl = $('lb-v2-exposure-hint');
    if (!cal) return;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    // 不可用 `|| 5`：PRIVATE lead=0 會被誤當成 5。
    var leadDays = Number(minLeadDays);
    if (!Number.isFinite(leadDays) || leadDays < 0) {
      leadDays = isPrivateCal ? 0 : 5;
    }
    var earliest = new Date(today);
    earliest.setDate(earliest.getDate() + leadDays);
    var earliestYmd = earliest.getFullYear() + '-' +
      String(earliest.getMonth() + 1).padStart(2, '0') + '-' +
      String(earliest.getDate()).padStart(2, '0');
    var durationDays = getSelectedPlanDurationDays();
    var maxIntervalDays = getSelectedPlanMaxIntervalDays();
    var grantExpiresYmd = getSelectedPlanGrantExpiresYmd();
    // 短檔：整段迄日不可超過可預約上限 → 最晚可選起日 = 上限 − (天數−1)
    var latestStartYmd = maxEndYmd || '';
    if (durationDays > 1 && maxEndYmd) {
      latestStartYmd = addDaysYmd(maxEndYmd, -(durationDays - 1));
    }
    cal.setAttribute('data-max-end', maxEndYmd || '');
    cal.setAttribute('data-latest-start', latestStartYmd || '');
    cal.setAttribute('data-duration-days', String(durationDays || 0));
    cal.setAttribute('data-max-interval-days', String(maxIntervalDays || 0));
    cal.setAttribute('data-private-cal', isPrivateCal ? '1' : '0');

    if (hintEl) {
      var windowLabel = grantExpiresYmd && maxEndYmd === grantExpiresYmd
        ? ((isPrivateCal ? '年約' : '通行證') + '有效至 <strong>' + formatDateZh(maxEndYmd) + '</strong>')
        : ('未來 ' + EXPOSURE_CALENDAR_DAYS + ' 天內' +
          (maxEndYmd ? ('（檔期最晚至 <strong>' + formatDateZh(maxEndYmd) + '</strong>）') : ''));
      var leadHint = leadDays > 0
        ? ('（需提前 ' + leadDays + ' 天）')
        : (isPrivateCal ? '（當日即可）' : '');
      hintEl.innerHTML = '目前可預約' + windowLabel +
        '。曝光起日最早 <strong>' + formatDateZh(earliestYmd) + '</strong>' + leadHint +
        (latestStartYmd && durationDays > 1
          ? ('；短檔 ' + durationDays + ' 天最晚起日 <strong>' + formatDateZh(latestStartYmd) + '</strong>（避免迄日超出上限）')
          : '') +
        (maxIntervalDays > 0 && durationDays <= 0
          ? ('；單次排程最長 <strong>' + maxIntervalDays + ' 天</strong>')
          : '') +
        '。' +
        (durationDays > 0
          ? ('短檔固定 <strong>' + durationDays + ' 天</strong>：點起日即自動帶迄日。')
          : '點起日，再點迄日（淡粉外框＝可選迄日範圍；再點同一日起日可取消）。') +
        (isPrivateCal
          ? ' 課程日期須落在曝光檔期內。玫瑰框＝已選曝光區間（不上公開版位牆）。'
          : ' 課程日期須落在曝光檔期內。綠＝有空位，紅＝已滿，藍「保」＝你下架後保留的原檔期（可沿用），玫瑰框＝已選區間。');
    }

    if (!days || !days.length) {
      cal.innerHTML = '';
      syncExposureDateDisplays();
      return;
    }

    var byDay = {};
    days.forEach(function (d) { byDay[d.day] = d; });

    var months = {};
    days.forEach(function (d) {
      var m = d.day.slice(0, 7);
      if (!months[m]) months[m] = true;
    });
    // 確保含上限當月完整格線（超出日顯示為不可選）
    if (maxEndYmd) months[maxEndYmd.slice(0, 7)] = true;

    var WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];
    var html = '';
    Object.keys(months).sort().forEach(function (ym) {
      var parts = ym.split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10); // 1-12
      var first = new Date(year, month - 1, 1);
      var daysInMonth = new Date(year, month, 0).getDate();
      var startWeekday = first.getDay(); // 0=Sun

      html += '<div class="lb-v2-cal-month">';
      html += '<div class="lb-v2-cal-month__head">' + year + ' 年 ' + month + ' 月</div>';
      html += '<div class="lb-v2-cal-weekdays">';
      WEEKDAYS.forEach(function (w) {
        html += '<span class="lb-v2-cal-weekday">' + w + '</span>';
      });
      html += '</div><div class="lb-v2-cal-grid">';

      var i;
      for (i = 0; i < startWeekday; i++) {
        html += '<span class="lb-v2-cal-day lb-v2-cal-day--empty" aria-hidden="true"></span>';
      }
      for (var dayNum = 1; dayNum <= daysInMonth; dayNum++) {
        var ymd = ym + '-' + String(dayNum).padStart(2, '0');
        var d = byDay[ymd];
        var dayDate = new Date(ymd + 'T00:00:00');
        var isPast = dayDate < earliest;
        // A day the vendor still holds from their own unpublish is reusable by
        // them even though it counts as occupied for everyone else.
        var heldByMe = !!(d && d.held_by_me);
        var isFull = d && d.max > 0 && d.available <= 0 && !heldByMe;
        var noData = !d;
        var beyondWindow = !!(maxEndYmd && ymd > maxEndYmd);
        // 短檔：起日選了之後迄日會超出上限 → 不可當起日
        var startTooLate = !!(latestStartYmd && durationDays > 0 && ymd > latestStartYmd);
        var canStart = !(noData || isPast || isFull || beyondWindow || startTooLate);
        var cls = 'lb-v2-cal-day';
        if (!canStart) {
          if (isFull && !beyondWindow && !isPast && !startTooLate) cls += ' lb-v2-cal-day--full';
          else cls += ' lb-v2-cal-day--past';
        } else {
          cls += ' lb-v2-cal-day--ok';
          if (heldByMe) cls += ' lb-v2-cal-day--held';
        }
        var availText = d && d.max > 0 ? String(d.available) : (d ? '∞' : '—');
        if (heldByMe && canStart) availText = '保';
        var title = formatDateZh(ymd);
        if (beyondWindow) title += '　超出可預約上限，不可選';
        else if (startTooLate) title += '　短檔迄日會超出上限，不可當起日';
        else if (isFull) title += '　已滿';
        else if (heldByMe) title += '　你的保留檔期（可沿用）';
        else if (d) title += '　剩餘 ' + availText;
        else title += '　無資料';
        html += '<button type="button" class="' + cls + '" data-day="' + ymd +
          '" data-can-start="' + (canStart ? '1' : '0') +
          '" title="' + title + '"' + (canStart ? '' : ' disabled tabindex="-1"') + '>' +
          '<span class="lb-v2-cal-day__num">' + dayNum + '</span>' +
          '<span class="lb-v2-cal-day__cap">' + (canStart ? availText : '') + '</span>' +
          '</button>';
      }
      html += '</div></div>';
    });
    cal.innerHTML = html;

    // 若目前已選區間會超出上限，清掉
    var startEl = $('lb-v2-listing-exposure-start');
    var endEl = $('lb-v2-listing-exposure-end');
    if (startEl && startEl.value) {
      var endVal = endEl ? endEl.value : '';
      if (durationDays > 0) endVal = addDaysYmd(startEl.value, durationDays - 1);
      if ((latestStartYmd && startEl.value > latestStartYmd) ||
          (maxEndYmd && endVal && endVal > maxEndYmd)) {
        startEl.value = '';
        if (endEl) endEl.value = '';
      } else if (durationDays > 0 && endEl) {
        endEl.value = endVal;
      }
    }

    highlightSelectedExposureDays();
    syncExposureDateDisplays();
  }

  async function fetchFeePlans(listingMode, slug) {
    var cacheKey = (listingMode || '') + '_' + (slug || '');
    if (cachedFeePlans[cacheKey]) return cachedFeePlans[cacheKey];
    var qs = '?listing_mode=' + encodeURIComponent(listingMode || '');
    if (slug) qs += '&vendor_slug=' + encodeURIComponent(slug);
    var response = await fetch(PATHS.feePlans + qs, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    var payload = null;
    try { payload = await response.json(); } catch (e) { payload = null; }
    if (!(payload && payload.ok)) {
      var planErr = extractApiError(payload);
      var errMsg = planErr.code ? '[' + planErr.code + '] ' + planErr.message : (planErr.message || ('無法載入上架費方案 (HTTP ' + response.status + ')'));
      throw new Error(errMsg);
    }
    cachedFeePlans[cacheKey] = payload.plans || [];
    return cachedFeePlans[cacheKey];
  }

  /** Module switched off by 官方: existing quota still submits, new purchases stop. */
  function isModulePurchaseClosed(mode) {
    if (!cachedEntitlement) return false;
    var m = findModeEntitlement(mode);
    return !!(m && m.can_purchase === false);
  }

  /** Official module switch off (soft or force). Absent entitlement row ≠ disabled. */
  function isModuleDisabled(mode) {
    var key = String(mode || '').toUpperCase();
    var m = findModeEntitlement(key);
    if (m) return m.module_enabled === false;
    return !!cachedModuleDisabled[key];
  }

  // 「不綁定版位」的方案就是基礎上架單：先買它，課程才會有商品與曝光檔期。
  var BASE_LISTING_GROUP_TITLE = '基礎上架（不綁版位）';

  function isBaseListingPlan(p) {
    return !p || p.slot_id == null || p.slot_id === '';
  }

  // ── 購買即鎖定曝光檔期 ─────────────────────────────────────
  // docs/purchase-locked-exposure-window-spec.md
  // 買的是「哪個版位的哪一段日子」：先選日 → 建佔位單 → 帶著它去結帳。
  // 付款後日期就鎖死，之後只補內容。免費方案改成當場「領取檔期」。

  var PURCHASE_WINDOW_MIN_LEAD_DAYS = 5;
  var feePurchasePlansCache = [];
  var feePurchasePlansById = {};
  var feePurchaseCardOpts = {};
  /** 與後端 PURCHASE_HOLD_MINUTES 對齊；只影響文案。 */
  var PURCHASE_WINDOW_HOLD_MINUTES = 30;

  function pwTodayYmd() {
    var d = new Date();
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }

  function pwAddDays(ymd, days) {
    var parts = String(ymd || '').split('-');
    var d = new Date(Date.UTC(
      parseInt(parts[0], 10),
      (parseInt(parts[1], 10) || 1) - 1,
      parseInt(parts[2], 10) || 1
    ));
    d.setUTCDate(d.getUTCDate() + days);
    return d.toISOString().slice(0, 10);
  }

  function planVariantNumId(p) {
    if (!p || !p.shopify_variant_id) return '';
    var gid = String(p.shopify_variant_id);
    var m = gid.match(/(\d+)\s*$/);
    return m ? m[1] : gid.replace(/\D/g, '');
  }

  function buildExposureWindowPickerHtml(p, slug, parentListingId) {
    var isFree = Number(p.price) === 0;
    var durationDays = parseInt(p.duration_days, 10) || 0;
    var earliest = pwAddDays(pwTodayYmd(), PURCHASE_WINDOW_MIN_LEAD_DAYS);
    var freeBucket = isFree ? freeQuotaBucketForSlot(p.slot_id || null) : null;
    var freeRemaining = freeBucket ? (parseInt(freeBucket.remaining, 10) || 0) : null;
    var exhausted = freeRemaining !== null && freeRemaining <= 0;

    var html = '<div class="lb-v2-fee-plan-window" data-plan-id="' + p.id + '"' +
      ' data-duration-days="' + durationDays + '"' +
      ' data-slot-id="' + escapeHtml(String(p.slot_id || '')) + '"' +
      ' data-variant-id="' + escapeHtml(planVariantNumId(p)) + '"' +
      ' data-slug="' + escapeHtml(slug || '') + '"' +
      ' data-parent-listing-id="' + escapeHtml(String(parentListingId || '')) + '"' +
      ' style="margin-top:0.6rem;">';

    if (exhausted) {
      html += '<p class="lb-v2-hint" style="color:#c0392b;margin:0;">免費次數已用完（上限 ' +
        freeBucket.limit + ' 次），請改選付費方案</p></div>';
      return html;
    }

    // 營運結帳廣告方案只鎖版位曝光窗；母課改到「課程廣告刊登」套用。
    // 若呼叫端預填 data-parent-listing-id（課程廣告一次買＋綁），submit 仍會帶上。
    var isAddonPlan = !isBaseListingPlan(p);
    if (isAddonPlan && !parentListingId) {
      html += '<p class="lb-v2-hint" style="margin:0 0 0.55rem;">' +
        '此處只鎖定版位曝光檔期；之後到「課程廣告刊登」選擇要掛上的基礎上架課程。' +
        '</p>';
    }

    html += '<label class="lb-v2-fee-plan-window__label">曝光起日</label>' +
      '<input type="date" class="lb-v2-input lb-v2-fee-plan-window-start" data-window-start ' +
        'min="' + earliest + '" style="width:100%;">';

    if (durationDays > 0) {
      html += '<p class="lb-v2-hint" data-window-end-hint style="margin:0.3rem 0 0;">' +
        '短檔 ' + durationDays + ' 天：選起日後自動排到迄日</p>';
    } else {
      html += '<label class="lb-v2-fee-plan-window__label">曝光迄日</label>' +
        '<input type="date" class="lb-v2-input lb-v2-fee-plan-window-end" data-window-end ' +
          'min="' + earliest + '" style="width:100%;">';
    }

    if (p.slot_id) {
      html += '<div class="lb-v2-fee-plan-window__cal">' +
        '<div class="lb-v2-fee-plan-window__cal-head">' +
          '<p class="lb-v2-fee-plan-window__cal-label">版位剩餘容量</p>' +
          '<div class="lb-v2-fee-plan-window__legend" aria-hidden="true">' +
            '<span class="lb-v2-fee-plan-window__legend-item is-ok">有空</span>' +
            '<span class="lb-v2-fee-plan-window__legend-item is-full">已滿</span>' +
            '<span class="lb-v2-fee-plan-window__legend-item is-sel">已選</span>' +
          '</div>' +
        '</div>' +
        '<p class="lb-v2-hint lb-v2-fee-plan-window__cal-hint" data-window-cal-hint></p>' +
        '<div class="lb-v2-exposure-calendar lb-v2-fee-plan-window__calendar" data-window-calendar></div>' +
      '</div>' +
      '<p class="lb-v2-hint" data-window-avail style="margin:0.35rem 0 0;"></p>';
    }

    // CTA 改放 modal footer（與「稍後再說」並列固定底部）
    html += '<p class="lb-v2-hint" data-window-msg style="margin:0.55rem 0 0;">' +
      (isFree
        ? '領取後檔期即鎖定並計入免費次數' +
          (freeRemaining !== null ? ('（此版位剩 ' + freeRemaining + '／' + freeBucket.limit + ' 次）') : '') +
          '，之後不可改期。'
        : '按下後會先為你保留 ' + PURCHASE_WINDOW_HOLD_MINUTES + ' 分鐘，' +
          '完成付款才正式鎖定；逾時未付款會自動釋放。') +
      '</p>';

    html += '</div>';
    return html;
  }

  function pwSetMessage(box, text, isError) {
    var msg = box ? box.querySelector('[data-window-msg]') : null;
    if (!msg) return;
    msg.textContent = text;
    msg.style.color = isError ? '#c0392b' : '';
  }

  function pwWindowDates(box) {
    var startEl = box ? box.querySelector('[data-window-start]') : null;
    var endEl = box ? box.querySelector('[data-window-end]') : null;
    var durationDays = parseInt(box.getAttribute('data-duration-days'), 10) || 0;
    var start = startEl ? String(startEl.value || '') : '';
    var end = durationDays > 0
      ? (start ? pwAddDays(start, durationDays - 1) : '')
      : (endEl ? String(endEl.value || '') : '');
    return { start: start, end: end };
  }

  /**
   * 選完日就先問一次每日剩餘：日曆與送審用同一套 occupancy，先問這裡等於先看到
   * 「這天已滿」，不用等按下去被 SLOT_CAPACITY_FULL 打回。
   */
  async function pwCheckAvailability(box) {
    if (!box) return;
    var line = box.querySelector('[data-window-avail]');
    if (!line) return;
    var slotId = parseInt(box.getAttribute('data-slot-id'), 10) || 0;
    var range = pwWindowDates(box);
    box.removeAttribute('data-window-full');
    box.removeAttribute('data-window-full-msg');
    box.removeAttribute('data-window-over-parent');
    box.removeAttribute('data-window-over-parent-msg');
    if (!slotId || !range.start || !range.end || range.end < range.start) {
      line.textContent = '';
      line.style.color = '';
      return;
    }
    var parentStart = box.getAttribute('data-parent-start') || '';
    var parentEnd = box.getAttribute('data-parent-end') || '';
    if ((parentStart && range.start < parentStart) || (parentEnd && range.end > parentEnd)) {
      var overMsg = '短檔會變成 ' + range.start + ' ~ ' + range.end +
        '，已超出基礎上架曝光範圍（' + (parentStart || '—') + ' ~ ' + (parentEnd || '—') +
        '），請改選較早的起日。';
      box.setAttribute('data-window-over-parent', '1');
      box.setAttribute('data-window-over-parent-msg', overMsg);
      line.style.color = '#c0392b';
      line.textContent = '超出基礎上架曝光範圍（' + range.start + ' ~ ' + range.end + '）';
      showPortalAlert(overMsg, '超出基礎上架曝光範圍');
      return;
    }
    var slug = box.getAttribute('data-slug') || getListingVendorSlug();
    var key = slotId + '_' + range.start + '_' + range.end + '_' + (slug || '') + '_pw';
    line.style.color = '';
    line.textContent = '查詢版位可用量中…';
    try {
      var data = slotAvailCache[key];
      if (!data) {
        var qs = '?slot_id=' + slotId + '&start_date=' + range.start +
          '&end_date=' + range.end +
          (slug ? '&vendor_slug=' + encodeURIComponent(slug) : '');
        var resp = await fetch(PATHS.slotAvailability + qs, {
          method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin',
        });
        data = await resp.json();
        if (!data || !data.ok) throw new Error('unavailable');
        slotAvailCache[key] = data;
      }
      var days = (data.days || []).filter(function (d) {
        return d.day >= range.start && d.day <= range.end;
      });
      if (!days.length) {
        line.textContent = '';
        return;
      }
      var full = days.filter(function (d) { return Number(d.available) <= 0; });
      if (full.length) {
        var fullMsg = '此檔期有 ' + full.length + ' 天已滿（' +
          full.slice(0, 3).map(function (d) { return d.day; }).join('、') +
          (full.length > 3 ? ' 等' : '') + '），請改選其他日期';
        box.setAttribute('data-window-full', '1');
        box.setAttribute('data-window-full-msg', fullMsg);
        // 已滿改由彈窗警示，月曆下方只留簡短狀態，避免兩行紅字堆在按鈕上。
        line.style.color = '#c0392b';
        line.textContent = '所選檔期有日期已滿';
        return;
      }
      var least = days.reduce(function (min, d) {
        return Number(d.available) < Number(min.available) ? d : min;
      }, days[0]);
      var dayQuotaBits = days.map(function (d) {
        var cap = Number(d.max) <= 0 ? '∞' : String(Number(d.available));
        return d.day.slice(5).replace('-', '/') + ' 剩 ' + cap;
      });
      line.style.color = '';
      // max_capacity <= 0 ＝ 不限量，後端回 999，別把它當成「還有 999 席」報出去。
      line.textContent = Number(least.max) <= 0
        ? ('此檔期可購買（' + range.start + ' ~ ' + range.end + '；此版位不限每日席次）')
        : ('此檔期可購買（' + range.start + ' ~ ' + range.end + '；' +
          dayQuotaBits.join('、') +
          '；最緊 ' + least.day + ' 尚餘 ' + Number(least.available) + ' 席）');
    } catch (e) {
      line.style.color = '';
      line.textContent = '';
    }
  }

  var exposureWindowSubmitInFlight = false;

  /**
   * 鎖窗會實際吃掉版位容量並開出訂單，重複送出就是重複佔位。
   * 下面那層只在 btn 找得到時才 disable，這道閘不依賴 DOM。
   */
  async function submitExposureWindow(box, action) {
    if (exposureWindowSubmitInFlight) return;
    exposureWindowSubmitInFlight = true;
    try {
      return await submitExposureWindowInner(box, action);
    } finally {
      exposureWindowSubmitInFlight = false;
    }
  }

  async function submitExposureWindowInner(box, action) {
    if (!box) return;
    var btn = box.querySelector('[data-window-action]') ||
      document.querySelector('#lb-v2-modal-actions .lb-v2-btn--accent');
    var startEl = box.querySelector('[data-window-start]');
    var endEl = box.querySelector('[data-window-end]');
    var durationDays = parseInt(box.getAttribute('data-duration-days'), 10) || 0;
    var planId = parseInt(box.getAttribute('data-plan-id'), 10) || 0;
    var slug = box.getAttribute('data-slug') || getListingVendorSlug();
    var parentSelect = box.querySelector('[data-window-parent]');
    var parentListingId = parentSelect
      ? parseInt(parentSelect.value, 10) || 0
      : parseInt(box.getAttribute('data-parent-listing-id'), 10) || 0;
    var start = startEl ? String(startEl.value || '') : '';
    var end = durationDays > 0
      ? (start ? pwAddDays(start, durationDays - 1) : '')
      : (endEl ? String(endEl.value || '') : '');

    if (!start || !end) {
      showPortalAlert('請先選擇曝光檔期', '無法鎖定檔期');
      return;
    }
    if (end < start) {
      showPortalAlert('曝光迄日不能早於起日', '無法鎖定檔期');
      return;
    }
    if (box.getAttribute('data-window-full') === '1') {
      showPortalAlert(
        box.getAttribute('data-window-full-msg') || '此檔期有日期已滿，請改選其他日期',
        '檔期已滿'
      );
      return;
    }
    if (box.getAttribute('data-window-over-parent') === '1') {
      showPortalAlert(
        box.getAttribute('data-window-over-parent-msg') || '廣告檔期超出基礎上架曝光範圍',
        '超出基礎上架曝光範圍'
      );
      return;
    }

    if (btn) btn.disabled = true;
    pwSetMessage(box, action === 'claim' ? '領取中…' : '鎖定檔期中…', false);

    var body = {
      vendor_slug: slug,
      fee_plan_id: planId,
      exposure_start_at: start,
      exposure_end_at: end,
    };
    if (parentListingId) body.parent_listing_id = parentListingId;

    var result = await postAppProxyJson(
      action === 'claim' ? PATHS.listingClaimWindow : PATHS.listingPurchaseHold,
      body
    );
    if (!result.ok) {
      if (btn) btn.disabled = false;
      pwSetMessage(box, '', false);
      showPortalAlert(
        formatPortalError(result.code, result.message || '鎖定檔期失敗'),
        result.code === 'SLOT_CAPACITY_FULL' ? '檔期已滿' : '無法鎖定檔期'
      );
      return;
    }

    // 剛吃掉一席，快取裡的剩餘數就過時了。
    slotAvailCache = {};

    if (action === 'claim') {
      var slotIdOnBox = parseInt(box.getAttribute('data-slot-id'), 10) || 0;
      var isBaseClaim = !slotIdOnBox;
      var lockedListingId = (result.payload && result.payload.listing_id) || 0;
      var claimMsg;
      var claimNav = null;
      var claimAdsCreate = false;
      if (parentListingId) {
        claimMsg = '已領取 ' + start + ' ~ ' + end + '，已建立廣告草稿：請到「課程廣告刊登」補廣告圖後送審。';
        claimNav = 'course-ads';
        claimAdsCreate = true;
      } else if (isBaseClaim) {
        claimMsg = '已領取 ' + start + ' ~ ' + end + '：請到「上架新課程」選擇額度方案並補完內容後送審。';
        claimNav = 'course-new';
      } else {
        claimMsg = '已領取 ' + start + ' ~ ' + end + '：請到「課程廣告刊登」選擇要套用的基礎上架課程。';
        claimNav = 'course-ads';
        claimAdsCreate = true;
      }
      pwSetMessage(box, claimMsg, false);
      cachedEntitlement = null;
      clearFeeEntitlementTtlCache();
      try { closeModal(); } catch (e) { /* ignore */ }
      await refreshListingItemsAfterWindowLock();
      await loadFeePurchasePlans();
      showListingSuccess(claimMsg, '已領取檔期', {
        navigate: claimNav,
        listingId: isBaseClaim ? lockedListingId : 0,
        adsCreate: claimAdsCreate,
      });
      return;
    }

    var variantId = box.getAttribute('data-variant-id') || '';
    if (!variantId) {
      if (btn) btn.disabled = false;
      pwSetMessage(box, '方案尚未連結 LadyBae 商品，請聯繫官方', true);
      return;
    }
    var heldListingId = (result.payload && result.payload.listing_id) || 0;
    if (!heldListingId) {
      if (btn) btn.disabled = false;
      pwSetMessage(box, '佔位失敗，請重新選擇檔期', true);
      return;
    }
    var props = 'properties%5Bslug_handle%5D=' + encodeURIComponent(slug) +
      '&properties%5Blisting_id%5D=' + encodeURIComponent(heldListingId);
    window.location.href = '/cart/add?id=' + encodeURIComponent(variantId) +
      '&quantity=1&' + props + '&return_to=/cart';
  }

  /** 加購檔期必須落在母課檔期內，直接把日期範圍夾在母課上，少一趟被打回。 */
  function pwSyncParentRange(box) {
    if (!box) return;
    var select = box.querySelector('[data-window-parent]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var pStart = opt.getAttribute('data-parent-start') || '';
    var pEnd = opt.getAttribute('data-parent-end') || '';
    var earliest = pwAddDays(pwTodayYmd(), PURCHASE_WINDOW_MIN_LEAD_DAYS);
    var min = pStart && pStart > earliest ? pStart : earliest;
    ['[data-window-start]', '[data-window-end]'].forEach(function (sel) {
      var input = box.querySelector(sel);
      if (!input) return;
      input.setAttribute('min', min);
      if (pEnd) input.setAttribute('max', pEnd);
      else input.removeAttribute('max');
      if (input.value && (input.value < min || (pEnd && input.value > pEnd))) {
        input.value = '';
        try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) { /* ignore */ }
      }
    });
    var hint = box.querySelector('[data-window-parent-hint]');
    if (hint) {
      hint.textContent = pStart && pEnd
        ? '課程上架檔期：' + pStart + ' ~ ' + pEnd + '（廣告檔期需落在此範圍內）'
        : '';
    }
  }

  /**
   * 營運結帳／廣告加購：把裸 type=date 升級成 createDynPickerField。
   * Shopify theme 常把原生 date 洗成空粉框、點不開；dyn picker 與開課日同一套。
   */
  function upgradeBareWindowDateInput(input, role) {
    if (!input || !input.parentNode) return null;
    if (input.classList.contains('lb-v2-picker-native')) return input;
    var existing = input.closest('.lb-v2-picker-field');
    if (existing) {
      return existing.querySelector('.lb-v2-picker-native') || input;
    }
    var box = input.closest('.lb-v2-fee-plan-window') ||
      input.closest('[data-ad-slot-card]') ||
      input.parentElement;
    var planId = (box && (box.getAttribute('data-plan-id') || box.getAttribute('data-plan'))) || 'x';
    var uid = 'lb-v2-win-' + role + '-' + String(planId).replace(/\W+/g, '') + '-' +
      String(Date.now()).slice(-4) + String(Math.floor(Math.random() * 90 + 10));
    var min = input.getAttribute('min') || '';
    var max = input.getAttribute('max') || '';
    var val = String(input.value || '').trim();
    var wrap = createDynPickerField(uid, 'date');
    wrap.classList.add('lb-v2-fee-window-picker');
    if (input.classList.contains('lb-v2-input--sm')) wrap.classList.add('lb-v2-picker-field--sm');
    var native = wrap.querySelector('#' + uid) || wrap.querySelector('.lb-v2-picker-native');
    if (!native) return input;
    native.required = false;
    native.removeAttribute('required');
    if (min) native.setAttribute('min', min);
    if (max) native.setAttribute('max', max);
    if (role === 'start') native.setAttribute('data-window-start', '');
    else native.setAttribute('data-window-end', '');
    if (input.classList.contains('lb-v2-fee-plan-window-start')) {
      native.classList.add('lb-v2-fee-plan-window-start');
    }
    if (input.classList.contains('lb-v2-fee-plan-window-end')) {
      native.classList.add('lb-v2-fee-plan-window-end');
    }
    input.parentNode.replaceChild(wrap, input);
    if (val) {
      native.value = val;
      try { native.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) { /* ignore */ }
      try { native.dispatchEvent(new Event('change', { bubbles: true })); } catch (e2) { /* ignore */ }
    }
    return native;
  }

  function upgradeWindowDateInputsIn(container) {
    if (!container) return;
    var bare = container.querySelectorAll(
      'input[type="date"][data-window-start], input[type="date"][data-window-end]'
    );
    Array.prototype.slice.call(bare).forEach(function (input) {
      var role = input.hasAttribute('data-window-start') ? 'start' : 'end';
      upgradeBareWindowDateInput(input, role);
    });
  }


  function highlightWindowCalDays(box) {
    if (!box) return;
    var cal = box.querySelector('[data-window-calendar]');
    if (!cal) return;
    var range = pwWindowDates(box);
    cal.querySelectorAll('.lb-v2-cal-day[data-day]').forEach(function (btn) {
      var day = btn.getAttribute('data-day');
      btn.classList.remove('lb-v2-cal-day--selected', 'lb-v2-cal-day--in-range', 'lb-v2-cal-day--end-hint');
      if (!range.start || !day) return;
      if (day === range.start) btn.classList.add('lb-v2-cal-day--selected');
      // 檔期含迄日：18~20 共 3 天時，19 與 20 都要紅底（不可 day < end）
      else if (range.end && day > range.start && day <= range.end) btn.classList.add('lb-v2-cal-day--in-range');
    });
  }

  function renderWindowCapacityCalendar(calEl, days, opts) {
    if (!calEl) return;
    opts = opts || {};
    var minLeadDays = opts.minLeadDays;
    var maxEndYmd = opts.maxEndYmd || '';
    var durationDays = opts.durationDays || 0;
    var minStartYmd = opts.minStartYmd || '';
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var leadDays = Number(minLeadDays);
    if (!Number.isFinite(leadDays) || leadDays < 0) leadDays = PURCHASE_WINDOW_MIN_LEAD_DAYS;
    var earliest = new Date(today);
    earliest.setDate(earliest.getDate() + leadDays);
    var earliestYmd = earliest.getFullYear() + '-' +
      String(earliest.getMonth() + 1).padStart(2, '0') + '-' +
      String(earliest.getDate()).padStart(2, '0');
    if (minStartYmd && minStartYmd > earliestYmd) earliestYmd = minStartYmd;

    var latestStartYmd = maxEndYmd || '';
    if (durationDays > 1 && maxEndYmd) {
      latestStartYmd = pwAddDays(maxEndYmd, -(durationDays - 1));
    }
    calEl.setAttribute('data-max-end', maxEndYmd || '');
    calEl.setAttribute('data-latest-start', latestStartYmd || '');
    calEl.setAttribute('data-duration-days', String(durationDays || 0));

    if (!days || !days.length) {
      calEl.innerHTML = '<p class="lb-v2-hint">此區間無可用日期。</p>';
      return;
    }

    var byDay = {};
    days.forEach(function (d) { byDay[d.day] = d; });
    var months = {};
    days.forEach(function (d) {
      var m = d.day.slice(0, 7);
      if (!months[m]) months[m] = true;
    });
    if (maxEndYmd) months[maxEndYmd.slice(0, 7)] = true;
    if (minStartYmd) months[minStartYmd.slice(0, 7)] = true;

    var WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];
    var html = '';
    Object.keys(months).sort().forEach(function (ym) {
      var parts = ym.split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10);
      var first = new Date(year, month - 1, 1);
      var daysInMonth = new Date(year, month, 0).getDate();
      var startWeekday = first.getDay();
      html += '<div class="lb-v2-cal-month">';
      html += '<div class="lb-v2-cal-month__head">' + year + ' 年 ' + month + ' 月</div>';
      html += '<div class="lb-v2-cal-weekdays">';
      WEEKDAYS.forEach(function (w) {
        html += '<span class="lb-v2-cal-weekday">' + w + '</span>';
      });
      html += '</div><div class="lb-v2-cal-grid">';
      var i;
      for (i = 0; i < startWeekday; i++) {
        html += '<span class="lb-v2-cal-day lb-v2-cal-day--empty" aria-hidden="true"></span>';
      }
      for (var dayNum = 1; dayNum <= daysInMonth; dayNum++) {
        var ymdVal = ym + '-' + String(dayNum).padStart(2, '0');
        var d = byDay[ymdVal];
        var dayDate = new Date(ymdVal + 'T00:00:00');
        var isPast = dayDate < earliest || !!(earliestYmd && ymdVal < earliestYmd);
        var heldByMe = !!(d && d.held_by_me);
        var isFull = d && d.max > 0 && d.available <= 0 && !heldByMe;
        var noData = !d;
        var beyondWindow = !!(maxEndYmd && ymdVal > maxEndYmd);
        var beforeParent = !!(minStartYmd && ymdVal < minStartYmd);
        var startTooLate = !!(latestStartYmd && durationDays > 0 && ymdVal > latestStartYmd);
        // 母課／上限窗內天數顯示額度；短檔會超出者仍可點，選後警示。
        var canStart = !(noData || isPast || isFull || beyondWindow || beforeParent);
        var inParentRange = !beyondWindow && !beforeParent && !isPast;
        var cls = 'lb-v2-cal-day';
        if (!canStart) {
          if (isFull && inParentRange) cls += ' lb-v2-cal-day--full';
          else cls += ' lb-v2-cal-day--past';
        } else {
          cls += ' lb-v2-cal-day--ok';
          if (startTooLate) cls += ' lb-v2-cal-day--overflow-start';
          if (heldByMe) cls += ' lb-v2-cal-day--held';
        }
        var availText = d && d.max > 0 ? String(d.available) : (d ? '∞' : '—');
        if (heldByMe && canStart) availText = '保';
        var title = ymdVal;
        if (beyondWindow || beforeParent) title += '　超出可選範圍';
        else if (startTooLate) title += '　短檔迄日會超出基礎上架曝光範圍';
        else if (isFull) title += '　已滿';
        else if (heldByMe) title += '　你的保留';
        else if (d) title += '　剩餘 ' + availText;
        html += '<button type="button" class="' + cls + '" data-day="' + ymdVal +
          '" data-can-start="' + (canStart ? '1' : '0') +
          '" title="' + title + '"' + (canStart ? '' : ' disabled tabindex="-1"') + '>' +
          '<span class="lb-v2-cal-day__num">' + dayNum + '</span>' +
          '<span class="lb-v2-cal-day__cap">' + (canStart || isFull || (inParentRange && d) ? availText : '') + '</span>' +
          '</button>';
      }
      html += '</div></div>';
    });
    calEl.innerHTML = html;
  }

  async function loadWindowCapacityCalendar(box) {
    if (!box) return;
    var cal = box.querySelector('[data-window-calendar]');
    var hint = box.querySelector('[data-window-cal-hint]');
    if (!cal) return;
    var slotId = parseInt(box.getAttribute('data-slot-id'), 10) || 0;
    if (!slotId) {
      cal.innerHTML = '';
      return;
    }
    var durationDays = parseInt(box.getAttribute('data-duration-days'), 10) || 0;
    var parentSelect = box.querySelector('[data-window-parent]');
    var parentStart = box.getAttribute('data-parent-start') || '';
    var parentEnd = box.getAttribute('data-parent-end') || '';
    var parentListingId = box.getAttribute('data-parent-listing-id') || '';
    if (parentSelect) {
      var opt = parentSelect.options[parentSelect.selectedIndex];
      if (opt) {
        parentStart = opt.getAttribute('data-parent-start') || parentStart;
        parentEnd = opt.getAttribute('data-parent-end') || parentEnd;
        parentListingId = String(opt.value || parentListingId || '');
      }
    }
    var now = new Date();
    var start = pwTodayYmd();
    var endD = new Date(now.getFullYear(), now.getMonth(), now.getDate() + EXPOSURE_CALENDAR_DAYS);
    var windowEnd = endD.getFullYear() + '-' +
      String(endD.getMonth() + 1).padStart(2, '0') + '-' +
      String(endD.getDate()).padStart(2, '0');
    var end = parentEnd && parentEnd < windowEnd ? parentEnd : windowEnd;
    if (parentStart && parentStart > start) start = parentStart;
    var slug = box.getAttribute('data-slug') || getListingVendorSlug();
    if (hint) {
      var bits = [];
      bits.push('數字＝當日剩餘席次（∞＝不限）');
      if (parentStart && parentEnd) {
        bits.push('須落在 <strong>' + escapeHtml(parentStart) + ' ~ ' + escapeHtml(parentEnd) + '</strong>');
      }
      if (durationDays > 0) {
        bits.push('短檔 <strong>' + durationDays + ' 天</strong>，點起日自動帶迄日');
      } else {
        bits.push('點起日選擇檔期');
      }
      hint.innerHTML = bits.join(' · ');
    }
    var key = 'pwcal_' + slotId + '_' + start + '_' + end + '_' + (slug || '') + '_' + parentListingId;
    if (slotAvailCache[key]) {
      renderWindowCapacityCalendar(cal, slotAvailCache[key].days, {
        minLeadDays: resolveMinLeadDays(slotAvailCache[key].min_lead_days, PURCHASE_WINDOW_MIN_LEAD_DAYS),
        maxEndYmd: end,
        durationDays: durationDays,
        minStartYmd: parentStart || ''
      });
      highlightWindowCalDays(box);
      return;
    }
    cal.innerHTML = '<p class="lb-v2-hint">載入版位剩餘容量中…</p>';
    try {
      var qs = '?slot_id=' + slotId + '&start_date=' + start + '&end_date=' + end +
        (slug ? '&vendor_slug=' + encodeURIComponent(slug) : '') +
        (parentListingId && /^\d+$/.test(String(parentListingId))
          ? '&listing_id=' + parentListingId
          : '');
      var resp = await fetch(PATHS.slotAvailability + qs, {
        method: 'GET', headers: { Accept: 'application/json' }, credentials: 'same-origin',
      });
      var data = await resp.json();
      if (data && data.ok) {
        slotAvailCache[key] = data;
        renderWindowCapacityCalendar(cal, data.days, {
          minLeadDays: resolveMinLeadDays(data.min_lead_days, PURCHASE_WINDOW_MIN_LEAD_DAYS),
          maxEndYmd: end,
          durationDays: durationDays,
          minStartYmd: parentStart || ''
        });
        highlightWindowCalDays(box);
      } else {
        cal.innerHTML = '<p class="lb-v2-hint" style="color:#c0392b">載入剩餘容量失敗</p>';
      }
    } catch (e) {
      cal.innerHTML = '<p class="lb-v2-hint" style="color:#c0392b">載入剩餘容量失敗</p>';
    }
  }

  function bindWindowCalendarInteractions(box) {
    if (!box) return;
    var cal = box.querySelector('[data-window-calendar]');
    if (!cal || cal.__lbPwCalBound) return;
    cal.__lbPwCalBound = true;
    cal.addEventListener('click', function (ev) {
      var dayBtn = ev.target && ev.target.closest ? ev.target.closest('.lb-v2-cal-day') : null;
      if (!dayBtn || dayBtn.disabled || dayBtn.getAttribute('data-can-start') !== '1') return;
      var ymdVal = dayBtn.getAttribute('data-day');
      if (!ymdVal) return;
      var startEl = box.querySelector('[data-window-start]');
      if (!startEl) return;
      startEl.value = ymdVal;
      try { startEl.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) { /* ignore */ }
      try { startEl.dispatchEvent(new Event('change', { bubbles: true })); } catch (e2) { /* ignore */ }
      highlightWindowCalDays(box);
    });
  }

  function bindCheckoutModeTabs(container) {
    if (!container) return;
    var tabs = container.querySelector('.lb-v2-checkout-mode-tabs');
    if (!tabs || tabs.__lbBound) return;
    tabs.__lbBound = true;
    tabs.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-checkout-mode]') : null;
      if (!btn) return;
      var mode = btn.getAttribute('data-checkout-mode');
      tabs.querySelectorAll('[data-checkout-mode]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      container.querySelectorAll('.lb-v2-fee-mode-block').forEach(function (sec) {
        var on = sec.getAttribute('data-mode') === mode;
        sec.hidden = !on;
        sec.classList.toggle('is-active', on);
      });
    });
  }

  function bindExposureWindowPickers(container) {
    if (!container) return;
    upgradeWindowDateInputsIn(container);
    container.querySelectorAll('[data-window-parent]').forEach(function (select) {
      var box = select.closest('.lb-v2-fee-plan-window');
      pwSyncParentRange(box);
      select.addEventListener('change', function () {
        pwSyncParentRange(box);
        loadWindowCapacityCalendar(box);
        pwCheckAvailability(box);
      });
    });
    container.querySelectorAll('[data-window-action]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var box = btn.closest('.lb-v2-fee-plan-window');
        submitExposureWindow(box, btn.getAttribute('data-window-action'));
      });
    });
    container.querySelectorAll('[data-window-start]').forEach(function (input) {
      input.addEventListener('change', function () {
        var box = input.closest('.lb-v2-fee-plan-window');
        if (!box) return;
        var durationDays = parseInt(box.getAttribute('data-duration-days'), 10) || 0;
        var hint = box.querySelector('[data-window-end-hint]');
        if (durationDays > 0 && hint) {
          hint.textContent = input.value
            ? '曝光檔期：' + input.value + ' ~ ' + pwAddDays(input.value, durationDays - 1) +
              '（共 ' + durationDays + ' 天）'
            : '短檔 ' + durationDays + ' 天：選起日後自動排到迄日';
        }
        highlightWindowCalDays(box);
        pwCheckAvailability(box);
      });
    });
    container.querySelectorAll('[data-window-end]').forEach(function (input) {
      input.addEventListener('change', function () {
        var box = input.closest('.lb-v2-fee-plan-window');
        highlightWindowCalDays(box);
        pwCheckAvailability(box);
      });
    });
    container.querySelectorAll('.lb-v2-fee-plan-window[data-slot-id]').forEach(function (box) {
      var slotId = parseInt(box.getAttribute('data-slot-id'), 10) || 0;
      if (!slotId) return;
      bindWindowCalendarInteractions(box);
      loadWindowCapacityCalendar(box);
    });
  }

  function buildFeePlanCardsHtml(plans, opts) {
    opts = opts || {};
    var listingId = opts.listingId || '';
    var slug = opts.slug || getListingVendorSlug();
    var blockFull = opts.blockFullPurchase === true;
    var TYPE_LABELS = { SINGLE: '單次', DURATION: '通行證' };

    var groups = {};
    var groupOrder = [];
    plans.forEach(function (p) {
      var key = p.slot_slug || '__none__';
      if (!groups[key]) {
        groups[key] = { name: p.slot_name || BASE_LISTING_GROUP_TITLE, slug: key, plans: [] };
        groupOrder.push(key);
      }
      groups[key].plans.push(p);
    });

    var html = '';
    groupOrder.forEach(function (gKey) {
      var grp = groups[gKey];
      if (groupOrder.length > 1 || gKey !== '__none__') {
        html += '<h4 class="lb-v2-fee-slot-group-title">' + escapeHtml(grp.name) + '</h4>';
      }
      html += '<div class="lb-v2-fee-plans-grid">';
      grp.plans.forEach(function (p) {
        var typeLabel = TYPE_LABELS[p.plan_type] || p.plan_type;
        if (p.plan_type === 'SINGLE' && p.duration_days) {
          typeLabel = '短檔 ' + p.duration_days + ' 天';
        }
        var durationText = '';
        if (p.plan_type === 'DURATION') {
          if (p.validity_days) durationText = p.validity_days + ' 天效期';
          else if (p.duration_months) durationText = p.duration_months + ' 個月';
          if (p.max_booking_interval_days) durationText += '（單次≤' + p.max_booking_interval_days + '天）';
        }
        var priceText = Number(p.price) > 0 ? 'NT$' + p.price : '免費';
        var unused = parseInt(p.unused_single_count, 10) || 0;
        var statusBits = [];
        if (p.plan_type === 'DURATION' && p.has_active_grant) {
          statusBits.push(p.grant_expires_at
            ? '有效至 ' + formatDateTw(p.grant_expires_at)
            : '已開通');
        }
        if (p.plan_type === 'SINGLE' && unused > 0) {
          statusBits.push('剩餘 ' + unused + ' 次');
        }
        var grantInfo = statusBits.length
          ? '<span class="lb-v2-badge lb-v2-badge--active">' + statusBits.join(' · ') + '</span>'
          : '';

        var isFullBlocked = blockFull && p.listing_mode === 'FULL';
        var moduleClosed = !isFullBlocked && isModulePurchaseClosed(p.listing_mode);
        if (moduleClosed) return;
        var buyBlocked = isFullBlocked;
        var planMode = String(p.listing_mode || '').toUpperCase();
        var isBase = isBaseListingPlan(p);
        var ctaLabel = isBase ? '選擇檔期' : '選擇版位檔期';
        if (planMode === 'PRIVATE') ctaLabel = Number(p.price) > 0 ? '前往購買' : (p.has_active_grant ? '申請續約' : '申請開通');

        var cartUrl = '';
        if (!buyBlocked && p.shopify_variant_id && Number(p.price) > 0) {
          var gid = String(p.shopify_variant_id);
          var m = gid.match(/(\d+)\s*$/);
          var variantNumId = m ? m[1] : gid.replace(/\D/g, '');
          var props = 'properties%5Bslug_handle%5D=' + encodeURIComponent(slug);
          if (listingId && p.plan_type === 'SINGLE') {
            props += '&properties%5Blisting_id%5D=' + encodeURIComponent(listingId);
          }
          cartUrl = '/cart/add?id=' + encodeURIComponent(variantNumId) + '&quantity=1&' + props + '&return_to=/cart';
        }

        html += '<article class="lb-v2-fee-plan-card lb-v2-fee-plan-card--compact' +
          (buyBlocked ? ' is-blocked' : '') +
          (isBase ? ' is-base' : ' is-addon') +
          '" data-plan-id="' + p.id + '">' +
          '<div class="lb-v2-fee-plan-card__top">' +
            '<div class="lb-v2-fee-plan-card__eyebrow">' + escapeHtml(typeLabel + (durationText ? ' · ' + durationText : '')) + '</div>' +
            '<div class="lb-v2-fee-plan-name">' + escapeHtml(p.name) + '</div>' +
            (grantInfo ? '<div class="lb-v2-fee-plan-card__badges">' + grantInfo + '</div>' : '') +
          '</div>' +
          '<div class="lb-v2-fee-plan-card__foot">' +
            '<div class="lb-v2-fee-plan-price">' + priceText + '</div>';

        if (isFullBlocked) {
          html += '<p class="lb-v2-fee-plan-blocked">無申請宣傳刊登（含金流）服務</p>';
        } else if (planMode === 'PRIVATE') {
          if (cartUrl) {
            html += '<a href="' + cartUrl + '" class="lb-v2-btn lb-v2-btn--accent lb-v2-fee-plan-buy">' + escapeHtml(ctaLabel) + '</a>';
          } else if (Number(p.price) === 0) {
            html += '<button type="button" class="lb-v2-btn lb-v2-btn--accent lb-v2-fee-plan-buy" data-private-free-apply="' +
              p.id + '">' + escapeHtml(ctaLabel) + '</button>';
          } else if (!p.shopify_variant_id) {
            html += '<span class="lb-v2-fee-plan-card__warn">方案尚未連結商品</span>';
          }
        } else if (Number(p.price) > 0 && !p.shopify_variant_id) {
          html += '<span class="lb-v2-fee-plan-card__warn">方案尚未連結商品</span>';
        } else {
          html += '<button type="button" class="lb-v2-btn lb-v2-btn--accent lb-v2-fee-plan-buy" data-open-purchase-plan="' +
            p.id + '">' + escapeHtml(ctaLabel) + '</button>';
        }
        html += '</div></article>';
      });
      html += '</div>';
    });
    return html;
  }

  function openFeePurchasePlanModal(planId) {
    var plan = feePurchasePlansById[String(planId)];
    if (!plan) return;
    var opts = feePurchaseCardOpts || {};
    var slug = opts.slug || getListingVendorSlug();
    var listingId = opts.listingId || '';
    var isBase = isBaseListingPlan(plan);
    var priceText = Number(plan.price) > 0 ? ('NT$' + plan.price) : '免費';
    var typeBits = [];
    if (plan.plan_type === 'SINGLE' && plan.duration_days) typeBits.push('短檔 ' + plan.duration_days + ' 天');
    else if (plan.plan_type === 'DURATION') typeBits.push('通行證');
    if (plan.slot_name) typeBits.push(plan.slot_name);
    else typeBits.push(BASE_LISTING_GROUP_TITLE);

    var body =
      '<div class="lb-v2-purchase-modal">' +
        '<div class="lb-v2-purchase-modal__hero">' +
          '<p class="lb-v2-purchase-modal__kicker">' + escapeHtml(typeBits.join(' · ')) + '</p>' +
          '<h4 class="lb-v2-purchase-modal__title">' + escapeHtml(plan.name || ('方案 #' + plan.id)) + '</h4>' +
          '<p class="lb-v2-purchase-modal__price">' + escapeHtml(priceText) + '</p>' +
          '<p class="lb-v2-purchase-modal__note">' +
            (isBase
              ? '選好曝光檔期後付款／領取鎖定；系統會建立課程草稿，再到「上架新課程」選擇額度方案並補內容送審。'
              : '選好曝光檔期後鎖定版位容量；之後到「課程廣告刊登」套用到基礎上架課程。') +
          '</p>' +
        '</div>' +
        '<div class="lb-v2-purchase-modal__body" id="lb-v2-purchase-modal-body">' +
          buildExposureWindowPickerHtml(plan, slug, listingId) +
        '</div>' +
      '</div>';

    var isFree = Number(plan.price) === 0;
    var freeBucket = isFree ? freeQuotaBucketForSlot(plan.slot_id || null) : null;
    var freeRemaining = freeBucket ? (parseInt(freeBucket.remaining, 10) || 0) : null;
    var exhausted = freeRemaining !== null && freeRemaining <= 0;
    var actions = [{ label: '稍後再說', ghost: true, close: true }];
    if (!exhausted) {
      actions.push({
        label: isFree ? '領取此檔期' : '鎖定檔期並前往付款',
        accent: true,
        close: false,
        onClick: function () {
          var box = document.querySelector('#lb-v2-modal .lb-v2-fee-plan-window');
          submitExposureWindow(box, isFree ? 'claim' : 'buy');
          return false;
        }
      });
    }

    openModal({
      title: isBase ? '基礎上架・鎖定檔期' : '廣告加購・鎖定檔期',
      bodyHtml: body,
      wide: true,
      disableCloseX: true,
      actions: actions
    });

    var panel = document.querySelector('#lb-v2-modal .lb-v2-modal__panel');
    if (panel) panel.classList.add('lb-v2-modal__panel--purchase');
    var host = $('lb-v2-purchase-modal-body') || $('lb-v2-modal-body');
    if (host) bindExposureWindowPickers(host);
  }

  function bindFeePurchasePlanOpeners(container) {
    if (!container || container.__lbPurchaseOpenBound) return;
    container.__lbPurchaseOpenBound = true;
    container.addEventListener('click', function (ev) {
      var btn = ev.target && ev.target.closest ? ev.target.closest('[data-open-purchase-plan]') : null;
      if (!btn || !container.contains(btn)) return;
      ev.preventDefault();
      openFeePurchasePlanModal(btn.getAttribute('data-open-purchase-plan'));
    });
  }

  function renderAllFeePlanSections(container, plans, opts) {

    opts = opts || {};
    var blockFull = opts.blockFullPurchase === true || !isFullServiceEnabled();
    var sections = [
      { mode: 'EXPOSURE', title: '純上架', desc: '外部收款・平台不代收' },
      { mode: 'PROMO', title: '宣傳刊登（不含金流）', desc: '宣傳牆曝光・外連導流' },
      { mode: 'FULL', title: '宣傳刊登（含金流）', desc: 'LadyBae 結帳・雙週結算' },
      { mode: 'PRIVATE', title: '資格限定課', desc: '私域年約・通行證' },
    ];
    var all = plans || [];
    if (!all.length) {
      container.innerHTML =
        '<p style="color:#c0392b;font-weight:600;">目前沒有可購買的上架費方案。</p>' +
        '<p class="lb-v2-hint">請先到管理後台「上架費方案」確認已儲存並啟用。</p>';
      return;
    }

    var visible = [];
    sections.forEach(function (sec) {
      var closed = isModulePurchaseClosed(sec.mode);
      var hasQuota = canSubmitForMode(sec.mode);
      if (closed && !hasQuota) return;
      visible.push(sec);
    });
    if (!visible.length) {
      container.innerHTML = '<p class="lb-v2-muted">目前沒有可購買的上架方案。</p>';
      return;
    }

    var activeMode = visible[0].mode;
    var studioHeadHtml =
      '<div class="lb-v2-checkout-studio__head">' +
        '<span class="lb-v2-fee-stage__step">基礎方案</span>' +
        '<span class="lb-v2-fee-stage__title">宣傳刊登</span>' +
      '</div>';
    var tabsHtml = '<div class="lb-v2-checkout-mode-tabs" role="tablist" aria-label="方案類型" data-count="' +
      visible.length + '">';
    visible.forEach(function (sec, i) {
      tabsHtml += '<button type="button" class="lb-v2-checkout-mode-tab' + (i === 0 ? ' is-active' : '') +
        '" role="tab" data-checkout-mode="' + sec.mode + '" aria-selected="' + (i === 0 ? 'true' : 'false') + '">' +
        '<span class="lb-v2-checkout-mode-tab__title">' + escapeHtml(sec.title) + '</span>' +
        '<span class="lb-v2-checkout-mode-tab__desc">' + escapeHtml(sec.desc) + '</span>' +
      '</button>';
    });
    tabsHtml += '</div>';

    var panelsHtml = '<div class="lb-v2-checkout-mode-panels">';
    visible.forEach(function (sec, i) {
      var closed = isModulePurchaseClosed(sec.mode);
      var modePlans = all.filter(function (p) { return p.listing_mode === sec.mode; });
      panelsHtml += '<section class="lb-v2-fee-mode-block' + (closed ? ' is-closing' : '') +
        (i === 0 ? ' is-active' : '') + '" data-mode="' + sec.mode + '"' +
        (i === 0 ? '' : ' hidden') + '>';
      if (closed) {
        panelsHtml += '<p class="lb-v2-fee-full-blocked">此模組已關閉 — 不可再購買。請盡快消化既有額度。</p>';
      } else if (sec.mode === 'FULL' && blockFull) {
        panelsHtml += '<p class="lb-v2-fee-full-blocked">尚未設定手續費率，無法購買宣傳刊登（含金流）方案。請聯繫官方。</p>';
      }
      if (closed) {
        // leftover grants shown in entitlement cards
      } else if (!modePlans.length) {
        panelsHtml += '<p class="lb-v2-muted">此模式目前沒有方案。</p>';
      } else {
        var cardOpts = Object.assign({}, opts, { blockFullPurchase: blockFull });
        var basePlans = modePlans.filter(isBaseListingPlan);
        var adPlans = modePlans.filter(function (p) { return !isBaseListingPlan(p); });
        if (basePlans.length) {
          panelsHtml += '<div class="lb-v2-fee-stage" data-fee-stage="base">' +
            '<p class="lb-v2-fee-stage__desc">選檔期 → 付款鎖定 → 建立草稿 → 補內容送審。</p>' +
            buildFeePlanCardsHtml(basePlans, cardOpts) +
          '</div>';
        }
        if (adPlans.length && isSlotAddonPurchaseEnabled()) {
          var canAddon = hasAddonEligibleParent(sec.mode);
          panelsHtml += '<div class="lb-v2-fee-stage" data-fee-stage="addon">' +
            '<div class="lb-v2-fee-stage__head">' +
              '<span class="lb-v2-fee-stage__step">進階方案</span>' +
              '<span class="lb-v2-fee-stage__title">廣告版位加購</span>' +
            '</div>' +
            '<p class="lb-v2-fee-stage__desc">為已審核課程加買版位；下方月曆可看每日剩餘容量。</p>';
          if (!canAddon) {
            panelsHtml += '<p class="lb-v2-fee-stage__gate">' +
              escapeHtml(addonEligibleGateMessage(sec.mode) ||
                '尚無可加購的課程 — 請先完成基礎上架並通過審核。') +
              '</p>';
          }
          panelsHtml += buildFeePlanCardsHtml(adPlans, cardOpts) + '</div>';
        }
        if (!basePlans.length && !(adPlans.length && isSlotAddonPurchaseEnabled())) {
          panelsHtml += '<p class="lb-v2-muted">此模式目前沒有方案。</p>';
        }
      }
      panelsHtml += '</section>';
    });
    panelsHtml += '</div>';

    container.innerHTML =
      '<div class="lb-v2-checkout-studio">' +
        studioHeadHtml +
        tabsHtml +
        panelsHtml +
      '</div>';
    bindCheckoutModeTabs(container);
  }

  async function loadFeePurchaseTab() {
    feePurchaseBound = true;
    var notice = $('lb-v2-fee-purchase-notice');
    var slug = getListingVendorSlug();
    if (!slug || vendorMode === ALL_MODE) {
      if (notice) {
        notice.hidden = false;
        notice.textContent = '請先在上方選擇單一廠商，再購買上架與廣告方案。';
      }
      var ent = $('lb-v2-fee-entitlement');
      if (ent) ent.innerHTML = '';
      var plansEl = $('lb-v2-fee-purchase-plans');
      if (plansEl) plansEl.innerHTML = '';
      var hist = $('lb-v2-fee-grant-history');
      if (hist) hist.innerHTML = '';
      return;
    }
    if (notice) notice.hidden = true;
    try {
      await loadFeeEntitlement(slug);
      // 營運結帳頁不呈現「目前額度摘要」；上架頁仍用 renderEntitlementCards。
      renderGrantHistory($('lb-v2-fee-grant-history'));
      await loadFeePurchasePlans();
    } catch (err) {
      if (notice) {
        notice.hidden = false;
        notice.textContent = err.message || '載入失敗';
      }
    }
  }

  async function startFreePrivateApplication(feePlanId, btn) {
    var slug = getListingVendorSlug();
    var notice = $('lb-v2-fee-purchase-notice');
    if (!slug || !feePlanId) return;
    if (btn) btn.disabled = true;
    try {
      var res = await postAppProxyJson(PATHS.privateApplicationStartFree, {
        vendor_slug: slug,
        fee_plan_id: parseInt(feePlanId, 10),
      });
      if (res.ok) {
        if (notice) {
          notice.hidden = false;
          notice.textContent = '已建立免費年約申請，請至「資格限定課」補填申請資料。';
        }
        switchTab('private');
      } else {
        if (notice) {
          notice.hidden = false;
          notice.textContent = res.message || '申請失敗';
        }
        if (btn) btn.disabled = false;
      }
    } catch (err) {
      if (notice) {
        notice.hidden = false;
        notice.textContent = err.message || '申請失敗';
      }
      if (btn) btn.disabled = false;
    }
  }

  function bindPrivateFreeApplyButtons(container) {
    if (!container) return;
    container.querySelectorAll('[data-private-free-apply]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-private-free-apply');
        startFreePrivateApplication(id, btn);
      });
    });
  }

  /**
   * 廣告加購在購買頁就要選母課，所以這裡需要課程列表。使用者可能直接開在
   * 購買頁，`allListingItems` 還是空的，會誤判成「沒有可加購的課程」。
   */
  async function ensureListingItemsLoaded(slug) {
    if (!slug || allListingItems.length) return;
    try {
      var res = await fetchAppProxy(PATHS.listingList, slug);
      if (res.ok) allListingItems = (res.payload || res).items || [];
    } catch (e) { /* 購買頁不因列表失敗而擋住基礎上架 */ }
  }

  async function loadFeePurchasePlans() {
    var container = $('lb-v2-fee-purchase-plans');
    if (!container) return;
    var slug = getListingVendorSlug();
    container.innerHTML = '<p class="lb-v2-muted">載入可購買方案…</p>';
    try {
      await ensureListingItemsLoaded(slug);
      // Fetch all modes; bust cache so unused counts refresh after purchase
      delete cachedFeePlans['_' + slug];
      delete cachedFeePlans['EXPOSURE_' + slug];
      delete cachedFeePlans['PROMO_' + slug];
      delete cachedFeePlans['FULL_' + slug];
      var plans = await fetchFeePlans('', slug);
      feePurchasePlansCache = plans || [];
      feePurchasePlansById = {};
      feePurchasePlansCache.forEach(function (p) {
        if (p && p.id != null) feePurchasePlansById[String(p.id)] = p;
      });
      feePurchaseCardOpts = { slug: slug };
      container.__lbPurchaseOpenBound = false;
      renderAllFeePlanSections(container, plans, { slug: slug });
      bindPrivateFreeApplyButtons(container);
      bindFeePurchasePlanOpeners(container);
    } catch (err) {
      container.innerHTML = '<p style="color:#c0392b;">' + escapeHtml(err.message || '載入失敗') + '</p>';
    }
  }

  // ═══════════════════════════════════════════════════════
  // 課程廣告刊登（加購清單 + 一次選多版位建立）
  // 底層仍是「一版位一張加購單」：每個勾選版位各跑一次 purchase-hold，
  // 再把所有 variant 一起丟進購物車結帳，維持購買即鎖窗。
  // ═══════════════════════════════════════════════════════

  var courseAdsPlans = [];
  var courseAdsPlanById = {};
  var courseAdsCheckoutInFlight = false;

  function adsNotice(text, isError) {
    var el = $('lb-v2-ads-notice');
    if (!el) return;
    if (!text) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = text;
    el.style.color = isError ? '#c0392b' : '';
  }

  function adsCreateNotice(text, isError) {
    var el = $('lb-v2-ads-create-notice');
    if (!el) return;
    if (!text) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = text;
    el.style.color = isError ? '#c0392b' : '';
  }

  function setCourseAdsView(sub) {
    adsSub = sub === 'create' ? 'create' : 'list';
    var listView = $('lb-v2-ads-list-view');
    var createView = $('lb-v2-ads-create-view');
    if (listView) listView.hidden = adsSub !== 'list';
    if (createView) createView.hidden = adsSub !== 'create';
    renderSubNavState();
    if (adsSub === 'create') renderCourseAdsCreate();
  }

  /** 課程管理「加購廣告」→ 課程廣告刊登／建立廣告，並預選該基礎上架。 */
  var courseAdsPreferredParentId = null;
  /** 剛領取／購買完成的待套用檔期，建立頁要立刻勾選。 */
  var courseAdsPreferredPickIds = null;

  async function refreshListingItemsAfterWindowLock() {
    var slug = getListingVendorSlug();
    if (!slug || vendorMode === ALL_MODE) return;
    try {
      var res = await fetchAppProxy(PATHS.listingList, slug);
      if (res.ok) allListingItems = (res.payload || res).items || [];
    } catch (e) { /* ignore */ }
    if (activeTab === 'course-ads') {
      renderCourseAdsList();
      if (adsSub === 'create') renderCourseAdsCreate();
    }
  }

  async function goCreateAdForParent(parentId) {
    var parent = findListingItemById(parentId);
    if (!parent) {
      showListingAlert('找不到要加購的課程，請重新整理列表');
      return;
    }
    if (!canAddSlotAddon(parent)) {
      showListingAlert('此課程尚未通過審核或檔期已結束，無法加購廣告版位');
      return;
    }
    courseAdsPreferredParentId = Number(parent.id);
    adsSub = 'create';
    if (typeof switchTab === 'function') switchTab('course-ads');
    setCourseAdsView('create');
    try {
      await loadCourseAdsTab(false);
    } catch (e) { /* ignore */ }
    setCourseAdsView('create');
    adsCreateNotice(
      '已帶入課程「' + (parent.title || ('#' + parent.id)) + '」。請選擇已鎖定檔期，或於下方購買／領取新版位。',
      false
    );
  }

  function adsPlanPrice(planId) {
    var p = courseAdsPlanById[String(planId || '')];
    if (!p) return null;
    return Number(p.price) || 0;
  }

  function adsPriceText(price) {
    if (price == null) return '—';
    return Number(price) > 0 ? 'NT$' + Number(price) : '免費';
  }

  async function loadCourseAdsTab(forceReload) {
    var slug = getListingVendorSlug();
    var listEl = $('lb-v2-ads-list');
    if (!slug || vendorMode === ALL_MODE) {
      adsNotice('請先在上方選擇單一廠商，再檢視課程廣告。', false);
      if (listEl) listEl.innerHTML = '';
      var picker = $('lb-v2-ads-slot-picker');
      if (picker) picker.innerHTML = '';
      return;
    }
    adsNotice('', false);
    setDataLoading(true, '載入課程廣告…');
    try {
      if (forceReload || !allListingItems.length) {
        var res = await fetchAppProxy(PATHS.listingList, slug);
        if (res.ok) allListingItems = (res.payload || res).items || [];
      }
      if (forceReload || !courseAdsPlans.length) {
        try {
          courseAdsPlans = await fetchFeePlans('', slug);
        } catch (e) {
          courseAdsPlans = [];
        }
        courseAdsPlanById = {};
        courseAdsPlans.forEach(function (p) {
          if (p && p.id != null) courseAdsPlanById[String(p.id)] = p;
        });
      }
      renderCourseAdsList();
      if (adsSub === 'create') renderCourseAdsCreate();
    } catch (err) {
      adsNotice(err.message || '載入失敗', true);
    } finally {
      setDataLoading(false);
    }
  }

  function normalizeAdsFilterDate(raw) {
    var s = String(raw || '').trim().replace(/\//g, '-');
    if (!s) return '';
    var m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (!m) return null;
    var y = m[1];
    var mo = ('0' + m[2]).slice(-2);
    var d = ('0' + m[3]).slice(-2);
    var iso = y + '-' + mo + '-' + d;
    var dt = new Date(iso + 'T00:00:00');
    if (Number.isNaN(dt.getTime())) return null;
    if (dt.getFullYear() !== Number(y) || (dt.getMonth() + 1) !== Number(mo) || dt.getDate() !== Number(d)) {
      return null;
    }
    return iso;
  }

  function readCourseAdsFilters() {
    var statusFilter = (($('lb-v2-ads-status-filter') || {}).value) || '';
    var fromRaw = (($('lb-v2-ads-date-from') || {}).value) || '';
    var toRaw = (($('lb-v2-ads-date-to') || {}).value) || '';
    var dateFrom = normalizeAdsFilterDate(fromRaw);
    var dateTo = normalizeAdsFilterDate(toRaw);
    if (fromRaw.trim() && dateFrom == null) {
      return { ok: false, message: '檔期起請用 YYYY-MM-DD（例如 2026-08-01）' };
    }
    if (toRaw.trim() && dateTo == null) {
      return { ok: false, message: '檔期迄請用 YYYY-MM-DD（例如 2026-08-31）' };
    }
    if (dateFrom && dateTo && dateFrom > dateTo) {
      return { ok: false, message: '檔期起不可晚於檔期迄' };
    }
    return { ok: true, statusFilter: statusFilter, dateFrom: dateFrom || '', dateTo: dateTo || '' };
  }

  function renderCourseAdsList() {
    var listEl = $('lb-v2-ads-list');
    if (!listEl) return;
    var filters = readCourseAdsFilters();
    if (!filters.ok) {
      adsNotice(filters.message, true);
      return;
    }
    adsNotice('', false);
    var statusFilter = filters.statusFilter;
    var dateFrom = filters.dateFrom;
    var dateTo = filters.dateTo;
    var ads = (allListingItems || []).filter(function (item) {
      if (!isSlotAddonListing(item)) return false;
      if (statusFilter && String(item.status || '').toUpperCase() !== statusFilter) return false;
      var start = ymd(item.exposure_start_at) || '';
      var end = ymd(item.exposure_end_at) || '';
      if (dateFrom && end && end < dateFrom) return false;
      if (dateTo && start && start > dateTo) return false;
      return true;
    });
    if (!ads.length) {
      listEl.innerHTML = '<div class="lb-v2-empty">' +
        (statusFilter || dateFrom || dateTo
          ? '此篩選條件目前沒有廣告加購單。'
          : '尚未套用任何廣告版位。可先到「營運結帳」鎖定檔期，再到「建立廣告」套用到課程。') +
        '</div>';
      return;
    }
    ads.sort(function (a, b) { return Number(b.id) - Number(a.id); });
    var mobile = preferMobileTicketList();
    // 不用 listing-list-scroll（max-height+overflow 會裁切原生日期選單）
    var html = '<div class="lb-v2-ads-board__scroll">';
    if (!mobile) {
      html += '<div class="lb-v2-table-wrap lb-v2-table-wrap--desktop lb-v2-ads-board__table-wrap">' +
        '<table class="lb-v2-table lb-v2-table--ads"><thead><tr>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--id">課程編號</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--date">課程日期</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--title">課程名稱</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--slot">廣告版位</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--window">廣告檔期</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--fee">廣告費用</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--status">廣告狀態</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--adid">廣告編號</th>' +
        '<th class="lb-v2-ads-col lb-v2-ads-col--actions">操作</th>' +
        '</tr></thead><tbody>';
    } else {
      html += '<div class="lb-v2-m-cards lb-v2-m-cards--force" aria-label="廣告列表">';
    }
    ads.forEach(function (ad) {
      var parent = findListingItemById(ad.parent_listing_id) || {};
      var disp = listingDisplayStatus(ad);
      var statusLabel = disp.label;
      var statusKey = String(ad.status || '').toUpperCase();
      var startYmd = ymd(ad.exposure_start_at) || '';
      var endYmd = ymd(ad.exposure_end_at) || '';
      var windowText = startYmd && endYmd ? (startYmd + ' ~ ' + endYmd) : '檔期未設定';
      var windowHtml = startYmd && endYmd
        ? '<span class="lb-v2-ads-window"><span>' + escapeHtml(startYmd) + '</span><span>' + escapeHtml(endYmd) + '</span></span>'
        : '<span class="lb-v2-ads-window">' + escapeHtml(windowText) + '</span>';
      var priceText = adsPriceText(adsPlanPrice(ad.fee_plan_id));
      if (String(ad.listing_fee_status || '').toUpperCase() === 'WAIVED') priceText = '官方免費';
      var editable = statusKey === 'DRAFT' || statusKey === 'REJECTED';
      var actions =
        (editable
          ? '<button type="button" class="lb-v2-ads-act" data-ad-edit="' + ad.id + '">編輯</button>' +
            '<button type="button" class="lb-v2-ads-act" data-ad-detach="' + ad.id +
            '" data-ad-title="' + escapeHtml(ad.slot_name || ('廣告加購 #' + ad.id)) + '">解套</button>'
          : '') +
        '<button type="button" class="lb-v2-ads-act" data-ad-preview="' + ad.id + '">預覽</button>';
      var slotName = ad.slot_name || ('版位 #' + (ad.slot_id || '—'));
      var statusHtml =
        '<span class="lb-v2-ads-status lb-v2-ads-status--' + escapeHtml((disp.key || statusKey).toLowerCase()) + '" style="color:' + escapeHtml(disp.color || '') + '">' +
        escapeHtml(statusLabel) + '</span>' +
        (disp.key === 'PENDING_SHELF' && startYmd
          ? '<span class="lb-v2-ads-status__stage">' + escapeHtml(startYmd) + ' 起</span>'
          : '') +
        (ad.rejected_reason
          ? '<span class="lb-v2-ads-status__reason">' + escapeHtml(ad.rejected_reason) + '</span>'
          : '');
      if (!mobile) {
        html += '<tr>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--id">' +
            listingTrackIdsHtml({ id: ad.parent_listing_id, shopify_product_id: parent.shopify_product_id }) +
          '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--date">' + escapeHtml(listingCourseDateLabel(parent)) + '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--title"><span class="lb-v2-ads-title-chip">' + escapeHtml(parent.title || '（找不到母課）') + '</span></td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--slot">' + escapeHtml(slotName) + '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--window">' + windowHtml + '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--fee">' + escapeHtml(priceText || '—') + '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--status">' + statusHtml + '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--adid">廣告 #' + ad.id + '</td>' +
          '<td class="lb-v2-ads-col lb-v2-ads-col--actions"><div class="lb-v2-ads-acts">' + actions + '</div></td></tr>';
      } else {
        html += '<article class="lb-v2-m-card lb-v2-m-card--board">' +
          '<div class="lb-v2-m-card__head">' +
            '<span class="lb-v2-ads-title-chip">' + escapeHtml(slotName) + '</span>' +
            '<div class="lb-v2-m-card__status-wrap">' + statusHtml + '</div>' +
          '</div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">課程名稱</span><span class="lb-v2-m-card__value">' +
            escapeHtml(parent.title || '（找不到母課）') + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">課程編號</span><span class="lb-v2-m-card__value">' +
            listingTrackIdsHtml({ id: ad.parent_listing_id, shopify_product_id: parent.shopify_product_id }) +
            '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">課程日期</span><span class="lb-v2-m-card__value">' +
            escapeHtml(listingCourseDateLabel(parent)) + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">廣告檔期</span><span class="lb-v2-m-card__value">' + escapeHtml(windowText) + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">廣告費用</span><span class="lb-v2-m-card__value">' + escapeHtml(priceText || '—') + '</span></div>' +
          '<div class="lb-v2-m-card__row"><span class="lb-v2-m-card__label">廣告編號</span><span class="lb-v2-m-card__value">廣告 #' + ad.id + '</span></div>' +
          '<div class="lb-v2-m-card__actions lb-v2-ads-acts">' + actions + '</div>' +
        '</article>';
      }
    });
    html += mobile ? '</div></div>' : '</tbody></table></div></div>';
    listEl.innerHTML = html;
  }

  /** 廣告預覽：用與前台相同的牆 HTML 呈現這張加購單會長什麼樣。 */
  function openAdPreviewModal(adId) {
    var ad = findListingItemById(adId);
    if (!ad) return;
    var parent = findListingItemById(ad.parent_listing_id) || {};
    var own = parentListingImageSrcs(ad);
    var imgs = own.length ? own : parentListingImageSrcs(parent);
    var slotName = ad.slot_name || ('版位 #' + (ad.slot_id || '—'));
    var kind = resolveWallPreviewKind(slotName, '', parent.listing_mode);
    openModal({
      wide: true,
      title: '廣告預覽 · #' + ad.id,
      bodyHtml:
        '<p class="lb-v2-hint">課程「<strong>' + escapeHtml(parent.title || ('#' + ad.parent_listing_id)) +
          '</strong>」｜檔期 ' + escapeHtml(ymd(ad.exposure_start_at) || '—') + ' ~ ' +
          escapeHtml(ymd(ad.exposure_end_at) || '—') + '｜狀態 ' +
          escapeHtml(listingDisplayStatus(ad).label || '') + '</p>' +
        '<p class="lb-v2-hint">' + (own.length ? '目前為廣告專用圖。' : '目前沿用基礎上架圖。') +
          '同池<strong>不保證順位</strong>。</p>' +
        '<div class="lb-v2-place-preview"><div class="lb-v2-place-preview__block">' +
          '<h4 class="lb-v2-place-preview__h">' + escapeHtml(slotName) + '</h4>' +
          buildStorefrontSlotWallToggleHtml(kind, {
            title: parent.title || '（課程標題）',
            desk: imgs[0] || '',
            mob: imgs[1] || imgs[0] || '',
            imgs: imgs,
            desc: listingPreviewDesc(parent, 90),
            vendor: listingPreviewVendorName(parent),
            priceText: listingPreviewPriceText(parent),
          }) +
        '</div></div>',
      actions: [{ label: '關閉', accent: true, close: true }],
    });
    var body = $('lb-v2-modal-body');
    if (body) bindSlotPreviewToggle(body);
  }


  /** 建立廣告草稿狀態：每張已購檔期各自的圖／裁切（不碰母課商品圖）。 */
  var courseAdsDrafts = {};
  var courseAdsApplyInFlight = false;

  function ensureCourseAdsDraft(listingId) {
    var id = String(listingId || '');
    if (!courseAdsDrafts[id]) {
      courseAdsDrafts[id] = {
        sources: [],
        files: [],
        crops: [],
        cropped: [],
        // 已存過且未再調構圖的圖：套用時直接沿用網址，不重複產生 Shopify 檔案
        savedSrc: [],
        timers: {},
      };
    }
    return courseAdsDrafts[id];
  }

  /** 這張加購單自己的廣告專用圖（與母課圖相同者視為沿用，不算專用）。 */
  function listingOwnAdImageSrcs(item, parent) {
    var own = parentListingImageSrcs(item).map(function (s) {
      return coerceDurablePublicImageUrl(s);
    }).filter(Boolean);
    if (!own.length) return [];
    var parentSrcs = parentListingImageSrcs(parent);
    var sameAsParent =
      own.length === parentSrcs.length &&
      own.every(function (s, i) { return s === parentSrcs[i]; });
    return sameAsParent ? [] : own;
  }

  /**
   * 已存過的廣告專用圖要帶回卡片，否則廠商重開「課程廣告刊登」會看到「尚未上傳」，
   * 以為圖不見了（圖其實還在 images_json 與 Shopify Files）。
   */
  function prefillCourseAdsDraft(card, item, parent) {
    var draft = ensureCourseAdsDraft(item.id);
    if (draft.prefilled) return;
    draft.prefilled = true;
    if (draft.sources.filter(Boolean).length) return;
    var own = listingOwnAdImageSrcs(item, parent);
    if (!own.length) return;
    var kind = courseAdsKindForItem(item);
    var limit = getAddonWallImageLimit(kind) || 1;
    own.slice(0, limit).forEach(function (src) {
      var idx = draft.sources.length;
      draft.sources.push(src);
      draft.files.push(null);
      draft.crops.push(defaultAddonCrop(0, 0));
      draft.cropped.push('');
      draft.savedSrc[idx] = coerceDurablePublicImageUrl(src) || src;
      loadImageElement(src).then(function (img) {
        var crop = draft.crops[idx] || defaultAddonCrop(0, 0);
        crop.natW = img.naturalWidth || img.width;
        crop.natH = img.naturalHeight || img.height;
        draft.crops[idx] = crop;
        renderCourseAdsDraftCrop(card, item, parent);
        renderCourseAdsDraftPreview(card, item, parent);
      }).catch(function () { /* 讀不到就留原圖，仍可重新上傳 */ });
    });
  }

  function clearCourseAdsDraft(listingId) {
    var d = courseAdsDrafts[String(listingId || '')];
    if (!d) return;
    (d.sources || []).forEach(revokeIfBlobUrl);
    (d.cropped || []).forEach(revokeIfBlobUrl);
    Object.keys(d.timers || {}).forEach(function (k) { clearTimeout(d.timers[k]); });
    delete courseAdsDrafts[String(listingId || '')];
  }

  /** 刪單張專用圖並緊湊重排（刪第 1 張 → 原第 2 張變第 1 張）。 */
  function removeCourseAdsDraftAt(listingId, idx) {
    var draft = ensureCourseAdsDraft(listingId);
    if (!(idx >= 0) || idx >= draft.sources.length) return;
    Object.keys(draft.timers || {}).forEach(function (k) {
      clearTimeout(draft.timers[k]);
    });
    draft.timers = {};
    revokeIfBlobUrl(draft.sources[idx]);
    revokeIfBlobUrl(draft.cropped[idx]);
    draft.sources.splice(idx, 1);
    draft.files.splice(idx, 1);
    draft.crops.splice(idx, 1);
    draft.cropped.splice(idx, 1);
    (draft.savedSrc || []).splice(idx, 1);
  }

  function syncCourseAdsUploadUi(card, draft, limit) {
    if (!card) return;
    var count = (draft && draft.sources ? draft.sources.filter(Boolean).length : 0);
    var drop = card.querySelector('[data-ads-drop]');
    var toolbar = card.querySelector('[data-ads-toolbar]');
    var full = limit > 0 && count >= limit;
    if (drop) drop.hidden = full;
    if (toolbar) toolbar.hidden = count === 0;
  }

  function courseAdsPendingEligible(parent) {
    var pending = (allListingItems || []).filter(isPayableUnattachedAdWindow);
    if (!parent) return pending.slice();
    var pStart = ymd(parent.exposure_start_at);
    var pEnd = ymd(parent.exposure_end_at);
    var parentMode = String(parent.listing_mode || '').toUpperCase();
    return pending.filter(function (item) {
      if (String(item.listing_mode || '').toUpperCase() !== parentMode) return false;
      var start = ymd(item.exposure_start_at);
      var end = ymd(item.exposure_end_at);
      if (pStart && start && start < pStart) return false;
      if (pEnd && end && end > pEnd) return false;
      return true;
    });
  }

  function courseAdsSelectedIds() {
    var pick = $('lb-v2-ads-pick');
    if (!pick) return [];
    return Array.prototype.slice.call(pick.querySelectorAll('input[data-ads-pick]:checked')).map(function (el) {
      return String(el.value || '');
    }).filter(Boolean);
  }

  /**
   * 這裡列的都是「已鎖檔期、還沒套用到母課」的廣告窗（套用後就改由廣告管理顯示），
   * 所以標籤要把「未使用」講出來，不然只寫「已付款」會讓人以為已經在跑。
   */
  function courseAdsFeeLabel(item) {
    var fee = String(item.listing_fee_status || '').toUpperCase();
    if (fee === 'WAIVED') return '免費未使用';
    if (fee === 'PAID') return '已付款未使用';
    return fee || '—';
  }

  function courseAdsKindForItem(item) {
    return resolveWallPreviewKind(
      item.slot_name || '',
      [item.title, item.slot_slug, item.fee_plan_name].filter(Boolean).join(' '),
      item.listing_mode || ''
    );
  }

  async function bakeCourseAdsDraftBlob(draft, kind, idx) {
    var src = draft.sources[idx];
    var spec = getAddonCropSpec(kind, idx);
    if (!src || !spec) return null;
    var crop = draft.crops[idx] || defaultAddonCrop(0, 0);
    var img = await loadImageElement(src);
    var natW = img.naturalWidth || img.width;
    var natH = img.naturalHeight || img.height;
    if (!(natW > 0 && natH > 0)) return null;
    crop.natW = natW;
    crop.natH = natH;
    draft.crops[idx] = crop;
    var rect = computeCoverCropRect(natW, natH, spec.ratio, crop.zoom, crop.fx, crop.fy);
    var outW = Math.round(rect.w);
    var outH = Math.round(rect.h);
    var longEdge = Math.max(outW, outH);
    if (longEdge > 2200) {
      var s = 2200 / longEdge;
      outW = Math.max(1, Math.round(outW * s));
      outH = Math.max(1, Math.round(outH * s));
    }
    var canvas = document.createElement('canvas');
    canvas.width = outW;
    canvas.height = outH;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
    ctx.drawImage(img, rect.x, rect.y, rect.w, rect.h, 0, 0, outW, outH);
    return canvasToJpegBlob(canvas, 0.92);
  }

  function renderCourseAdsDraftCrop(card, item, parent) {
    var root = card.querySelector('[data-ads-crop-root]');
    if (!root) return;
    var draft = ensureCourseAdsDraft(item.id);
    var kind = courseAdsKindForItem(item);
    var limit = getAddonWallImageLimit(kind) || 1;
    var html = '';
    var any = false;
    for (var idx = 0; idx < draft.sources.length; idx++) {
      if (!draft.sources[idx]) continue;
      var spec = getAddonCropSpec(kind, idx);
      if (!spec) continue;
      any = true;
      var crop = draft.crops[idx] || defaultAddonCrop(0, 0);
      var previewSrc = draft.sources[idx];
      html += '<div class="lb-v2-addon-crop" data-crop-idx="' + idx + '">' +
        '<div class="lb-v2-addon-crop__head"><div class="lb-v2-addon-crop__title">' +
        '<span class="lb-v2-addon-crop__kicker">構圖</span><strong>第 ' + (idx + 1) + ' 張 · ' +
        escapeHtml(spec.label) + '</strong></div>' +
        '<div class="lb-v2-addon-crop__head-actions">' +
        '<span class="lb-v2-addon-crop__ratio">' + escapeHtml(spec.ratioLabel) + '</span>' +
        '<button type="button" class="lb-v2-addon-crop__remove" data-ads-remove-idx="' + idx +
        '" aria-label="刪除第 ' + (idx + 1) + ' 張">刪除</button>' +
        '</div></div>' +
        '<div class="lb-v2-addon-crop__stage"><div class="lb-v2-addon-crop__viewport">' +
        cropFrameBoxOpenTag(spec) +
        '<img src="' + escapeHtml(previewSrc) + '" alt="裁切預覽" data-crop-live="1">' +
        '<span class="lb-v2-addon-crop__guide" aria-hidden="true"></span></div></div>' +
        '<div class="lb-v2-addon-crop__controls" role="group" aria-label="構圖微調">' +
        '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">縮放</span>' +
        '<input class="lb-v2-addon-crop__range" type="range" min="100" max="300" step="1" value="' +
        Math.round((crop.zoom || 1) * 100) + '" data-crop-zoom="' + idx + '"></div>' +
        '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">左右</span>' +
        '<input class="lb-v2-addon-crop__range" type="range" min="0" max="100" step="1" value="' +
        Math.round(crop.fx == null ? 50 : crop.fx) + '" data-crop-fx="' + idx + '"></div>' +
        '<div class="lb-v2-addon-crop__ctrl"><span class="lb-v2-addon-crop__ctrl-label">上下</span>' +
        '<input class="lb-v2-addon-crop__range" type="range" min="0" max="100" step="1" value="' +
        Math.round(crop.fy == null ? 50 : crop.fy) + '" data-crop-fy="' + idx + '"></div>' +
        '</div></div>' +
        '<p class="lb-v2-addon-crop__warn">' + escapeHtml(cropFramePanHint(crop, spec)) + '</p>' +
        '</div>';
    }
    root.innerHTML = any ? html : '';
    if (any) {
      for (var j = 0; j < draft.sources.length; j++) {
        if (!draft.sources[j]) continue;
        applyLiveCropFrameStyle(
          root.querySelector('.lb-v2-addon-crop[data-crop-idx="' + j + '"] .lb-v2-addon-crop__frame img'),
          draft.crops[j] || defaultAddonCrop(0, 0),
          getAddonCropSpec(kind, j)
        );
      }
    }
    syncCourseAdsUploadUi(card, draft, limit);
  }

  function renderCourseAdsDraftPreview(card, item, parent) {
    var box = card.querySelector('[data-ads-preview]');
    if (!box) return;
    var draft = ensureCourseAdsDraft(item.id);
    var kind = courseAdsKindForItem(item);
    var imgs = [];
    for (var i = 0; i < draft.sources.length; i++) {
      if (!draft.sources[i]) continue;
      imgs.push(draft.cropped[i] || draft.sources[i]);
    }
    if (!imgs.length) imgs = parentListingImageSrcs(parent);
    var desk = imgs[0] || '';
    var mob = imgs[1] || desk;
    var usingOwn = draft.sources.filter(Boolean).length > 0;
    box.innerHTML =
      '<div class="lb-v2-place-preview lb-v2-place-preview--compose">' +
        '<p class="lb-v2-review-note">官網真實版位預覽' +
          (usingOwn ? '（專用圖・已套裁切）' : '（尚未上傳，暫沿用課程圖示意）') +
          '：調構圖時可一眼對照牆面。</p>' +
        '<div class="lb-v2-place-preview__block">' +
          '<h4 class="lb-v2-place-preview__h">' + escapeHtml(item.slot_name || '廣告版位') + '</h4>' +
          buildStorefrontSlotWallToggleHtml(kind, {
            title: (parent && parent.title) || '（課程標題）',
            desk: desk,
            mob: mob,
            imgs: imgs,
            desc: listingPreviewDesc(parent, 90),
            vendor: listingPreviewVendorName(parent),
            priceText: listingPreviewPriceText(parent),
            openDevice: readSlotPreviewDevice(box),
          }) +
        '</div></div>';
    bindSlotPreviewToggle(box);
  }

  function scheduleCourseAdsDraftPreview(card, item, parent, idx) {
    var draft = ensureCourseAdsDraft(item.id);
    if (draft.timers[idx]) clearTimeout(draft.timers[idx]);
    draft.timers[idx] = setTimeout(function () {
      var kind = courseAdsKindForItem(item);
      var crop = draft.crops[idx] || defaultAddonCrop(0, 0);
      var spec = getAddonCropSpec(kind, idx);
      var frameImg = card.querySelector(
        '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
      );
      if (frameImg) {
        if (draft.sources[idx] && frameImg.getAttribute('src') !== draft.sources[idx]) {
          frameImg.src = draft.sources[idx];
        }
        applyLiveCropFrameStyle(frameImg, crop, spec);
      }
      var warnEl = card.querySelector(
        '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__warn'
      );
      if (warnEl && spec) warnEl.textContent = cropFramePanHint(crop, spec);
      bakeCourseAdsDraftBlob(draft, kind, idx).then(function (blob) {
        if (!blob) return;
        revokeIfBlobUrl(draft.cropped[idx]);
        draft.cropped[idx] = URL.createObjectURL(blob);
        renderCourseAdsDraftPreview(card, item, parent);
      }).catch(function () { /* ignore */ });
    }, 120);
  }

  function bindCourseAdsDraftCard(card, item, parent) {
    if (!card || card._lbComposeBound) return;
    card._lbComposeBound = true;
    var input = card.querySelector('[data-ads-file]');
    prefillCourseAdsDraft(card, item, parent);
    var draft = ensureCourseAdsDraft(item.id);
    var kind = courseAdsKindForItem(item);
    var limit = getAddonWallImageLimit(kind) || 1;
    var hint = card.querySelector('[data-ads-img-hint]');
    if (hint) hint.textContent = slotAddonImageHintText(item.slot_name || '', item.title || '');
    syncCourseAdsUploadUi(card, draft, limit);

    if (input) {
      input.addEventListener('change', function () {
        var files = Array.from(input.files || []);
        var remaining = limit - draft.sources.filter(Boolean).length;
        if (remaining <= 0) {
          adsCreateNotice('此版位最多 ' + limit + ' 張專用圖', true);
          input.value = '';
          syncCourseAdsUploadUi(card, draft, limit);
          return;
        }
        files.slice(0, remaining).forEach(function (file) {
          if (!file.type || !file.type.startsWith('image/')) return;
          if (file.size > 5 * 1024 * 1024) {
            adsCreateNotice('單張圖片請小於 5MB', true);
            return;
          }
          var preview = URL.createObjectURL(file);
          loadImageElement(preview).then(function (img) {
            var idx = draft.sources.length;
            if (idx >= limit) {
              revokeIfBlobUrl(preview);
              syncCourseAdsUploadUi(card, draft, limit);
              return;
            }
            draft.sources.push(preview);
            draft.files.push(file);
            draft.crops.push(defaultAddonCrop(img.naturalWidth || img.width, img.naturalHeight || img.height));
            draft.cropped.push('');
            if (draft.savedSrc) draft.savedSrc[idx] = null;
            renderCourseAdsDraftCrop(card, item, parent);
            renderCourseAdsDraftPreview(card, item, parent);
            scheduleCourseAdsDraftPreview(card, item, parent, idx);
          }).catch(function () {
            revokeIfBlobUrl(preview);
            adsCreateNotice('無法讀取圖片，請改用 JPG／PNG', true);
          });
        });
        input.value = '';
      });
    }

    var cropRoot = card.querySelector('[data-ads-crop-root]');
    if (cropRoot && !cropRoot._lbCropBound) {
      cropRoot._lbCropBound = true;
      cropRoot.addEventListener('input', function (e) {
        var el = e.target;
        if (!el || !el.getAttribute) return;
        var idxZ = el.getAttribute('data-crop-zoom');
        var idxX = el.getAttribute('data-crop-fx');
        var idxY = el.getAttribute('data-crop-fy');
        var idx = idxZ != null ? parseInt(idxZ, 10)
          : (idxX != null ? parseInt(idxX, 10)
            : (idxY != null ? parseInt(idxY, 10) : -1));
        if (!(idx >= 0)) return;
        var crop = draft.crops[idx] || defaultAddonCrop(0, 0);
        if (idxZ != null) crop.zoom = Math.max(1, (parseInt(el.value, 10) || 100) / 100);
        if (idxX != null) crop.fx = parseInt(el.value, 10) || 0;
        if (idxY != null) crop.fy = parseInt(el.value, 10) || 0;
        draft.crops[idx] = crop;
        if (draft.savedSrc) draft.savedSrc[idx] = null;
        var liveImg = card.querySelector(
          '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__frame img'
        );
        var specNow = getAddonCropSpec(courseAdsKindForItem(item), idx);
        applyLiveCropFrameStyle(liveImg, crop, specNow);
        var warnEl = card.querySelector(
          '.lb-v2-addon-crop[data-crop-idx="' + idx + '"] .lb-v2-addon-crop__warn'
        );
        if (warnEl && specNow) warnEl.textContent = cropFramePanHint(crop, specNow);
        scheduleCourseAdsDraftPreview(card, item, parent, idx);
      });
    }

    card.addEventListener('click', function (e) {
      var removeBtn = e.target && e.target.closest ? e.target.closest('[data-ads-remove-idx]') : null;
      if (removeBtn) {
        e.preventDefault();
        var rmIdx = parseInt(removeBtn.getAttribute('data-ads-remove-idx'), 10);
        if (!(rmIdx >= 0)) return;
        removeCourseAdsDraftAt(item.id, rmIdx);
        draft = ensureCourseAdsDraft(item.id);
        renderCourseAdsDraftCrop(card, item, parent);
        renderCourseAdsDraftPreview(card, item, parent);
        for (var i = 0; i < draft.sources.length; i++) {
          if (draft.sources[i]) scheduleCourseAdsDraftPreview(card, item, parent, i);
        }
        return;
      }
      var rm = e.target && e.target.closest ? e.target.closest('[data-ads-clear]') : null;
      if (!rm) return;
      e.preventDefault();
      clearCourseAdsDraft(item.id);
      draft = ensureCourseAdsDraft(item.id);
      renderCourseAdsDraftCrop(card, item, parent);
      renderCourseAdsDraftPreview(card, item, parent);
    });
  }

  function renderCourseAdsComposeCards() {
    var host = $('lb-v2-ads-compose-cards');
    var actions = $('lb-v2-ads-compose-actions');
    var parent = findListingItemById(($('lb-v2-ads-parent') || {}).value);
    if (!host) return;
    var ids = courseAdsSelectedIds();
    if (!parent || !ids.length) {
      host.hidden = true;
      host.innerHTML = '';
      if (actions) actions.hidden = true;
      return;
    }
    var cardsHtml = '';
    var cardOrd = 0;
    ids.forEach(function (id) {
      var item = findListingItemById(id);
      if (!item) return;
      cardOrd += 1;
      var kind = courseAdsKindForItem(item);
      var limit = getAddonWallImageLimit(kind) || 1;
      var start = ymd(item.exposure_start_at) || '—';
      var end = ymd(item.exposure_end_at) || '—';
      var pricePlan = (courseAdsPlans || []).find(function (p) {
        return String(p.id) === String(item.fee_plan_id || '');
      });
      var priceText = pricePlan ? adsPriceText(Number(pricePlan.price) || 0) : courseAdsFeeLabel(item);
      cardsHtml +=
        '<article class="lb-v2-ads-compose-card" data-ads-compose-card="' + escapeHtml(id) +
          '" data-ads-ord="' + cardOrd + '">' +
          '<header class="lb-v2-ads-compose-card__head">' +
            '<div class="lb-v2-ads-compose-card__head-main">' +
              '<span class="lb-v2-ads-compose-card__ord">廣告 ' + cardOrd + '</span>' +
              '<h3 class="lb-v2-ads-compose-card__title">' + escapeHtml(item.slot_name || ('版位 #' + item.slot_id)) + '</h3>' +
              '<p class="lb-v2-ads-compose-card__meta">單號 #' + escapeHtml(id) + ' · ' +
                escapeHtml(courseAdsFeeLabel(item)) + '</p>' +
            '</div>' +
            '<strong class="lb-v2-ads-compose-card__price">' + escapeHtml(priceText) + '</strong>' +
          '</header>' +
          '<div class="lb-v2-ads-compose-card__schedule">' +
            '<span class="lb-v2-ads-compose-card__label">曝光檔期（已鎖定）</span>' +
            '<p>' + escapeHtml(start) + ' <span class="lb-v2-muted">至</span> ' + escapeHtml(end) + '</p>' +
          '</div>' +
          '<div class="lb-v2-ads-compose-card__upload">' +
            '<span class="lb-v2-ads-compose-card__label">廣告專用圖（最多 ' + limit + ' 張）</span>' +
            '<p class="lb-v2-hint" data-ads-img-hint></p>' +
            '<p class="lb-v2-hint">寫入此加購單，不覆蓋課程商品頁圖庫。調構圖時左側（手機為上方）牆面即時更新，無需來回捲動。</p>' +
            '<label class="lb-v2-ads-compose-card__drop" data-ads-drop>' +
              '<input type="file" accept="image/*" multiple hidden data-ads-file>' +
              '<span class="lb-v2-ads-compose-card__drop-plus">＋</span>' +
              '<span>點擊上傳 JPG／PNG（單張 &lt; 5MB）</span>' +
            '</label>' +
            '<div class="lb-v2-ads-compose-card__toolbar" data-ads-toolbar hidden>' +
              '<button type="button" class="lb-v2-btn lb-v2-btn--sm" data-ads-clear>全部清除</button>' +
            '</div>' +
            '<div class="lb-v2-addon-compose lb-v2-ads-compose-card__compose">' +
              '<div class="lb-v2-ads-compose-card__preview lb-v2-addon-compose__wall" data-ads-preview></div>' +
              '<div data-ads-crop-root class="lb-v2-addon-crop-root lb-v2-addon-compose__crop"></div>' +
            '</div>' +
          '</div>' +
        '</article>';
    });
    host.innerHTML = cardsHtml;
    host.hidden = !cardsHtml;
    if (actions) actions.hidden = !cardsHtml;
    Array.prototype.slice.call(host.querySelectorAll('[data-ads-compose-card]')).forEach(function (card) {
      var id = card.getAttribute('data-ads-compose-card');
      var item = findListingItemById(id);
      if (!item) return;
      bindCourseAdsDraftCard(card, item, parent);
      renderCourseAdsDraftCrop(card, item, parent);
      renderCourseAdsDraftPreview(card, item, parent);
    });
  }

  function renderCourseAdsPickOptions(parent) {
    var pick = $('lb-v2-ads-pick');
    var hint = $('lb-v2-ads-pick-hint');
    if (!pick) return;
    var keep = courseAdsSelectedIds();
    var prefer = (courseAdsPreferredPickIds && courseAdsPreferredPickIds.length)
      ? courseAdsPreferredPickIds.map(String)
      : [];
    if (prefer.length) courseAdsPreferredPickIds = null;
    var selected = {};
    keep.concat(prefer).forEach(function (id) { selected[String(id)] = true; });
    var list = courseAdsPendingEligible(parent);
    list.sort(function (a, b) { return Number(b.id) - Number(a.id); });
    if (!list.length) {
      pick.innerHTML = '<p class="lb-v2-ads-pick__empty">' +
        escapeHtml(parent
          ? '此課程目前沒有可套用的已購檔期'
          : '請先選擇課程') +
        '</p>';
      pick.classList.add('is-empty');
      if (hint) {
        hint.textContent = parent
          ? '沒有符合此課程檔期／模式的待套用窗。可先到「營運結帳」鎖定，或展開下方購買新版位。'
          : '列出已鎖定、尚未套用的版位檔期（含免費）。直接打勾即可複選。';
      }
      renderCourseAdsComposeCards();
      return;
    }
    pick.classList.remove('is-empty');
    pick.innerHTML = list.map(function (item) {
      var start = ymd(item.exposure_start_at) || '—';
      var end = ymd(item.exposure_end_at) || '—';
      var id = String(item.id);
      var checked = selected[id] ? ' checked' : '';
      var slot = item.slot_name || ('版位 #' + item.slot_id);
      var fee = courseAdsFeeLabel(item);
      return '<label class="lb-v2-ads-pick__row' + (checked ? ' is-checked' : '') + '">' +
        '<input type="checkbox" class="lb-v2-ads-pick__check" data-ads-pick value="' + escapeHtml(id) + '"' + checked + '>' +
        '<span class="lb-v2-ads-pick__main">' +
          '<span class="lb-v2-ads-pick__name">' + escapeHtml(slot) + '</span>' +
          '<span class="lb-v2-ads-pick__sep" aria-hidden="true">·</span>' +
          '<span class="lb-v2-ads-pick__meta">#' + escapeHtml(id) + '　' +
            escapeHtml(start) + '～' + escapeHtml(end) + '</span>' +
        '</span>' +
        '<span class="lb-v2-ads-pick__fee">' + escapeHtml(fee) + '</span>' +
      '</label>';
    }).join('');
    if (hint) {
      hint.textContent = '可勾選 ' + list.length + ' 筆待套用檔期。勾選後下方展開專用圖上傳、裁切與桌／手機預覽。';
    }
    renderCourseAdsComposeCards();
  }

  /** 建立廣告：選課 → 複選已購檔期 → 每版位專用圖／預覽 → 一次套用。 */
  function renderCourseAdsCreate() {
    syncSlotAddonPurchaseUi();
    var select = $('lb-v2-ads-parent');
    var picker = $('lb-v2-ads-slot-picker');
    if (!select) return;
    var parents = (allListingItems || []).filter(canAddSlotAddon);
    var hint = $('lb-v2-ads-parent-hint');
    if (!parents.length) {
      select.innerHTML = '<option value="">（尚無可套用的課程）</option>';
      if (hint) hint.textContent = '只列出已通過審核、檔期未結束的基礎上架課程（資格限定課不可加購）。';
      renderCourseAdsPickOptions(null);
      if (picker) picker.innerHTML = '<p class="lb-v2-muted">請先完成基礎上架並通過審核。</p>';
      updateCourseAdsTotal();
      return;
    }
    var keep = select.value;
    if (courseAdsPreferredParentId != null &&
        parents.some(function (i) { return String(i.id) === String(courseAdsPreferredParentId); })) {
      keep = String(courseAdsPreferredParentId);
    }
    select.innerHTML = parents.map(function (item) {
      return '<option value="' + item.id + '">' +
        escapeHtml('#' + item.id + '　' + (item.title || '') +
          '（' + (LISTING_MODE_TEXT[item.listing_mode] || item.listing_mode || '') + '）') +
        '</option>';
    }).join('');
    if (keep && parents.some(function (i) { return String(i.id) === String(keep); })) select.value = keep;
    if (courseAdsPreferredParentId != null &&
        String(select.value) === String(courseAdsPreferredParentId)) {
      courseAdsPreferredParentId = null;
    }
    var parent = findListingItemById(select.value);
    if (hint && parent) {
      hint.textContent = '課程上架檔期：' + (ymd(parent.exposure_start_at) || '—') + ' ~ ' +
        (ymd(parent.exposure_end_at) || '—') + '（廣告檔期需落在此範圍內）。';
    }
    renderCourseAdsPickOptions(parent);
    renderCourseAdsSlotPicker();
  }

  async function submitCourseAdsApply() {
    if (courseAdsApplyInFlight) return;
    var slug = getListingVendorSlug();
    var parent = findListingItemById(($('lb-v2-ads-parent') || {}).value);
    var ids = courseAdsSelectedIds();
    if (!slug || !parent) {
      adsCreateNotice('請先選擇要套用的基礎上架課程', true);
      return;
    }
    if (!ids.length) {
      adsCreateNotice('請至少選擇一個已購買／已領取的廣告檔期', true);
      return;
    }
    var applyBtn = $('lb-v2-ads-apply');
    courseAdsApplyInFlight = true;
    if (applyBtn) applyBtn.disabled = true;
    adsCreateNotice('套用並送審中…', false);
    var okCount = 0;
    var errors = [];
    try {
      for (var i = 0; i < ids.length; i++) {
        var listingId = Number(ids[i]);
        var item = findListingItemById(listingId);
        if (!item) {
          errors.push('#' + ids[i] + ' 找不到檔期');
          continue;
        }
        var kind = courseAdsKindForItem(item);
        var limit = getAddonWallImageLimit(kind) || 0;
        var draft = ensureCourseAdsDraft(listingId);
        if (kind === 'event_spotlight' && draft.sources.filter(Boolean).length < 4) {
          errors.push((item.slot_name || ('#' + listingId)) + '：活動焦點需 4 張圖');
          continue;
        }
        if (limit > 0 && draft.sources.filter(Boolean).length > limit) {
          errors.push((item.slot_name || ('#' + listingId)) + '：超過此版位上限 ' + limit + ' 張');
          continue;
        }

        var attachRes = await postAppProxyJson(PATHS.listingAttachParent, {
          vendor_slug: slug,
          listing_id: listingId,
          parent_listing_id: Number(parent.id),
        });
        if (!attachRes.ok) {
          errors.push('#' + listingId + ' 套用失敗：' + (attachRes.message || attachRes.code || ''));
          continue;
        }

        var imagesJson = [];
        for (var imgIdx = 0; imgIdx < draft.sources.length; imgIdx++) {
          if (!draft.sources[imgIdx]) continue;
          var savedSrc = coerceDurablePublicImageUrl((draft.savedSrc || [])[imgIdx] || '');
          if (savedSrc) {
            // 帶回來且沒再調構圖：沿用正式 CDN，不重複上傳一份一樣的圖
            imagesJson.push({ src: savedSrc, uploaded: true });
            continue;
          }
          var spec = getAddonCropSpec(kind, imgIdx);
          var file = null;
          if (spec) {
            var blob = null;
            try {
              blob = await bakeCourseAdsDraftBlob(draft, kind, imgIdx);
            } catch (bakeErr) {
              blob = null;
            }
            if (blob) {
              file = new File([blob], 'ad-' + listingId + '-' + (imgIdx + 1) + '.jpg', { type: 'image/jpeg' });
            }
          }
          if (!file && draft.files[imgIdx]) file = draft.files[imgIdx];
          if (!file) {
            var rawSrc = coerceDurablePublicImageUrl(String(draft.sources[imgIdx] || ''));
            if (rawSrc) imagesJson.push({ src: rawSrc, uploaded: true });
            continue;
          }
          try {
            var url = await uploadListingImageFile(file, 'cover');
            if (url) imagesJson.push({ src: url, uploaded: true });
          } catch (upErr) {
            errors.push('#' + listingId + ' 第' + (imgIdx + 1) + '張上傳失敗');
          }
        }

        if (imagesJson.length) {
          var saveRes = await postAppProxyJson(PATHS.listingSave, {
            vendor_slug: slug,
            id: listingId,
            parent_listing_id: Number(parent.id),
            slot_id: Number(item.slot_id) || null,
            fee_plan_id: Number(item.fee_plan_id) || null,
            exposure_start_at: ymd(item.exposure_start_at),
            exposure_end_at: ymd(item.exposure_end_at),
            images_json: imagesJson,
          });
          if (!saveRes.ok) {
            errors.push('#' + listingId + ' 存圖失敗：' + (saveRes.message || ''));
            continue;
          }
        }

        var submitRes = await postAppProxyJson(PATHS.listingSubmit, {
          vendor_slug: slug,
          listing_id: listingId,
        });
        if (!submitRes.ok) {
          errors.push('#' + listingId + ' 已套用但送審失敗：' + (submitRes.message || submitRes.code || '') + '（可至廣告列表補圖再送）');
          okCount += 1;
          continue;
        }
        clearCourseAdsDraft(listingId);
        okCount += 1;
      }

      await loadCourseAdsTab(true);
      if (okCount && !errors.length) {
        adsCreateNotice('已成功套用並送審 ' + okCount + ' 筆廣告。', false);
        setCourseAdsView('list');
      } else if (okCount) {
        adsCreateNotice('完成 ' + okCount + ' 筆；部分失敗：' + errors.slice(0, 3).join('；'), true);
        setCourseAdsView('list');
      } else {
        adsCreateNotice(errors[0] || '套用失敗', true);
      }
    } catch (err) {
      adsCreateNotice(err.message || '套用失敗', true);
    } finally {
      courseAdsApplyInFlight = false;
      if (applyBtn) applyBtn.disabled = false;
    }
  }


  function renderCourseAdsSlotPicker() {
    var picker = $('lb-v2-ads-slot-picker');
    var select = $('lb-v2-ads-parent');
    if (!picker || !select) return;
    syncSlotAddonPurchaseUi();
    var parent = findListingItemById(select.value);
    var hint = $('lb-v2-ads-parent-hint');
    if (!parent) {
      picker.innerHTML = '';
      updateCourseAdsTotal();
      return;
    }
    var pStart = ymd(parent.exposure_start_at);
    var pEnd = ymd(parent.exposure_end_at);
    if (hint) {
      hint.textContent = '課程上架檔期：' + (pStart || '—') + ' ~ ' + (pEnd || '—') +
        '（廣告檔期需落在此範圍內，且最早需提前 ' + PURCHASE_WINDOW_MIN_LEAD_DAYS + ' 天）。';
    }
    var mode = String(parent.listing_mode || '').toUpperCase();
    var slug = getListingVendorSlug();
    var earliest = pwAddDays(pwTodayYmd(), PURCHASE_WINDOW_MIN_LEAD_DAYS);
    var minDate = pStart && pStart > earliest ? pStart : earliest;
    var adPlans = (courseAdsPlans || []).filter(function (p) {
      if (!p || isBaseListingPlan(p)) return false;
      if (String(p.listing_mode || '').toUpperCase() !== mode) return false;
      if (isModulePurchaseClosed(p.listing_mode)) return false;
      return true;
    });
    if (!adPlans.length) {
      picker.innerHTML = '<p class="lb-v2-muted">此作業模式目前沒有可購買的廣告版位方案。</p>';
      updateCourseAdsTotal();
      return;
    }
    picker.innerHTML = adPlans.map(function (p) {
      var durationDays = parseInt(p.duration_days, 10) || 0;
      var isFree = Number(p.price) === 0;
      var freeBucket = isFree ? freeQuotaBucketForSlot(p.slot_id || null) : null;
      var freeRemaining = freeBucket ? (parseInt(freeBucket.remaining, 10) || 0) : null;
      var exhausted = freeRemaining !== null && freeRemaining <= 0;
      var missingVariant = !isFree && !planVariantNumId(p);
      var blocked = exhausted || missingVariant;
      return '<div class="lb-v2-ads-slot lb-v2-fee-plan-window" data-ad-slot-card' +
          ' data-plan-id="' + p.id + '"' +
          ' data-slot-id="' + escapeHtml(String(p.slot_id || '')) + '"' +
          ' data-duration-days="' + durationDays + '"' +
          ' data-variant-id="' + escapeHtml(planVariantNumId(p)) + '"' +
          ' data-price="' + (Number(p.price) || 0) + '"' +
          ' data-free="' + (isFree ? '1' : '0') + '"' +
          ' data-slug="' + escapeHtml(slug || '') + '"' +
          ' data-parent-listing-id="' + escapeHtml(String(parent.id || '')) + '"' +
          ' data-parent-start="' + escapeHtml(pStart || '') + '"' +
          ' data-parent-end="' + escapeHtml(pEnd || '') + '">' +
        '<div class="lb-v2-ads-slot__head">' +
          (blocked
            ? '<span class="lb-v2-ads-slot__check" aria-hidden="true">✕</span>'
            : '<input type="checkbox" class="lb-v2-ads-slot__check" data-ad-slot-pick aria-label="選擇 ' +
              escapeHtml(p.slot_name || p.name || '') + '">') +
          '<span class="lb-v2-ads-slot__name">' + escapeHtml(p.slot_name || ('版位 #' + p.slot_id)) + '</span>' +
          '<span class="lb-v2-ads-slot__price">' + escapeHtml(adsPriceText(Number(p.price) || 0)) + '</span>' +
        '</div>' +
        '<div class="lb-v2-ads-slot__meta">' + escapeHtml(p.name || '') +
          (durationDays > 0 ? '｜短檔 ' + durationDays + ' 天' : '｜自選天數') +
          (isFree && freeBucket ? '｜免費剩 ' + freeRemaining + '／' + freeBucket.limit + ' 次' : '') +
        '</div>' +
        (blocked
          ? '<p class="lb-v2-ads-slot__msg is-error">' +
              (exhausted ? '免費次數已用完，請改選付費版位' : '方案尚未連結 LadyBae 商品，請聯繫官方') +
            '</p>'
          : '<div class="lb-v2-ads-slot__body">' +
              '<div class="lb-v2-fee-plan-window__cal">' +
                '<div class="lb-v2-fee-plan-window__cal-head">' +
                  '<p class="lb-v2-fee-plan-window__cal-label">版位剩餘容量</p>' +
                  '<div class="lb-v2-fee-plan-window__legend" aria-hidden="true">' +
                    '<span class="lb-v2-fee-plan-window__legend-item is-ok">有空</span>' +
                    '<span class="lb-v2-fee-plan-window__legend-item is-full">已滿</span>' +
                    '<span class="lb-v2-fee-plan-window__legend-item is-sel">已選</span>' +
                  '</div>' +
                '</div>' +
                '<p class="lb-v2-hint lb-v2-fee-plan-window__cal-hint" data-window-cal-hint></p>' +
                '<div class="lb-v2-exposure-calendar lb-v2-fee-plan-window__calendar" data-window-calendar></div>' +
              '</div>' +
              '<div class="lb-v2-ads-slot__dates">' +
                '<input type="date" class="lb-v2-input lb-v2-input--sm" data-window-start min="' + minDate + '"' +
                  (pEnd ? ' max="' + pEnd + '"' : '') + '>' +
                (durationDays > 0
                  ? '<span class="lb-v2-muted">起日 +' + durationDays + ' 天</span>'
                  : '<span class="lb-v2-muted">～</span><input type="date" class="lb-v2-input lb-v2-input--sm" data-window-end min="' +
                    minDate + '"' + (pEnd ? ' max="' + pEnd + '"' : '') + '>') +
              '</div>' +
              '<p class="lb-v2-ads-slot__msg" data-window-avail></p>' +
              '<p class="lb-v2-ads-slot__msg" data-window-msg></p>' +
            '</div>') +
      '</div>';
    }).join('');
    bindCourseAdsSlotCards();
    updateCourseAdsTotal();
  }

  function courseAdsCards() {
    var picker = $('lb-v2-ads-slot-picker');
    if (!picker) return [];
    return Array.prototype.slice.call(picker.querySelectorAll('[data-ad-slot-card]'));
  }

  function courseAdsPickedCards() {
    return courseAdsCards().filter(function (card) {
      var cb = card.querySelector('[data-ad-slot-pick]');
      return !!(cb && cb.checked);
    });
  }

  function updateCourseAdsTotal() {
    var picked = courseAdsPickedCards();
    var box = $('lb-v2-ads-total');
    var valueEl = $('lb-v2-ads-total-value');
    var hintEl = $('lb-v2-ads-total-hint');
    if (!box || !valueEl) return;
    if (!picked.length) {
      box.hidden = true;
      return;
    }
    var total = picked.reduce(function (sum, card) {
      return sum + (parseFloat(card.getAttribute('data-price')) || 0);
    }, 0);
    var freeCount = picked.filter(function (c) { return c.getAttribute('data-free') === '1'; }).length;
    box.hidden = false;
    valueEl.textContent = 'NT$' + total;
    if (hintEl) {
      hintEl.textContent = '已選 ' + picked.length + ' 個版位' +
        (freeCount ? '（其中 ' + freeCount + ' 個免費，會直接領取檔期不進購物車）' : '');
    }
  }

  function bindCourseAdsSlotCards() {
    courseAdsCards().forEach(function (card) {
      upgradeWindowDateInputsIn(card);
      bindWindowCalendarInteractions(card);
      var slotId = parseInt(card.getAttribute('data-slot-id'), 10) || 0;
      if (slotId) loadWindowCapacityCalendar(card);
      var cb = card.querySelector('[data-ad-slot-pick]');
      if (cb) {
        cb.addEventListener('change', function () {
          card.classList.toggle('is-picked', cb.checked);
          updateCourseAdsTotal();
          if (cb.checked) {
            loadWindowCapacityCalendar(card);
            pwCheckAvailability(card);
          }
        });
      }
      card.querySelectorAll('[data-window-start],[data-window-end]').forEach(function (input) {
        input.addEventListener('change', function () {
          highlightWindowCalDays(card);
          pwCheckAvailability(card);
        });
      });
    });
  }

  /**
   * 結帳：付費版位逐筆建 hold、免費版位當場領取，最後把付費品項一次加進購物車。
   * 一版位一張加購單的底層模型不變，只是 UI 讓廠商一次選完。
   */
  async function submitCourseAdsCheckout() {
    if (courseAdsCheckoutInFlight) return;
    var slug = getListingVendorSlug();
    var select = $('lb-v2-ads-parent');
    var parent = select ? findListingItemById(select.value) : null;
    if (!slug || !parent) {
      adsCreateNotice('請先選擇要加購廣告的課程', true);
      return;
    }
    var picked = courseAdsPickedCards();
    if (!picked.length) {
      adsCreateNotice('請至少勾選一個廣告版位', true);
      return;
    }
    var pStart = ymd(parent.exposure_start_at);
    var pEnd = ymd(parent.exposure_end_at);
    var earliest = pwAddDays(pwTodayYmd(), PURCHASE_WINDOW_MIN_LEAD_DAYS);
    var jobs = [];
    for (var i = 0; i < picked.length; i += 1) {
      var card = picked[i];
      var range = pwWindowDates(card);
      var slotLabel = (card.querySelector('.lb-v2-ads-slot__name') || {}).textContent || '版位';
      if (!range.start || !range.end) {
        pwSetMessage(card, '請選擇廣告檔期', true);
        adsCreateNotice('「' + slotLabel + '」尚未選檔期', true);
        return;
      }
      if (range.end < range.start) {
        pwSetMessage(card, '迄日不能早於起日', true);
        adsCreateNotice('「' + slotLabel + '」檔期起迄顛倒', true);
        return;
      }
      if (range.start < earliest) {
        pwSetMessage(card, '最早需提前 ' + PURCHASE_WINDOW_MIN_LEAD_DAYS + ' 天', true);
        adsCreateNotice('「' + slotLabel + '」起日太近，最早需提前 ' + PURCHASE_WINDOW_MIN_LEAD_DAYS + ' 天', true);
        return;
      }
      if ((pStart && range.start < pStart) || (pEnd && range.end > pEnd)) {
        var overMsg = '短檔會變成 ' + range.start + ' ~ ' + range.end +
          '，已超出基礎上架曝光範圍（' + (pStart || '—') + ' ~ ' + (pEnd || '—') +
          '），請改選較早的起日。';
        pwSetMessage(card, '需落在課程檔期 ' + pStart + ' ~ ' + pEnd + ' 內', true);
        adsCreateNotice('「' + slotLabel + '」檔期超出課程上架檔期', true);
        showPortalAlert(overMsg, '超出基礎上架曝光範圍');
        return;
      }
      if (card.getAttribute('data-window-over-parent') === '1') {
        showPortalAlert(
          card.getAttribute('data-window-over-parent-msg') || '廣告檔期超出基礎上架曝光範圍',
          '超出基礎上架曝光範圍'
        );
        adsCreateNotice('「' + slotLabel + '」檔期超出課程上架檔期', true);
        return;
      }
      jobs.push({ card: card, range: range, label: slotLabel });
    }

    courseAdsCheckoutInFlight = true;
    var checkoutBtn = $('lb-v2-ads-checkout');
    if (checkoutBtn) checkoutBtn.disabled = true;
    adsCreateNotice('建立廣告加購單中…', false);
    var cartItems = [];
    var claimed = 0;
    var claimedIds = [];
    try {
      for (var j = 0; j < jobs.length; j += 1) {
        var job = jobs[j];
        var isFree = job.card.getAttribute('data-free') === '1';
        // 建立頁先鎖窗、不綁母課：付完／領完立刻進下方「選擇廣告」，再套用專用圖。
        var body = {
          vendor_slug: slug,
          fee_plan_id: parseInt(job.card.getAttribute('data-plan-id'), 10) || 0,
          exposure_start_at: job.range.start,
          exposure_end_at: job.range.end,
        };
        if (job.card.getAttribute('data-window-full') === '1') {
          showPortalAlert(
            job.card.getAttribute('data-window-full-msg') || '此檔期有日期已滿，請改選其他日期',
            '檔期已滿'
          );
          adsCreateNotice('「' + job.label + '」檔期已滿，請改選其他日期', true);
          return;
        }
        var result = await postAppProxyJson(
          isFree ? PATHS.listingClaimWindow : PATHS.listingPurchaseHold,
          body
        );
        if (!result.ok) {
          pwSetMessage(job.card, '', false);
          showPortalAlert(
            formatPortalError(result.code, result.message || '建立失敗'),
            result.code === 'SLOT_CAPACITY_FULL' ? '檔期已滿' : '無法鎖定檔期'
          );
          adsCreateNotice(
            '「' + job.label + '」建立失敗：' +
              formatPortalError(result.code, result.message || '請改選其他檔期') +
            (cartItems.length ? '；已建立的其他版位保留 ' + PURCHASE_WINDOW_HOLD_MINUTES + ' 分鐘，逾時自動釋放。' : ''),
            true
          );
          return;
        }
        slotAvailCache = {};
        var lockedId = (result.payload && result.payload.listing_id) || 0;
        if (isFree) {
          claimed += 1;
          if (lockedId) claimedIds.push(String(lockedId));
          pwSetMessage(job.card, '已領取檔期', false);
          continue;
        }
        var heldId = lockedId;
        var variantId = job.card.getAttribute('data-variant-id') || '';
        if (!heldId || !variantId) {
          pwSetMessage(job.card, '佔位失敗，請重新選擇檔期', true);
          adsCreateNotice('「' + job.label + '」佔位失敗，請重試', true);
          return;
        }
        cartItems.push({
          id: Number(variantId),
          quantity: 1,
          properties: { slug_handle: slug, listing_id: String(heldId) },
        });
      }

      cachedEntitlement = null;
      clearFeeEntitlementTtlCache();

      if (!cartItems.length) {
        courseAdsPreferredPickIds = claimedIds.slice();
        adsCreateNotice(
          '已領取 ' + claimed + ' 個免費版位檔期，已加入下方「選擇廣告」。請勾選後上傳專用圖並送審。',
          false
        );
        await loadCourseAdsTab(true);
        setCourseAdsView('create');
        return;
      }

      var cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: cartItems }),
      });
      if (!cartRes.ok) throw new Error('加入購物車失敗，請重試');
      window.location.href = '/cart';
    } catch (err) {
      adsCreateNotice(err.message || '結帳失敗，請重試', true);
    } finally {
      courseAdsCheckoutInFlight = false;
      if (checkoutBtn) checkoutBtn.disabled = false;
    }
  }

  (function bindCourseAdsPanel() {
    var parentSelect = $('lb-v2-ads-parent');
    if (parentSelect) {
      parentSelect.addEventListener('change', function () {
        adsCreateNotice('', false);
        renderCourseAdsPickOptions(findListingItemById(parentSelect.value));
        renderCourseAdsSlotPicker();
      });
    }
    var pick = $('lb-v2-ads-pick');
    if (pick && !pick.__lbAdsPickBound) {
      pick.__lbAdsPickBound = true;
      pick.addEventListener('change', function (ev) {
        var t = ev.target;
        if (!t || !t.matches || !t.matches('input[data-ads-pick]')) return;
        var row = t.closest('.lb-v2-ads-pick__row');
        if (row) row.classList.toggle('is-checked', !!t.checked);
        adsCreateNotice('', false);
        renderCourseAdsComposeCards();
      });
    }
    var applyBtn = $('lb-v2-ads-apply');
    if (applyBtn) applyBtn.addEventListener('click', submitCourseAdsApply);
    var statusFilter = $('lb-v2-ads-status-filter');
    // 狀態／日期改完後按「套用篩選」才重畫，避免選日期卻沒有確認動作
    var applyFilter = $('lb-v2-ads-filter-apply');
    if (applyFilter) applyFilter.addEventListener('click', renderCourseAdsList);
    var clearFilter = $('lb-v2-ads-filter-clear');
    if (clearFilter) {
      clearFilter.addEventListener('click', function () {
        if (statusFilter) statusFilter.value = '';
        var df = $('lb-v2-ads-date-from');
        var dt = $('lb-v2-ads-date-to');
        if (df) df.value = '';
        if (dt) dt.value = '';
        adsNotice('', false);
        renderCourseAdsList();
      });
    }
    var adsBar = document.querySelector('#lb-v2-ads-list-view .lb-v2-ads-board__bar');
    Array.prototype.slice.call(document.querySelectorAll('[data-ads-date]')).forEach(function (el) {
      bindBoardDatePicker(el, adsBar, renderCourseAdsList);
    });
    var goCreate = $('lb-v2-ads-go-create');
    if (goCreate) {
      goCreate.addEventListener('click', function () {
        setCourseAdsView('create');
      });
    }
    var checkoutBtn = $('lb-v2-ads-checkout');
    if (checkoutBtn) checkoutBtn.addEventListener('click', submitCourseAdsCheckout);
    var listEl = $('lb-v2-ads-list');
    if (listEl) {
      listEl.addEventListener('click', function (e) {
        var t = e.target && e.target.closest
          ? e.target.closest('[data-ad-edit],[data-ad-detach],[data-ad-preview]')
          : null;
        if (!t) return;
        e.preventDefault();
        if (t.hasAttribute('data-ad-edit')) {
          openSlotAddonModal({ addonId: parseInt(t.getAttribute('data-ad-edit'), 10) });
          return;
        }
        if (t.hasAttribute('data-ad-detach')) {
          confirmDetachAdListing(
            t.getAttribute('data-ad-detach'),
            t.getAttribute('data-ad-title') || '',
            { goCreate: true }
          );
          return;
        }
        if (t.hasAttribute('data-ad-preview')) {
          openAdPreviewModal(parseInt(t.getAttribute('data-ad-preview'), 10));
        }
      });
    }
  })();

  boot();
})();

